
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("l7ScM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9d44f0dd638c374f$export$2e2bcd8739ae039);

var $ivm9B = parcelRequire("ivm9B");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9UpXi = parcelRequire("9UpXi");
const $9d44f0dd638c374f$var$HorizontalNavJiraInner = ({ queries: { horizontalNavQuery: horizontalNavQuery } })=>{
    /*
   * Keep this component as small as possible! Ideally, it is so small that all it does is call usePreloadedQuery,
   * spread JiraHorizontalNavigationContent and the response into into JiraHorizontalNavigationContent.
   *
   * This means we don't run into the issue of having to import the compiled query into mocks, which means you can't add
   * @relay_test_operation to the query in the test/storybook, which can create hard-to-solve mock issues like this one:
   * https://hello.atlassian.net/wiki/x/FzuK1w
   * */ const data = (0, $8Uumt.usePreloadedQuery)((0, $ivm9B.default), horizontalNavQuery);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UpXi.default), {
        queryRef: data
    });
};
var $9d44f0dd638c374f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($9d44f0dd638c374f$var$HorizontalNavJiraInner);

});
parcelRegister("ivm9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e7cee9907baeab7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<25637c34c77ecbacbdb193525c6b35dc>>
 * @relayHash 803bd2411b5ccfb7091d5aac3095a48a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6d9f5406464f687f1985513ff8a0101826fc3041b4f0dee81c75ab40777cf9e2

var $58v9Y = parcelRequire("58v9Y");

var $i536Z = parcelRequire("i536Z");

var $9pmwJ = parcelRequire("9pmwJ");

var $eiowN = parcelRequire("eiowN");
const $5e7cee9907baeab7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerNavigationInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTMPBoardRoute"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withBoard"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withProject"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "boardType"
    }, v22 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JiraHorizontalNavigationContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "containerNavigationInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraContainerNavigationResult"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "first",
                                                    "variableName": "first"
                                                }
                                            ],
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDefault"
                                                                },
                                                                v10 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeKey"
                                                                },
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRename"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRemove"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canSetAsDefault"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v12 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v14 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraNavigationItem",
                                                                            "abstractKey": "__isJiraNavigationItem"
                                                                        }
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                },
                                                                v14 /*: any*/ 
                                                            ]
                                                        },
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v15 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeUrl"
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v15 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v18 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "withBoard",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "withProject",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "idOrKey",
                                    "variableName": "projectIdOrKey"
                                }
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "alias": "canEditProjectConfig",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ],
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                },
                                v9 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
                                                    "kind": "LinkedField",
                                                    "name": "teamsConnected",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "isTMPBoardRoute",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "projectKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "mostRecentlyViewedBoard",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLiveTemplate"
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6d9f5406464f687f1985513ff8a0101826fc3041b4f0dee81c75ab40777cf9e2",
            "metadata": {},
            "name": "HorizontalNavJiraInnerQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $58v9Y.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": (0, $9pmwJ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": (0, $i536Z.default)
            }
        }
    };
}();
$5e7cee9907baeab7$var$node.hash = "cfedd5347d81ca2f36fa810c25c638f4";
(0, $eiowN.PreloadableQueryRegistry).set($5e7cee9907baeab7$var$node.params.id, $5e7cee9907baeab7$var$node);
var $5e7cee9907baeab7$export$2e2bcd8739ae039 = $5e7cee9907baeab7$var$node;

});

parcelRegister("9UpXi", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb33d72d81438f58$export$2e2bcd8739ae039);

var $gxnRm = parcelRequire("gxnRm");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $5NiYd = parcelRequire("5NiYd");

var $g7crU = parcelRequire("g7crU");

var $2A19k = parcelRequire("2A19k");

var $7CMCs = parcelRequire("7CMCs");

var $7Ib1j = parcelRequire("7Ib1j");

var $fK1eg = parcelRequire("fK1eg");

var $inpPZ = parcelRequire("inpPZ");

var $jPgWz = parcelRequire("jPgWz");
const $bb33d72d81438f58$var$JiraHorizontalNavigationContentComponent = ({ queryRef: queryRef })=>{
    const data = (0, $8Uumt.useFragment)((0, $gxnRm.default), queryRef);
    const project = data.jira_projectByIdOrKey;
    const [isFullscreen] = (0, $g7crU.useIsFullscreen)();
    const setMostRecentlyViewedBoard = (0, $2A19k.useSetMostRecentlyViewedBoard)();
    (0, $5uXOq.useEffect)(()=>{
        if (data?.jira?.containerNavigation?.scopeId && project?.softwareBoardCount && project.softwareBoardCount > 0) setMostRecentlyViewedBoard?.(data.jira.containerNavigation.scopeId, project?.__id);
    }, [
        setMostRecentlyViewedBoard,
        data?.jira?.containerNavigation?.scopeId,
        project?.__id,
        project?.softwareBoardCount
    ]);
    // Some routes with invalid project scope or scope Id request for horizontal navigation
    // E.g. JSM projects do not support horizontal navigation, but connect app routes in JSM will request for it
    // These cases are unprocessable and return a dedicated 422 error, so we can skip rendering and return null
    if (data.jira?.containerNavigation?.extensions?.[0]?.statusCode === 422) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, project && (0, $4R6GH.fg)('jira_custom_templates_ux') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Ib1j.CustomTemplateProjectBanner), {
        projectFragment: project
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $inpPZ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fK1eg.default), {
        projectFragment: project,
        queryFragment: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "HorizontalNavTabContentErrorBoundary",
        packageName: "jiraHorizontalNav",
        fallback: (0, $5NiYd.TabsSkeleton)
    }, !isFullscreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jPgWz.default), {
        projectFragment: project,
        queryFragment: data
    }) : null)));
};
const $bb33d72d81438f58$var$JiraHorizontalNavigationContent = /*#__PURE__*/ (0, $5uXOq.memo)($bb33d72d81438f58$var$JiraHorizontalNavigationContentComponent);
var $bb33d72d81438f58$export$2e2bcd8739ae039 = $bb33d72d81438f58$var$JiraHorizontalNavigationContent;

});
parcelRegister("gxnRm", function(module, exports) {

$parcel$export(module.exports, "default", () => $817155e15ff948b3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a86618c278da68f77dfd7cea3a0d726e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $817155e15ff948b3$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "containerNavigationInput"
        },
        {
            "kind": "RootArgument",
            "name": "projectIdOrKey"
        },
        {
            "kind": "RootArgument",
            "name": "withProject"
        }
    ],
    "kind": "Fragment",
    "name": "JiraHorizontalNavigationContent",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabsContent_query"
        },
        {
            "kind": "FragmentSpread",
            "name": "NavHeader_query"
        },
        {
            "condition": "withProject",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "idOrKey",
                            "variableName": "projectIdOrKey"
                        }
                    ],
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "TabsContent_project"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "NavHeader_project"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "CustomTemplateProjectBanner"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "softwareBoardCount"
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "input",
                                "variableName": "containerNavigationInput"
                            }
                        ],
                        "kind": "LinkedField",
                        "name": "containerNavigation",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "scopeId"
                                    }
                                ],
                                "type": "JiraContainerNavigation"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "extensions",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "statusCode"
                                            }
                                        ]
                                    }
                                ],
                                "type": "QueryError"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira.containerNavigation"
                }
            ]
        }
    ],
    "type": "Query"
};
$817155e15ff948b3$var$node.hash = "9a87f5d323bf1da69997ea76a7a24c06";
var $817155e15ff948b3$export$2e2bcd8739ae039 = $817155e15ff948b3$var$node;

});

parcelRegister("g7crU", function(module, exports) {

$parcel$export(module.exports, "useIsFullscreen", () => $aa937e51388f56fd$export$d397eccea5f37b0a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $aa937e51388f56fd$export$d397eccea5f37b0a = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.isFullscreen
});

});
parcelRegister("5e5zm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $0c99a19d69d506cf$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $0c99a19d69d506cf$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $0c99a19d69d506cf$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $0c99a19d69d506cf$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $0c99a19d69d506cf$export$99e05a60cac05e86);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8CM3x = parcelRequire("8CM3x");
const $0c99a19d69d506cf$export$539e68c09584883a = 240;
const $0c99a19d69d506cf$export$b92df8810d2fcd01 = 0;
const $0c99a19d69d506cf$var$initialState = {
    isChromeless: false,
    isFullscreen: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $0c99a19d69d506cf$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        }
    }
};
const $0c99a19d69d506cf$export$b8cdfd44cddaf07 = (0, $iXqE5.createStore)({
    initialState: $0c99a19d69d506cf$var$initialState,
    actions: $8CM3x.actions,
    name: 'JiraLayoutStore'
});
const $0c99a19d69d506cf$export$6136bc3b9858cff4 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$export$b8cdfd44cddaf07, {
    selector: null
});
const $0c99a19d69d506cf$var$detailPanelWidthStore = (0, $iXqE5.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $0c99a19d69d506cf$export$95fd7b6da3b9bbb0 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
const $0c99a19d69d506cf$export$99e05a60cac05e86 = (0, $3sQ5x.createActionsHook)($0c99a19d69d506cf$var$detailPanelWidthStore);

});
parcelRegister("8CM3x", function(module, exports) {

$parcel$export(module.exports, "actions", () => $939ad82f8ddcb8d9$export$e324594224ef24da);

var $4oU0I = parcelRequire("4oU0I");

var $flhve = parcelRequire("flhve");

var $f5TQt = parcelRequire("f5TQt");

var $hPsAX = parcelRequire("hPsAX");

var $gqQUV = parcelRequire("gqQUV");

var $byk51 = parcelRequire("byk51");
const $939ad82f8ddcb8d9$export$e324594224ef24da = {
    setIsChromeless: // global
    $f5TQt.setIsChromeless,
    setIsFullscreen: $hPsAX.setIsFullscreen,
    showBanner: // banner
    $4oU0I.showBanner,
    dismissCurrentBanner: $4oU0I.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $gqQUV.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $byk51.setRightSidebarState,
    openRightSidebar: $byk51.openRightSidebar,
    closeRightSidebar: $byk51.closeRightSidebar,
    closeAllRightSidebar: $byk51.closeAllRightSidebar,
    closeCurrentRightSidebar: $byk51.closeCurrentRightSidebar,
    minimiseRightSidebar: $byk51.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $flhve.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $flhve.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $flhve.removeBottomRightCornerPortal
};

});
parcelRegister("4oU0I", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $820929f36789bf81$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $820929f36789bf81$export$a45bccc0cc9ac424);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $820929f36789bf81$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $820929f36789bf81$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($820929f36789bf81$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("flhve", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $560ff4740e75fa9e$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $560ff4740e75fa9e$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $560ff4740e75fa9e$export$928bf7e228ce06d2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $560ff4740e75fa9e$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $560ff4740e75fa9e$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $560ff4740e75fa9e$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("f5TQt", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $0389a2d5715d1f25$export$1998c4816ad37edb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0389a2d5715d1f25$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("hPsAX", function(module, exports) {

$parcel$export(module.exports, "setIsFullscreen", () => $e3c9e6899dc6b3f0$export$9c73b2f282069160);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e3c9e6899dc6b3f0$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
        setState({
            isFullscreen: isFullscreen
        });
    };

});

parcelRegister("gqQUV", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $54ca906cbb882b25$export$3e0fd2d894ef83c8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $54ca906cbb882b25$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});

parcelRegister("byk51", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $4dabd377b098e1a2$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $4dabd377b098e1a2$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $4dabd377b098e1a2$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $4dabd377b098e1a2$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $4dabd377b098e1a2$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $4dabd377b098e1a2$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $4dabd377b098e1a2$export$c8dafe074328c4ca);

var $ajpes = parcelRequire("ajpes");
const $4dabd377b098e1a2$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $4dabd377b098e1a2$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $4dabd377b098e1a2$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $4dabd377b098e1a2$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $4dabd377b098e1a2$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $4dabd377b098e1a2$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $4dabd377b098e1a2$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $4dabd377b098e1a2$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $4dabd377b098e1a2$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});




parcelRegister("2A19k", function(module, exports) {

$parcel$export(module.exports, "useSetMostRecentlyViewedBoard", () => $6dee56e78d8107f5$export$3c43491dc3e7b6a8);

var $dm1MT = parcelRequire("dm1MT");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $eCBf9 = parcelRequire("eCBf9");

var $iJZ8l = parcelRequire("iJZ8l");
const $6dee56e78d8107f5$export$d1b013dc8403efee = 'setMostRecentlyViewedBoard';
const $6dee56e78d8107f5$export$b8b9d90f9e5bd72b = 'horizontalNavSoftware';
const $6dee56e78d8107f5$export$d57b6b390e78d90f = 'Navigation';
const $6dee56e78d8107f5$export$3c43491dc3e7b6a8 = ()=>{
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $dm1MT.default));
    const onError = (0, $5uXOq.useCallback)((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: $6dee56e78d8107f5$export$d1b013dc8403efee,
                packageName: $6dee56e78d8107f5$export$b8b9d90f9e5bd72b,
                teamName: $6dee56e78d8107f5$export$d57b6b390e78d90f
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, []);
    return (0, $5uXOq.useCallback)((id, projectRelayId)=>{
        commitMutation({
            variables: {
                id: id
            },
            onError: onError,
            updater: (store, data)=>{
                if (!data?.jira?.setMostRecentlyViewedBoard?.success || !projectRelayId) return;
                const parentRecord = store.get(projectRelayId);
                const newBoardDataId = (0, $iJZ8l.default)({
                    id: data?.jira?.setMostRecentlyViewedBoard?.board?.id
                }, 'JiraBoard');
                const newBoardRecord = newBoardDataId && store.get(newBoardDataId);
                if (parentRecord && newBoardRecord) parentRecord.setLinkedRecord(newBoardRecord, 'mostRecentlyViewedBoard');
            },
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira?.setMostRecentlyViewedBoard ?? {};
                if (errors) {
                    const error = new (0, $eCBf9.MutationError)(errors[0]);
                    !error.statusCode?.toString().startsWith('4') && onError(error);
                }
            }
        });
    }, [
        commitMutation,
        onError
    ]);
};

});
parcelRegister("dm1MT", function(module, exports) {

$parcel$export(module.exports, "default", () => $08d2dc7d025ea157$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a2587a8feb5ed65f63719a9f78f154d>>
 * @relayHash e4b9571054871d36ce4a62f8dfc3a347
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 460e3bc3e7ed3d8d27b904af0f9749ba9913444eb0c65d55e5522990c53522ff
const $08d2dc7d025ea157$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v3 = {
        "concreteType": "JiraBoard",
        "kind": "LinkedField",
        "name": "board",
        "plural": false,
        "selections": v2 /*: any*/ 
    }, v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "setMostRecentlyViewedBoardMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSetMostRecentlyViewedBoardPayload",
                            "kind": "LinkedField",
                            "name": "setMostRecentlyViewedBoard",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "setMostRecentlyViewedBoardMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSetMostRecentlyViewedBoardPayload",
                            "kind": "LinkedField",
                            "name": "setMostRecentlyViewedBoard",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v2 /*: any*/ ,
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "460e3bc3e7ed3d8d27b904af0f9749ba9913444eb0c65d55e5522990c53522ff",
            "metadata": {},
            "name": "setMostRecentlyViewedBoardMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$08d2dc7d025ea157$var$node.hash = "4cedd313a6b84b6c272b36ea0fb2a5e6";
var $08d2dc7d025ea157$export$2e2bcd8739ae039 = $08d2dc7d025ea157$var$node;

});

parcelRegister("eCBf9", function(module, exports) {

$parcel$export(module.exports, "MutationError", () => $5fe48c9a5d56428c$export$10c788363424e94e);
class $5fe48c9a5d56428c$export$10c788363424e94e extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.message = payload.message ?? '';
        this.extensions = payload.extensions;
        this.statusCode = payload.extensions?.statusCode ?? null;
        this.errorType = payload.extensions?.errorType ?? null;
    }
}

});


parcelRegister("7Ib1j", function(module, exports) {

$parcel$export(module.exports, "CustomTemplateProjectBanner", () => $1d7413b3f4dbc2fa$export$659f09fccafc59ca);

var $8VUgV = parcelRequire("8VUgV");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dS3PR = parcelRequire("dS3PR");

var $l5jpf = parcelRequire("l5jpf");

var $koVbs = parcelRequire("koVbs");

var $aQoCL = parcelRequire("aQoCL");
const $1d7413b3f4dbc2fa$var$isBannerSupported = ()=>{
    if (false) return true;
    if (typeof window !== 'undefined') return window.__SPA__;
    return false;
};
const $1d7413b3f4dbc2fa$export$659f09fccafc59ca = ({ projectFragment: projectFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $8VUgV.default), projectFragment);
    return data.isLiveTemplate === true && $1d7413b3f4dbc2fa$var$isBannerSupported() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l5jpf.JiraBanner), {
        appearance: "announcement",
        messageId: "horizontal-nav.ui.content.banner",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $aQoCL.default).customTemplateProjectBannerMessage)));
};

});
parcelRegister("8VUgV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6aa7e4c35098a2c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<53e84c22517867c880da6c976b95643a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f6aa7e4c35098a2c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CustomTemplateProjectBanner",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isLiveTemplate"
        }
    ],
    "type": "JiraProject"
};
$f6aa7e4c35098a2c$var$node.hash = "8fa4edcc596948b7b940eaf11aa2562a";
var $f6aa7e4c35098a2c$export$2e2bcd8739ae039 = $f6aa7e4c35098a2c$var$node;

});

parcelRegister("l5jpf", function(module, exports) {

$parcel$export(module.exports, "JiraBanner", () => $3840750ff328d8cb$export$23eaf79dd14ebe6e);

var $5uXOq = parcelRequire("5uXOq");

var $lkmWu = parcelRequire("lkmWu");

var $10xFf = parcelRequire("10xFf");

var $lAEmg = parcelRequire("lAEmg");
const $3840750ff328d8cb$export$23eaf79dd14ebe6e = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lAEmg.ChoreographerBanner), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkmWu.default), rest);
};

});
parcelRegister("lAEmg", function(module, exports) {

$parcel$export(module.exports, "ChoreographerBanner", () => $f0c8589fc9ef9b7d$export$d77caaec2153a90b);

var $lkmWu = parcelRequire("lkmWu");

var $cSWNW = parcelRequire("cSWNW");
const $f0c8589fc9ef9b7d$export$d77caaec2153a90b = (0, $cSWNW.withChoreographedRender)((0, $lkmWu.default));

});


parcelRegister("aQoCL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ed507aac7e03085$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6ed507aac7e03085$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultViewRedirectFlagTitle: {
        "id": "business-horizontal-nav.project-navigation.default-view-redirect-flag-title",
        "defaultMessage": "We've taken you to the default view"
    },
    defaultViewRedirectFlagDescription: {
        "id": "business-horizontal-nav.project-navigation.default-view-redirect-flag-description",
        "defaultMessage": "The view you're trying to access has been removed."
    },
    customTemplateProjectBannerMessage: {
        "id": "jira-horizontal-nav.custom-template-project-banner-message",
        "defaultMessage": "This project is saved as a custom template. Project settings changes will apply to the template."
    },
    projectNavigation: {
        "id": "jira-horizontal-nav.project-navigation",
        "defaultMessage": "Project navigation"
    }
});

});


parcelRegister("fK1eg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9e172e45f4424ed$export$2e2bcd8739ae039);

var $caHFT = parcelRequire("caHFT");

var $doRiK = parcelRequire("doRiK");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2vSU6 = parcelRequire("2vSU6");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $irF25 = parcelRequire("irF25");

var $hzZnF = parcelRequire("hzZnF");

var $4VBHB = parcelRequire("4VBHB");
const $d9e172e45f4424ed$var$NavHeader = ({ queryFragment: queryFragment, projectFragment: projectFragment = null })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const data = (0, $8Uumt.useFragment)((0, $doRiK.default), queryFragment);
    const projectData = (0, $8Uumt.useFragment)((0, $caHFT.default), projectFragment);
    if ((0, $4R6GH.fg)('blu-7761-tabbed-nav-relay-checks')) {
        // a user board can only exist outside of a project
        if (data.jira.jiraBoard?.__typename === 'JiraBoard' && !projectData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4VBHB.UserBoardHeader), {
            boardFragment: data.jira.jiraBoard
        });
    } else if (data.jira.jiraBoard && !projectData) // @ts-expect-error Expecting data.jira.jiraBoard to be a JiraBoard type
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4VBHB.UserBoardHeader), {
        boardFragment: data.jira.jiraBoard
    });
    // from this point, we only support project scope
    if (!projectData) return null;
    if ((0, $4R6GH.fg)('issue_terminology_refresh_change_boarding_modal')) {
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'projectOrIssuePage',
            action: 'viewed'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'projectOrIssueScreen');
    }
    const board = data.jira.jiraBoard ?? projectData?.mostRecentlyViewedBoard;
    // softwareBoardCount >= 1 condition ensures boardless projects have the correct header (ie ProjectHeader)
    if (board && projectData.projectType === (0, $2vSU6.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT) && projectData.projectStyle === (0, $2vSU6.COMPANY_MANAGED_PROJECT) && projectData.softwareBoardCount && projectData.softwareBoardCount >= 1) // @ts-expect-error Expecting board to be a JiraBoard type
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irF25.HorizontalNavBoardHeader), {
        boardFragment: board,
        projectFragment: projectData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hzZnF.ProjectHeader), {
        queryFragment: data,
        projectFragment: projectData
    });
};
var $d9e172e45f4424ed$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($d9e172e45f4424ed$var$NavHeader);

});
parcelRegister("caHFT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed7f59a739301f95$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cb3d49ec1361822d0b50dc23ab66269c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ed7f59a739301f95$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isTMPBoardRoute"
        }
    ],
    "kind": "Fragment",
    "name": "NavHeader_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ProjectHeader_project"
        },
        {
            "kind": "FragmentSpread",
            "name": "HorizontalNavBoardHeader_project"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectStyle"
            },
            "action": "THROW",
            "path": "projectStyle"
        },
        {
            "kind": "ScalarField",
            "name": "softwareBoardCount"
        },
        {
            "condition": "isTMPBoardRoute",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "mostRecentlyViewedBoard",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "HorizontalNavBoardHeader_board"
                                }
                            ],
                            "type": "JiraBoard"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$ed7f59a739301f95$var$node.hash = "e6f2c3a6daae909edfe8b5a8b679337c";
var $ed7f59a739301f95$export$2e2bcd8739ae039 = $ed7f59a739301f95$var$node;

});

parcelRegister("doRiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1ccaf9d0c88deef$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<991301e4ae06f83b6b953ffeb227d1f0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f1ccaf9d0c88deef$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "boardId"
        },
        {
            "kind": "RootArgument",
            "name": "withBoard"
        }
    ],
    "kind": "Fragment",
    "name": "NavHeader_query",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ProjectHeader_query"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "withBoard",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "id",
                                        "variableName": "boardId"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "jiraBoard",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "UserBoardHeader_board"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "HorizontalNavBoardHeader_board"
                                            }
                                        ],
                                        "type": "JiraBoard"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$f1ccaf9d0c88deef$var$node.hash = "40f4384a6241e1becab27e3bdaca23ec";
var $f1ccaf9d0c88deef$export$2e2bcd8739ae039 = $f1ccaf9d0c88deef$var$node;

});

parcelRegister("irF25", function(module, exports) {

$parcel$export(module.exports, "HorizontalNavBoardHeader", () => $30137961c15e82bc$export$a50d1fe8d7279a5c);

var $8CWoZ = parcelRequire("8CWoZ");

var $d9zQ5 = parcelRequire("d9zQ5");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");


var $g7crU = parcelRequire("g7crU");


var $2203k = parcelRequire("2203k");

var $iXVV6 = parcelRequire("iXVV6");

var $eC0BO = parcelRequire("eC0BO");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $krB5y = parcelRequire("krB5y");

var $hjXMc = parcelRequire("hjXMc");

var $2qjHu = parcelRequire("2qjHu");
const $30137961c15e82bc$export$a50d1fe8d7279a5c = ({ boardFragment: boardFragment, projectFragment: projectFragment = null })=>{
    const [isFullscreen] = (0, $g7crU.useIsFullscreen)();
    const board = (0, $8Uumt.useFragment)((0, $d9zQ5.default), boardFragment);
    const project = (0, $8Uumt.useFragment)((0, $8CWoZ.default), projectFragment);
    const toBoardType = (jiraBoardType)=>{
        if (jiraBoardType === 'SCRUM') return 0, $8f9d7295a53f46ca$export$b75edebf0c64f31e;
        if (jiraBoardType === 'KANBAN') return 0, $8f9d7295a53f46ca$export$eff0efe8746a33f;
    };
    const boardData = (0, $5uXOq.useMemo)(()=>{
        if (board?.__typename !== 'JiraBoard') return null;
        const isPublicBoard = !!board.name;
        return isPublicBoard ? {
            id: board?.boardId?.toString(),
            dataId: board?.__id,
            admins: {
                users: [],
                groups: []
            },
            name: board.name,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            type: toBoardType(board.boardType),
            favourite: board.favouriteValue?.isFavourite ?? false,
            canEdit: !!board.canEdit
        } : {
            id: board?.boardId?.toString(),
            dataId: board?.__id,
            admins: {
                users: [],
                groups: []
            },
            canEdit: !!board.canEdit,
            isPrivate: true
        };
    }, [
        board
    ]);
    const showTeamButton = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('team-connection-visibility-in-jira') && (0, $6s1PB.expVal)('team_and_container_m1', 'isEnabled', false);
    const analyticsData = (0, $5uXOq.useMemo)(()=>({
            navigationContainer: (0, $68cb678dc917978e$export$b83d0ee9325a2d0a)
        }), []);
    if (board == null || board.__typename !== 'JiraBoard' || board.boardId == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eC0BO.default), {
        title: board.name,
        isLoading: board == null,
        extraComponentsClose: [
            showTeamButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2qjHu.NavigationTeamButton), {
                key: "TeamButton",
                projectFragment: project ?? null,
                scope: "board"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                key: "BoardActions",
                attributes: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2203k.BoardActions), {
                key: "BoardActions",
                board: boardData,
                projectFragment: project ?? null,
                isBoardFavorite: board.favouriteValue?.isFavourite ?? undefined
            }))
        ],
        extraComponentsFar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krB5y.ExtraComponentsFar), {
            projectFragment: project ?? null
        }),
        testId: "horizontal-nav-header.ui.board-header.header",
        extraComponentsAbove: !isFullscreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjXMc.HorizontalNavProjectBreadcrumbs), {
            projectFragment: project ?? null,
            shouldShowProjectName: true
        })
    });
};

});
parcelRegister("8CWoZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4383aaac6682da6c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0e2cdcef8dcfebdff39ba9650da81044>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4383aaac6682da6c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "isTMPBoardRoute"
        }
    ],
    "kind": "Fragment",
    "name": "HorizontalNavBoardHeader_project",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "NavigationTeamButton_project"
                }
            ]
        },
        {
            "condition": "isTMPBoardRoute",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_navigationBoardActionMenu_BoardActions"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "extraComponentsFar_horizontalNav"
        },
        {
            "kind": "FragmentSpread",
            "name": "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs"
        }
    ],
    "type": "JiraProject"
};
$4383aaac6682da6c$var$node.hash = "0182ef8ea67e2047a2c73a62c74cf453";
var $4383aaac6682da6c$export$2e2bcd8739ae039 = $4383aaac6682da6c$var$node;

});

parcelRegister("d9zQ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $78aa502f173ea5af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<739dfc853bfad69d6e306d8e6203605d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $78aa502f173ea5af$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "HorizontalNavBoardHeader_board",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "boardId"
            },
            "action": "THROW",
            "path": "boardId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "ScalarField",
            "name": "canEdit"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "boardType"
            },
            "action": "THROW",
            "path": "boardType"
        },
        {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                    },
                    "action": "THROW",
                    "path": "favouriteValue.isFavourite"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "__id"
                    },
                    "action": "THROW",
                    "path": "__id"
                }
            ]
        }
    ],
    "type": "JiraBoard"
};
$78aa502f173ea5af$var$node.hash = "2bee90c92c0551f1635f4463f247385b";
var $78aa502f173ea5af$export$2e2bcd8739ae039 = $78aa502f173ea5af$var$node;

});

const $8f9d7295a53f46ca$export$b75edebf0c64f31e = 'scrum';
const $8f9d7295a53f46ca$export$eff0efe8746a33f = 'kanban';
const $8f9d7295a53f46ca$export$aca095bc476d426f = 'simple';

const $68cb678dc917978e$export$2ee9e5a3556c1e43 = 'sidebar';
const $68cb678dc917978e$export$793ed84f5e13fedc = 'top';
const $68cb678dc917978e$export$f1c9dd0f5207dd5e = 'tab';
const $68cb678dc917978e$export$b83d0ee9325a2d0a = 'projectTitle';

parcelRegister("2203k", function(module, exports) {

$parcel$export(module.exports, "BoardActions", () => $5884ba870969fb86$export$bb50bc4d1176eb2f);

var $7FzK5 = parcelRequire("7FzK5");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $8U6zd = parcelRequire("8U6zd");

var $42CjB = parcelRequire("42CjB");

var $4IrpZ = parcelRequire("4IrpZ");

var $epOG5 = parcelRequire("epOG5");

var $kJpBP = parcelRequire("kJpBP");
var $3Z96c = parcelRequire("3Z96c");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $dS3PR = parcelRequire("dS3PR");

var $6BtlL = parcelRequire("6BtlL");

var $9BBUA = parcelRequire("9BBUA");

var $koVbs = parcelRequire("koVbs");

var $9g2vH = parcelRequire("9g2vH");


var $eDLAW = parcelRequire("eDLAW");

var $36mJD = parcelRequire("36mJD");

var $d62in = parcelRequire("d62in");

var $jgJNO = parcelRequire("jgJNO");

var $koeKL = parcelRequire("koeKL");

var $lVJAU = parcelRequire("lVJAU");

var $3HwlS = parcelRequire("3HwlS");

var $4R6GH = parcelRequire("4R6GH");

var $hCCtP = parcelRequire("hCCtP");

var $h2QE2 = parcelRequire("h2QE2");

var $8j0rr = parcelRequire("8j0rr");

var $lmBAt = parcelRequire("lmBAt");

var $LmW5e = parcelRequire("LmW5e");

var $eIGIx = parcelRequire("eIGIx");

var $gYrf5 = parcelRequire("gYrf5");
const $5884ba870969fb86$export$bb50bc4d1176eb2f = (0, $LmW5e.memoWithCondition)(()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'), ({ board: board, projectFragment: projectFragment, placement: placement, isBoardFavorite: isBoardFavorite = false, isParentProjectStarred: isParentProjectStarred, forceOpen: forceOpen = false, iconButtonSpacing: iconButtonSpacing = 'default' })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(forceOpen);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { sendMeatBallDropDownOnBoardsAnalyticsEvent: sendMeatBallDropDownOnBoardsAnalyticsEvent } = (0, $eDLAW.useProjectsAnalyticsL3)();
    const { sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent: sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent } = (0, $36mJD.useProjectsAnalyticsL4)();
    const project = (0, $8Uumt.useFragment)((0, $7FzK5.default), projectFragment);
    const tenantId = (0, $koeKL.useCloudId)();
    const boardARI = (0, $6BtlL.JiraSoftwareBoardAri).create({
        siteId: tenantId,
        boardId: board?.id.toString() ?? ''
    }).toString();
    const [showDeleteModal, setShowDeleteModal] = (0, $5uXOq.useState)(false);
    const boardId = board?.id || '';
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const route = (0, $8j0rr.useRoute)();
    const isBacklogUrl = (0, $9g2vH.isBacklogRoute)(route.name);
    const openModal = ()=>{
        setShowDeleteModal(true);
        sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent({
            recent: !isParentProjectStarred,
            starred: isParentProjectStarred ?? false,
            boardId: Number(boardId),
            itemId: (0, $496585bee7985bb9$export$a68d619e7022f2c3),
            projectId: project?.projectId ?? '',
            projectType: project?.projectType
        });
    };
    const handleBoardDelete = ()=>{
        if (!board?.dataId) return;
        setShowDeleteModal(false);
        push(`/browse/${project?.projectKey}`);
    };
    const handleModalCancel = ()=>{
        setShowDeleteModal(false);
    };
    const IconButton = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? (0, $hCCtP.ThemedIconButton) : (0, $42CjB.default);
    const onBoardDeleteFailed = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? (0, $5uXOq.useCallback)(()=>setShowDeleteModal(false), []) : ()=>setShowDeleteModal(false);
    const onTriggerClick = (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? (0, $5uXOq.useCallback)(()=>{
        setIsOpen(!isOpen);
        sendMeatBallDropDownOnBoardsAnalyticsEvent({
            recent: !isParentProjectStarred,
            starred: isParentProjectStarred ?? false,
            boardId: Number(boardId),
            projectId: project?.projectId ?? '',
            projectType: project?.projectType
        });
    }, [
        isOpen,
        sendMeatBallDropDownOnBoardsAnalyticsEvent,
        isParentProjectStarred,
        boardId,
        project?.projectId,
        project?.projectType
    ]) : ()=>{
        setIsOpen(!isOpen);
        sendMeatBallDropDownOnBoardsAnalyticsEvent({
            recent: !isParentProjectStarred,
            starred: isParentProjectStarred ?? false,
            boardId: Number(boardId),
            projectId: project?.projectId ?? '',
            projectType: project?.projectType
        });
    };
    const onClose = (0, $eIGIx.useCallbackWithCondition)(()=>setIsOpen(false), [], ()=>(0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1'));
    if (!project?.projectKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: onClose,
        placement: placement ?? 'bottom-start',
        testId: "navigation-board-action-menu.ui.popup",
        messageId: "navigation-board-action-menu.ui.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d62in.FavoriteToggleButton), {
                entityId: boardARI,
                entityTypeName: "JiraBoard",
                defaultIsStarred: isBoardFavorite,
                onClick: ()=>sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent({
                        recent: !isParentProjectStarred,
                        starred: isParentProjectStarred ?? false,
                        itemId: isBoardFavorite ? (0, $496585bee7985bb9$export$7ae7abcf2c19d3e5) : (0, $496585bee7985bb9$export$78fd0bd637fe1684),
                        boardId: Number(boardId),
                        projectId: project?.projectId ?? '',
                        projectType: project?.projectType
                    })
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($epOG5))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)",
                    spacing: "spacious"
                }),
                "aria-label": formatMessage((0, $gYrf5.default).boardSettingsLabel),
                href: $5884ba870969fb86$var$getJSWCMPBoardSettingsUrl(project?.projectKey, boardId, isBacklogUrl),
                onClick: ()=>{
                    sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent({
                        recent: !isParentProjectStarred,
                        starred: isParentProjectStarred ?? false,
                        boardId: Number(boardId),
                        itemId: (0, $496585bee7985bb9$export$192d610b0b7719f4),
                        projectId: project?.projectId ?? '',
                        projectType: project?.projectType
                    });
                }
            }, formatMessage((0, $gYrf5.default).boardSettingsLabel))), board?.canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
                hasSeparator: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4IrpZ))), {
                    label: "",
                    spacing: "spacious",
                    color: "var(--ds-icon-accent-red, #C9372C)"
                }),
                onClick: openModal
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                color: "color.text.danger"
            }, formatMessage((0, $gYrf5.default).deleteBoardLabel))))), board && board.canEdit && showDeleteModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9BBUA.default), {
                board: board,
                // eslint-disable-next-line jira/deprecations/no-base-url
                baseUrl: "",
                onBoardDeleteFailed: onBoardDeleteFailed,
                onBoardDeleted: handleBoardDelete,
                onCancel: handleModalCancel
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconButton, {
                ...triggerProps,
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                        ...iconProps,
                        size: "small"
                    }),
                label: formatMessage((0, $gYrf5.default).dropdownIconLabel),
                appearance: "subtle",
                spacing: (0, $4R6GH.fg)('jira-project-theming-m2-bug-fixes') ? iconButtonSpacing : 'default',
                onClick: onTriggerClick,
                isSelected: isOpen,
                testId: "navigation-board-action-menu.ui.dropdown"
            }),
        shouldRenderToParent: (0, $4R6GH.fg)('a11y-actions-menus-reading-order')
    });
});
function $5884ba870969fb86$var$getJSWCMPBoardSettingsUrl(projectKey, boardId, isBacklogUrl) {
    const supportsCurrentNav = (0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)();
    if (supportsCurrentNav && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) {
        const query = isBacklogUrl ? '?from-backlog=1' : '';
        return `${(0, $h2QE2.getBoardSettingsUrl)((0, $h2QE2.getBoardUrl)(projectKey, boardId, true))}/filter${query}`;
    }
    const path = isBacklogUrl ? '/backlog' : '';
    return `/jira/software/c/projects/${projectKey}/boards/${boardId}${path}?config=filter`;
}

});
parcelRegister("7FzK5", function(module, exports) {

$parcel$export(module.exports, "default", () => $18a3e7e58b3c58ae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<caaf1222eee2525329079525fc89c17d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $18a3e7e58b3c58ae$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_navigationBoardActionMenu_BoardActions",
    "selections": [
        {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        }
    ],
    "type": "JiraProject"
};
$18a3e7e58b3c58ae$var$node.hash = "c4890e10b4a9bc525d38501ea5a616a3";
var $18a3e7e58b3c58ae$export$2e2bcd8739ae039 = $18a3e7e58b3c58ae$var$node;

});

parcelRegister("4IrpZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32784ef133e6e682f32ae3035edbf69e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36f08a2f957bd6ab$var$_react = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $36f08a2f957bd6ab$var$_baseNew = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $36f08a2f957bd6ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36f08a2f957bd6ab$var$DeleteIcon = (props)=>/*#__PURE__*/ $36f08a2f957bd6ab$var$_react.default.createElement($36f08a2f957bd6ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$36f08a2f957bd6ab$var$DeleteIcon.displayName = 'DeleteIcon';
var $36f08a2f957bd6ab$var$_default = module.exports.default = $36f08a2f957bd6ab$var$DeleteIcon;

});

parcelRegister("6BtlL", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAri", () => $4cecf7137216f798$export$fcd404066e55a7a8);

var $8ANGM = parcelRequire("8ANGM");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira-software/board/manifest.ts
var $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $8ANGM.JiraSoftwareBoardAriResourceOwner),
    resourceType: (0, $8ANGM.JiraSoftwareBoardAriResourceType),
    resourceIdSlug: "{boardId}",
    resourceIdSegmentFormats: {
        boardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira-software/board/index.ts
var $4cecf7137216f798$export$fcd404066e55a7a8 = class _JiraSoftwareBoardAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._boardId = opts.resourceIdSegmentValues.boardId;
    }
    get siteId() {
        return this._siteId;
    }
    get boardId() {
        return this._boardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.qualifier,
            platformQualifier: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.resourceOwner,
            resourceType: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.resourceType,
            resourceId: `${opts.boardId}`,
            resourceIdSegmentValues: {
                boardId: opts.boardId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            boardId: this.boardId
        };
    }
};

});
parcelRegister("8ANGM", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAriResourceOwner", () => $64183abbeecc9672$export$d716ba4f5572ec86);
$parcel$export(module.exports, "JiraSoftwareBoardAriResourceType", () => $64183abbeecc9672$export$d4b70c04cf2221a5);
// src/jira-software/board/types.ts
var $64183abbeecc9672$export$d716ba4f5572ec86 = "jira-software", $64183abbeecc9672$export$d4b70c04cf2221a5 = "board";

});


parcelRegister("9BBUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $22a0504256a529d4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jzjy1 = parcelRequire("jzjy1");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");


var $1tXsX = parcelRequire("1tXsX");

var $49qY2 = parcelRequire("49qY2");

var $ck8Za = parcelRequire("ck8Za");

var $iAAcr = parcelRequire("iAAcr");
// eslint-disable-next-line jira/react/no-class-components
class $22a0504256a529d4$var$DeleteModal extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onInitialised: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onBoardDeleted: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $ck8Za.default)((0, $1tXsX.default));
        this.store.dispatch((0, $49qY2.setAppProps)(this.props));
        this.store.dispatch((0, $49qY2.getActiveSprints)());
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iAAcr.default), null)));
    }
}
var $22a0504256a529d4$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSource)('deleteBoard', (0, $4d5e0871c06cee03$export$1171103ea9083ffa))($22a0504256a529d4$var$DeleteModal);

});
parcelRegister("lf2Au", function(module, exports) {

$parcel$export(module.exports, "default", () => $9249f8c63b854f95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $9249f8c63b854f95$var$AppStyle = ({ children: children })=>/*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            "_11c82smr _4t3i1kw7"
        ])
    }, children);
const $9249f8c63b854f95$var$appStyles = null;
var $9249f8c63b854f95$export$2e2bcd8739ae039 = $9249f8c63b854f95$var$AppStyle;

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("1tXsX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b51ccb85a14bd3c5$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $3pHol = parcelRequire("3pHol");

var $jxD18 = parcelRequire("jxD18");
var // @ts-expect-error - TS2769 - No overload matches this call.
$b51ccb85a14bd3c5$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $3pHol.default), (0, $jxD18.default));

});
parcelRegister("3pHol", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b51828983128039$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");


var $fsh9d = parcelRequire("fsh9d");

var $9xsrV = parcelRequire("9xsrV");

var $49qY2 = parcelRequire("49qY2");

var $8ojMd = parcelRequire("8ojMd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b51828983128039$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $49qY2.DELETE_BOARD)).mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $8ojMd.getBaseUrl)(state);
        const board = (0, $8ojMd.getBoard)(state);
        return (0, $9xsrV.default)(baseUrl, board.id).mergeMap(()=>{
            (0, $8ojMd.getOnBoardDeleted)(state)(board);
            return (0, $kVLXA.Observable).of((0, $49qY2.boardDeleted)());
        }).catch((error)=>{
            (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'directories.boards-v2.delete-modal.ops.delete-board', (0, $cb28450c2d487e75$export$f1a2e76e49f3534e));
            const reason = error.statusCode === 404 ? 'board-not-found' : 'unknown';
            (0, $8ojMd.getOnBoardDeleteFailed)(state)(board, reason);
            return (0, $kVLXA.Observable).of((0, $49qY2.deleteBoardFailed)({
                reason: reason
            }));
        });
    });

});
const $cb28450c2d487e75$export$f1a2e76e49f3534e = 'directories.boards.error';

parcelRegister("fsh9d", function(module, exports) {

$parcel$export(module.exports, "logSafeErrorWithoutCustomerData", () => $064efdbf2b7e743c$export$c77be5886e7f1d9e);

var $2YZCu = parcelRequire("2YZCu");
const $064efdbf2b7e743c$export$b94ad046ae639a1c = (error, location, suffix, message)=>(0, $2YZCu.default).safeErrorWithoutCustomerData(location, message || error.message, error);
const $064efdbf2b7e743c$export$c77be5886e7f1d9e = (error, location, suffix, message)=>(0, $2YZCu.default).safeErrorWithoutCustomerData(location, message || error.message, error);

});

parcelRegister("9xsrV", function(module, exports) {

$parcel$export(module.exports, "default", () => $30eef91be03ea0d6$export$2e2bcd8739ae039);

var $487fd = parcelRequire("487fd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$30eef91be03ea0d6$export$2e2bcd8739ae039 = (baseUrl, boardId)=>{
    const url = `/rest/agile/1.0/board/${boardId}`;
    const options = {
        method: 'delete'
    };
    return (0, $487fd.default)(url, options);
};

});
parcelRegister("487fd", function(module, exports) {

$parcel$export(module.exports, "default", () => $96196282ac54fa24$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $x9xyg = parcelRequire("x9xyg");

var $5HnTq = parcelRequire("5HnTq");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $96196282ac54fa24$var$noContentStatus = 204;
const $96196282ac54fa24$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $96196282ac54fa24$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$96196282ac54fa24$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $x9xyg.setMark)(`BEGIN_${key}`);
    }
    return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), opts), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $x9xyg.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, str, traceId);
                else throw new (0, $jJZqs.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $96196282ac54fa24$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        return response.json();
    });
}
var $96196282ac54fa24$export$2e2bcd8739ae039 = $96196282ac54fa24$var$fetchJson$;

});


parcelRegister("49qY2", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $d54547bc1c4d086f$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $d54547bc1c4d086f$export$cfda7627848a58cd);
$parcel$export(module.exports, "GET_ACTIVE_SPRINTS", () => $d54547bc1c4d086f$export$590db52f99257537);
$parcel$export(module.exports, "getActiveSprints", () => $d54547bc1c4d086f$export$2893b8608d2a6d6a);
$parcel$export(module.exports, "ACTIVE_SPRINTS_RETRIEVED", () => $d54547bc1c4d086f$export$215dde409662413);
$parcel$export(module.exports, "activeSprintsRetrieved", () => $d54547bc1c4d086f$export$12dcad2fd94d0a72);
$parcel$export(module.exports, "GET_ACTIVE_SPRINTS_FAILED", () => $d54547bc1c4d086f$export$14cf35077b6f85f7);
$parcel$export(module.exports, "getActiveSprintsFailed", () => $d54547bc1c4d086f$export$694c6ee523cd87cb);
$parcel$export(module.exports, "DELETE_BOARD", () => $d54547bc1c4d086f$export$a68d619e7022f2c3);
$parcel$export(module.exports, "deleteBoard", () => $d54547bc1c4d086f$export$fc0ef3a3a9b2b3cd);
$parcel$export(module.exports, "DELETE_BOARD_FAILED", () => $d54547bc1c4d086f$export$8cad23f5fe7e6ff3);
$parcel$export(module.exports, "deleteBoardFailed", () => $d54547bc1c4d086f$export$983279b2aa6031b0);
$parcel$export(module.exports, "BOARD_DELETED", () => $d54547bc1c4d086f$export$aea8ac0fecc03cf6);
$parcel$export(module.exports, "boardDeleted", () => $d54547bc1c4d086f$export$d6d2ce109de8e68b);
const $d54547bc1c4d086f$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
const $d54547bc1c4d086f$export$cfda7627848a58cd = (payload)=>({
        type: $d54547bc1c4d086f$export$8aefe701a6f431e0,
        payload: payload
    });
const $d54547bc1c4d086f$export$590db52f99257537 = 'state.GET_ACTIVE_SPRINTS';
const $d54547bc1c4d086f$export$2893b8608d2a6d6a = ()=>({
        type: $d54547bc1c4d086f$export$590db52f99257537
    });
const $d54547bc1c4d086f$export$215dde409662413 = 'state.ACTIVE_SPRINTS_RETRIEVED';
const $d54547bc1c4d086f$export$12dcad2fd94d0a72 = (payload)=>({
        type: $d54547bc1c4d086f$export$215dde409662413,
        payload: payload
    });
const $d54547bc1c4d086f$export$14cf35077b6f85f7 = 'state.GET_ACTIVE_SPRINTS_FAILED';
const $d54547bc1c4d086f$export$694c6ee523cd87cb = ()=>({
        type: $d54547bc1c4d086f$export$14cf35077b6f85f7
    });
const $d54547bc1c4d086f$export$a68d619e7022f2c3 = 'state.DELETE_BOARD';
const $d54547bc1c4d086f$export$fc0ef3a3a9b2b3cd = ()=>({
        type: $d54547bc1c4d086f$export$a68d619e7022f2c3
    });
const $d54547bc1c4d086f$export$8cad23f5fe7e6ff3 = 'state.DELETE_BOARD_FAILED';
const $d54547bc1c4d086f$export$983279b2aa6031b0 = (payload)=>({
        type: $d54547bc1c4d086f$export$8cad23f5fe7e6ff3,
        payload: payload
    });
const $d54547bc1c4d086f$export$aea8ac0fecc03cf6 = 'state.BOARD_DELETED';
const $d54547bc1c4d086f$export$d6d2ce109de8e68b = ()=>({
        type: $d54547bc1c4d086f$export$aea8ac0fecc03cf6
    });

});

parcelRegister("8ojMd", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $fd5d0e91a7503729$export$f654b28f82155665);
$parcel$export(module.exports, "getBoard", () => $fd5d0e91a7503729$export$2223f2dfcfd77cef);
$parcel$export(module.exports, "getOnInitialised", () => $fd5d0e91a7503729$export$47263859bc15a8b8);
$parcel$export(module.exports, "getOnBoardDeleted", () => $fd5d0e91a7503729$export$3efb56c7750e8ce1);
$parcel$export(module.exports, "getOnBoardDeleteFailed", () => $fd5d0e91a7503729$export$311506722a7438bc);
$parcel$export(module.exports, "getOnCancel", () => $fd5d0e91a7503729$export$2c6267c00ffc9906);
$parcel$export(module.exports, "isDeleteInProgress", () => $fd5d0e91a7503729$export$906c0d65e4ece39d);
$parcel$export(module.exports, "getSprintInformation", () => $fd5d0e91a7503729$export$4e64490e97fad74a);
const $fd5d0e91a7503729$export$f654b28f82155665 = (state)=>state.appProps.baseUrl;
const $fd5d0e91a7503729$export$2223f2dfcfd77cef = (state)=>state.appProps.board;
const $fd5d0e91a7503729$export$47263859bc15a8b8 = (state)=>state.appProps.onInitialised;
const $fd5d0e91a7503729$export$3efb56c7750e8ce1 = (state)=>state.appProps.onBoardDeleted;
const $fd5d0e91a7503729$export$311506722a7438bc = (state)=>state.appProps.onBoardDeleteFailed;
const $fd5d0e91a7503729$export$2c6267c00ffc9906 = (state)=>state.appProps.onCancel;
const $fd5d0e91a7503729$export$906c0d65e4ece39d = (state)=>state.isDeleteInProgress;
const $fd5d0e91a7503729$export$4e64490e97fad74a = (state)=>state.sprintInformation;

});


parcelRegister("jxD18", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b8e1cebd0698b37$export$2e2bcd8739ae039);
parcelRequire("9o0uh");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");



var $fsh9d = parcelRequire("fsh9d");

var $1o0mA = parcelRequire("1o0mA");

var $49qY2 = parcelRequire("49qY2");

var $8ojMd = parcelRequire("8ojMd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8b8e1cebd0698b37$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $49qY2.GET_ACTIVE_SPRINTS)).mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $8ojMd.getBaseUrl)(state);
        const board = (0, $8ojMd.getBoard)(state);
        // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'. | TS2339 - Property 'type' does not exist on type 'Board'.
        const shouldSkipCheckingActiveSprints = board.isPrivate || board.type !== (0, $8f9d7295a53f46ca$export$b75edebf0c64f31e);
        if (shouldSkipCheckingActiveSprints) {
            (0, $8ojMd.getOnInitialised)(state)();
            return (0, $kVLXA.Observable).of((0, $49qY2.activeSprintsRetrieved)([]));
        }
        return (0, $kVLXA.Observable).fromPromise((0, $1o0mA.default)(baseUrl, board.id)).mergeMap((sprints)=>{
            (0, $8ojMd.getOnInitialised)(state)();
            return (0, $kVLXA.Observable).of((0, $49qY2.activeSprintsRetrieved)(sprints));
        })// @ts-expect-error - TS2345 - Argument of type '(error: FetchError) => Observable<ActiveSprintsRetrievedAction> | Observable<GetActiveSprintsFailedAction>' is not assignable to parameter of type '(err: any, caught: Observable<ActiveSprintsRetrievedAction>) => ObservableInput<ActiveSprintsRetrievedAction>'.
        .catch((error)=>{
            if (error.statusCode === 404) return (0, $kVLXA.Observable).of((0, $49qY2.activeSprintsRetrieved)([]));
            (0, $fsh9d.logSafeErrorWithoutCustomerData)(error, 'directories.boards-v2.delete-modal.ops.get-active-sprints', (0, $cb28450c2d487e75$export$f1a2e76e49f3534e));
            return (0, $kVLXA.Observable).of((0, $49qY2.getActiveSprintsFailed)());
        });
    });

});
parcelRegister("1o0mA", function(module, exports) {

$parcel$export(module.exports, "default", () => $593a1371127faca1$export$2e2bcd8739ae039);

var $cVp8I = parcelRequire("cVp8I");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$593a1371127faca1$export$2e2bcd8739ae039 = async (baseUrl, boardId)=>{
    const activeSprints = await (0, $cVp8I.default)(baseUrl, boardId);
    return activeSprints.values;
};

});
parcelRegister("cVp8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f7120231aa21daa$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $7f4tk = parcelRequire("7f4tk");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8f7120231aa21daa$export$2e2bcd8739ae039 = (baseUrl, boardId)=>{
    const params = (0, $ebyGx.stringify)({
        state: 'active'
    });
    return (0, $7f4tk.default)(`/rest/agile/1.0/board/${boardId}/sprint?${params}`);
};

});




parcelRegister("ck8Za", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ca4b6202c29f451$export$2e2bcd8739ae039);

var $F2Mxm = parcelRequire("F2Mxm");

var $0jPL7 = parcelRequire("0jPL7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5ca4b6202c29f451$export$2e2bcd8739ae039 = (rootEpic)=>(0, $F2Mxm.default)({
        appName: 'directories/boards-v2/delete-modal',
        rootReducer: $0jPL7.default,
        rootEpic: rootEpic
    });

});
parcelRegister("0jPL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2fd5f8b2e6ddfae$export$2e2bcd8739ae039);

var $49qY2 = parcelRequire("49qY2");
const $e2fd5f8b2e6ddfae$var$defaultState = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    appProps: undefined,
    sprintInformation: undefined,
    isDeleteInProgress: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e2fd5f8b2e6ddfae$export$2e2bcd8739ae039 = (state = $e2fd5f8b2e6ddfae$var$defaultState, action)=>{
    switch(action.type){
        case 0, $49qY2.SET_APP_PROPS:
            return {
                ...state,
                appProps: action.payload
            };
        case 0, $49qY2.DELETE_BOARD:
            return {
                ...state,
                isDeleteInProgress: true
            };
        case 0, $49qY2.DELETE_BOARD_FAILED:
            return {
                ...state,
                isDeleteInProgress: false
            };
        case 0, $49qY2.ACTIVE_SPRINTS_RETRIEVED:
            return {
                ...state,
                sprintInformation: {
                    sprints: action.payload
                }
            };
        case 0, $49qY2.GET_ACTIVE_SPRINTS_FAILED:
            return {
                ...state,
                sprintInformation: {
                    error: true
                }
            };
        case 0, $49qY2.GET_ACTIVE_SPRINTS:
        case 0, $49qY2.BOARD_DELETED:
            return state;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("iAAcr", function(module, exports) {

$parcel$export(module.exports, "default", () => $af343ed9c16b8de5$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $az4zD = parcelRequire("az4zD");

var $bC2fB = parcelRequire("bC2fB");

var $49qY2 = parcelRequire("49qY2");

var $8ojMd = parcelRequire("8ojMd");

var $i89gU = parcelRequire("i89gU");

var $kzAuQ = parcelRequire("kzAuQ");
const $af343ed9c16b8de5$var$mapStateToProps = (state)=>({
        Content: $i89gU.default,
        board: (0, $8ojMd.getBoard)(state),
        sprintInformation: (0, $8ojMd.getSprintInformation)(state),
        deleteInProgress: (0, $8ojMd.isDeleteInProgress)(state),
        onCancel: (0, $8ojMd.getOnCancel)(state)
    });
var $af343ed9c16b8de5$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $az4zD.injectIntlV2), (0, $bC2fB.connect)($af343ed9c16b8de5$var$mapStateToProps, {
    onDelete: (0, $49qY2.deleteBoard)
}))(// @ts-expect-error - Argument of type 'typeof DeleteBoardsModal' is not assignable to parameter of type 'ComponentType<{ intl: IntlShapeV2 | IntlShape | undefined; }>'.
(0, $kzAuQ.default));

});
parcelRegister("az4zD", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $90dc1bd887533804$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");

var $dY8Js = parcelRequire("dY8Js");

var $koVbs = parcelRequire("koVbs");
const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $90dc1bd887533804$var$getDisplayName(Component) {
    if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $koVbs.default)();
        const intlRef = (0, $5uXOq.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
};

});

parcelRegister("i89gU", function(module, exports) {

$parcel$export(module.exports, "default", () => $54da6d40f32d7800$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $8ojMd = parcelRequire("8ojMd");

var $igKvW = parcelRequire("igKvW");
const $54da6d40f32d7800$var$mapStateToProps = (state)=>({
        board: (0, $8ojMd.getBoard)(state),
        sprintInformation: (0, $8ojMd.getSprintInformation)(state)
    });
var // @ts-expect-error - Argument of type 'ComponentType<WithIntlProps<Props>>' is not assignable to parameter of type 'ComponentType<Matching<{ board: Board; sprintInformation: SprintInformation | undefined; } & {}, WithIntlProps<Props>>>'.
$54da6d40f32d7800$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($54da6d40f32d7800$var$mapStateToProps, {})((0, $igKvW.default));

});
parcelRegister("igKvW", function(module, exports) {

$parcel$export(module.exports, "default", () => $45b0115c410cf51a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $dS3PR = parcelRequire("dS3PR");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $az4zD = parcelRequire("az4zD");

var $45XQ3 = parcelRequire("45XQ3");
// eslint-disable-next-line jira/react/no-class-components
class $45b0115c410cf51a$var$Content extends (0, $5uXOq.Component) {
    renderContentForPrivateBoard() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $45XQ3.default).privateBoardMessageIssueTerminologyRefreshM4 : (0, $45XQ3.default).privateBoardMessage)));
    }
    renderLearnMoreLink(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            as: "p"
        }, formatMessage((0, $45XQ3.default).activeSprintsRecommendation, {
            boardName: board.name
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            as: "em"
        }, (0, $4R6GH.fg)('replace-anchor-with-link__jira-cosmos') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
            href: "https://confluence.atlassian.com/jirasoftwarecloud/running-sprints-in-a-scrum-project-764478111.html"
        }, formatMessage((0, $45XQ3.default).link)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: "https://confluence.atlassian.com/jirasoftwarecloud/running-sprints-in-a-scrum-project-764478111.html"
        }, formatMessage((0, $45XQ3.default).link)))));
    }
    renderContentForNoSprints(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $45XQ3.default).noSprintsMessageIssueTerminologyRefreshM4 : (0, $45XQ3.default).noSprintsMessage, {
            boardName: board.name
        })));
    }
    renderContentForSingleSprint(board, sprint) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $45XQ3.default).singleSprintMessageIssueTerminologyRefreshM4 : (0, $45XQ3.default).singleSprintMessage,
            // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            values: {
                sprintName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                    href: sprint.url
                }, sprint.name)
            }
        })), this.renderLearnMoreLink(board));
    }
    renderContentForMultipleSprints(board, sprints) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $45XQ3.default).multipleSprintsMessageIssueTerminologyRefreshM4 : (0, $45XQ3.default).multipleSprintsMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", null, sprints.map(({ name: name, url: url }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
                key: index
            }, (0, $4R6GH.fg)('replace-anchor-with-link__jira-cosmos') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                href: url
            }, name) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                href: url
            }, name)))), this.renderLearnMoreLink(board));
    }
    renderContentForSprintRetrievalError(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $45XQ3.default).retrievalFailedMessageIssueTerminologyRefreshM4 : (0, $45XQ3.default).retrievalFailedMessage, {
            boardName: board.name
        })), this.renderLearnMoreLink(board));
    }
    render() {
        const { board: board, sprintInformation: sprintInformation } = this.props;
        // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
        if (board.isPrivate) return this.renderContentForPrivateBoard();
        // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'SprintInformation'.
        if (sprintInformation.error) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'.
        return this.renderContentForSprintRetrievalError(board);
        // @ts-expect-error - TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        if (sprintInformation.sprints.length === 1) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'. | TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        return this.renderContentForSingleSprint(board, sprintInformation.sprints[0]);
        // @ts-expect-error - TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        if (sprintInformation.sprints.length > 1) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'. | TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        return this.renderContentForMultipleSprints(board, sprintInformation.sprints);
        // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'.
        return this.renderContentForNoSprints(board);
    }
}
var $45b0115c410cf51a$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($45b0115c410cf51a$var$Content);

});
parcelRegister("45XQ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d141b44f5ce2e32$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1d141b44f5ce2e32$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    singleSprintMessage: {
        "id": "directories.boards-v2.delete-modal.content.single-sprint-message",
        "defaultMessage": "This board contains issues from {sprintName}, and that sprint is currently active."
    },
    multipleSprintsMessage: {
        "id": "directories.boards-v2.delete-modal.content.multiple-sprints-message",
        "defaultMessage": "This board contains issues from these active sprints:"
    },
    retrievalFailedMessage: {
        "id": "directories.boards-v2.delete-modal.content.retrieval-failed-message",
        "defaultMessage": "Just a heads up, we're having trouble getting information about active sprints. Issues on {boardName} might be part of one."
    },
    activeSprintsRecommendation: {
        "id": "directories.boards-v2.delete-modal.content.active-sprints-recommendation",
        "defaultMessage": "We recommend completing or deleting active sprints before deleting {boardName}."
    },
    noSprintsMessage: {
        "id": "directories.boards-v2.delete-modal.content.no-sprints-message",
        "defaultMessage": "Deleting {boardName} doesn't affect the issues on the board. And, it won't complete or delete any active sprints."
    },
    privateBoardMessage: {
        "id": "directories.boards-v2.delete-modal.content.private-board-message",
        "defaultMessage": "Deleting this board doesn't affect the issues on the board. And, it won't complete or delete any active sprints."
    },
    link: {
        "id": "directories.boards-v2.delete-modal.content.link",
        "defaultMessage": "Learn more about running sprints."
    },
    singleSprintMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.single-sprint-message-issue-terminology-refresh-m4",
        "defaultMessage": "This board contains work items from {sprintName}, and that sprint is currently active."
    },
    multipleSprintsMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.multiple-sprints-message-issue-terminology-refresh-m4",
        "defaultMessage": "This board contains work items from these active sprints:"
    },
    retrievalFailedMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.retrieval-failed-message-issue-terminology-refresh-m4",
        "defaultMessage": "Just a heads up, we're having trouble getting information about active sprints. Work items on {boardName} might be part of one."
    },
    noSprintsMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.no-sprints-message-issue-terminology-refresh-m4",
        "defaultMessage": "Deleting {boardName} doesn't affect the work items on the board. And, it won't complete or delete any active sprints."
    },
    privateBoardMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.private-board-message-issue-terminology-refresh-m4",
        "defaultMessage": "Deleting this board doesn't affect the work items on the board. And, it won't complete or delete any active sprints."
    }
});

});



parcelRegister("kzAuQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9258234539a783c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $6BtlL = parcelRequire("6BtlL");

var $hZHze = parcelRequire("hZHze");

var $1ppIJ = parcelRequire("1ppIJ");

var $9fuVs = parcelRequire("9fuVs");

var $3HwlS = parcelRequire("3HwlS");

var $koeKL = parcelRequire("koeKL");

var $iJZ8l = parcelRequire("iJZ8l");

var $ehcCJ = parcelRequire("ehcCJ");

var $iT7TT = parcelRequire("iT7TT");
function $c9258234539a783c$var$DeleteBoardsModal(props) {
    const { Content: Content, board: board, sprintInformation: sprintInformation, deleteInProgress: deleteInProgress, onCancel: onCancel, onDelete: onDelete } = props;
    const { intl: { formatMessage: formatMessage } } = props;
    const tenantId = (0, $koeKL.useCloudId)();
    const { deleteBoard: deleteBoard } = (0, $ehcCJ.useDeleteBoard)();
    if (!sprintInformation) return null;
    const onCancelOrNoop = !deleteInProgress ? onCancel : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    const heading = board.isPrivate ? formatMessage((0, $iT7TT.default).deletePrivateBoard) : // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Board'.
    formatMessage((0, $iT7TT.default).deleteBoard, {
        boardName: board.name
    });
    const handleDelete = ()=>{
        const boardARI = (0, $6BtlL.JiraSoftwareBoardAri).create({
            siteId: tenantId,
            boardId: board.id.toString() ?? ''
        }).toString();
        const dataId = (0, $iJZ8l.default)({
            id: boardARI
        }, 'JiraBoard');
        onDelete();
        if (dataId) deleteBoard(dataId);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ppIJ.ModalDialog), {
        messageId: "delete-boards-modal.modal-dialog",
        messageType: "transactional",
        onClose: onCancelOrNoop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), {
        appearance: "danger"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZHze.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "danger",
        onClick: (0, $3HwlS.getWillShowNav4)() ? handleDelete : onDelete,
        isDisabled: deleteInProgress
    }, formatMessage((0, $iT7TT.default).deleteCaption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        onClick: onCancelOrNoop,
        isDisabled: deleteInProgress
    }, formatMessage((0, $iT7TT.default).cancel)))));
}
$c9258234539a783c$var$DeleteBoardsModal.defaultProps = {
    deleteInProgress: false,
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $c9258234539a783c$export$2e2bcd8739ae039 = $c9258234539a783c$var$DeleteBoardsModal;

});
parcelRegister("hZHze", function(module, exports) {

$parcel$export(module.exports, "default", () => $69dc4a27be9f367e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $gvRPW = parcelRequire("gvRPW");
// eslint-disable-next-line jira/react/no-class-components
class $69dc4a27be9f367e$var$ViewTracker extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $69dc4a27be9f367e$var$ViewTrackerWithAnalytics = (0, $994MI.default)({
    componentName: 'view-tracker'
})((0, $cb25w.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $gvRPW.PAGE_EVENT_ACTION)
        }).fire()
})($69dc4a27be9f367e$var$ViewTracker));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$69dc4a27be9f367e$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($69dc4a27be9f367e$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    });

});

parcelRegister("1ppIJ", function(module, exports) {

$parcel$export(module.exports, "ModalDialog", () => $8fbdebf88f199b98$export$1fa217be60c2f188);

var $5uXOq = parcelRequire("5uXOq");

var $7NYq5 = parcelRequire("7NYq5");

var $lu5k0 = parcelRequire("lu5k0");
const $8fbdebf88f199b98$export$1fa217be60c2f188 = ({ shouldReturnFocus: shouldReturnFocus, ...rest })=>{
    const returnFocusTarget = (0, $lu5k0.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    (0, $5uXOq.useEffect)(()=>()=>{
            if (returnFocusTarget?.current) {
                !shouldReturnFocus && returnFocusTarget.current.focus();
                setReturnFocusTo(null);
            }
        }, [
        returnFocusTarget,
        setReturnFocusTo,
        shouldReturnFocus
    ]);
    /**
	 *  when shouldReturnFocus is defined,
	 * 	we won't handle passing focus back to this element
	 *	we will ignore the returnFocusTarget
	 */ const returnFocus = shouldReturnFocus ?? !returnFocusTarget;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        shouldReturnFocus: returnFocus,
        ...rest,
        messageId: rest.messageId ?? 'software.modal-dialog.ui.ak-modal-dialog',
        messageType: rest.messageType ?? 'transactional'
    });
};

});
parcelRegister("lu5k0", function(module, exports) {

$parcel$export(module.exports, "useModalDialogActions", () => $5f429bdcb9dbbc95$export$3cf2e4b6d3541465);
$parcel$export(module.exports, "useReturnFocusTo", () => $5f429bdcb9dbbc95$export$217308a4ece853b2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $49R2H = parcelRequire("49R2H");

var $a3Qjd = parcelRequire("a3Qjd");

var $kIxMH = parcelRequire("kIxMH");
const $5f429bdcb9dbbc95$var$Store = (0, $iXqE5.createStore)({
    name: 'JiraSoftwareModalDialog',
    initialState: $49R2H.initialState,
    actions: $a3Qjd.actions
});
const $5f429bdcb9dbbc95$export$3cf2e4b6d3541465 = (0, $3sQ5x.createActionsHook)($5f429bdcb9dbbc95$var$Store);
const $5f429bdcb9dbbc95$export$217308a4ece853b2 = (0, $3sQ5x.createStateHook)($5f429bdcb9dbbc95$var$Store, {
    selector: (0, $kIxMH.getReturnFocusTo)
});

});
parcelRegister("49R2H", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $1a3a816977643252$export$d4c72bab9d6cc13a);
const $1a3a816977643252$export$d4c72bab9d6cc13a = {
    returnFocusTo: null
};

});

parcelRegister("a3Qjd", function(module, exports) {

$parcel$export(module.exports, "actions", () => $1886bc9c17d47b9b$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $1886bc9c17d47b9b$export$b263d1e638b131c2 = (returnFocusTo)=>({ setState: setState })=>{
        setState({
            returnFocusTo: returnFocusTo
        });
    };
const $1886bc9c17d47b9b$export$e324594224ef24da = {
    setReturnFocusTo: $1886bc9c17d47b9b$export$b263d1e638b131c2
};

});

parcelRegister("kIxMH", function(module, exports) {

$parcel$export(module.exports, "getReturnFocusTo", () => $cd4eb273a1fc9e15$export$d5f8692765ccd209);
const $cd4eb273a1fc9e15$export$d5f8692765ccd209 = (state)=>state.returnFocusTo;

});



parcelRegister("koeKL", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $559e3c14e9652b55$export$9da0f7c65f28ed16);

var $9OXo1 = parcelRequire("9OXo1");
const $559e3c14e9652b55$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("ehcCJ", function(module, exports) {

$parcel$export(module.exports, "useDeleteBoard", () => $f597fd2c84db3563$export$abd16ada93ebfa6a);

var $8Uumt = parcelRequire("8Uumt");
const $f597fd2c84db3563$export$16ded94db5ddbcd7 = ({ environment: environment })=>{
    const deleteBoard = (boardDataId)=>{
        (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
            store.delete(boardDataId);
        });
    };
    return {
        deleteBoard: deleteBoard
    };
};
const $f597fd2c84db3563$export$abd16ada93ebfa6a = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return $f597fd2c84db3563$export$16ded94db5ddbcd7({
        environment: environment
    });
};

});

parcelRegister("iT7TT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7cc28168885a575$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f7cc28168885a575$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    deleteBoard: {
        "id": "directories.boards-v2.delete-modal.delete-board",
        "defaultMessage": "Delete {boardName}"
    },
    deletePrivateBoard: {
        "id": "directories.boards-v2.delete-modal.delete-private-board",
        "defaultMessage": "Delete board"
    },
    cancel: {
        "id": "directories.boards-v2.delete-modal.cancel",
        "defaultMessage": "Cancel"
    },
    deleteCaption: {
        "id": "directories.boards-v2.delete-modal.delete-caption",
        "defaultMessage": "Delete"
    }
});

});




parcelRegister("9g2vH", function(module, exports) {

$parcel$export(module.exports, "isBoardRoute", () => $ccbac8c858ea0da2$export$437d4d6e25681588);
$parcel$export(module.exports, "isBacklogRoute", () => $ccbac8c858ea0da2$export$bcb853db5e3e8054);
const $ccbac8c858ea0da2$export$437d4d6e25681588 = (routeName)=>routeName === 'rapidboard-board' || routeName === 'rapidboard-board-embed' || routeName === 'rapidboard-board-settings' || routeName === 'rapidboard-user-board' || routeName === 'rapidboard-user-board-settings' || routeName === 'servicedesk-boards' || routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-practice-custom-board';
const $ccbac8c858ea0da2$export$bcb853db5e3e8054 = (routeName)=>routeName === 'rapidboard-backlog' || routeName === 'rapidboard-user-backlog' || routeName === 'rapidboard-backlog-embed';

});

const $496585bee7985bb9$export$f06dfcec5ff912e = 'meatballDropdown';
const $496585bee7985bb9$export$7ae7abcf2c19d3e5 = 'removeFromStarred';
const $496585bee7985bb9$export$78fd0bd637fe1684 = 'addToStarred';
const $496585bee7985bb9$export$c540230986f848f6 = 'addPeople';
const $496585bee7985bb9$export$44d67b522cbcce6d = 'projects';
const $496585bee7985bb9$export$3cc9ab700c406a19 = 'projectSettings';
const $496585bee7985bb9$export$dc23a793cf9e9de8 = 'archiveProject';
const $496585bee7985bb9$export$a68d619e7022f2c3 = 'deleteBoard';
const $496585bee7985bb9$export$22748439827110a4 = 'deleteProject';
const $496585bee7985bb9$export$192d610b0b7719f4 = 'boardSettings';
const $496585bee7985bb9$export$a65812b4aab631bb = 'alertSettings';
const $496585bee7985bb9$export$36b5d4d0cb4e437 = 'moveInSidebar';
const $496585bee7985bb9$export$ca6db12118be69a1 = 'schemas';
const $496585bee7985bb9$export$f2eca6cf19c9a973 = 'reports';
const $496585bee7985bb9$export$147264622218a553 = 'dataManager';
const $496585bee7985bb9$export$ee52916f9ebd8000 = 'adapters';
const $496585bee7985bb9$export$83d40997eb7cc5b7 = 'assetsGlobalConfiguration';
const $496585bee7985bb9$export$5c09fa42f8d45ed8 = 'dismissRecommendation';
const $496585bee7985bb9$export$de9ad1ebeca97ec1 = 'newDiscoveryProject';
const $496585bee7985bb9$export$27e4092edca7bb97 = 'jwmSampleProject';
const $496585bee7985bb9$export$ce0bea1467165424 = 'whyAmISeeingThis';
const $496585bee7985bb9$export$98d08638c2a90c44 = 'starredAndRecentProjects';
const $496585bee7985bb9$export$ed36b1ade72db400 = 'starredProjectsOnly';
const $496585bee7985bb9$export$f8a73cc0211412ca = 'mostRecentProjectOnly';
const $496585bee7985bb9$export$3e2efdbdb3eed97e = 'moreProjects';
const $496585bee7985bb9$export$2de7e56f66635690 = 'viewAllProjects';
const $496585bee7985bb9$export$5ff59e4f08b9b299 = 'moveToTop';
const $496585bee7985bb9$export$9964b4a63620a911 = 'moveUp';
const $496585bee7985bb9$export$2692a384035c5ef7 = 'moveDown';
const $496585bee7985bb9$export$a5a45050b97fca24 = 'moveToBottom';

parcelRegister("eDLAW", function(module, exports) {

$parcel$export(module.exports, "useProjectsAnalyticsL3", () => $304a05e3ff22f010$export$619b8904be99ed7c);

var $5uXOq = parcelRequire("5uXOq");






var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $aTtGi = parcelRequire("aTtGi");

const $304a05e3ff22f010$export$619b8904be99ed7c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const commonAttributes = (0, $5uXOq.useMemo)(()=>({
            level: (0, $951a0ed422513987$export$f9db6a58b4aabd18)
        }), []);
    // actions inside meatball menu on projects
    const sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ itemId: itemId, recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
            itemId: itemId,
            parentItemId: projectId,
            parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // meatball menu on boards
    const sendMeatBallDropDownOnBoardsAnalyticsEvent = (0, $5uXOq.useCallback)(({ recent: recent, starred: starred, boardId: boardId, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$b887e88d8d0739f6)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$9bd6c21d500ae611),
            itemId: (0, $496585bee7985bb9$export$f06dfcec5ff912e),
            projectId: projectId,
            parentItemId: boardId,
            parentItemType: (0, $632bd8725b437a12$export$9b8283d5878d2491),
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    const sendChangeViewViewOptionAnalyticsEvent = (0, $5uXOq.useCallback)(({ itemId: itemId })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$17bca95234dea43b),
            itemId: itemId,
            parentItemId: (0, $632bd8725b437a12$export$119dad133da0b4a)
        };
        (0, $8zOmE.fireUIAnalytics)(event, (0, $d59b407ab907bf7b$export$8d155d2412839524), attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent: sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent,
        sendMeatBallDropDownOnBoardsAnalyticsEvent: sendMeatBallDropDownOnBoardsAnalyticsEvent,
        sendChangeViewViewOptionAnalyticsEvent: sendChangeViewViewOptionAnalyticsEvent
    };
};

});
const $ce8062101363feb9$export$6dd9406e478a1fe2 = 'navigationItem';
const $ce8062101363feb9$export$b887e88d8d0739f6 = 'button';
const $ce8062101363feb9$export$64fed82162bd367 = 'dropdownItem';

const $1e554a683893bd46$export$4165a3d0da3bd147 = 'fixedItem';
const $1e554a683893bd46$export$95b0c331af13d819 = 'fixedItemButton';
const $1e554a683893bd46$export$74712b62056d422e = 'fixedItemAction';
const $1e554a683893bd46$export$3ac911b122986477 = 'customItem';
const $1e554a683893bd46$export$9bd6c21d500ae611 = 'customItemButton';
const $1e554a683893bd46$export$5374c2c2d3ece55e = 'customItemAction';
const $1e554a683893bd46$export$56981f28056f258e = 'customItemDropdownAction';
const $1e554a683893bd46$export$17bca95234dea43b = 'fixedItemDropdownAction';

const $632bd8725b437a12$export$9b8283d5878d2491 = 'board';
const $632bd8725b437a12$export$c3d83ca6855fa0d0 = 'app';
const $632bd8725b437a12$export$c1c49903035a02df = 'filter';
const $632bd8725b437a12$export$6deee0e4f2fb784e = 'defaultFilter';
const $632bd8725b437a12$export$4695c1a423ffe431 = 'dashboard';
const $632bd8725b437a12$export$5828682c822c26e7 = 'queue';
const $632bd8725b437a12$export$fe791c4fa892e400 = 'project';
const $632bd8725b437a12$export$c303e491e026ebc6 = 'plan';
const $632bd8725b437a12$export$509e83d3c8d91279 = 'appSubpage';
const $632bd8725b437a12$export$a2e7d1d0a3d169f4 = 'asset';
const $632bd8725b437a12$export$b56168d831461ce2 = 'operation';
const $632bd8725b437a12$export$499a3e77858b7713 = 'translationGroup';
const $632bd8725b437a12$export$bb8a37ab8d9ba82b = 'roadmap';
const $632bd8725b437a12$export$9a778ca616c24a93 = 'projectRecommendation';
const $632bd8725b437a12$export$9cbb0f231a0ab7ea = 'overview';
const $632bd8725b437a12$export$119dad133da0b4a = 'changeView';

const $951a0ed422513987$export$265c523d1a8f25cf = '1';
const $951a0ed422513987$export$fe3b012b0224e4e1 = '2';
const $951a0ed422513987$export$f9db6a58b4aabd18 = '3';
const $951a0ed422513987$export$35ac629b8b943d5a = '4';

parcelRegister("aTtGi", function(module, exports) {

$parcel$export(module.exports, "getSectionByStarredOrRecent", () => $085f7c8df53a9d4d$export$542854f16c0127e7);

var $jecJ3 = parcelRequire("jecJ3");
const $085f7c8df53a9d4d$export$542854f16c0127e7 = ({ starred: starred, recent: recent })=>{
    if (starred) return 0, $jecJ3.SECTION_ITEM_STARRED;
    if (recent) return 0, $jecJ3.SECTION_ITEM_RECENT;
    return '';
};

});
parcelRegister("jecJ3", function(module, exports) {

$parcel$export(module.exports, "SECTION_ITEM_RECENT", () => $06147718dc8a8493$export$ed5276b2863990a4);
$parcel$export(module.exports, "SECTION_ITEM_STARRED", () => $06147718dc8a8493$export$73b9e2753c0313a);
$parcel$export(module.exports, "SECTION_ITEM_YOUR_WORK", () => $06147718dc8a8493$export$a7cdcfc40ede2092);
$parcel$export(module.exports, "SECTION_ITEM_APPS", () => $06147718dc8a8493$export$31b95a89c6fecef5);
$parcel$export(module.exports, "SECTION_ITEM_PLANS", () => $06147718dc8a8493$export$b8d778ecbc8de386);
$parcel$export(module.exports, "SECTION_ITEM_PROJECTS", () => $06147718dc8a8493$export$31111a67d393221);
$parcel$export(module.exports, "SECTION_ITEM_FILTERS", () => $06147718dc8a8493$export$15cffe8e769011f4);
$parcel$export(module.exports, "SECTION_ITEM_DASHBOARDS", () => $06147718dc8a8493$export$573d88e8f19dee53);
$parcel$export(module.exports, "SECTION_ITEM_OPERATIONS", () => $06147718dc8a8493$export$4d8d544db40ea55b);
$parcel$export(module.exports, "SECTION_ITEM_TEAMS", () => $06147718dc8a8493$export$ee4743a74ca6b2b4);
$parcel$export(module.exports, "SECTION_ITEM_ASSETS", () => $06147718dc8a8493$export$935694b184853c59);
$parcel$export(module.exports, "SECTION_ITEM_MORE", () => $06147718dc8a8493$export$b0aa6b1b7598bca0);
$parcel$export(module.exports, "SECTION_ITEM_CUSTOMIZE_SIDEBAR", () => $06147718dc8a8493$export$60a8edfaff189e32);
$parcel$export(module.exports, "SECTION_ITEM_OVERVIEW", () => $06147718dc8a8493$export$c15c267765b7c087);
$parcel$export(module.exports, "SECTION_ITEM_ROADMAPS", () => $06147718dc8a8493$export$1e1623e43a47b758);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_ASSETS", () => $06147718dc8a8493$export$be1ee97c6c39a7a0);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_GOALS", () => $06147718dc8a8493$export$340dfb7166bc7df6);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_CONFLUENCE", () => $06147718dc8a8493$export$68f5347447985678);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_LOOM", () => $06147718dc8a8493$export$1d6ac45ce8d48696);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_TEAMS", () => $06147718dc8a8493$export$73432842fefef2ac);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_PROJECTS", () => $06147718dc8a8493$export$3023d22f41447712);
$parcel$export(module.exports, "GLOBAL_APP_SHORTCUT_OPSGENIE", () => $06147718dc8a8493$export$3cc2573a8cf93a99);
$parcel$export(module.exports, "SECTION_ITEM_MAP", () => $06147718dc8a8493$export$1a73d7f5e6997c6d);

var $jhS4y = parcelRequire("jhS4y");
const $06147718dc8a8493$export$ed5276b2863990a4 = 'recent';
const $06147718dc8a8493$export$73b9e2753c0313a = 'starred';
const $06147718dc8a8493$export$a01a58e0d3083eac = 'yourApps';
const $06147718dc8a8493$export$a7cdcfc40ede2092 = 'yourWork';
const $06147718dc8a8493$export$31b95a89c6fecef5 = 'apps';
const $06147718dc8a8493$export$b8d778ecbc8de386 = 'plans';
const $06147718dc8a8493$export$31111a67d393221 = 'projects';
const $06147718dc8a8493$export$15cffe8e769011f4 = 'filters';
const $06147718dc8a8493$export$573d88e8f19dee53 = 'dashboards';
const $06147718dc8a8493$export$4d8d544db40ea55b = 'operations';
const $06147718dc8a8493$export$ee4743a74ca6b2b4 = 'teams';
const $06147718dc8a8493$export$935694b184853c59 = 'assets';
const $06147718dc8a8493$export$b0aa6b1b7598bca0 = 'more';
const $06147718dc8a8493$export$60a8edfaff189e32 = 'customiseSidebar';
const $06147718dc8a8493$export$c15c267765b7c087 = 'overviews';
const $06147718dc8a8493$export$e52ffdfdd2f167e7 = 'communication';
const $06147718dc8a8493$export$61feca79c347b0c7 = 'goals';
const $06147718dc8a8493$export$1e1623e43a47b758 = 'roadmaps';
const $06147718dc8a8493$export$99cd56faa69bbbb6 = 'customerService';
const $06147718dc8a8493$export$f3045e909a12df36 = 'customerHubs';
const $06147718dc8a8493$export$f780439bdf7412c6 = 'customerServiceAnalytics';
const $06147718dc8a8493$export$be1ee97c6c39a7a0 = 'assetsGlobalAppShortcut';
const $06147718dc8a8493$export$340dfb7166bc7df6 = 'goalsGlobalAppShortcut';
const $06147718dc8a8493$export$68f5347447985678 = 'confluenceGlobalAppShortcut';
const $06147718dc8a8493$export$1d6ac45ce8d48696 = 'loomGlobalAppShortcut';
const $06147718dc8a8493$export$73432842fefef2ac = 'teamsGlobalAppShortcut';
const $06147718dc8a8493$export$3023d22f41447712 = 'projectsGlobalAppShortcut';
const $06147718dc8a8493$export$3cc2573a8cf93a99 = 'opsgenieGlobalAppShortcut';
const $06147718dc8a8493$export$1a73d7f5e6997c6d = {
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).APPS]: $06147718dc8a8493$export$31b95a89c6fecef5,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).ASSETS]: $06147718dc8a8493$export$935694b184853c59,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).DASHBOARDS]: $06147718dc8a8493$export$573d88e8f19dee53,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).FILTERS]: $06147718dc8a8493$export$15cffe8e769011f4,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).OPERATIONS]: $06147718dc8a8493$export$4d8d544db40ea55b,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).PLANS]: $06147718dc8a8493$export$b8d778ecbc8de386,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).PROJECTS]: $06147718dc8a8493$export$31111a67d393221,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).RECENT]: $06147718dc8a8493$export$ed5276b2863990a4,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).STARRED]: $06147718dc8a8493$export$73b9e2753c0313a,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).TEAMS]: $06147718dc8a8493$export$ee4743a74ca6b2b4,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GOALS]: $06147718dc8a8493$export$61feca79c347b0c7,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).OVERVIEWS]: $06147718dc8a8493$export$c15c267765b7c087,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).COMMUNICATION]: $06147718dc8a8493$export$e52ffdfdd2f167e7,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).ROADMAPS]: $06147718dc8a8493$export$1e1623e43a47b758,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE]: $06147718dc8a8493$export$99cd56faa69bbbb6,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_HUBS]: $06147718dc8a8493$export$f3045e909a12df36,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: $06147718dc8a8493$export$f780439bdf7412c6,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_GOALS]: $06147718dc8a8493$export$340dfb7166bc7df6,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_ASSETS]: $06147718dc8a8493$export$be1ee97c6c39a7a0,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_CONFLUENCE]: $06147718dc8a8493$export$68f5347447985678,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_LOOM]: $06147718dc8a8493$export$1d6ac45ce8d48696,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_TEAMS]: $06147718dc8a8493$export$73432842fefef2ac,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_PROJECTS]: $06147718dc8a8493$export$3023d22f41447712,
    [(0, $jhS4y.CONFIGURABLE_MENU_ID).GLOBAL_APP_OPSGENIE]: $06147718dc8a8493$export$3cc2573a8cf93a99
};

});


const $d59b407ab907bf7b$export$8d155d2412839524 = 'projectsNavigationMenuItem';
const $d59b407ab907bf7b$export$13171e509c859bbf = 'projectSettingsNavigationMenuItem';


parcelRegister("36mJD", function(module, exports) {

$parcel$export(module.exports, "useProjectsAnalyticsL4", () => $6db414ac8e29993a$export$cc7d25cb07e1eb10);

var $5uXOq = parcelRequire("5uXOq");






var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $aTtGi = parcelRequire("aTtGi");
const $6db414ac8e29993a$export$cc7d25cb07e1eb10 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const commonAttributes = (0, $5uXOq.useMemo)(()=>({
            level: (0, $951a0ed422513987$export$35ac629b8b943d5a)
        }), []);
    // actions inside meatball menu on boards
    const sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ itemId: itemId, recent: recent, starred: starred, boardId: boardId, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
            itemId: itemId,
            parentItemId: boardId,
            parentItemType: (0, $632bd8725b437a12$export$9b8283d5878d2491),
            projectId: projectId,
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    // actions inside meatball menu on projects
    const sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent = (0, $5uXOq.useCallback)(({ itemId: itemId, recent: recent, starred: starred, projectId: projectId, projectType: projectType })=>{
        const event = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $ce8062101363feb9$export$64fed82162bd367)
        });
        const attributes = {
            ...commonAttributes,
            componentType: (0, $1e554a683893bd46$export$56981f28056f258e),
            itemId: itemId,
            parentItemId: projectId,
            parentItemType: (0, $632bd8725b437a12$export$fe791c4fa892e400),
            projectId: projectId,
            projectType: projectType,
            section: (0, $aTtGi.getSectionByStarredOrRecent)({
                starred: starred,
                recent: recent
            })
        };
        (0, $8zOmE.fireUIAnalytics)(event, 'projectsNavigationMenuItem', attributes);
    }, [
        commonAttributes,
        createAnalyticsEvent
    ]);
    return {
        sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent: sendMeatBallDropDownOnBoardsMenuItemAnalyticsEvent,
        sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent: sendMeatBallDropDownOnProjectsMenuItemAnalyticsEvent
    };
};

});

parcelRegister("d62in", function(module, exports) {

$parcel$export(module.exports, "FavoriteToggleButton", () => $177932fc5526585a$export$b01f3062fe4ad89b);

var $5uXOq = parcelRequire("5uXOq");

var $dm1qi = parcelRequire("dm1qi");

var $dAf5R = parcelRequire("dAf5R");

var $kJpBP = parcelRequire("kJpBP");

var $dS3PR = parcelRequire("dS3PR");

var $4041n = parcelRequire("4041n");

var $koVbs = parcelRequire("koVbs");

var $9eeFp = parcelRequire("9eeFp");

var $9WLyc = parcelRequire("9WLyc");
const $177932fc5526585a$var$UnstarredIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAf5R))), {
    label: "",
    color: "currentColor",
    spacing: "spacious"
});
const $177932fc5526585a$var$StarredIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dm1qi))), {
    label: "",
    color: "var(--ds-icon-accent-yellow, #B38600)",
    spacing: "spacious"
});
const $177932fc5526585a$export$b01f3062fe4ad89b = ({ entityId: entityId, entityTypeName: entityTypeName, defaultIsStarred: defaultIsStarred = false, name: name, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isStarred, setIsStarred] = (0, $5uXOq.useState)(defaultIsStarred);
    const { changeFavoriteMutation: changeFavoriteMutation } = (0, $4041n.useChangeFavorite)();
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        setIsStarred((prevIsStarred)=>!prevIsStarred);
        onClick?.();
    }, [
        onClick
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isStarred !== defaultIsStarred) changeFavoriteMutation({
            id: entityId,
            typename: entityTypeName,
            value: isStarred
        });
    }, [
        entityId,
        entityTypeName,
        isStarred,
        defaultIsStarred,
        changeFavoriteMutation
    ]);
    const handleOnClickWithStopPropagation = (0, $9eeFp.useStopPropagation)(handleOnClick);
    return isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        iconBefore: $177932fc5526585a$var$StarredIcon,
        onClick: handleOnClickWithStopPropagation,
        "aria-label": name ? formatMessage((0, $9WLyc.default).removeFromStarredWithName, {
            name: name
        }) : formatMessage((0, $9WLyc.default).removeFromStarred)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        color: "color.text"
    }, formatMessage((0, $9WLyc.default).removeFromStarred))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        iconBefore: $177932fc5526585a$var$UnstarredIcon,
        onClick: handleOnClickWithStopPropagation,
        "aria-label": name ? formatMessage((0, $9WLyc.default).addToStarredWithName, {
            name: name
        }) : formatMessage((0, $9WLyc.default).addToStarred)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        color: "color.text"
    }, formatMessage((0, $9WLyc.default).addToStarred)));
};

});
parcelRegister("dm1qi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b8e6f0febff8b04$var$_react = $9b8e6f0febff8b04$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9b8e6f0febff8b04$var$_baseNew = $9b8e6f0febff8b04$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9b8e6f0febff8b04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b8e6f0febff8b04$var$StarStarredIcon = (props)=>/*#__PURE__*/ $9b8e6f0febff8b04$var$_react.default.createElement($9b8e6f0febff8b04$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$9b8e6f0febff8b04$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $9b8e6f0febff8b04$var$_default = module.exports.default = $9b8e6f0febff8b04$var$StarStarredIcon;

});

parcelRegister("4041n", function(module, exports) {

$parcel$export(module.exports, "FavoriteChangeContext", () => $e574e5c3227b76f4$export$a5d258b9665ce94b);
$parcel$export(module.exports, "FavoriteChangeProvider", () => $e574e5c3227b76f4$export$b06b5ce59fd5e408);
$parcel$export(module.exports, "FavoriteChangeConsumer", () => $e574e5c3227b76f4$export$f227cdfbb355444a);
$parcel$export(module.exports, "useChangeFavorite", () => $e574e5c3227b76f4$export$cfa169f3278459e8);

var $kZupY = parcelRequire("kZupY");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $jcw0u = parcelRequire("jcw0u");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $iJZ8l = parcelRequire("iJZ8l");

var $j6ttF = parcelRequire("j6ttF");

var $7lK06 = parcelRequire("7lK06");

var $eXQym = parcelRequire("eXQym");

var $5c9oS = parcelRequire("5c9oS");

var $7SIuT = parcelRequire("7SIuT");
const $e574e5c3227b76f4$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $e574e5c3227b76f4$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $e574e5c3227b76f4$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {}
    },
    changeFavorite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))),
    changeFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    updateFavoriteState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $e574e5c3227b76f4$export$a5d258b9665ce94b = /*#__PURE__*/ (0, $5uXOq.createContext)($e574e5c3227b76f4$export$b212ddc707077772);
// supports project types only for now
const $e574e5c3227b76f4$var$useRelayFavoriteUpdate = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const commitUpdate = (0, $5uXOq.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $eXQym.PROJECTS_ITEM_TYPE)) (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $iJZ8l.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favoriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $e574e5c3227b76f4$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $e574e5c3227b76f4$var$useRelayFavoriteUpdate();
    const [items, setItems] = (0, $5uXOq.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {}
    });
    const onChangeStart = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: true
        }));
    }, []);
    const onChangeSuccess = (0, $5uXOq.useCallback)((item, analyticsEvent)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
        if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
        `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
    }, []);
    const onChangeFail = (0, $5uXOq.useCallback)((item, analyticsId, error)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            value: !item.value,
            pending: false
        }));
        if (onShowFlag) onShowFlag((0, $7SIuT.errorFlag)());
        (0, $jcw0u.default)({
            meta: {
                id: analyticsId,
                packageName: 'jiraFavouriteChangeProvider',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onShowFlag
    ]);
    const changeFavorite = (0, $5uXOq.useCallback)(async (item, analyticsEvent)=>{
        const performChange = async ()=>{
            onChangeStart(item);
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $5c9oS.default)(item);
                const typename = (0, $j6ttF.favoriteTypeToTypename)(item.type, item.id);
                if (typename) (0, $7lK06.publishFavorite)(typename, {
                    type: 'REST',
                    entityId: item.id,
                    isFavourite: item.value
                });
                onChangeSuccess(item, analyticsEvent);
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
            }
        };
        return performChange();
    }, [
        commitUpdate,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $kZupY.default));
    const changeFavoriteMutation = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        const dataId = (0, $iJZ8l.default)({
            id: payload.id
        }, payload.typename);
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        const onUpdate = (store, isOptimistic)=>{
            if (!dataId) return;
            (0, $7lK06.publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: isOptimistic
            });
            const record = store.get(dataId);
            if (record) {
                // Some favoritable entities provide an `isFavourite` field, e.g. `JiraFilter`, `JiraProject`.
                if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                // Optimistically update the `favouriteValue` node associated with the updated entity (if present).
                // We only need to do this during optimistic update as the node will be returned in a successful
                // mutation response.
                if (isOptimistic) {
                    const favoriteRecord = record.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(payload.value, 'isFavourite');
                }
            }
        };
        onChangeStart(restItem);
        commitMutation({
            variables: {
                input: {
                    entityId: payload.id,
                    isFavourite: payload.value,
                    beforeEntityId: payload.beforeEntity?.id ?? null
                }
            },
            optimisticUpdater: (store)=>{
                onUpdate(store, true);
            },
            updater: (store, response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
            },
            onCompleted: (response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                else onChangeFail(restItem, 'changeFavoriteMutation');
            },
            onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
        });
    }, [
        commitMutation,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const updateFavoriteState = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const emitChangedFavorite = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        onChangeSuccess(payload, analyticsEvent);
        const typeName = (0, $j6ttF.favoriteTypeToTypename)(payload.type, payload.id);
        if (typeName) (0, $7lK06.publishFavorite)(typeName, {
            type: 'REST',
            entityId: payload.id,
            isFavourite: payload.value
        });
    }, [
        onChangeSuccess
    ]);
    const emitChangedFavoriteMutation = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (payload, store, analyticsEvent)=>{
        const dataId = (0, $iJZ8l.default)({
            id: payload.id
        }, payload.typename) ?? '';
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        onChangeSuccess(restItem, analyticsEvent);
        (0, $7lK06.publishFavorite)(payload.typename, {
            type: 'MUTATION',
            store: store,
            dataId: dataId,
            entityId: payload.id,
            isFavourite: payload.value,
            isOptimistic: false
        });
    }, [
        onChangeSuccess
    ]);
    const providerValue = (0, $5uXOq.useMemo)(()=>({
            items: items,
            changeFavorite: changeFavorite,
            changeFavoriteMutation: changeFavoriteMutation,
            emitChangedFavorite: emitChangedFavorite,
            emitChangedFavoriteMutation: emitChangedFavoriteMutation,
            updateFavoriteState: updateFavoriteState
        }), [
        items,
        changeFavorite,
        changeFavoriteMutation,
        emitChangedFavorite,
        emitChangedFavoriteMutation,
        updateFavoriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$a5d258b9665ce94b.Provider, {
        value: providerValue
    }, children);
};
const $e574e5c3227b76f4$export$f227cdfbb355444a = $e574e5c3227b76f4$export$a5d258b9665ce94b.Consumer;
const $e574e5c3227b76f4$export$61944ffe37754ff2 = (WrappedComponent)=>{
    const WithFavoriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$f227cdfbb355444a, null, (favoriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favoriteChangeContext: FavoriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                favoriteChangeContext: favoriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavoriteChangeConsumer;
};
const $e574e5c3227b76f4$export$cfa169f3278459e8 = ()=>(0, $5uXOq.useContext)($e574e5c3227b76f4$export$a5d258b9665ce94b);

});
parcelRegister("kZupY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64781493fbfe6b0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<581ee8573bf9ee1f32ccc64539d4c7bc>>
 * @relayHash 6de546c6546651e6c4572b78dca9bcd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f
const $d64781493fbfe6b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
            "metadata": {},
            "name": "viewSetFavouriteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d64781493fbfe6b0$var$node.hash = "af74e48c451986374e11a5b801d5009f";
var $d64781493fbfe6b0$export$2e2bcd8739ae039 = $d64781493fbfe6b0$var$node;

});

parcelRegister("dXq4S", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $5c4418bd595ae8cf$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $5c4418bd595ae8cf$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $5c4418bd595ae8cf$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $5c4418bd595ae8cf$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $5c4418bd595ae8cf$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
        const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
    const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("j6ttF", function(module, exports) {

$parcel$export(module.exports, "favoriteTypeToTypename", () => $b9c3378eb0d73712$export$b98f76d96728a853);
$parcel$export(module.exports, "favoriteMutationToRestPayload", () => $b9c3378eb0d73712$export$717886a1047f1287);

var $9AmTW = parcelRequire("9AmTW");

var $6BtlL = parcelRequire("6BtlL");

var $kwbhb = parcelRequire("kwbhb");

var $6oLWS = parcelRequire("6oLWS");

var $aSWXp = parcelRequire("aSWXp");

var $kV9ss = parcelRequire("kV9ss");
function $b9c3378eb0d73712$var$assertUnreachable(_) {
    throw new Error('Unexpected entity type');
}
const $b9c3378eb0d73712$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $b9c3378eb0d73712$export$b98f76d96728a853 = (type, resourceId)=>{
    switch(type){
        case 'projects':
            return 'JiraProject';
        case 'filters':
            return $b9c3378eb0d73712$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
        case 'dashboards':
            return 'JiraDashboard';
        case 'plans':
            return 'JiraPlan';
        case 'boards':
            return 'JiraBoard';
        case 'queues':
            return 'JiraServiceManagementQueue';
        default:
            return undefined;
    }
};
const $b9c3378eb0d73712$var$favoriteAriToId = (typename, ari)=>{
    switch(typename){
        case 'JiraProject':
            return (0, $kV9ss.JiraProjectAri).parse(ari).projectId;
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return (0, $6oLWS.JiraFilterAri).parse(ari).filterId;
        case 'JiraDashboard':
            return (0, $kwbhb.JiraDashboardAri).parse(ari).dashboardId;
        case 'JiraPlan':
            return (0, $aSWXp.JiraPlanAri).parse(ari).planId;
        case 'JiraBoard':
            return (0, $6BtlL.JiraSoftwareBoardAri).parse(ari).boardId;
        case 'JiraServiceManagementQueue':
            return (0, $9AmTW.JiraServicedeskQueueAri).parse(ari).queueId;
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$var$favoriteTypenameToType = (typename)=>{
    switch(typename){
        case 'JiraProject':
            return 'projects';
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return 'filters';
        case 'JiraDashboard':
            return 'dashboards';
        case 'JiraPlan':
            return 'plans';
        case 'JiraBoard':
            return 'boards';
        case 'JiraServiceManagementQueue':
            return 'queues';
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
        id: $b9c3378eb0d73712$var$favoriteAriToId(typename, id),
        type: $b9c3378eb0d73712$var$favoriteTypenameToType(typename),
        value: value,
        beforeEntity: beforeEntity ? {
            id: $b9c3378eb0d73712$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
            type: $b9c3378eb0d73712$var$favoriteTypenameToType(beforeEntity.typename)
        } : undefined
    });

});
parcelRegister("9AmTW", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAri", () => $6fa93d978dc51edc$export$555c8ae00f64ebff);

var $IfwMb = parcelRequire("IfwMb");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira-servicedesk/queue/manifest.ts
var $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $IfwMb.JiraServicedeskQueueAriResourceOwner),
    resourceType: (0, $IfwMb.JiraServicedeskQueueAriResourceType),
    resourceIdSlug: "activation/{activationId}/{queueId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        queueId: /[0-9]+/
    }
};
// src/jira-servicedesk/queue/index.ts
var $6fa93d978dc51edc$export$555c8ae00f64ebff = class _JiraServicedeskQueueAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._queueId = opts.resourceIdSegmentValues.queueId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get queueId() {
        return this._queueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.qualifier,
            platformQualifier: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.resourceOwner,
            resourceType: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.queueId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                queueId: opts.queueId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            queueId: this.queueId
        };
    }
};

});
parcelRegister("IfwMb", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAriResourceOwner", () => $085027a493012871$export$704112eeb385ceab);
$parcel$export(module.exports, "JiraServicedeskQueueAriResourceType", () => $085027a493012871$export$6adb8c07b8bc2c5a);
// src/jira-servicedesk/queue/types.ts
var $085027a493012871$export$704112eeb385ceab = "jira-servicedesk", $085027a493012871$export$6adb8c07b8bc2c5a = "queue";

});


parcelRegister("kwbhb", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAri", () => $eeff8afd95fca51f$export$b7d4016f0f5da5b8);

var $6H9w3 = parcelRequire("6H9w3");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/dashboard/manifest.ts
var $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6H9w3.JiraDashboardAriResourceOwner),
    resourceType: (0, $6H9w3.JiraDashboardAriResourceType),
    resourceIdSlug: "activation/{activationId}/{dashboardId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        dashboardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/dashboard/index.ts
var $eeff8afd95fca51f$export$b7d4016f0f5da5b8 = class _JiraDashboardAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._dashboardId = opts.resourceIdSegmentValues.dashboardId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get dashboardId() {
        return this._dashboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.qualifier,
            platformQualifier: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.resourceOwner,
            resourceType: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.dashboardId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                dashboardId: opts.dashboardId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            dashboardId: this.dashboardId
        };
    }
};

});
parcelRegister("6H9w3", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAriResourceOwner", () => $014208d660d71eea$export$62c1deae25c41d24);
$parcel$export(module.exports, "JiraDashboardAriResourceType", () => $014208d660d71eea$export$e4e3a57a5e435aff);
// src/jira/dashboard/types.ts
var $014208d660d71eea$export$62c1deae25c41d24 = "jira", $014208d660d71eea$export$e4e3a57a5e435aff = "dashboard";

});


parcelRegister("aSWXp", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAri", () => $7eccae3426beb5b5$export$6d2eb3641569f26);

var $fi2nK = parcelRequire("fi2nK");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/plan/manifest.ts
var $7eccae3426beb5b5$var$jiraPlanAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $fi2nK.JiraPlanAriResourceOwner),
    resourceType: (0, $fi2nK.JiraPlanAriResourceType),
    resourceIdSlug: "activation/{activationId}/{planId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        planId: /[0-9]+/
    }
};
// src/jira/plan/index.ts
var $7eccae3426beb5b5$export$6d2eb3641569f26 = class _JiraPlanAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._planId = opts.resourceIdSegmentValues.planId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get planId() {
        return this._planId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.qualifier,
            platformQualifier: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.resourceOwner,
            resourceType: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.planId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                planId: opts.planId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $7eccae3426beb5b5$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $7eccae3426beb5b5$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            planId: this.planId
        };
    }
};

});
parcelRegister("fi2nK", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAriResourceOwner", () => $b21a627cc548ba69$export$bfd26af3c5e1b90d);
$parcel$export(module.exports, "JiraPlanAriResourceType", () => $b21a627cc548ba69$export$d6abe08eb30f433d);
// src/jira/plan/types.ts
var $b21a627cc548ba69$export$bfd26af3c5e1b90d = "jira", $b21a627cc548ba69$export$d6abe08eb30f433d = "plan";

});



parcelRegister("7lK06", function(module, exports) {

$parcel$export(module.exports, "publishFavorite", () => $703ce7b9c2eadfdd$export$229a24253fb568e1);
$parcel$export(module.exports, "useSubscribeToFavorite", () => $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2);

var $5uXOq = parcelRequire("5uXOq");
/**
 * Simple pub-sub implementation to emit and listen to change events for the favorite state of an entity.
 */ class $703ce7b9c2eadfdd$var$FavoritePubSub {
    constructor(){
        this.subscribers = {};
        this.subscribe = (typename, subscriber)=>{
            this.subscribers[typename] = [
                ...this.subscribers[typename] ?? [],
                subscriber
            ];
            return ()=>{
                this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
            };
        };
        this.publish = (typename, payload)=>{
            this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
        };
    }
}
// Singleton to emit and listen to events
const $703ce7b9c2eadfdd$var$favoritePubSub = new $703ce7b9c2eadfdd$var$FavoritePubSub();
const $703ce7b9c2eadfdd$export$229a24253fb568e1 = $703ce7b9c2eadfdd$var$favoritePubSub.publish;
const $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
    (0, $5uXOq.useEffect)(()=>{
        const typenames = Array.isArray(typename) ? typename : [
            typename
        ];
        const unsubscribes = typenames.map((val)=>$703ce7b9c2eadfdd$var$favoritePubSub.subscribe(val, subscriber));
        return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
    }, [
        typename,
        subscriber
    ]);
};

});

parcelRegister("eXQym", function(module, exports) {

$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $6c76a5a290814989$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $6c76a5a290814989$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $6c76a5a290814989$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $6c76a5a290814989$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $6c76a5a290814989$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $6c76a5a290814989$export$9c8cfad65800ddfb);
$parcel$export(module.exports, "VALID_ITEM_TYPENAMES", () => $6c76a5a290814989$export$2d63a9c2e78633c8);
const $6c76a5a290814989$export$aade82542e73ffc8 = 'boards';
const $6c76a5a290814989$export$a448ebfa10cebc74 = 'filters';
const $6c76a5a290814989$export$f8099f229527572c = 'dashboards';
const $6c76a5a290814989$export$8e58083dcbb878d = 'issues';
const $6c76a5a290814989$export$2fd44a6cb58b66cb = 'plans';
const $6c76a5a290814989$export$8e2cd98172988d7e = 'projects';
const $6c76a5a290814989$export$6b0c8e47d2c7f1d9 = 'queues';
const $6c76a5a290814989$export$9c8cfad65800ddfb = [
    $6c76a5a290814989$export$aade82542e73ffc8,
    $6c76a5a290814989$export$f8099f229527572c,
    $6c76a5a290814989$export$a448ebfa10cebc74,
    $6c76a5a290814989$export$8e58083dcbb878d,
    $6c76a5a290814989$export$2fd44a6cb58b66cb,
    $6c76a5a290814989$export$8e2cd98172988d7e,
    $6c76a5a290814989$export$6b0c8e47d2c7f1d9
];
const $6c76a5a290814989$export$2d63a9c2e78633c8 = [
    'JiraProject',
    'JiraCustomFilter',
    'JiraSystemFilter',
    'JiraDashboard',
    'JiraPlan',
    'JiraBoard',
    'JiraServiceManagementQueue'
];

});

parcelRegister("5c9oS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9559749111f2eca$export$2e2bcd8739ae039);

var $7eYK2 = parcelRequire("7eYK2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f9559749111f2eca$export$2e2bcd8739ae039 = async (request)=>(0, $7eYK2.updateFavorite)(request);

});
parcelRegister("7eYK2", function(module, exports) {

$parcel$export(module.exports, "updateFavorite", () => $16085bb5bdb7219b$export$8c2f00130cc945dc);

var $eusud = parcelRequire("eusud");
const $16085bb5bdb7219b$export$8c2f00130cc945dc = async (request)=>{
    if (request.value) return (0, $eusud.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $eusud.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("7SIuT", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $7252fdcfc0e15292$export$b9a7f1ebeaa76953);

var $0YlRJ = parcelRequire("0YlRJ");
const $7252fdcfc0e15292$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $0YlRJ.default)
    });

});
parcelRegister("0YlRJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ad72b3da53041c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $87ad72b3da53041c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});



parcelRegister("9eeFp", function(module, exports) {

$parcel$export(module.exports, "useStopPropagation", () => $9838019739bca90d$export$f7bb512e68bcecd9);

var $5uXOq = parcelRequire("5uXOq");
const $9838019739bca90d$export$f7bb512e68bcecd9 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
onEvent)=>(0, $5uXOq.useCallback)((e, ...args)=>{
        try {
            onEvent?.(e, ...args);
        } finally{
            e?.stopPropagation();
        }
    }, [
        onEvent
    ]);

});

parcelRegister("9WLyc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ff4f0ec548b713f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0ff4f0ec548b713f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addToStarred: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred",
        "defaultMessage": "Add to starred"
    },
    removeFromStarred: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred",
        "defaultMessage": "Remove from starred"
    },
    addToStarredWithName: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.add-to-starred-with-name",
        "defaultMessage": "Add \"{name}\" to starred"
    },
    removeFromStarredWithName: {
        "id": "navigation-apps-sidebar-nav4-common.favorite-toggle-button.remove-from-starred-with-name",
        "defaultMessage": "Remove \"{name}\" from starred"
    }
});

});


parcelRegister("jgJNO", function(module, exports) {

$parcel$export(module.exports, "JiraPopup", () => $93ebfe5964b2617d$export$2da4be1e3f9adef3);

var $5uXOq = parcelRequire("5uXOq");

var $1I7E8 = parcelRequire("1I7E8");

var $10xFf = parcelRequire("10xFf");

var $egZ8z = parcelRequire("egZ8z");
const $93ebfe5964b2617d$export$2da4be1e3f9adef3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egZ8z.ChoreographerPopup), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.Popup), rest);
};

});
parcelRegister("egZ8z", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopup", () => $985c2abc03675c6b$export$8ecc19d18d3df807);

var $1I7E8 = parcelRequire("1I7E8");

var $fG5AJ = parcelRequire("fG5AJ");
const $985c2abc03675c6b$export$8ecc19d18d3df807 = (0, $fG5AJ.withChoreographedToggle)((0, $1I7E8.Popup), 'isOpen', 'content');

});


parcelRegister("hCCtP", function(module, exports) {

$parcel$export(module.exports, "ThemedButtonWrapper", () => $34060b1367424582$export$269674ad0c604d30);
$parcel$export(module.exports, "ThemedButtonNew", () => $34060b1367424582$export$15536ee0f9ee7c0b);
$parcel$export(module.exports, "ThemedIconButton", () => $34060b1367424582$export$d9c2d067feb61447);
$parcel$export(module.exports, "ThemedLinkButton", () => $34060b1367424582$export$b0b5aeed52623827);
$parcel$export(module.exports, "ThemedLinkIconButton", () => $34060b1367424582$export$a1ab08e79d264ec8);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");
var $krXdA = parcelRequire("krXdA");

var $6cG4N = parcelRequire("6cG4N");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $lmBAt = parcelRequire("lmBAt");
const $34060b1367424582$export$269674ad0c604d30 = ({ children: children })=>(0, $lmBAt.getIsSoftwareThemingEnabled)() || (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: [
            $34060b1367424582$var$overrideStyles,
            $34060b1367424582$var$wrapperStyles
        ]
    }, children) : children;
const $34060b1367424582$export$15536ee0f9ee7c0b = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$b0b5aeed52623827 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$a1ab08e79d264ec8 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krXdA.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$var$overrideStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error Object literal may only specify known properties, and ''--ds-background-brand-bold'' does not exist in type 'SafeCSSObject'.ts(2353)
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-disabled': (0, $6cG4N.Tokens).COLOR_BACKGROUND_DISABLED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-subtle-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-subtle-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-icon-subtle': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-icon': (0, $6cG4N.Tokens).COLOR_TEXT,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-link': (0, $6cG4N.Tokens).COLOR_LINK,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-link-pressed': (0, $6cG4N.Tokens).COLOR_LINK_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-disabled': (0, $6cG4N.Tokens).COLOR_TEXT_DISABLED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-inverse': (0, $6cG4N.Tokens).COLOR_TEXT_INVERSE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-selected': (0, $6cG4N.Tokens).COLOR_TEXT_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-subtle': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-border': (0, $6cG4N.Tokens).COLOR_BORDER,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-border-selected': (0, $6cG4N.Tokens).COLOR_BORDER_SELECTED
});
const $34060b1367424582$var$wrapperStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex'
});

});
parcelRegister("lmBAt", function(module, exports) {

$parcel$export(module.exports, "getIsSoftwareThemingEnabled", () => $e55c8e35955d09b8$export$a505f57c5130832f);
$parcel$export(module.exports, "getIsSoftwareThemingM2Enabled", () => $e55c8e35955d09b8$export$4fa2eaefe7d59f41);

var $3HwlS = parcelRequire("3HwlS");

var $6s1PB = parcelRequire("6s1PB");
const $e55c8e35955d09b8$export$a505f57c5130832f = ()=>(0, $3HwlS.getWillShowNav4)() && (0, $6s1PB.expVal)('jira_theming_milestone_1', 'isEnabled', false);
const $e55c8e35955d09b8$export$4fa2eaefe7d59f41 = ()=>$e55c8e35955d09b8$export$a505f57c5130832f() && (0, $6s1PB.expVal)('jira_theming_milestone_2', 'isEnabled', false);

});


parcelRegister("h2QE2", function(module, exports) {

$parcel$export(module.exports, "getBoardSettingsHref", () => $34db911e1caaedb7$export$8d54870ff0bbaead);
$parcel$export(module.exports, "isSelected", () => $34db911e1caaedb7$export$e4d153b3e021fb47);
$parcel$export(module.exports, "getBoardUrl", () => $34db911e1caaedb7$export$505a9f131607d070);
$parcel$export(module.exports, "getJSMBoardUrl", () => $34db911e1caaedb7$export$3416b472014eed93);
$parcel$export(module.exports, "getJSMCalendarUrl", () => $34db911e1caaedb7$export$16e1d659b389d4ae);
$parcel$export(module.exports, "getUserBoardUrl", () => $34db911e1caaedb7$export$45f8e28589795b6f);
$parcel$export(module.exports, "getBoardSettingsUrl", () => $34db911e1caaedb7$export$222cc43a27cdf5b1);

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");
function $34db911e1caaedb7$export$8d54870ff0bbaead(view, location) {
    if (((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && // Delete line when cleaning up blu-7261
    !$34db911e1caaedb7$var$isServiceDeskLocation(location) && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) {
        const basePath = location.pathname.slice(0, location.pathname.lastIndexOf('/'));
        const query = location.search ? location.search : '';
        return `${basePath}/${view}${query}`;
    }
    return `${location.pathname}?config=${view}`;
}
function $34db911e1caaedb7$export$e4d153b3e021fb47(view, queryConfig = '', pathConfig = '') {
    if (((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && // Delete line when cleaning up blu-7261
    (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) return pathConfig === view;
    return queryConfig === view;
}
function $34db911e1caaedb7$export$505a9f131607d070(projectKey, boardId, isCMPBoard) {
    return `/jira/software${isCMPBoard ? '/c' : ''}/projects/${projectKey}/boards/${boardId}`;
}
function $34db911e1caaedb7$export$3416b472014eed93(projectKey, boardId) {
    return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}`;
}
function $34db911e1caaedb7$export$16e1d659b389d4ae(projectKey, boardId) {
    return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}/calendar`;
}
function $34db911e1caaedb7$export$45f8e28589795b6f(accountId, boardId) {
    return `/jira/people/${accountId}/boards/${boardId}`;
}
function $34db911e1caaedb7$export$222cc43a27cdf5b1(ordinaryBoardUrl) {
    return `${ordinaryBoardUrl}/settings`;
}
function $34db911e1caaedb7$var$isServiceDeskLocation(location) {
    return location.pathname.includes('/servicedesk');
}

});

parcelRegister("8j0rr", function(module, exports) {

$parcel$export(module.exports, "useRoute", () => $71494baa766bb420$export$3f79f0b98112cf57);

var $lODMY = parcelRequire("lODMY");
const $71494baa766bb420$export$3f79f0b98112cf57 = (0, $lODMY.createRouterSelector)((state)=>state.route);

});

parcelRegister("LmW5e", function(module, exports) {

$parcel$export(module.exports, "memoWithCondition", () => $9f8bd255d0869198$export$26f85cb52df6fa94);

var $5uXOq = parcelRequire("5uXOq");

var $7XYc4 = parcelRequire("7XYc4");
const $9f8bd255d0869198$export$26f85cb52df6fa94 = (condition, Component, propsAreEqual)=>{
    return (0, $7XYc4.componentWithCondition)(condition, /*#__PURE__*/ (0, $5uXOq.memo)(Component, propsAreEqual), Component);
};

});

parcelRegister("eIGIx", function(module, exports) {

$parcel$export(module.exports, "useMemoWithCondition", () => $8faf574d2943732e$export$ed979cc60a2ab51b);
$parcel$export(module.exports, "useCallbackWithCondition", () => $8faf574d2943732e$export$a51aeb9e9cb9a97e);

var $5uXOq = parcelRequire("5uXOq");
const $8faf574d2943732e$export$ed979cc60a2ab51b = (fn, deps, condition)=>{
    if (condition()) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $5uXOq.useMemo)(fn, deps);
    return fn();
};
const $8faf574d2943732e$export$a51aeb9e9cb9a97e = (fn, deps, condition)=>{
    if (condition()) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $5uXOq.useCallback)(fn, deps);
    return fn;
};

});

parcelRegister("gYrf5", function(module, exports) {

$parcel$export(module.exports, "default", () => $19b00a9a853f2de0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $19b00a9a853f2de0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    boardSettingsLabel: {
        "id": "navigation-board-action-menu.board-settings-label",
        "defaultMessage": "Board settings"
    },
    deleteBoardLabel: {
        "id": "navigation-board-action-menu.delete-board-label",
        "defaultMessage": "Delete board"
    },
    dropdownIconLabel: {
        "id": "navigation-board-action-menu.dropdown-icon-label",
        "defaultMessage": "Board actions"
    }
});

});


parcelRegister("eC0BO", function(module, exports) {

$parcel$export(module.exports, "default", () => $55a9450e4a0fa7fd$export$2e2bcd8739ae039);
/* BaseHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $9IFFl = parcelRequire("9IFFl");

var $1IAbb = parcelRequire("1IAbb");
const $55a9450e4a0fa7fd$var$BaseHeader = ({ title: title, withInlineEdit: withInlineEdit, onConfirm: onConfirm, onValidate: onValidate, id: id, icon: icon, extraComponentsClose: extraComponentsClose, extraComponentsFar: extraComponentsFar, extraComponentsAbove: extraComponentsAbove, isLoading: isLoading = false, testId: testId })=>{
    const WrapperElement = extraComponentsAbove ? (0, $dC5iT.default) : (0, $5uXOq.Fragment);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperElement, null, extraComponentsAbove && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        xcss: $55a9450e4a0fa7fd$var$extraComponentsAboveStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $55a9450e4a0fa7fd$var$breadcrumbSkeletonStyles,
        testId: "navigation-kit-header.extra-component-above-skeleton-1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $55a9450e4a0fa7fd$var$breadcrumbSkeletonStyles,
        testId: "navigation-kit-header.extra-component-above-skeleton-2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $55a9450e4a0fa7fd$var$headerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9IFFl.IconSkeleton), {
        "data-testid": "business-horizontal-nav.common.ui.header.icon-skeleton"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $55a9450e4a0fa7fd$var$titleSkeletonStyles,
        testId: "business-horizontal-nav.common.ui.header.title-skeleton"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperElement, null, extraComponentsAbove && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $55a9450e4a0fa7fd$var$extraComponentsAboveStyles
    }, extraComponentsAbove), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $55a9450e4a0fa7fd$var$headerWrapperStyles,
        testId: testId
    }, icon, withInlineEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1IAbb.EditableTitle), {
        key: id,
        title: title,
        onConfirm: onConfirm,
        onValidate: onValidate
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $55a9450e4a0fa7fd$var$titleContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($55a9450e4a0fa7fd$var$Title, null, title)), extraComponentsClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "start"
    }, extraComponentsClose), extraComponentsFar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "end",
        space: "space.100",
        xcss: $55a9450e4a0fa7fd$var$extraComponentsFarStyles
    }, extraComponentsFar)));
};
var $55a9450e4a0fa7fd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($55a9450e4a0fa7fd$var$BaseHeader);
const $55a9450e4a0fa7fd$var$headerWrapperStyles = (0, $8CUq3.xcss)({
    justifyContent: 'flex-start',
    gap: 'space.075',
    alignItems: 'center',
    minWidth: "var(--ds-space-0, 0px)",
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    height: "var(--ds-space-400, 32px)"
});
const $55a9450e4a0fa7fd$var$titleSkeletonStyles = (0, $8CUq3.xcss)({
    boxSizing: 'border-box',
    height: "var(--ds-space-300, 24px)",
    width: '200px',
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius'
});
const $55a9450e4a0fa7fd$var$breadcrumbSkeletonStyles = (0, $8CUq3.xcss)({
    boxSizing: 'border-box',
    height: "var(--ds-space-300, 24px)",
    width: '90px',
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius'
});
const $55a9450e4a0fa7fd$var$extraComponentsFarStyles = (0, $8CUq3.xcss)({
    alignSelf: 'end',
    marginLeft: 'auto'
});
const $55a9450e4a0fa7fd$var$extraComponentsAboveStyles = (0, $8CUq3.xcss)({
    justifyContent: 'flex-start',
    alignItems: 'center',
    minWidth: "var(--ds-space-0, 0px)",
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $55a9450e4a0fa7fd$var$titleContainerStyles = (0, $8CUq3.xcss)({
    display: 'grid'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $55a9450e4a0fa7fd$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c8lodh _19pkidpf _syazfrbu _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9IFFl", function(module, exports) {

$parcel$export(module.exports, "ProjectIcon", () => $48848e57380c5fd1$export$219c8b8c393795b3);
$parcel$export(module.exports, "IconSkeleton", () => $48848e57380c5fd1$export$777a4901c1708535);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $48848e57380c5fd1$var$iconStylesCompiledStyles = null;
const $48848e57380c5fd1$export$219c8b8c393795b3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _vchhusvi _4t3igktf _1bsbgktf",
            __cmplp.className
        ])
    });
});
const $48848e57380c5fd1$export$777a4901c1708535 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _vchhusvi _4t3igktf _1bsbgktf _bfhkn82g",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1IAbb", function(module, exports) {

$parcel$export(module.exports, "EditableTitle", () => $b24d60a278aa78d2$export$f9d7171ad5f156a8);
/* EditableTitle.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/choreographer/message-id-by-folder-structure */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bopR4 = parcelRequire("bopR4");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $jgJNO = parcelRequire("jgJNO");

var $6BDPK = parcelRequire("6BDPK");

var $3VRT6 = parcelRequire("3VRT6");
const $b24d60a278aa78d2$var$renderReadView = (title, triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h1", {
        ...triggerProps,
        className: (0, $bwpsq.default)([
            "_1e0c11p5 _k48pmoej"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b24d60a278aa78d2$var$ReadView, {
        "data-testid": "horizontal-nav-header.common.ui.read-view"
    }, title));
const $b24d60a278aa78d2$export$f9d7171ad5f156a8 = /*#__PURE__*/ (0, $5uXOq.memo)(({ title: title, onConfirm: onConfirm, onValidate: onValidate })=>{
    const [editValue, setEditValue] = (0, $5uXOq.useState)(title);
    const [error, setError] = (0, $5uXOq.useState)('');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $6BDPK.inlineEditTitleEditViewEntryPoint), {});
    const readViewTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b24d60a278aa78d2$var$inlineEditTitleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bopR4.default), {
        isRequired: true,
        ...(0, $4R6GH.fg)('jfp_a11y_autodev_bus_project_name_edit_label') && {
            editLabel: formatMessage((0, $3VRT6.default).editProjectName)
        },
        defaultValue: editValue,
        onEdit: ()=>setError(''),
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                id: "navigation-kit-header.inline-edit-title-edit-view",
                packageName: "jiraNavigationKitHeaderInlineEditTitleEditView",
                entryPointReferenceSubject: entryPointReferenceSubject,
                runtimeProps: {
                    errorMessage: errorMessage,
                    fieldProps: {
                        ...fieldProps,
                        defaultValue: editValue ?? '',
                        value: undefined
                    }
                },
                fallback: $b24d60a278aa78d2$var$renderReadView(title),
                errorFallback: ()=>$b24d60a278aa78d2$var$renderReadView(title)
            }),
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                ref: readViewTrigger
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
                messageId: "navigation-kit-inline-edit-title.ui.jira-popup",
                messageType: "transactional",
                isOpen: error !== '',
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        xcss: $b24d60a278aa78d2$var$errorPopupStyles
                    }, error),
                placement: "right",
                trigger: (triggerProps)=>$b24d60a278aa78d2$var$renderReadView(editValue, triggerProps)
            })),
        onConfirm: (newValue)=>{
            const value = newValue.trim();
            setEditValue(value);
            onConfirm(value);
        },
        validate: (newValue)=>onValidate(title ?? '', newValue.trim())
    }));
});
const $b24d60a278aa78d2$var$errorPopupStyles = (0, $8CUq3.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    padding: 'space.200'
});
const $b24d60a278aa78d2$var$headingStyles = null;
const $b24d60a278aa78d2$var$inlineEditTitleStyles = (0, $8CUq3.xcss)({
    // Negative margin is added here to make the inline edit field fit in the
    // header without needing to modify the header height
    marginTop: 'space.negative.200',
    marginBottom: 'space.negative.100',
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b24d60a278aa78d2$var$ReadView = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c8lodh _syazfrbu _19pk12x7 _otyr12x7 _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bopR4", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fb3572edb783a8f$export$2e2bcd8739ae039);
/* inline-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $7O4UO = parcelRequire("7O4UO");

var $efXp3 = parcelRequire("efXp3");

var $VSDnB = parcelRequire("VSDnB");

var $3Lty3 = parcelRequire("3Lty3");

var $jldZL = parcelRequire("jldZL");

var $1PDuf = parcelRequire("1PDuf");

var $pZGLJ = parcelRequire("pZGLJ");

var $6LLMl = parcelRequire("6LLMl");
const $9fb3572edb783a8f$var$fieldStyles = null;
const $9fb3572edb783a8f$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $9fb3572edb783a8f$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $5uXOq.useState)(startWithEditViewOpen);
    const timerRef = (0, $5uXOq.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $pZGLJ.default)(isEditing, isEditingState);
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$9fb3572edb783a8f$var$analyticsAttributes
    });
    const onCancelClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]); /**
                                 * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
                                 *  confirms the value, if the focus is not transferred to the action buttons.
                                 *
                                 *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
                                 *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
                                 *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
                                 *  `autoSubmitWhenBlur`.
                                 *
                                 *  There are two paths here the function can be triggered:
                                 *
                                 *  - focus on input first, and then use keyboard to `submit`
                                 *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
                                 */ 
    const onEditViewWrapperBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /**
                                                        * Gets called when focus is transferred to the editView, or action buttons.
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field.
                                                        */ 
    const onEditViewWrapperFocus = (0, $5uXOq.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6LLMl.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $efXp3.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit),
        children: ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $2OMIu.jsx)("form", {
                /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit,
                ref: formRef,
                // This is because due to some default focus being applied to the form element, the inline edit component
                // was being focused automatically and causing scroll issues in issue view
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $VSDnB.fg)('platform_design_system_inline_edit_dont_focus') ? 'dont-default-focus' : undefined,
                children: shouldBeEditing ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: defaultValue,
                    validate: validate,
                    isRequired: isRequired,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                            onBlur: (e)=>{
                                if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                            },
                            onFocus: onEditViewWrapperFocus,
                            className: (0, $bwpsq.default)([
                                "_p12f1osq _kqswh2mm"
                            ]),
                            children: [
                                editView({
                                    ...fieldProps,
                                    errorMessage: error
                                }, editViewRef),
                                !hideActionButtons ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PDuf.default), {
                                    testId: testId,
                                    cancelButtonLabel: cancelButtonLabel,
                                    confirmButtonLabel: confirmButtonLabel,
                                    onMouseDown: ()=>{
                                        /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                                    },
                                    onCancelClick: (e)=>{
                                        reset();
                                        onCancelClick(e);
                                    }
                                }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                                    hidden: true,
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                }, "edit-view" // used for reset to default value
                ) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: "",
                    isRequired: isRequired,
                    children: renderReadView
                }, "read-view" // used for reset to default value
                )
            })
    });
};
const $9fb3572edb783a8f$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9fb3572edb783a8f$var$InnerInlineEdit, {
        ...props
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $9fb3572edb783a8f$export$2e2bcd8739ae039 = $9fb3572edb783a8f$var$InlineEdit;

});
parcelRegister("7O4UO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e20204ce79b642c$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("3joPi");

var $9KnKW = parcelRequire("9KnKW");

var $dRN65 = parcelRequire("dRN65");

var $efXp3 = parcelRequire("efXp3");

var $2x3Cb = parcelRequire("2x3Cb");

var $kxqHl = parcelRequire("kxqHl");

var $6cAn5 = parcelRequire("6cAn5");
const $7e20204ce79b642c$var$fieldWrapperStyles = null;
function $7e20204ce79b642c$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $7e20204ce79b642c$var$isFunction(x) {
    return typeof x === 'function';
}
function $7e20204ce79b642c$var$usePreviousRef(current) {
    const ref = (0, $5uXOq.useRef)(current);
    // will be updated on the next render
    (0, $5uXOq.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, $efXp3.FormContext));
    const isDisabled = (0, $5uXOq.useContext)((0, $efXp3.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $5uXOq.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
    (0, $5uXOq.useEffect)(()=>{
        typeof $6cAn5;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $9KnKW.useId)();
    const fieldId = (0, $5uXOq.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $bwpsq.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2x3Cb.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kxqHl.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Provider, {
                value: fieldId,
                children: props.children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("dRN65", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $706cd4dbd4574fd7$export$3c4232819458a302);

var $5uXOq = parcelRequire("5uXOq");
const $706cd4dbd4574fd7$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});

parcelRegister("efXp3", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $987e2ff089e89967$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $987e2ff089e89967$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $987e2ff089e89967$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lqWDn = parcelRequire("lqWDn");

var $8tHJX = parcelRequire("8tHJX");

var $gZL7V = parcelRequire("gZL7V");
const $987e2ff089e89967$export$c24727297075ec6a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $987e2ff089e89967$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
    const formRef = (0, $5uXOq.useRef)(null);
    const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $5uXOq.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $lqWDn.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(values, name, value);
                    }
                }
            }
        });
        (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $5uXOq.useState)({
        dirty: false,
        submitting: false
    });
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: {
                    onSubmit: handleSubmit,
                    ref: formRef,
                    onKeyDown: handleKeyDown
                },
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change
            }) : children();
            return result === undefined ? null : result;
        }
        return children;
    })();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($987e2ff089e89967$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
}

});
parcelRegister("lqWDn", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $f9a9822f8af64e2a$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f9a9822f8af64e2a$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $f9a9822f8af64e2a$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f9a9822f8af64e2a$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f9a9822f8af64e2a$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f9a9822f8af64e2a$export$f681a8129d2e9d28);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");
//      
var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
var $f9a9822f8af64e2a$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
    string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f9a9822f8af64e2a$var$keysCache = {};
var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
    }
    return $f9a9822f8af64e2a$var$keysCache[key];
};
//      
var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f9a9822f8af64e2a$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
    var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $ddEsc.default)(current, [
                key
            ].map($f9a9822f8af64e2a$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
};
var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
    var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f9a9822f8af64e2a$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                    shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values)); // clone to avoid writing
            if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                    var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $bS32t.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $bS32t.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("8tHJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c2f612c5adb35a$export$2e2bcd8739ae039);

var $lqWDn = parcelRequire("lqWDn");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lqWDn.getIn)(errors, input.name);
    });
};
//      
var $62c2f612c5adb35a$var$noop = function noop() {};
var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;

});

parcelRegister("gZL7V", function(module, exports) {

var $ajB7H = parcelRequire("ajB7H");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c5f6e64373be0bfc$var$set(object, path, value) {
    return object == null ? object : $ajB7H(object, path, value);
}
module.exports = $c5f6e64373be0bfc$var$set;

});


parcelRegister("2x3Cb", function(module, exports) {

$parcel$export(module.exports, "Label", () => $987b76a5b7a0ea9b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $987b76a5b7a0ea9b$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = null;
const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("legend", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("kxqHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d55ac25356e81a33$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d55ac25356e81a33$var$requiredIndicatorStyles = null;
function $d55ac25356e81a33$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $bwpsq.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("1PDuf", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d92d54fb10d87e$export$2e2bcd8739ae039);
/* buttons.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $i28qQ = parcelRequire("i28qQ");

var $ky7e4 = parcelRequire("ky7e4");

var $lLLkM = parcelRequire("lLLkM");
const $55d92d54fb10d87e$var$buttonsContainerStyles = null;
const $55d92d54fb10d87e$var$buttonWrapperBaseStyles = null;
const $55d92d54fb10d87e$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    type: "submit",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ky7e4))), {
                            ...iconProps,
                            LEGACY_size: "small",
                            size: "small"
                        }),
                    onMouseDown: onMouseDown,
                    label: confirmButtonLabel,
                    testId: testId && `${testId}--confirm`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))), {
                            ...iconProps,
                            LEGACY_size: "small",
                            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lLLkM))),
                            size: "small"
                        }),
                    label: cancelButtonLabel,
                    onClick: onCancelClick,
                    onMouseDown: onMouseDown,
                    testId: testId && `${testId}--cancel`
                })
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$55d92d54fb10d87e$export$2e2bcd8739ae039 = $55d92d54fb10d87e$var$Buttons;

});
parcelRegister("ky7e4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4eca488eebd24f6b0c74ed2566069d9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef5c96854bbf6178$var$_react = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ef5c96854bbf6178$var$_checkMark = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ef5c96854bbf6178$var$_check = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("kbxJz")));
function $ef5c96854bbf6178$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef5c96854bbf6178$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ef5c96854bbf6178$var$_react.default.createElement($ef5c96854bbf6178$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ef5c96854bbf6178$var$_check.default
    }, props));
$ef5c96854bbf6178$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ef5c96854bbf6178$var$_default = module.exports.default = $ef5c96854bbf6178$var$CheckMarkIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});

parcelRegister("kbxJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb1f0098e5a023eb$var$_react = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $eb1f0098e5a023eb$var$_checkMark = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $eb1f0098e5a023eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb1f0098e5a023eb$var$CheckIcon = (props)=>/*#__PURE__*/ $eb1f0098e5a023eb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $eb1f0098e5a023eb$var$_checkMark.default
    }));
$eb1f0098e5a023eb$var$CheckIcon.displayName = 'CheckIcon';
var $eb1f0098e5a023eb$var$_default = module.exports.default = $eb1f0098e5a023eb$var$CheckIcon;

});



parcelRegister("pZGLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5aa752dd00081f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $d5aa752dd00081f6$var$usePrevious = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $d5aa752dd00081f6$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $5uXOq.useRef)(null);
    const editViewRef = (0, $5uXOq.useRef)();
    const preventFocusOnEditButtonRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $d5aa752dd00081f6$var$usePrevious(shouldBeEditing);
    (0, $5uXOq.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $d5aa752dd00081f6$export$2e2bcd8739ae039 = $d5aa752dd00081f6$var$useButtonFocusHook;

});

parcelRegister("6LLMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba9adf9a6463766$export$2e2bcd8739ae039);
/* read-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3Lty3 = parcelRequire("3Lty3");
const $1ba9adf9a6463766$var$readViewContainerStyles = null;
const $1ba9adf9a6463766$var$editButtonStyles = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _189e1grb _1dqoglyw _1h6d3acm _1e0c1ule _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _r06hglyw _bfhk18uv _vwz4kb7n _1xp41p6i _14ly1bk5 _1j8znqa1 _mizu1r31 _ra3xglyw _128midpf"
};
const $1ba9adf9a6463766$var$readViewWrapperStyles = null;
const $1ba9adf9a6463766$var$readViewFitContainerWidthStyles = null;
const $1ba9adf9a6463766$var$DRAG_THRESHOLD = 5;
const $1ba9adf9a6463766$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $5uXOq.useRef)(0);
    const startY = (0, $5uXOq.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_vwz4kb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                xcss: $1ba9adf9a6463766$var$editButtonStyles.root,
                onClick: onEditRequested,
                ref: editButtonRef,
                testId: testId && `${testId}--edit-button`,
                "aria-label": editButtonLabel
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
                onClick: onReadViewClick,
                onMouseDown: (e)=>{
                    startX.current = e.clientX;
                    startY.current = e.clientY;
                },
                "data-read-view-fit-container-width": readViewFitContainerWidth,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _v564thzt _1h6d3acm _1dqonqa1 _189e1bk5 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr314ae",
                    readViewFitContainerWidth && "_1bsb1osq"
                ]),
                children: readView()
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1ba9adf9a6463766$export$2e2bcd8739ae039 = $1ba9adf9a6463766$var$ReadView;

});


parcelRegister("47gW9", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $1be876415a945060$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $1be876415a945060$export$5f13515bd3a35325);

var $5uXOq = parcelRequire("5uXOq");

var $iRKpN = parcelRequire("iRKpN");
const $1be876415a945060$export$25d2524a63315ed = (actions, isActive = true, eventMap)=>{
    const removePreviousListeners = (0, $5uXOq.useRef)(null);
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $5uXOq.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        const elementEventMap = eventMap || $1be876415a945060$export$5f13515bd3a35325(actions);
        if (element && isActive) {
            (0, $iRKpN.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: elementEventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $iRKpN.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: elementEventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        actions,
        eventMap,
        isActive
    ]);
};
const $1be876415a945060$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("iRKpN", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $62bae43418420b8a$export$15257a36a7e3f9d6);
function $62bae43418420b8a$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("7XluA", function(module, exports) {

$parcel$export(module.exports, "JiraEntryPointContainer", () => $f4c300dcb0cbacff$export$ee1e46af8fa2fb93);
$parcel$export(module.exports, "NestedEntryPointContainer", () => $f4c300dcb0cbacff$export$54db9e88249c9162);

var $5uXOq = parcelRequire("5uXOq");

var $8Bm0k = parcelRequire("8Bm0k");

var $c5vfY = parcelRequire("c5vfY");
const $f4c300dcb0cbacff$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
    const entryPointReference = (0, $8Bm0k.useEntryPointSubscription)(entryPointReferenceSubject);
    return entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c5vfY.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        placeholderName: "jira-entry-point-container"
    }) : null;
};
const $f4c300dcb0cbacff$export$54db9e88249c9162 = (0, $c5vfY.InternalEntryPointContainer);

});
parcelRegister("8Bm0k", function(module, exports) {

$parcel$export(module.exports, "useEntryPointSubscription", () => $0458c70c3d6616bf$export$3cd1c81e13390c49);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $0458c70c3d6616bf$export$3cd1c81e13390c49 = (subject)=>{
    const [entryPointReference, setEntryPointReference] = (0, $5uXOq.useState)(subject.getValue);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subject.subscribe(setEntryPointReference);
        setEntryPointReference(subject.getValue());
        return unsubscribe;
    }, [
        subject
    ]);
    // We should never provide an entrypoint that has been disposed.
    // This check guards against race conditions that could be triggered by the entrypoint load manager + concurrent rendering.
    if (entryPointReference?.isDisposed && (0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) return null;
    return entryPointReference;
};

});

parcelRegister("c5vfY", function(module, exports) {

$parcel$export(module.exports, "InternalEntryPointContainer", () => $df42b2d5b5551f77$export$5d4dc37edd8a3adb);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $l8ruj = parcelRequire("l8ruj");
const $df42b2d5b5551f77$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>/* eslint-disable-next-line jira/ufo/valid-labels */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: errorAttributes,
        fallback: errorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: placeholderName ?? packageName ?? 'internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    }))));

});
parcelRegister("l8ruj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6056b4460d0127e0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1tcYS = parcelRequire("1tcYS");

var $bFU4G = parcelRequire("bFU4G");

var $8Ec39 = parcelRequire("8Ec39");

var $cEm1b = parcelRequire("cEm1b");

var $4R6GH = parcelRequire("4R6GH");

var $c1haS = parcelRequire("c1haS");

var $aJOZ3 = parcelRequire("aJOZ3");
/** A portion of the page we apply measurement to */ function $6056b4460d0127e0$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $1tcYS.useInteractionContext)();
    const relayProfilerContext = (0, $5uXOq.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $5uXOq.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    this.getInteractionContext().addPreload((0, $bFU4G.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $bFU4G.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $4R6GH.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aJOZ3.default), {
        labelStack: interactionContext.labelStack,
        onRender: (...args)=>interactionContext.onRender(...args)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEm1b.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children)));
}
function $6056b4460d0127e0$export$2e2bcd8739ae039({ name: segmentName, children: children, mode: mode = 'single' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Ec39.default), {
        name: segmentName,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6056b4460d0127e0$var$JiraUFOSegmentWrapper, null, children));
}

});
parcelRegister("aJOZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $37d596e34a54eb72$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $37d596e34a54eb72$var$SsrRenderProfiler = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
var $37d596e34a54eb72$export$2e2bcd8739ae039 = $37d596e34a54eb72$var$SsrRenderProfiler;

});




parcelRegister("4mO32", function(module, exports) {

$parcel$export(module.exports, "useEntryPoint", () => $f8987436643ccece$export$338256068bc140fb);

var $5uXOq = parcelRequire("5uXOq");

var $cutA3 = parcelRequire("cutA3");

var $4R6GH = parcelRequire("4R6GH");

var $c8WsS = parcelRequire("c8WsS");

var $9CqsK = parcelRequire("9CqsK");

var $j1gA4 = parcelRequire("j1gA4");

var $bzXq1 = parcelRequire("bzXq1");
const $f8987436643ccece$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $c8WsS.DEFAULT_OPTIONS))=>{
    // TODO: break tests on instability (stableEntryPointParams!==entryPointParams)
    // prevents {} from from triggering updates
    const stableEntryPointParams = (0, $cutA3.useShallowStableReference)(entryPointParams, (0, $4R6GH.fg)('jfp_magma_entrypoint-stability'));
    const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $j1gA4.useEntryPointLoadManager)(entryPoint, stableEntryPointParams);
    const { startMetric: startMetric, stopMetric: stopMetric } = (0, $bzXq1.useMetricLogger)(metric);
    const entryPointActions = (0, $9CqsK.useEntryPointActions)(loadActions, options, startMetric);
    return (0, $5uXOq.useMemo)(()=>({
            entryPointActions: entryPointActions,
            entryPointReferenceSubject: entryPointReferenceSubject,
            stopMetric: stopMetric
        }), [
        entryPointActions,
        entryPointReferenceSubject,
        stopMetric
    ]);
};

});
parcelRegister("cutA3", function(module, exports) {

$parcel$export(module.exports, "useShallowStableReference", () => $43441358a7826a3c$export$cb8a85c49e39f60);
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions */ 
var $5uXOq = parcelRequire("5uXOq");

var $9pe79 = parcelRequire("9pe79");
const $43441358a7826a3c$var$STABLE_EMPTY_OBJECT = Object.freeze({});
const $43441358a7826a3c$var$STABLE_EMPTY_ARRAY = Object.freeze([]);
const $43441358a7826a3c$export$419c5efa1812e327 = ()=>$43441358a7826a3c$var$STABLE_EMPTY_OBJECT;
const $43441358a7826a3c$export$d81919e21b7bcda0 = ()=>$43441358a7826a3c$var$STABLE_EMPTY_ARRAY;
const $43441358a7826a3c$export$abf22ef229d645f7 = (value)=>Object.keys(value).length === 0 ? $43441358a7826a3c$var$STABLE_EMPTY_OBJECT : value;
const $43441358a7826a3c$export$540f03090e93e8f6 = (value)=>value.length === 0 ? $43441358a7826a3c$var$STABLE_EMPTY_ARRAY : value;
function $43441358a7826a3c$export$cb8a85c49e39f60(props, isEnabled = true) {
    const ref = (0, $5uXOq.useRef)(props);
    if (!isEnabled) return props;
    if (!(0, $9pe79.default)(props, ref.current)) ref.current = props;
    return ref.current;
}

});

parcelRegister("c8WsS", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_OPTIONS", () => $34664e57314d5c26$export$93ca5d3f8675ae4c);
const $34664e57314d5c26$export$93ca5d3f8675ae4c = {
    preloadMaxAge: 2000,
    timeToIntent: 200
};

});

parcelRegister("9CqsK", function(module, exports) {

$parcel$export(module.exports, "useEntryPointActions", () => $7bc2afeacf23b901$export$90681c8c3a56f09a);

var $5uXOq = parcelRequire("5uXOq");

var $jp5kW = parcelRequire("jp5kW");

var $c8WsS = parcelRequire("c8WsS");
const $7bc2afeacf23b901$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
const $7bc2afeacf23b901$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $c8WsS.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $c8WsS.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
    const preloadIntentTimeout = (0, $5uXOq.useRef)();
    const preloadMaxAgeTimeout = (0, $5uXOq.useRef)();
    const preloadLastRequested = (0, $5uXOq.useRef)(0);
    const cancelPreload = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $jp5kW.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) {
            clearTimeout(preloadIntentTimeout.current);
            clearTimeout(preloadMaxAgeTimeout.current);
        }
    }, []);
    const load = (0, $5uXOq.useCallback)(()=>{
        cancelPreload();
        startMetric(preloadLastRequested.current);
        if (preloadLastRequested.current > 0) commitPreload();
        else loadEntryPoint();
        preloadLastRequested.current = 0;
    }, [
        cancelPreload,
        commitPreload,
        loadEntryPoint,
        startMetric
    ]);
    const preload = (0, $5uXOq.useCallback)(()=>{
        if ((0, $jp5kW.default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) return;
        cancelPreload();
        preloadIntentTimeout.current = setTimeout(()=>{
            preloadLastRequested.current = Date.now();
            loadEntryPoint({
                isPreload: true
            });
            preloadMaxAgeTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = 0;
            }, preloadMaxAge);
        }, timeToIntent);
    }, [
        cancelPreload,
        loadEntryPoint,
        preloadMaxAge,
        timeToIntent
    ]);
    (0, $5uXOq.useEffect)(()=>cancelPreload, [
        cancelPreload
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            cancelPreload: cancelPreload,
            load: load,
            preload: preload,
            unload: unloadEntryPoint
        }), [
        cancelPreload,
        load,
        preload,
        unloadEntryPoint
    ]);
};

});

parcelRegister("j1gA4", function(module, exports) {

$parcel$export(module.exports, "useEntryPointLoadManager", () => $d6e83c6db8fa388b$export$bfae318f9651db2f);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $fiv1r = parcelRequire("fiv1r");

var $iU8T2 = parcelRequire("iU8T2");
const $d6e83c6db8fa388b$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
    const environmentProvider = (0, $fiv1r.useJiraRelayEnvironmentProvider)();
    const canLoad = (0, $5uXOq.useRef)(true);
    const timer = (0, $5uXOq.useRef)();
    const removeInactiveLoadsIdleCallback = (0, $5uXOq.useRef)(null);
    const entryPointReferenceQueue = (0, $5uXOq.useRef)([]);
    const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $iU8T2.useEntryPointReferenceSubject)(entryPoint);
    const setNextUpdate = (0, $5uXOq.useCallback)((nextEntryPointReference)=>{
        setEntryPointReference(nextEntryPointReference);
        if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) {
            // Delay clean up to prioritise render cycle in case
            // prior queries get used again
            $d6e83c6db8fa388b$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            removeInactiveLoadsIdleCallback.current = $d6e83c6db8fa388b$var$callWhenIdle(()=>{
                const { current: currentQueue } = entryPointReferenceQueue;
                entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $iU8T2.removeAll)(currentQueue) : (0, $iU8T2.removeInactiveLoads)(currentQueue);
            });
        } else // Delay clean up to prioritise render cycle in case
        // prior queries get used again
        timer.current = setTimeout(()=>{
            const { current: currentQueue } = entryPointReferenceQueue;
            entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $iU8T2.removeAll)(currentQueue) : (0, $iU8T2.removeInactiveLoads)(currentQueue);
        }, 0);
    }, [
        setEntryPointReference
    ]);
    const load = (0, $5uXOq.useCallback)(({ isPreload: isPreload } = {
        isPreload: false
    })=>{
        if (canLoad.current) {
            const reference = (0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
            entryPointReferenceQueue.current.unshift({
                value: reference,
                isPreload: isPreload
            });
            if (isPreload) entryPointReferenceQueue.current = (0, $iU8T2.removeRedundantPreloads)(entryPointReferenceQueue.current);
            else setNextUpdate(reference);
        }
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        setNextUpdate
    ]);
    const unload = (0, $5uXOq.useCallback)(()=>{
        setNextUpdate(null);
    }, [
        setNextUpdate
    ]);
    const commitPreload = (0, $5uXOq.useCallback)(()=>{
        const [firstItem] = entryPointReferenceQueue.current;
        if (firstItem?.isPreload) {
            firstItem.isPreload = false;
            setNextUpdate(firstItem.value);
        }
    }, [
        setNextUpdate
    ]);
    if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        // In concurrent mode especially with strict mode, we would get stuck on canLoad.current = false
        // and it would never be turned back on to true without this
        canLoad.current = true;
        return ()=>{
            $d6e83c6db8fa388b$var$maybeCancelIdleCallback(removeInactiveLoadsIdleCallback.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $iU8T2.removeAll)(entryPointReferenceQueue.current);
        };
    }, []);
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>()=>{
            clearTimeout(timer.current);
            canLoad.current = false;
            entryPointReferenceQueue.current = (0, $iU8T2.removeAll)(entryPointReferenceQueue.current);
        }, []);
    return {
        entryPointReferenceSubject: (0, $5uXOq.useMemo)(()=>({
                getValue: getValue,
                subscribe: subscribe
            }), [
            getValue,
            subscribe
        ]),
        loadEntryPoint: load,
        unloadEntryPoint: unload,
        commitPreload: commitPreload
    };
};
function $d6e83c6db8fa388b$var$callWhenIdle(callback) {
    if ('requestIdleCallback' in window && typeof requestIdleCallback === 'function') return requestIdleCallback(callback);
    if ('requestAnimationFrame' in window && typeof requestAnimationFrame === 'function') return requestAnimationFrame(callback);
    return setTimeout(callback, 0);
}
function $d6e83c6db8fa388b$var$maybeCancelIdleCallback(idleCallbackId) {
    if (idleCallbackId === null) return;
    if ('cancelIdleCallback' in window && typeof cancelIdleCallback === 'function') {
        if (typeof idleCallbackId === 'number') return cancelIdleCallback(idleCallbackId);
        return;
    }
    if ('cancelAnimationFrame' in window && typeof cancelAnimationFrame === 'function') {
        if (typeof idleCallbackId === 'number') return cancelAnimationFrame(idleCallbackId);
        return;
    }
    return clearTimeout(idleCallbackId);
}

});
parcelRegister("iU8T2", function(module, exports) {

$parcel$export(module.exports, "removeRedundantPreloads", () => $011b3d8d407c2901$export$a5b3b808f05fede2);
$parcel$export(module.exports, "removeInactiveLoads", () => $011b3d8d407c2901$export$ae329fe3ea179cb4);
$parcel$export(module.exports, "removeAll", () => $011b3d8d407c2901$export$1cfc7aad5cb1833b);
$parcel$export(module.exports, "useEntryPointReferenceSubject", () => $011b3d8d407c2901$export$322c8997d351da6a);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $4R6GH = parcelRequire("4R6GH");
const $011b3d8d407c2901$export$a5b3b808f05fede2 = (queue)=>{
    const [, ...potentialRedundantItems] = queue;
    potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
        if (isPreload) value.dispose();
    });
    return queue.filter(({ value: value })=>!value.isDisposed);
};
const $011b3d8d407c2901$export$ae329fe3ea179cb4 = (queue)=>{
    if (queue.length === 0) return [];
    const [activeItem, ...redundantItems] = queue;
    redundantItems.forEach(({ value: value })=>{
        value.dispose();
    });
    return [
        activeItem
    ];
};
const $011b3d8d407c2901$export$1cfc7aad5cb1833b = (queue)=>{
    queue.forEach(({ value: value })=>{
        value.dispose();
    });
    return [];
};
const $011b3d8d407c2901$export$322c8997d351da6a = (entryPoint)=>{
    const value = (0, $5uXOq.useRef)(null);
    const subscribers = (0, $5uXOq.useRef)();
    const unsub = (0, $5uXOq.useRef)(null);
    const subscribe = (0, $5uXOq.useCallback)((subscriber)=>{
        if (!subscribers.current) subscribers.current = new Set();
        subscribers.current.add(subscriber);
        return ()=>{
            subscribers.current?.delete(subscriber);
        };
    }, []);
    const setEntryPointReference = (0, $5uXOq.useCallback)((entryPointReference)=>{
        value.current = entryPointReference;
        const notifySubscribers = ()=>{
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                    subscriber(entryPointReference);
                });
            });
        };
        if ($011b3d8d407c2901$var$isReactAsyncJSResourceReference(entryPoint?.root) && (0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) unsub.current = entryPoint?.root?.onComplete?.(()=>{
            notifySubscribers();
        });
        else notifySubscribers();
    }, [
        entryPoint
    ]);
    const getValue = (0, $5uXOq.useCallback)(()=>value.current, []);
    (0, $5uXOq.useEffect)(()=>()=>{
            subscribers.current?.clear();
            if ((0, $4R6GH.fg)('jira-concurrent-entrypoint-fix')) unsub.current?.();
        }, []);
    return {
        getValue: getValue,
        setEntryPointReference: setEntryPointReference,
        subscribe: subscribe
    };
};
/**
 * JSResourceReference's in react-relay don't have an onComplete method,
 * but the version that we actually use from @atlassian/react-async does.
 */ function $011b3d8d407c2901$var$isReactAsyncJSResourceReference(value) {
    return Boolean(value && 'onComplete' in value && 'getModuleName' in value);
}

});


parcelRegister("bzXq1", function(module, exports) {

$parcel$export(module.exports, "useMetricLogger", () => $25198ca8fad8a13c$export$f291ec7cea728e1);

var $5uXOq = parcelRequire("5uXOq");
const $25198ca8fad8a13c$export$f291ec7cea728e1 = (metric)=>{
    const preloadStartTime = (0, $5uXOq.useRef)(0);
    const loadStartTime = (0, $5uXOq.useRef)(0);
    const startMetric = (0, $5uXOq.useCallback)((preloadTime = 0)=>{
        if (metric) {
            metric.start();
            preloadStartTime.current = preloadTime;
            loadStartTime.current = Date.now();
        }
    }, [
        metric
    ]);
    const stopMetric = (0, $5uXOq.useCallback)((additionalCustomData)=>{
        if (metric) {
            const preloadData = preloadStartTime.current > 0 ? {
                preloadToStartDuration: loadStartTime.current - preloadStartTime.current
            } : undefined;
            const metricData = preloadData || additionalCustomData ? {
                customData: {
                    ...preloadData,
                    ...additionalCustomData
                }
            } : undefined;
            metric.stop(metricData);
        }
    }, [
        metric
    ]);
    return {
        startMetric: startMetric,
        stopMetric: stopMetric
    };
};

});


parcelRegister("6BDPK", function(module, exports) {

$parcel$export(module.exports, "inlineEditTitleEditViewEntryPoint", () => $8bd2b33918b67933$export$6adaa323774f44e4);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $8bd2b33918b67933$export$6adaa323774f44e4 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("e9qgv")).then((module)=>module.InlineEditTitleEditViewEntryPoint), {
        moduleId: "55d1ca2e",
        moduleName: "InlineEditTitleEditView",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("e9qgv", function(module, exports) {

let $a4d647b45eba973c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a4d647b45eba973c$var$load("hdJ0Z").then(()=>parcelRequire('2gc8v'));

});


parcelRegister("3VRT6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ab5299bad64cef7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2ab5299bad64cef7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editProjectName: {
        "id": "horizontal.nav.header.editable.title.edit.project.name",
        "defaultMessage": "Project name"
    }
});

});



parcelRegister("krB5y", function(module, exports) {

$parcel$export(module.exports, "ExtraComponentsFar", () => $389ae185a2dab3d2$export$e21e0ccc96f4edd);

var $fXZnT = parcelRequire("fXZnT");

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $8Uumt = parcelRequire("8Uumt");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $g7crU = parcelRequire("g7crU");

var $cZpsT = parcelRequire("cZpsT");

var $6jY6G = parcelRequire("6jY6G");

var $9FHy9 = parcelRequire("9FHy9");

var $Bvv5R = parcelRequire("Bvv5R");

var $2yK1M = parcelRequire("2yK1M");
const $389ae185a2dab3d2$export$e21e0ccc96f4edd = ({ projectFragment: projectFragment })=>{
    const [isFullscreen] = (0, $g7crU.useIsFullscreen)();
    const { name: currentRouteName } = (0, $6jY6G.useCurrentRoute)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const componentsToShow = [];
    const project = (0, $8Uumt.useFragment)((0, $fXZnT.default), projectFragment);
    const hasFullscreenButton = (0, $Bvv5R.SUPPORTED_ROUTES).includes(currentRouteName);
    const canEditProjectConfig = project?.canEditProjectConfig?.canPerform ?? false;
    const shouldShowAutomation = !isAnonymous && project && canEditProjectConfig;
    const isSimplified = project?.projectStyle === (0, $2vSU6.TEAM_MANAGED_PROJECT);
    if (isFullscreen) {
        if (hasFullscreenButton && (0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) {
            componentsToShow.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Bvv5R.HeaderFullscreenButton), {
                key: "fullscreen"
            }));
            return componentsToShow;
        }
        return null;
    }
    let projectShareContext = null;
    if (project) projectShareContext = {
        avatarUrl: project?.avatar?.large ?? '',
        id: Number(project.projectId),
        isSimplified: isSimplified,
        key: project.key,
        name: project.name,
        style: project.projectStyle === (0, $2vSU6.TEAM_MANAGED_PROJECT) ? (0, $2vSU6.ProjectStyle).NEXT_GEN : (0, $2vSU6.ProjectStyle).CLASSIC,
        type: project?.projectType ?? ''
    };
    if (hasFullscreenButton && (0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) componentsToShow.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Bvv5R.HeaderFullscreenButton), {
        key: "fullscreen"
    }));
    if (projectShareContext && !isAnonymous) componentsToShow.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), {
        key: "share-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "ccEcoBoardBacklogShare"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FHy9.ShareButton), {
        data: projectShareContext,
        key: "Share"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        name: "ccEcoBoardBacklogShare"
    })));
    if (shouldShowAutomation) componentsToShow.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2yK1M.AutomationButton), {
        key: "automation"
    }));
    return componentsToShow;
};

});
parcelRegister("fXZnT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3a6919f38a63b3b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6388d6addc3201cb95f9624f0c643121>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a3a6919f38a63b3b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "extraComponentsFar_horizontalNav",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        },
        {
            "alias": "canEditProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        }
    ],
    "type": "JiraProject"
};
$a3a6919f38a63b3b$var$node.hash = "5e95b8ebdc04c45245fa22575f910961";
var $a3a6919f38a63b3b$export$2e2bcd8739ae039 = $a3a6919f38a63b3b$var$node;

});

parcelRegister("cZpsT", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b);

var $9OXo1 = parcelRequire("9OXo1");
const $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});

parcelRegister("9FHy9", function(module, exports) {

$parcel$export(module.exports, "ShareButton", () => $42f92381533036a0$export$e980dfbc2840e8bc);

var $5uXOq = parcelRequire("5uXOq");

var $kOEld = parcelRequire("kOEld");

var $6BtlL = parcelRequire("6BtlL");

var $kV9ss = parcelRequire("kV9ss");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");


var $104Ju = parcelRequire("104Ju");

var $22OQR = parcelRequire("22OQR");

var $5GqLe = parcelRequire("5GqLe");

var $iL8EU = parcelRequire("iL8EU");

var $koeKL = parcelRequire("koeKL");

var $dCm1o = parcelRequire("dCm1o");

var $aocZ2 = parcelRequire("aocZ2");

var $hU5v5 = parcelRequire("hU5v5");
const $42f92381533036a0$var$ShareButtonInner = ({ data: data })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isUserBoard = 'isProjectBoard' in data && data.isProjectBoard === false;
    const integrationType = (0, $5GqLe.integrationTypes).BOARD;
    const objectAri = isUserBoard ? (0, $6BtlL.JiraSoftwareBoardAri).create({
        siteId: cloudId,
        boardId: String(data.id)
    }).toString() : (0, $kV9ss.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(data.id)
    }).toString();
    const [{ onDialogClose: onDialogClose, poSpotlightShareButtonId: poSpotlightShareButtonId }] = (0, $104Ju.useProjectShareButton)();
    const contentType = `${data.name}_${integrationType}`;
    const renderCustomTriggerButton = (0, $5uXOq.useCallback)(({ onClick: onClick, isSelected: isSelected }, { ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
            ...triggerProps,
            onClick: onClick,
            isSelected: isSelected,
            id: "po-spotlight-share-button",
            "data-vc": "share-button",
            appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
                spacing: "spacious",
                label: formatMessage((0, $hU5v5.messages).shareFormTitle),
                color: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('camptasks1101-update-color-tokens-of-icons') ? "var(--ds-icon-subtle, #626F86)" : 'currentColor'
            })
        }), [
        formatMessage
    ]);
    const [isFirstHovered, setIsFirstHovered] = (0, $5uXOq.useState)(false);
    const shareButtonRef = (0, $5uXOq.useRef)(null);
    const handleIconHover = (0, $5uXOq.useCallback)(()=>{
        setIsFirstHovered(true);
        shareButtonRef?.current?.focus();
    }, []);
    // GALILEO-1454 START
    const fireJpdRoadmapOnTimelineSpotlightTrigger = (0, $aocZ2.useFireJpdRoadmapOnTimelineSpotlightTrigger)();
    const handleShareDialogClose = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('grw-880_jpd_roadmap_on_jira_timeline_killswitch')) fireJpdRoadmapOnTimelineSpotlightTrigger();
        onDialogClose?.();
    }, [
        fireJpdRoadmapOnTimelineSpotlightTrigger,
        onDialogClose
    ]);
    // GALILEO-1454 END
    return isFirstHovered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: shareButtonRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iL8EU.ShareButton), {
        integrationType: integrationType,
        productId: "jira",
        subProductId: "jira-software",
        shareTitle: data.name,
        shareContentType: contentType,
        objectAri: objectAri,
        poSpotlightShareButtonId: poSpotlightShareButtonId,
        shareFormTitle: formatMessage((0, $hU5v5.messages).shareFormTitle),
        shareFormHelperMessage: formatMessage((0, $hU5v5.messages).shareHelperMessage),
        renderCustomTriggerButton: renderCustomTriggerButton,
        onDialogClose: handleShareDialogClose
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
            spacing: "spacious",
            label: formatMessage((0, $hU5v5.messages).shareFormTitle),
            color: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('camptasks1101-update-color-tokens-of-icons') ? "var(--ds-icon-subtle, #626F86)" : 'currentColor'
        }),
        appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onMouseEnter: handleIconHover,
        onFocus: handleIconHover
    });
};
const $42f92381533036a0$export$e980dfbc2840e8bc = ({ data: data })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $104Ju.ProjectShareContainer), {
        scope: (0, $8fd3709049e64a0b$export$f86c4708a4b1ecd4)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42f92381533036a0$var$ShareButtonInner, {
        data: data
    }));

});
parcelRegister("kOEld", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eddb3c8fd23121248d7a9663e3c0819a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f277c50ed79b6741$var$_react = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f277c50ed79b6741$var$_share = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("empdx")));

var $f277c50ed79b6741$var$_share2 = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("jZX0t")));
function $f277c50ed79b6741$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShareIcon.
 * This component is ShareIcon, with `UNSAFE_fallbackIcon` set to "ShareIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f277c50ed79b6741$var$ShareIcon = (props)=>/*#__PURE__*/ $f277c50ed79b6741$var$_react.default.createElement($f277c50ed79b6741$var$_share.default, Object.assign({
        LEGACY_fallbackIcon: $f277c50ed79b6741$var$_share2.default
    }, props));
$f277c50ed79b6741$var$ShareIcon.Name = 'ShareIconMigration';
var $f277c50ed79b6741$var$_default = module.exports.default = $f277c50ed79b6741$var$ShareIcon;

});
parcelRegister("jZX0t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8f17c524b03e26b$var$_react = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e8f17c524b03e26b$var$_share = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("empdx")));
function $e8f17c524b03e26b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e8f17c524b03e26b$var$ShareIcon = (props)=>/*#__PURE__*/ $e8f17c524b03e26b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $e8f17c524b03e26b$var$_share.default
    }));
$e8f17c524b03e26b$var$ShareIcon.displayName = 'ShareIcon';
var $e8f17c524b03e26b$var$_default = module.exports.default = $e8f17c524b03e26b$var$ShareIcon;

});


const $8fd3709049e64a0b$export$f86c4708a4b1ecd4 = 'project-share-button-global';

parcelRegister("104Ju", function(module, exports) {

$parcel$export(module.exports, "ProjectShareContainer", () => $a3cc015566e54a3d$export$44b5323fa87de475);
$parcel$export(module.exports, "useProjectShareButton", () => $a3cc015566e54a3d$export$5abd9014d277b249);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $a3cc015566e54a3d$export$44b5323fa87de475 = (0, $gg7kZ.createContainer)();
const $a3cc015566e54a3d$var$initialState = {
    integrationType: '',
    productId: 'jira',
    subProductId: undefined,
    shareLink: undefined,
    shareTitle: '',
    shareContentType: '',
    shareFormTitle: undefined,
    objectAri: '',
    shareIntegrations: undefined,
    copyTooltipText: undefined,
    onDialogClose: undefined,
    onTriggerButtonClick: undefined,
    shareFormHelperMessage: undefined,
    shareFieldsFooter: undefined,
    poSpotlightShareButtonId: undefined
};
const $a3cc015566e54a3d$var$Store = (0, $iXqE5.createStore)({
    containedBy: $a3cc015566e54a3d$export$44b5323fa87de475,
    initialState: $a3cc015566e54a3d$var$initialState,
    actions: {
        setContext: (context)=>({ setState: setState })=>{
                setState({
                    ...$a3cc015566e54a3d$var$initialState,
                    ...context
                });
            },
        clearContext: ()=>({ setState: setState })=>{
                setState($a3cc015566e54a3d$var$initialState);
            }
    },
    name: 'project-share-button'
});
const $a3cc015566e54a3d$export$5abd9014d277b249 = (0, $3sQ5x.createHook)($a3cc015566e54a3d$var$Store);

});

parcelRegister("22OQR", function(module, exports) {

$parcel$export(module.exports, "ThemedButton", () => $87e6157378e1cf19$export$f67fb575035cc7d0);
/* ThemedButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");
const $87e6157378e1cf19$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87e6157378e1cf19$var$CustomButton, {
        ...props,
        as: as,
        ref: ref
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87e6157378e1cf19$var$CustomButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $2rqOp.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5GqLe", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $0970fea694a8095f$export$a7359bcfb0ca8e98);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $0970fea694a8095f$export$f7109619a5e9e0d6);
const $0970fea694a8095f$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments',
    DEPENDENCIES: 'dependencies',
    INCREMENT: 'increment',
    QUEUE: 'queue'
};
const $0970fea694a8095f$export$f7109619a5e9e0d6 = 'growthShareButton';

});

parcelRegister("iL8EU", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $4e5335f44d688bbf$export$5619d05bf511476b);
$parcel$export(module.exports, "ShareButtonAnalyticsWrapperWithGating", () => $4e5335f44d688bbf$export$593c5080db936480);
$parcel$export(module.exports, "ShareButtonSync", () => $4e5335f44d688bbf$export$9b6a83af27cc7de5);
$parcel$export(module.exports, "ShareButton", () => $4e5335f44d688bbf$export$e980dfbc2840e8bc);
$parcel$export(module.exports, "ShareButtonAsync", () => $4e5335f44d688bbf$export$3585ee2128ae4c25);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $kOEld = parcelRequire("kOEld");

var $42CjB = parcelRequire("42CjB");

var $1PVpv = parcelRequire("1PVpv");

var $empdx = parcelRequire("empdx");

var $b71gk = parcelRequire("b71gk");

var $koVbs = parcelRequire("koVbs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $itmJb = parcelRequire("itmJb");

var $4R6GH = parcelRequire("4R6GH");

var $dAfqg = parcelRequire("dAfqg");

var $7XYc4 = parcelRequire("7XYc4");

var $67hPg = parcelRequire("67hPg");
var $kNJSJ = parcelRequire("kNJSJ");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $2vSU6 = parcelRequire("2vSU6");

var $Kpokz = parcelRequire("Kpokz");

var $7aU9g = parcelRequire("7aU9g");

var $8BVfN = parcelRequire("8BVfN");
const $4e5335f44d688bbf$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            color: "var(--ds-icon, #44546F)"
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $Kpokz.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4e5335f44d688bbf$var$ShareButtonBase = (0, $kxZPA.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("7aU9g"))), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
const $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper = ({ children: children })=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const projectKey = data?.projectKey || '';
    const projectType = data?.projectType;
    const projectStyle = data?.simplified ? (0, $2vSU6.TEAM_MANAGED_PROJECT) : (0, $2vSU6.COMPANY_MANAGED_PROJECT);
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isProjectAdmin = data?.isProjectAdmin || false;
    const analyticsData = (0, $5uXOq.useMemo)(()=>{
        const projectContextData = projectKey ? {
            projectType: projectType,
            projectStyle: projectStyle,
            isProjectAdmin: isProjectAdmin
        } : undefined;
        return {
            isAdmin: isAdmin,
            userLocation: userLocation,
            ...projectContextData
        };
    }, [
        projectKey,
        projectType,
        projectStyle,
        isProjectAdmin,
        userLocation,
        isAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PVpv.FabricElementsAnalyticsContext), {
        data: analyticsData
    }, children));
};
const $4e5335f44d688bbf$export$593c5080db936480 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsw-smart-access-extended-analytics-enabled'), $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper, (0, $5uXOq.Fragment));
const $4e5335f44d688bbf$export$9b6a83af27cc7de5 = (props)=>(0, $4R6GH.fg)('migrate_share_dialog_error_boundary') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async.share.button",
        packageName: "share-button",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7aU9g.default), props))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7aU9g.default), props)));
const $4e5335f44d688bbf$export$e980dfbc2840e8bc = (props)=>(0, $4R6GH.fg)('migrate_share_dialog_error_boundary') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async.share.button",
        packageName: "share-button",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButtonBase, props)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButtonBase, props))));
const $4e5335f44d688bbf$export$3585ee2128ae4c25 = (props)=>{
    const { Panel: Panel, trigger: trigger } = (0, $kNJSJ.usePanel)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({}), []);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            ...props
        }), [
        props
    ]);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: props.errorBoundaryId,
        packageName: "jiraShareButton",
        teamName: props.teamName,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67hPg.Trigger), {
        trigger: trigger,
        entryPoint: (0, $8BVfN.shareButtonEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps
    }, ({ ref: ref })=>!isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            testId: "share-button.button",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            appearance: "default",
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($empdx))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                }),
            onClick: ()=>setIsOpen(true)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Panel, null));
};

});
parcelRegister("dAfqg", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $0baaa0dcf730951a$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $0baaa0dcf730951a$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $0baaa0dcf730951a$export$a85f6b5857d2176);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");
const $0baaa0dcf730951a$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $324W5.useResourceWithCustomRouterContext)((0, $dxCvy.projectContextResourceWithCache), customContext);
    const updateCache = (0, $5uXOq.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $0baaa0dcf730951a$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $0baaa0dcf730951a$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return children(projectContext);
};

});

parcelRegister("Kpokz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $026d1258a1c95d57$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $026d1258a1c95d57$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("7aU9g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "JiraShareButton", () => $4e0ba5939e9454a3$export$1b9334aba47cc461);
$parcel$export(module.exports, "default", () => $4e0ba5939e9454a3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $81zXP = parcelRequire("81zXP");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $dXq4S = parcelRequire("dXq4S");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");

var $7CMCs = parcelRequire("7CMCs");

var $dAfqg = parcelRequire("dAfqg");

var $cSD7y = parcelRequire("cSD7y");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lIxty = parcelRequire("lIxty");

var $3Qkpk = parcelRequire("3Qkpk");

var $ly021 = parcelRequire("ly021");

var $3Misg = parcelRequire("3Misg");

var $cvSAQ = parcelRequire("cvSAQ");

var $60DYE = parcelRequire("60DYE");

var $5GqLe = parcelRequire("5GqLe");

var $cRUzY = parcelRequire("cRUzY");

var $fG2b8 = parcelRequire("fG2b8");

var $hn0BX = parcelRequire("hn0BX");

var $1uAgh = parcelRequire("1uAgh");

var $ckpyh = parcelRequire("ckpyh");
// Remove Old suffix and wrap in memo on clean up of vc90_perf_improve_pre_share_on_issue_view
const $4e0ba5939e9454a3$var$JiraShareButtonOld = (props)=>{
    const { triggerButtonStyle: triggerButtonStyle, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose, renderCustomTriggerButton: renderCustomTriggerButton, shareShortcutTriggerCount: shareShortcutTriggerCount = 0, prevShareShortcutTriggerCount: prevShareShortcutTriggerCount = 0, shareFormTitle: shareFormTitle, shareContentType: shareContentType, poSpotlightShareButtonId: poSpotlightShareButtonId, additionalTabs: additionalTabs, shareIntegrations: shareIntegrations, shareFieldsFooter: shareFieldsFooterProp, ...otherProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { cloudId: cloudId, activationId: activationId } = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ loading: loadingOutgoingMailStatus, data: outgoingMailStatus, error: outgoingMailStatusError }, fetchEmailSettings] = (0, $3Qkpk.default)();
    const [{ data: hasUserPermission, error: userPermissionError }, fetchUserPermission] = (0, $ly021.default)();
    const [{ loading: loadingComplainceStatusHipaa, data: complainceStatusHIPAA, error: complainceStatusHipaaError }, fetchHipaaComplianceStatus] = (0, $lIxty.useIsHipaaComplianceService)();
    const isExtendedShareDialogEnabled = (0, $cvSAQ.useIsExtendedShareDialogEnabled)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { data: projectAccessData, fetch: fetchProjectAccessLevels, loading: isProjectAccessLoading, error: fetchProjectAccessError } = (0, $3Misg.useProjectAccessLevel)();
    const { data: userRoles, fetch: fetchUserRoles, loading: userRolesLoading, error: fetchUserRolesError } = (0, $60DYE.useUserRole)(projectContext?.projectKey);
    const [isAutoOpen, setIsAutoOpen] = (0, $5uXOq.useState)(true);
    const shortcutPressed = !!(shareShortcutTriggerCount && shareShortcutTriggerCount > 0 && shareShortcutTriggerCount > prevShareShortcutTriggerCount);
    (0, $5uXOq.useEffect)(()=>{
        if (outgoingMailStatus === undefined && isAutoOpenDialog === true) fetchEmailSettings();
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        outgoingMailStatus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (complainceStatusHIPAA === undefined && isAutoOpenDialog === true) fetchHipaaComplianceStatus();
    // complianceStatusHIPAA is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        complainceStatusHIPAA
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasUserPermission === undefined && isAutoOpenDialog === true) fetchUserPermission();
    // hasUserPermission is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        hasUserPermission
    ]);
    // This is used purely to trigger a re-render.
    // If `isAutoOpenDialog` prop is already true, when the prop is recalculated
    // in the parent if it's `true` again there will be no re-render.
    (0, $5uXOq.useEffect)(()=>{
        if (outgoingMailStatus === undefined && shortcutPressed) fetchEmailSettings();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        outgoingMailStatus,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (complainceStatusHIPAA === undefined && shortcutPressed) fetchHipaaComplianceStatus();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        complainceStatusHIPAA,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasUserPermission === undefined && shortcutPressed) fetchUserPermission();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchUserPermission is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasUserPermission,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    const getCustomFormTitle = (0, $5uXOq.useCallback)(()=>{
        switch(shareContentType){
            case 'summary':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmSummary);
            case 'board':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmBoard);
            case 'list':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmList);
            case 'calendar':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmCalendar);
            case 'timeline':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmTimeline);
            case 'form':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmForm);
            case 'attachments':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmAttachments);
            default:
                return shareFormTitle;
        }
    }, [
        formatMessage,
        shareContentType,
        shareFormTitle
    ]);
    // Error handling fires analytics.
    (0, $5uXOq.useEffect)(()=>{
        if (outgoingMailStatusError) (0, $jcw0u.default)({
            meta: {
                id: 'getEmailSettings',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        outgoingMailStatusError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (complainceStatusHipaaError) (0, $jcw0u.default)({
            meta: {
                id: 'getComplainceStatusHIPAA',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        complainceStatusHipaaError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (userPermissionError) (0, $jcw0u.default)({
            meta: {
                id: 'userPermissionError',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        userPermissionError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (fetchProjectAccessError) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'fetchProjectAccessLevels failed', 'shareButton', {
            source: (0, $5GqLe.ANALYTICS_SOURCE),
            error: fetchProjectAccessError
        });
    }, [
        createAnalyticsEvent,
        fetchProjectAccessError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (fetchUserRolesError) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'fetchUserRoles failed', 'shareButton', {
            source: (0, $5GqLe.ANALYTICS_SOURCE),
            error: fetchUserRolesError
        });
    }, [
        createAnalyticsEvent,
        fetchUserRolesError
    ]);
    // Loading but no errors or data available.
    const shouldAutoOpenPreShareDialog = isAutoOpenDialog === true && (loadingOutgoingMailStatus || loadingComplainceStatusHipaa || complainceStatusHIPAA !== undefined || !!outgoingMailStatusError || !!complainceStatusHipaaError || outgoingMailStatus !== undefined);
    const shareFieldsFooter = isExtendedShareDialogEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jiraShareButtonProjectAccessLevel",
        packageName: "jiraShareButton",
        teamName: "a4t-pandora",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ckpyh.ProjectAccessLevelSelectContainer), {
        currentAccessLevel: projectAccessData?.accessLevel,
        accessLevels: projectAccessData?.availableAccessLevels,
        getProjectAccessLevels: fetchProjectAccessLevels,
        isLoading: isProjectAccessLoading
    })), shareFieldsFooterProp) : shareFieldsFooterProp;
    const isOutgoingMailDisabled = outgoingMailStatus?.isEmailEnabled === false;
    const isDisabledDueToEmail = isOutgoingMailDisabled && (additionalTabs?.length ?? 0) === 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (outgoingMailStatus === undefined || isDisabledDueToEmail || complainceStatusHIPAA?.isCompliant === true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hn0BX.default), {
        triggerButtonStyle: triggerButtonStyle,
        loading: loadingOutgoingMailStatus || loadingComplainceStatusHipaa,
        error: outgoingMailStatusError || complainceStatusHipaaError,
        emailSettings: outgoingMailStatus,
        hipaaStatus: complainceStatusHIPAA,
        renderCustomTriggerButton: renderCustomTriggerButton,
        getEmailSettings: fetchEmailSettings,
        getHipaaStatus: fetchHipaaComplianceStatus,
        getUserPermission: fetchUserPermission,
        ...isExtendedShareDialogEnabled && {
            getUserRoles: fetchUserRoles
        },
        isAutoOpenDialog: shortcutPressed || shouldAutoOpenPreShareDialog,
        onTriggerButtonClick: props.onTriggerButtonClick,
        shareShortcutTriggerCount: shareShortcutTriggerCount,
        poSpotlightShareButtonId: poSpotlightShareButtonId
    }), outgoingMailStatus !== undefined && !isDisabledDueToEmail && complainceStatusHIPAA?.isCompliant === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1uAgh.default), {
        triggerButtonAppearance: "default",
        isAutoOpenDialog: isAutoOpen,
        renderCustomTriggerButton: renderCustomTriggerButton,
        shareContentType: shareContentType,
        shareFormTitle: shareFormTitle || getCustomFormTitle(),
        triggerButtonStyle: triggerButtonStyle,
        isBrowseUsersEnabled: hasUserPermission,
        onDialogClose: ()=>{
            setIsAutoOpen(false);
            if (onDialogClose) onDialogClose();
        },
        orgId: orgId,
        workspaceAri: (0, $4R6GH.fg)('jira_share_button-enable_jira_workspace_ari') ? (0, $81zXP.JiraWorkspaceAri).create({
            activationId: activationId,
            siteId: cloudId
        }).toString() : (0, $dXq4S.createAri)({
            resourceId: activationId,
            cloudId: cloudId,
            resourceType: 'workspace',
            resourceOwner: 'jira'
        }),
        additionalTabs: additionalTabs,
        shareIntegrations: isOutgoingMailDisabled ? [] : shareIntegrations,
        isOutgoingMailDisabled: isOutgoingMailDisabled,
        shareFieldsFooter: isOutgoingMailDisabled ? (0, $cRUzY.default)({
            canUserEnableEmail: outgoingMailStatus?.canUserEnableEmail
        }) : shareFieldsFooter,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
        ...isExtendedShareDialogEnabled && {
            userRoles: userRoles,
            userRolesLoading: userRolesLoading,
            accessLevel: projectAccessData?.accessLevel.value
        },
        ...otherProps
    }));
};
const $4e0ba5939e9454a3$var$MemoedJiraShareButton = /*#__PURE__*/ (0, $5uXOq.memo)($4e0ba5939e9454a3$var$JiraShareButtonOld);
const $4e0ba5939e9454a3$export$1b9334aba47cc461 = (0, $cSD7y.componentWithFG)('vc90_perf_improve_pre_share_on_issue_view', $4e0ba5939e9454a3$var$MemoedJiraShareButton, $4e0ba5939e9454a3$var$JiraShareButtonOld);
var $4e0ba5939e9454a3$export$2e2bcd8739ae039 = $4e0ba5939e9454a3$export$1b9334aba47cc461;

});
parcelRegister("lIxty", function(module, exports) {

$parcel$export(module.exports, "useIsHipaaComplianceService", () => $8b53c07d7b6353b9$export$dad138577ca71048);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");
const $8b53c07d7b6353b9$var$getHipaaComplianceStatus = async ()=>(0, $eusud.performGetRequest)('/rest/internal/latest/compliance/status/HIPAA');
const $8b53c07d7b6353b9$export$dad138577ca71048 = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchHipaaComplianceStatus } = (0, $ld2hZ.useService)($8b53c07d7b6353b9$var$getHipaaComplianceStatus);
    const transformedData = (0, $5uXOq.useMemo)(()=>data ? {
            isCompliant: data.isCompliant
        } : undefined, [
        data
    ]);
    return [
        {
            loading: loading,
            error: error,
            data: transformedData
        },
        fetchHipaaComplianceStatus
    ];
};

});

parcelRegister("3Qkpk", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b79009b50ad613d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");
const $8b79009b50ad613d$var$getEmailSettings = async ()=>(0, $eusud.performGetRequest)('/rest/jira-mail-plugin/1.0/outgoingMail/config');
const $8b79009b50ad613d$export$5f20fafd52370aae = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchEmailSettings } = (0, $ld2hZ.useService)($8b79009b50ad613d$var$getEmailSettings);
    const transformedData = (0, $5uXOq.useMemo)(()=>data ? {
            isEmailEnabled: data.enabled,
            canUserEnableEmail: data.canEditConfig
        } : undefined, [
        data
    ]);
    return [
        {
            loading: loading,
            error: error,
            data: transformedData
        },
        fetchEmailSettings
    ];
};
var $8b79009b50ad613d$export$2e2bcd8739ae039 = $8b79009b50ad613d$export$5f20fafd52370aae;

});

parcelRegister("ly021", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3c761b58cac213d$export$2e2bcd8739ae039);

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");
const $b3c761b58cac213d$var$getUserPermission = async ()=>(0, $eusud.performGetRequest)('/rest/api/3/mypermissions?permissions=USER_PICKER');
const $b3c761b58cac213d$export$ce7974a7294500be = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchUserPermission } = (0, $ld2hZ.useService)($b3c761b58cac213d$var$getUserPermission);
    return [
        {
            loading: loading,
            error: error,
            data: data?.permissions?.USER_PICKER?.havePermission
        },
        fetchUserPermission
    ];
};
var $b3c761b58cac213d$export$2e2bcd8739ae039 = $b3c761b58cac213d$export$ce7974a7294500be;

});

parcelRegister("3Misg", function(module, exports) {

$parcel$export(module.exports, "useProjectAccessLevel", () => $da4bace31cc40a76$export$e262f937bd216199);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");

var $dAfqg = parcelRequire("dAfqg");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5GqLe = parcelRequire("5GqLe");
const $da4bace31cc40a76$var$getProjectAccessLevel = async (projectId)=>{
    if (!projectId) throw new Error('Project ID is missing while fetching project access level.');
    return (0, $eusud.performGetRequest)(`/rest/internal/simplified/1.0/accesslevel/project/${projectId}`);
};
const $da4bace31cc40a76$var$getProjectAccessLevels = async ()=>{
    return (0, $eusud.performGetRequest)('/rest/internal/simplified/1.0/accesslevel?projectType=software');
};
const $da4bace31cc40a76$var$updateProjectAccessLevel = async ({ projectId: projectId, projectKey: projectKey, accessLevel: accessLevel })=>{
    if (!projectId || !projectKey) throw new Error('Project ID and/or Key is missing while updating project access level.');
    return (0, $eusud.performPutRequest)(`/rest/internal/simplified/1.0/projects/${projectId}/summary`, {
        body: JSON.stringify({
            accessLevel: accessLevel,
            key: projectKey
        })
    });
};
const $da4bace31cc40a76$export$e262f937bd216199 = ()=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { projectId: projectId, projectKey: projectKey } = (0, $5uXOq.useMemo)(()=>({
            projectId: projectContext?.projectId,
            projectKey: projectContext?.projectKey
        }), [
        projectContext
    ]);
    const fetchProjectAccessLevels = (0, $5uXOq.useCallback)(()=>Promise.all([
            $da4bace31cc40a76$var$getProjectAccessLevel(projectId),
            $da4bace31cc40a76$var$getProjectAccessLevels()
        ]).then(([accessLevel, availableAccessLevels])=>({
                accessLevel: accessLevel,
                availableAccessLevels: availableAccessLevels
            })), [
        projectId
    ]);
    const sendProjectAccessLevelUpdate = (0, $5uXOq.useCallback)(({ accessLevel: accessLevel })=>$da4bace31cc40a76$var$updateProjectAccessLevel({
            projectId: projectId,
            projectKey: projectKey,
            accessLevel: accessLevel
        }), [
        projectId,
        projectKey
    ]);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $ld2hZ.useService)(fetchProjectAccessLevels);
    const { loading: isUpdating, error: updateError, fetch: update } = (0, $ld2hZ.useService)(sendProjectAccessLevelUpdate);
    const fetchWithAnalytics = (0, $5uXOq.useCallback)(async ()=>{
        const result = await fetch();
        if (result) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchProjectAccessLevels succeeded', 'shareButton', {
            source: (0, $5GqLe.ANALYTICS_SOURCE)
        });
        return result;
    }, [
        fetch,
        createAnalyticsEvent
    ]);
    return {
        loading: loading || isUpdating,
        error: error,
        updateError: updateError,
        data: data,
        fetch: fetchWithAnalytics,
        update: update
    };
};

});

parcelRegister("cvSAQ", function(module, exports) {

$parcel$export(module.exports, "useIsExtendedShareDialogEnabled", () => $8c2efaed9c82d207$export$1000ebfdeca10b3c);

var $6s1PB = parcelRequire("6s1PB");

var $3HwlS = parcelRequire("3HwlS");

var $lODMY = parcelRequire("lODMY");

var $itmJb = parcelRequire("itmJb");

var $dAfqg = parcelRequire("dAfqg");
const $8c2efaed9c82d207$export$1000ebfdeca10b3c = ()=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const isProjectAdmin = !!projectContextData?.isProjectAdmin;
    const isTMP = (0, $dAfqg.useIsSimplifiedProject)();
    const projectType = projectContextData?.projectType;
    const isBusinessOrSoftwareProject = projectType === 'business' || projectType === 'software';
    const shouldShowInNav3View = (0, $lODMY.useIsActiveRoute)(new Set([
        'software-timeline',
        'software-boards',
        'software-backlog',
        'issue'
    ]));
    return ((0, $3HwlS.getWillShowNav4)() || shouldShowInNav3View) && isBusinessOrSoftwareProject && isTMP && (isAdmin || isProjectAdmin) && (0, $6s1PB.expVal)('tmp_secure_project_access_share_dialog', 'isEnabled', false);
};

});

parcelRegister("60DYE", function(module, exports) {

$parcel$export(module.exports, "useUserRole", () => $13fb2e5bc2538e40$export$77101ee802ae0455);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5GqLe = parcelRequire("5GqLe");
const $13fb2e5bc2538e40$var$getUserRolesService = (projectKey)=>{
    if (!projectKey) throw new Error('Project Key is required to fetch user roles');
    return (0, $eusud.performGetRequest)(`/rest/api/3/project/${projectKey}/roledetails?excludeConnectAddons=true`);
};
const $13fb2e5bc2538e40$var$addUserRoleService = ({ projectKey: projectKey, roleId: roleId, groups: groups, users: users })=>{
    if (!projectKey) throw new Error('Project key is required to add user role');
    return (0, $eusud.performPostRequest)(`/rest/projectconfig/latest/roles/${projectKey}/${roleId}`, {
        body: JSON.stringify({
            groups: groups,
            users: users
        })
    });
};
const $13fb2e5bc2538e40$export$77101ee802ae0455 = (projectKey)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: data, fetch: fetch, loading: isFetching, error: fetchError } = (0, $ld2hZ.useService)(()=>$13fb2e5bc2538e40$var$getUserRolesService(projectKey));
    const { loading: isAdding, error: addError, fetch: addUserRoleInternal } = (0, $ld2hZ.useService)($13fb2e5bc2538e40$var$addUserRoleService);
    const add = (0, $5uXOq.useCallback)((roleId, { users: users, groups: groups })=>addUserRoleInternal({
            projectKey: projectKey,
            roleId: roleId,
            users: users,
            groups: groups
        }), [
        addUserRoleInternal,
        projectKey
    ]);
    const fetchWithAnalytics = (0, $5uXOq.useCallback)(async ()=>{
        const result = await fetch();
        if (result) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchUserRoles succeeded', 'shareButton', {
            source: (0, $5GqLe.ANALYTICS_SOURCE)
        });
        return result;
    }, [
        createAnalyticsEvent,
        fetch
    ]);
    return {
        fetch: fetchWithAnalytics,
        add: add,
        data: data,
        loading: isFetching || isAdding,
        error: fetchError,
        updateError: addError
    };
};

});

parcelRegister("cRUzY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2333dcf1c6e1c11b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $cGLqe = parcelRequire("cGLqe");
const $2333dcf1c6e1c11b$var$OutgoingMailWarningMessage = ({ canUserEnableEmail: canUserEnableEmail })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return canUserEnableEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
            href: "/secure/admin/OutgoingMailServers.jspa"
        }, formatMessage((0, $cGLqe.default).outgoingMailSettingsLink)),
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $cGLqe.default).disabledWarningMessage))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $cGLqe.default).disabledWarningMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $cGLqe.default).nonAdminWarningMessage)));
};
var $2333dcf1c6e1c11b$export$2e2bcd8739ae039 = $2333dcf1c6e1c11b$var$OutgoingMailWarningMessage;

});
parcelRegister("92Z2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97355a0cc6aeb06$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $3HeRx = parcelRequire("3HeRx");
const $a97355a0cc6aeb06$var$sectionMessageStyles = {
    container: "_2rkoglpi _1nmz1hna",
    bleed: "_1mou1i6y _1e0c1txw",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $a97355a0cc6aeb06$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $3HeRx.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "section",
        backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.container,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.bleed,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    children: [
                        !!title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.content,
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: (0, $VSDnB.fg)('platform_ads_explicit_font_styles') && $a97355a0cc6aeb06$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                })
            ]
        })
    });
});
const $a97355a0cc6aeb06$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;

});
parcelRegister("3HeRx", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $dg0Fl = parcelRequire("dg0Fl");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");

const $d1d7dced94bb00f5$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jWct))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
    }
};
function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $d1d7dced94bb00f5$var$appearanceIconSchema[appearance] || $d1d7dced94bb00f5$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';



parcelRegister("ctz0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e844da07d79ea04$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $5McnS = parcelRequire("5McnS");
var $MHKc7 = parcelRequire("MHKc7");
var $3Lty3 = parcelRequire("3Lty3");
const $2e844da07d79ea04$var$styles = {
    common: "_11c82smr _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
    anchor: "_1053w7te _9oik18uv _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
    pressable: "_bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $2e844da07d79ea04$var$SectionMessageAction = /*#__PURE__*/ (0, $5uXOq.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    if (!linkComponent && (0, $VSDnB.fg)('platform_section_message_action_migration')) {
        if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5McnS.default), {
            testId: testId,
            onClick: onClick,
            href: href,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.anchor),
            children: children
        });
        if (onClick) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.pressable),
            children: children
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            as: "span",
            testId: testId,
            children: children
        });
    }
    return onClick || href ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
});
var $2e844da07d79ea04$export$2e2bcd8739ae039 = $2e844da07d79ea04$var$SectionMessageAction;

});

parcelRegister("cGLqe", function(module, exports) {

$parcel$export(module.exports, "default", () => $5118dd1ca51be8cb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5118dd1ca51be8cb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    disabledWarningMessage: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message",
        "defaultMessage": "Outgoing mail is not configured."
    },
    adminEnableOutgoingMail: {
        "id": "share-button.pre-share-view.warning-content.admin-enable-outgoing-mail",
        "defaultMessage": "You can configure it here"
    },
    outgoingMail: {
        "id": "share-button.pre-share-view.warning-content.outgoing-mail",
        "defaultMessage": "Outgoing Mail"
    },
    nonAdminWarningMessage: {
        "id": "share-button.pre-share-view.warning-content.non-admin-warning-message",
        "defaultMessage": "Please contact your Jira administrator to enable sharing."
    },
    disabledWarningMessageIfHipaa: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message-if-hipaa",
        "defaultMessage": "You cannot share issue as your organization has signed up for HIPAA compliance"
    },
    disabledWarningMessageIfHipaaIssueTermRefresh: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message-if-hipaa-issue-term-refresh",
        "defaultMessage": "You can't share work item as your organization has signed up for HIPAA compliance"
    },
    outgoingMailSettingsLink: {
        "id": "share-button.pre-share-view.warning-content.enable-outgoing-mail-link",
        "defaultMessage": "Set up email sharing"
    }
});

});


parcelRegister("fG2b8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a915a4d87397f963$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a915a4d87397f963$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    shareMainTabTextJwmSummary: {
        "id": "share-button.share-main-tab-text-jwm-summary",
        "defaultMessage": "Share summary"
    },
    shareMainTabTextJwmBoard: {
        "id": "share-button.share-main-tab-text-jwm-board",
        "defaultMessage": "Share board"
    },
    shareMainTabTextJwmList: {
        "id": "share-button.share-main-tab-text-jwm-list",
        "defaultMessage": "Share list"
    },
    shareMainTabTextJwmCalendar: {
        "id": "share-button.share-main-tab-text-jwm-calendar",
        "defaultMessage": "Share calendar"
    },
    shareMainTabTextJwmTimeline: {
        "id": "share-button.share-main-tab-text-jwm-timeline",
        "defaultMessage": "Share timeline"
    },
    shareMainTabTextJwmForm: {
        "id": "share-button.share-main-tab-text-jwm-form",
        "defaultMessage": "Share form"
    },
    shareMainTabTextJwmAttachments: {
        "id": "share-button.share-main-tab-text-jwm-attachments",
        "defaultMessage": "Share attachments"
    }
});

});

parcelRegister("hn0BX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6286a7fcdb67d585$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $fVnbM = parcelRequire("fVnbM");

var $empdx = parcelRequire("empdx");

var $kOEld = parcelRequire("kOEld");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $jgJNO = parcelRequire("jgJNO");

var $9fuVs = parcelRequire("9fuVs");

var $gwIPs = parcelRequire("gwIPs");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $l8ruj = parcelRequire("l8ruj");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $cSD7y = parcelRequire("cSD7y");

var $ggimd = parcelRequire("ggimd");

var $6P8F6 = parcelRequire("6P8F6");
const $6286a7fcdb67d585$var$ConditionalTooltip = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $ggimd.default).shareTriggerButtonText),
        ...(0, $4R6GH.fg)('jfp_a11y_team_button_has_verbose_accessible_name') && {
            isScreenReaderAnnouncementDisabled: true
        },
        position: "top"
    }, children);
};
// Remove Old suffix and wrap in memo on clean up of vc90_perf_improve_pre_share_on_issue_view
const $6286a7fcdb67d585$var$PreShareViewOld = ({ triggerButtonStyle: triggerButtonStyle, loading: loading, error: error, emailSettings: emailSettings, hipaaStatus: hipaaStatus, renderCustomTriggerButton: renderCustomTriggerButton, getEmailSettings: getEmailSettings, getHipaaStatus: getHipaaStatus, getUserPermission: getUserPermission, getUserRoles: getUserRoles, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose, onTriggerButtonClick: onTriggerButtonClick, shareShortcutTriggerCount: shareShortcutTriggerCount, poSpotlightShareButtonId: poSpotlightShareButtonId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(isAutoOpenDialog);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // Used to invoke a re-render when isAutoOpenDialog has not changed but the shortcut has been pressed again.
    (0, $5uXOq.useEffect)(()=>{
        setIsOpen(isAutoOpenDialog);
    }, [
        isAutoOpenDialog,
        shareShortcutTriggerCount
    ]);
    const onTriggerClick = (0, $5uXOq.useCallback)((trigger)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'PreShareView Button Clicked',
            actionSubject: 'Share'
        });
        setIsOpen(!isOpen);
        if (!isOpen) {
            getUserPermission();
            getEmailSettings();
            getHipaaStatus();
            getUserRoles && getUserRoles();
        }
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, trigger);
        if (onTriggerButtonClick) onTriggerButtonClick();
    }, [
        createAnalyticsEvent,
        isOpen,
        onTriggerButtonClick,
        getUserPermission,
        getEmailSettings,
        getHipaaStatus,
        getUserRoles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        onClose: ()=>{
            setIsOpen(false);
            onDialogClose && onDialogClose();
        },
        zIndex: (0, $gwIPs.layers).modal,
        messageId: "share-button.ui.pre-share-view.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6286a7fcdb67d585$var$DialogLayout, {
                "data-testid": "share-button.ui.pre-share-view.warningModal"
            }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                testId: "share-button.ui.pre-share-view.loading",
                size: "medium"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6P8F6.WarningContent), {
                isEmailEnabled: emailSettings?.isEmailEnabled,
                canUserEnableEmail: !!emailSettings?.canUserEnableEmail,
                isUserHIPAA: !!hipaaStatus?.isCompliant
            }), error && // eslint-disable-next-line @atlaskit/design-system/use-heading
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h1", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $ggimd.default).errorMessage)))),
        isOpen: isOpen,
        placement: "left-start",
        trigger: (triggerProps)=>renderCustomTriggerButton ? renderCustomTriggerButton({
                isSelected: isOpen,
                onClick: ()=>onTriggerClick('RenderCustomTriggerPreShareView')
            }, triggerProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6286a7fcdb67d585$var$ConditionalTooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                name: "issue-pre-share-button"
            }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                testId: "share-button.ui.pre-share-view.button",
                id: poSpotlightShareButtonId,
                isDisabled: loading,
                label: formatMessage((0, $ggimd.default).shareTriggerButtonText),
                ...triggerProps,
                appearance: "default",
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($empdx))), {
                        spacing: "spacious",
                        ...(0, $4R6GH.fg)('jfp_a11y_team_button_has_verbose_accessible_name') ? {
                            testId: 'share-button.ui.pre-share-view.share-icon',
                            label: ''
                        } : {
                            label: triggerButtonStyle === 'icon-with-text' ? '' : formatMessage((0, $ggimd.default).shareTriggerButtonText)
                        },
                        color: "var(--ds-icon, #44546F)"
                    }),
                onClick: ()=>onTriggerClick('PreShareView')
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                testId: "share-button.ui.pre-share-view.button",
                id: poSpotlightShareButtonId,
                disabled: loading,
                ...triggerProps,
                appearance: "subtle",
                ...(0, $4R6GH.fg)('jfp_a11y_team_button_has_verbose_accessible_name') && {
                    'aria-label': formatMessage((0, $ggimd.default).shareTriggerButtonText)
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
                    LEGACY_size: "medium",
                    spacing: "spacious",
                    ...(0, $4R6GH.fg)('jfp_a11y_team_button_has_verbose_accessible_name') ? {
                        testId: 'share-button.ui.pre-share-view.share-icon',
                        label: ''
                    } : {
                        label: triggerButtonStyle === 'icon-with-text' ? '' : formatMessage((0, $ggimd.default).shareTriggerButtonText)
                    },
                    color: "var(--ds-icon, #44546F)"
                }),
                onClick: ()=>onTriggerClick('PreShareView')
            }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $ggimd.default).shareTriggerButtonText) : null)))
    });
};
const $6286a7fcdb67d585$var$MemoedPreShareView = /*#__PURE__*/ (0, $5uXOq.memo)($6286a7fcdb67d585$var$PreShareViewOld);
const $6286a7fcdb67d585$export$412417a0122f041e = (0, $cSD7y.componentWithFG)('vc90_perf_improve_pre_share_on_issue_view', $6286a7fcdb67d585$var$MemoedPreShareView, $6286a7fcdb67d585$var$PreShareViewOld);
var $6286a7fcdb67d585$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $6286a7fcdb67d585$export$412417a0122f041e;
const $6286a7fcdb67d585$var$DialogLayout = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gwIPs", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $80d528dbc2b11cbc$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $80d528dbc2b11cbc$export$7a57f79000377ca2);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $80d528dbc2b11cbc$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $80d528dbc2b11cbc$export$7be255094ccdc533);

var $k5uoT = parcelRequire("k5uoT");
const $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 = 8;
const $80d528dbc2b11cbc$export$7a57f79000377ca2 = (0, $k5uoT.borderRadius)();
const $80d528dbc2b11cbc$export$22dec01f2c854397 = 40;
const $80d528dbc2b11cbc$export$dab5ea164c6f81a = 100;
const $80d528dbc2b11cbc$export$7be255094ccdc533 = {
    banner: (0, $k5uoT.layers).navigation(),
    card: (0, $k5uoT.layers).card(),
    dialog: (0, $k5uoT.layers).dialog(),
    navigation: (0, $k5uoT.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $k5uoT.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $k5uoT.layers).navigation() - 1,
    layer: (0, $k5uoT.layers).layer(),
    blanket: (0, $k5uoT.layers).blanket(),
    modal: (0, $k5uoT.layers).modal(),
    flag: (0, $k5uoT.layers).flag(),
    spotlight: (0, $k5uoT.layers).spotlight(),
    tooltip: (0, $k5uoT.layers).tooltip(),
    mobileBanner: $80d528dbc2b11cbc$export$dab5ea164c6f81a
};
const $80d528dbc2b11cbc$export$b3219800bda33a1f = {
    issueIconSize: 16
};

});

parcelRegister("ggimd", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3676909909c5a34$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a3676909909c5a34$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.pre-share-view.share-trigger-button-text",
        "defaultMessage": "Share"
    },
    errorMessage: {
        "id": "share-button.pre-share-view.error-message",
        "defaultMessage": "Unable to fetch sharing details"
    }
});

});

parcelRegister("6P8F6", function(module, exports) {

$parcel$export(module.exports, "WarningContent", () => $ecad3da73effb00b$export$b7eb687edfdfe752);

var $5uXOq = parcelRequire("5uXOq");

var $bU3PY = parcelRequire("bU3PY");

var $41j30 = parcelRequire("41j30");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $cGLqe = parcelRequire("cGLqe");
function $ecad3da73effb00b$export$b7eb687edfdfe752({ isEmailEnabled: isEmailEnabled, canUserEnableEmail: canUserEnableEmail, isUserHIPAA: isUserHIPAA }) {
    if (isEmailEnabled === false || isUserHIPAA) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "PreShareWarningView"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: "Warning",
        testId: "share-button.ui.pre-share-view.warning-content.warning-icon"
    }), isEmailEnabled === false && // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $cGLqe.default).disabledWarningMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), canUserEnableEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $cGLqe.default).adminEnableOutgoingMail), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
        href: "/secure/admin/OutgoingMailServers.jspa"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $cGLqe.default).outgoingMail))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $cGLqe.default).nonAdminWarningMessage)), isEmailEnabled !== false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $cGLqe.default).disabledWarningMessageIfHipaaIssueTermRefresh : (0, $cGLqe.default).disabledWarningMessageIfHipaa), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            canUserEnableEmail: canUserEnableEmail,
            isUserHIPAA: isUserHIPAA
        }
    }));
    return null;
}

});
parcelRegister("41j30", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c2f3c33a6194375$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8oe80 = parcelRequire("8oe80");

var $hjSul = parcelRequire("hjSul");
function $7c2f3c33a6194375$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), rest, children);
}
var $7c2f3c33a6194375$export$2e2bcd8739ae039 = (0, $8oe80.default)('link', {
    onClick: 'clicked'
})($7c2f3c33a6194375$var$Link);

});

parcelRegister("5oFIy", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $3ea3e1dfbcd8cda6$export$2ccf161b817b43b);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");


var $8zOmE = parcelRequire("8zOmE");
// eslint-disable-next-line jira/react/no-class-components
class $3ea3e1dfbcd8cda6$var$FireComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $8zOmE.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $3ea3e1dfbcd8cda6$export$64eb47d7b94ba089 = (0, $cb25w.default)()($3ea3e1dfbcd8cda6$var$FireComponent);
const $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e)
    });
const $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$947dac6c72b26f81)
    });
const $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$12346a674644c156)
    });
const $3ea3e1dfbcd8cda6$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});



parcelRegister("1uAgh", function(module, exports) {

$parcel$export(module.exports, "default", () => $379ea30a2af32bdf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2gQ83 = parcelRequire("2gQ83");

var $dsCiy = parcelRequire("dsCiy");

var $4Pf62 = parcelRequire("4Pf62");

var $7f4tk = parcelRequire("7f4tk");

var $pa9q9 = parcelRequire("pa9q9");
var $34Vv8 = parcelRequire("34Vv8");

var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $dAfqg = parcelRequire("dAfqg");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $kAdLR = parcelRequire("kAdLR");

var $aYuZy = parcelRequire("aYuZy");

var $kwHgU = parcelRequire("kwHgU");

var $8HBuB = parcelRequire("8HBuB");

var $cvSAQ = parcelRequire("cvSAQ");

var $3Misg = parcelRequire("3Misg");

var $b4Qrh = parcelRequire("b4Qrh");

var $60DYE = parcelRequire("60DYE");

var $5GqLe = parcelRequire("5GqLe");
const $379ea30a2af32bdf$var$USER_PICKER_LIMIT = 20;
class $379ea30a2af32bdf$export$e980dfbc2840e8bc extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            shouldAutoDismissFlag: true,
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onTriggerButtonClick: ()=>{}
        };
    }
    constructor(props){
        super(props), this.getOriginTracingInstance = ()=>new (0, $2gQ83.default)({
                product: this.props.productId
            }), this.loadUsers = async (searchText = '')=>{
            const searchTextEncoded = encodeURIComponent(searchText);
            const url = `/rest/api/3/groupuserpicker?maxResults=${$379ea30a2af32bdf$var$USER_PICKER_LIMIT}&query=${searchTextEncoded}&showAvatar=true&avatarSize=medium&excludeConnectAddons=true`;
            const groupsAndUsers = await (0, $7f4tk.default)(url);
            return groupsAndUsers.users.users.filter((user)=>user.accountType === 'atlassian').map((user)=>{
                const userData = {
                    type: 'user',
                    id: user.accountId,
                    name: user.displayName,
                    avatarUrl: user.avatarUrl
                };
                return userData;
            });
        }, this.showFlags = (flags)=>{
            const { flagService: flagService, shouldAutoDismissFlag: shouldAutoDismissFlag } = this.props;
            if (flagService?.showFlag) flags.forEach((flag)=>{
                flagService.showFlag({
                    type: flag.appearance,
                    title: flag.title.defaultMessage,
                    isAutoDismiss: shouldAutoDismissFlag,
                    messageId: `share-button.ui.share-view.showFlag.${flag.title.id}`,
                    messageType: 'transactional'
                });
            });
        }, this.cloudId = '';
        this.cloudId = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)().cloudId;
        if (props.legacyShareClientConfig !== undefined) this.legacyShareClient = new (0, $aYuZy.default)(props.legacyShareClientConfig);
    }
    render() {
        const { objectAri: objectAri, renderCustomTriggerButton: renderCustomTriggerButton, shareLink: shareLink, shareTitle: shareTitle, shareContentType: shareContentType, shareFormTitle: shareFormTitle, subProductId: subProductId, triggerButtonAppearance: triggerButtonAppearance = 'subtle', triggerButtonStyle: triggerButtonStyle, onTriggerButtonClick: onTriggerButtonClick, shareIntegrations: shareIntegrations, integrationMode: integrationMode = 'off', isAutoOpenDialog: isAutoOpenDialog, onDialogClose: onDialogClose, copyTooltipText: copyTooltipText, orgId: orgId, isBrowseUsersEnabled: isBrowseUsersEnabled, shareFormHelperMessage: shareFormHelperMessage, shareFieldsFooter: shareFieldsFooter, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, isOutgoingMailDisabled: isOutgoingMailDisabled, customHeader: customHeader, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, onSubmit: onSubmit, userRoles: userRoles = [], userRolesLoading: userRolesLoading } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsCiy.ShareDialogContainer), {
            shareClient: this.legacyShareClient,
            triggerButtonAppearance: triggerButtonAppearance,
            triggerButtonStyle: triggerButtonStyle,
            cloudId: this.cloudId,
            orgId: orgId,
            loadUserOptions: this.legacyShareClient && this.loadUsers,
            // @ts-expect-error - TS2322 - Type '() => OriginTracing' is not assignable to type 'OriginTracingFactory'.
            originTracingFactory: this.getOriginTracingInstance,
            productId: subProductId,
            renderCustomTriggerButton: renderCustomTriggerButton,
            shareAri: objectAri || (0, $kAdLR.createAri)(subProductId, this.cloudId),
            shareFormHelperMessage: shareFormHelperMessage,
            shareLink: shareLink,
            shareTitle: shareTitle,
            shareContentType: shareContentType,
            shareFormTitle: shareFormTitle,
            showFlags: this.showFlags,
            enableSmartUserPicker: !this.legacyShareClient,
            product: "jira",
            onTriggerButtonClick: onTriggerButtonClick,
            shareIntegrations: shareIntegrations,
            integrationMode: integrationMode,
            isAutoOpenDialog: isAutoOpenDialog,
            onDialogClose: onDialogClose,
            copyTooltipText: copyTooltipText,
            isBrowseUsersDisabled: isBrowseUsersEnabled === false,
            shareFieldsFooter: shareFieldsFooter,
            workspaceAri: this.props.workspaceAri,
            additionalTabs: additionalTabs,
            builtInTabContentWidth: builtInTabContentWidth,
            isSubmitShareDisabled: isOutgoingMailDisabled,
            customHeader: customHeader,
            isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
            additionalUserFields: isExtendedShareDialogEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8HBuB.UserRole), {
                roles: userRoles,
                isLoading: !!userRolesLoading
            }),
            CustomSubmitButton: isExtendedShareDialogEnabled ? (0, $b4Qrh.CustomShareSubmitButton) : undefined,
            onSubmit: onSubmit
        });
    }
}
const $379ea30a2af32bdf$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    projectAccessLevelUpdated: {
        "id": "share-button.ui.share-view.project-access-level-updated.non-final",
        "defaultMessage": "Access updated"
    },
    errorUpdateProjectAccessLevel: {
        "id": "share-button.ui.share-view.error-update-project-access-level.non-final",
        "defaultMessage": "Error updating project access level"
    },
    errorAddingUsersToRole: {
        "id": "share-button.ui.share-view.error-adding-users-to-role.non-final",
        "defaultMessage": "Error adding users to role"
    }
});
const $379ea30a2af32bdf$var$noop = ()=>null;
const $379ea30a2af32bdf$var$ShareButtonFC = ({ objectAri: objectAri, triggerButtonAppearance: triggerButtonAppearance = 'subtle', onTriggerButtonClick: onTriggerButtonClick = $379ea30a2af32bdf$var$noop, integrationMode: integrationMode = 'off', isBrowseUsersEnabled: isBrowseUsersEnabled, isOutgoingMailDisabled: isOutgoingMailDisabled, legacyShareClientConfig: legacyShareClientConfig, shouldAutoDismissFlag: shouldAutoDismissFlag = false, onSubmit: onSubmit, userRoles: userRoles = [], userRolesLoading: userRolesLoading, accessLevel: accessLevel, ...props })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isExtendedShareDialogEnabled = (0, $cvSAQ.useIsExtendedShareDialogEnabled)();
    const legacyShareClient = (0, $5uXOq.useMemo)(()=>legacyShareClientConfig && new (0, $aYuZy.default)(legacyShareClientConfig), [
        legacyShareClientConfig
    ]);
    const getOriginTracingInstance = (0, $5uXOq.useCallback)(()=>{
        return new (0, $2gQ83.default)({
            product: 'jira'
        });
    }, []);
    const showFlags = (0, $5uXOq.useCallback)((flags)=>{
        if (showFlag) flags.forEach((flag)=>{
            showFlag({
                type: flag.appearance,
                title: flag.title.defaultMessage,
                isAutoDismiss: shouldAutoDismissFlag,
                messageId: `share-button.ui.share-view.showFlag.${flag.title.id}`,
                messageType: 'transactional'
            });
        });
    }, [
        showFlag,
        shouldAutoDismissFlag
    ]);
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { update: updateProjectAccessLevel, updateError: projectAccessLevelError } = (0, $3Misg.useProjectAccessLevel)();
    const { add: addToUserRole, updateError: useRoleError } = (0, $60DYE.useUserRole)(projectContext?.projectKey);
    (0, $5uXOq.useEffect)(()=>{
        if (projectAccessLevelError) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraUsersAndRoles.updateAccessType failed', 'changeAccessButton', {
                source: (0, $5GqLe.ANALYTICS_SOURCE),
                projectType: projectContext?.projectType,
                isTmp: true,
                error: projectAccessLevelError
            });
            showFlag({
                type: 'error',
                title: formatMessage($379ea30a2af32bdf$export$defe85febe8b728c.errorUpdateProjectAccessLevel),
                isAutoDismiss: shouldAutoDismissFlag,
                messageId: 'share-button.ui.share-view.show-flag.error.update-project-access-level',
                messageType: 'transactional'
            });
        }
    }, [
        projectAccessLevelError,
        formatMessage,
        showFlag,
        shouldAutoDismissFlag,
        createAnalyticsEvent,
        projectContext?.projectType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (useRoleError) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraUsersAndRoles.addActorToRole failed', 'roleOption', {
                source: (0, $5GqLe.ANALYTICS_SOURCE),
                packageName: '@atlassian/jira-share-button',
                error: useRoleError
            });
            showFlag({
                type: 'error',
                title: formatMessage($379ea30a2af32bdf$export$defe85febe8b728c.errorAddingUsersToRole),
                isAutoDismiss: shouldAutoDismissFlag,
                messageId: 'share-button.ui.share-view.show-flag.error.adding-users-to-role.1',
                messageType: 'transactional'
            });
        }
    }, [
        useRoleError,
        formatMessage,
        showFlag,
        shouldAutoDismissFlag,
        createAnalyticsEvent
    ]);
    const handleOnSubmit = (0, $5uXOq.useCallback)((data)=>{
        if (isExtendedShareDialogEnabled) {
            if (data?.projectAccessLevel?.value && data?.projectAccessLevel?.value !== accessLevel) // We use `.then()` syntax here instead of changing the entire function to `async` to avoid blocking the user role updates below
            updateProjectAccessLevel({
                accessLevel: data?.projectAccessLevel.value
            }).then((response)=>{
                if (!response) return;
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'project updated', 'changeAccessButton', {
                    source: (0, $5GqLe.ANALYTICS_SOURCE),
                    projectType: projectContext?.projectType,
                    isTmp: true,
                    updatedItem: 'projectAccess',
                    accessLevel: data?.projectAccessLevel?.value
                });
                if (!data.users?.length) showFlag({
                    type: 'success',
                    title: formatMessage($379ea30a2af32bdf$export$defe85febe8b728c.projectAccessLevelUpdated),
                    isAutoDismiss: shouldAutoDismissFlag,
                    messageId: 'share-button.ui.share-view.show-flag.success.project-access-level-updated',
                    messageType: 'transactional'
                });
            });
            if (data.users?.length > 0 && data?.userRole?.value) {
                const { value: roleId, label: roleName } = data.userRole;
                const userIds = data.users.filter((user)=>user.type === 'user').map((user)=>user.id);
                const groupIds = data.users.filter((user)=>user.type === 'group').map((group)=>group.id);
                addToUserRole(roleId, {
                    users: userIds,
                    groups: groupIds
                }).then((response)=>{
                    if (!response) return;
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'project updated', 'roleOption', {
                        source: (0, $5GqLe.ANALYTICS_SOURCE),
                        roleId: roleId,
                        roleName: roleName,
                        numberOfExistingUsersAdded: userIds.length,
                        numberOfExistingGroupsAdded: groupIds.length,
                        updatedItem: 'projectRole'
                    });
                });
            }
        }
        onSubmit && onSubmit(data);
    }, [
        isExtendedShareDialogEnabled,
        onSubmit,
        accessLevel,
        updateProjectAccessLevel,
        createAnalyticsEvent,
        projectContext?.projectType,
        showFlag,
        formatMessage,
        shouldAutoDismissFlag,
        addToUserRole
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsCiy.ShareDialogContainer), {
        shareClient: legacyShareClient,
        cloudId: cloudId,
        loadUserOptions: legacyShareClient && (0, $kwHgU.loadUsers),
        // @ts-expect-error - TS2322 - Type '() => OriginTracing' is not assignable to type 'OriginTracingFactory'.
        originTracingFactory: getOriginTracingInstance,
        shareAri: objectAri || (0, $kAdLR.createAri)(props.subProductId, cloudId),
        showFlags: showFlags,
        enableSmartUserPicker: !legacyShareClient,
        product: "jira",
        isBrowseUsersDisabled: isBrowseUsersEnabled === false,
        isSubmitShareDisabled: isOutgoingMailDisabled,
        triggerButtonAppearance: triggerButtonAppearance,
        onTriggerButtonClick: onTriggerButtonClick,
        integrationMode: integrationMode,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
        onSubmit: handleOnSubmit,
        CustomSubmitButton: isExtendedShareDialogEnabled ? (0, $b4Qrh.CustomShareSubmitButton) : undefined,
        additionalUserFields: isExtendedShareDialogEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8HBuB.UserRole), {
            accessLevel: accessLevel,
            roles: userRoles,
            isLoading: !!userRolesLoading
        }),
        ...props
    });
};
var $379ea30a2af32bdf$export$2e2bcd8739ae039 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jira-growth-share-button-refactor-fc'), $379ea30a2af32bdf$var$ShareButtonFC, (0, $az4zD.injectIntlV2)((0, $34Vv8.default)($379ea30a2af32bdf$export$e980dfbc2840e8bc)));

});
parcelRegister("dsCiy", function(module, exports) {

$parcel$export(module.exports, "ShareDialogContainer", () => $dd0122880035a80e$export$78b28896b43ae5d6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1SBaA = parcelRequire("1SBaA");

var $8QpSo = parcelRequire("8QpSo");

var $ousew = parcelRequire("ousew");

var $3joPi = parcelRequire("3joPi");

var $cb25w = parcelRequire("cb25w");

var $VSDnB = parcelRequire("VSDnB");

var $9b5JR = parcelRequire("9b5JR");

var $inlXa = parcelRequire("inlXa");

var $idKBS = parcelRequire("idKBS");

var $b2oBK = parcelRequire("b2oBK");

var $hQWyD = parcelRequire("hQWyD");

var $65uFp = parcelRequire("65uFp");

var $2sAb4 = parcelRequire("2sAb4");

var $7ZU6o = parcelRequire("7ZU6o");

var $7v5Ga = parcelRequire("7v5Ga");

var $4gTjW = parcelRequire("4gTjW");
const $dd0122880035a80e$var$COPY_LINK_EVENT = (0, $b2oBK.copyLinkButtonClicked)({
    start: 0
});
const $dd0122880035a80e$export$f84bd70098573c5c = {
    disableSharingToEmails: false
};
const $dd0122880035a80e$var$memoizedFormatCopyLink = (0, $8QpSo.default)((origin, link)=>origin.addToUrl(link));
function $dd0122880035a80e$var$getCurrentPageUrl() {
    return window.location.href;
}
class $dd0122880035a80e$export$bc8c417f2da43f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            enableSmartUserPicker: false,
            shareeAction: 'view',
            product: 'confluence'
        };
    }
    constructor(props){
        super(props), this._isMounted = false, this._urlShorteningRequestCounter = 0, this._lastUrlShorteningWasTooSlow = false, this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $b2oBK.CHANNEL_ID));
        }, this.fetchConfig = ()=>{
            this.setState({
                isFetchingConfig: true
            }, async ()=>{
                try {
                    (0, $65uFp.renderShareDialogExp).start();
                    const config = await this.shareClient.getConfig(this.props.cloudId);
                    if (this._isMounted) this.setState({
                        config: config,
                        isFetchingConfig: false
                    });
                    (0, $65uFp.renderShareDialogExp).success();
                } catch (error) {
                    if (this._isMounted) this.setState({
                        config: $dd0122880035a80e$export$f84bd70098573c5c,
                        isFetchingConfig: false
                    });
                    let { ...errObj } = error;
                    if (error instanceof Error) errObj = {
                        ...errObj,
                        className: error.constructor.name
                    };
                    (0, $hQWyD.isValidFailedExperience)((0, $65uFp.renderShareDialogExp), errObj);
                }
            });
        }, this.handleSubmitShare = ({ users: users, comment: comment, ...rest })=>{
            const shareLink = this.getFormShareLink();
            const { productId: productId, shareAri: shareAri, shareContentType: shareContentType, shareTitle: shareTitle, shareeAction: shareeAction, workspaceAri: workspaceAri, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled } = this.props;
            const content = {
                ari: shareAri,
                link: shareLink,
                title: shareTitle,
                type: shareContentType,
                workspaceAri: workspaceAri
            };
            const metaData = {
                productId: productId,
                atlOriginId: this.getFormShareOriginTracing().id,
                shareeAction: shareeAction
            };
            this.props.onSubmit?.({
                users: users,
                comment: comment,
                ...rest
            });
            if (isExtendedShareDialogEnabled && users.length === 0) return Promise.resolve();
            return this.shareClient.share(content, (0, $4gTjW.optionDataToUsers)(users), metaData, comment).then(()=>{
                if (!this._isMounted) return;
                // renew Origin Tracing Id per share action succeeded
                this.setState((state)=>({
                        shareActionCount: state.shareActionCount + 1
                    }));
            });
        }, this.handleDialogOpen = async ()=>{
            if (this.props.onDialogOpen) this.props.onDialogOpen();
            this.setState({
                currentPageUrl: $dd0122880035a80e$var$getCurrentPageUrl()
            }, ()=>{
                this.updateShortCopyLink();
            });
            // always refetch the config when modal is re-opened
            this.fetchConfig();
        }, this.decorateAnalytics = (payload)=>{
            if (payload.type === $dd0122880035a80e$var$COPY_LINK_EVENT.type && payload.action === $dd0122880035a80e$var$COPY_LINK_EVENT.action && payload.actionSubjectId === $dd0122880035a80e$var$COPY_LINK_EVENT.actionSubjectId) {
                const isCopyLinkShortened = !!this.getShortenedCopyLink();
                payload = {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        shortUrl: isCopyLinkShortened
                    }
                };
                if (this.shouldShortenCopyLink() && !isCopyLinkShortened) this._lastUrlShorteningWasTooSlow = true;
            }
            return payload;
        }, // ensure origin is re-generated if the link or the factory changes
        // separate memoization is needed since copy != form
        this.getUniqueCopyLinkOriginTracing = (0, $8QpSo.default)((link, originTracingFactory)=>{
            return originTracingFactory();
        }), // form origin must furthermore be regenerated after each form share
        this.getUniqueFormShareOriginTracing = (0, $8QpSo.default)((link, originTracingFactory, shareCount)=>{
            return originTracingFactory();
        }), this.getUpToDateShortenedCopyLink = (0, $8QpSo.default)((data, originId)=>{
            this._lastUrlShorteningWasTooSlow = false;
            this._urlShorteningRequestCounter++;
            this.createAndFireEvent((0, $b2oBK.shortUrlRequested)());
            const start = Date.now();
            return this.urlShortenerClient.shorten({
                ...data,
                originId: originId
            }).then((response)=>{
                this.createAndFireEvent((0, $b2oBK.shortUrlGenerated)(start, this._lastUrlShorteningWasTooSlow));
                return response.shortUrl;
            }).catch(()=>{
                this.createAndFireEvent((0, $b2oBK.errorEncountered)('urlShortening'));
                return null;
            });
        }, (0, (/*@__PURE__*/$parcel$interopDefault($1SBaA)))), this.getFormShareLink = ()=>{
            // original share link is used here
            return this.getRawLink();
        };
        // v0.4 -> v0.5 .client -> .shareClient
        (0, $3joPi.default)(!props.client, 'elements/share: Breaking change, please update your props!');
        this.shareClient = props.shareClient || new (0, $inlXa.ShareServiceClient)();
        this.urlShortenerClient = props.urlShortenerClient || new (0, $9b5JR.AtlassianUrlShortenerClient)();
        this.state = {
            shareActionCount: 0,
            config: $dd0122880035a80e$export$f84bd70098573c5c,
            isFetchingConfig: false,
            currentPageUrl: $dd0122880035a80e$var$getCurrentPageUrl(),
            shortenedCopyLink: null
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    componentDidUpdate(prevProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($1SBaA)))(prevProps.shortLinkData, this.props.shortLinkData)) this.updateShortCopyLink();
    }
    getRawLink() {
        const { shareLink: shareLink } = this.props;
        const { currentPageUrl: currentPageUrl } = this.state;
        return shareLink || currentPageUrl;
    }
    getCopyLinkOriginTracing() {
        const { originTracingFactory: originTracingFactory } = this.props;
        const shareLink = this.getRawLink();
        return this.getUniqueCopyLinkOriginTracing(shareLink, originTracingFactory);
    }
    getFormShareOriginTracing() {
        const { originTracingFactory: originTracingFactory } = this.props;
        const { shareActionCount: shareActionCount } = this.state;
        const shareLink = this.getRawLink();
        return this.getUniqueFormShareOriginTracing(shareLink, originTracingFactory, shareActionCount);
    }
    getFullCopyLink() {
        const { formatCopyLink: formatCopyLink } = this.props;
        const shareLink = this.getRawLink();
        const copyLinkOrigin = this.getCopyLinkOriginTracing();
        return (formatCopyLink || $dd0122880035a80e$var$memoizedFormatCopyLink)(copyLinkOrigin, shareLink);
    }
    shouldShortenCopyLink() {
        return !!this.props.shortLinkData || !!this.props.useUrlShortener;
    }
    getShortenedCopyLink() {
        return this.shouldShortenCopyLink() && this.state.shortenedCopyLink || undefined;
    }
    getCopyLink() {
        return this.getShortenedCopyLink() || this.getFullCopyLink();
    }
    updateShortCopyLink() {
        this.setState({
            shortenedCopyLink: null
        });
        const { shortLinkData: shortLinkData } = this.props;
        if (!shortLinkData) return;
        const originId = this.getCopyLinkOriginTracing().id;
        const shortLink = this.getUpToDateShortenedCopyLink(shortLinkData, originId);
        const requestCounter = this._urlShorteningRequestCounter;
        shortLink.then((shortenedCopyLink)=>{
            if (!this._isMounted) return;
            const isRequestOutdated = requestCounter !== this._urlShorteningRequestCounter;
            if (isRequestOutdated) return;
            this.setState({
                shortenedCopyLink: shortenedCopyLink
            });
        });
    }
    render() {
        const { cloudId: cloudId, orgId: orgId, isAutoOpenDialog: isAutoOpenDialog, dialogPlacement: dialogPlacement, loadUserOptions: loadUserOptions, renderCustomTriggerButton: renderCustomTriggerButton, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, shouldCloseOnEscapePress: shouldCloseOnEscapePress, showFlags: showFlags, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, triggerButtonAppearance: triggerButtonAppearance, triggerButtonIcon: triggerButtonIcon, triggerButtonStyle: triggerButtonStyle, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, bottomMessage: bottomMessage, shareeAction: shareeAction, product: product, productAttributes: productAttributes, customHeader: customHeader, customFooter: customFooter, onTriggerButtonClick: onTriggerButtonClick, onUserSelectionChange: onUserSelectionChange, shareFieldsFooter: shareFieldsFooter, isCopyDisabled: isCopyDisabled, isPublicLink: isPublicLink, integrationMode: integrationMode, shareIntegrations: shareIntegrations, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, shareAri: shareAri, tabIndex: tabIndex, copyTooltipText: copyTooltipText, onDialogClose: onDialogClose, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions, isSubmitShareDisabled: isSubmitShareDisabled, additionalUserFields: additionalUserFields, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, CustomSubmitButton: CustomSubmitButton } = this.props;
        const { config: config, isFetchingConfig: isFetchingConfig } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2sAb4.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ZU6o.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7v5Ga.ShareDialogWithTrigger), {
                    onTriggerButtonClick: onTriggerButtonClick,
                    isAutoOpenDialog: isAutoOpenDialog,
                    config: config,
                    isFetchingConfig: isFetchingConfig,
                    copyLink: this.getCopyLink(),
                    analyticsDecorator: this.decorateAnalytics,
                    dialogPlacement: dialogPlacement,
                    loadUserOptions: loadUserOptions,
                    onDialogOpen: this.handleDialogOpen,
                    onShareSubmit: this.handleSubmitShare,
                    renderCustomTriggerButton: renderCustomTriggerButton,
                    shareContentType: shareContentType,
                    shareContentSubType: shareContentSubType,
                    shareContentId: shareContentId,
                    shareFormTitle: shareFormTitle,
                    shareFormHelperMessage: shareFormHelperMessage,
                    copyLinkOrigin: this.getCopyLinkOriginTracing(),
                    formShareOrigin: this.getFormShareOriginTracing(),
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress,
                    showFlags: showFlags,
                    enableSmartUserPicker: enableSmartUserPicker,
                    loggedInAccountId: loggedInAccountId,
                    cloudId: cloudId,
                    orgId: orgId,
                    triggerButtonAppearance: triggerButtonAppearance,
                    triggerButtonIcon: triggerButtonIcon,
                    triggerButtonStyle: triggerButtonStyle,
                    triggerButtonTooltipPosition: triggerButtonTooltipPosition,
                    triggerButtonTooltipText: triggerButtonTooltipText,
                    bottomMessage: bottomMessage,
                    submitButtonLabel: shareeAction === 'edit' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $idKBS.messages).inviteTriggerButtonText
                    }),
                    product: product,
                    productAttributes: productAttributes,
                    customHeader: (0, $VSDnB.fg)('platform_share_custom_header_prop') && customHeader,
                    customFooter: customFooter,
                    onUserSelectionChange: onUserSelectionChange,
                    shareFieldsFooter: shareFieldsFooter,
                    isCopyDisabled: isCopyDisabled,
                    isPublicLink: isPublicLink,
                    integrationMode: integrationMode,
                    shareIntegrations: shareIntegrations,
                    shareAri: shareAri,
                    tabIndex: tabIndex,
                    copyTooltipText: copyTooltipText,
                    onDialogClose: onDialogClose,
                    isBrowseUsersDisabled: isBrowseUsersDisabled,
                    userPickerOptions: userPickerOptions,
                    additionalTabs: additionalTabs,
                    builtInTabContentWidth: builtInTabContentWidth,
                    isSubmitShareDisabled: isSubmitShareDisabled,
                    additionalUserFields: additionalUserFields,
                    isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                    CustomSubmitButton: CustomSubmitButton
                })
            })
        });
    }
}
const $dd0122880035a80e$export$78b28896b43ae5d6 = (0, $cb25w.default)()($dd0122880035a80e$export$bc8c417f2da43f4);

});
parcelRegister("1SBaA", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("9b5JR", function(module, exports) {

$parcel$export(module.exports, "AtlassianUrlShortenerClient", () => $db8e8ad360042aaf$export$8fed7002650b52ef);
class $db8e8ad360042aaf$export$8fed7002650b52ef {
    async shorten(data) {
        try {
            const response = await fetch('/gateway/api/atl-link/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) throw new Error(`status="${response.status}"`);
            const result = await response.json();
            if (!result.shortUrl) throw new Error('Breach of contract!');
            return result;
        } catch (err) {
            if (err instanceof Error) err.message = `While shortening URL: ${err.message}!`;
            throw err;
        }
    }
}

});

parcelRegister("inlXa", function(module, exports) {

$parcel$export(module.exports, "ShareServiceClient", () => $17bc358e1d85e6d0$export$ee05f3e1f0248b62);

var $dS9cn = parcelRequire("dS9cn");
const $17bc358e1d85e6d0$export$a7d7a4246bdd7a12 = 'share';
const $17bc358e1d85e6d0$export$1a440d9a41e6ce3e = 'share/configuration';
const $17bc358e1d85e6d0$export$7745139d0aa6183c = '/gateway/api';
class $17bc358e1d85e6d0$export$ee05f3e1f0248b62 {
    constructor(serviceConfig){
        this.serviceConfig = {
            url: $17bc358e1d85e6d0$export$7745139d0aa6183c,
            ...serviceConfig || {}
        };
    }
    getConfig(cloudId) {
        const options = {
            path: $17bc358e1d85e6d0$export$1a440d9a41e6ce3e,
            queryParams: {
                cloudId: cloudId
            },
            requestInit: {
                method: 'get'
            }
        };
        return (0, $dS9cn.utils).requestService(this.serviceConfig, options);
    }
    /**
	 * To send a POST request to the share endpoint in Share service
	 */ share(content, recipients, metadata, comment) {
        return fetch(`${this.serviceConfig.url}/${$17bc358e1d85e6d0$export$a7d7a4246bdd7a12}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            credentials: 'include',
            body: JSON.stringify({
                content: content,
                recipients: recipients,
                metadata: metadata,
                comment: comment
            })
        }).then((response)=>{
            if (response.status === 204) return Promise.resolve();
            else if (response.ok) return response.json();
            else return Promise.reject({
                code: response.status,
                reason: response.statusText,
                body: response.json()
            });
        });
    }
}

});

parcelRegister("idKBS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $990cec53807f67a0$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $990cec53807f67a0$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    formTitle: {
        id: 'fabric.elements.share.form.title',
        defaultMessage: 'Share',
        description: 'Title for Share form.'
    },
    formSend: {
        id: 'fabric.elements.share.form.send',
        defaultMessage: 'Send',
        description: 'Label for Share form submit button.'
    },
    formShare: {
        id: 'fabric.elements.share.form.share',
        defaultMessage: 'Share',
        description: 'Label for Share form submit button.'
    },
    formSendPublic: {
        id: 'fabric.elements.share.form.public.send',
        defaultMessage: 'Send public link',
        description: 'Label for Share form submit button when link is public.'
    },
    formSharePublic: {
        id: 'fabric.elements.share.form.public.share',
        defaultMessage: 'Share public link',
        description: 'Label for Share form submit button when link is public.'
    },
    formRetry: {
        id: 'fabric.elements.share.form.retry',
        defaultMessage: 'Retry',
        description: 'Label for Share from retry button.'
    },
    formNoPermissions: {
        id: 'fabric.elements.share.form.no-permissions',
        defaultMessage: 'You do not have the ability to share.',
        description: 'Copy to show when a user can not share.'
    },
    commentLabel: {
        id: 'fabric.elements.share.form.comment.label',
        defaultMessage: 'Message (optional)',
        description: 'Label for the comment field in the Share form.'
    },
    extendedDialogCommentLabel: {
        id: 'fabric.elements.share.form.extended.dialog.comment.label',
        defaultMessage: 'Message',
        description: 'Label for the comment field in the extended share dialog.'
    },
    commentPlaceholder: {
        id: 'fabric.elements.share.form.comment.placeholder',
        defaultMessage: 'Anything they should know?',
        description: 'Placeholder for the comment field in Share form.'
    },
    // Email disabled (Jira)
    userPickerLabelEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.label.email-disabled-jira',
        defaultMessage: 'Names or teams',
        description: 'Label for the user picker field in the Share form in Jira with no email option.'
    },
    userPickerPlaceholderEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira',
        defaultMessage: 'e.g. Maria, Team Orange',
        description: 'Placeholder for the user picker field in the Share form in Jira with no email option. These examples should be localized.'
    },
    userPickerRequiredMessageEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira',
        defaultMessage: 'Select at least one person or team',
        description: 'Error message for the user picker field in the Share form in Jira with no email option, when no entries are selected.'
    },
    // Email disabled (Confluence)
    userPickerLabelEmailDisabledConfluence: {
        id: 'fabric.elements.share.form.user-picker.label.email-disabled-confluence',
        defaultMessage: 'Names, teams, or groups',
        description: 'Label for the user picker field in the Share form in Confluence with no email option.'
    },
    userPickerRequiredMessageEmailDisabledConfluence: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence',
        defaultMessage: 'Select at least one person, team, or group',
        description: 'Error message for the user picker field in the Share form in Confluence with no email option, when no entries are selected.'
    },
    // Browse users disabled
    userPickerLabelBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.label.email-only',
        defaultMessage: 'Emails',
        description: 'Label for the user picker field in the Share form when browse user permissions are disabled.'
    },
    userPickerPlaceholderBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.placeholder.email-only',
        defaultMessage: 'e.g. maria@company.com',
        description: 'Placeholder for the user picker field in the Share form when browse user permissions are disabled. These examples should be localized.'
    },
    userPickerRequiredMessageBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-only',
        defaultMessage: 'Select at least one email',
        description: 'Error message for the user picker field in the Share form in when browse user permissions are disabled, when no entries are selected.'
    },
    // Generic (Jira)
    userPickerLabelJira: {
        id: 'fabric.elements.share.form.user-picker.label.jira',
        defaultMessage: 'Names, teams, or emails',
        description: 'Label for the user picker field in the Share form in Jira.'
    },
    userPickerPlaceholderJira: {
        id: 'fabric.elements.share.form.user-picker.placeholder.jira',
        defaultMessage: 'e.g. Maria, Team Orange, maria@company.com',
        description: 'Placeholder for the user picker field in the Share form in Jira. These examples should be localized.'
    },
    userPickerRequiredMessageJira: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.jira',
        defaultMessage: 'Select at least one person, team, or email',
        description: 'Error message for the user picker field in the Share form in Jira, when no entries are selected.'
    },
    // Generic (Confluence)
    userPickerLabelConfluence: {
        id: 'fabric.elements.share.form.user-picker.label.confluence',
        defaultMessage: 'Names, teams, groups, or emails',
        description: 'Label for the user picker field in the Share form in Confluence.'
    },
    userPickerPlaceholderConfluence: {
        id: 'fabric.elements.share.form.user-picker.placeholder.confluence',
        defaultMessage: 'e.g. Maria, Team Orange, group-one',
        description: 'Placeholder for the user picker field in the Share form in Confluence. These examples should be localized.'
    },
    userPickerRequiredMessageConfluence: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.confluence',
        defaultMessage: 'Select at least one person, team, group, or email',
        description: 'Error message for the user picker field in the Share form in Confluence, when no entries are selected.'
    },
    // Common messages
    userPickerAddMoreMessage: {
        id: 'fabric.elements.share.form.user-picker.add-more',
        defaultMessage: 'Enter more',
        description: 'Message to encourage the user to add more items to user picker in Share form.'
    },
    userPickerRequiredMessage: {
        id: 'fabric.elements.share.form.user-picker.validation.required',
        defaultMessage: 'Select at least one user, group, team or email.',
        description: 'Required error message for the user picker field in Share form.'
    },
    userPickerExistingUserOnlyNoOptionsMessage: {
        id: 'fabric.elements.share.form.user-picker.no-options.existingUserOnly',
        defaultMessage: `We couldn\u{2019}t find any results for "{inputValue}".`,
        description: 'Existing user only no options message displayed when the search for users returns empty.'
    },
    userPickerGenericNoOptionsMessage: {
        id: 'fabric.elements.share.form.user-picker.no-options.generic',
        defaultMessage: `We couldn\u{2019}t find any results for "{inputValue}". Invite people by using an email address.`,
        description: 'Generic no options message displayed when the search for users returns empty.'
    },
    shareTriggerButtonIconLabel: {
        id: 'fabric.elements.share.trigger.button.icon.label',
        defaultMessage: 'Share icon',
        description: 'Default text for aria-label of the share dialog trigger button icon'
    },
    shareTriggerButtonText: {
        id: 'fabric.elements.share.trigger.button.text',
        defaultMessage: 'Share',
        description: 'Default text for the share dialog trigger button'
    },
    shareTriggerButtonTooltipText: {
        id: 'fabric.elements.share.trigger.button.tooltip.text',
        defaultMessage: 'Share',
        description: 'Default text for tooltip on the icon-only share dialog trigger button'
    },
    inviteTriggerButtonText: {
        id: 'fabric.elements.share.trigger.button.invite.text',
        defaultMessage: 'Invite',
        description: 'Button label for when the sharee action is set to "edit".'
    },
    copyLinkButtonText: {
        id: 'fabric.elements.share.copylink.button.text',
        defaultMessage: 'Copy link',
        description: 'Default text for the Copy Link button'
    },
    copyPublicLinkButtonText: {
        id: 'fabric.elements.share.copypubliclink.button.text',
        defaultMessage: 'Copy public link',
        description: 'Default text for the Copy Link button when the link is public'
    },
    copiedToClipboardMessage: {
        id: 'fabric.elements.share.copied.to.clipboard.message',
        defaultMessage: 'Link copied to clipboard',
        description: 'Default text for the copied link message'
    },
    infoMessageDefaultConfluence: {
        id: 'fabric.elements.share.form.info.message.no.invite.confluence',
        defaultMessage: 'Recipients will see the name of the page and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Confluence page title and the included message'
    },
    infoMessageDefaultJira: {
        id: 'fabric.elements.share.form.info.message.no.invite.jira',
        defaultMessage: 'Recipients will see the name of the issue and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Jira issue title and the included message'
    },
    infoMessageDefaultJiraIssueTermRefresh: {
        id: 'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh',
        defaultMessage: 'Recipients will see the name of the work item and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Jira issue title and the included message'
    },
    requiredFieldSummary: {
        id: 'fabric.elements.share.form.required-field.summary',
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Summary info of required fields asterisk.'
    },
    shareFailureIconLabel: {
        id: 'fabric.elements.share.failure.icon.label',
        defaultMessage: 'Error icon',
        description: 'Default text for the aria-label of the share failure error icon in the tooltip'
    },
    shareFailureMessage: {
        id: 'fabric.elements.share.failure.message',
        defaultMessage: 'Unable to share',
        description: 'Default text for share failure message displayed in the tooltip'
    },
    shareSuccessMessage: {
        id: 'fabric.elements.share.success.message',
        defaultMessage: "{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}",
        description: 'Default text for share success message displayed in a flag'
    },
    shareToIntegrationButtonText: {
        id: 'fabric.elements.share.to.integration.button',
        defaultMessage: 'Share to {integrationName}',
        description: 'Text for the button that allows the user to share the currently viewed item through a 3rd party app like Slack'
    },
    shareInIntegrationButtonText: {
        id: 'fabric.elements.share.in.integration.button',
        defaultMessage: 'Share in {integrationName}',
        description: 'Text for the button that allows the user to share the currently viewed item through a 3rd party app like Slack'
    },
    shareMainTabTextJira: {
        id: 'fabric.elements.share.main.tab.text.jira',
        defaultMessage: 'Share issue',
        description: 'Text for the main share tab for jira'
    },
    shareMainTabTextConfluence: {
        id: 'fabric.elements.share.main.tab.text.confluence',
        defaultMessage: 'Share page',
        description: 'Text for the main share tab for confluence'
    },
    inviteToConfluence: {
        id: 'fabric.elements.share.invite.to.confluence',
        defaultMessage: 'Invite to Confluence',
        description: 'Text for the byline of the non-licensed users'
    },
    inviteToJira: {
        id: 'fabric.elements.share.invite.to.jira',
        defaultMessage: 'Invite to Jira',
        description: 'Text for the byline of the non-licensed users'
    },
    sharePopupLabel: {
        id: 'fabric.elements.share.popup.label',
        defaultMessage: 'Share',
        description: 'Label of the popup that contains share menu used by assistive technologies'
    },
    slackMenuItemText: {
        id: 'fabric.elements.share.menu.slack.label',
        defaultMessage: 'Slack',
        description: 'Text for the slack menu in share'
    },
    emailMenuItemText: {
        id: 'fabric.elements.share.menu.email.label',
        defaultMessage: 'Email',
        description: 'Text for the email menu in share'
    }
});

});

parcelRegister("b2oBK", function(module, exports) {

$parcel$export(module.exports, "CHANNEL_ID", () => $5f90f772f4877396$export$e5fd2b76433ec8a8);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $5f90f772f4877396$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "INTEGRATION_MODAL_SOURCE", () => $5f90f772f4877396$export$8944b0a832f27e18);
$parcel$export(module.exports, "screenEvent", () => $5f90f772f4877396$export$a129deea0412e0d8);
$parcel$export(module.exports, "shareSplitButtonEvent", () => $5f90f772f4877396$export$eab30ffadcd0ab75);
$parcel$export(module.exports, "shareIntegrationButtonEvent", () => $5f90f772f4877396$export$f04d85d45801fef1);
$parcel$export(module.exports, "errorEncountered", () => $5f90f772f4877396$export$afe83ea4a1997503);
$parcel$export(module.exports, "shareTriggerButtonClicked", () => $5f90f772f4877396$export$584e8ee8b04ff145);
$parcel$export(module.exports, "shareTabClicked", () => $5f90f772f4877396$export$544b588ba577a9a6);
$parcel$export(module.exports, "shareMenuItemClicked", () => $5f90f772f4877396$export$69ab8fd7ab99f6db);
$parcel$export(module.exports, "cancelShare", () => $5f90f772f4877396$export$b4731c87331a8174);
$parcel$export(module.exports, "shortUrlRequested", () => $5f90f772f4877396$export$35781a2d50f9fba9);
$parcel$export(module.exports, "shortUrlGenerated", () => $5f90f772f4877396$export$e78d65558f8d859a);
$parcel$export(module.exports, "copyLinkButtonClicked", () => $5f90f772f4877396$export$9af471d00b79f9b0);
$parcel$export(module.exports, "formShareSubmitted", () => $5f90f772f4877396$export$e2e6cacbe383cb80);

var $3smIt = parcelRequire("3smIt");
const $5f90f772f4877396$var$buildAttributes = (attributes = {})=>({
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        ...attributes
    });
const $5f90f772f4877396$var$createEvent = (eventType, source, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        source: source,
        attributes: $5f90f772f4877396$var$buildAttributes(attributes)
    });
const $5f90f772f4877396$var$createScreenEvent = (name, attributes = {})=>({
        eventType: 'screen',
        name: name,
        attributes: $5f90f772f4877396$var$buildAttributes(attributes)
    });
const $5f90f772f4877396$export$e5fd2b76433ec8a8 = 'fabric-elements';
const $5f90f772f4877396$export$f7109619a5e9e0d6 = 'shareModal';
const $5f90f772f4877396$export$8944b0a832f27e18 = 'integrationShareDialog';
const $5f90f772f4877396$export$a129deea0412e0d8 = ({ isPublicLink: isPublicLink = false })=>$5f90f772f4877396$var$createScreenEvent($5f90f772f4877396$export$f7109619a5e9e0d6, {
        isPublicLink: isPublicLink
    });
const $5f90f772f4877396$export$eab30ffadcd0ab75 = ()=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$8944b0a832f27e18, 'clicked', 'button', 'shareSplitButton');
const $5f90f772f4877396$export$f04d85d45801fef1 = (type = '')=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$8944b0a832f27e18, 'clicked', 'button', 'shareToIntegration', {
        integrationType: type.toLowerCase()
    });
const $5f90f772f4877396$export$afe83ea4a1997503 = (actionSubjectId, attributes = {})=>$5f90f772f4877396$var$createEvent('operational', $5f90f772f4877396$export$f7109619a5e9e0d6, 'encountered', 'error', actionSubjectId, {
        ...attributes,
        source: $5f90f772f4877396$export$f7109619a5e9e0d6
    });
const $5f90f772f4877396$export$584e8ee8b04ff145 = ()=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'button', 'share');
const $5f90f772f4877396$export$544b588ba577a9a6 = (subjectId, shareContentType)=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'tab', subjectId || 'shareTab', {
        shareContentType: shareContentType
    });
const $5f90f772f4877396$export$69ab8fd7ab99f6db = (subjectId, shareContentType)=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'menuItem', subjectId || 'shareMenuItem', {
        shareContentType: shareContentType
    });
const $5f90f772f4877396$export$b4731c87331a8174 = (start)=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'pressed', 'keyboardShortcut', 'cancelShare', {
        source: $5f90f772f4877396$export$f7109619a5e9e0d6,
        duration: $5f90f772f4877396$var$duration(start)
    });
const $5f90f772f4877396$export$35781a2d50f9fba9 = ()=>$5f90f772f4877396$var$createEvent('operational', $5f90f772f4877396$export$f7109619a5e9e0d6, 'requested', 'shortUrl', undefined, {
        source: $5f90f772f4877396$export$f7109619a5e9e0d6
    });
const $5f90f772f4877396$export$e78d65558f8d859a = (start, tooSlow)=>$5f90f772f4877396$var$createEvent('operational', $5f90f772f4877396$export$f7109619a5e9e0d6, 'generated', 'shortUrl', undefined, {
        source: $5f90f772f4877396$export$f7109619a5e9e0d6,
        duration: $5f90f772f4877396$var$duration(start),
        tooSlow: tooSlow
    });
const $5f90f772f4877396$export$9af471d00b79f9b0 = ({ start: start, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false, ari: ari })=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'button', 'copyShareLink', {
        source: $5f90f772f4877396$export$f7109619a5e9e0d6,
        duration: $5f90f772f4877396$var$duration(start),
        shortUrl: undefined,
        // unknown at creation, will be filled later
        contentType: shareContentType,
        contentSubType: shareContentSubType,
        contentId: shareContentId,
        isPublicLink: isPublicLink,
        ari: ari,
        // this specific string is needed for marking a successful navigation session
        navdexPointType: 'navigationSessionEnd',
        ...$5f90f772f4877396$var$getOriginTracingAttributes(shareOrigin)
    });
const $5f90f772f4877396$export$e2e6cacbe383cb80 = ({ start: start, data: data, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false })=>{
    const users = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isUser));
    const externalUsers = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isExternalUser));
    const groups = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isGroup));
    const teams = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isTeam));
    const teamUserCounts = $5f90f772f4877396$var$extractMemberCountsFromTeams(data, (0, $3smIt.isTeam));
    const emails = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isEmail));
    return $5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'button', 'submitShare', {
        ...$5f90f772f4877396$var$getOriginTracingAttributes(shareOrigin),
        contentType: shareContentType,
        contentSubType: shareContentSubType,
        contentId: shareContentId,
        duration: $5f90f772f4877396$var$duration(start),
        emailCount: emails.length,
        teamCount: teams.length,
        userCount: users.length,
        groupCount: groups.length,
        externalUserCount: externalUsers.length,
        users: users,
        teams: teams,
        teamUserCounts: teamUserCounts,
        groups: groups,
        messageLength: data.comment && data.comment.format === 'plain_text' ? data.comment.value.length : 0,
        isMessageEnabled: true,
        isPublicLink: isPublicLink
    });
};
const $5f90f772f4877396$var$duration = (start)=>Date.now() - start;
const $5f90f772f4877396$var$getOriginTracingAttributes = (origin)=>origin ? origin.toAnalyticsAttributes({
        hasGeneratedId: true
    }) : {};
const $5f90f772f4877396$var$extractIdsByType = (data, checker)=>data.users.filter(checker).map((option)=>option.id);
const $5f90f772f4877396$var$extractMemberCountsFromTeams = (data, checker)=>// teams with zero memberships cannot exist in share, so we use that
    // as the default value for undefined team member counts
    data.users.filter(checker).map((option)=>option.memberCount || 0);

});
parcelRegister("3smIt", function(module, exports) {

$parcel$export(module.exports, "isExternalUser", () => $02015d62698c11ec$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $02015d62698c11ec$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $02015d62698c11ec$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $02015d62698c11ec$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $02015d62698c11ec$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $02015d62698c11ec$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $02015d62698c11ec$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $02015d62698c11ec$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $02015d62698c11ec$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $02015d62698c11ec$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $02015d62698c11ec$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $02015d62698c11ec$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $02015d62698c11ec$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $02015d62698c11ec$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $02015d62698c11ec$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $02015d62698c11ec$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $02015d62698c11ec$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $02015d62698c11ec$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $02015d62698c11ec$export$5419897287f5f1c7);

var $8QpSo = parcelRequire("8QpSo");


var $b9dFI = parcelRequire("b9dFI");
const $02015d62698c11ec$export$f6058dbcb5980cb = (option)=>option.type === (0, $f93312f7d4958f08$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $02015d62698c11ec$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $f93312f7d4958f08$export$8436e53e45ffe15b);
const $02015d62698c11ec$export$f8c4277cb588611f = (option)=>option.type === (0, $f93312f7d4958f08$export$26bc40b960693765);
const $02015d62698c11ec$export$d7976824e9f55785 = (option)=>option.type === (0, $f93312f7d4958f08$export$d460f747b73abb10);
const $02015d62698c11ec$export$7fbbfbca30081d0 = (option)=>option.type === (0, $f93312f7d4958f08$export$6662b3461398ef8c);
const $02015d62698c11ec$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $f93312f7d4958f08$export$eafd0979afa5b224);
const $02015d62698c11ec$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $02015d62698c11ec$var$isOptionData = (option)=>option.name !== undefined;
const $02015d62698c11ec$export$3f993c492bd6c728 = (option)=>{
    if ($02015d62698c11ec$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $02015d62698c11ec$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $02015d62698c11ec$export$9652023d9040757 = (a)=>typeof a?.[Symbol.iterator] === 'function';
const $02015d62698c11ec$export$d2312e68e1f5ad00 = (0, $8QpSo.default)((options)=>options.map($02015d62698c11ec$export$3f993c492bd6c728));
const $02015d62698c11ec$export$e6fda14a194bcbcc = (0, $8QpSo.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($02015d62698c11ec$export$3f993c492bd6c728);
    return $02015d62698c11ec$export$3f993c492bd6c728(defaultValue);
});
const $02015d62698c11ec$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $02015d62698c11ec$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $02015d62698c11ec$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $02015d62698c11ec$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $02015d62698c11ec$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
};
const $02015d62698c11ec$export$b4f8f1f54acec99b = (optionData)=>{
    if ($02015d62698c11ec$export$2e44165f1da65304(optionData) || $02015d62698c11ec$export$f8c4277cb588611f(optionData) || $02015d62698c11ec$export$d3a8f0b77e9737fc(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $02015d62698c11ec$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $b9dFI.default);
const $02015d62698c11ec$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $02015d62698c11ec$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};

});
const $f93312f7d4958f08$export$8436e53e45ffe15b = 'user';
const $f93312f7d4958f08$export$50042ec1d2e00e63 = 'external_user';
const $f93312f7d4958f08$export$26bc40b960693765 = 'team';
const $f93312f7d4958f08$export$d460f747b73abb10 = 'group';
const $f93312f7d4958f08$export$6662b3461398ef8c = 'email';
const $f93312f7d4958f08$export$eafd0979afa5b224 = 'custom';

parcelRegister("b9dFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $768d8504b373d7ff$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $ao4Ml = parcelRequire("ao4Ml");

var $5n5w4 = parcelRequire("5n5w4");
var $283js = parcelRequire("283js");
var $iGDLS = parcelRequire("iGDLS");

var $4wJSY = parcelRequire("4wJSY");

var $9KnKW = parcelRequire("9KnKW");

var $7VXAu = parcelRequire("7VXAu");


var $7K5PP = parcelRequire("7K5PP");

var $hT6ku = parcelRequire("hT6ku");

var $9DWu0 = parcelRequire("9DWu0");
/**
 * Are we rendering on the client or server?
 */ const $768d8504b373d7ff$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $768d8504b373d7ff$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $768d8504b373d7ff$var$defaultPopperProps = {
    modifiers: $768d8504b373d7ff$var$modifiers,
    placement: 'bottom-start'
};
const $768d8504b373d7ff$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $768d8504b373d7ff$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$768d8504b373d7ff$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $hT6ku.defaultComponents),
            ...props.components
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$768d8504b373d7ff$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $cBeZP.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5n5w4.Manager), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9KnKW.IdProvider), {
                    postfix: "-popup-select",
                    children: ({ id: id })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iGDLS.Reference), {
                                    children: ({ ref: ref })=>target && target({
                                            isOpen: isOpen,
                                            onKeyDown: this.handleTargetKeyDown,
                                            ref: this.resolveTargetRef(ref),
                                            // Should technically be 'dialog' by default instead of 'true' via AriaAttributes, but will require further changes.
                                            // See go/DSP-22283
                                            'aria-haspopup': 'true',
                                            'aria-expanded': isOpen,
                                            'aria-controls': isOpen ? id : undefined
                                        })
                                }),
                                this.renderSelect(id)
                            ]
                        })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9DWu0.NotifyOpenLayerObserver), {
                    isOpen: this.state.isOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$eaa8c8a70ac22806})`
                })
        }, this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $hT6ku.defaultComponents),
            mergedPopperProps: $768d8504b373d7ff$var$defaultPopperProps
        }, // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        }, this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        }, this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        }, this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        }, this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        }, // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $cBeZP.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        }, /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }, // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            }, this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        }, // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        }, this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        }, // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        }, // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $768d8504b373d7ff$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $hT6ku.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const popper = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $283js.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                },
                children: ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hT6ku.MenuDialog), {
                        // There is not a limited amount of values for the widths, so they need to remain dynamic.
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            ...style,
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        },
                        "data-placement": placement,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref),
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ao4Ml.default), {
                            disabled: !focusLockEnabled,
                            returnFocus: true,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                                    label: getLabel(),
                                    backspaceRemovesValue: false,
                                    controlShouldRenderValue: false,
                                    isClearable: false,
                                    tabSelectsValue: false,
                                    menuIsOpen: true,
                                    placeholder: placeholder,
                                    ref: this.getSelectRef,
                                    ...props,
                                    isSearchable: showSearchControl,
                                    styles: (0, $7VXAu.mergeStyles)(this.defaultStyles, props.styles || {}),
                                    maxMenuHeight: this.getMaxHeight(),
                                    components: selectComponents,
                                    onChange: this.handleSelectChange,
                                    testId: testId
                                }),
                                footer
                            ]
                        })
                    })
            });
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $7nsd3.createPortal)(popper, portalDestination);
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.close();
        };
    }
}

});
parcelRegister("5n5w4", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $3e93612641040812$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $3e93612641040812$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $3e93612641040812$export$d0d38e7dec7a1a61);

var $5uXOq = parcelRequire("5uXOq");
var $3e93612641040812$export$3dbd3405086fec7b = $5uXOq.createContext();
var $3e93612641040812$export$cbabb21c2529b130 = $5uXOq.createContext();
function $3e93612641040812$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $5uXOq.useRef(false);
    $5uXOq.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $5uXOq.createElement($3e93612641040812$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $5uXOq.createElement($3e93612641040812$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("283js", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $18cee5f949ac4034$export$badac9ada3a0bdf9);

var $5uXOq = parcelRequire("5uXOq");

var $5n5w4 = parcelRequire("5n5w4");

var $eclLw = parcelRequire("eclLw");

var $fNOWl = parcelRequire("fNOWl");
var $18cee5f949ac4034$var$NOOP = function NOOP() {
    return void 0;
};
var $18cee5f949ac4034$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $18cee5f949ac4034$var$EMPTY_MODIFIERS = [];
function $18cee5f949ac4034$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $18cee5f949ac4034$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $5uXOq.useContext((0, $5n5w4.ManagerReferenceNodeContext));
    var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $5uXOq.useEffect(function() {
        (0, $eclLw.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $5uXOq.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $fNOWl.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $5uXOq.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $18cee5f949ac4034$var$NOOP,
            update: update || $18cee5f949ac4034$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $eclLw.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("eclLw", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $a56311d537d20f47$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $a56311d537d20f47$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $a56311d537d20f47$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $a56311d537d20f47$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $a56311d537d20f47$export$700979bc83e7db82);

var $5uXOq = parcelRequire("5uXOq");
var $a56311d537d20f47$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $a56311d537d20f47$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $a56311d537d20f47$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $a56311d537d20f47$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $a56311d537d20f47$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $a56311d537d20f47$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;

});

parcelRegister("fNOWl", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $b812f23d0bbb9e85$export$f4d5bf230a36dd6e);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $8Pv9O = parcelRequire("8Pv9O");

var $lHrkK = parcelRequire("lHrkK");

var $eclLw = parcelRequire("eclLw");
var $b812f23d0bbb9e85$var$EMPTY_MODIFIERS = [];
var $b812f23d0bbb9e85$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $5uXOq.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $b812f23d0bbb9e85$var$EMPTY_MODIFIERS
    };
    var _React$useState = $5uXOq.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $5uXOq.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $7nsd3.flushSync(function() {
                    setState({
                        styles: (0, $eclLw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $eclLw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $5uXOq.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $5uXOq.useRef();
    (0, $eclLw.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $eclLw.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $8Pv9O.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("8Pv9O", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $66db415bc009fd50$export$8f7491d57c8f97a9);

var $dsn8Y = parcelRequire("dsn8Y");

var $4TVC8 = parcelRequire("4TVC8");

var $j8nKB = parcelRequire("j8nKB");

var $baic6 = parcelRequire("baic6");

var $1AoLg = parcelRequire("1AoLg");

var $gy4Xr = parcelRequire("gy4Xr");

var $3dDWl = parcelRequire("3dDWl");

var $1DdSC = parcelRequire("1DdSC");

var $gzAfz = parcelRequire("gzAfz");

var $6iLAT = parcelRequire("6iLAT");


var $66db415bc009fd50$export$d34966752335dd47 = [
    (0, $4TVC8.default),
    (0, $j8nKB.default),
    (0, $baic6.default),
    (0, $1AoLg.default),
    (0, $gy4Xr.default),
    (0, $3dDWl.default),
    (0, $1DdSC.default),
    (0, $gzAfz.default),
    (0, $6iLAT.default)
];
var $66db415bc009fd50$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $dsn8Y.popperGenerator)({
    defaultModifiers: $66db415bc009fd50$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("dsn8Y", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $9cbfd7bdb6a4f3f1$export$ed5e13716264f202);

var $gvlia = parcelRequire("gvlia");

var $jkGDj = parcelRequire("jkGDj");

var $2r6BH = parcelRequire("2r6BH");

var $gbHJy = parcelRequire("gbHJy");

var $kcmIg = parcelRequire("kcmIg");

var $a8clb = parcelRequire("a8clb");

var $i9xH7 = parcelRequire("i9xH7");


var $gmkfg = parcelRequire("gmkfg");
var $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $9cbfd7bdb6a4f3f1$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $gmkfg.isElement)(reference) ? (0, $2r6BH.default)(reference) : reference.contextElement ? (0, $2r6BH.default)(reference.contextElement) : [],
                    popper: (0, $2r6BH.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $kcmIg.default)((0, $i9xH7.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gvlia.default)(reference, (0, $gbHJy.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $jkGDj.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $a8clb.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $9cbfd7bdb6a4f3f1$export$8f7491d57c8f97a9 = /*#__PURE__*/ $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gvlia", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0400ebb908e52cb$export$2e2bcd8739ae039);

var $g2O7Z = parcelRequire("g2O7Z");

var $9FFjG = parcelRequire("9FFjG");

var $f5IBt = parcelRequire("f5IBt");

var $gmkfg = parcelRequire("gmkfg");

var $imzt5 = parcelRequire("imzt5");

var $eVELE = parcelRequire("eVELE");

var $c6EdA = parcelRequire("c6EdA");

var $90xPK = parcelRequire("90xPK");
function $c0400ebb908e52cb$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $90xPK.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $90xPK.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $c0400ebb908e52cb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $gmkfg.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $gmkfg.isHTMLElement)(offsetParent) && $c0400ebb908e52cb$var$isElementScaled(offsetParent);
    var documentElement = (0, $eVELE.default)(offsetParent);
    var rect = (0, $g2O7Z.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f5IBt.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $c6EdA.default)(documentElement)) scroll = (0, $9FFjG.default)(offsetParent);
        if ((0, $gmkfg.isHTMLElement)(offsetParent)) {
            offsets = (0, $g2O7Z.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $imzt5.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("g2O7Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $bae3b796a534b2cf$export$2e2bcd8739ae039);

var $gmkfg = parcelRequire("gmkfg");

var $90xPK = parcelRequire("90xPK");

var $1Prpe = parcelRequire("1Prpe");

var $d8bsQ = parcelRequire("d8bsQ");
function $bae3b796a534b2cf$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $gmkfg.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $90xPK.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $90xPK.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $gmkfg.isElement)(element) ? (0, $1Prpe.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $d8bsQ.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("gmkfg", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $be8e67adfa808002$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $be8e67adfa808002$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $be8e67adfa808002$export$af51f0f06c0f328a);

var $1Prpe = parcelRequire("1Prpe");
function $be8e67adfa808002$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $1Prpe.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $be8e67adfa808002$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $1Prpe.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $be8e67adfa808002$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $1Prpe.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("1Prpe", function(module, exports) {

$parcel$export(module.exports, "default", () => $154fd01b154b825f$export$2e2bcd8739ae039);
function $154fd01b154b825f$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("90xPK", function(module, exports) {

$parcel$export(module.exports, "max", () => $68ee5bce69e9df7e$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $68ee5bce69e9df7e$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $68ee5bce69e9df7e$export$2077e0241d6afd3c);
var $68ee5bce69e9df7e$export$8960430cfd85939f = Math.max;
var $68ee5bce69e9df7e$export$96ec731ed4dcb222 = Math.min;
var $68ee5bce69e9df7e$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("d8bsQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $98f4ea48bb7f7060$export$2e2bcd8739ae039);

var $j5Xhq = parcelRequire("j5Xhq");
function $98f4ea48bb7f7060$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $j5Xhq.default)());
}

});
parcelRegister("j5Xhq", function(module, exports) {

$parcel$export(module.exports, "default", () => $de6c77c242bcf4cf$export$2e2bcd8739ae039);
function $de6c77c242bcf4cf$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("9FFjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $70a7fdf85bb2e8b8$export$2e2bcd8739ae039);

var $8YTLN = parcelRequire("8YTLN");

var $1Prpe = parcelRequire("1Prpe");

var $gmkfg = parcelRequire("gmkfg");

var $i1ad3 = parcelRequire("i1ad3");
function $70a7fdf85bb2e8b8$export$2e2bcd8739ae039(node) {
    if (node === (0, $1Prpe.default)(node) || !(0, $gmkfg.isHTMLElement)(node)) return (0, $8YTLN.default)(node);
    else return (0, $i1ad3.default)(node);
}

});
parcelRegister("8YTLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $689f300ec0defb42$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");
function $689f300ec0defb42$export$2e2bcd8739ae039(node) {
    var win = (0, $1Prpe.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("i1ad3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1e03d69dfb9832f$export$2e2bcd8739ae039);
function $d1e03d69dfb9832f$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("f5IBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $afc9ebf0aa1487e4$export$2e2bcd8739ae039);
function $afc9ebf0aa1487e4$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("imzt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5e5cb506db8cdcb$export$2e2bcd8739ae039);

var $g2O7Z = parcelRequire("g2O7Z");

var $eVELE = parcelRequire("eVELE");

var $8YTLN = parcelRequire("8YTLN");
function $d5e5cb506db8cdcb$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $g2O7Z.default)((0, $eVELE.default)(element)).left + (0, $8YTLN.default)(element).scrollLeft;
}

});
parcelRegister("eVELE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ade6032ba4b824fe$export$2e2bcd8739ae039);

var $gmkfg = parcelRequire("gmkfg");
function $ade6032ba4b824fe$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $gmkfg.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("c6EdA", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d053e13cecc73ee$export$2e2bcd8739ae039);

var $1ix2F = parcelRequire("1ix2F");
function $8d053e13cecc73ee$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $1ix2F.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("1ix2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f211a5db2cb1d1b$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");
function $0f211a5db2cb1d1b$export$2e2bcd8739ae039(element) {
    return (0, $1Prpe.default)(element).getComputedStyle(element);
}

});



parcelRegister("jkGDj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e130f49f6e9ebcb4$export$2e2bcd8739ae039);

var $g2O7Z = parcelRequire("g2O7Z");
function $e130f49f6e9ebcb4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $g2O7Z.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("2r6BH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c633a6ac170841a$export$2e2bcd8739ae039);

var $k82dT = parcelRequire("k82dT");

var $eTUzl = parcelRequire("eTUzl");

var $1Prpe = parcelRequire("1Prpe");

var $c6EdA = parcelRequire("c6EdA");
function $1c633a6ac170841a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $k82dT.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $1Prpe.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $c6EdA.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($1c633a6ac170841a$export$2e2bcd8739ae039((0, $eTUzl.default)(target)));
}

});
parcelRegister("k82dT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea7647704a508683$export$2e2bcd8739ae039);

var $eTUzl = parcelRequire("eTUzl");

var $c6EdA = parcelRequire("c6EdA");

var $f5IBt = parcelRequire("f5IBt");

var $gmkfg = parcelRequire("gmkfg");
function $ea7647704a508683$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $f5IBt.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $gmkfg.isHTMLElement)(node) && (0, $c6EdA.default)(node)) return node;
    return $ea7647704a508683$export$2e2bcd8739ae039((0, $eTUzl.default)(node));
}

});
parcelRegister("eTUzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad921528f26834dd$export$2e2bcd8739ae039);

var $f5IBt = parcelRequire("f5IBt");

var $eVELE = parcelRequire("eVELE");

var $gmkfg = parcelRequire("gmkfg");
function $ad921528f26834dd$export$2e2bcd8739ae039(element) {
    if ((0, $f5IBt.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $gmkfg.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $eVELE.default)(element) // fallback
    );
}

});



parcelRegister("gbHJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8f9908a1e4106f$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");

var $f5IBt = parcelRequire("f5IBt");

var $1ix2F = parcelRequire("1ix2F");

var $gmkfg = parcelRequire("gmkfg");

var $6hs9X = parcelRequire("6hs9X");

var $eTUzl = parcelRequire("eTUzl");

var $j5Xhq = parcelRequire("j5Xhq");
function $bc8f9908a1e4106f$var$getTrueOffsetParent(element) {
    if (!(0, $gmkfg.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $1ix2F.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $bc8f9908a1e4106f$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $j5Xhq.default)());
    var isIE = /Trident/i.test((0, $j5Xhq.default)());
    if (isIE && (0, $gmkfg.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $1ix2F.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $eTUzl.default)(element);
    if ((0, $gmkfg.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $gmkfg.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $f5IBt.default)(currentNode)) < 0){
        var css = (0, $1ix2F.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $bc8f9908a1e4106f$export$2e2bcd8739ae039(element) {
    var window = (0, $1Prpe.default)(element);
    var offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6hs9X.default)(offsetParent) && (0, $1ix2F.default)(offsetParent).position === 'static')offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $f5IBt.default)(offsetParent) === 'html' || (0, $f5IBt.default)(offsetParent) === 'body' && (0, $1ix2F.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $bc8f9908a1e4106f$var$getContainingBlock(element) || window;
}

});
parcelRegister("6hs9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $492a2c861940c94d$export$2e2bcd8739ae039);

var $f5IBt = parcelRequire("f5IBt");
function $492a2c861940c94d$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $f5IBt.default)(element)) >= 0;
}

});


parcelRegister("kcmIg", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb468bf0752088cc$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");
function $eb468bf0752088cc$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $eb468bf0752088cc$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $eb468bf0752088cc$var$order(modifiers); // order based on phase
    return (0, $kJPed.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("kJPed", function(module, exports) {

$parcel$export(module.exports, "top", () => $f18fbf7b212a7c8e$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $f18fbf7b212a7c8e$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $f18fbf7b212a7c8e$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $f18fbf7b212a7c8e$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $f18fbf7b212a7c8e$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $f18fbf7b212a7c8e$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $f18fbf7b212a7c8e$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $f18fbf7b212a7c8e$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $f18fbf7b212a7c8e$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $f18fbf7b212a7c8e$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $f18fbf7b212a7c8e$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $f18fbf7b212a7c8e$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $f18fbf7b212a7c8e$export$d087d3878fdf71d5);
var $f18fbf7b212a7c8e$export$1e95b668f3b82d = 'top';
var $f18fbf7b212a7c8e$export$40e543e69a8b3fbb = 'bottom';
var $f18fbf7b212a7c8e$export$79ffe56a765070d2 = 'right';
var $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4 = 'left';
var $f18fbf7b212a7c8e$export$dfb5619354ba860 = 'auto';
var $f18fbf7b212a7c8e$export$aec2ce47c367b8c3 = [
    $f18fbf7b212a7c8e$export$1e95b668f3b82d,
    $f18fbf7b212a7c8e$export$40e543e69a8b3fbb,
    $f18fbf7b212a7c8e$export$79ffe56a765070d2,
    $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4
];
var $f18fbf7b212a7c8e$export$b3571188c770cc5a = 'start';
var $f18fbf7b212a7c8e$export$bd5df0f255a350f8 = 'end';
var $f18fbf7b212a7c8e$export$390fd549c5303b4d = 'clippingParents';
var $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f = 'viewport';
var $f18fbf7b212a7c8e$export$ae5ab1c730825774 = 'popper';
var $f18fbf7b212a7c8e$export$ca50aac9f3ba507f = 'reference';
var $f18fbf7b212a7c8e$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f18fbf7b212a7c8e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
        placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
    ]);
}, []);
var $f18fbf7b212a7c8e$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f18fbf7b212a7c8e$export$aec2ce47c367b8c3, [
    $f18fbf7b212a7c8e$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
        placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f18fbf7b212a7c8e$export$421679a7c3d56e = 'beforeRead';
var $f18fbf7b212a7c8e$export$aafa59e2e03f2942 = 'read';
var $f18fbf7b212a7c8e$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $f18fbf7b212a7c8e$export$c65e99957a05207c = 'beforeMain';
var $f18fbf7b212a7c8e$export$f22da7240b7add18 = 'main';
var $f18fbf7b212a7c8e$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f18fbf7b212a7c8e$export$8d4d2d70e7d46032 = 'beforeWrite';
var $f18fbf7b212a7c8e$export$68d8715fc104d294 = 'write';
var $f18fbf7b212a7c8e$export$70a6e5159acce2e6 = 'afterWrite';
var $f18fbf7b212a7c8e$export$d087d3878fdf71d5 = [
    $f18fbf7b212a7c8e$export$421679a7c3d56e,
    $f18fbf7b212a7c8e$export$aafa59e2e03f2942,
    $f18fbf7b212a7c8e$export$6964f6c886723980,
    $f18fbf7b212a7c8e$export$c65e99957a05207c,
    $f18fbf7b212a7c8e$export$f22da7240b7add18,
    $f18fbf7b212a7c8e$export$bab79516f2d662fe,
    $f18fbf7b212a7c8e$export$8d4d2d70e7d46032,
    $f18fbf7b212a7c8e$export$68d8715fc104d294,
    $f18fbf7b212a7c8e$export$70a6e5159acce2e6
];

});


parcelRegister("a8clb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7604395822cc5d61$export$2e2bcd8739ae039);
function $7604395822cc5d61$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("i9xH7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3733441fcf2e882$export$2e2bcd8739ae039);
function $d3733441fcf2e882$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("4TVC8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3918fd6b815bcf57$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");
var $3918fd6b815bcf57$var$passive = {
    passive: true
};
function $3918fd6b815bcf57$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $1Prpe.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $3918fd6b815bcf57$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $3918fd6b815bcf57$var$effect,
    data: {}
};

});

parcelRegister("j8nKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $dee1300a39219bb5$export$2e2bcd8739ae039);

var $dJ0Jl = parcelRequire("dJ0Jl");
function $dee1300a39219bb5$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dJ0Jl.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $dee1300a39219bb5$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $dee1300a39219bb5$var$popperOffsets,
    data: {}
};

});
parcelRegister("dJ0Jl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fe00b5c334118ac$export$2e2bcd8739ae039);

var $QXpw1 = parcelRequire("QXpw1");

var $cGRJ4 = parcelRequire("cGRJ4");

var $9GF9F = parcelRequire("9GF9F");

var $kJPed = parcelRequire("kJPed");
function $9fe00b5c334118ac$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $QXpw1.default)(placement) : null;
    var variation = placement ? (0, $cGRJ4.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $kJPed.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $kJPed.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $kJPed.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $kJPed.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $9GF9F.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $kJPed.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $kJPed.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("QXpw1", function(module, exports) {

$parcel$export(module.exports, "default", () => $09f2f123ac4a9fdf$export$2e2bcd8739ae039);

function $09f2f123ac4a9fdf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("cGRJ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $93d315208040ceed$export$2e2bcd8739ae039);
function $93d315208040ceed$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("9GF9F", function(module, exports) {

$parcel$export(module.exports, "default", () => $70d7f5cda4210aa3$export$2e2bcd8739ae039);
function $70d7f5cda4210aa3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("baic6", function(module, exports) {

$parcel$export(module.exports, "default", () => $820ebddbe0682e4f$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $gbHJy = parcelRequire("gbHJy");

var $1Prpe = parcelRequire("1Prpe");

var $eVELE = parcelRequire("eVELE");

var $1ix2F = parcelRequire("1ix2F");

var $QXpw1 = parcelRequire("QXpw1");

var $cGRJ4 = parcelRequire("cGRJ4");

var $90xPK = parcelRequire("90xPK");
var $820ebddbe0682e4f$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $820ebddbe0682e4f$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $90xPK.round)(x * dpr) / dpr || 0,
        y: (0, $90xPK.round)(y * dpr) / dpr || 0
    };
}
function $820ebddbe0682e4f$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $kJPed.left);
    var sideY = (0, $kJPed.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $gbHJy.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $1Prpe.default)(popper)) {
            offsetParent = (0, $eVELE.default)(popper);
            if ((0, $1ix2F.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $kJPed.top) || (placement === (0, $kJPed.left) || placement === (0, $kJPed.right)) && variation === (0, $kJPed.end)) {
            sideY = (0, $kJPed.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $kJPed.left) || (placement === (0, $kJPed.top) || placement === (0, $kJPed.bottom)) && variation === (0, $kJPed.end)) {
            sideX = (0, $kJPed.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $820ebddbe0682e4f$var$unsetSides);
    var _ref4 = roundOffsets === true ? $820ebddbe0682e4f$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $1Prpe.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $820ebddbe0682e4f$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $QXpw1.default)(state.placement),
        variation: (0, $cGRJ4.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $820ebddbe0682e4f$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $820ebddbe0682e4f$var$computeStyles,
    data: {}
};

});

parcelRegister("1AoLg", function(module, exports) {

$parcel$export(module.exports, "default", () => $127c5c56b9511f5f$export$2e2bcd8739ae039);

var $f5IBt = parcelRequire("f5IBt");

var $gmkfg = parcelRequire("gmkfg");
// and applies them to the HTMLElements such as popper and arrow
function $127c5c56b9511f5f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $gmkfg.isHTMLElement)(element) || !(0, $f5IBt.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $127c5c56b9511f5f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $gmkfg.isHTMLElement)(element) || !(0, $f5IBt.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $127c5c56b9511f5f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $127c5c56b9511f5f$var$applyStyles,
    effect: $127c5c56b9511f5f$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("gy4Xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0c3aad300d72ee1$export$2e2bcd8739ae039);

var $QXpw1 = parcelRequire("QXpw1");

var $kJPed = parcelRequire("kJPed");
function $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $QXpw1.default)(placement);
    var invertDistance = [
        (0, $kJPed.left),
        (0, $kJPed.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $kJPed.left),
        (0, $kJPed.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $c0c3aad300d72ee1$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $kJPed.placements).reduce(function(acc, placement) {
        acc[placement] = $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $c0c3aad300d72ee1$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $c0c3aad300d72ee1$var$offset
};

});

parcelRegister("3dDWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $258191447a7022df$export$2e2bcd8739ae039);

var $jwSgb = parcelRequire("jwSgb");

var $QXpw1 = parcelRequire("QXpw1");

var $4tIVJ = parcelRequire("4tIVJ");

var $kgkit = parcelRequire("kgkit");

var $cqF2x = parcelRequire("cqF2x");

var $kJPed = parcelRequire("kJPed");

var $cGRJ4 = parcelRequire("cGRJ4");
function $258191447a7022df$var$getExpandedFallbackPlacements(placement) {
    if ((0, $QXpw1.default)(placement) === (0, $kJPed.auto)) return [];
    var oppositePlacement = (0, $jwSgb.default)(placement);
    return [
        (0, $4tIVJ.default)(placement),
        oppositePlacement,
        (0, $4tIVJ.default)(oppositePlacement)
    ];
}
function $258191447a7022df$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $QXpw1.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $jwSgb.default)(preferredPlacement)
    ] : $258191447a7022df$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $QXpw1.default)(placement) === (0, $kJPed.auto) ? (0, $cqF2x.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $QXpw1.default)(placement);
        var isStartVariation = (0, $cGRJ4.default)(placement) === (0, $kJPed.start);
        var isVertical = [
            (0, $kJPed.top),
            (0, $kJPed.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $kgkit.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $kJPed.right) : (0, $kJPed.left) : isStartVariation ? (0, $kJPed.bottom) : (0, $kJPed.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $jwSgb.default)(mainVariationSide);
        var altVariationSide = (0, $jwSgb.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $258191447a7022df$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $258191447a7022df$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("jwSgb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37b1862c86f39c4$export$2e2bcd8739ae039);
var $e37b1862c86f39c4$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $e37b1862c86f39c4$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $e37b1862c86f39c4$var$hash[matched];
    });
}

});

parcelRegister("4tIVJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $342cb90cb2622617$export$2e2bcd8739ae039);
var $342cb90cb2622617$var$hash = {
    start: 'end',
    end: 'start'
};
function $342cb90cb2622617$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $342cb90cb2622617$var$hash[matched];
    });
}

});

parcelRegister("kgkit", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec050bcf5e349283$export$2e2bcd8739ae039);

var $dknpr = parcelRequire("dknpr");

var $eVELE = parcelRequire("eVELE");

var $g2O7Z = parcelRequire("g2O7Z");

var $dJ0Jl = parcelRequire("dJ0Jl");

var $h8W1z = parcelRequire("h8W1z");

var $kJPed = parcelRequire("kJPed");

var $gmkfg = parcelRequire("gmkfg");

var $gIXWB = parcelRequire("gIXWB");

var $50KfK = parcelRequire("50KfK");
function $ec050bcf5e349283$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $kJPed.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $kJPed.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $kJPed.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $gIXWB.default)(typeof padding !== 'number' ? padding : (0, $50KfK.default)(padding, (0, $kJPed.basePlacements)));
    var altContext = elementContext === (0, $kJPed.popper) ? (0, $kJPed.reference) : (0, $kJPed.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $dknpr.default)((0, $gmkfg.isElement)(element) ? element : element.contextElement || (0, $eVELE.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $g2O7Z.default)(state.elements.reference);
    var popperOffsets = (0, $dJ0Jl.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $h8W1z.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $kJPed.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $kJPed.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $kJPed.right),
                (0, $kJPed.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $kJPed.top),
                (0, $kJPed.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("dknpr", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3f4d3932acb3b2$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $3V2hG = parcelRequire("3V2hG");

var $9NXD7 = parcelRequire("9NXD7");

var $2r6BH = parcelRequire("2r6BH");

var $gbHJy = parcelRequire("gbHJy");

var $eVELE = parcelRequire("eVELE");

var $1ix2F = parcelRequire("1ix2F");

var $gmkfg = parcelRequire("gmkfg");

var $g2O7Z = parcelRequire("g2O7Z");

var $eTUzl = parcelRequire("eTUzl");

var $j6yPg = parcelRequire("j6yPg");

var $f5IBt = parcelRequire("f5IBt");

var $h8W1z = parcelRequire("h8W1z");

var $90xPK = parcelRequire("90xPK");
function $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $g2O7Z.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $kJPed.viewport) ? (0, $h8W1z.default)((0, $3V2hG.default)(element, strategy)) : (0, $gmkfg.isElement)(clippingParent) ? $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $h8W1z.default)((0, $9NXD7.default)((0, $eVELE.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $9b3f4d3932acb3b2$var$getClippingParents(element) {
    var clippingParents = (0, $2r6BH.default)((0, $eTUzl.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $1ix2F.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $gmkfg.isHTMLElement)(element) ? (0, $gbHJy.default)(element) : element;
    if (!(0, $gmkfg.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $gmkfg.isElement)(clippingParent) && (0, $j6yPg.default)(clippingParent, clipperElement) && (0, $f5IBt.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $9b3f4d3932acb3b2$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $9b3f4d3932acb3b2$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $90xPK.max)(rect.top, accRect.top);
        accRect.right = (0, $90xPK.min)(rect.right, accRect.right);
        accRect.bottom = (0, $90xPK.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $90xPK.max)(rect.left, accRect.left);
        return accRect;
    }, $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("3V2hG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2da877912142c34b$export$2e2bcd8739ae039);

var $1Prpe = parcelRequire("1Prpe");

var $eVELE = parcelRequire("eVELE");

var $imzt5 = parcelRequire("imzt5");

var $d8bsQ = parcelRequire("d8bsQ");
function $2da877912142c34b$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $1Prpe.default)(element);
    var html = (0, $eVELE.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $d8bsQ.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $imzt5.default)(element),
        y: y
    };
}

});

parcelRegister("9NXD7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7236f1f1532b7fe8$export$2e2bcd8739ae039);

var $eVELE = parcelRequire("eVELE");

var $1ix2F = parcelRequire("1ix2F");

var $imzt5 = parcelRequire("imzt5");

var $8YTLN = parcelRequire("8YTLN");

var $90xPK = parcelRequire("90xPK");
function $7236f1f1532b7fe8$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $eVELE.default)(element);
    var winScroll = (0, $8YTLN.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $90xPK.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $90xPK.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $imzt5.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $1ix2F.default)(body || html).direction === 'rtl') x += (0, $90xPK.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("j6yPg", function(module, exports) {

$parcel$export(module.exports, "default", () => $de89978be23479c4$export$2e2bcd8739ae039);

var $gmkfg = parcelRequire("gmkfg");
function $de89978be23479c4$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $gmkfg.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("h8W1z", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b0316bb2f8fd97$export$2e2bcd8739ae039);
function $c7b0316bb2f8fd97$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("gIXWB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2cf410c4fe133f4$export$2e2bcd8739ae039);

var $1ANH0 = parcelRequire("1ANH0");
function $c2cf410c4fe133f4$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $1ANH0.default)(), paddingObject);
}

});
parcelRegister("1ANH0", function(module, exports) {

$parcel$export(module.exports, "default", () => $128fb32b18b92ffa$export$2e2bcd8739ae039);
function $128fb32b18b92ffa$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("50KfK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a60d4b4ac4f93e5$export$2e2bcd8739ae039);
function $3a60d4b4ac4f93e5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cqF2x", function(module, exports) {

$parcel$export(module.exports, "default", () => $90c7bf65fbdbec33$export$2e2bcd8739ae039);

var $cGRJ4 = parcelRequire("cGRJ4");

var $kJPed = parcelRequire("kJPed");

var $kgkit = parcelRequire("kgkit");

var $QXpw1 = parcelRequire("QXpw1");
function $90c7bf65fbdbec33$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $kJPed.placements) : _options$allowedAutoP;
    var variation = (0, $cGRJ4.default)(placement);
    var placements = variation ? flipVariations ? (0, $kJPed.variationPlacements) : (0, $kJPed.variationPlacements).filter(function(placement) {
        return (0, $cGRJ4.default)(placement) === variation;
    }) : (0, $kJPed.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $kgkit.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $QXpw1.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("1DdSC", function(module, exports) {

$parcel$export(module.exports, "default", () => $13043339457d5bc5$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $QXpw1 = parcelRequire("QXpw1");

var $9GF9F = parcelRequire("9GF9F");

var $dNtrn = parcelRequire("dNtrn");

var $4WpIh = parcelRequire("4WpIh");

var $jkGDj = parcelRequire("jkGDj");

var $gbHJy = parcelRequire("gbHJy");

var $kgkit = parcelRequire("kgkit");

var $cGRJ4 = parcelRequire("cGRJ4");

var $1ANH0 = parcelRequire("1ANH0");

var $90xPK = parcelRequire("90xPK");
function $13043339457d5bc5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $kgkit.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $QXpw1.default)(state.placement);
    var variation = (0, $cGRJ4.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $9GF9F.default)(basePlacement);
    var altAxis = (0, $dNtrn.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $kJPed.top) : (0, $kJPed.left);
        var altSide = mainAxis === 'y' ? (0, $kJPed.bottom) : (0, $kJPed.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $kJPed.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $kJPed.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $jkGDj.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $1ANH0.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4WpIh.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $gbHJy.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4WpIh.within)(tether ? (0, $90xPK.min)(min, tetherMin) : min, offset, tether ? (0, $90xPK.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $kJPed.top) : (0, $kJPed.left);
        var _altSide = mainAxis === 'x' ? (0, $kJPed.bottom) : (0, $kJPed.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $kJPed.top),
            (0, $kJPed.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4WpIh.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $4WpIh.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $13043339457d5bc5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $13043339457d5bc5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("dNtrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0b6b03fadcbdfd7$export$2e2bcd8739ae039);
function $a0b6b03fadcbdfd7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("4WpIh", function(module, exports) {

$parcel$export(module.exports, "within", () => $3990864f59117d05$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $3990864f59117d05$export$86c8af6d3ef0b4a);

var $90xPK = parcelRequire("90xPK");
function $3990864f59117d05$export$f28d906d67a997f3(min, value, max) {
    return (0, $90xPK.max)(min, (0, $90xPK.min)(value, max));
}
function $3990864f59117d05$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $3990864f59117d05$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("gzAfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10c08bd5e0ed9fb$export$2e2bcd8739ae039);

var $QXpw1 = parcelRequire("QXpw1");

var $jkGDj = parcelRequire("jkGDj");

var $j6yPg = parcelRequire("j6yPg");

var $gbHJy = parcelRequire("gbHJy");

var $9GF9F = parcelRequire("9GF9F");

var $4WpIh = parcelRequire("4WpIh");

var $gIXWB = parcelRequire("gIXWB");

var $50KfK = parcelRequire("50KfK");

var $kJPed = parcelRequire("kJPed");
var $c10c08bd5e0ed9fb$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $gIXWB.default)(typeof padding !== 'number' ? padding : (0, $50KfK.default)(padding, (0, $kJPed.basePlacements)));
};
function $c10c08bd5e0ed9fb$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $QXpw1.default)(state.placement);
    var axis = (0, $9GF9F.default)(basePlacement);
    var isVertical = [
        (0, $kJPed.left),
        (0, $kJPed.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $c10c08bd5e0ed9fb$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $jkGDj.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $kJPed.top) : (0, $kJPed.left);
    var maxProp = axis === 'y' ? (0, $kJPed.bottom) : (0, $kJPed.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $gbHJy.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4WpIh.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $c10c08bd5e0ed9fb$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $j6yPg.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $c10c08bd5e0ed9fb$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $c10c08bd5e0ed9fb$var$arrow,
    effect: $c10c08bd5e0ed9fb$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("6iLAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $496957b0c691a0ed$export$2e2bcd8739ae039);

var $kJPed = parcelRequire("kJPed");

var $kgkit = parcelRequire("kgkit");
function $496957b0c691a0ed$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $496957b0c691a0ed$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $kJPed.top),
        (0, $kJPed.right),
        (0, $kJPed.bottom),
        (0, $kJPed.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $496957b0c691a0ed$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $kgkit.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $kgkit.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $496957b0c691a0ed$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $496957b0c691a0ed$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $496957b0c691a0ed$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $496957b0c691a0ed$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $496957b0c691a0ed$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $496957b0c691a0ed$var$hide
};

});




parcelRegister("iGDLS", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $d9aafffd117cbcc1$export$e0be378c32fb70a7);

var $5uXOq = parcelRequire("5uXOq");

var $hBYjV = parcelRequire("hBYjV");

var $5n5w4 = parcelRequire("5n5w4");

var $eclLw = parcelRequire("eclLw");
function $d9aafffd117cbcc1$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $5uXOq.useContext((0, $5n5w4.ManagerReferenceNodeSetterContext));
    var refHandler = $5uXOq.useCallback(function(node) {
        (0, $eclLw.setRef)(innerRef, node);
        (0, $eclLw.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $5uXOq.useEffect(function() {
        return function() {
            return (0, $eclLw.setRef)(innerRef, null);
        };
    }, []);
    $5uXOq.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $eclLw.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("4wJSY", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $34bdbe885d924a05$export$3e67810a3f0e9f1c);
function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
    return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("7VXAu", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $11d0fd648d1f51c0$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $11d0fd648d1f51c0$export$e618dc39ac9ad607);

var $h1QWG = parcelRequire("h1QWG");

var $eZFhY = parcelRequire("eZFhY");

var $i48X9 = parcelRequire("i48X9");

var $95iuW = parcelRequire("95iuW");

var $dS5G5 = parcelRequire("dS5G5");

var $aA8TC = parcelRequire("aA8TC");

var $hqcPo = parcelRequire("hqcPo");

var $8l2RA = parcelRequire("8l2RA");

var $kKm82 = parcelRequire("kKm82");

var $hpcbi = parcelRequire("hpcbi");
const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
    clearIndicator: (0, $95iuW.clearIndicatorCSS),
    container: (0, $h1QWG.containerCSS),
    control: (0, $eZFhY.css),
    dropdownIndicator: (0, $95iuW.dropdownIndicatorCSS),
    group: (0, $i48X9.groupCSS),
    groupHeading: (0, $i48X9.groupHeadingCSS),
    indicatorsContainer: (0, $h1QWG.indicatorsContainerCSS),
    input: (0, $dS5G5.inputCSS),
    loadingIndicator: (0, $95iuW.loadingIndicatorCSS),
    loadingMessage: (0, $aA8TC.loadingMessageCSS),
    menu: (0, $aA8TC.menuCSS),
    menuList: (0, $aA8TC.menuListCSS),
    menuPortal: (0, $aA8TC.menuPortalCSS),
    multiValue: (0, $hqcPo.multiValueCSS),
    multiValueLabel: (0, $hqcPo.multiValueLabelCSS),
    multiValueRemove: (0, $hqcPo.multiValueRemoveCSS),
    noOptionsMessage: (0, $aA8TC.noOptionsMessageCSS),
    option: (0, $8l2RA.optionCSS),
    placeholder: (0, $kKm82.placeholderCSS),
    singleValue: (0, $hpcbi.css),
    valueContainer: (0, $h1QWG.valueContainerCSS)
};
function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});
parcelRegister("h1QWG", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $78186faf13ea75d3$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $78186faf13ea75d3$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $78186faf13ea75d3$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $78186faf13ea75d3$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $78186faf13ea75d3$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $78186faf13ea75d3$export$d0ffd7e649cab6f);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $agFN9 = parcelRequire("agFN9");

var $1dm34 = parcelRequire("1dm34");
const $78186faf13ea75d3$export$949392aeaf7d2e3a = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $agFN9.containerCSS)() : (0, $1dm34.containerCSS)(props);
const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $agFN9.SelectContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1dm34.SelectContainer), {
        ...props
    });
const $78186faf13ea75d3$export$47aec73c7aa6b9aa = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $agFN9.valueContainerCSS)() : (0, $1dm34.valueContainerCSS)(props);
const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $agFN9.ValueContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1dm34.ValueContainer), {
        ...props
    });
const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $agFN9.indicatorsContainerCSS)() : (0, $1dm34.indicatorsContainerCSS)();
const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $agFN9.IndicatorsContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1dm34.IndicatorsContainer), {
        ...props
    });

});
parcelRegister("agFN9", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $0e7e14a3e3f4b78e$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $0e7e14a3e3f4b78e$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $0e7e14a3e3f4b78e$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $0e7e14a3e3f4b78e$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $0e7e14a3e3f4b78e$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $0e7e14a3e3f4b78e$export$d0ffd7e649cab6f);
/* containers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $VSDnB = parcelRequire("VSDnB");

var $gyjU7 = parcelRequire("gyjU7");
const $0e7e14a3e3f4b78e$export$949392aeaf7d2e3a = ()=>({});
const $0e7e14a3e3f4b78e$var$containerStyles = {
    default: "_11c82smr _kqswh2mm _lcxv1rj4",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf",
    ff_safari_input_fix: "_11c81ixg _1tn22smr"
};
const $0e7e14a3e3f4b78e$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl, xcss: xcss } = props;
    const { className: className, css: css } = (0, $gyjU7.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $0e7e14a3e3f4b78e$var$containerStyles.default,
            isRtl && $0e7e14a3e3f4b78e$var$containerStyles.rtl,
            isDisabled && $0e7e14a3e3f4b78e$var$containerStyles.disabled,
            (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && $0e7e14a3e3f4b78e$var$containerStyles.ff_safari_input_fix,
            (0, $DEWI6.cx)(className, xcss, '-container')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
const $0e7e14a3e3f4b78e$export$47aec73c7aa6b9aa = ()=>({});
const $0e7e14a3e3f4b78e$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
    flex: "_1e0c1txw",
    compact: "_ca0qze3t _u5f312x7 _n3tdze3t _19bv12x7"
};
const $0e7e14a3e3f4b78e$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, xcss: xcss, selectProps: { controlShouldRenderValue: controlShouldRenderValue } } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $0e7e14a3e3f4b78e$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $0e7e14a3e3f4b78e$var$valueContainerStyles.flex,
            isCompact && $0e7e14a3e3f4b78e$var$valueContainerStyles.compact,
            (0, $DEWI6.cx)(className, xcss, '-ValueContainer')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
const $0e7e14a3e3f4b78e$export$9d74e3c8b5868ad7 = ()=>({});
const $0e7e14a3e3f4b78e$var$indicatorContainerStyles = null;
const $0e7e14a3e3f4b78e$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $DEWI6.cx)(className, xcss, '-IndicatorsContainer')
        ]),
        ...innerProps,
        children: children
    });
};

});
parcelRegister("gyjU7", function(module, exports) {

$parcel$export(module.exports, "noop", () => $109d3f9af5469308$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $109d3f9af5469308$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $109d3f9af5469308$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $109d3f9af5469308$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $109d3f9af5469308$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $109d3f9af5469308$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $109d3f9af5469308$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $109d3f9af5469308$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $109d3f9af5469308$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $109d3f9af5469308$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $109d3f9af5469308$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $109d3f9af5469308$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $109d3f9af5469308$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $109d3f9af5469308$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $109d3f9af5469308$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $109d3f9af5469308$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $109d3f9af5469308$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $109d3f9af5469308$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $109d3f9af5469308$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $109d3f9af5469308$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $109d3f9af5469308$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $109d3f9af5469308$export$4213b25a1c4e877);
$parcel$export(module.exports, "filterUnsupportedSelectors", () => $109d3f9af5469308$export$bf2eda47afa5f369);
const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
    if ($109d3f9af5469308$var$isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, xcss: xcss, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $109d3f9af5469308$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $109d3f9af5469308$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
    const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
        $109d3f9af5469308$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $109d3f9af5469308$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $109d3f9af5469308$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $109d3f9af5469308$var$passiveOptionAccessed = false;
const $109d3f9af5469308$var$options = {
    get passive () {
        return $109d3f9af5469308$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
}
const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $109d3f9af5469308$var$isArray(arg) {
    return Array.isArray(arg);
}
function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};
const $109d3f9af5469308$export$bf2eda47afa5f369 = (styles)=>{
    const unsupportedSelectors = [
        ':',
        '[',
        '>',
        '+',
        '~',
        ' ',
        '*',
        '#',
        '.',
        '@',
        '&',
        '|',
        '^',
        '$',
        '='
    ];
    return Object.keys(styles).reduce((filteredStyles, key)=>{
        if (!unsupportedSelectors.some((selector)=>key.includes(selector))) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};

});


parcelRegister("1dm34", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $cefbf12e841cc8e0$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $cefbf12e841cc8e0$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $cefbf12e841cc8e0$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $cefbf12e841cc8e0$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $cefbf12e841cc8e0$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $cefbf12e841cc8e0$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $h9kUS = parcelRequire("h9kUS");

var $gyjU7 = parcelRequire("gyjU7");
const $cefbf12e841cc8e0$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        position: 'relative',
        font: (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        pointerEvents: 'all',
        cursor: isDisabled ? 'not-allowed' : undefined,
        [`${(0, $h9kUS.media).above.xs}`]: {
            font: (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : undefined
        }
    });
const $cefbf12e841cc8e0$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'container', {
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }),
        ...innerProps
    }, children);
};
const $cefbf12e841cc8e0$export$47aec73c7aa6b9aa = ({ isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, selectProps: { controlShouldRenderValue: controlShouldRenderValue } })=>({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden',
        padding: `${isCompact ? 0 : "var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`
    });
const $cefbf12e841cc8e0$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
    const styles = (0, $gyjU7.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles.css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: styles.className || 'value-container',
        ...innerProps
    }, children);
};
const $cefbf12e841cc8e0$export$9d74e3c8b5868ad7 = ()=>({
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0,
        paddingRight: "var(--ds-space-050, 4px)"
    });
const $cefbf12e841cc8e0$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'indicatorsContainer', {
            indicators: true
        }),
        ...innerProps
    }, children);
};

});


parcelRegister("eZFhY", function(module, exports) {

$parcel$export(module.exports, "css", () => $728816cb4150b6bc$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $728816cb4150b6bc$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $8JQpT = parcelRequire("8JQpT");

var $PQCB3 = parcelRequire("PQCB3");
const $728816cb4150b6bc$export$dbf350e5966cf602 = (props)=>{
    return (0, $VSDnB.fg)('compiled-react-select') ? (0, $8JQpT.css)() : (0, $PQCB3.css)(props);
};
const $728816cb4150b6bc$var$Control = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8JQpT.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $PQCB3.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;

});
parcelRegister("8JQpT", function(module, exports) {

$parcel$export(module.exports, "css", () => $2fb743295de83222$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $2fb743295de83222$export$2e2bcd8739ae039);
/* control.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $2fb743295de83222$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkosqtm _v564r5cv _1h6d1elr _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _15peftgi _1ke8ftgi _jaboglyw _1u6l1bml _4cvx1elr _123b1h4p _d0altlke _irr31d5g _1oglgxqn",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsq049",
    disabled: "_1h6dsyzs _lcxvglyw _bfhksyzs _1u6llkwx",
    focused: "_1h6d1p6i _bfhkr01l _16qsq049 _1u6lq049 _4cvx1p6i _irr3r01l",
    subtle: "_1h6d3acm _bfhk18uv _1u6lnruj",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d3acm _bfhk18uv _1u6lnruj _4cvx3acm _irr318uv"
};
const $2fb743295de83222$export$dbf350e5966cf602 = ()=>({});
const $2fb743295de83222$var$Control = (props)=>{
    const { children: children, appearance: appearance, isCompact: isCompact, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $2fb743295de83222$var$styles.default,
            isDisabled && $2fb743295de83222$var$styles.disabled,
            isInvalid && $2fb743295de83222$var$styles.invalid,
            isCompact && $2fb743295de83222$var$styles.compact,
            appearance === 'subtle' && $2fb743295de83222$var$styles.subtle,
            appearance === 'subtle' && isFocused && $2fb743295de83222$var$styles.subtleFocused,
            isFocused && $2fb743295de83222$var$styles.focused,
            appearance === 'none' && $2fb743295de83222$var$styles.none,
            (0, $DEWI6.cx)(className, xcss, '-control')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        "aria-disabled": isDisabled || undefined,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2fb743295de83222$export$2e2bcd8739ae039 = $2fb743295de83222$var$Control;

});

parcelRegister("PQCB3", function(module, exports) {

$parcel$export(module.exports, "css", () => $00e6c98a997351d1$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $00e6c98a997351d1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $00e6c98a997351d1$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, isCompact: isCompact, appearance: appearance })=>{
    let borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
    let backgroundColor = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)";
    let backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
    let borderColorHover = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
    if (isDisabled) {
        backgroundColor = "var(--ds-background-disabled, #091E4208)";
        borderColor = "var(--ds-background-disabled, #091E4208)";
    }
    if (isInvalid) {
        borderColor = "var(--ds-border-danger, #E2483D)";
        borderColorHover = "var(--ds-border-danger, #E2483D)";
    }
    const transitionDuration = '200ms';
    if (appearance === 'subtle') {
        borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : 'transparent';
        backgroundColor = isFocused ? "var(--ds-surface, #FFFFFF)" : 'transparent';
        backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
    }
    if (appearance === 'none') {
        borderColor = 'transparent';
        backgroundColor = 'transparent';
        backgroundColorHover = 'transparent';
        borderColorHover = 'transparent';
    }
    return {
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        outline: '0 !important',
        position: 'relative',
        // Turn pointer events off when disabled - this makes it so hover etc don't work.
        pointerEvents: isDisabled ? 'none' : undefined,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderStyle: 'solid',
        borderRadius: "var(--ds-border-radius-100, 3px)",
        borderWidth: "var(--ds-border-width, 1px)",
        boxShadow: isInvalid ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
        '&:focus-within': {
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
        },
        minHeight: isCompact ? 32 : 40,
        padding: 0,
        transition: `background-color ${transitionDuration} ease-in-out,
border-color ${transitionDuration} ease-in-out`,
        '::-webkit-scrollbar': {
            height: 8,
            width: 8
        },
        '::-webkit-scrollbar-corner': {
            display: 'none'
        },
        ':hover': {
            '::-webkit-scrollbar-thumb': {
                // scrollbars occur only if the user passes in a custom component with overflow: scroll
                backgroundColor: 'rgba(0,0,0,0.2)'
            },
            cursor: 'pointer',
            backgroundColor: backgroundColorHover,
            borderColor: borderColorHover
        },
        '::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'rgba(0,0,0,0.4)'
        }
    };
};
const $00e6c98a997351d1$var$Control = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        ...(0, $gyjU7.getStyleProps)(props, 'control', {
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }),
        ...innerProps,
        "aria-disabled": isDisabled || undefined
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$00e6c98a997351d1$export$2e2bcd8739ae039 = $00e6c98a997351d1$var$Control;

});


parcelRegister("i48X9", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $902e86f4b4fe337b$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $902e86f4b4fe337b$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $902e86f4b4fe337b$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $902e86f4b4fe337b$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $OON7h = parcelRequire("OON7h");

var $2Tqqx = parcelRequire("2Tqqx");
const $902e86f4b4fe337b$export$b6794329c1460634 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $OON7h.groupCSS)() : (0, $2Tqqx.groupCSS)(props);
const $902e86f4b4fe337b$var$Group = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $OON7h.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2Tqqx.default), {
        ...props
    });
const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $OON7h.groupHeadingCSS)() : (0, $2Tqqx.groupHeadingCSS)(props);
const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $OON7h.GroupHeading), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2Tqqx.GroupHeading), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;

});
parcelRegister("OON7h", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $a3ce5541021fbdcc$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $a3ce5541021fbdcc$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $a3ce5541021fbdcc$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $a3ce5541021fbdcc$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $a3ce5541021fbdcc$var$styles = {
    root: "_n3tdu2gc _ca0qu2gc"
};
const $a3ce5541021fbdcc$export$b6794329c1460634 = ()=>({});
const $a3ce5541021fbdcc$var$Group = (props)=>{
    const { children: children, cx: builtinCX, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a3ce5541021fbdcc$var$styles.root,
            (0, $DEWI6.cx)(className, xcss, innerProps?.className, '-Group')
        ]),
        children: [
            label && /*#__PURE__*/ (0, $2OMIu.jsx)(Heading, {
                ...headingProps,
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                children: children
            })
        ]
    });
};
const $a3ce5541021fbdcc$var$headingStyles = null;
const $a3ce5541021fbdcc$export$e5a7fbb542efcb7d = ()=>({});
const $a3ce5541021fbdcc$export$85c8b41a3cd87edc = (props)=>{
    const { xcss: xcss } = props;
    const { data: data, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_11c81o8v _1e0c1ule _syaz1gjq _80om73ad _k48pmoej _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $DEWI6.cx)(className, xcss, '-group')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3ce5541021fbdcc$export$2e2bcd8739ae039 = $a3ce5541021fbdcc$var$Group;

});

parcelRegister("2Tqqx", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $460363aae382b65a$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $460363aae382b65a$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $460363aae382b65a$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $460363aae382b65a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $460363aae382b65a$export$b6794329c1460634 = ({})=>({
        paddingBottom: "var(--ds-space-100, 8px)",
        paddingTop: "var(--ds-space-100, 8px)"
    });
const $460363aae382b65a$var$Group = (props)=>{
    const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'group', {
            group: true
        }),
        ...innerProps
    }, label && /*#__PURE__*/ (0, $f8Sb3.jsx)(Heading, {
        ...headingProps,
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }, label), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, children));
};
const $460363aae382b65a$export$e5a7fbb542efcb7d = ({})=>({
        label: 'group',
        cursor: 'default',
        display: 'block',
        marginBottom: '0.25em',
        paddingLeft: "var(--ds-space-150, 12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        color: "var(--ds-text-subtle, #44546F)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textTransform: 'none'
    });
const $460363aae382b65a$export$85c8b41a3cd87edc = (props)=>{
    const { data: data, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'groupHeading', {
            'group-heading': true
        }),
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$460363aae382b65a$export$2e2bcd8739ae039 = $460363aae382b65a$var$Group;

});


parcelRegister("95iuW", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $13f090f36c42825d$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $13f090f36c42825d$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $13f090f36c42825d$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $13f090f36c42825d$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $13f090f36c42825d$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $13f090f36c42825d$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $7FTuF = parcelRequire("7FTuF");

var $ckNeS = parcelRequire("ckNeS");
const $13f090f36c42825d$export$e1687335805e1230 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $7FTuF.dropdownIndicatorCSS)() : (0, $ckNeS.dropdownIndicatorCSS)(props);
const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7FTuF.DropdownIndicator), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ckNeS.DropdownIndicator), {
        ...props
    });
const $13f090f36c42825d$export$9c0419fd944c1def = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $7FTuF.clearIndicatorCSS)() : (0, $ckNeS.clearIndicatorCSS)(props);
const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7FTuF.ClearIndicator), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ckNeS.ClearIndicator), {
        ...props
    });
const $13f090f36c42825d$export$1d3f24cde248e6b5 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $7FTuF.loadingIndicatorCSS)() : (0, $ckNeS.loadingIndicatorCSS)(props);
const $13f090f36c42825d$export$7c20be4c1d342248 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7FTuF.LoadingIndicator), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ckNeS.LoadingIndicator), {
        ...props
    });

});
parcelRegister("7FTuF", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $a7cf25f9e9baf2e9$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $a7cf25f9e9baf2e9$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $a7cf25f9e9baf2e9$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $a7cf25f9e9baf2e9$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $a7cf25f9e9baf2e9$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $a7cf25f9e9baf2e9$export$7c20be4c1d342248);
/* indicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $kEVMo = parcelRequire("kEVMo");

var $ip0rq = parcelRequire("ip0rq");

var $c0aEF = parcelRequire("c0aEF");
var $3Lty3 = parcelRequire("3Lty3");

var $eZJjh = parcelRequire("eZJjh");

var $gyjU7 = parcelRequire("gyjU7");
// ==============================
// Dropdown & Clear Icons
// ==============================
const $a7cf25f9e9baf2e9$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};
const $a7cf25f9e9baf2e9$var$dropdownWrapperStyles = {
    root: "_ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7"
};
const $a7cf25f9e9baf2e9$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1gjq _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf",
    disabled: "_syaz1lh4"
};
const $a7cf25f9e9baf2e9$export$e1687335805e1230 = ()=>({});
const $a7cf25f9e9baf2e9$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children, isDisabled: isDisabled, isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a7cf25f9e9baf2e9$var$dropdownStyles.default,
            isDisabled && $a7cf25f9e9baf2e9$var$dropdownStyles.disabled,
            isCompact && $a7cf25f9e9baf2e9$var$dropdownStyles.compact,
            (0, $DEWI6.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: children ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
            as: "span",
            xcss: $a7cf25f9e9baf2e9$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
                color: "currentColor",
                label: "open",
                LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)",
                size: "small"
            })
        })
    });
};
const $a7cf25f9e9baf2e9$export$9c0419fd944c1def = ()=>({});
const $a7cf25f9e9baf2e9$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz131l _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf"
};
const $a7cf25f9e9baf2e9$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear', isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a7cf25f9e9baf2e9$var$clearIndicatorStyles.default,
            isCompact && $a7cf25f9e9baf2e9$var$clearIndicatorStyles.compact,
            (0, $DEWI6.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
            xcss: $a7cf25f9e9baf2e9$var$iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ip0rq))), {
                label: "",
                color: "currentColor",
                LEGACY_size: "small",
                LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)",
                size: "small"
            })
        })
    });
};
const $a7cf25f9e9baf2e9$export$1d3f24cde248e6b5 = ()=>({});
const $a7cf25f9e9baf2e9$var$loadingIndicatorStyles = {
    default: "_ca0q12x7 _u5f3u2gc _n3td12x7 _19bvu2gc",
    compact: "_ca0qidpf _n3tdidpf"
};
const $a7cf25f9e9baf2e9$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, isCompact: isCompact, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)({
        ...restProps,
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a7cf25f9e9baf2e9$var$loadingIndicatorStyles.default,
            isCompact && $a7cf25f9e9baf2e9$var$loadingIndicatorStyles.compact,
            (0, $DEWI6.cx)(className, xcss, '-loadingIndicator')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
            size: "small"
        })
    });
};

});

parcelRegister("ckNeS", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $fbe9e11ad0f07d66$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $fbe9e11ad0f07d66$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $fbe9e11ad0f07d66$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $fbe9e11ad0f07d66$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $fbe9e11ad0f07d66$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $fbe9e11ad0f07d66$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $kEVMo = parcelRequire("kEVMo");

var $ip0rq = parcelRequire("ip0rq");

var $f5TWP = parcelRequire("f5TWP");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $gyjU7 = parcelRequire("gyjU7");
// ==============================
// Dropdown & Clear Icons
// ==============================
const $fbe9e11ad0f07d66$var$iconContainerStyles = (0, $8CUq3.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $fbe9e11ad0f07d66$var$dropdownWrapperStyles = (0, $8CUq3.xcss)({
    padding: 'space.075'
});
const $fbe9e11ad0f07d66$export$e1687335805e1230 = ({ isCompact: isCompact, isDisabled: isDisabled })=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtle, #44546F)",
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
        ':hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    });
const $fbe9e11ad0f07d66$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'dropdownIndicator', {
            indicator: true,
            'dropdown-indicator': true
        }),
        ...innerProps
    }, children ? children : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f5TWP.default), {
        as: "span",
        xcss: $fbe9e11ad0f07d66$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)",
        size: "small"
    })));
};
const $fbe9e11ad0f07d66$export$9c0419fd944c1def = ({ isCompact: isCompact })=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        color: "var(--ds-text-subtlest, #626F86)",
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
        ':hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    });
const $fbe9e11ad0f07d66$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear' } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'clearIndicator', {
            indicator: true,
            'clear-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5ILhZ.default), {
        xcss: $fbe9e11ad0f07d66$var$iconContainerStyles,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ip0rq))), {
        label: "",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)",
        size: "small"
    })));
};
const $fbe9e11ad0f07d66$export$1d3f24cde248e6b5 = ({ isCompact: isCompact })=>({
        label: 'loadingIndicator',
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`
    });
const $fbe9e11ad0f07d66$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)({
            ...restProps,
            innerProps: innerProps,
            isRtl: isRtl,
            size: size
        }, 'loadingIndicator', {
            indicator: true,
            'loading-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZJjh.default), {
        size: "small"
    }));
};

});


parcelRegister("dS5G5", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $1c949ac6f5985b40$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $1c949ac6f5985b40$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $dIuKO = parcelRequire("dIuKO");

var $2KDs7 = parcelRequire("2KDs7");
const $1c949ac6f5985b40$export$14a7781d0ca7abea = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $dIuKO.inputCSS)() : (0, $2KDs7.inputCSS)(props);
const $1c949ac6f5985b40$var$Input = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dIuKO.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2KDs7.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;

});
parcelRegister("dIuKO", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $6599751c7dd5cc6c$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $6599751c7dd5cc6c$export$2e2bcd8739ae039);
/* input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $6599751c7dd5cc6c$export$14a7781d0ca7abea = ()=>({});
const $6599751c7dd5cc6c$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
const $6599751c7dd5cc6c$var$nativeInnputStyles = null;
const $6599751c7dd5cc6c$var$hidden = null;
const $6599751c7dd5cc6c$var$Input = (props)=>{
    const { cx: builtinCX, value: value, xcss: xcss } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'input', {
        'input-container': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $6599751c7dd5cc6c$var$inputStyles.root,
            isDisabled && $6599751c7dd5cc6c$var$inputStyles.disabled,
            (0, $DEWI6.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $bwpsq.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6599751c7dd5cc6c$export$2e2bcd8739ae039 = $6599751c7dd5cc6c$var$Input;

});

parcelRegister("2KDs7", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $3bbb27dfa42e66e5$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $3bbb27dfa42e66e5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $3bbb27dfa42e66e5$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value })=>({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : '',
        ...$3bbb27dfa42e66e5$var$containerStyle,
        margin: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingTop: "var(--ds-space-025, 2px)",
        color: "var(--ds-text, #172B4D)"
    });
const $3bbb27dfa42e66e5$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
const $3bbb27dfa42e66e5$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': {
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre',
        ...$3bbb27dfa42e66e5$var$spacingStyle
    }
};
const $3bbb27dfa42e66e5$var$inputStyle = (isHidden)=>({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%',
        ...$3bbb27dfa42e66e5$var$spacingStyle
    });
const $3bbb27dfa42e66e5$var$Input = (props)=>{
    const { cx: cx, value: value } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $gyjU7.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'input', {
            'input-container': true
        }),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $3bbb27dfa42e66e5$var$inputStyle(isHidden),
        disabled: isDisabled,
        "data-testid": dataId,
        ...innerProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3bbb27dfa42e66e5$export$2e2bcd8739ae039 = $3bbb27dfa42e66e5$var$Input;

});


parcelRegister("aA8TC", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $1fde8cb844828ae2$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $1fde8cb844828ae2$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $1fde8cb844828ae2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $1fde8cb844828ae2$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $1fde8cb844828ae2$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $1fde8cb844828ae2$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $1fde8cb844828ae2$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $1fde8cb844828ae2$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $1fde8cb844828ae2$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $1fde8cb844828ae2$export$793392f970497feb);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $5aZmi = parcelRequire("5aZmi");

var $1s63F = parcelRequire("1s63F");
const $1fde8cb844828ae2$export$a228922d5ca42a79 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $5aZmi.menuCSS)() : (0, $1s63F.menuCSS)(props);
const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.MenuPlacer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.MenuPlacer), {
        ...props
    });
const $1fde8cb844828ae2$var$Menu = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
const $1fde8cb844828ae2$export$abafed69cff95d5e = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $5aZmi.menuListCSS)() : (0, $1s63F.menuListCSS)(props);
const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.MenuList), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.MenuList), {
        ...props
    });
// ==============================
// Menu Notices
// ==============================
const $1fde8cb844828ae2$var$noticeCSS = ({})=>({
        textAlign: 'center',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    });
const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
const $1fde8cb844828ae2$export$d58b72b7d3c4072c = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.NoOptionsMessage), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.NoOptionsMessage), {
        ...props
    });
const $1fde8cb844828ae2$export$e928a71d039d3102 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.LoadingMessage), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.LoadingMessage), {
        ...props
    });
const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $5aZmi.menuPortalCSS)() : (0, $1s63F.menuPortalCSS)(props);
const $1fde8cb844828ae2$export$793392f970497feb = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5aZmi.MenuPortal), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1s63F.MenuPortal), {
        ...props
    });

});
parcelRegister("5aZmi", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $76c1fc1d7ab61474$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $76c1fc1d7ab61474$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $76c1fc1d7ab61474$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $76c1fc1d7ab61474$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $76c1fc1d7ab61474$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "NoOptionsMessage", () => $76c1fc1d7ab61474$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $76c1fc1d7ab61474$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $76c1fc1d7ab61474$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $76c1fc1d7ab61474$export$793392f970497feb);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $g9RrE = parcelRequire("g9RrE");

var $7nsd3 = parcelRequire("7nsd3");

var $hrqx3 = parcelRequire("hrqx3");

var $dS3PR = parcelRequire("dS3PR");

var $gyjU7 = parcelRequire("gyjU7");
function $76c1fc1d7ab61474$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $gyjU7.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $gyjU7.normalizedHeight)(scrollParent);
    const scrollTop = (0, $gyjU7.getScrollTop)(scrollParent);
    const menuTopFromParent = menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $gyjU7.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const $76c1fc1d7ab61474$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $76c1fc1d7ab61474$var$menuStyles = {
    root: "_2rkoglpi _kqswstnw _1bsb1osq _1pbykb7n _otyru2gc _19pku2gc _bfhk1bhr _16qs17uf",
    bottom: "_154i1osq",
    top: "_94n51osq"
};
const $76c1fc1d7ab61474$export$a228922d5ca42a79 = ()=>({});
const $76c1fc1d7ab61474$var$PortalPlacementContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $76c1fc1d7ab61474$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($76c1fc1d7ab61474$var$PortalPlacementContext) || {};
    const ref = (0, $5uXOq.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $5uXOq.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $hrqx3.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $76c1fc1d7ab61474$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $76c1fc1d7ab61474$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $76c1fc1d7ab61474$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps, placement: placement = 'bottom', xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $76c1fc1d7ab61474$var$menuStyles.root,
            $76c1fc1d7ab61474$var$menuStyles[placement],
            (0, $DEWI6.cx)(xcss, className, '-menu')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ref: innerRef,
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$76c1fc1d7ab61474$export$2e2bcd8739ae039 = $76c1fc1d7ab61474$var$Menu;
const $76c1fc1d7ab61474$export$abafed69cff95d5e = ()=>({});
const $76c1fc1d7ab61474$var$menuListStyles = null;
const $76c1fc1d7ab61474$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti, maxHeight: maxHeight, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $DEWI6.cx)(className, xcss, '-MenuList')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            ...css,
            maxHeight: maxHeight
        },
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
// ==============================
// Menu Notices
// ==============================
const $76c1fc1d7ab61474$var$noticeCSS = ()=>({});
const $76c1fc1d7ab61474$var$noticeStyles = null;
const $76c1fc1d7ab61474$export$cf0e22534d8b0074 = $76c1fc1d7ab61474$var$noticeCSS;
const $76c1fc1d7ab61474$export$98ec46397a8cb3cd = $76c1fc1d7ab61474$var$noticeCSS;
const $76c1fc1d7ab61474$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $DEWI6.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
const $76c1fc1d7ab61474$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $DEWI6.cx)(className, xcss, '-LoadingMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
const $76c1fc1d7ab61474$export$1dbbeb9648d1fdc9 = ()=>({});
const $76c1fc1d7ab61474$var$menuPortalStyles = {
    root: "_1pbykb7n _1ltva1vk _kqswcp1v _154i1nmo _1bsb1qxj"
};
const $76c1fc1d7ab61474$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    const menuPortalRef = (0, $5uXOq.useRef)(null);
    const cleanupRef = (0, $5uXOq.useRef)(null);
    const [placement, setPortalPlacement] = (0, $5uXOq.useState)($76c1fc1d7ab61474$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
    const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $gyjU7.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $hrqx3.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $g9RrE.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $hrqx3.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)({
        ...props,
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }, 'menuPortal', {
        'menu-portal': true
    });
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $76c1fc1d7ab61474$var$menuPortalStyles.root,
            (0, $DEWI6.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': `${computedPosition.rect.left}px`,
            '--menu-position': menuPosition,
            '--menu-top': `${computedPosition.offset}px`,
            '--menu-width': `${computedPosition.rect.width}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...css
        },
        ...innerProps,
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($76c1fc1d7ab61474$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
};

});
parcelRegister("g9RrE", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $bc36f1aefc070984$export$deee3a793edee05f);

var $gSfPF = parcelRequire("gSfPF");
var $cVo0M = parcelRequire("cVo0M");

var $cVo0M = parcelRequire("cVo0M");

var $f8LYQ = parcelRequire("f8LYQ");
function $bc36f1aefc070984$var$getCssDimensions(element) {
    const css = (0, $f8LYQ.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $f8LYQ.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $cVo0M.round)(width) !== offsetWidth || (0, $cVo0M.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $bc36f1aefc070984$var$unwrapElement(element) {
    return !(0, $f8LYQ.isElement)(element) ? element.contextElement : element;
}
function $bc36f1aefc070984$var$getScale(element) {
    const domElement = $bc36f1aefc070984$var$unwrapElement(element);
    if (!(0, $f8LYQ.isHTMLElement)(domElement)) return (0, $cVo0M.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
    let x = ($ ? (0, $cVo0M.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $cVo0M.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $bc36f1aefc070984$var$noOffsets = /*#__PURE__*/ (0, $cVo0M.createCoords)(0);
function $bc36f1aefc070984$var$getVisualOffsets(element) {
    const win = (0, $f8LYQ.getWindow)(element);
    if (!(0, $f8LYQ.isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $f8LYQ.getWindow)(element)) return false;
    return isFixed;
}
function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $bc36f1aefc070984$var$unwrapElement(element);
    let scale = (0, $cVo0M.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $f8LYQ.isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
        } else scale = $bc36f1aefc070984$var$getScale(element);
    }
    const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, $cVo0M.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $f8LYQ.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $f8LYQ.isElement)(offsetParent) ? (0, $f8LYQ.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $f8LYQ.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $f8LYQ.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $f8LYQ.getWindow)(currentIFrame);
            currentIFrame = (0, $f8LYQ.getFrameElement)(currentWin);
        }
    }
    return (0, $cVo0M.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $f8LYQ.getNodeScroll)(element).scrollLeft;
    if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, $f8LYQ.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $f8LYQ.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $f8LYQ.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $cVo0M.createCoords)(1);
    const offsets = (0, $cVo0M.createCoords)(0);
    const isOffsetParentAnElement = (0, $f8LYQ.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f8LYQ.getNodeName)(offsetParent) !== 'body' || (0, $f8LYQ.isOverflowElement)(documentElement)) scroll = (0, $f8LYQ.getNodeScroll)(offsetParent);
        if ((0, $f8LYQ.isHTMLElement)(offsetParent)) {
            const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
            scale = $bc36f1aefc070984$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, $cVo0M.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $bc36f1aefc070984$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $bc36f1aefc070984$var$getDocumentRect(element) {
    const html = (0, $f8LYQ.getDocumentElement)(element);
    const scroll = (0, $f8LYQ.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $cVo0M.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $cVo0M.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $f8LYQ.getComputedStyle)(body).direction === 'rtl') x += (0, $cVo0M.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
    const win = (0, $f8LYQ.getWindow)(element);
    const html = (0, $f8LYQ.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $f8LYQ.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $f8LYQ.isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, $cVo0M.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, $f8LYQ.getDocumentElement)(element));
    else if ((0, $f8LYQ.isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $cVo0M.rectToClientRect)(rect);
}
function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $f8LYQ.getParentNode)(element);
    if (parentNode === stopNode || !(0, $f8LYQ.isElement)(parentNode) || (0, $f8LYQ.isLastTraversableNode)(parentNode)) return false;
    return (0, $f8LYQ.getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $f8LYQ.getOverflowAncestors)(element, [], false).filter((el)=>(0, $f8LYQ.isElement)(el) && (0, $f8LYQ.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $f8LYQ.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $f8LYQ.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $f8LYQ.isElement)(currentNode) && !(0, $f8LYQ.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $f8LYQ.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $f8LYQ.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $f8LYQ.isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $f8LYQ.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $bc36f1aefc070984$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $f8LYQ.isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $cVo0M.max)(rect.top, accRect.top);
        accRect.right = (0, $cVo0M.min)(rect.right, accRect.right);
        accRect.bottom = (0, $cVo0M.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cVo0M.max)(rect.left, accRect.left);
        return accRect;
    }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $bc36f1aefc070984$var$getDimensions(element) {
    const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $f8LYQ.isHTMLElement)(offsetParent);
    const documentElement = (0, $f8LYQ.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $cVo0M.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f8LYQ.getNodeName)(offsetParent) !== 'body' || (0, $f8LYQ.isOverflowElement)(documentElement)) scroll = (0, $f8LYQ.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, $cVo0M.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $bc36f1aefc070984$var$isStaticPositioned(element) {
    return (0, $f8LYQ.getComputedStyle)(element).position === 'static';
}
function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $f8LYQ.isHTMLElement)(element) || (0, $f8LYQ.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $f8LYQ.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
    const win = (0, $f8LYQ.getWindow)(element);
    if ((0, $f8LYQ.isTopLayer)(element)) return win;
    if (!(0, $f8LYQ.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $f8LYQ.getParentNode)(element);
        while(svgOffsetParent && !(0, $f8LYQ.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $f8LYQ.isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $f8LYQ.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $f8LYQ.isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $f8LYQ.isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, $f8LYQ.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $f8LYQ.getContainingBlock)(element) || win;
}
const $bc36f1aefc070984$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $bc36f1aefc070984$var$isRTL(element) {
    return (0, $f8LYQ.getComputedStyle)(element).direction === 'rtl';
}
const $bc36f1aefc070984$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $f8LYQ.getDocumentElement,
    getClippingRect: $bc36f1aefc070984$var$getClippingRect,
    getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
    getElementRects: $bc36f1aefc070984$var$getElementRects,
    getClientRects: $bc36f1aefc070984$var$getClientRects,
    getDimensions: $bc36f1aefc070984$var$getDimensions,
    getScale: $bc36f1aefc070984$var$getScale,
    isElement: $f8LYQ.isElement,
    isRTL: $bc36f1aefc070984$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $bc36f1aefc070984$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $f8LYQ.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $cVo0M.floor)(top);
        const insetRight = (0, $cVo0M.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $cVo0M.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $cVo0M.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $cVo0M.max)(0, (0, $cVo0M.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $f8LYQ.getOverflowAncestors)(referenceEl) : [],
        ...(0, $f8LYQ.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, $gSfPF.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $bc36f1aefc070984$export$cc800923e997bb8 = (0, $gSfPF.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, $gSfPF.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bc36f1aefc070984$export$fba63a578e423eb = (0, $gSfPF.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, $gSfPF.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bc36f1aefc070984$export$346677f925de839c = (0, $gSfPF.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bc36f1aefc070984$export$fe8985bb6374093c = (0, $gSfPF.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, $gSfPF.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, $gSfPF.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, $gSfPF.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $bc36f1aefc070984$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $gSfPF.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("gSfPF", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $c48df878d8118962$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $c48df878d8118962$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $c48df878d8118962$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $c48df878d8118962$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $c48df878d8118962$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $c48df878d8118962$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $c48df878d8118962$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $c48df878d8118962$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $c48df878d8118962$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $c48df878d8118962$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $c48df878d8118962$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("cVo0M")).rectToClientRect);

var $cVo0M = parcelRequire("cVo0M");
function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $cVo0M.getSideAxis)(placement);
    const alignmentAxis = (0, $cVo0M.getAlignmentAxis)(placement);
    const alignLength = (0, $cVo0M.getAxisLength)(alignmentAxis);
    const side = (0, $cVo0M.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $cVo0M.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $cVo0M.evaluate)(options, state);
    const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $cVo0M.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $cVo0M.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $cVo0M.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $cVo0M.getAlignmentAxis)(placement);
            const length = (0, $cVo0M.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $cVo0M.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $cVo0M.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $cVo0M.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $cVo0M.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $cVo0M.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $cVo0M.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $cVo0M.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $cVo0M.getAlignment)(placement) === alignment || (autoAlignment ? (0, $cVo0M.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $cVo0M.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $cVo0M.placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $cVo0M.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $cVo0M.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $cVo0M.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $cVo0M.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $cVo0M.getSide)(placement);
            const initialSideAxis = (0, $cVo0M.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $cVo0M.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $cVo0M.getOppositePlacement)(initialPlacement)
            ] : (0, $cVo0M.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $cVo0M.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $cVo0M.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $cVo0M.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
    return (0, $cVo0M.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $c48df878d8118962$var$getBoundingRect(rects) {
    const minX = (0, $cVo0M.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $cVo0M.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $cVo0M.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $cVo0M.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $c48df878d8118962$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $cVo0M.rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $cVo0M.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $cVo0M.rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $cVo0M.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $cVo0M.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $cVo0M.getSide)(placement) === 'left';
                    const maxRight = (0, $cVo0M.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $cVo0M.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $c48df878d8118962$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $cVo0M.getSide)(placement);
    const alignment = (0, $cVo0M.getAlignment)(placement);
    const isVertical = (0, $cVo0M.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $cVo0M.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $c48df878d8118962$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $cVo0M.getSideAxis)((0, $cVo0M.getSide)(placement));
            const mainAxis = (0, $cVo0M.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $cVo0M.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $cVo0M.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $cVo0M.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $cVo0M.getSideAxis)(placement);
            const mainAxis = (0, $cVo0M.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $cVo0M.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $cVo0M.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $c48df878d8118962$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $cVo0M.getSide)(placement);
            const alignment = (0, $cVo0M.getAlignment)(placement);
            const isYAxis = (0, $cVo0M.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $cVo0M.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $cVo0M.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $cVo0M.max)(overflow.left, 0);
                const xMax = (0, $cVo0M.max)(overflow.right, 0);
                const yMin = (0, $cVo0M.max)(overflow.top, 0);
                const yMax = (0, $cVo0M.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $cVo0M.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $cVo0M.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("cVo0M", function(module, exports) {

$parcel$export(module.exports, "sides", () => $968d6f1d7e429938$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $968d6f1d7e429938$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $968d6f1d7e429938$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $968d6f1d7e429938$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $968d6f1d7e429938$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $968d6f1d7e429938$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $968d6f1d7e429938$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $968d6f1d7e429938$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $968d6f1d7e429938$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $968d6f1d7e429938$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $968d6f1d7e429938$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $968d6f1d7e429938$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $968d6f1d7e429938$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $968d6f1d7e429938$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $968d6f1d7e429938$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $968d6f1d7e429938$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $968d6f1d7e429938$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $968d6f1d7e429938$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $968d6f1d7e429938$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $968d6f1d7e429938$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $968d6f1d7e429938$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $968d6f1d7e429938$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $968d6f1d7e429938$export$803cd8101b6c182b = /*#__PURE__*/ $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $968d6f1d7e429938$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $968d6f1d7e429938$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
    return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
}
function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
    return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
}
function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
    const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
    const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
    const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
    return [
        $968d6f1d7e429938$export$2b182c584985588b(placement),
        oppositePlacement,
        $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
    ];
}
function $968d6f1d7e429938$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
}
function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
    let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
    }
    return list;
}
function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
}
function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("f8LYQ", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $b05cd24baa7455b6$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $b05cd24baa7455b6$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $b05cd24baa7455b6$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $b05cd24baa7455b6$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $b05cd24baa7455b6$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $b05cd24baa7455b6$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $b05cd24baa7455b6$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $b05cd24baa7455b6$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $b05cd24baa7455b6$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $b05cd24baa7455b6$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $b05cd24baa7455b6$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $b05cd24baa7455b6$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $b05cd24baa7455b6$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $b05cd24baa7455b6$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $b05cd24baa7455b6$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $b05cd24baa7455b6$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $b05cd24baa7455b6$export$7bf1f8740e3e34af);
function $b05cd24baa7455b6$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $b05cd24baa7455b6$export$651544f548703224(node) {
    if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $b05cd24baa7455b6$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
}
function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
}
function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
}
function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
    if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($b05cd24baa7455b6$export$651544f548703224(element));
}
function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
    const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $b05cd24baa7455b6$export$940d8225183e1404(element) {
    let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
    while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
        if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $b05cd24baa7455b6$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($b05cd24baa7455b6$export$651544f548703224(node));
}
function $b05cd24baa7455b6$export$3735103072e4a80(element) {
    return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
    if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
    if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $b05cd24baa7455b6$export$e495491855dc5418(node);
    return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
    const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
    if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
    return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
}
function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("hrqx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2989fd9beaabfa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = (0, $5uXOq.useLayoutEffect);

});


parcelRegister("1s63F", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $b0d3f8517e4be892$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $b0d3f8517e4be892$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $b0d3f8517e4be892$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $b0d3f8517e4be892$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $b0d3f8517e4be892$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "NoOptionsMessage", () => $b0d3f8517e4be892$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $b0d3f8517e4be892$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $b0d3f8517e4be892$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $b0d3f8517e4be892$export$793392f970497feb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $g9RrE = parcelRequire("g9RrE");

var $7nsd3 = parcelRequire("7nsd3");

var $hrqx3 = parcelRequire("hrqx3");

var $cgL5K = parcelRequire("cgL5K");

var $gyjU7 = parcelRequire("gyjU7");
function $b0d3f8517e4be892$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $gyjU7.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $gyjU7.normalizedHeight)(scrollParent);
    const scrollTop = (0, $gyjU7.getScrollTop)(scrollParent);
    const menuTopFromParent = menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $gyjU7.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $gyjU7.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
function $b0d3f8517e4be892$var$alignToControl(placement) {
    const placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
const $b0d3f8517e4be892$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $b0d3f8517e4be892$export$a228922d5ca42a79 = ({ placement: placement })=>({
        label: 'menu',
        [$b0d3f8517e4be892$var$alignToControl(placement)]: '100%',
        position: 'absolute',
        width: '100%',
        zIndex: 1,
        borderRadius: "var(--ds-border-radius, 4px)",
        marginBottom: "var(--ds-space-100, 8px)",
        marginTop: "var(--ds-space-100, 8px)",
        backgroundColor: "var(--ds-surface-overlay, white)",
        boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
    });
const $b0d3f8517e4be892$var$PortalPlacementContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b0d3f8517e4be892$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($b0d3f8517e4be892$var$PortalPlacementContext) || {};
    const ref = (0, $5uXOq.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $5uXOq.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $hrqx3.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $b0d3f8517e4be892$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $b0d3f8517e4be892$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $b0d3f8517e4be892$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'menu', {
            menu: true
        }),
        ref: innerRef,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b0d3f8517e4be892$export$2e2bcd8739ae039 = $b0d3f8517e4be892$var$Menu;
const $b0d3f8517e4be892$export$abafed69cff95d5e = ({ maxHeight: maxHeight })=>({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch',
        paddingTop: "var(--ds-space-100, 8px)",
        paddingBottom: "var(--ds-space-100, 8px)"
    });
const $b0d3f8517e4be892$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'menuList', {
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
// ==============================
// Menu Notices
// ==============================
const $b0d3f8517e4be892$var$noticeCSS = ({})=>({
        textAlign: 'center',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    });
const $b0d3f8517e4be892$export$cf0e22534d8b0074 = $b0d3f8517e4be892$var$noticeCSS;
const $b0d3f8517e4be892$export$98ec46397a8cb3cd = $b0d3f8517e4be892$var$noticeCSS;
const $b0d3f8517e4be892$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'noOptionsMessage', {
            'menu-notice': true,
            'menu-notice--no-options': true
        }),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), {
        color: "color.text.subtle"
    }, children));
};
const $b0d3f8517e4be892$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'loadingMessage', {
            'menu-notice': true,
            'menu-notice--loading': true
        }),
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cgL5K.default), {
        color: "color.text.subtle"
    }, children));
};
const $b0d3f8517e4be892$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    });
const $b0d3f8517e4be892$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
    const menuPortalRef = (0, $5uXOq.useRef)(null);
    const cleanupRef = (0, $5uXOq.useRef)(null);
    const [placement, setPortalPlacement] = (0, $5uXOq.useState)($b0d3f8517e4be892$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
    const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $gyjU7.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $hrqx3.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $g9RrE.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $hrqx3.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: setMenuPortalElement,
        ...(0, $gyjU7.getStyleProps)({
            ...props,
            offset: computedPosition.offset,
            position: menuPosition,
            rect: computedPosition.rect
        }, 'menuPortal', {
            'menu-portal': true
        }),
        ...innerProps
    }, children);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($b0d3f8517e4be892$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});


parcelRegister("hqcPo", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $20933ad7b05a0c37$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $20933ad7b05a0c37$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $20933ad7b05a0c37$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $20933ad7b05a0c37$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $20933ad7b05a0c37$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $20933ad7b05a0c37$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $iBgL9 = parcelRequire("iBgL9");

var $4ntXy = parcelRequire("4ntXy");
const $20933ad7b05a0c37$export$23c213f7717186af = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $iBgL9.multiValueCSS)() : (0, $4ntXy.multiValueCSS)(props);
const $20933ad7b05a0c37$export$f40612612e0af964 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $iBgL9.multiValueLabelCSS)() : (0, $4ntXy.multiValueLabelCSS)(props);
const $20933ad7b05a0c37$export$283467f6c4ac142b = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $iBgL9.multiValueRemoveCSS)() : (0, $4ntXy.multiValueRemoveCSS)(props);
const $20933ad7b05a0c37$export$cf9cf2a30a59265c = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iBgL9.MultiValueContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ntXy.MultiValueContainer), {
        ...props
    });
const $20933ad7b05a0c37$export$544aeea2a5ce08ee = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iBgL9.MultiValueLabel), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ntXy.MultiValueLabel), {
        ...props
    });
function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a(props) {
    return(// The Remove button is intentionally excluded from the tab order, please avoid assigning a non-negative tabIndex to it. Context: https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+Options+on+an+Input+Field
    (0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iBgL9.MultiValueRemove), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ntXy.MultiValueRemove), {
        ...props
    }));
}
const $20933ad7b05a0c37$var$MultiValue = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iBgL9.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4ntXy.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;

});
parcelRegister("iBgL9", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $a2bd6c7425e95809$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $a2bd6c7425e95809$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $a2bd6c7425e95809$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $a2bd6c7425e95809$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $a2bd6c7425e95809$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $a2bd6c7425e95809$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $a2bd6c7425e95809$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $i28qQ = parcelRequire("i28qQ");

var $673MF = parcelRequire("673MF");

var $VSDnB = parcelRequire("VSDnB");

var $gyjU7 = parcelRequire("gyjU7");
const $a2bd6c7425e95809$var$multiValueStyles = {
    root: "_2rkogqwt _1e0c1txw _1ul9ze3t _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _bfhkm7j4 _p12f1osq _syazjpor _3yq3glyw",
    disabled: "_syaz1lh4 _bfhkm7j4",
    focused: "_syaz1wum _bfhkfg4m _16qs17si _1aewe4h9 _6up53acm _1xdnnqa1",
    refresh: "_2rkoiti9 _1h6d14je _1dqonqa1 _189ee4h9 _bfhk1j9a"
};
const $a2bd6c7425e95809$export$23c213f7717186af = ()=>({});
const $a2bd6c7425e95809$export$f40612612e0af964 = ()=>({});
const $a2bd6c7425e95809$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkogqwt _11c8dcr7 _o5721q9c _ca0qv77o _u5f3v77o _n3tdv77o _19bv12x7 _syaz1kw7",
    disabled: "_syaz1lh4",
    ellipsis: "_1bto1l2s",
    refresh: "_11c82smr _ca0qidpf _n3tdidpf _19bv1b66"
};
const $a2bd6c7425e95809$export$283467f6c4ac142b = ()=>({});
const $a2bd6c7425e95809$var$multiValueRemoveStyles = {
    focused: "_bfhk1km6 _lswu1rrc",
    root: "_2rkovtp2 _4cvr1h6o _1e0c1txw _lswu1dx5 _19bvv77o _u5f3v77o _irr31yvi _13br1jjn _1di61io2 _i5f81jjn",
    refresh: "_19itglyw _2rkoglpi _bfhk1w7a _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _syaz1fxt _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _2hwxv77o _1ah312gs _irr3166n _1di61dty"
};
const $a2bd6c7425e95809$export$cf9cf2a30a59265c = ({ children: children, innerProps: innerProps, isFocused: isFocused, isDisabled: isDisabled, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a2bd6c7425e95809$var$multiValueStyles.root,
            isDisabled && $a2bd6c7425e95809$var$multiValueStyles.disabled,
            isFocused && $a2bd6c7425e95809$var$multiValueStyles.focused,
            (0, $VSDnB.fg)('platform-component-visual-refresh') && $a2bd6c7425e95809$var$multiValueStyles.refresh,
            (0, $DEWI6.cx)(className, xcss, '-multiValue')
        ]),
        children: children
    });
};
const $a2bd6c7425e95809$export$544aeea2a5ce08ee = ({ children: children, innerProps: innerProps, isDisabled: isDisabled, hasEllipsis: hasEllipsis, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a2bd6c7425e95809$var$multiValueLabelStyles.root,
            isDisabled && $a2bd6c7425e95809$var$multiValueLabelStyles.disabled,
            hasEllipsis && $a2bd6c7425e95809$var$multiValueLabelStyles.ellipsis,
            (0, $VSDnB.fg)('platform-component-visual-refresh') && $a2bd6c7425e95809$var$multiValueLabelStyles.refresh,
            (0, $DEWI6.cx)(className, xcss, '-MultiValueLabel')
        ]),
        children: children
    });
};
const $a2bd6c7425e95809$var$disabledStyles = null;
const $a2bd6c7425e95809$var$enabledStyles = null;
function $a2bd6c7425e95809$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, isFocused: isFocused, innerProps: innerProps, className: className, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a2bd6c7425e95809$var$multiValueRemoveStyles.root,
            isFocused && $a2bd6c7425e95809$var$multiValueRemoveStyles.focused,
            (0, $VSDnB.fg)('platform-component-visual-refresh') && $a2bd6c7425e95809$var$multiValueRemoveStyles.refresh,
            (0, $DEWI6.cx)(className, xcss, '-MultiValueRemove')
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, $bwpsq.default)([
                isDisabled && "_1e0cglyw",
                !isDisabled && "_1e0c1kw7"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))), {
                label: "",
                color: "currentColor",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($673MF))),
                LEGACY_primaryColor: "transparent",
                LEGACY_secondaryColor: "inherit",
                LEGACY_size: "small",
                size: "small"
            })
        })
    });
}
const $a2bd6c7425e95809$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, isFocused: isFocused, removeProps: removeProps, selectProps: selectProps, cropWithEllipsis: cropWithEllipsis } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const ariaLabel = typeof children === 'string' ? children : data.label;
    const { css: containerCss, className: containerClassName } = (0, $gyjU7.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, $gyjU7.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, $gyjU7.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(Container, {
        data: data,
        innerProps: {
            style: containerCss,
            className: containerClassName,
            ...innerProps
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)(Remove, {
                data: data,
                innerProps: {
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': `${ariaLabel || 'option'}, remove`,
                    ...removeProps
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a2bd6c7425e95809$export$2e2bcd8739ae039 = $a2bd6c7425e95809$var$MultiValue;

});

parcelRegister("4ntXy", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $e8473c8c41411b48$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $e8473c8c41411b48$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $e8473c8c41411b48$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $e8473c8c41411b48$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $e8473c8c41411b48$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $e8473c8c41411b48$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $e8473c8c41411b48$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $i28qQ = parcelRequire("i28qQ");

var $673MF = parcelRequire("673MF");

var $VSDnB = parcelRequire("VSDnB");

var $gyjU7 = parcelRequire("gyjU7");
function $e8473c8c41411b48$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e8473c8c41411b48$export$23c213f7717186af = ({ isDisabled: isDisabled, isFocused: isFocused })=>{
    let backgroundColor;
    let color;
    if (isDisabled) {
        // Use the basic neutral background so it is slightly separate from the
        // field's background
        backgroundColor = "var(--ds-background-neutral, #091E420F)";
        color = "var(--ds-text-disabled, #091E424F)";
    } else if (isFocused) {
        backgroundColor = "var(--ds-background-selected, #E9F2FF)";
        color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
    } else {
        backgroundColor = (0, $VSDnB.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : "var(--ds-background-neutral, #091E420F)";
        color = "var(--ds-text, hsl(0, 0%, 20%))";
    }
    return {
        label: 'multiValue',
        display: 'flex',
        minWidth: 0,
        // resolves flex/text-overflow bug
        margin: "var(--ds-space-025, 2px)",
        borderRadius: "var(--ds-border-radius-050, 2px)",
        backgroundColor: backgroundColor,
        boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
        maxWidth: '100%',
        '@media screen and (-ms-high-contrast: active)': {
            border: isFocused ? '1px solid transparent' : 'none'
        },
        color: color,
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') && {
            borderRadius: "var(--ds-border-radius-100, 4px)",
            // Hardcode this color for visual refresh as there is no token color yet
            borderColor: '#B7B9BE',
            borderWidth: "var(--ds-border-width, 1px)",
            borderStyle: 'solid',
            backgroundColor: "var(--ds-background-input, #FFFFFF)"
        }
    };
};
const $e8473c8c41411b48$export$f40612612e0af964 = ({ cropWithEllipsis: cropWithEllipsis, isDisabled: isDisabled })=>({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap',
        borderRadius: "var(--ds-border-radius-050, 2px)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '85%',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        padding: "var(--ds-space-025, 2px)",
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : 'inherit',
        paddingLeft: "var(--ds-space-075, 6px)",
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') && {
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: "var(--ds-space-050, 4px)"
        }
    });
const $e8473c8c41411b48$export$283467f6c4ac142b = ({ isFocused: isFocused })=>({
        alignItems: 'center',
        display: 'flex',
        backgroundColor: isFocused ? "var(--ds-UNSAFE-transparent, transparent)" : undefined,
        fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
        paddingLeft: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-025, 2px)",
        borderRadius: '0px 2px 2px 0px',
        // DSP-6470 we should style like Tag once we have the :has selector
        ':hover': {
            backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)",
            fill: "var(--ds-text-danger, #000)"
        },
        ':active': {
            backgroundColor: "var(--ds-background-danger-pressed, #FD9891)",
            fill: "var(--ds-text-danger, #000)"
        },
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') && {
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            border: 'none',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
            appearance: 'none',
            borderRadius: "var(--ds-border-radius, 4px)",
            color: "var(--ds-text, #172B4D)",
            padding: "var(--ds-space-025, 2px)",
            marginRight: "var(--ds-space-025, 2px)",
            ':focus-visible': {
                outlineOffset: "var(--ds-space-negative-025, -2px)"
            },
            ':hover': {
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
            },
            ':active': {
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
            }
        }
    });
const $e8473c8c41411b48$var$MultiValueGeneric = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, children);
const $e8473c8c41411b48$export$cf9cf2a30a59265c = $e8473c8c41411b48$var$MultiValueGeneric;
const $e8473c8c41411b48$export$544aeea2a5ce08ee = $e8473c8c41411b48$var$MultiValueGeneric;
const $e8473c8c41411b48$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $e8473c8c41411b48$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
function $e8473c8c41411b48$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, innerProps: innerProps }) {
    return(// The Remove button is intentionally excluded from the tab order, please avoid assigning a non-negative tabIndex to it. Context: https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+Options+on+an+Input+Field
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: isDisabled ? $e8473c8c41411b48$var$disabledStyles : $e8473c8c41411b48$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))), {
        label: "",
        color: "currentColor",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($673MF))),
        LEGACY_primaryColor: "transparent",
        LEGACY_secondaryColor: "inherit",
        LEGACY_size: "small",
        size: "small"
    }))));
}
const $e8473c8c41411b48$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const ariaLabel = typeof children === 'string' ? children : data.label;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Container, {
        data: data,
        innerProps: {
            ...(0, $gyjU7.getStyleProps)(props, 'multiValue', {
                'multi-value': true,
                'multi-value--is-disabled': isDisabled
            }),
            ...innerProps
        },
        selectProps: selectProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Label, {
        data: data,
        innerProps: {
            ...(0, $gyjU7.getStyleProps)(props, 'multiValueLabel', {
                'multi-value__label': true
            })
        },
        selectProps: selectProps
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)(Remove, {
        data: data,
        innerProps: {
            ...(0, $gyjU7.getStyleProps)(props, 'multiValueRemove', {
                'multi-value__remove': true
            }),
            role: 'button',
            tabIndex: -1,
            'aria-label': `${ariaLabel || 'option'}, remove`,
            ...removeProps
        },
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e8473c8c41411b48$export$2e2bcd8739ae039 = $e8473c8c41411b48$var$MultiValue;

});


parcelRegister("8l2RA", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $6e6d67a90b457dc1$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $6e6d67a90b457dc1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $3ttih = parcelRequire("3ttih");

var $2coFy = parcelRequire("2coFy");
const $6e6d67a90b457dc1$export$ef897119b7e920ba = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $3ttih.optionCSS)() : (0, $2coFy.optionCSS)(props);
const $6e6d67a90b457dc1$var$Option = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3ttih.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2coFy.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;

});
parcelRegister("3ttih", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $067c79fba4bdfbb2$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $067c79fba4bdfbb2$export$2e2bcd8739ae039);
/* option.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $067c79fba4bdfbb2$export$ef897119b7e920ba = ()=>({});
const $067c79fba4bdfbb2$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syaz1fxt _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di61dty",
    disabled: "_syaz1lh4 _80om13gf _bfhk18uv _16qsglyw _1di618uv _1pknglyw",
    focused: "_bfhk166n _16qsu4to _1pknj1ic",
    selected: "_syazaqb7 _bfhkfg4m _16qsu4to _1di619ru _1pknj1ic",
    focusedSelected: "_bfhki1yw"
};
const $067c79fba4bdfbb2$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $067c79fba4bdfbb2$var$optionStyles.root,
            isFocused && $067c79fba4bdfbb2$var$optionStyles.focused,
            isSelected && $067c79fba4bdfbb2$var$optionStyles.selected,
            isFocused && isSelected && $067c79fba4bdfbb2$var$optionStyles.focusedSelected,
            isDisabled && $067c79fba4bdfbb2$var$optionStyles.disabled,
            (0, $DEWI6.cx)(className, xcss, '-option')
        ]),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$067c79fba4bdfbb2$export$2e2bcd8739ae039 = $067c79fba4bdfbb2$var$Option;

});

parcelRegister("2coFy", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $026e08b240e6e5e0$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $026e08b240e6e5e0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $026e08b240e6e5e0$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    let color = "var(--ds-text, #172B4D)";
    if (isDisabled) color = "var(--ds-text-disabled, #091E424F)";
    else if (isSelected) color = "var(--ds-text-selected, #0C66E4)";
    let boxShadow;
    let backgroundColor;
    if (isDisabled) backgroundColor = undefined;
    else if (isSelected && isFocused) backgroundColor = "var(--ds-background-selected-hovered, #CCE0FF)";
    else if (isSelected) backgroundColor = "var(--ds-background-selected, #E9F2FF)";
    else if (isFocused) backgroundColor = "var(--ds-background-neutral-subtle-hovered, #091E420F)";
    if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${"var(--ds-border-selected, #0C66E4)"}`;
    const cursor = isDisabled ? 'not-allowed' : 'default';
    return {
        label: 'option',
        display: 'block',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
        backgroundColor: backgroundColor,
        color: color,
        cursor: cursor,
        boxShadow: boxShadow,
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? "var(--ds-background-selected-pressed, #85B8FF)" : "var(--ds-background-neutral-subtle-pressed, #091E4224)" : undefined
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
        }
    };
};
const $026e08b240e6e5e0$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'option', {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$026e08b240e6e5e0$export$2e2bcd8739ae039 = $026e08b240e6e5e0$var$Option;

});


parcelRegister("kKm82", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $889d652a9d0dc097$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $889d652a9d0dc097$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $dw3lH = parcelRequire("dw3lH");

var $iL8GQ = parcelRequire("iL8GQ");
const $889d652a9d0dc097$export$5f3ffacd6594d90f = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $dw3lH.placeholderCSS)() : (0, $iL8GQ.placeholderCSS)(props);
const $889d652a9d0dc097$var$Placeholder = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dw3lH.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iL8GQ.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;

});
parcelRegister("dw3lH", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $7011c54f7352f26b$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $7011c54f7352f26b$export$2e2bcd8739ae039);
/* placeholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $7011c54f7352f26b$export$5f3ffacd6594d90f = ()=>({});
const $7011c54f7352f26b$var$placeholderStyles = {
    root: "_nd5l1sux _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz131l",
    disabled: "_syaz1lh4"
};
const $7011c54f7352f26b$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $7011c54f7352f26b$var$placeholderStyles.root,
            isDisabled && $7011c54f7352f26b$var$placeholderStyles.disabled,
            (0, $DEWI6.cx)(className, xcss, '-placeholder')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7011c54f7352f26b$export$2e2bcd8739ae039 = $7011c54f7352f26b$var$Placeholder;

});

parcelRegister("iL8GQ", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $aeddb46ca1eecdf2$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $aeddb46ca1eecdf2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $aeddb46ca1eecdf2$export$5f3ffacd6594d90f = ({ isDisabled: isDisabled })=>({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3',
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtlest, #626F86)"
    });
const $aeddb46ca1eecdf2$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'placeholder', {
            placeholder: true
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$aeddb46ca1eecdf2$export$2e2bcd8739ae039 = $aeddb46ca1eecdf2$var$Placeholder;

});


parcelRegister("hpcbi", function(module, exports) {

$parcel$export(module.exports, "css", () => $aff94346c62a222f$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $aff94346c62a222f$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $5Zgwp = parcelRequire("5Zgwp");

var $9pbjn = parcelRequire("9pbjn");
const $aff94346c62a222f$export$dbf350e5966cf602 = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? (0, $5Zgwp.css)() : (0, $9pbjn.css)(props);
const $aff94346c62a222f$var$SingleValue = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Zgwp.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9pbjn.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;

});
parcelRegister("5Zgwp", function(module, exports) {

$parcel$export(module.exports, "css", () => $11f234ca28812396$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $11f234ca28812396$export$2e2bcd8739ae039);
/* single-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $gyjU7 = parcelRequire("gyjU7");
const $11f234ca28812396$export$dbf350e5966cf602 = ()=>({});
const $11f234ca28812396$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz1fxt",
    disalbed: "_syaz1lh4"
};
const $11f234ca28812396$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $gyjU7.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $11f234ca28812396$var$styles.root,
            isDisabled && $11f234ca28812396$var$styles.disalbed,
            (0, $DEWI6.cx)(className, xcss, '-singleValue')
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$11f234ca28812396$export$2e2bcd8739ae039 = $11f234ca28812396$var$SingleValue;

});

parcelRegister("9pbjn", function(module, exports) {

$parcel$export(module.exports, "css", () => $0f24309584527733$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $0f24309584527733$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $0f24309584527733$export$dbf350e5966cf602 = ({ isDisabled: isDisabled })=>({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text, #172B4D)"
    });
const $0f24309584527733$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $gyjU7.getStyleProps)(props, 'singleValue', {
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0f24309584527733$export$2e2bcd8739ae039 = $0f24309584527733$var$SingleValue;

});



parcelRegister("7K5PP", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $c2d344e1481a2d3b$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $eAthk = parcelRequire("eAthk");

var $3c98u = parcelRequire("3c98u");
const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, $3c98u.default)((0, $eAthk.default));
const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, $gB4mS.default)('atlaskit');
const $c2d344e1481a2d3b$var$Select = (0, $994MI.default)({
    componentName: 'select',
    packageName: $c2d344e1481a2d3b$var$packageName,
    packageVersion: $c2d344e1481a2d3b$var$packageVersion
})((0, $cb25w.default)({
    onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $c2d344e1481a2d3b$var$packageName,
            packageVersion: $c2d344e1481a2d3b$var$packageVersion
        }
    })
})($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;

});
parcelRegister("eAthk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d0cf20527a3a891$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("iaInK")).default);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $iaInK = parcelRequire("iaInK");

var $9uJ4X = parcelRequire("9uJ4X");
const $6d0cf20527a3a891$var$AsyncSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $iaInK.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $9uJ4X.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6d0cf20527a3a891$export$2e2bcd8739ae039 = $6d0cf20527a3a891$var$AsyncSelect;

});
parcelRegister("2QhWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8e863683b34816f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2Z7Iz = parcelRequire("2Z7Iz");

var $VSDnB = parcelRequire("VSDnB");

var $eEtcC = parcelRequire("eEtcC");

var $bChGW = parcelRequire("bChGW");

var $jtVgE = parcelRequire("jtVgE");
var $9cRAr = parcelRequire("9cRAr");
var $galqx = parcelRequire("galqx");

var $7uagk = parcelRequire("7uagk");

var $81i5b = parcelRequire("81i5b");

var $aA8TC = parcelRequire("aA8TC");

var $5JAlL = parcelRequire("5JAlL");

var $7VXAu = parcelRequire("7VXAu");

var $gyjU7 = parcelRequire("gyjU7");
const $d8e863683b34816f$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $gyjU7.isTouchCapable)(),
    captureMenuScroll: !(0, $gyjU7.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $5JAlL.createFilter)(),
    formatGroupLabel: (0, $eEtcC.formatGroupLabel),
    getOptionLabel: (0, $eEtcC.getOptionLabel),
    getOptionValue: (0, $eEtcC.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $eEtcC.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $gyjU7.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
    const label = $d8e863683b34816f$var$getOptionLabel(props, option);
    const value = $d8e863683b34816f$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $gyjU7.notNullish));
}
function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
    return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
}
function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
    return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
}
function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $d8e863683b34816f$var$instanceId = 1;
class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props), this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        }, // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, // Refs
        // ------------------------------
        this.controlRef = null, this.getControlRef = (ref)=>{
            this.controlRef = ref;
        }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        }, this.inputRef = null, this.getInputRef = (ref)=>{
            this.inputRef = ref;
        }, // aliased for consumers
        this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        }, this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $gyjU7.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $gyjU7.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $gyjU7.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $gyjU7.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        }, this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $gyjU7.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        }, this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $gyjU7.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $gyjU7.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        }, this.getFocusableOptionsWithIds = ()=>{
            return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, $gyjU7.classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
            return $d8e863683b34816f$var$getOptionLabel(this.props, data);
        }, this.getOptionValue = (data)=>{
            return $d8e863683b34816f$var$getOptionValue(this.props, data);
        }, this.getStyles = (key, props)=>{
            const base = (0, $7VXAu.defaultStyles)[key](props);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            if (!custom) return base;
            const customStyles = (0, $VSDnB.fg)('compiled-react-select') ? (0, $gyjU7.filterUnsupportedSelectors)(custom(base, props)) : custom(base, props);
            return customStyles;
        }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        }, this.getComponents = ()=>{
            return (0, $bChGW.defaultComponents)(this.props);
        }, this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        }, this.onMenuMouseMove = (event)=>{
            this.blockOptionHover = false;
        }, this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        }, this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        }, this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $gyjU7.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        }, this.onCompositionStart = ()=>{
            this.isComposing = true;
        }, this.onCompositionEnd = ()=>{
            this.isComposing = false;
        }, this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        }, this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        }, this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        }, this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        }, this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        }, this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        }, this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        }, this.shouldHideSelectedOptions = ()=>{
            return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
        this.state.selectValue = (0, $gyjU7.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $gyjU7.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $gyjU7.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $gyjU7.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $gyjU7.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        const focusedOption = focusableOptions[openAtIndex];
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusedOption,
            focusedOptionId: this.getFocusedOptionId(focusedOption)
        }, ()=>this.onMenuOpen());
        (0, $2Z7Iz.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
    }
    updateInputLabel(inputLabel) {
        if (inputLabel) {
            this.inputRef?.setAttribute('aria-label', inputLabel);
            setTimeout(()=>{
                const normalizedLabel = this.props['aria-label'] || this.props.label;
                if (normalizedLabel) this.inputRef?.setAttribute('aria-label', normalizedLabel);
                else this.inputRef?.removeAttribute('aria-label');
            }, 500);
        }
    }
    calculateInputLabel(focusedOption, optionIndex) {
        const { options: options } = this.props;
        const isOptionsGrouped = options?.every((obj)=>typeof obj === 'object' && obj !== null && 'options' in obj);
        let inputLabel = this.getOptionLabel(focusedOption);
        const isOptionFocused = (option)=>{
            return this.getOptionLabel(option) === inputLabel;
        };
        const groupData = options?.find((option)=>{
            const groupCandidate = option;
            return groupCandidate.options?.some(isOptionFocused) ?? false;
        });
        if (isOptionsGrouped) {
            const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
            const totalLength = options?.reduce((acc, currentGroup)=>{
                const group = currentGroup;
                acc += group?.options?.length;
                return acc;
            }, 0);
            inputLabel = `${inputLabel}, ${groupData?.label} (${groupOptionIndex + 1} of ${totalLength})`;
        } else inputLabel = `${inputLabel} (${optionIndex + 1} of ${options?.length})`;
        return inputLabel;
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription() {
        const descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
        const { isMulti: isMulti } = this.props;
        const hasValue = this.state.selectValue.length > 0;
        // Determine base description based on selection state
        const baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
        // Fast path for single select with no description prop
        if (!isMulti && !descriptionProp) return {
            'aria-describedby': baseDescriptionId
        };
        // Build the describedby string efficiently
        let describedBy = baseDescriptionId;
        // Add description prop if it exists
        if (descriptionProp) describedBy = describedBy ? `${descriptionProp} ${describedBy}` : descriptionProp;
        // For multi-select, always add multi-message ID
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            describedBy = describedBy ? `${describedBy} ${multiMessage}` : multiMessage;
        }
        return {
            'aria-describedby': describedBy
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'both',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            // TODO: Might need to remove this
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.calculateDescription()
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jtVgE.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $gyjU7.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, $5uXOq.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, $5uXOq.createElement)(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}-remove`
                    },
                    id: `${this.getElementId('selected-value')}-${index}-remove`
                },
                data: opt,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}`
                    },
                    id: `${this.getElementId('selected-value')}-${index}`
                }
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $2OMIu.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            innerProps: {
                id: this.getElementId('single-value')
            },
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled ? undefined : isDisabled,
                'aria-describedby': headingId,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $5uXOq.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $5uXOq.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $2OMIu.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aA8TC.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $galqx.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>/*#__PURE__*/ (0, $2OMIu.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    ...this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-labelledby': this.inputRef?.id || this.getElementId('input')
                                    },
                                    'aria-multiselectable': !commonProps.isMulti || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox for safari to announce first option
                                    ...(0, $2Z7Iz.isSafari)() && !this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-describedby': this.inputRef?.id || this.getElementId('input')
                                    }
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            })
                    })
                })
        });
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, $2OMIu.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        }) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9cRAr.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $81i5b.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions
        });
    }
    renderMultiselectMessage() {
        // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
        // Also, since this is rendered onscreen, it should be transtlated automatically.
        const msg = `, multiple selections available, ${this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : ''}`;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: msg
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $2OMIu.jsxs)(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown,
                ...testId && {
                    'data-testid': testId && `${testId}-select--container`
                }
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            children: [
                this.renderLiveRegion(),
                commonProps.isMulti && this.renderMultiselectMessage(),
                /*#__PURE__*/ (0, $2OMIu.jsxs)(Control, {
                    ...commonProps,
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd,
                        ...testId && {
                            'data-testid': `${testId}-select--control`
                        }
                    },
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)(ValueContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            isCompact: isCompact,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--value-container`
                                },
                                ...commonProps.isMulti && commonProps.hasValue && !(0, $2Z7Iz.isAppleDevice)() && {
                                    // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                    // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                    // DST Accessibility.
                                    role: 'application'
                                }
                            },
                            children: [
                                this.renderPlaceholderOrValue(),
                                this.renderInput()
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)(IndicatorsContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--indicators-container`
                                }
                            },
                            children: [
                                this.renderClearIndicator(),
                                this.renderLoadingIndicator(),
                                this.renderDropdownIndicator()
                            ]
                        })
                    ]
                }),
                this.renderMenu(),
                this.renderFormField(),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7uagk.NotifyOpenLayerObserver), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
}

});
parcelRegister("eEtcC", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", () => $1a3d0f2eb875e1af$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $1a3d0f2eb875e1af$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $1a3d0f2eb875e1af$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $1a3d0f2eb875e1af$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("bChGW", function(module, exports) {

$parcel$export(module.exports, "components", () => $ea75c1778b4e3ad2$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $ea75c1778b4e3ad2$export$71abc632aa29e6fe);

var $h1QWG = parcelRequire("h1QWG");

var $eZFhY = parcelRequire("eZFhY");

var $i48X9 = parcelRequire("i48X9");

var $95iuW = parcelRequire("95iuW");

var $dS5G5 = parcelRequire("dS5G5");

var $aA8TC = parcelRequire("aA8TC");

var $hqcPo = parcelRequire("hqcPo");

var $8l2RA = parcelRequire("8l2RA");

var $kKm82 = parcelRequire("kKm82");

var $hpcbi = parcelRequire("hpcbi");
const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $95iuW.ClearIndicator),
    Control: (0, $eZFhY.default),
    DropdownIndicator: (0, $95iuW.DropdownIndicator),
    Group: (0, $i48X9.default),
    GroupHeading: (0, $i48X9.GroupHeading),
    IndicatorsContainer: (0, $h1QWG.IndicatorsContainer),
    Input: (0, $dS5G5.default),
    LoadingIndicator: (0, $95iuW.LoadingIndicator),
    Menu: (0, $aA8TC.default),
    MenuList: (0, $aA8TC.MenuList),
    MenuPortal: (0, $aA8TC.MenuPortal),
    LoadingMessage: (0, $aA8TC.LoadingMessage),
    NoOptionsMessage: (0, $aA8TC.NoOptionsMessage),
    MultiValue: (0, $hqcPo.default),
    MultiValueContainer: (0, $hqcPo.MultiValueContainer),
    MultiValueLabel: (0, $hqcPo.MultiValueLabel),
    MultiValueRemove: (0, $hqcPo.MultiValueRemove),
    Option: (0, $8l2RA.default),
    Placeholder: (0, $kKm82.default),
    SelectContainer: (0, $h1QWG.SelectContainer),
    SingleValue: (0, $hpcbi.default),
    ValueContainer: (0, $h1QWG.ValueContainer)
};
const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
        ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
        ...props.components
    });

});

parcelRegister("jtVgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe53037961824c2$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $c8F86 = parcelRequire("c8F86");

var $39bHe = parcelRequire("39bHe");
function $afe53037961824c2$export$2e2bcd8739ae039(props) {
    return (0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c8F86.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $39bHe.default), {
        ...props
    });
}

});
parcelRegister("c8F86", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb54a2dcae79e275$export$2e2bcd8739ae039);
/* dummy-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gyjU7 = parcelRequire("gyjU7");
const $fb54a2dcae79e275$var$dummyInputStyles = null;
function $fb54a2dcae79e275$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $gyjU7.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
        ref: innerRef,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d3acm _syaz3acm _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ]),
        ...filteredProps
    });
}

});

parcelRegister("39bHe", function(module, exports) {

$parcel$export(module.exports, "default", () => $00ee388602b33ee1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $gyjU7 = parcelRequire("gyjU7");
const $00ee388602b33ee1$var$dummyInputStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 1,
    padding: 0,
    position: 'relative',
    background: 0,
    border: 0,
    caretColor: 'transparent',
    color: 'transparent',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'inherit',
    gridArea: '1 / 1 / 2 / 3',
    insetInlineStart: -100,
    label: 'dummyInput',
    opacity: 0,
    outline: 0,
    transform: 'scale(.01)'
});
function $00ee388602b33ee1$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $gyjU7.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ref: innerRef,
        ...filteredProps,
        css: $00ee388602b33ee1$var$dummyInputStyles
    });
}

});


parcelRegister("9cRAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a388fa48a9e96271$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $hU6tE = parcelRequire("hU6tE");

var $9Oi37 = parcelRequire("9Oi37");
const $a388fa48a9e96271$var$RequiredInput = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hU6tE.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Oi37.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;

});
parcelRegister("hU6tE", function(module, exports) {

$parcel$export(module.exports, "default", () => $945267b00a632302$export$2e2bcd8739ae039);
/* required-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGmKJ = parcelRequire("eGmKJ");
const $945267b00a632302$var$styles = null;
const $945267b00a632302$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $2OMIu.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _jqf61a21 _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $eGmKJ.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$945267b00a632302$export$2e2bcd8739ae039 = $945267b00a632302$var$RequiredInput;

});

parcelRegister("9Oi37", function(module, exports) {

$parcel$export(module.exports, "default", () => $c26802938ecd7698$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $eGmKJ = parcelRequire("eGmKJ");
function $c26802938ecd7698$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c26802938ecd7698$var$styles = {
    name: "1fj9brw-requiredInput",
    styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
};
const $c26802938ecd7698$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $c26802938ecd7698$var$styles,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $eGmKJ.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c26802938ecd7698$export$2e2bcd8739ae039 = $c26802938ecd7698$var$RequiredInput;

});


parcelRegister("galqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15a49c0b3452f71$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $59IMp = parcelRequire("59IMp");

var $3jzRI = parcelRequire("3jzRI");
const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $59IMp.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $3jzRI.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                onClick: $e15a49c0b3452f71$var$blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}

});
parcelRegister("59IMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $96c08116303d9e3a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gyjU7 = parcelRequire("gyjU7");
const $96c08116303d9e3a$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $5uXOq.useRef)(false);
    const isTop = (0, $5uXOq.useRef)(false);
    const touchStart = (0, $5uXOq.useRef)(0);
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $5uXOq.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $gyjU7.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("3jzRI", function(module, exports) {

$parcel$export(module.exports, "default", () => $840302f0f43020c5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $840302f0f43020c5$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $840302f0f43020c5$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $840302f0f43020c5$var$preventTouchMove(e) {
    e.preventDefault();
}
function $840302f0f43020c5$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $840302f0f43020c5$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $840302f0f43020c5$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $840302f0f43020c5$var$activeScrollLocks = 0;
const $840302f0f43020c5$var$listenerOptions = {
    capture: false,
    passive: false
};
function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $5uXOq.useRef)({});
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$840302f0f43020c5$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $840302f0f43020c5$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $840302f0f43020c5$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$840302f0f43020c5$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $840302f0f43020c5$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("7uagk", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $7a4261c0e93bff6e$export$17baa7c95b6ba1b8);

var $9Mkr0 = parcelRequire("9Mkr0");
function $7a4261c0e93bff6e$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore - hot-116676
    (0, $9Mkr0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("81i5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3ccfcdca5695e58$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $7ZLLh = parcelRequire("7ZLLh");

var $bbz9Z = parcelRequire("bbz9Z");
const $a3ccfcdca5695e58$var$LiveRegion = (props)=>(0, $VSDnB.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ZLLh.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bbz9Z.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;

});
parcelRegister("7ZLLh", function(module, exports) {

$parcel$export(module.exports, "default", () => $419a6948853c8feb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dQlbw = parcelRequire("dQlbw");

var $7lhj2 = parcelRequire("7lhj2");
const $419a6948853c8feb$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isOptionDisabled: isOptionDisabled, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, isLoading: isLoading } = selectProps;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $5uXOq.useMemo)(()=>({
            ...(0, $dQlbw.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $5uXOq.useMemo)(()=>{
        let message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    const ariaResults = (0, $5uXOq.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ScreenReaderText = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7lhj2.default), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7lhj2.default), {
                "aria-live": ariaLive,
                role: "status",
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$419a6948853c8feb$export$2e2bcd8739ae039 = $419a6948853c8feb$var$LiveRegion;

});
parcelRegister("dQlbw", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", () => $d3258ad64818881e$export$a7265767c78f9bae);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ const $d3258ad64818881e$export$a7265767c78f9bae = {
    onChange: (props)=>{
        const { action: action, label: label = '', isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? `option ${label}, deselected` : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? `option ${label}, selected.` : '';
            default:
                return '';
        }
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return inputValue ? `${resultsMessage} for search term ${inputValue}.` : '';
    }
};

});

parcelRegister("7lhj2", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ce650310f44beb$export$2e2bcd8739ae039);
/* a11y-text.tsx generated by @compiled/babel-plugin v0.36.1 */ // Assistive text to describe visual elements. Hidden for sighted users.

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $59ce650310f44beb$var$styles = null;
const $59ce650310f44beb$var$A11yText = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _jqf6ydhy _uiztglyw _o5721q9c",
            "-a11yText"
        ]),
        ...props
    });
var $59ce650310f44beb$export$2e2bcd8739ae039 = $59ce650310f44beb$var$A11yText;

});


parcelRegister("bbz9Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $412616b9b75aa026$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $dQlbw = parcelRequire("dQlbw");

var $4Z3qi = parcelRequire("4Z3qi");
const $412616b9b75aa026$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isOptionDisabled: isOptionDisabled, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, isLoading: isLoading } = selectProps;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $5uXOq.useMemo)(()=>({
            ...(0, $dQlbw.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $5uXOq.useMemo)(()=>{
        let message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    const ariaResults = (0, $5uXOq.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ScreenReaderText = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-results"
    }, ariaResults));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4Z3qi.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4Z3qi.default), {
        "aria-live": ariaLive,
        role: "status"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$412616b9b75aa026$export$2e2bcd8739ae039 = $412616b9b75aa026$var$LiveRegion;

});
parcelRegister("4Z3qi", function(module, exports) {

$parcel$export(module.exports, "default", () => $1acf6ce83a1ce1d0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $f8Sb3 = parcelRequire("f8Sb3");
function $1acf6ce83a1ce1d0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
const $1acf6ce83a1ce1d0$var$styles = {
    name: "jvmzbk-a11yText",
    styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;user-select:none;white-space:nowrap"
};
const $1acf6ce83a1ce1d0$var$A11yText = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $1acf6ce83a1ce1d0$var$styles,
        ...props
    });
var $1acf6ce83a1ce1d0$export$2e2bcd8739ae039 = $1acf6ce83a1ce1d0$var$A11yText;

});



parcelRegister("5JAlL", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);

var $8QpSo = parcelRequire("8QpSo");

var $bXu2O = parcelRequire("bXu2O");
const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, $8QpSo.default)((0, $bXu2O.stripDiacritics));
const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $bXu2O.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("bXu2O", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", () => $df93339199dda18e$export$b5bee4b27048330b);
const $df93339199dda18e$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $df93339199dda18e$var$diacriticToBase = {};
for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
    let diacritic = $df93339199dda18e$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
    return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
};

});



parcelRegister("iaInK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e85c90096c52fe4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gyjU7 = parcelRequire("gyjU7");
function $7e85c90096c52fe4$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $5uXOq.useRef)(undefined);
    const mounted = (0, $5uXOq.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $5uXOq.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        const inputValue = (0, $gyjU7.handleInputChange)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("9uJ4X", function(module, exports) {

$parcel$export(module.exports, "default", () => $72b6d9d338d10de1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("3c98u", function(module, exports) {

$parcel$export(module.exports, "default", () => $628a0199069e875a$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $5uXOq.useRef)(null);
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});


parcelRegister("hT6ku", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $3f79b132df1e01ff$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $3f79b132df1e01ff$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $3f79b132df1e01ff$export$71abc632aa29e6fe);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gMMNe = parcelRequire("gMMNe");

var $bChGW = parcelRequire("bChGW");

var $jldZL = parcelRequire("jldZL");
const $3f79b132df1e01ff$var$menuDialogStyles = null;
const $3f79b132df1e01ff$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`,
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _1pby16oo _bfhk1bhr _16qseva7"
        ]),
        children: children
    });
});
// ==============================
// Custom Components
// ==============================
const $3f79b132df1e01ff$var$dropdownStyles = null;
const $3f79b132df1e01ff$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1bsbzwfg _12l2v77o _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gMMNe))), {
            color: "currentColor",
            label: ""
        })
    });
const $3f79b132df1e01ff$var$controlStyles = null;
const $3f79b132df1e01ff$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: innerRef,
        className: (0, $bwpsq.default)([
            "_85i51b66 _1q51u2gc _y4tiu2gc _bozgu2gc"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Control, {
            ...props,
            innerProps: innerProps
        })
    });
const $3f79b132df1e01ff$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Control, {
            ...props
        })
    });
// NOTE `props` intentionally omitted from `Fragment`
const $3f79b132df1e01ff$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        children: children
    });
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
const $3f79b132df1e01ff$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).ClearIndicator, {
        ...props
    });
const $3f79b132df1e01ff$var$MultiValueRemove = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).MultiValueRemove, {
        ...props
    });
const $3f79b132df1e01ff$export$71abc632aa29e6fe = {
    Control: $3f79b132df1e01ff$var$Control,
    DropdownIndicator: $3f79b132df1e01ff$var$DropdownIndicator,
    Menu: $3f79b132df1e01ff$var$Menu,
    ClearIndicator: $3f79b132df1e01ff$var$ClearIndicator,
    MultiValueRemove: $3f79b132df1e01ff$var$MultiValueRemove
};

});
parcelRegister("gMMNe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd994b90fa78030d2d1c292998636115>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c386fa4cb21167b0$var$_react = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c386fa4cb21167b0$var$_search = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("hyOJh")));

var $c386fa4cb21167b0$var$_search2 = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("77ZoC")));
function $c386fa4cb21167b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c386fa4cb21167b0$var$SearchIcon = (props)=>/*#__PURE__*/ $c386fa4cb21167b0$var$_react.default.createElement($c386fa4cb21167b0$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $c386fa4cb21167b0$var$_search2.default
    }, props));
$c386fa4cb21167b0$var$SearchIcon.Name = 'SearchIconMigration';
var $c386fa4cb21167b0$var$_default = module.exports.default = $c386fa4cb21167b0$var$SearchIcon;

});
parcelRegister("77ZoC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5308cfd5e45a5605$var$_react = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5308cfd5e45a5605$var$_search = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("hyOJh")));
function $5308cfd5e45a5605$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5308cfd5e45a5605$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $5308cfd5e45a5605$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $5308cfd5e45a5605$var$_search.default
    }));
$5308cfd5e45a5605$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $5308cfd5e45a5605$var$_default = module.exports.default = $5308cfd5e45a5605$var$EditorSearchIcon;

});



parcelRegister("9DWu0", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $072287da151cf77b$export$17baa7c95b6ba1b8);

var $9Mkr0 = parcelRequire("9Mkr0");
function $072287da151cf77b$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore error TS2353: Object literal may only specify known properties, and &#39;onClose&#39; does not exist in type &#39;{ isOpen?: boolean | undefined; }&#39;.
    (0, $9Mkr0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});




parcelRegister("hQWyD", function(module, exports) {

$parcel$export(module.exports, "isValidFailedExperience", () => $4557ff6e37d018ec$export$883079293b9cad76);
const $4557ff6e37d018ec$var$ignoredErrorStatusCode = [
    401,
    403,
    429
];
const $4557ff6e37d018ec$export$883079293b9cad76 = (experience, // the type for error is 'any' because consumers of the share config can pass in custom error objects
error)=>{
    const errorStatusCode = error.code || error.status || error.statusCode;
    if ($4557ff6e37d018ec$var$ignoredErrorStatusCode.includes(parseInt(errorStatusCode))) {
        experience.abort({
            metadata: {
                error: error
            }
        });
        return;
    }
    experience.failure({
        metadata: {
            error: error
        }
    });
};

});

parcelRegister("65uFp", function(module, exports) {

$parcel$export(module.exports, "renderShareDialogExp", () => $8388968bcc7a2bcd$export$99c0383421ae57eb);
$parcel$export(module.exports, "shareSubmitExp", () => $8388968bcc7a2bcd$export$31627ee726f40567);

var $7Zbvr = parcelRequire("7Zbvr");
var $boHLC = parcelRequire("boHLC");
const $8388968bcc7a2bcd$export$99c0383421ae57eb = new (0, $boHLC.UFOExperience)('render-share-dialog', {
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $8388968bcc7a2bcd$export$31627ee726f40567 = new (0, $boHLC.UFOExperience)('share-submit-action', {
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});

});
parcelRegister("7Zbvr", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $e40e68027603de60$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $e40e68027603de60$export$cc26007c03242fff);
var $e40e68027603de60$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $e40e68027603de60$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("boHLC", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $69d53cdb5241e240$export$c00d22927c60484a);

var $iLwDN = parcelRequire("iLwDN");
class $69d53cdb5241e240$export$c00d22927c60484a extends (0, $iLwDN.UFOAbstractExperience) {
}

});
parcelRegister("iLwDN", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $cc70575b2203e361$export$d31c89db257648c);

var $7Jxgt = parcelRequire("7Jxgt");


var $1vlV8 = parcelRequire("1vlV8");

var $dCAsn = parcelRequire("dCAsn");

var $dlucd = parcelRequire("dlucd");

var $blQsS = parcelRequire("blQsS");

var $9tjMO = parcelRequire("9tjMO");

var $1CRHx = parcelRequire("1CRHx");

var $jZA09 = parcelRequire("jZA09");

var $hM2B6 = parcelRequire("hM2B6");

var $7Zbvr = parcelRequire("7Zbvr");
const $cc70575b2203e361$var$getPageVisibleState = ()=>{
    return !(0, $1CRHx.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $blQsS.PageVisibleState).VISIBLE : (0, $blQsS.PageVisibleState).HIDDEN;
};
const $cc70575b2203e361$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $9tjMO.roundPerfNow)();
};
class $cc70575b2203e361$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $jZA09.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $blQsS.PageVisibleState).MIXED;
            (0, $dlucd.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $7Zbvr.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $7Zbvr.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $dCAsn.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $hM2B6.canTransition)(this.state, newState)) {
            (0, $dCAsn.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $jZA09.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $7Jxgt.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $1vlV8.getGlobalEventStream)().push((0, $1vlV8.unsubscribeEvent)((0, $blQsS.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $dCAsn.ufolog)('this.parent', this.parent);
                (0, $1vlV8.getGlobalEventStream)().push((0, $1vlV8.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $dCAsn.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $dCAsn.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $jZA09.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
            (0, $dlucd.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $dCAsn.ufolog)('subscribed', this.id);
                (0, $1vlV8.getGlobalEventStream)().push((0, $1vlV8.subscribeEvent)((0, $blQsS.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $blQsS.FMP_MARK) && name !== (0, $blQsS.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $dCAsn.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $cc70575b2203e361$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $jZA09.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $blQsS.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $blQsS.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $dCAsn.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $dlucd.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $jZA09.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $jZA09.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $jZA09.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $dCAsn.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $bbbd8b5766b053fb$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $bbbd8b5766b053fb$export$2295b861f318254a = '0.1.5';

parcelRegister("1vlV8", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $d117cb8be5e8747a$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $d117cb8be5e8747a$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $d117cb8be5e8747a$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $d117cb8be5e8747a$export$7c957416596ca127);

var $dCAsn = parcelRequire("dCAsn");

var $blQsS = parcelRequire("blQsS");
const $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $d117cb8be5e8747a$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $d117cb8be5e8747a$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $dCAsn.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $d117cb8be5e8747a$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $blQsS.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $d117cb8be5e8747a$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $blQsS.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $d117cb8be5e8747a$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $blQsS.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("dCAsn", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $c8856379f9e2d7e8$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $c8856379f9e2d7e8$export$d53d07b6034c4560);
class $c8856379f9e2d7e8$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $c8856379f9e2d7e8$export$4ab84f6f04f6566d = new $c8856379f9e2d7e8$var$UFOLogger();
const $c8856379f9e2d7e8$export$b4958caff08a0960 = (...args)=>{
    $c8856379f9e2d7e8$export$4ab84f6f04f6566d.log(...args);
};
const $c8856379f9e2d7e8$export$d53d07b6034c4560 = (...args)=>{
    $c8856379f9e2d7e8$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("blQsS", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $2d245cff606eb60d$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $2d245cff606eb60d$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $2d245cff606eb60d$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $2d245cff606eb60d$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $2d245cff606eb60d$export$837e0f79a8056912);
var $2d245cff606eb60d$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $2d245cff606eb60d$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $2d245cff606eb60d$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $2d245cff606eb60d$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $2d245cff606eb60d$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $2d245cff606eb60d$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $2d245cff606eb60d$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $2d245cff606eb60d$export$9f2bf58999404c75 = 'fmp';
const $2d245cff606eb60d$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("dlucd", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $46b8336a04974a29$export$13e680397ec8f3eb);

var $1CRHx = parcelRequire("1CRHx");
class $46b8336a04974a29$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $1CRHx.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $46b8336a04974a29$export$13e680397ec8f3eb = new $46b8336a04974a29$var$VisibilityChangeObserver();

});
parcelRegister("1CRHx", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $5d24ea5e24f61a4f$export$15e172712955e18f);
const $5d24ea5e24f61a4f$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("9tjMO", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $29608d3bcf65c265$export$5f490af6b2b115cf);
const $29608d3bcf65c265$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("jZA09", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $175f7a63840c5fab$export$81b70111112841a0);
const $175f7a63840c5fab$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("hM2B6", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $6edf4365ea9733d4$export$178881f329fdb81f);

var $jZA09 = parcelRequire("jZA09");
const $6edf4365ea9733d4$var$UFOStateAvailableTransitions = {
    [(0, $jZA09.UFOExperienceState).NOT_STARTED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ],
    [(0, $jZA09.UFOExperienceState).STARTED.id]: [
        (0, $jZA09.UFOExperienceState).IN_PROGRESS.id,
        (0, $jZA09.UFOExperienceState).BLOCKED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $jZA09.UFOExperienceState).BLOCKED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).BLOCKED.id]: [
        (0, $jZA09.UFOExperienceState).RECOVERED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).RECOVERED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).SUCCEEDED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ],
    [(0, $jZA09.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $jZA09.UFOExperienceState).SUCCEEDED.id,
        (0, $jZA09.UFOExperienceState).FAILED.id,
        (0, $jZA09.UFOExperienceState).ABORTED.id
    ],
    [(0, $jZA09.UFOExperienceState).FAILED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ],
    [(0, $jZA09.UFOExperienceState).ABORTED.id]: [
        (0, $jZA09.UFOExperienceState).STARTED.id
    ]
};
const $6edf4365ea9733d4$export$178881f329fdb81f = (state1, state2)=>{
    return $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id] && $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});




parcelRegister("2sAb4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d485dd997db54c76$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $b2oBK = parcelRequire("b2oBK");
// ErrorBoundary does not support in functional component
// eslint-disable-next-line @repo/internal/react/no-class-components
class $d485dd997db54c76$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) createAnalyticsEvent((0, $b2oBK.errorEncountered)(undefined, {
            message: error.message,
            errorClass: error.name
        })).fire((0, $b2oBK.CHANNEL_ID));
        this.setState({
            hasError: true
        });
    }
    render() {
        const { hasError: hasError } = this.state;
        if (hasError) // Silently fail.
        return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}
var $d485dd997db54c76$export$2e2bcd8739ae039 = (0, $cb25w.default)()($d485dd997db54c76$var$ErrorBoundary);

});

parcelRegister("7ZU6o", function(module, exports) {

$parcel$export(module.exports, "default", () => $3769956cd18ef333$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $55GMe = parcelRequire("55GMe");
const $3769956cd18ef333$var$MessagesIntlProvider = ({ intl: intl, children: children })=>{
    const mergedMessages = (0, $5uXOq.useMemo)(()=>{
        return {
            ...intl.messages,
            ...(0, $55GMe.getMessagesForLocale)(intl.locale)
        };
    }, [
        intl.messages,
        intl.locale
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: intl.locale,
        messages: mergedMessages,
        defaultLocale: "en-US",
        children: children
    });
};
var $3769956cd18ef333$export$2e2bcd8739ae039 = (0, $8RXs9.default)($3769956cd18ef333$var$MessagesIntlProvider);

});
parcelRegister("55GMe", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $8fc7d6e642efa1c9$export$d0a3169680473b6c);
// Cannot import from `../i18n` because there is `../i18n.tsx` file there.
/* eslint-disable @atlassian/tangerine/import/no-dangling-index */ 
var $aiyiV = parcelRequire("aiyiV");
var $c7HRD = parcelRequire("c7HRD");
var $gdvwP = parcelRequire("gdvwP");
var $1mT6n = parcelRequire("1mT6n");
var $axcS0 = parcelRequire("axcS0");
var $gM6wy = parcelRequire("gM6wy");
var $jCrgt = parcelRequire("jCrgt");
var $ddwcq = parcelRequire("ddwcq");
var $2Slqk = parcelRequire("2Slqk");
var $byDyk = parcelRequire("byDyk");
var $9y8hX = parcelRequire("9y8hX");
var $bMFAQ = parcelRequire("bMFAQ");
var $4JZF5 = parcelRequire("4JZF5");
var $dzumV = parcelRequire("dzumV");
var $fH3rr = parcelRequire("fH3rr");
var $16RW6 = parcelRequire("16RW6");
var $hrNSu = parcelRequire("hrNSu");
var $ioYTp = parcelRequire("ioYTp");
var $iQCSg = parcelRequire("iQCSg");
var $hkr2R = parcelRequire("hkr2R");
var $7dbDF = parcelRequire("7dbDF");
var $8zZLq = parcelRequire("8zZLq");
var $dGOFQ = parcelRequire("dGOFQ");
var $64yeQ = parcelRequire("64yeQ");
var $iTJhG = parcelRequire("iTJhG");
const $8fc7d6e642efa1c9$var$localesMessagesMap = {
    cs: $aiyiV.default,
    da: $c7HRD.default,
    de: $gdvwP.default,
    en: $1mT6n.default,
    en_GB: $axcS0.default,
    en_ZZ: $gM6wy.default,
    es: $jCrgt.default,
    et: $ddwcq.default,
    fi: $2Slqk.default,
    fr: $byDyk.default,
    hu: $9y8hX.default,
    is: $bMFAQ.default,
    it: $4JZF5.default,
    ja: $dzumV.default,
    ko: $fH3rr.default,
    nb: $16RW6.default,
    nl: $hrNSu.default,
    pl: $ioYTp.default,
    pt_BR: $iQCSg.default,
    'pt-BR': (0, $iQCSg.default),
    pt_PT: $hkr2R.default,
    'pt-PT': (0, $hkr2R.default),
    ro: $7dbDF.default,
    ru: $8zZLq.default,
    sk: $dGOFQ.default,
    sv: $64yeQ.default,
    zh: $iTJhG.default
};
const $8fc7d6e642efa1c9$export$d0a3169680473b6c = (locale)=>{
    let messages = $8fc7d6e642efa1c9$var$localesMessagesMap[locale];
    if (!messages) {
        const parentLocale = locale.split(/[-_]/)[0];
        messages = $8fc7d6e642efa1c9$var$localesMessagesMap[parentLocale];
    }
    if (!messages) messages = (0, $1mT6n.default);
    return messages;
};

});
parcelRegister("aiyiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b03a8517fda6267e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $b03a8517fda6267e$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Odkaz zkop\xedrov\xe1n do schr\xe1nky",
    'fabric.elements.share.copylink.button.text': "Zkop\xedrovat odkaz",
    'fabric.elements.share.copypubliclink.button.text': "Kop\xedrovat ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.failure.icon.label': 'Ikona chyby',
    'fabric.elements.share.failure.message': "Nelze sd\xedlet",
    'fabric.elements.share.form.comment.label': "Zpr\xe1va (voliteln\xe1)",
    'fabric.elements.share.form.comment.placeholder': "N\u011Bco, co by m\u011Bli v\u011Bd\u011Bt?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "P\u0159\xedjemci uvid\xed n\xe1zev str\xe1nky a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.info.message.no.invite.jira': "P\u0159\xedjemci uvid\xed n\xe1zev po\u017Eadavku a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "P\u0159\xedjemci uvid\xed n\xe1zev po\u017Eadavku a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.no-permissions': "Nem\xe1te mo\u017Enost sd\xedlet.",
    'fabric.elements.share.form.public.send': "Odeslat ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.form.public.share': "Sd\xedlet ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.form.required-field.summary': "Povinn\xe1 pole jsou ozna\u010Dena hv\u011Bzdi\u010Dkou.",
    'fabric.elements.share.form.retry': 'Zkusit znovu',
    'fabric.elements.share.form.send': 'Odeslat',
    'fabric.elements.share.form.share': "Sd\xedlet",
    'fabric.elements.share.form.title': "Sd\xedlet",
    'fabric.elements.share.form.user-picker.add-more': "Zadejte v\xedce",
    'fabric.elements.share.form.user-picker.label.confluence': "Jm\xe9na, t\xfdmy, skupiny nebo e-maily",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Jm\xe9na, t\xfdmy nebo skupiny",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Jm\xe9na nebo t\xfdmy",
    'fabric.elements.share.form.user-picker.label.email-only': 'E-maily',
    'fabric.elements.share.form.user-picker.label.jira': "Jm\xe9na, t\xfdmy nebo e-maily",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Pro \u201E{inputValue}\u201C se nepoda\u0159ilo naj\xedt \u017E\xe1dn\xe9 v\xfdsledky.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Pro \u201E{inputValue}\u201C se nepoda\u0159ilo naj\xedt \u017E\xe1dn\xe9 v\xfdsledky. Pozv\u011Bte lidi pomoc\xed jejich e-mailov\xe9 adresy.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "nap\u0159. Marie, T\xfdm pomeran\u010D, skupina-jedna",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "nap\u0159. Marie, T\xfdm pomeran\u010D",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "nap\u0159. marie@spolecnost.cz",
    'fabric.elements.share.form.user-picker.placeholder.jira': "nap\u0159. Marie, T\xfdm pomeran\u010D, marie@spolecnost.cz",
    'fabric.elements.share.form.user-picker.validation.required': "Vyberte alespo\u0148 jednoho u\u017Eivatele, skupinu, t\xfdm nebo e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Vyberte alespo\u0148 jednu osobu, t\xfdm, skupinu nebo e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Vyberte alespo\u0148 jednu osobu, t\xfdm nebo skupinu",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Vyberte alespo\u0148 jednu osobu nebo t\xfdm",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Vyberte alespo\u0148 jeden e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Vyberte alespo\u0148 jednu osobu, t\xfdm nebo e-mail",
    'fabric.elements.share.in.integration.button': "Sd\xedlet v: {integrationName}",
    'fabric.elements.share.invite.to.confluence': 'Pozvat do Confluence',
    'fabric.elements.share.invite.to.jira': 'Pozvat do Jira',
    'fabric.elements.share.main.tab.text.confluence': "Sd\xedlet str\xe1nku",
    'fabric.elements.share.main.tab.text.jira': "Sd\xedlet po\u017Eadavek",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Sd\xedlet",
    'fabric.elements.share.success.message': "{object, select,blogpost {P\u0159\xedsp\u011Bvek na blogu byl sd\xedlen}board {Board byl sd\xedlen}calendar {Kalend\xe1\u0159 byl sd\xedlen}draft {Koncept byl sd\xedlen}filter {Filtr byl sd\xedlen}issue {Po\u017Eadavek byl sd\xedlen}summary {Souhrn byl sd\xedlen}list {Seznam byl sd\xedlen}timeline {\u010Casov\xe1 osa byla sd\xedlena}form {Formul\xe1\u0159 byl sd\xedlen}media {Multim\xe9dia byla sd\xedlena}page {Str\xe1nka byla sd\xedlena}project {Projekt byl sd\xedlen}pullrequest {Pull request byl sd\xedlen}question {Ot\xe1zka byla sd\xedlena}report {Sestava byla sd\xedlena}repository {Repozit\xe1\u0159 byl sd\xedlen}request {\u017D\xe1dost byla sd\xedlena}roadmap {\u010Casov\xe1 osa byla sd\xedlena}site {Web byl sd\xedlen}space {Prostor byl sd\xedlen}other {Odkaz byl sd\xedlen}}",
    'fabric.elements.share.to.integration.button': "Sd\xedlet ve slu\u017Eb\u011B {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona sd\xedlen\xed",
    'fabric.elements.share.trigger.button.invite.text': 'Pozvat',
    'fabric.elements.share.trigger.button.text': "Sd\xedlet",
    'fabric.elements.share.trigger.button.tooltip.text': "Sd\xedlet"
};

});

parcelRegister("c7HRD", function(module, exports) {

$parcel$export(module.exports, "default", () => $40449a444ce6f8c1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $40449a444ce6f8c1$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link er kopieret til udklipsholder',
    'fabric.elements.share.copylink.button.text': 'Kopier link',
    'fabric.elements.share.copypubliclink.button.text': "Kopi\xe9r offentligt link",
    'fabric.elements.share.failure.icon.label': 'Fejlikon',
    'fabric.elements.share.failure.message': 'Kan ikke deles',
    'fabric.elements.share.form.comment.label': 'Besked (valgfrit)',
    'fabric.elements.share.form.comment.placeholder': "Er der noget, de b\xf8r vide?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Modtagere vil se navnet p\xe5 siden og din besked",
    'fabric.elements.share.form.info.message.no.invite.jira': "Modtagere vil se navnet p\xe5 sagen og din meddelelse",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Modtagere f\xe5r vist navnet p\xe5 sagen og din besked",
    'fabric.elements.share.form.no-permissions': 'Du kan ikke dele.',
    'fabric.elements.share.form.public.send': 'Send offentligt link',
    'fabric.elements.share.form.public.share': 'Del offentligt link',
    'fabric.elements.share.form.required-field.summary': "P\xe5kr\xe6vede felter er markeret med en stjerne",
    'fabric.elements.share.form.retry': "Pr\xf8v igen",
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Del',
    'fabric.elements.share.form.title': 'Del',
    'fabric.elements.share.form.user-picker.add-more': 'Indtast mere',
    'fabric.elements.share.form.user-picker.label.confluence': 'Navne, teams, grupper eller e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Navne, teams eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Navne eller teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Navne, teams eller e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi kunne ikke finde nogen resultater for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi kunne ikke finde nogen resultater for "{inputValue}". Invit\xe9r personer via e-mailadresser.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'f.eks. Maria, Team Orange, gruppe et',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'f.eks. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'f.eks. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'f.eks. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': "V\xe6lg mindst \xe9n bruger, \xe9n gruppe, \xe9t team eller \xe9n e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe6lg mindst en person, et team, en gruppe eller en e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe6lg mindst en person, et team eller en gruppe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe6lg mindst en person eller et team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe6lg mindst en e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe6lg mindst en person, et team eller en e-mail",
    'fabric.elements.share.in.integration.button': 'Del i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Inviter til Confluence',
    'fabric.elements.share.invite.to.jira': 'Inviter til Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Del side',
    'fabric.elements.share.main.tab.text.jira': 'Del sag',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Del',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogindl\xe6g delt}board {Tavle delt}calendar {Kalender delt}draft {Udkast delt}filter {Filter delt}issue {Sag delt}summary {Oversigt delt}list {Liste delt}timeline {Tidslinje delt}form {Formular delt}media {Medier delt}page {Side delt}project {Projekt delt}pullrequest {Pullanmodning delt}question {Sp\xf8rgsm\xe5l delt}report {Rapport delt}repository {Lager delt}request {Anmodning delt}roadmap {Tidslinje delt}site {Websted delt}space {Omr\xe5de delt}other {Link delt}}",
    'fabric.elements.share.to.integration.button': 'Del med {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Del ikon',
    'fabric.elements.share.trigger.button.invite.text': "Invit\xe9r",
    'fabric.elements.share.trigger.button.text': 'Del',
    'fabric.elements.share.trigger.button.tooltip.text': 'Del'
};

});

parcelRegister("gdvwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9ad081aeac1c38f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $c9ad081aeac1c38f$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link in Zwischenablage kopiert',
    'fabric.elements.share.copylink.button.text': 'Link kopieren',
    'fabric.elements.share.copypubliclink.button.text': "\xd6ffentlichen Link kopieren",
    'fabric.elements.share.failure.icon.label': 'Fehler-Symbol',
    'fabric.elements.share.failure.message': "Teilen nicht m\xf6glich",
    'fabric.elements.share.form.comment.label': 'Nachricht (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Irgendetwas Wissenswertes?',
    'fabric.elements.share.form.info.message.no.invite.confluence': "Empf\xe4nger sehen den Namen der Seite und Ihre Nachricht",
    'fabric.elements.share.form.info.message.no.invite.jira': "Empf\xe4nger sehen den Namen des Vorgangs und Ihre Nachricht",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Empf\xe4nger sehen den Namen des Vorgangs und Ihre Nachricht",
    'fabric.elements.share.form.no-permissions': "Sie k\xf6nnen keine Elemente teilen.",
    'fabric.elements.share.form.public.send': "\xd6ffentlichen Link senden",
    'fabric.elements.share.form.public.share': "\xd6ffentlichen Link teilen",
    'fabric.elements.share.form.required-field.summary': 'Pflichtfelder sind mit einem Sternchen markiert.',
    'fabric.elements.share.form.retry': 'Erneut versuchen',
    'fabric.elements.share.form.send': 'Senden',
    'fabric.elements.share.form.share': 'Teilen',
    'fabric.elements.share.form.title': 'Teilen',
    'fabric.elements.share.form.user-picker.add-more': 'Weitere eingeben',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namen, Teams, Gruppen oder E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namen, Teams oder Gruppen',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namen oder Teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.label.jira': 'Namen, Teams oder E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Es wurden keine Ergebnisse f\xfcr \u201E{inputValue}\u201C gefunden.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Es wurden keine Ergebnisse f\xfcr \u201E{inputValue}\u201C gefunden. Laden Sie Personen mittels E-Mail-Adresse ein.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "z.\xa0B. Maria, Team Orange, Gruppe eins",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "z.\xa0B. Maria, Team Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "z.\xa0B. maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "z.\xa0B. Maria, Team Orange, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "W\xe4hlen Sie mindestens einen Benutzer, eine Gruppe, ein Team oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "W\xe4hlen Sie mindestens eine Person, ein Team, eine Gruppe oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "W\xe4hlen Sie mindestens eine Person, ein Team oder eine Gruppe aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "W\xe4hlen Sie mindestens eine Person oder ein Team aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "W\xe4hlen Sie mindestens eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "W\xe4hlen Sie mindestens eine Person, ein Team oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.in.integration.button': 'In {integrationName} teilen',
    'fabric.elements.share.invite.to.confluence': 'Zu Confluence einladen',
    'fabric.elements.share.invite.to.jira': 'Zu Jira einladen',
    'fabric.elements.share.main.tab.text.confluence': 'Seite teilen',
    'fabric.elements.share.main.tab.text.jira': 'Vorgang teilen',
    'fabric.elements.share.menu.email.label': 'E-Mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Teilen',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blogpost geteilt}board {Board geteilt}calendar {Kalender geteilt}draft {Entwurf geteilt}filter {Filter geteilt}issue {Vorgang geteilt}summary {Zusammenfassung geteilt}list {Liste geteilt}timeline {Zeitleiste geteilt}form {Formular geteilt}media {Medien geteilt}page {Seite geteilt}project {Projekt geteilt}pullrequest {Pull-Anfrage geteilt}question {Frage geteilt}report {Bericht geteilt}repository {Repository geteilt}request {Anfrage geteilt}roadmap {Zeitleiste geteilt}site {Site geteilt}space {Bereich geteilt}other {Link geteilt}}',
    'fabric.elements.share.to.integration.button': 'Mit {integrationName} teilen',
    'fabric.elements.share.trigger.button.icon.label': 'Teilen-Symbol',
    'fabric.elements.share.trigger.button.invite.text': 'Einladen',
    'fabric.elements.share.trigger.button.text': 'Teilen',
    'fabric.elements.share.trigger.button.tooltip.text': 'Teilen'
};

});

parcelRegister("1mT6n", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ae943d78330d54c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $5ae943d78330d54c$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copied to clipboard',
    'fabric.elements.share.copylink.button.text': 'Copy link',
    'fabric.elements.share.copypubliclink.button.text': 'Copy public link',
    'fabric.elements.share.failure.icon.label': 'Error icon',
    'fabric.elements.share.failure.message': 'Unable to share',
    'fabric.elements.share.form.comment.label': 'Message (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Anything they should know?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Recipients will see the name of the page and your message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Recipients will see the name of the issue and your message',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Recipients will see the name of the work item and your message',
    'fabric.elements.share.form.no-permissions': 'You do not have the ability to share.',
    'fabric.elements.share.form.public.send': 'Send public link',
    'fabric.elements.share.form.public.share': 'Share public link',
    'fabric.elements.share.form.required-field.summary': 'Required fields are marked with an asterisk',
    'fabric.elements.share.form.retry': 'Retry',
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Share',
    'fabric.elements.share.form.title': 'Share',
    'fabric.elements.share.form.user-picker.add-more': 'Enter more',
    'fabric.elements.share.form.user-picker.label.confluence': 'Names, teams, groups, or emails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Names, teams, or groups',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Names or teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'Emails',
    'fabric.elements.share.form.user-picker.label.jira': 'Names, teams, or emails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'We couldn\u2019t find any results for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'e.g. Maria, Team Orange, group-one',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'e.g. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'e.g. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'e.g. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': 'Select at least one user, group, team or email.',
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Select at least one person, team, group, or email',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Select at least one person, team, or group',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Select at least one person or team',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Select at least one email',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Select at least one person, team, or email',
    'fabric.elements.share.in.integration.button': 'Share in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invite to Confluence',
    'fabric.elements.share.invite.to.jira': 'Invite to Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Share page',
    'fabric.elements.share.main.tab.text.jira': 'Share issue',
    'fabric.elements.share.menu.email.label': 'Email',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Share',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}',
    'fabric.elements.share.to.integration.button': 'Share to {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Share icon',
    'fabric.elements.share.trigger.button.invite.text': 'Invite',
    'fabric.elements.share.trigger.button.text': 'Share',
    'fabric.elements.share.trigger.button.tooltip.text': 'Share'
};

});

parcelRegister("axcS0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4de2c962853eb1a7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $4de2c962853eb1a7$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copied to clipboard',
    'fabric.elements.share.copylink.button.text': 'Copy link',
    'fabric.elements.share.copypubliclink.button.text': 'Copy public link',
    'fabric.elements.share.failure.icon.label': 'Error icon',
    'fabric.elements.share.failure.message': 'Unable to share',
    'fabric.elements.share.form.comment.label': 'Message (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Anything they should know?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Recipients will see the name of the page and your message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Recipients will see the name of the issue and your message',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Recipients will see the name of the work item and your message',
    'fabric.elements.share.form.no-permissions': 'You do not have the ability to share.',
    'fabric.elements.share.form.public.send': 'Send public link',
    'fabric.elements.share.form.public.share': 'Share public link',
    'fabric.elements.share.form.required-field.summary': 'Required fields are marked with an asterisk',
    'fabric.elements.share.form.retry': 'Retry',
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Share',
    'fabric.elements.share.form.title': 'Share',
    'fabric.elements.share.form.user-picker.add-more': 'Enter more',
    'fabric.elements.share.form.user-picker.label.confluence': 'Names, teams, groups, or emails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Names, teams, or groups',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Names or teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'Emails',
    'fabric.elements.share.form.user-picker.label.jira': 'Names, teams, or emails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'We couldn\u2019t find any results for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'e.g. Maria, Team Orange, group-one',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'e.g. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'e.g. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'e.g. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': 'Select at least one user, group, team or email.',
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Select at least one person, team, group, or email',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Select at least one person, team, or group',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Select at least one person or team',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Select at least one email',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Select at least one person, team, or email',
    'fabric.elements.share.in.integration.button': 'Share in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invite to Confluence',
    'fabric.elements.share.invite.to.jira': 'Invite to Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Share page',
    'fabric.elements.share.main.tab.text.jira': 'Share issue',
    'fabric.elements.share.menu.email.label': 'Email',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Share',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}',
    'fabric.elements.share.to.integration.button': 'Share to {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Share icon',
    'fabric.elements.share.trigger.button.invite.text': 'Invite',
    'fabric.elements.share.trigger.button.text': 'Share',
    'fabric.elements.share.trigger.button.tooltip.text': 'Share'
};

});

parcelRegister("gM6wy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ca0de856e819520$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $8ca0de856e819520$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u2063\u2062Link copied to clipboard\x8f\u200D\x8f\u2061\u206B\u206A\u200D\u206E\x8f\x8d\x8f\u206C\u206A\u206C\x90\u200C\x9d\u206F\x81\x90\u206C\u206B\u2061\u206A\x8d\x8d\u206A\x90\u206C\x8d\u2060\u2061\u2063\u2064",
    'fabric.elements.share.copylink.button.text': "\u2063\u2062Copy link\x8d\u206C\x8f\u206E\u206A\u200D\u206E\x9d\x90\u061C\u2061\x8d\u206E\x90\u206D\x8d\u2061\u200C\u206F\x8d\u2061\x8d\u206A\x81\x81\u206B\u206E\u200C\x9d\u2060\u206F\x81\u2063\u2064",
    'fabric.elements.share.copypubliclink.button.text': "\u2063\u2062Copy public link\u2061\x81\u200C\u206F\u200D\u206D\x9d\u2061\x8f\u206C\u206D\x8f\u2061\x81\x81\u206A\u206A\x90\u206E\u2060\u061C\u2060\u206F\u206E\u206B\u206D\u200C\u061C\u200C\x9d\x9d\x9d\u2063\u2064",
    'fabric.elements.share.failure.icon.label': "\u2063\u2062Error icon\u200D\u061C\u206C\u206E\u206F\u2061\u206E\u206F\x8f\x90\u2060\u061C\x90\u061C\u200D\u200C\u206A\u206A\u200C\u200C\u206E\u206F\x90\u200D\u2061\u206B\u206A\u2060\x8f\u200C\x90\u206E\u2063\u2064",
    'fabric.elements.share.failure.message': "\u2063\u2062Unable to share\x8f\u206A\u206E\x90\u200D\x90\u2061\x90\u206A\x8d\u206D\x8d\x9d\u2060\x90\x9d\u206C\u2061\u206C\x9d\x8d\u206C\u206C\u206B\x9d\x8d\u206B\x9d\u200C\x81\u200D\u2060\u2063\u2064",
    'fabric.elements.share.form.comment.label': "\u2063\u2062Message (optional)\x8d\u200D\u206F\x8d\u206B\x90\u2060\u2061\u206D\u206E\u206F\u2061\u2060\x8f\u206C\u206E\u206B\x81\u200C\x90\u206D\u206C\x8d\u2060\u061C\u2060\u2060\x81\x8f\u200D\u200D\u206F\u2063\u2064",
    'fabric.elements.share.form.comment.placeholder': "\u2063\u2062Anything they should know?\u2060\u206F\x81\u061C\x8d\u2061\u2061\u200D\u206B\u206B\u206F\u206A\x81\u2061\u200C\u2060\x8d\x90\u206E\x90\u206E\x81\u206D\u200D\x8f\u206C\u206E\u206A\u206C\u2060\u206A\u206D\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u2063\u2062Recipients will see the name of the page and your message\u206F\u2060\x81\x90\u200C\u200C\x81\x90\u061C\u2060\x8d\u200C\x81\u206A\u2061\u061C\u206E\x8f\u2060\u206D\u206D\x8f\u200C\u200C\x9d\u206D\u200C\u2060\x8f\x8f\u206A\u200C\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u2063\u2062Recipients will see the name of the issue and your message\x81\u206C\u206C\x8d\u206F\u200D\u206B\u200D\u2060\u061C\u2061\x81\u206D\x8d\u206A\x8d\x90\u206B\x8d\u206A\x8f\x8d\u206D\u206E\u206D\x9d\u200D\u206C\u206E\x9d\u206F\u2060\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u2063\u2062Recipients will see the name of the work item and your message\u061C\u206B\u200D\u206B\u206D\u2060\u200D\u200C\u200C\x90\x8f\u206D\u2060\u200C\x8f\u206E\u206B\x9d\x9d\u206E\x8f\u2060\x90\u206F\u2060\x9d\u206D\u2060\u206F\x81\u206B\u206B\u2063\u2064",
    'fabric.elements.share.form.no-permissions': "\u2063\u2062You do not have the ability to share.\x8f\u206B\u206F\x8f\u061C\u206B\u206D\x81\u206C\u206F\u206F\u206C\u2060\u206E\u200D\u200D\x81\x81\u200D\u206B\x8d\u206E\x9d\u206C\x8f\u206A\u2061\u2060\u2061\x90\u206D\u206E\u2063\u2064",
    'fabric.elements.share.form.public.send': "\u2063\u2062Send public link\u206E\u206B\x8d\u206D\u206E\u206C\u2060\u206F\u206B\u206F\u061C\u2060\x8d\x9d\u200D\u206F\u2060\u2061\u206E\x81\u061C\u206F\u206D\x8d\x8f\u200C\x8d\x81\u206D\u2061\u206B\u2060\u2063\u2064",
    'fabric.elements.share.form.public.share': "\u2063\u2062Share public link\u2060\u2061\x90\u200D\u206A\u206A\u200D\u206F\u200D\x8f\u206B\u200C\u2060\u206C\u061C\u200D\u206C\u200C\u206F\x9d\u206F\x8d\u200D\x81\x9d\u206D\u2061\u2061\u206D\u2061\u061C\u206E\u2063\u2064",
    'fabric.elements.share.form.required-field.summary': "\u2063\u2062Required fields are marked with an asterisk\x8d\x8d\u200D\u206C\u2060\u206F\u206A\x9d\u206F\u200D\x90\x9d\u206A\u206D\x9d\u206B\u206C\u200C\x90\x81\x81\u206C\u2061\u200C\u200C\u2060\u200D\u061C\u206B\x9d\u206B\x9d\u2063\u2064",
    'fabric.elements.share.form.retry': "\u2063\u2062Retry\u200C\u206B\u206F\u206D\u200C\x9d\u206C\u2061\u061C\u200C\u206C\u206C\u206A\u206C\u206C\x8d\x90\u206A\x9d\x8d\u206C\u206A\u200C\x81\x8f\x8f\u2061\u2061\u206F\x90\u200C\x8d\u2063\u2064",
    'fabric.elements.share.form.send': "\u2063\u2062Send\x90\u200D\u206D\u200C\x8f\u2060\u2060\u200D\u061C\u200D\x8d\u200C\u206D\u206F\u200D\u206E\u206B\u206D\u2061\u206F\x9d\u206F\u206F\u206F\u061C\u206A\u206D\u206A\x8d\x8d\u2060\u061C\u2063\u2064",
    'fabric.elements.share.form.share': "\u2063\u2062Share\u2060\x8f\u200C\u200D\x9d\x9d\u206A\u206D\u206B\u206C\x81\x90\x8d\u2060\x8f\x8f\u206C\u200C\u206A\u200C\u061C\u2060\u061C\x8f\u061C\x8f\u206D\u206E\x8f\x8f\u200C\x81\u2063\u2064",
    'fabric.elements.share.form.title': "\u2063\u2062Share\u206E\u206B\u2060\u206E\x9d\u206C\x8d\u061C\x90\x9d\u206A\u206B\u206D\u206F\u200C\u206F\u200D\x9d\u061C\u200D\u206E\u2060\u206E\x81\u206F\u061C\x8d\x81\x8f\u2061\u206B\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.add-more': "\u2063\u2062Enter more\u2060\x9d\u2060\x81\u2061\u200D\u206B\u206F\u206E\x8d\x8d\u206B\u200C\u061C\u061C\u200C\x9d\u200D\u2060\x8d\x9d\u206C\x8f\u206A\x8f\u206B\x8d\x9d\u061C\u206C\u200D\u2060\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.confluence': "\u2063\u2062Names, teams, groups, or emails\u206F\x9d\u206F\u206D\x81\u2061\x90\u200D\u206E\u2060\x90\x8f\x81\x8d\u2061\u206D\u200D\u206D\u200D\u206A\x9d\x81\u206F\u206C\u061C\x90\u200C\u200D\x81\x8d\u206E\u200D\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u2063\u2062Names, teams, or groups\u206A\x8d\x8f\u206F\x90\u206E\u200D\u206E\u2060\u061C\u206F\u206C\x8d\x8d\x9d\u200C\x90\u206F\x9d\u061C\u206C\x90\x90\u206B\u2060\u061C\u2060\u206E\x8d\u2061\x8f\u206A\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u2063\u2062Names or teams\x8d\u206B\u206C\u206D\u206E\x90\x9d\u200C\u206A\x90\x90\u206D\u200D\u206F\u200D\x8f\u061C\u061C\u206F\u206F\u061C\u206E\u206F\u206B\u2060\u061C\u2060\u200D\u2061\x9d\x8d\x90\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-only': "\u2063\u2062Emails\x81\u061C\x9d\u206C\x8f\u206A\u200C\u206A\u206F\u2060\u206B\x9d\u206F\x90\x9d\x9d\u206A\u061C\x8f\u206B\u206F\u206E\x8f\u061C\x9d\u206C\u206E\u206F\u2060\u206C\x8f\u206C\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.jira': "\u2063\u2062Names, teams, or emails\u200C\u2061\u206D\u206B\u200C\u061C\u206F\u061C\u2060\u200C\x8f\x8f\u2061\u206D\x81\u206B\x8f\u061C\u200D\x8d\x8f\u2061\u206E\u061C\u206D\x81\u2060\u061C\u2060\u206B\u206F\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '\u2063\u2062We couldn\u2019t find any results for "{inputValue}".\u206D\x8f\x8f\u2061\u206D\u200C\x81\x9d\u206D\x90\x8f\u200C\u206E\u206F\u206B\x8f\u061C\u2061\u2061\u206F\u2061\x81\x9d\u2060\x90\u2060\u206B\x9d\u200D\u206D\u200D\u206A\u2063\u2064',
    'fabric.elements.share.form.user-picker.no-options.generic': '\u2063\u2062We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.\x8d\u2061\u061C\x8f\x9d\u206E\u061C\u200D\u2060\u206A\u206A\x9d\u061C\x9d\x8f\x90\u2060\u2060\u2061\u206E\u061C\u206F\u206C\x90\u2061\u2060\u206D\u200D\u206B\x8f\x90\u200D\u2063\u2064',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u2063\u2062e.g. Maria, Team Orange, group-one\u200D\u206D\x81\u2061\u200D\u2060\u206B\u061C\x90\x8f\u206C\u206E\u206A\x8f\x8f\u061C\u206E\u200D\x90\x8d\x8d\x90\u206C\x90\u2061\u206C\x9d\u206F\x90\u206F\u206C\x9d\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u2063\u2062e.g. Maria, Team Orange\x81\u206E\u206C\x81\u061C\x9d\u2061\u206A\u206F\x9d\x90\u206C\u200C\x90\u2061\u200D\u206D\x90\u206F\x81\x81\u061C\u206C\u206C\u206C\x8d\u061C\x8d\u206F\u061C\u206A\u061C\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u2063\u2062e.g. maria@company.com\x8d\u206B\u206A\u061C\x9d\u206B\x81\u2060\u206B\x9d\u206B\u206C\u206B\u200C\u206C\u200D\u206C\u206F\u061C\u206B\x90\u206A\x8f\u2060\u200D\u061C\u206F\u206E\u200C\x8f\u061C\x8d\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u2063\u2062e.g. Maria, Team Orange, maria@company.com\x8f\x8d\u206A\u200C\u2061\u061C\u206D\x81\u2061\x8d\u206A\x8d\u200D\x8d\u206A\u206D\u2061\u2061\u061C\u200C\x9d\u200C\u206C\u200D\u206A\x8f\u206C\u2060\u206D\u206B\x9d\u2061\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required': "\u2063\u2062Select at least one user, group, team or email.\x81\u206E\u206A\x81\u206F\u2061\x8f\x9d\x9d\u206D\u2061\u061C\u206B\u206F\x9d\u200C\u200D\u206D\u206B\x81\x81\u206A\u206F\u200C\x8d\x90\x81\u206B\u2060\u061C\x9d\u206B\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u2063\u2062Select at least one person, team, group, or email\u206B\x81\u206E\x9d\u206D\x90\u200D\x9d\u200C\u206D\x9d\u2060\u206B\x8d\x8f\u206C\u206C\u2061\u206D\u206F\x8d\x90\u200C\x90\u200D\u206F\u200C\u206A\u206D\u2061\u2060\u200D\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u2063\u2062Select at least one person, team, or group\x8d\u206C\u206F\u061C\x90\u206D\x9d\u206D\u206A\u200C\u206E\x8f\u2060\u206D\x81\u206A\x8d\u206A\x9d\x9d\u2060\u200C\u206A\x8f\u200C\x9d\x9d\u206E\u2061\x8d\x81\x8f\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u2063\u2062Select at least one person or team\u206A\u206F\u200D\x8f\u206D\u206F\u206B\x90\u206C\x81\u206E\u2060\u200D\u2061\x81\u206A\x8d\u206E\u206F\x8f\x9d\x8f\x8f\u2060\x9d\x81\x81\u206A\u206C\x81\u200C\u2061\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u2063\u2062Select at least one email\x8f\u206F\u206D\x81\u200D\u206B\u206B\x8d\u206D\x8d\u200C\x8d\x9d\u200C\u206F\u200D\u200D\u2060\u2061\u206F\u061C\x8d\u206F\x90\u200D\u2061\u206A\x8d\x90\u200C\x8f\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u2063\u2062Select at least one person, team, or email\u2060\x9d\u2060\u206A\x90\u200C\u200C\u061C\u206C\u200D\x8d\u200D\u200D\u2060\u200C\u206C\u206A\u206D\u206D\u206E\u200D\u200D\x90\u061C\u200C\u2060\u206A\u206B\u2061\u206A\u2060\x8f\u2063\u2064",
    'fabric.elements.share.in.integration.button': "\u2063\u2062Share in {integrationName}\u2060\u061C\x90\u206A\u2061\u206C\u206D\u2061\u206D\x90\x8f\x8f\u200C\u206B\u206A\x9d\u206C\u2061\u061C\u200C\x90\u206E\u206A\u206F\u206C\x81\u200C\x8f\u206C\u200C\x81\u206D\u2063\u2064",
    'fabric.elements.share.invite.to.confluence': "\u2063\u2062Invite to Confluence\u206A\u206E\x8f\u2061\x8f\u206D\u206B\x9d\u206A\x9d\x8f\u206F\u061C\u200D\u206B\u206A\u200D\x9d\u2060\u206D\u200D\x8f\u2061\x8d\u2060\u2061\u206E\x81\u206C\u061C\u200D\u200D\u2063\u2064",
    'fabric.elements.share.invite.to.jira': "\u2063\u2062Invite to Jira\u061C\x8f\u2060\u2061\x8f\u206F\x8d\x81\x9d\x81\u206C\u2060\u200C\u206E\u206E\u061C\x90\u2060\u206E\u2060\u200D\x8d\x81\u206B\u206F\x8d\u200D\u206B\u2061\x9d\u206C\x8f\u2063\u2064",
    'fabric.elements.share.main.tab.text.confluence': "\u2063\u2062Share page\x81\u206A\u206F\u206D\u206C\u206C\x8f\x8f\x8f\x8d\x8f\x8f\u206A\u206C\u206F\x9d\u200C\x8f\u200D\u200C\u200D\u2060\x8d\u206B\x8f\u2061\u061C\u206E\x81\u200C\x8d\u206E\u2063\u2064",
    'fabric.elements.share.main.tab.text.jira': "\u2063\u2062Share issue\x9d\x9d\x8f\x9d\u061C\u206D\u200D\u206E\x90\x81\u200D\x9d\x81\x90\x8f\u206C\u061C\u200D\x9d\x9d\u206C\x9d\u206F\u2061\u2060\u2060\u206A\u206E\u061C\x81\u200D\x8f\u2063\u2064",
    'fabric.elements.share.menu.email.label': "\u2063\u2062Email\u206E\x90\u200D\u206B\u2061\u206C\u061C\u206A\u206A\u200C\u200C\x8f\u061C\x8f\u200C\u200C\u206C\u206D\u200C\u206A\x8f\x81\u206F\u2061\x8d\u2061\u206E\u2061\u206E\u206C\u206A\u206A\u2063\u2064",
    'fabric.elements.share.menu.slack.label': "\u2063\u2062Slack\u206B\u200C\u206B\x8f\u061C\u206D\x9d\u061C\x8f\u200D\u2060\u200D\x81\x90\u206C\u206F\u200C\x81\u2061\x9d\x8f\u206F\u200D\x8f\u206E\u200C\x8f\x81\u206C\u2060\x8d\u2060\u2063\u2064",
    'fabric.elements.share.popup.label': "\u2063\u2062Share\u206D\x9d\u206D\u206B\u206C\u200D\u200C\u206C\x8f\u206C\x90\x81\x81\x8d\x90\x8f\u206B\u206A\u2061\u200C\u206F\u206A\u200C\u206E\x9d\x8d\u206E\u200C\u200D\u200D\x81\u206C\u2063\u2064",
    'fabric.elements.share.success.message': "\u2063\u2062{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}\x8f\x8f\u206A\x81\x9d\u206F\u061C\u206F\u206A\u200C\u206C\u206F\u206F\x8d\x8d\u206C\u206C\x8d\u206C\u206D\u206C\u206A\u206E\u2060\u200D\x90\u061C\x90\x81\u206E\u206D\x9d\u2063\u2064",
    'fabric.elements.share.to.integration.button': "\u2063\u2062Share to {integrationName}\x9d\u206D\u200C\x9d\x8d\u206C\u206E\u206E\u206D\u206A\u2061\u200C\u2060\u206F\x90\u2061\x8d\u2061\u2061\u2060\x9d\u200D\x90\u200D\u206A\x9d\u061C\u200C\x9d\u206B\u2061\x8f\u2063\u2064",
    'fabric.elements.share.trigger.button.icon.label': "\u2063\u2062Share icon\x81\x90\u200C\x9d\u206C\u200D\x8f\x8f\u206E\x9d\u206F\u206B\x8f\u206F\x9d\x8d\x8d\u061C\u200D\x9d\x8f\u206C\u206F\u200D\u206D\u061C\x90\u206A\u200C\u206A\u206B\u2061\u2063\u2064",
    'fabric.elements.share.trigger.button.invite.text': "\u2063\u2062Invite\u2061\u200D\u206A\u206B\x9d\u206D\x8f\u200D\u206F\x81\u2060\u206B\u206B\x8f\x8f\u206E\u061C\u2061\x8f\u200C\u206E\x81\u2060\u061C\u061C\x9d\u206E\u061C\x9d\u206D\u206A\u061C\u2063\u2064",
    'fabric.elements.share.trigger.button.text': "\u2063\u2062Share\u206B\u206A\x81\x8d\x8d\x9d\x8f\u200C\u206D\u206D\x9d\u2061\x81\x81\u200D\u206F\u200C\u206C\u200D\x90\u206A\u206B\u206F\u061C\u061C\u206E\x9d\u2061\u200D\x90\x81\u206B\u2063\u2064",
    'fabric.elements.share.trigger.button.tooltip.text': "\u2063\u2062Share\u200C\u206F\u2061\u206A\x90\u200C\u061C\u200C\x8f\u200C\u206A\u206F\u206D\u2060\u061C\u2061\u206D\u206F\u206E\u206D\x8d\u200C\x90\u200C\u200D\u206A\u206E\x8d\u206A\u200C\u206C\u206A\u2063\u2064"
};

});

parcelRegister("jCrgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa4d05b5c2cb0939$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $fa4d05b5c2cb0939$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Enlace copiado en el portapapeles',
    'fabric.elements.share.copylink.button.text': 'Copiar enlace',
    'fabric.elements.share.copypubliclink.button.text': "Copiar enlace p\xfablico",
    'fabric.elements.share.failure.icon.label': 'Icono de error',
    'fabric.elements.share.failure.message': 'No se puede compartir',
    'fabric.elements.share.form.comment.label': 'Mensaje (opcional)',
    'fabric.elements.share.form.comment.placeholder': "\xbfHay algo que haya que saber?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Los destinatarios ver\xe1n el nombre de la p\xe1gina y tu mensaje",
    'fabric.elements.share.form.info.message.no.invite.jira': "Los destinatarios ver\xe1n el nombre de la incidencia y tu mensaje",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Los destinatarios ver\xe1n el nombre de la actividad y tu mensaje",
    'fabric.elements.share.form.no-permissions': 'No puedes compartir.',
    'fabric.elements.share.form.public.send': "Enviar enlace p\xfablico",
    'fabric.elements.share.form.public.share': "Compartir enlace p\xfablico",
    'fabric.elements.share.form.required-field.summary': "Los campos obligatorios est\xe1n marcados con un asterisco",
    'fabric.elements.share.form.retry': 'Reintentar',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.share': 'Compartir',
    'fabric.elements.share.form.title': 'Compartir',
    'fabric.elements.share.form.user-picker.add-more': "Introduce m\xe1s cosas",
    'fabric.elements.share.form.user-picker.label.confluence': "Nombres, equipos, grupos o correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nombres, equipos o grupos',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nombres o equipos',
    'fabric.elements.share.form.user-picker.label.email-only': "Correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.label.jira': "Nombres, equipos o correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'No hemos encontrado ning\xfan resultado para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'No hemos encontrado ning\xfan resultado para "{inputValue}". Invita a la gente mediante una direcci\xf3n de correo electr\xf3nico.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "p.\xa0ej. Mar\xeda, equipo naranja, grupo uno",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "p.\xa0ej. Mar\xeda, equipo naranja",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "p.\xa0ej. maria@empresa.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "p.\xa0ej. Mar\xeda, equipo naranja, maria@empresa.com",
    'fabric.elements.share.form.user-picker.validation.required': "Selecciona al menos un usuario, grupo, equipo o correo electr\xf3nico.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Selecciona al menos una persona, equipo, grupo o correo electr\xf3nico",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Selecciona al menos una persona, equipo o grupo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Selecciona al menos una persona o equipo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Selecciona al menos un correo electr\xf3nico",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Selecciona al menos una persona, equipo o correo electr\xf3nico",
    'fabric.elements.share.in.integration.button': 'Compartir en {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invitar a Confluence',
    'fabric.elements.share.invite.to.jira': 'Invitar a Jira',
    'fabric.elements.share.main.tab.text.confluence': "Compartir p\xe1gina",
    'fabric.elements.share.main.tab.text.jira': 'Compartir incidencia',
    'fabric.elements.share.menu.email.label': "Correo electr\xf3nico",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Compartir',
    'fabric.elements.share.success.message': "{object, select,blogpost {Entrada de blog compartida}board {Tablero compartido}calendar {Calendario compartido}draft {Borrador compartido}filter {Filtro compartido}issue {Incidencia compartida}summary {Resumen compartido}list {Lista compartida}timeline {Cronograma compartido}form {Formulario compartido}media {Recursos multimedia compartidos}page {P\xe1gina compartida}project {Proyecto compartido}pullrequest {Solicitud de incorporaci\xf3n de cambios compartida}question {Pregunta compartida}report {Informe compartido}repository {Repositorio compartido}request {Solicitud compartida}roadmap {Cronograma compartido}site {Sitio compartido}space {Espacio compartido}other {Enlace compartido}}",
    'fabric.elements.share.to.integration.button': 'Compartir en {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Icono de compartir',
    'fabric.elements.share.trigger.button.invite.text': 'Invitar',
    'fabric.elements.share.trigger.button.text': 'Compartir',
    'fabric.elements.share.trigger.button.tooltip.text': 'Compartir'
};

});

parcelRegister("ddwcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8a813df19fa2152$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Estonian
var $f8a813df19fa2152$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Link kopeeritud l\xf5ikelauale",
    'fabric.elements.share.copylink.button.text': 'Kopeeri link',
    'fabric.elements.share.failure.icon.label': 'Vea ikoon',
    'fabric.elements.share.failure.message': 'Jagamine nurjus',
    'fabric.elements.share.form.comment.placeholder': "S\xf5numi lisamine",
    'fabric.elements.share.form.retry': 'Proovi uuesti',
    'fabric.elements.share.form.send': 'Saada',
    'fabric.elements.share.form.title': 'Jaga',
    'fabric.elements.share.form.user-picker.add-more': 'Sisesta veel',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Me ei suutnud leida \xfchtegi tulemust seoses otsitavaga \u201E{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Me ei suutnud leida \xfchtegi tulemust seoses otsitavaga \u201E{inputValue}". Kutsu inimesi e-posti aadressi alusel.',
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Sisesta nimi v\xf5i meeskond",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Sisestage nimi, r\xfchm, meeskond v\xf5i meil",
    'fabric.elements.share.form.user-picker.placeholder.jira': "Sisestage nimi, tiim v\xf5i meil",
    'fabric.elements.share.form.user-picker.validation.required': "Valige v\xe4hemalt \xfcks kasutaja, r\xfchm, meeskond v\xf5i meil.",
    'fabric.elements.share.form.user-picker.validation.required.jira': "Valige v\xe4hemalt \xfcks kasutaja, tiim v\xf5i meil.",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blogipostitus jagatud} board {T\xf6\xf6laud jagatud} calendar {Kalender jagatud} draft {Mustand jagatud} filter {Filter jagatud} issue {Probleem jagatud} media {Meediafail jagatud} page {Leht jagatud} project {Projekt jagatud} pullrequest {T\xf5mbekutse jagatud} question {K\xfcsimus jagatud} report {Raport jagatud} repository {Koodihoidla jagatud} request {Taotlus jagatud} roadmap {T\xf6\xf6plaan jagatud} site {Sait jagatud} space {Ruum jagatud} other {Link jagatud}}",
    'fabric.elements.share.trigger.button.icon.label': 'Jagamisikoon',
    'fabric.elements.share.trigger.button.invite.text': 'Kutsu',
    'fabric.elements.share.trigger.button.text': 'Jaga',
    'fabric.elements.share.trigger.button.tooltip.text': 'Jaga'
};

});

parcelRegister("2Slqk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8abdec291b18f8c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $c8abdec291b18f8c$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Linkki kopioitu leikep\xf6yd\xe4lle",
    'fabric.elements.share.copylink.button.text': 'Kopioi linkki',
    'fabric.elements.share.copypubliclink.button.text': 'Kopioi julkinen linkki',
    'fabric.elements.share.failure.icon.label': 'Virhekuvake',
    'fabric.elements.share.failure.message': 'Ei voitu jakaa',
    'fabric.elements.share.form.comment.label': 'Viesti (valinnainen)',
    'fabric.elements.share.form.comment.placeholder': "Mit\xe4 muiden tulisi tiet\xe4\xe4?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Vastaanottajat n\xe4kev\xe4t sivun nimen ja viestisi",
    'fabric.elements.share.form.info.message.no.invite.jira': "Vastaanottajat n\xe4kev\xe4t asian nimen ja viestisi",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Vastaanottajat n\xe4kev\xe4t ty\xf6teht\xe4v\xe4n nimen ja viestisi",
    'fabric.elements.share.form.no-permissions': 'Sinulla ei ole jakamisoikeutta.',
    'fabric.elements.share.form.public.send': "L\xe4het\xe4 julkinen linkki",
    'fabric.elements.share.form.public.share': 'Jaa julkinen linkki',
    'fabric.elements.share.form.required-field.summary': "Pakolliset kent\xe4t on merkitty t\xe4hdell\xe4",
    'fabric.elements.share.form.retry': "Yrit\xe4 uudelleen",
    'fabric.elements.share.form.send': "L\xe4het\xe4",
    'fabric.elements.share.form.share': 'Jaa',
    'fabric.elements.share.form.title': 'Jaa',
    'fabric.elements.share.form.user-picker.add-more': "Sy\xf6t\xe4 lis\xe4\xe4",
    'fabric.elements.share.form.user-picker.label.confluence': "Nimet, tiimit, ryhm\xe4t tai s\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Nimet, tiimit tai ryhm\xe4t",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nimet tai tiimit',
    'fabric.elements.share.form.user-picker.label.email-only': "S\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.label.jira': "Nimet, tiimit tai s\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Tuloksia ei l\xf6ytynyt haulle "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Tuloksia ei l\xf6ytynyt haulle "{inputValue}". Kutsu henkil\xf6it\xe4 s\xe4hk\xf6postiosoitteen avulla.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "esim. Maria, Oranssi tiimi, ykk\xf6sryhm\xe4",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'esim. Maria, Oranssi tiimi',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'esim. maria@yritys.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'esim. Maria, Oranssi tiimi, maria@yritys.com',
    'fabric.elements.share.form.user-picker.validation.required': "Valitse v\xe4hint\xe4\xe4n yksi k\xe4ytt\xe4j\xe4, ryhm\xe4, tiimi tai s\xe4hk\xf6postiosoite.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi, ryhm\xe4 tai s\xe4hk\xf6postiosoite",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi tai ryhm\xe4",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6 tai tiimi",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Valitse v\xe4hint\xe4\xe4n yksi s\xe4hk\xf6postiosoite",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi tai s\xe4hk\xf6postiosoite",
    'fabric.elements.share.in.integration.button': 'Jaa sovelluksessa {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Kutsu Confluenceen',
    'fabric.elements.share.invite.to.jira': 'Kutsu Jiraan',
    'fabric.elements.share.main.tab.text.confluence': 'Jaa sivu',
    'fabric.elements.share.main.tab.text.jira': 'Jaa asia',
    'fabric.elements.share.menu.email.label': "S\xe4hk\xf6posti",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Jaa',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogijulkaisu jaettu}board {Taulu jaettu}calendar {Kalenteri jaettu}draft {Luonnos jaettu}filter {Suodatin jaettu}issue {Asia jaettu}summary {Yhteenveto jaettu}list {Luettelo jaettu}timeline {Aikajana jaettu}form {Lomake jaettu}media {Media jaettu}page {Sivu jaettu}project {Projekti jaettu}pullrequest {Pull-pyynt\xf6 jaettu}question {Kysymys jaettu}report {Raportti jaettu}repository {S\xe4il\xf6 jaettu}request {Pyynt\xf6 jaettu}roadmap {Aikajana jaettu}site {Sivusto jaettu}space {Ty\xf6tila jaettu}other {Linkki jaettu}}",
    'fabric.elements.share.to.integration.button': 'Jaa kohteeseen {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Jaa kuvake',
    'fabric.elements.share.trigger.button.invite.text': 'Kutsu',
    'fabric.elements.share.trigger.button.text': 'Jaa',
    'fabric.elements.share.trigger.button.tooltip.text': 'Jaa'
};

});

parcelRegister("byDyk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1bb494a2b2c3eb5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $f1bb494a2b2c3eb5$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Lien copi\xe9 dans le presse-papier",
    'fabric.elements.share.copylink.button.text': 'Copier le lien',
    'fabric.elements.share.copypubliclink.button.text': 'Copier le lien public',
    'fabric.elements.share.failure.icon.label': "Ic\xf4ne d'erreur",
    'fabric.elements.share.failure.message': 'Partage impossible',
    'fabric.elements.share.form.comment.label': 'Message (facultatif)',
    'fabric.elements.share.form.comment.placeholder': "D'autres choses \xe0 savoir\xa0?",
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Les destinataires verront le nom de la page et votre message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Les destinataires verront le nom du ticket et votre message',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Les destinataires verront le nom du ticket et votre message',
    'fabric.elements.share.form.no-permissions': 'Vous ne pouvez pas partager ce contenu.',
    'fabric.elements.share.form.public.send': 'Envoyer le lien public',
    'fabric.elements.share.form.public.share': 'Partager un lien public',
    'fabric.elements.share.form.required-field.summary': "Les champs obligatoires sont marqu\xe9s d'un ast\xe9risque",
    'fabric.elements.share.form.retry': "R\xe9essayer",
    'fabric.elements.share.form.send': 'Envoyer',
    'fabric.elements.share.form.share': 'Partager',
    'fabric.elements.share.form.title': 'Partager',
    'fabric.elements.share.form.user-picker.add-more': "Saisir plus d\u2019\xe9l\xe9ments",
    'fabric.elements.share.form.user-picker.label.confluence': "Noms, \xe9quipes, groupes ou e-mails",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Noms, \xe9quipes ou groupes",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Noms ou \xe9quipes",
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': "Noms, \xe9quipes ou e-mails",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Pas de r\xe9sultats pour \xab\xa0{inputValue}\xa0\xbb.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Pas de r\xe9sultats pour \xab\xa0{inputValue}\xa0\xbb. Invitez des personnes \xe0 l'aide d'une adresse e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "Par exemple, Maria, \xe9quipe Orange, groupe-1",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "Par exemple, Maria, \xe9quipe Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'Par exemple, maria@entreprise.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': "Par exemple, Maria, \xe9quipe Orange, maria@entreprise.com",
    'fabric.elements.share.form.user-picker.validation.required': "S\xe9lectionnez au moins un utilisateur, un groupe, une \xe9quipe ou une adresse e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "S\xe9lectionnez au moins une personne, une \xe9quipe, un groupe ou un e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "S\xe9lectionnez au moins une personne, une \xe9quipe ou un groupe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "S\xe9lectionnez au moins une personne ou \xe9quipe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "S\xe9lectionnez au moins un e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "S\xe9lectionnez au moins une personne, une \xe9quipe ou un e-mail",
    'fabric.elements.share.in.integration.button': 'Partager dans {integrationName}',
    'fabric.elements.share.invite.to.confluence': "Inviter \xe0 rejoindre Confluence",
    'fabric.elements.share.invite.to.jira': "Inviter \xe0 rejoindre Jira",
    'fabric.elements.share.main.tab.text.confluence': 'Partager la page',
    'fabric.elements.share.main.tab.text.jira': 'Partager le ticket',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Partager',
    'fabric.elements.share.success.message': "{object, select,blogpost {Billet de blog partag\xe9}board {Tableau partag\xe9}calendar {Calendrier partag\xe9}draft {Brouillon partag\xe9}filter {Filtre partag\xe9}issue {Ticket partag\xe9}summary {R\xe9sum\xe9 partag\xe9}list {Liste partag\xe9e}timeline {Chronologie partag\xe9e}form {Formulaire partag\xe9}media {M\xe9dia partag\xe9}page {Page partag\xe9e}project {Projet partag\xe9}pullrequest {Pull request partag\xe9e}question {Question partag\xe9e}report {Rapport partag\xe9}repository {D\xe9p\xf4t partag\xe9}request {Demande partag\xe9e}roadmap {Chronologie partag\xe9e}site {Site partag\xe9}space {Espace partag\xe9}other {Lien partag\xe9}}",
    'fabric.elements.share.to.integration.button': 'Partager avec {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "Ic\xf4ne de partage",
    'fabric.elements.share.trigger.button.invite.text': 'Inviter',
    'fabric.elements.share.trigger.button.text': 'Partager',
    'fabric.elements.share.trigger.button.tooltip.text': 'Partager'
};

});

parcelRegister("9y8hX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b7ac209639193ae$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $7b7ac209639193ae$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Hivatkoz\xe1s \xe1tm\xe1solva a v\xe1g\xf3lapra",
    'fabric.elements.share.copylink.button.text': "Hivatkoz\xe1s m\xe1sol\xe1sa",
    'fabric.elements.share.copypubliclink.button.text': "Publikus link m\xe1sol\xe1sa",
    'fabric.elements.share.failure.icon.label': 'Hiba ikon',
    'fabric.elements.share.failure.message': 'Nem lehet megosztani',
    'fabric.elements.share.form.comment.label': "\xdczenet (nem k\xf6telez\u0151)",
    'fabric.elements.share.form.comment.placeholder': "Van b\xe1rmi, amit \xe9rdemes tudni?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "A c\xedmzettek l\xe1tj\xe1k az oldal nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.info.message.no.invite.jira': "A c\xedmzettek l\xe1tj\xe1k az \xfcgy nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "A c\xedmzettek l\xe1tj\xe1k az \xfcgy nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.no-permissions': "Nincs lehet\u0151s\xe9ged a megoszt\xe1sra.",
    'fabric.elements.share.form.public.send': "Publikus link k\xfcld\xe9se",
    'fabric.elements.share.form.public.share': "Nyilv\xe1nos link megoszt\xe1sa",
    'fabric.elements.share.form.required-field.summary': "A k\xf6telez\u0151 mez\u0151k csillaggal vannak megjel\xf6lve",
    'fabric.elements.share.form.retry': "\xdajra",
    'fabric.elements.share.form.send': "K\xfcld\xe9s",
    'fabric.elements.share.form.share': "Megoszt\xe1s",
    'fabric.elements.share.form.title': "Megoszt\xe1s",
    'fabric.elements.share.form.user-picker.add-more': "Tov\xe1bbiak megad\xe1sa",
    'fabric.elements.share.form.user-picker.label.confluence': "Nevek, csapatok, csoportok vagy e-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nevek, csapatok vagy csoportok',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nevek vagy csapatok',
    'fabric.elements.share.form.user-picker.label.email-only': "E-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.label.jira': "Nevek, csapatok vagy e-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nincs tal\xe1lat a k\xf6vetkez\u0151 keres\xe9sre: \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nincs tal\xe1lat a k\xf6vetkez\u0151 keres\xe9sre: \u201E{inputValue}\u201D. H\xedvj meg embereket az e-mail-c\xedm\xfck alapj\xe1n.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "pl. M\xe1ria, Narancs csapat, egyes-csoport",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "pl. M\xe1ria, Narancs csapat",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'pl. maria@vallalat.hu',
    'fabric.elements.share.form.user-picker.placeholder.jira': "pl. M\xe1ria, Narancs csapat, maria@vallalat.hu",
    'fabric.elements.share.form.user-picker.validation.required': "V\xe1lassz ki legal\xe1bb egy felhaszn\xe1l\xf3t, csoportot, csapatot vagy e-mail-c\xedmet.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot, csoportot vagy e-mail-c\xedmet",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot vagy csoportot",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt vagy csapatot",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe1lassz ki legal\xe1bb egy e-mail-c\xedmet",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot vagy e-mail-c\xedmet",
    'fabric.elements.share.in.integration.button': "Megoszt\xe1s itt: {integrationName}",
    'fabric.elements.share.invite.to.confluence': "Megh\xedv\xe1s a Confluence-be",
    'fabric.elements.share.invite.to.jira': "Megh\xedv\xe1s a Jir\xe1ba",
    'fabric.elements.share.main.tab.text.confluence': "Oldal megoszt\xe1sa",
    'fabric.elements.share.main.tab.text.jira': "\xdcgy megoszt\xe1sa",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Megoszt\xe1s",
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogposzt megosztva}board {T\xe1bla megosztva}calendar {Napt\xe1r megosztva}draft {Piszkozat megosztva}filter {Sz\u0171r\u0151 megosztva}issue {\xdcgy megosztva}summary {\xd6sszefoglal\xf3 megosztva}list {Lista megosztva}timeline {Id\u0151vonal megosztva}form {\u0170rlap megosztva}media {M\xe9dia megosztva}page {Oldal megosztva}project {Projekt megosztva}pullrequest {Pull-k\xe9relem megosztva}question {K\xe9rd\xe9s megosztva}report {Jelent\xe9s megosztva}repository {Adatt\xe1r megosztva}request {K\xe9relem megosztva}roadmap {Id\u0151vonal megosztva}site {Webhely megosztva}space {Munkat\xe9r megosztva}other {Link megosztva}}",
    'fabric.elements.share.to.integration.button': "Megoszt\xe1s itt: {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikon megoszt\xe1sa",
    'fabric.elements.share.trigger.button.invite.text': "Megh\xedv\xe1s",
    'fabric.elements.share.trigger.button.text': "Megoszt\xe1s",
    'fabric.elements.share.trigger.button.tooltip.text': "Megoszt\xe1s"
};

});

parcelRegister("bMFAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $567821fb7188ce82$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ // Icelandic
var $567821fb7188ce82$export$2e2bcd8739ae039 = {
    'fabric.elements.share.form.title': 'Deila',
    'fabric.elements.share.form.send': 'Senda ',
    'fabric.elements.share.form.retry': 'Reyna aftur',
    'fabric.elements.share.form.comment.placeholder': "B\xe6ta vi\xf0 skilabo\xf0um",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Sl\xe1\xf0u inn nafn, teymi e\xf0a t\xf6lvup\xf3stur",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Sl\xe1\xf0u inn nafn e\xf0a teymi",
    'fabric.elements.share.form.user-picker.add-more': "F\xe6ra inn fleiri ",
    'fabric.elements.share.form.user-picker.validation.required': "Veldu a\xf0 minnsta kosti einn notanda, teymi e\xf0a netfang.",
    'fabric.elements.share.form.user-picker.no-options.domainBasedUserOnly': "\xde\xfa getur a\xf0eins bo\xf0i\xf0 f\xf3lki sem eru me\xf0 {domains} netf\xf6ng. Haf\xf0u samband vi\xf0 stj\xf3rnanda s\xed\xf0unnar \xfeinnar til a\xf0 bj\xf3\xf0a \xf6\xf0ru f\xf3lki.",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Ekki fundust neinar ni\xf0urst\xf6\xf0ur fyrir \u201E{inputValue}\u201C. Bj\xf3ddu f\xf3lki me\xf0 \xfev\xed a\xf0 nota netf\xf6ng.",
    'fabric.elements.share.form.user-picker.no-options.generic': 'Engar ni\xf0urst\xf6\xf0ur fundust fyrir "{inputValue}". Bj\xf3ddu f\xf3lki me\xf0 \xfev\xed a\xf0 nota t\xf6lvup\xf3stfang.',
    'fabric.elements.share.trigger.button.icon.label': "Deilingart\xe1kn",
    'fabric.elements.share.trigger.button.text': 'Deila',
    'fabric.elements.share.trigger.button.tooltip.text': 'Deila',
    'fabric.elements.share.trigger.button.invite.text': "Bo\xf0i\xf0",
    'fabric.elements.share.copylink.button.icon.label': "\u201EAfrita tengil\u201C-t\xe1kn",
    'fabric.elements.share.copylink.button.text': 'Afrita tengil',
    'fabric.elements.share.copied.to.clipboard.icon.label': "T\xe1kn sem s\xfdnir a\xf0 tengilinn hafi veri\xf0 afrita\xf0ur me\xf0 g\xf3\xf0um \xe1rangri",
    'fabric.elements.share.copied.to.clipboard.message': "Tengill afrita\xf0ur \xe1 klippibor\xf0",
    'fabric.elements.share.form.capabilities.info.message': "Bo\xf0skorti\xf0 \xfeitt ver\xf0ur sent til stj\xf3rnanda til sam\xfeykkis",
    'fabric.elements.share.failure.icon.label': "Villut\xe1kn",
    'fabric.elements.share.failure.message': "Ekki er h\xe6gt a\xf0 deila",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blog post shared} tafla {Board shared} dagatal {Calendar shared} uppkast {Draft shared} s\xeda {Filter shared} m\xe1lefni {Issue shared} mi\xf0ill {Media shared} s\xed\xf0a {Page shared} verkefni {Project shared} togbei\xf0ni {Pull Request shared} spurning {Question shared} sk\xfdrsla {Report shared} Gagnageymsla {Repository shared} bei\xf0ni {Request shared} vegv\xedsir {Roadmap shared} s\xed\xf0a {Site shared} sv\xe6\xf0i {Space shared} anna\xf0 {Link Shared}}",
    'fabric.elements.share.admin.notified.message': "Stj\xf3rnanda hefur veri\xf0 tilkynnt"
};

});

parcelRegister("4JZF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee9f8422b31a9859$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $ee9f8422b31a9859$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copiato negli appunti',
    'fabric.elements.share.copylink.button.text': 'Copia link',
    'fabric.elements.share.copypubliclink.button.text': 'Copia link pubblico',
    'fabric.elements.share.failure.icon.label': 'Icona Errore',
    'fabric.elements.share.failure.message': 'Impossibile effettuare la condivisione',
    'fabric.elements.share.form.comment.label': 'Messaggio (opzionale)',
    'fabric.elements.share.form.comment.placeholder': 'Vuoi comunicare loro qualcosa?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'I destinatari vedranno il nome della pagina e il tuo messaggio',
    'fabric.elements.share.form.info.message.no.invite.jira': 'I destinatari vedranno il nome del ticket e il tuo messaggio',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'I destinatari vedranno il nome del ticket e il tuo messaggio',
    'fabric.elements.share.form.no-permissions': 'Non puoi eseguire condivisioni.',
    'fabric.elements.share.form.public.send': 'Invia link pubblico',
    'fabric.elements.share.form.public.share': 'Condividi link pubblico',
    'fabric.elements.share.form.required-field.summary': 'I campi obbligatori sono contrassegnati da un asterisco',
    'fabric.elements.share.form.retry': 'Riprova',
    'fabric.elements.share.form.send': 'Invia',
    'fabric.elements.share.form.share': 'Condividi',
    'fabric.elements.share.form.title': 'Condividi',
    'fabric.elements.share.form.user-picker.add-more': 'Inerisci altri elementi',
    'fabric.elements.share.form.user-picker.label.confluence': 'Nomi, team, gruppi o indirizzi e-mail',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nomi, team o gruppi',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nomi o team',
    'fabric.elements.share.form.user-picker.label.email-only': 'Indirizzi e-mail',
    'fabric.elements.share.form.user-picker.label.jira': 'Nomi, team o indirizzi e-mail',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nessun risultato trovato per \u201C{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nessun risultato trovato per \u201C{inputValue}\u201D. Invita le persone inserendo il loro indirizzo e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'ad esempio Maria, Team Arancione, gruppo uno',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'ad esempio Maria, Team Arancione',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'ad esempio maria@azienda.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'ad esempio Maria, Team Arancione, maria@azienda.com',
    'fabric.elements.share.form.user-picker.validation.required': "Seleziona almeno un utente, un gruppo, un team o un'e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Seleziona almeno una persona, un team, un gruppo o un indirizzo e-mail.',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Seleziona almeno una persona, un team o un gruppo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Seleziona almeno una persona o un team.',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Seleziona almeno un indirizzo e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Seleziona almeno una persona, un team o un indirizzo e-mail',
    'fabric.elements.share.in.integration.button': 'Condividi in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invita in Confluence',
    'fabric.elements.share.invite.to.jira': 'Invita in Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Condividi pagina',
    'fabric.elements.share.main.tab.text.jira': 'Condividi ticket',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Condividi',
    'fabric.elements.share.success.message': '{object, select,blogpost {Post del blog condiviso}board {Board condivisa}calendar {Calendario condiviso}draft {Bozza condivisa}filter {Filtro condiviso}issue {Ticket condiviso}summary {Riepilogo condiviso}list {Elenco condiviso}timeline {Timeline condivisa}form {Modulo condiviso}media {Elemento multimediale condiviso}page {Pagina condiviso}project {Progetto condiviso}pullrequest {Pull request condivisa}question {Domanda condivisa}report {Report condiviso}repository {Repository condiviso}request {Richiesta condivisa}roadmap {Timeline condivisa}site {Sito condiviso}space {Spazio condiviso}other {Link condiviso}}',
    'fabric.elements.share.to.integration.button': 'Condividi in {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Icona Condividi',
    'fabric.elements.share.trigger.button.invite.text': 'Invita',
    'fabric.elements.share.trigger.button.text': 'Condividi',
    'fabric.elements.share.trigger.button.tooltip.text': 'Condividi'
};

});

parcelRegister("dzumV", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb77872613c037b3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $eb77872613c037b3$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F",
    'fabric.elements.share.copylink.button.text': "\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
    'fabric.elements.share.copypubliclink.button.text': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
    'fabric.elements.share.failure.icon.label': "\u30A8\u30E9\u30FC \u30A2\u30A4\u30B3\u30F3",
    'fabric.elements.share.failure.message': "\u5171\u6709\u3067\u304D\u307E\u305B\u3093",
    'fabric.elements.share.form.comment.label': "\u30E1\u30C3\u30BB\u30FC\u30B8 (\u30AA\u30D7\u30B7\u30E7\u30F3)",
    'fabric.elements.share.form.comment.placeholder': "\u5171\u6709\u5148\u306E\u30E6\u30FC\u30B6\u30FC\u3078\u306E\u30B3\u30E1\u30F3\u30C8\u304C\u3042\u308B\u5834\u5408\u306F\u3053\u3053\u306B\u66F8\u304D\u8FBC\u307F\u307E\u3059\u3002",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u53D7\u4FE1\u8005\u306B\u30DA\u30FC\u30B8\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u53D7\u4FE1\u8005\u306B\u8AB2\u984C\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u53D7\u4FE1\u8005\u306B\u4F5C\u696D\u9805\u76EE\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.no-permissions': "\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u3002",
    'fabric.elements.share.form.public.send': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u9001\u4FE1",
    'fabric.elements.share.form.public.share': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u5171\u6709",
    'fabric.elements.share.form.required-field.summary': "\u5FC5\u9808\u30D5\u30A3\u30FC\u30EB\u30C9\u306B\u306F\u30A2\u30B9\u30BF\u30EA\u30B9\u30AF\u304C\u4ED8\u3044\u3066\u3044\u307E\u3059",
    'fabric.elements.share.form.retry': "\u518D\u8A66\u884C",
    'fabric.elements.share.form.send': "\u9001\u4FE1",
    'fabric.elements.share.form.share': "\u5171\u6709",
    'fabric.elements.share.form.title': "\u5171\u6709",
    'fabric.elements.share.form.user-picker.add-more': "\u3055\u3089\u306B\u8FFD\u52A0",
    'fabric.elements.share.form.user-picker.label.confluence': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B0\u30EB\u30FC\u30D7",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u540D\u524D\u307E\u305F\u306F\u30C1\u30FC\u30E0",
    'fabric.elements.share.form.user-picker.label.email-only': "\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.label.jira': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '"{inputValue}" \u306B\u4E00\u81F4\u3059\u308B\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002',
    'fabric.elements.share.form.user-picker.no-options.generic': '"{inputValue}" \u306B\u4E00\u81F4\u3059\u308B\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u4F7F\u7528\u3057\u3066\u30E6\u30FC\u30B6\u30FC\u3092\u62DB\u5F85\u3057\u3066\u304F\u3060\u3055\u3044\u3002',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8\u3001\u30B0\u30EB\u30FC\u30D7\u30EF\u30F3",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u4F8B: sato@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8\u3001sato@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u30E6\u30FC\u30B6\u30FC\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u30C1\u30FC\u30E0\u3001\u30E1\u30FC\u30EB\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B0\u30EB\u30FC\u30D7\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u30E6\u30FC\u30B6\u30FC\u307E\u305F\u306F\u30C1\u30FC\u30E0\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.in.integration.button': "{integrationName} \u3067\u5171\u6709",
    'fabric.elements.share.invite.to.confluence': "Confluence \u306B\u62DB\u5F85",
    'fabric.elements.share.invite.to.jira': "Jira \u306B\u62DB\u5F85",
    'fabric.elements.share.main.tab.text.confluence': "\u30DA\u30FC\u30B8\u3092\u5171\u6709",
    'fabric.elements.share.main.tab.text.jira': "\u8AB2\u984C\u3092\u5171\u6709",
    'fabric.elements.share.menu.email.label': "\u30E1\u30FC\u30EB",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u5171\u6709",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u30D6\u30ED\u30B0\u6295\u7A3F\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}board {\u30DC\u30FC\u30C9\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}calendar {\u30AB\u30EC\u30F3\u30C0\u30FC\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}draft {\u4E0B\u66F8\u304D\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}filter {\u30D5\u30A3\u30EB\u30BF\u30FC\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}issue {\u8AB2\u984C\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}summary {\u8981\u7D04\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}list {\u30EA\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}timeline {\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}form {\u30D5\u30A9\u30FC\u30E0\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}media {\u30E1\u30C7\u30A3\u30A2\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}page {\u30DA\u30FC\u30B8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}project {\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}pullrequest {\u30D7\u30EB \u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}question {\u8CEA\u554F\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}report {\u30EC\u30DD\u30FC\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}repository {\u30EA\u30DD\u30B8\u30C8\u30EA\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}request {\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}roadmap {\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}site {\u30B5\u30A4\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}space {\u30B9\u30DA\u30FC\u30B9\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}other {\u30EA\u30F3\u30AF\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}}",
    'fabric.elements.share.to.integration.button': "{integrationName} \u3068\u5171\u6709",
    'fabric.elements.share.trigger.button.icon.label': "\u5171\u6709\u30A2\u30A4\u30B3\u30F3",
    'fabric.elements.share.trigger.button.invite.text': "\u62DB\u5F85",
    'fabric.elements.share.trigger.button.text': "\u5171\u6709",
    'fabric.elements.share.trigger.button.tooltip.text': "\u5171\u6709"
};

});

parcelRegister("fH3rr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c880483be1fc144$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $6c880483be1fc144$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\uB9C1\uD06C\uB97C \uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC\uD568",
    'fabric.elements.share.copylink.button.text': "\uB9C1\uD06C \uBCF5\uC0AC",
    'fabric.elements.share.copypubliclink.button.text': "\uACF5\uAC1C \uB9C1\uD06C \uBCF5\uC0AC",
    'fabric.elements.share.failure.icon.label': "\uC624\uB958 \uC544\uC774\uCF58",
    'fabric.elements.share.failure.message': "\uACF5\uC720\uD560 \uC218 \uC5C6\uC74C",
    'fabric.elements.share.form.comment.label': "\uBA54\uC2DC\uC9C0(\uC120\uD0DD \uC0AC\uD56D)",
    'fabric.elements.share.form.comment.placeholder': "\uC0AC\uC6A9\uC790\uAC00 \uC54C\uC544\uC57C \uD560 \uB0B4\uC6A9\uC774 \uC788\uC2B5\uB2C8\uAE4C?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\uC218\uC2E0\uC790\uAC00 \uD398\uC774\uC9C0 \uC774\uB984\uACFC \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.info.message.no.invite.jira': "\uC218\uC2E0\uC790\uAC00 \uC774\uC288 \uC774\uB984\uACFC \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\uC218\uC2E0\uC790\uAC00 \uC5C5\uBB34 \uD56D\uBAA9 \uC774\uB984 \uBC0F \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.no-permissions': "\uACF5\uC720\uD560 \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'fabric.elements.share.form.public.send': "\uACF5\uAC1C \uB9C1\uD06C \uBCF4\uB0B4\uAE30",
    'fabric.elements.share.form.public.share': "\uACF5\uAC1C \uB9C1\uD06C \uACF5\uC720",
    'fabric.elements.share.form.required-field.summary': "\uD544\uC218 \uD544\uB4DC\uB294 \uBCC4\uD45C\uB85C \uD45C\uC2DC\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.retry': "\uB2E4\uC2DC \uC2DC\uB3C4",
    'fabric.elements.share.form.send': "\uBCF4\uB0B4\uAE30",
    'fabric.elements.share.form.share': "\uACF5\uC720",
    'fabric.elements.share.form.title': "\uACF5\uC720",
    'fabric.elements.share.form.user-picker.add-more': "\uB354 \uC785\uB825\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.label.confluence': "\uC774\uB984, \uD300, \uADF8\uB8F9 \uB610\uB294 \uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\uC774\uB984, \uD300 \uB610\uB294 \uADF8\uB8F9",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\uC774\uB984 \uB610\uB294 \uD300",
    'fabric.elements.share.form.user-picker.label.email-only': "\uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.label.jira': "\uC774\uB984, \uD300 \uB610\uB294 \uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '"{inputValue}"\uC5D0 \uB300\uD55C \uACB0\uACFC\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.',
    'fabric.elements.share.form.user-picker.no-options.generic': '"{inputValue}"\uC5D0 \uB300\uD55C \uACB0\uACFC\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4. \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC0AC\uC6A9\uD558\uC5EC \uC0AC\uC6A9\uC790\uB97C \uCD08\uB300\uD558\uC138\uC694.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\uC608: Maria, Team Orange, group-one",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\uC608: Maria, Team Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\uC608: maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\uC608: Maria, Team Orange, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\uC0AC\uC6A9\uC790, \uADF8\uB8F9, \uD300 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\uC0AC\uC6A9\uC790, \uD300, \uADF8\uB8F9 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\uC0AC\uC6A9\uC790, \uD300 \uB610\uB294 \uADF8\uB8F9\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\uC0AC\uC6A9\uC790 \uB610\uB294 \uD300\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\uC0AC\uC6A9\uC790, \uD300 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.in.integration.button': "{integrationName}\uC5D0\uC11C \uACF5\uC720",
    'fabric.elements.share.invite.to.confluence': "Confluence\uC5D0 \uCD08\uB300",
    'fabric.elements.share.invite.to.jira': "Jira\uC5D0 \uCD08\uB300",
    'fabric.elements.share.main.tab.text.confluence': "\uD398\uC774\uC9C0 \uACF5\uC720",
    'fabric.elements.share.main.tab.text.jira': "\uC774\uC288 \uACF5\uC720",
    'fabric.elements.share.menu.email.label': "\uC774\uBA54\uC77C",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\uACF5\uC720",
    'fabric.elements.share.success.message': "{object, select,blogpost {\uACF5\uC720\uD55C \uBE14\uB85C\uADF8 \uAC8C\uC2DC\uBB3C}board {\uACF5\uC720\uD55C \uBCF4\uB4DC}calendar {\uACF5\uC720\uD55C \uCE98\uB9B0\uB354}draft {\uACF5\uC720\uD55C \uCD08\uC548}filter {\uACF5\uC720\uD55C \uD544\uD130}issue {\uACF5\uC720\uD55C \uC774\uC288}summary {\uACF5\uC720\uD55C \uC694\uC57D}list {\uACF5\uC720\uD55C \uBAA9\uB85D}timeline {\uACF5\uC720\uD55C \uD0C0\uC784\uB77C\uC778}form {\uACF5\uC720\uD55C \uC591\uC2DD}media {\uACF5\uC720\uD55C \uBBF8\uB514\uC5B4}page {\uACF5\uC720\uD55C \uD398\uC774\uC9C0}project {\uACF5\uC720\uD55C \uD504\uB85C\uC81D\uD2B8}pullrequest {\uACF5\uC720\uD55C \uD480\uB9AC\uD018\uC2A4\uD2B8}question {\uACF5\uC720\uD55C \uC9C8\uBB38}report {\uACF5\uC720\uD55C \uBCF4\uACE0\uC11C}repository {\uACF5\uC720\uD55C \uB9AC\uD3EC\uC9C0\uD1A0\uB9AC}request {\uACF5\uC720\uD55C \uC694\uCCAD}timeline {\uACF5\uC720\uD55C \uD0C0\uC784\uB77C\uC778}site {\uACF5\uC720\uD55C \uC0AC\uC774\uD2B8}space {\uACF5\uC720\uD55C \uC2A4\uD398\uC774\uC2A4}other {\uACF5\uC720\uD55C \uB9C1\uD06C}}",
    'fabric.elements.share.to.integration.button': "{integrationName}\uC5D0 \uACF5\uC720",
    'fabric.elements.share.trigger.button.icon.label': "\uACF5\uC720 \uC544\uC774\uCF58",
    'fabric.elements.share.trigger.button.invite.text': "\uCD08\uB300",
    'fabric.elements.share.trigger.button.text': "\uACF5\uC720",
    'fabric.elements.share.trigger.button.tooltip.text': "\uACF5\uC720"
};

});

parcelRegister("16RW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa1be7e35603d5ed$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $fa1be7e35603d5ed$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Kobling er kopiert til utklippstavlen',
    'fabric.elements.share.copylink.button.text': 'Kopier kobling',
    'fabric.elements.share.copypubliclink.button.text': 'Kopier offentlig tilgjengelig kobling',
    'fabric.elements.share.failure.icon.label': 'Feil-ikon',
    'fabric.elements.share.failure.message': 'Kan ikke deles',
    'fabric.elements.share.form.comment.label': 'Melding (valgfritt)',
    'fabric.elements.share.form.comment.placeholder': "Er det noe mottakerne b\xf8r vite om dette?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Mottakerne vil se navnet p\xe5 siden og meldingen",
    'fabric.elements.share.form.info.message.no.invite.jira': "Mottakerne vil se navnet p\xe5 saken og meldingen",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Mottakerne vil se navnet p\xe5 arbeidsoppgaven og meldingen",
    'fabric.elements.share.form.no-permissions': "Du har ikke muligheten til \xe5 dele.",
    'fabric.elements.share.form.public.send': 'Send offentlig tilgjengelig kobling',
    'fabric.elements.share.form.public.share': 'Del offentlig kobling',
    'fabric.elements.share.form.required-field.summary': 'Obligatoriske felt er merket med stjerne',
    'fabric.elements.share.form.retry': "Pr\xf8v igjen",
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Del',
    'fabric.elements.share.form.title': 'Del',
    'fabric.elements.share.form.user-picker.add-more': 'Legg til mer',
    'fabric.elements.share.form.user-picker.label.confluence': 'Navn, team, grupper eller e-poster',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Navn, team eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Navn eller team',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-poster',
    'fabric.elements.share.form.user-picker.label.jira': 'Navn, team eller e-poster',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi kunne ikke finne noen resultater for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi kunne ikke finne noen resultater for "{inputValue}". Inviter personer ved \xe5 bruke en e-postadresse.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "f.eks. Maria, oransje team, gruppe \xe9n",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'f.eks. Maria, oransje team',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'f.eks. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'f.eks. Maria, oransje team, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': "Velg minst \xe9n bruker, gruppe eller e-post eller minst ett team.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Velg minst \xe9n person, gruppe, e-postadresse eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Velg minst \xe9n person, gruppe eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Velg minst \xe9n person eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Velg minst \xe9n e-postadresse",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Velg minst \xe9n person, gruppe, e-postadresse eller ett team",
    'fabric.elements.share.in.integration.button': 'Del i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Inviter til Confluence',
    'fabric.elements.share.invite.to.jira': 'Inviter til Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Del side',
    'fabric.elements.share.main.tab.text.jira': 'Del sak',
    'fabric.elements.share.menu.email.label': 'E-post',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Del',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogginnlegg er delt}board {Tavle er delt}calendar {Kalender er delt}draft {Utkast er delt}filter {Filter er delt}issue {Sak er delt}summary {Sammendrag er delt}list {Liste er delt}timeline {Tidslinje er delt}form {Skjema er delt}media {Medier er delt}page {Side er delt}project {Prosjekt er delt}pullrequest {Pull-foresp\xf8rsel er delt}question {Sp\xf8rsm\xe5l er delt}report {Rapport er delt}repository {Repositorium er delt}request {Foresp\xf8rsel er delt}roadmap {Veikart er delt}site {Nettsted er delt}space {Omr\xe5de er delt}other {Kobling er delt}}",
    'fabric.elements.share.to.integration.button': 'Del til {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Dele-ikon',
    'fabric.elements.share.trigger.button.invite.text': 'Inviter',
    'fabric.elements.share.trigger.button.text': 'Del',
    'fabric.elements.share.trigger.button.tooltip.text': 'Del'
};

});

parcelRegister("hrNSu", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cf381178f2c2c61$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $9cf381178f2c2c61$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link naar klembord gekopieerd',
    'fabric.elements.share.copylink.button.text': "Link kopi\xebren",
    'fabric.elements.share.copypubliclink.button.text': "Openbare link kopi\xebren",
    'fabric.elements.share.failure.icon.label': "Pictogram 'Fout'",
    'fabric.elements.share.failure.message': 'Kan niet delen',
    'fabric.elements.share.form.comment.label': 'Bericht (optioneel)',
    'fabric.elements.share.form.comment.placeholder': 'Is er iets ze moet weten?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Ontvangers zien de naam van de pagina en je bericht',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Ontvangers zien de naam van de issue en je bericht',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Ontvangers zien de naam van het werkitem en je bericht',
    'fabric.elements.share.form.no-permissions': 'Je kunt niet delen.',
    'fabric.elements.share.form.public.send': 'Openbare link verzenden',
    'fabric.elements.share.form.public.share': 'Openbare link delen',
    'fabric.elements.share.form.required-field.summary': 'Verplichte velden zijn aangeduid met een asterisk',
    'fabric.elements.share.form.retry': 'Opnieuw proberen',
    'fabric.elements.share.form.send': 'Verzenden',
    'fabric.elements.share.form.share': 'Delen',
    'fabric.elements.share.form.title': 'Delen',
    'fabric.elements.share.form.user-picker.add-more': 'Meer invoeren',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namen, teams, groepen of e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namen, teams of groepen',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namen of teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Namen, teams of e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Geen resultaten gevonden voor ''{inputValue}'.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Geen resultaten gevonden voor ''{inputValue}'. Nodig personen uit door hun e-mailadres in te voeren.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'bijv. Maria, team Oranje, groep-een',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'bijv. Maria, team Oranje',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'bijv. Maria, maria@bedrijf.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'bijv. Maria, team Oranje, maria@bedrijf.com',
    'fabric.elements.share.form.user-picker.validation.required': "Selecteer minimaal \xe9\xe9n gebruiker, groep, team of e-mailadres.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Selecteer minimaal \xe9\xe9n persoon, team, groep of e-mailadres",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Selecteer minimaal \xe9\xe9n persoon, team of groep",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Selecteer minimaal \xe9\xe9n persoon of team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Selecteer minimaal \xe9\xe9n e-mailadres",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Selecteer minimaal \xe9\xe9n persoon, team of e-mailadres",
    'fabric.elements.share.in.integration.button': 'Delen in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Uitnodigen voor Confluence',
    'fabric.elements.share.invite.to.jira': 'Uitnodigen voor Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Pagina delen',
    'fabric.elements.share.main.tab.text.jira': 'Issue delen',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Delen',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blogpost gedeeld}board {Bord gedeeld}calendar {Agenda gedeeld}draft {Concept gedeeld}filter {Filter gedeeld}issue {Issue gedeeld}summary {Samenvatting gedeeld}list {Lijst gedeeld}timeline {Tijdlijn gedeeld}form {Formulier gedeeld}media {Media gedeeld}page {Pagina gedeeld}project {Project gedeeld}pullrequest {Pull-request gedeeld}question {Vraag gedeeld}report {Rapport gedeeld}repository {Repository gedeeld}request {Aanvraag gedeeld}roadmap {Tijdlijn gedeeld}site {Site gedeeld}space {Space gedeeld}other {Link gedeeld}}',
    'fabric.elements.share.to.integration.button': 'Delen met {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "Pictogram 'Delen'",
    'fabric.elements.share.trigger.button.invite.text': 'Uitnodigen',
    'fabric.elements.share.trigger.button.text': 'Delen',
    'fabric.elements.share.trigger.button.tooltip.text': 'Delen'
};

});

parcelRegister("ioYTp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7d711b9dc04d41d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $f7d711b9dc04d41d$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0141\u0105cze skopiowano do schowka",
    'fabric.elements.share.copylink.button.text': "Kopiuj \u0142\u0105cze",
    'fabric.elements.share.copypubliclink.button.text': "Kopiuj \u0142\u0105cze publiczne",
    'fabric.elements.share.failure.icon.label': "Ikona b\u0142\u0119du",
    'fabric.elements.share.failure.message': "Nie mo\u017Cna udost\u0119pni\u0107",
    'fabric.elements.share.form.comment.label': "Wiadomo\u015B\u0107 (opcjonalnie)",
    'fabric.elements.share.form.comment.placeholder': "Czy jest co\u015B, o czym powinni wiedzie\u0107?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Odbiorcy zobacz\u0105 nazw\u0119 strony i Tw\xf3j komunikat",
    'fabric.elements.share.form.info.message.no.invite.jira': "Odbiorcy zobacz\u0105 nazw\u0119 zg\u0142oszenia i Tw\xf3j komunikat",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Odbiorcy zobacz\u0105 nazw\u0119 zg\u0142oszenia i\xa0Tw\xf3j komunikat.",
    'fabric.elements.share.form.no-permissions': "Nie mo\u017Cesz udost\u0119pnia\u0107.",
    'fabric.elements.share.form.public.send': "Wy\u015Blij \u0142\u0105cze publiczne",
    'fabric.elements.share.form.public.share': "Udost\u0119pnij \u0142\u0105cze publiczne",
    'fabric.elements.share.form.required-field.summary': "Pola wymagane s\u0105 oznaczone gwiazdk\u0105",
    'fabric.elements.share.form.retry': "Spr\xf3buj ponownie",
    'fabric.elements.share.form.send': "Wy\u015Blij",
    'fabric.elements.share.form.share': "Udost\u0119pnij",
    'fabric.elements.share.form.title': "Udost\u0119pnij",
    'fabric.elements.share.form.user-picker.add-more': "Wprowad\u017A wi\u0119cej",
    'fabric.elements.share.form.user-picker.label.confluence': "Nazwy, zespo\u0142y, grupy lub adresy e-mail",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Nazwy, zespo\u0142y lub grupy",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Nazwy lub zespo\u0142y",
    'fabric.elements.share.form.user-picker.label.email-only': 'Adresy e-mail',
    'fabric.elements.share.form.user-picker.label.jira': "Nazwy, zespo\u0142y lub adresy e-mail",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nie znaleziono wynik\xf3w dla \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nie znaleziono wynik\xf3w dla \u201E{inputValue}\u201D. Zapro\u015B u\u017Cytkownik\xf3w, podaj\u0105c adres e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy, grupa 1",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'np. maria@firma.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy, maria@firma.com",
    'fabric.elements.share.form.user-picker.validation.required': "Wybierz co najmniej jednego u\u017Cytkownika, jedn\u0105 grup\u0119 albo jeden zesp\xf3\u0142 lub adres e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142, jedn\u0105 grup\u0119 lub jeden adres e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142 lub jedn\u0105 grup\u0119",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Wybierz co najmniej jedn\u0105 osob\u0119 lub jeden zesp\xf3\u0142",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Wybierz co najmniej jeden adres e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142 lub jeden adres e-mail",
    'fabric.elements.share.in.integration.button': "Udost\u0119pnij w {integrationName}",
    'fabric.elements.share.invite.to.confluence': "Zapro\u015B do\xa0Confluence",
    'fabric.elements.share.invite.to.jira': "Zapro\u015B do\xa0systemu Jira",
    'fabric.elements.share.main.tab.text.confluence': "Udost\u0119pnij stron\u0119",
    'fabric.elements.share.main.tab.text.jira': "Udost\u0119pnij zg\u0142oszenie",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Udost\u0119pnij",
    'fabric.elements.share.success.message': "{object, select,blogpost {Udost\u0119pniono wpis na blogu}board {Udost\u0119pniono tablic\u0119}calendar {Udost\u0119pniono kalendarz}draft {Udost\u0119pniono wersj\u0119 robocz\u0105}filter {Udost\u0119pniono filtr}issue {Udost\u0119pniono zg\u0142oszenie}summary {Udost\u0119pniono podsumowanie}list {Udost\u0119pniono list\u0119}timeline {Udost\u0119pniono o\u015B czasu}form {Udost\u0119pniono formularz}media {Udost\u0119pniono multimedia}page {Udost\u0119pniono stron\u0119}project {Udost\u0119pniono projekt}pullrequest {Udost\u0119pniono pull request}question {Udost\u0119pniono pytanie}report {Udost\u0119pniono raport}repository {Udost\u0119pniono repozytorium}request {Udost\u0119pniono wniosek}roadmap {Udost\u0119pniono o\u015B czasu}site {Udost\u0119pniono witryn\u0119}space {Udost\u0119pniono przestrze\u0144}other {Udost\u0119pniono \u0142\u0105cze}}",
    'fabric.elements.share.to.integration.button': "Udost\u0119pnij w {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona udost\u0119pniania",
    'fabric.elements.share.trigger.button.invite.text': "Zapro\u015B",
    'fabric.elements.share.trigger.button.text': "Udost\u0119pnij",
    'fabric.elements.share.trigger.button.tooltip.text': "Udost\u0119pnij"
};

});

parcelRegister("iQCSg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2341ebeae6083b8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $b2341ebeae6083b8$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Link copiado para a \xe1rea de transfer\xeancia",
    'fabric.elements.share.copylink.button.text': 'Copiar link',
    'fabric.elements.share.copypubliclink.button.text': "Copiar link p\xfablico",
    'fabric.elements.share.failure.icon.label': "\xcdcone de erro",
    'fabric.elements.share.failure.message': "N\xe3o foi poss\xedvel compartilhar",
    'fabric.elements.share.form.comment.label': 'Mensagem (opcional)',
    'fabric.elements.share.form.comment.placeholder': "H\xe1 algo que eles deveriam saber?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Os destinat\xe1rios v\xe3o ver o nome da p\xe1gina e sua mensagem",
    'fabric.elements.share.form.info.message.no.invite.jira': "Os destinat\xe1rios v\xe3o ver o nome do item e sua mensagem",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Os destinat\xe1rios v\xe3o ver o nome do ticket e a mensagem",
    'fabric.elements.share.form.no-permissions': "Voc\xea n\xe3o est\xe1 apto a compartilhar.",
    'fabric.elements.share.form.public.send': "Enviar link p\xfablico",
    'fabric.elements.share.form.public.share': "Compartilhar link p\xfablico",
    'fabric.elements.share.form.required-field.summary': "Os campos obrigat\xf3rios est\xe3o marcados com um asterisco",
    'fabric.elements.share.form.retry': 'Tentar novamente',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.share': 'Compartilhar',
    'fabric.elements.share.form.title': 'Compartilhar',
    'fabric.elements.share.form.user-picker.add-more': 'Insira mais itens',
    'fabric.elements.share.form.user-picker.label.confluence': 'Nomes, equipes, grupos ou e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nomes, equipes ou grupos',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nomes ou equipes',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Nomes, equipes ou e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'N\xe3o encontramos nenhum resultado para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'N\xe3o encontramos nenhum resultado para "{inputValue}". Convide pessoas usando um endere\xe7o de e-mail.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'por exemplo, Maria, equipe laranja, grupo um',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'por exemplo, Maria, equipe laranja',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'por exemplo, maria@empresa.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'por exemplo, Maria, equipe laranja, maria@empresa.com',
    'fabric.elements.share.form.user-picker.validation.required': "Selecione ao menos um usu\xe1rio, grupo, equipe ou e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Selecione pelo menos uma pessoa, equipe, grupo ou e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Selecione pelo menos uma pessoa, equipe ou grupo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Selecione pelo menos uma pessoa ou equipe',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Selecione pelo menos um e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Selecione pelo menos uma pessoa, equipe ou e-mail',
    'fabric.elements.share.in.integration.button': 'Compartilhar em {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Convidar para o Confluence',
    'fabric.elements.share.invite.to.jira': 'Convidar para o Jira',
    'fabric.elements.share.main.tab.text.confluence': "Compartilhar p\xe1gina",
    'fabric.elements.share.main.tab.text.jira': 'Compartilhar item',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Compartilhar',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blog compartilhado}board {Quadro compartilhado}calendar {Calend\xe1rio compartilhado}draft {Rascunho compartilhado}filter {Filtro compartilhado}issue {Item compartilhado}summary {Resumo compartilhado}list {Lista compartilhada}timeline {Cronograma compartilhado}form {Formul\xe1rio compartilhado}media {M\xeddia compartilhada}page {P\xe1gina compartilhada}project {Projeto compartilhado}pullrequest {Pull request compartilhada}question {Pergunta compartilhada}report {Relat\xf3rio compartilhado}repository {Reposit\xf3rio compartilhado}request {Solicita\xe7\xe3o compartilhada}roadmap {Cronograma compartilhado}site {Site compartilhado}space {Espa\xe7o compartilhado}other {Link compartilhado}}",
    'fabric.elements.share.to.integration.button': 'Compartilhar em {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "\xcdcone de compartilhamento",
    'fabric.elements.share.trigger.button.invite.text': 'Convidar',
    'fabric.elements.share.trigger.button.text': 'Compartilhar',
    'fabric.elements.share.trigger.button.tooltip.text': 'Compartilhar'
};

});

parcelRegister("hkr2R", function(module, exports) {

$parcel$export(module.exports, "default", () => $362c0a09cda3dcd7$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Portugal)
var $362c0a09cda3dcd7$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Liga\xe7\xe3o copiada para a \xe1rea de transfer\xeancia",
    'fabric.elements.share.copylink.button.text': "Copiar liga\xe7\xe3o",
    'fabric.elements.share.failure.icon.label': "\xcdcone de erro",
    'fabric.elements.share.failure.message': "N\xe3o \xe9 poss\xedvel partilhar",
    'fabric.elements.share.form.comment.placeholder': 'Adicionar uma mensagem',
    'fabric.elements.share.form.retry': 'Tentar novamente',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.title': 'Partilhar',
    'fabric.elements.share.form.user-picker.add-more': 'Introduza mais',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'N\xe3o foi poss\xedvel encontrar resultados para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'N\xe3o foi poss\xedvel encontrar resultados para "{inputValue}". Convite pessoas adicionando um endere\xe7o de e-mail.',
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': 'Introduza o nome ou equipa',
    'fabric.elements.share.form.user-picker.placeholder.generic': 'Introduza o nome, grupo, equipa ou e-mail',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'Introduza o nome, a equipa ou o e-mail',
    'fabric.elements.share.form.user-picker.validation.required': 'Selecione, pelo menos, um utilizador, grupo, equipa ou e-mail.',
    'fabric.elements.share.form.user-picker.validation.required.jira': 'Selecione, pelo menos, um utilizador, equipa ou e-mail.',
    'fabric.elements.share.success.message': "{object, select, blogpost {Publica\xe7\xe3o do blogue partilhada} board {Quadro partilhado} calendar {Calend\xe1rio partilhado} draft {Rascunho partilhado} filter {Filtro partilhado} issue {Problema partilhado} media {Multim\xe9dia partilhado} page {P\xe1gina partilhada} project {Projeto partilhado} pullrequest {Pedidos Pull partilhados} question {Pergunta partilhada} report {Relat\xf3rio partilhado} repository {Reposit\xf3rio partilhado} request {Pedido partilhado} roadmap {Roteiro partilhado} site {Site partilhado} space {Espa\xe7o partilhado} other {Liga\xe7\xe3o partilhada}}",
    'fabric.elements.share.trigger.button.icon.label': "Partilhar \xedcone",
    'fabric.elements.share.trigger.button.invite.text': 'Convidar',
    'fabric.elements.share.trigger.button.text': 'Partilhar',
    'fabric.elements.share.trigger.button.tooltip.text': 'Partilhar'
};

});

parcelRegister("7dbDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc047a07085c3fb$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ // Romanian
var $6bc047a07085c3fb$export$2e2bcd8739ae039 = {
    'fabric.elements.share.form.title': "Partaja\u021Bi",
    'fabric.elements.share.form.send': "Trimite\u021Bi",
    'fabric.elements.share.form.retry': "Re\xeencerca\u021Bi",
    'fabric.elements.share.form.comment.placeholder': "Ad\u0103uga\u021Bi un mesaj",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Introduce\u021Bi nume, echip\u0103 sau e-mail",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Introduce\u021Bi nume sau echip\u0103",
    'fabric.elements.share.form.user-picker.add-more': "Introduce\u021Bi mai multe",
    'fabric.elements.share.form.user-picker.validation.required': "Selecta\u021Bi cel pu\u021Bin un utilizator, echip\u0103 sau e-mail.",
    'fabric.elements.share.form.user-picker.no-options.domainBasedUserOnly': "Pute\u021Bi invita persoane nu mai cu adrese de e-mail {domains}. Contacta\u021Bi administratorul site-ului pentru a invita alte persoane.",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nu am g\u0103sit niciun rezultat pentru \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': 'Nu am g\u0103sit niciun rezultat pentru "{inputValue}". Invit\u0103 persoane utiliz\xe2nd o adres\u0103 de e-mail.',
    'fabric.elements.share.trigger.button.icon.label': "Pictogram\u0103 partajare",
    'fabric.elements.share.trigger.button.text': "Partaja\u021Bi",
    'fabric.elements.share.trigger.button.tooltip.text': "Partaja\u021Bi",
    'fabric.elements.share.trigger.button.invite.text': "Invita\u021Bi",
    'fabric.elements.share.copylink.button.icon.label': "Pictogram\u0103 copiere link",
    'fabric.elements.share.copylink.button.text': "Copia\u021Bi link",
    'fabric.elements.share.copied.to.clipboard.icon.label': "Pictogram\u0103 copiere linkuri cu succes",
    'fabric.elements.share.copied.to.clipboard.message': "Link copiat \xeen clipboard",
    'fabric.elements.share.form.capabilities.info.message': "Invita\u021Bia dvs. va fi transmis\u0103 unui administrator pentru aprobare",
    'fabric.elements.share.failure.icon.label': "Pictogram\u0103 eroare",
    'fabric.elements.share.failure.message': 'Nu se poate partaja',
    'fabric.elements.share.success.message': "{object, select, blogpost {Blog post shared} panou {Board shared} calendar {Calendar shared} schi\u021B\u0103{Draft shared} filtru {Filter shared} problem\u0103 {Issue shared} media {Media shared} pagin\u0103 {Page shared} proiect {Project shared} pullrequest {Pull Request shared} \xeentrebare {Question shared} raport {Report shared} depozit {Repository shared} solicitare {Request shared} planificare {Roadmap shared} site {Site shared} spa\u021Biu {Space shared} altele {Link Shared}}",
    'fabric.elements.share.admin.notified.message': 'Administratorul dvs. a fost notificat'
};

});

parcelRegister("8zZLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d906580aa8a5e1c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $7d906580aa8a5e1c$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0421\u0441\u044B\u043B\u043A\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430",
    'fabric.elements.share.copylink.button.text': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.copypubliclink.button.text': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.failure.icon.label': "\u0417\u043D\u0430\u0447\u043E\u043A \u043E\u0448\u0438\u0431\u043A\u0438",
    'fabric.elements.share.failure.message': "\u041D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.comment.label': "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
    'fabric.elements.share.form.comment.placeholder': "\u0427\u0442\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u0437\u043D\u0430\u0442\u044C?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0437\u0430\u0434\u0430\u0447\u0438 \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0437\u0430\u0434\u0430\u0447\u0438 \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.no-permissions': "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043E\u0431\u0449\u0438\u0439 \u0434\u043E\u0441\u0442\u0443\u043F.",
    'fabric.elements.share.form.public.send': "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.form.public.share': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0441\u044B\u043B\u043A\u043E\u0439 \u043E\u0431\u0449\u0435\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430",
    'fabric.elements.share.form.required-field.summary': "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F \u043E\u0442\u043C\u0435\u0447\u0435\u043D\u044B \u0437\u0432\u0435\u0437\u0434\u043E\u0447\u043A\u043E\u0439",
    'fabric.elements.share.form.retry': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C",
    'fabric.elements.share.form.send': "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
    'fabric.elements.share.form.share': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.title': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.user-picker.add-more': "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439",
    'fabric.elements.share.form.user-picker.label.confluence': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B, \u0433\u0440\u0443\u043F\u043F\u044B \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0438\u043B\u0438 \u0433\u0440\u0443\u043F\u043F\u044B",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u0418\u043C\u0435\u043D\u0430 \u0438\u043B\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u044B",
    'fabric.elements.share.form.user-picker.label.email-only': "\u0410\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.label.jira': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \xab{inputValue}\xbb.",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \xab{inputValue}\xbb. \u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb, \u0433\u0440\u0443\u043F\u043F\u0430-\u043E\u0434\u0438\u043D",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B 1\xa0\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0433\u0440\u0443\u043F\u043F\u0443, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443, \u0433\u0440\u0443\u043F\u043F\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0433\u0440\u0443\u043F\u043F\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u043B\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.in.integration.button': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0432 {integrationName}",
    'fabric.elements.share.invite.to.confluence': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u0432 Confluence",
    'fabric.elements.share.invite.to.jira': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u0432 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435\u0439",
    'fabric.elements.share.main.tab.text.jira': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0437\u0430\u0434\u0430\u0447\u0435\u0439",
    'fabric.elements.share.menu.email.label': "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0438\u0441\u0438 \u0432 \u0431\u043B\u043E\u0433\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}board {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0434\u043E\u0441\u043A\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}calendar {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}draft {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0447\u0435\u0440\u043D\u043E\u0432\u0438\u043A\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}filter {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0444\u0438\u043B\u044C\u0442\u0440\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}issue {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u0434\u0430\u0447\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}summary {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0442\u0435\u043C\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}list {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u043F\u0438\u0441\u043A\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}timeline {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}form {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0444\u043E\u0440\u043C\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}media {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043C\u0435\u0434\u0438\u0430\u0444\u0430\u0439\u043B\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}page {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}project {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}pullrequest {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0440\u043E\u0441\u0443 pull \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}question {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0432\u043E\u043F\u0440\u043E\u0441\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}report {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043E\u0442\u0447\u0435\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}repository {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0440\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0440\u0438\u044E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}request {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}roadmap {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}site {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0430\u0439\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}space {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0440\u0430\u0437\u0434\u0435\u043B\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}other {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0441\u044B\u043B\u043A\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}}",
    'fabric.elements.share.to.integration.button': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0432 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u0417\u043D\u0430\u0447\u043E\u043A \xab\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F\xbb",
    'fabric.elements.share.trigger.button.invite.text': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C",
    'fabric.elements.share.trigger.button.text': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.trigger.button.tooltip.text': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F"
};

});

parcelRegister("dGOFQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cd5c80c863bfbe9$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $9cd5c80c863bfbe9$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Prepojenie sa skop\xedrovalo do schr\xe1nky",
    'fabric.elements.share.copylink.button.text': "Kop\xedrova\u0165 prepojenie",
    'fabric.elements.share.failure.icon.label': 'Ikona chyby',
    'fabric.elements.share.failure.message': "Zdie\u013Eanie nie je mo\u017En\xe9",
    'fabric.elements.share.form.comment.placeholder': "Prida\u0165 spr\xe1vu",
    'fabric.elements.share.form.retry': "Opakova\u0165",
    'fabric.elements.share.form.send': "Odosla\u0165",
    'fabric.elements.share.form.title': "Zdie\u013Eanie",
    'fabric.elements.share.form.user-picker.add-more': "Zadajte \u010Fal\u0161ie polo\u017Eky",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nepodarilo sa n\xe1js\u0165 \u017Eiadne v\xfdsledky pre \u201E{inputValue}\u201C.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nepodarilo sa n\xe1js\u0165 \u017Eiadne v\xfdsledky pre \u201E{inputValue}\u201C. Pozvite \u013Eud\xed pomocou e-mailovej adresy.",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Zadajte meno alebo t\xedm",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Zadajte meno, skupinu, t\xedm alebo e-mail",
    'fabric.elements.share.form.user-picker.placeholder.jira': "Zadajte meno, t\xedm alebo e-mail",
    'fabric.elements.share.form.user-picker.validation.required': "Vyberte aspo\u0148 jedn\xe9ho pou\u017E\xedvate\u013Ea, skupinu, t\xedm alebo e-mail.",
    'fabric.elements.share.form.user-picker.validation.required.jira': "Vyberte aspo\u0148 jedn\xe9ho pou\u017E\xedvate\u013Ea, t\xedm alebo e-mail.",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blogov\xfd pr\xedspevok sa zdie\u013Eal} board {N\xe1stenka sa zdie\u013Eala} calendar {Kalend\xe1r sa zdie\u013Eal} draft {Koncept sa zdie\u013Eal} filter {Filter sa zdie\u013Eal} issue {Probl\xe9m sa zdie\u013Eal} media {Medi\xe1lny s\xfabor sa zdie\u013Eal} page {Str\xe1nka sa zdie\u013Eala} project {Projekt sa zdie\u013Eal} pullrequest {Po\u017Eiadavka na stiahnutie a pos\xfadenie sa zdie\u013Eala} question {Ot\xe1zka sa zdie\u013Eala} report {Zostava sa zdie\u013Eala} repository {Repozit\xe1r sa zdie\u013Eal} request {\u017Diados\u0165 sa zdie\u013Eala} roadmap {Pl\xe1n sa zdie\u013Eal} site {Web sa zdie\u013Eal} space {Priestor sa zdie\u013Eal} other {Prepojenie sa zdie\u013Ealo}}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona zdie\u013Eania",
    'fabric.elements.share.trigger.button.invite.text': "Pozva\u0165",
    'fabric.elements.share.trigger.button.text': "Zdie\u013Ea\u0165",
    'fabric.elements.share.trigger.button.tooltip.text': "Zdie\u013Eanie"
};

});

parcelRegister("64yeQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $643613031271747a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $643613031271747a$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "L\xe4nk kopierad till urklipp",
    'fabric.elements.share.copylink.button.text': "Kopiera l\xe4nk",
    'fabric.elements.share.copypubliclink.button.text': "Kopiera offentlig l\xe4nk",
    'fabric.elements.share.failure.icon.label': 'Fel-ikon',
    'fabric.elements.share.failure.message': 'Det gick inte att dela',
    'fabric.elements.share.form.comment.label': 'Meddelande (valfritt)',
    'fabric.elements.share.form.comment.placeholder': "Finns det n\xe5got de beh\xf6ver veta?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Mottagare ser namnet p\xe5 sidan och ditt meddelande",
    'fabric.elements.share.form.info.message.no.invite.jira': "Mottagare ser namnet p\xe5 \xe4rendet och ditt meddelande",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Mottagare ser namnet p\xe5 arbetsuppgiften och ditt meddelande",
    'fabric.elements.share.form.no-permissions': "Du har inte m\xf6jlighet att dela.",
    'fabric.elements.share.form.public.send': "Skicka offentlig l\xe4nk",
    'fabric.elements.share.form.public.share': "Dela offentlig l\xe4nk",
    'fabric.elements.share.form.required-field.summary': "Obligatoriska f\xe4lt \xe4r markerade med en asterisk",
    'fabric.elements.share.form.retry': "F\xf6rs\xf6k igen",
    'fabric.elements.share.form.send': 'Skicka',
    'fabric.elements.share.form.share': 'Dela',
    'fabric.elements.share.form.title': 'Dela',
    'fabric.elements.share.form.user-picker.add-more': 'Ange fler',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namn, team, grupper eller e-postadresser',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namn, team eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namn eller team',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-postadresser',
    'fabric.elements.share.form.user-picker.label.jira': 'Namn, team eller e-postadresser',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi hittade inte n\xe5gra resultat f\xf6r "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi hittade inte n\xe5gra resultat f\xf6r "{inputValue}". Bjud in personer genom att anv\xe4nda e-postadresser.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 't.ex. Maria, Team Orange, grupp-ett',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 't.ex. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': "t.ex. maria@f\xf6retag.se",
    'fabric.elements.share.form.user-picker.placeholder.jira': "t.ex. Maria, Team Orange, maria@f\xf6retag.se",
    'fabric.elements.share.form.user-picker.validation.required': "V\xe4lj minst en anv\xe4ndare, en grupp, ett team eller en e-postadress.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe4lj minst en person, ett team, en grupp eller en e-postadress",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe4lj minst en person, ett team eller en grupp",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe4lj minst en person eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe4lj minst en e-postadress",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe4lj minst en person, ett team eller en e-postadress",
    'fabric.elements.share.in.integration.button': 'Dela i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Bjud in till Confluence',
    'fabric.elements.share.invite.to.jira': 'Bjud in till Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Dela sida',
    'fabric.elements.share.main.tab.text.jira': "Dela \xe4rende",
    'fabric.elements.share.menu.email.label': 'E-post',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Dela',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogginl\xe4gg har delats}board {Tavla har delats}calendar {Kalender har delats}draft {Utkast har delats}filter {Filter har delats}issue {\xc4rende har delats}summary {Sammanfattning har delats}list {Lista har delats}timeline {Tidslinje har delats}form {Formul\xe4r har delats}media {Media har delats}page {Sida har delats}project {Projekt har delats}pullrequest {Pull request har delats}question {Fr\xe5ga har delats}report {Rapport har delats}repository {Lagringsplats har delats}request {F\xf6rfr\xe5gan har delats}roadmap {Tidslinje har delats}site {Webbplats har delats}space {Utrymme har delats}other {L\xe4nk har delats}}",
    'fabric.elements.share.to.integration.button': 'Dela till {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Dela-ikon',
    'fabric.elements.share.trigger.button.invite.text': 'Bjud In',
    'fabric.elements.share.trigger.button.text': 'Dela',
    'fabric.elements.share.trigger.button.tooltip.text': 'Dela'
};

});

parcelRegister("iTJhG", function(module, exports) {

$parcel$export(module.exports, "default", () => $65937a71b1200549$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $65937a71b1200549$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u94FE\u63A5\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F",
    'fabric.elements.share.copylink.button.text': "\u590D\u5236\u94FE\u63A5",
    'fabric.elements.share.copypubliclink.button.text': "\u590D\u5236\u516C\u5171\u94FE\u63A5",
    'fabric.elements.share.failure.icon.label': "\u9519\u8BEF\u56FE\u6807",
    'fabric.elements.share.failure.message': "\u65E0\u6CD5\u5171\u4EAB",
    'fabric.elements.share.form.comment.label': "\u6D88\u606F\uFF08\u53EF\u9009\uFF09",
    'fabric.elements.share.form.comment.placeholder': "\u5BF9\u65B9\u662F\u5426\u5E94\u77E5\u9053\u67D0\u4E9B\u4FE1\u606F\uFF1F",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u9875\u9762\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u4E8B\u52A1\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u5DE5\u4F5C\u9879\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.no-permissions': "\u60A8\u65E0\u6CD5\u5171\u4EAB\u3002",
    'fabric.elements.share.form.public.send': "\u53D1\u9001\u516C\u5171\u94FE\u63A5",
    'fabric.elements.share.form.public.share': "\u5206\u4EAB\u516C\u5F00\u94FE\u63A5",
    'fabric.elements.share.form.required-field.summary': "\u5FC5\u586B\u5B57\u6BB5\u6807\u6709\u661F\u53F7",
    'fabric.elements.share.form.retry': "\u91CD\u8BD5",
    'fabric.elements.share.form.send': "\u53D1\u9001",
    'fabric.elements.share.form.share': "\u5171\u4EAB",
    'fabric.elements.share.form.title': "\u5171\u4EAB",
    'fabric.elements.share.form.user-picker.add-more': "\u8F93\u5165\u66F4\u591A",
    'fabric.elements.share.form.user-picker.label.confluence': "\u59D3\u540D\u3001\u56E2\u961F\u3001\u7FA4\u7EC4\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u59D3\u540D\u3001\u56E2\u961F\u6216\u7FA4\u7EC4",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u59D3\u540D\u6216\u56E2\u961F",
    'fabric.elements.share.form.user-picker.label.email-only': "\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.label.jira': "\u59D3\u540D\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u6211\u4EEC\u627E\u4E0D\u5230\u4EFB\u4F55\u5173\u4E8E\u201C{inputValue}\u201D\u7684\u7ED3\u679C\u3002",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u6211\u4EEC\u627E\u4E0D\u5230\u4EFB\u4F55\u5173\u4E8E\u201C{inputValue}\u201D\u7684\u7ED3\u679C\u3002\u8BF7\u7528\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u9080\u8BF7\u4ED6\u4EBA\u3002",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F\u3001\u7B2C\u4E00\u7EC4",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u4F8B\u5982\uFF0Cmaria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F\u3001maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u7528\u6237\u3001\u7EC4\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u3002",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u3001\u7FA4\u7EC4\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u6216\u7FA4\u7EC4",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u6216\u56E2\u961F",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.in.integration.button': "\u5728 {integrationName} \u4E2D\u5206\u4EAB",
    'fabric.elements.share.invite.to.confluence': "\u9080\u8BF7\u52A0\u5165 Confluence",
    'fabric.elements.share.invite.to.jira': "\u9080\u8BF7\u52A0\u5165 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u5206\u4EAB\u9875\u9762",
    'fabric.elements.share.main.tab.text.jira': "\u5171\u4EAB\u4E8B\u52A1",
    'fabric.elements.share.menu.email.label': "\u7535\u5B50\u90AE\u4EF6",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u5171\u4EAB",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u535A\u5BA2\u6587\u7AE0\u5DF2\u5171\u4EAB}board {\u9762\u677F\u5DF2\u5171\u4EAB}calendar {\u65E5\u5386\u5DF2\u5171\u4EAB}draft {\u8349\u7A3F\u5DF2\u5171\u4EAB}filter {\u7B5B\u9009\u5668\u5DF2\u5171\u4EAB}issue {\u4E8B\u52A1\u5DF2\u5171\u4EAB}summary {\u6458\u8981\u5DF2\u5171\u4EAB}list {\u5217\u8868\u5DF2\u5171\u4EAB}timeline {\u65F6\u95F4\u7EBF\u5DF2\u5171\u4EAB}form {\u8868\u5355\u5DF2\u5171\u4EAB}media {\u5A92\u4F53\u5DF2\u5171\u4EAB}page {\u9875\u9762\u5DF2\u5171\u4EAB}project {\u9879\u76EE\u5DF2\u5171\u4EAB}pullrequest {\u62C9\u53D6\u8BF7\u6C42\u5DF2\u5171\u4EAB}question {\u95EE\u9898\u5DF2\u5171\u4EAB}report {\u62A5\u544A\u5DF2\u5171\u4EAB}repository {\u5B58\u50A8\u5E93\u5DF2\u5171\u4EAB}request {\u8BF7\u6C42\u5DF2\u5171\u4EAB}roadmap {\u65F6\u95F4\u7EBF\u5DF2\u5171\u4EAB}site {\u7AD9\u70B9\u5DF2\u5171\u4EAB}space {\u7A7A\u95F4\u5DF2\u5171\u4EAB}other {\u94FE\u63A5\u5DF2\u5171\u4EAB}}",
    'fabric.elements.share.to.integration.button': "\u5206\u4EAB\u5230 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u5171\u4EAB\u56FE\u6807",
    'fabric.elements.share.trigger.button.invite.text': "\u9080\u8BF7",
    'fabric.elements.share.trigger.button.text': "\u5171\u4EAB",
    'fabric.elements.share.trigger.button.tooltip.text': "\u5171\u4EAB"
};

});



parcelRegister("7v5Ga", function(module, exports) {

$parcel$export(module.exports, "ShareDialogWithTrigger", () => $2879aae105082725$export$c7f8df1e37e7f581);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $cb25w = parcelRequire("cb25w");

var $kOEld = parcelRequire("kOEld");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $k8nZq = parcelRequire("k8nZq");

var $k5uoT = parcelRequire("k5uoT");

var $3bDjY = parcelRequire("3bDjY");

var $idKBS = parcelRequire("idKBS");


var $b2oBK = parcelRequire("b2oBK");

var $hQWyD = parcelRequire("hQWyD");

var $65uFp = parcelRequire("65uFp");

var $KNlKW = parcelRequire("KNlKW");

var $bked4 = parcelRequire("bked4");

var $1t1FK = parcelRequire("1t1FK");

var $cnQaw = parcelRequire("cnQaw");

var $4gTjW = parcelRequire("4gTjW");
function $2879aae105082725$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2879aae105082725$var$shareButtonWrapperStyles = {
    name: "8s6ifx",
    styles: "display:inline-flex;outline:none"
};
const $2879aae105082725$export$4d9147e1bc6c176 = {
    users: [],
    comment: {
        format: 'plain_text',
        value: ''
    }
};
const $2879aae105082725$export$55abe7932f6ca981 = ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    });
class $2879aae105082725$export$e927f7ec13b9edc0 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.defaultProps = {
            isDisabled: false,
            dialogPlacement: 'bottom-end',
            shouldCloseOnEscapePress: true,
            triggerButtonAppearance: 'subtle',
            triggerButtonStyle: 'icon-only',
            triggerButtonTooltipPosition: 'top',
            dialogZIndex: (0, $k5uoT.layers).modal()
        };
    }
    componentDidMount() {
        if (this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isAutoOpenDialog !== prevProps.isAutoOpenDialog && this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentWillUnmount() {
        if (this.props.isAutoOpenDialog && this.props.onDialogClose) this.props.onDialogClose();
    }
    async generateShareError(err) {
        const errorBody = err.body ? await err.body : {};
        // We'll only try and deal with the first error, sorry
        const firstErrorFromBody = errorBody.messagesDetails?.[0];
        return {
            message: firstErrorFromBody?.message || err.message,
            errorCode: firstErrorFromBody?.errorCode,
            helpUrl: firstErrorFromBody?.helpUrl,
            retryable: firstErrorFromBody?.errorCode === undefined
        };
    }
    render() {
        const { isDialogOpen: isDialogOpen, isSharing: isSharing, shareError: shareError, defaultValue: defaultValue, showIntegrationForm: showIntegrationForm, selectedIntegration: selectedIntegration, isMenuItemSelected: isMenuItemSelected } = this.state;
        const { copyLink: copyLink, dialogPlacement: dialogPlacement, config: config, isFetchingConfig: isFetchingConfig, loadUserOptions: loadUserOptions, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, bottomMessage: bottomMessage, submitButtonLabel: submitButtonLabel, product: product, productAttributes: productAttributes, customHeader: customHeader, customFooter: customFooter, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, cloudId: cloudId, orgId: orgId, shareFieldsFooter: shareFieldsFooter, dialogZIndex: dialogZIndex, isPublicLink: isPublicLink, tabIndex: tabIndex, copyTooltipText: copyTooltipText, integrationMode: integrationMode, shareIntegrations: shareIntegrations, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions, isSubmitShareDisabled: isSubmitShareDisabled, additionalUserFields: additionalUserFields, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, CustomSubmitButton: CustomSubmitButton } = this.props;
        const style = typeof tabIndex !== 'undefined' && tabIndex >= 0 ? {
            outline: 'none'
        } : undefined;
        const footer = (0, $4gTjW.resolveShareFooter)(integrationMode, this.state.tabIndex, customFooter);
        // for performance purposes, we may want to have a loadable content i.e. ShareForm
        return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $2879aae105082725$var$shareButtonWrapperStyles,
            tabIndex: tabIndex,
            onKeyDown: this.handleKeyDown,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1I7E8.default), {
            content: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                    ref: this.containerRef
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $KNlKW.default), {
                    Content: selectedIntegration && selectedIntegration.Content,
                    selectedIntegration: selectedIntegration,
                    copyLink: copyLink,
                    showIntegrationForm: showIntegrationForm,
                    bottomMessage: bottomMessage,
                    customHeader: (0, $VSDnB.fg)('platform_share_custom_header_prop') && customHeader,
                    customFooter: footer,
                    loadOptions: loadUserOptions,
                    isSharing: isSharing,
                    shareFormTitle: shareFormTitle,
                    showTitle: integrationMode !== 'tabs' || !shareIntegrations || !shareIntegrations.length,
                    shareFormHelperMessage: shareFormHelperMessage,
                    shareError: shareError,
                    defaultValue: defaultValue,
                    config: config,
                    isFetchingConfig: isFetchingConfig,
                    setIsLoading: this.setIsLoading,
                    submitButtonLabel: submitButtonLabel,
                    product: product,
                    productAttributes: productAttributes,
                    enableSmartUserPicker: enableSmartUserPicker,
                    loggedInAccountId: loggedInAccountId,
                    cloudId: cloudId,
                    orgId: orgId,
                    onUserSelectionChange: this.handleOnUserSelectionChange,
                    shareFieldsFooter: shareFieldsFooter,
                    isPublicLink: isPublicLink,
                    copyTooltipText: copyTooltipText,
                    integrationMode: integrationMode,
                    shareIntegrations: shareIntegrations,
                    additionalTabs: additionalTabs,
                    builtInTabContentWidth: builtInTabContentWidth,
                    isMenuItemSelected: isMenuItemSelected,
                    isSubmitShareDisabled: isSubmitShareDisabled,
                    // actions
                    onLinkCopy: this.handleCopyLink,
                    onSubmit: this.handleShareSubmit,
                    onDismiss: this.handleFormDismiss,
                    onDialogClose: this.handleCloseDialog,
                    onTabChange: this.onTabChange,
                    onMenuItemChange: this.onMenuItemChange,
                    //ref
                    selectPortalRef: this.selectPortalRef,
                    isBrowseUsersDisabled: isBrowseUsersDisabled,
                    userPickerOptions: userPickerOptions,
                    additionalUserFields: additionalUserFields,
                    isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                    CustomSubmitButton: CustomSubmitButton
                })),
            isOpen: isDialogOpen,
            onClose: this.handleCloseDialog,
            placement: dialogPlacement,
            trigger: this.renderShareTriggerButton,
            zIndex: dialogZIndex,
            label: this.props.intl.formatMessage((0, $idKBS.messages).sharePopupLabel),
            role: "dialog",
            // TODO: remove after https://hello.atlassian.net/wiki/x/SoEGzQ experiment is finished
            offset: this.calculatePopupOffset({
                isMenuItemSelected: isMenuItemSelected,
                dialogPlacement: dialogPlacement
            }),
            shouldRenderToParent: (0, $VSDnB.fg)('enable-appropriate-reading-order-in-share-dialog')
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $k8nZq.default), {
            zIndex: (0, $4gTjW.generateSelectZIndex)(dialogZIndex)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            ref: this.selectPortalRef
        }))));
    }
    constructor(...args){
        super(...args), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), /**
   * Because the PopUp component has a higher zIndex it causes
   * the select to be rendered within it, and add scrollbars.
   * We will render the select options the PopUp outside,
   */ this.selectPortalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.start = 0, this.state = {
            isDialogOpen: false,
            isSharing: false,
            ignoreIntermediateState: false,
            defaultValue: $2879aae105082725$export$4d9147e1bc6c176,
            isUsingSplitButton: false,
            showIntegrationForm: false,
            selectedIntegration: null,
            tabIndex: 0,
            isMenuItemSelected: false,
            isLoading: false
        }, this.closeAndResetDialog = ()=>{
            this.setState({
                defaultValue: $2879aae105082725$export$4d9147e1bc6c176,
                ignoreIntermediateState: true,
                shareError: undefined,
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                isMenuItemSelected: false
            });
            const { onUserSelectionChange: onUserSelectionChange, onDialogClose: onDialogClose } = this.props;
            if (onUserSelectionChange) onUserSelectionChange($2879aae105082725$export$4d9147e1bc6c176.users);
            if (onDialogClose) onDialogClose();
        }, this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, analyticsDecorator: analyticsDecorator } = this.props;
            if (analyticsDecorator) payload = analyticsDecorator(payload);
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $b2oBK.CHANNEL_ID));
        }, this.onTabChange = (index)=>{
            let subjectId = 'shareTab';
            const { shareContentType: shareContentType } = this.props;
            if (index === 1) subjectId = 'shareToSlackTab';
            this.createAndFireEvent((0, $b2oBK.shareTabClicked)(subjectId, shareContentType));
            this.setState({
                tabIndex: index
            });
        }, this.onMenuItemChange = (menuType)=>{
            let subjectId = menuType === 'Slack' ? 'shareToSlackMenuItem' : 'shareMenuItem';
            const { shareContentType: shareContentType } = this.props;
            this.createAndFireEvent((0, $b2oBK.shareMenuItemClicked)(subjectId, shareContentType));
            this.setState({
                isMenuItemSelected: true
            });
        }, this.getFlags = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            // The reason for providing message property is that in jira,
            // the Flag system takes only Message Descriptor as payload
            // and formatMessage is called for every flag
            // if the translation data is not provided, a translated default message
            // will be displayed
            return [
                {
                    appearance: 'success',
                    title: {
                        ...(0, $idKBS.messages).shareSuccessMessage,
                        defaultMessage: formatMessage((0, $idKBS.messages).shareSuccessMessage, {
                            object: this.props.shareContentType.toLowerCase()
                        })
                    },
                    type: (0, $dcbcc8fabc474606$export$9540ac9c843b8743)
                }
            ];
        }, this.setIsLoading = (isLoading)=>{
            this.setState({
                isLoading: isLoading
            });
        }, this.focus = ()=>{
            if (this.containerRef.current) this.containerRef.current.focus();
        }, this.handleKeyDown = (event)=>{
            const { isLoading: isLoading, isDialogOpen: isDialogOpen } = this.state;
            const { shouldCloseOnEscapePress: shouldCloseOnEscapePress } = this.props;
            if (isLoading) {
                event.stopPropagation();
                this.focus();
            }
            if (isDialogOpen) switch(event.key){
                case 'Esc':
                case 'Escape':
                    // The @atlaskit/popup will capture the event and auto-close, we
                    // need to prevent that if the dialog is set to not close on `ESC`
                    if (!shouldCloseOnEscapePress) {
                        event.preventDefault();
                        event.stopPropagation();
                        // put the focus back onto the share dialog so that
                        // the user can press the escape key again to close the dialog
                        this.focus();
                        return;
                    }
                    // The dialog will auto-close in @atlaskit/popup, we just need to fire
                    // the right events.
                    if (shouldCloseOnEscapePress) {
                        // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
                        // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
                        // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
                        (0, $65uFp.renderShareDialogExp).abort();
                        this.createAndFireEvent((0, $b2oBK.cancelShare)(this.start));
                        this.closeAndResetDialog();
                    }
            }
        }, this.handleDialogOpen = ()=>{
            this.setState((state)=>({
                    isDialogOpen: !state.isDialogOpen,
                    ignoreIntermediateState: false,
                    showIntegrationForm: false,
                    selectedIntegration: null
                }), ()=>{
                const { onDialogOpen: onDialogOpen, isPublicLink: isPublicLink } = this.props;
                const { isDialogOpen: isDialogOpen } = this.state;
                if (isDialogOpen) {
                    this.start = Date.now();
                    this.createAndFireEvent((0, $b2oBK.screenEvent)({
                        isPublicLink: isPublicLink
                    }));
                    if (onDialogOpen) onDialogOpen();
                    this.focus();
                } else this.handleCloseDialog();
            });
        }, this.onTriggerClick = ()=>{
            const { onTriggerButtonClick: onTriggerButtonClick } = this.props;
            this.createAndFireEvent((0, $b2oBK.shareTriggerButtonClicked)());
            this.handleDialogOpen();
            if (onTriggerButtonClick) onTriggerButtonClick();
        }, this.handleCloseDialog = ()=>{
            if (this.props.onDialogClose) this.props.onDialogClose();
            // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
            // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
            // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
            (0, $65uFp.renderShareDialogExp).abort();
            this.setState({
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                tabIndex: 0,
                isMenuItemSelected: false
            });
        }, this.handleShareSubmit = (data)=>{
            const { onShareSubmit: onShareSubmit, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, formShareOrigin: formShareOrigin, showFlags: showFlags, isPublicLink: isPublicLink, createAnalyticsEvent: createAnalyticsEvent, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled } = this.props;
            if (!onShareSubmit) return;
            (0, $65uFp.shareSubmitExp).start();
            this.setState({
                isSharing: true
            });
            this.createAndFireEvent((0, $b2oBK.formShareSubmitted)({
                start: this.start,
                data: data,
                shareContentType: shareContentType,
                shareOrigin: formShareOrigin,
                isPublicLink: isPublicLink,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'shared',
                    actionSubject: 'page',
                    source: (0, $b2oBK.ANALYTICS_SOURCE),
                    attributes: {
                        contentType: shareContentType,
                        subContentType: shareContentSubType,
                        shareData: data
                    }
                }
            }).fire();
            onShareSubmit(data).then(()=>{
                this.closeAndResetDialog();
                this.setState({
                    isSharing: false
                });
                if (isExtendedShareDialogEnabled && data.users.length === 0) (0, $65uFp.shareSubmitExp).abort();
                else {
                    showFlags(this.getFlags());
                    (0, $65uFp.shareSubmitExp).success();
                }
            }).catch(async (err)=>{
                const shareError = await this.generateShareError(err).catch((errorGenFailed)=>({
                        message: err.message || errorGenFailed.message || 'Unknown error',
                        retryable: true
                    }));
                this.setState({
                    isSharing: false,
                    shareError: shareError
                });
                (0, $hQWyD.isValidFailedExperience)((0, $65uFp.shareSubmitExp), err);
            });
        }, this.handleFormDismiss = (data)=>{
            this.setState(({ ignoreIntermediateState: ignoreIntermediateState })=>ignoreIntermediateState ? null : {
                    defaultValue: data
                });
        }, this.calculatePopupOffset = ({ isMenuItemSelected: isMenuItemSelected, dialogPlacement: dialogPlacement })=>{
            if (isMenuItemSelected && dialogPlacement === 'bottom-end') return [
                -0.1,
                8
            ];
            return [
                0,
                8
            ];
        }, this.handleCopyLink = ()=>{
            const { copyLinkOrigin: copyLinkOrigin, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, isPublicLink: isPublicLink, shareAri: shareAri } = this.props;
            this.createAndFireEvent((0, $b2oBK.copyLinkButtonClicked)({
                start: this.start,
                shareContentType: shareContentType,
                shareOrigin: copyLinkOrigin,
                isPublicLink: isPublicLink,
                ari: shareAri,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
        }, this.handleIntegrationClick = (integration)=>{
            this.setState({
                isUsingSplitButton: false,
                isDialogOpen: true,
                showIntegrationForm: true,
                selectedIntegration: integration
            });
        }, this.renderShareTriggerButton = (triggerProps)=>{
            const { isDialogOpen: isDialogOpen, isUsingSplitButton: isUsingSplitButton } = this.state;
            const { intl: { formatMessage: formatMessage }, isDisabled: isDisabled, renderCustomTriggerButton: renderCustomTriggerButton, triggerButtonIcon: triggerButtonIcon, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, triggerButtonAppearance: triggerButtonAppearance, triggerButtonStyle: triggerButtonStyle, integrationMode: integrationMode, shareIntegrations: shareIntegrations, dialogZIndex: dialogZIndex, dialogPlacement: dialogPlacement } = this.props;
            let button;
            const ShareButtonIcon = triggerButtonIcon || $2879aae105082725$export$55abe7932f6ca981;
            // Render a custom or standard button.
            if (renderCustomTriggerButton) {
                const { shareError: shareError } = this.state;
                button = renderCustomTriggerButton({
                    error: shareError,
                    isDisabled: isDisabled,
                    isSelected: isDialogOpen,
                    onClick: this.onTriggerClick
                }, triggerProps);
            } else button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bked4.default), {
                appearance: triggerButtonAppearance,
                text: triggerButtonStyle !== 'icon-only' ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $idKBS.messages).shareTriggerButtonText) : null,
                "aria-label": formatMessage((0, $idKBS.messages).shareTriggerButtonText),
                onClick: this.onTriggerClick,
                iconBefore: triggerButtonStyle !== 'text-only' ? /*#__PURE__*/ (0, $f8Sb3.jsx)(ShareButtonIcon, {
                    label: ""
                }) : undefined,
                isSelected: isDialogOpen,
                isDisabled: isDisabled,
                ref: triggerProps.ref,
                // When we autoFocus the dialog, we want to autofocus the trigger as well, that way when the dialog is closed, the trigger is focused
                autoFocus: this.props.isAutoOpenDialog
            });
            // If the button only shows the icon, wrap it in a tooltip containing the button text.
            if (triggerButtonStyle === 'icon-only') button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
                content: !isUsingSplitButton ? triggerButtonTooltipText || formatMessage((0, $idKBS.messages).shareTriggerButtonTooltipText) : null,
                position: triggerButtonTooltipPosition,
                hideTooltipOnClick: true
            }, button);
            // If there are any integrations, wrap the share button in a split button with integrations.
            if (integrationMode === 'split' && shareIntegrations?.length) button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cnQaw.default), {
                shareButton: button,
                handleOpenSplitButton: this.handleOpenSplitButton,
                handleCloseSplitButton: this.handleCloseSplitButton,
                isUsingSplitButton: isUsingSplitButton,
                triggerButtonAppearance: triggerButtonAppearance,
                dialogZIndex: dialogZIndex,
                dialogPlacement: dialogPlacement,
                shareIntegrations: shareIntegrations,
                onIntegrationClick: this.handleIntegrationClick,
                createAndFireEvent: this.createAndFireEvent
            });
            return button;
        }, this.handleOpenSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: true
            }, ()=>this.handleCloseDialog());
            this.createAndFireEvent((0, $b2oBK.shareSplitButtonEvent)());
        }, this.handleCloseSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: false
            });
        }, this.handleOnUserSelectionChange = (value)=>{
            const { onUserSelectionChange: onUserSelectionChange } = this.props;
            this.setState({
                shareError: undefined
            });
            onUserSelectionChange?.(value);
        };
    }
}
const $2879aae105082725$export$bc20a02e9bc30e54 = (props)=>(0, $VSDnB.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1t1FK.ShareDialogWithTriggerInternal), props) : /*#__PURE__*/ (0, $f8Sb3.jsx)($2879aae105082725$export$e927f7ec13b9edc0, props);
const $2879aae105082725$export$c7f8df1e37e7f581 = (0, $cb25w.default)()((0, $8RXs9.default)($2879aae105082725$export$bc20a02e9bc30e54));

});
const $dcbcc8fabc474606$export$9540ac9c843b8743 = 'object-shared';
const $dcbcc8fabc474606$export$57af6ad1a12df839 = 'admin-notified';

parcelRegister("KNlKW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b9c92562d0fe90f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $eZJjh = parcelRequire("eZJjh");

var $dZbU3 = parcelRequire("dZbU3");

var $iXiUJ = parcelRequire("iXiUJ");
function $7b9c92562d0fe90f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7b9c92562d0fe90f$var$spinnerWrapperStyles = {
    name: "1frfa00",
    styles: "width:100%;height:100%;display:flex;justify-content:center;align-content:center"
};

const $7b9c92562d0fe90f$var$LazyShareFormLazy = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("lhRB1")));
const $7b9c92562d0fe90f$var$LoadingDialog = ({ shareFormTitle: shareFormTitle, showTitle: showTitle, setIsLoading: setIsLoading, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        setIsLoading(true);
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dZbU3.default), {
        shareFormTitle: shareFormTitle,
        integrationMode: integrationMode,
        isMenuItemSelected: isMenuItemSelected,
        // if `showTitle` is passed, we use it. Otherwise, we will show title for loading dialog.
        shouldShowTitle: typeof showTitle === 'boolean' ? showTitle : true,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $7b9c92562d0fe90f$var$spinnerWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZJjh.default), null)));
};
var $7b9c92562d0fe90f$export$2e2bcd8739ae039 = (props)=>(0, $VSDnB.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iXiUJ.default), props) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $f8Sb3.jsx)($7b9c92562d0fe90f$var$LoadingDialog, {
            shareFormTitle: props.shareFormTitle,
            showTitle: props.showTitle,
            setIsLoading: props.setIsLoading,
            integrationMode: props.integrationMode,
            isMenuItemSelected: props.isMenuItemSelected,
            isExtendedShareDialogEnabled: props.isExtendedShareDialogEnabled
        })
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($7b9c92562d0fe90f$var$LazyShareFormLazy, props));

});
parcelRegister("dZbU3", function(module, exports) {

$parcel$export(module.exports, "default", () => $018ce6039808fd6c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $idKBS = parcelRequire("idKBS");

var $6OqtU = parcelRequire("6OqtU");

var $10MNJ = parcelRequire("10MNJ");

var $i3XHT = parcelRequire("i3XHT");
const $018ce6039808fd6c$var$ShareFormWrapper = ({ shareFormTitle: shareFormTitle, shouldShowTitle: shouldShowTitle, children: children = null, header: header = null, footer: footer = null, integrationMode: integrationMode = 'off', isMenuItemSelected: isMenuItemSelected = false, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const ContentWrapper = (0, $VSDnB.fg)('share-compiled-migration') ? (0, $10MNJ.InlineDialogContentWrapper) : (0, $i3XHT.InlineDialogContentWrapper);
    const FormWrapper = (0, $VSDnB.fg)('share-compiled-migration') ? (0, $10MNJ.InlineDialogFormWrapper) : (0, $i3XHT.InlineDialogFormWrapper);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(ContentWrapper, {
        label: formatMessage((0, $idKBS.messages).formTitle),
        children: [
            (0, $VSDnB.fg)('platform_share_custom_header_prop') && header,
            /*#__PURE__*/ (0, $2OMIu.jsxs)(FormWrapper, {
                integrationMode: integrationMode,
                isMenuItemSelected: isMenuItemSelected,
                isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                children: [
                    shouldShowTitle && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6OqtU.ShareHeader), {
                        title: shareFormTitle
                    }),
                    children
                ]
            }),
            footer
        ]
    });
};
var $018ce6039808fd6c$export$2e2bcd8739ae039 = $018ce6039808fd6c$var$ShareFormWrapper;

});
parcelRegister("6OqtU", function(module, exports) {

$parcel$export(module.exports, "ShareHeader", () => $b6372b3118718628$export$77192fbb468e5af8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $l1N8i = parcelRequire("l1N8i");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $idKBS = parcelRequire("idKBS");
const $b6372b3118718628$var$headerWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    marginRight: 'space.400',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'space.400'
});
const $b6372b3118718628$var$headerWrapperExtraSpaceStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});
const $b6372b3118718628$export$77192fbb468e5af8 = ({ isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, title: title })=>{
    const headingSize = isExtendedShareDialogEnabled ? 'medium' : 'small';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: [
            $b6372b3118718628$var$headerWrapperStyles,
            isExtendedShareDialogEnabled && $b6372b3118718628$var$headerWrapperExtraSpaceStyles
        ],
        children: (0, $VSDnB.fg)('share-header-accessibility') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
            size: headingSize,
            as: "h2",
            children: title || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $idKBS.messages).formTitle
            })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
            size: headingSize,
            children: title || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $idKBS.messages).formTitle
            })
        })
    });
};

});

parcelRegister("10MNJ", function(module, exports) {

$parcel$export(module.exports, "InlineDialogFormWrapper", () => $923a8f62c8def5db$export$54db87debcabf37b);
$parcel$export(module.exports, "InlineDialogContentWrapper", () => $923a8f62c8def5db$export$a05835e82fd98f96);
/* compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $923a8f62c8def5db$var$styles = {
    menuNotSelectedAndMenuIntegration: "_1bsbpk3t",
    tabsIntegration: "_1bsb1wug",
    default: "_1bsb1j89",
    extendedDefault: "_1bsb1op3",
    inlineDialogContentWrapper: "_ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb"
};
const $923a8f62c8def5db$export$54db87debcabf37b = ({ children: children, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    if (!isMenuItemSelected && integrationMode === 'menu') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($923a8f62c8def5db$var$styles.menuNotSelectedAndMenuIntegration),
        children: children
    });
    if ((0, $VSDnB.fg)('smart_links_for_plans_platform')) {
        if (integrationMode === 'tabs') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: (0, $3JT92.cx)($923a8f62c8def5db$var$styles.tabsIntegration),
            children: children
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)(isExtendedShareDialogEnabled ? $923a8f62c8def5db$var$styles.extendedDefault : $923a8f62c8def5db$var$styles.default),
        children: children
    });
};
const $923a8f62c8def5db$export$a05835e82fd98f96 = ({ children: children, label: label })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        "aria-label": label,
        xcss: $923a8f62c8def5db$var$styles.inlineDialogContentWrapper,
        children: children
    });

});

parcelRegister("i3XHT", function(module, exports) {

$parcel$export(module.exports, "InlineDialogFormWrapper", () => $cd74a614dabf2b1c$export$54db87debcabf37b);
$parcel$export(module.exports, "InlineDialogContentWrapper", () => $cd74a614dabf2b1c$export$a05835e82fd98f96);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $MaS1v = parcelRequire("MaS1v");
/**
 * Set fixed width considering full form width and full menu width in order
 * to prevent dialog form from bouncing when isLoading prop is set to true.
 * Since loading container has 100% width, it adjusts accordingly.
 */ const $cd74a614dabf2b1c$var$calculateFormWrapperWidth = ({ integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    const formWidth = `${isExtendedShareDialogEnabled ? 452 : 352}px`;
    if (!isMenuItemSelected && integrationMode === 'menu') return 0, $MaS1v.menuWrapperWidth;
    if ((0, $VSDnB.fg)('smart_links_for_plans_platform')) {
        if (integrationMode === 'tabs') return 'auto';
    }
    return formWidth;
};
const $cd74a614dabf2b1c$export$54db87debcabf37b = ({ children: children, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    const styles = {
        width: $cd74a614dabf2b1c$var$calculateFormWrapperWidth({
            integrationMode: integrationMode,
            isMenuItemSelected: isMenuItemSelected,
            isExtendedShareDialogEnabled: isExtendedShareDialogEnabled
        })
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: styles
    }, children);
};
const $cd74a614dabf2b1c$var$inlineDialogContentWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`
});
const $cd74a614dabf2b1c$export$a05835e82fd98f96 = ({ children: children, label: label })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $cd74a614dabf2b1c$var$inlineDialogContentWrapperStyles,
        "aria-label": label
    }, children);
};

});
parcelRegister("MaS1v", function(module, exports) {

$parcel$export(module.exports, "ShareMenuItem", () => $604fc1c02fbeee92$export$144cc6e5e0841ff9);
$parcel$export(module.exports, "menuWrapperWidth", () => $604fc1c02fbeee92$export$1cd8104f92c0e299);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $kJpBP = parcelRequire("kJpBP");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $604fc1c02fbeee92$var$iconContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'size.200',
    width: 'size.200',
    borderRadius: 'border.radius'
});
const $604fc1c02fbeee92$export$144cc6e5e0841ff9 = ({ iconName: iconName, labelId: labelId, onClickHandler: onClickHandler })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
        iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($604fc1c02fbeee92$export$8f314e512d92575f, {
            icon: iconName
        }),
        onClick: onClickHandler,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...labelId
        })
    });
const $604fc1c02fbeee92$export$8f314e512d92575f = ({ icon: icon })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $604fc1c02fbeee92$var$iconContainerStyles,
        children: icon
    });
const $604fc1c02fbeee92$export$1cd8104f92c0e299 = '102px';

});



parcelRegister("iXiUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $61d94c1e278a7cbd$export$2e2bcd8739ae039);
/* lazyNext.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $MHKc7 = parcelRequire("MHKc7");

var $eZJjh = parcelRequire("eZJjh");

var $dZbU3 = parcelRequire("dZbU3");
const $61d94c1e278a7cbd$var$styles = {
    spinnerWrapperStyles: "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _ae4v1h6o"
};

const $61d94c1e278a7cbd$var$LazyShareFormLazy = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("2pN3k")));
const $61d94c1e278a7cbd$var$LoadingDialog = ({ shareFormTitle: shareFormTitle, showTitle: showTitle, setIsLoading: setIsLoading, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        setIsLoading(true);
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dZbU3.default), {
        shareFormTitle: shareFormTitle,
        integrationMode: integrationMode,
        isMenuItemSelected: isMenuItemSelected,
        // if `showTitle` is passed, we use it. Otherwise, we will show title for loading dialog.
        shouldShowTitle: typeof showTitle === 'boolean' ? showTitle : true,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: (0, $3JT92.cx)($61d94c1e278a7cbd$var$styles.spinnerWrapperStyles),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {})
        })
    });
};
var $61d94c1e278a7cbd$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)($61d94c1e278a7cbd$var$LoadingDialog, {
            shareFormTitle: props.shareFormTitle,
            showTitle: props.showTitle,
            setIsLoading: props.setIsLoading,
            integrationMode: props.integrationMode,
            isMenuItemSelected: props.isMenuItemSelected,
            isExtendedShareDialogEnabled: props.isExtendedShareDialogEnabled
        }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($61d94c1e278a7cbd$var$LazyShareFormLazy, {
            ...props
        })
    });

});
parcelRegister("2pN3k", function(module, exports) {

let $1c23f763c8bd0f91$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1c23f763c8bd0f91$var$load("ffQaD"),
    $1c23f763c8bd0f91$var$load("kvRbA"),
    $1c23f763c8bd0f91$var$load("c2PGS")
]).then(()=>parcelRequire('6GxX7'));

});


parcelRegister("lhRB1", function(module, exports) {

let $f7f4c298928f54d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f7f4c298928f54d1$var$load("ffQaD"),
    $f7f4c298928f54d1$var$load("kvRbA"),
    $f7f4c298928f54d1$var$load("3AP4i")
]).then(()=>parcelRequire('1haaP'));

});


parcelRegister("bked4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c623df2911700361$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
const $c623df2911700361$export$e980dfbc2840e8bc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(// Discard aria-haspopup
function ShareButton({ text: text, 'aria-haspopup': _ariaHasPopup, ...props }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        id: "share-trigger-btn",
        ref: ref,
        "aria-haspopup": "dialog",
        ...props,
        children: text
    });
});
$c623df2911700361$export$e980dfbc2840e8bc.displayName = 'ShareButton';
var $c623df2911700361$export$2e2bcd8739ae039 = $c623df2911700361$export$e980dfbc2840e8bc;

});

parcelRegister("1t1FK", function(module, exports) {

$parcel$export(module.exports, "ShareDialogWithTriggerInternal", () => $38a31715b9b420dd$export$bc20a02e9bc30e54);
/* ShareDialogWithTriggerNext.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $cb25w = parcelRequire("cb25w");

var $3JT92 = parcelRequire("3JT92");

var $kOEld = parcelRequire("kOEld");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $k8nZq = parcelRequire("k8nZq");

var $MHKc7 = parcelRequire("MHKc7");

var $k5uoT = parcelRequire("k5uoT");

var $3bDjY = parcelRequire("3bDjY");

var $idKBS = parcelRequire("idKBS");


var $b2oBK = parcelRequire("b2oBK");

var $hQWyD = parcelRequire("hQWyD");

var $65uFp = parcelRequire("65uFp");

var $KNlKW = parcelRequire("KNlKW");

var $bked4 = parcelRequire("bked4");

var $cnQaw = parcelRequire("cnQaw");

var $4gTjW = parcelRequire("4gTjW");
const $38a31715b9b420dd$var$styles = {
    shareButtonWrapperStyles: "_12ji1r31 _1qu2glyw _12y31o36 _1e0c116y",
    outlineNone: "_12ji1r31 _1qu2glyw _12y31o36"
};
const $38a31715b9b420dd$export$4d9147e1bc6c176 = {
    users: [],
    comment: {
        format: 'plain_text',
        value: ''
    }
};
const $38a31715b9b420dd$export$55abe7932f6ca981 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    });
class $38a31715b9b420dd$export$bc20a02e9bc30e54 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.defaultProps = {
            isDisabled: false,
            dialogPlacement: 'bottom-end',
            shouldCloseOnEscapePress: true,
            triggerButtonAppearance: 'subtle',
            triggerButtonStyle: 'icon-only',
            triggerButtonTooltipPosition: 'top',
            dialogZIndex: (0, $k5uoT.layers).modal()
        };
    }
    componentDidMount() {
        if (this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isAutoOpenDialog !== prevProps.isAutoOpenDialog && this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentWillUnmount() {
        if (this.props.isAutoOpenDialog && this.props.onDialogClose) this.props.onDialogClose();
    }
    async generateShareError(err) {
        const errorBody = err.body ? await err.body : {};
        // We'll only try and deal with the first error, sorry
        const firstErrorFromBody = errorBody.messagesDetails?.[0];
        return {
            message: firstErrorFromBody?.message || err.message,
            errorCode: firstErrorFromBody?.errorCode,
            helpUrl: firstErrorFromBody?.helpUrl,
            retryable: firstErrorFromBody?.errorCode === undefined
        };
    }
    render() {
        const { isDialogOpen: isDialogOpen, isSharing: isSharing, shareError: shareError, defaultValue: defaultValue, showIntegrationForm: showIntegrationForm, selectedIntegration: selectedIntegration, isMenuItemSelected: isMenuItemSelected } = this.state;
        const { copyLink: copyLink, dialogPlacement: dialogPlacement, config: config, isFetchingConfig: isFetchingConfig, loadUserOptions: loadUserOptions, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, bottomMessage: bottomMessage, submitButtonLabel: submitButtonLabel, product: product, productAttributes: productAttributes, customHeader: customHeader, customFooter: customFooter, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, cloudId: cloudId, orgId: orgId, shareFieldsFooter: shareFieldsFooter, dialogZIndex: dialogZIndex, isPublicLink: isPublicLink, tabIndex: tabIndex, copyTooltipText: copyTooltipText, integrationMode: integrationMode, shareIntegrations: shareIntegrations, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions, isSubmitShareDisabled: isSubmitShareDisabled, additionalUserFields: additionalUserFields, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, CustomSubmitButton: CustomSubmitButton } = this.props;
        const footer = (0, $4gTjW.resolveShareFooter)(integrationMode, this.state.tabIndex, customFooter);
        // for performance purposes, we may want to have a loadable content i.e. ShareForm
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
            xcss: (0, $3JT92.cx)($38a31715b9b420dd$var$styles.shareButtonWrapperStyles, typeof tabIndex !== 'undefined' && tabIndex >= 0 && $38a31715b9b420dd$var$styles.outlineNone),
            tabIndex: tabIndex,
            onKeyDown: this.handleKeyDown,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
                    content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: this.containerRef,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $KNlKW.default), {
                                Content: selectedIntegration && selectedIntegration.Content,
                                selectedIntegration: selectedIntegration,
                                copyLink: copyLink,
                                showIntegrationForm: showIntegrationForm,
                                bottomMessage: bottomMessage,
                                customHeader: (0, $VSDnB.fg)('platform_share_custom_header_prop') && customHeader,
                                customFooter: footer,
                                loadOptions: loadUserOptions,
                                isSharing: isSharing,
                                shareFormTitle: shareFormTitle,
                                showTitle: integrationMode !== 'tabs' || !shareIntegrations || !shareIntegrations.length,
                                shareFormHelperMessage: shareFormHelperMessage,
                                shareError: shareError,
                                defaultValue: defaultValue,
                                config: config,
                                isFetchingConfig: isFetchingConfig,
                                setIsLoading: this.setIsLoading,
                                submitButtonLabel: submitButtonLabel,
                                product: product,
                                productAttributes: productAttributes,
                                enableSmartUserPicker: enableSmartUserPicker,
                                loggedInAccountId: loggedInAccountId,
                                cloudId: cloudId,
                                orgId: orgId,
                                onUserSelectionChange: this.handleOnUserSelectionChange,
                                shareFieldsFooter: shareFieldsFooter,
                                isPublicLink: isPublicLink,
                                copyTooltipText: copyTooltipText,
                                integrationMode: integrationMode,
                                shareIntegrations: shareIntegrations,
                                additionalTabs: additionalTabs,
                                builtInTabContentWidth: builtInTabContentWidth,
                                isMenuItemSelected: isMenuItemSelected,
                                isSubmitShareDisabled: isSubmitShareDisabled,
                                // actions
                                onLinkCopy: this.handleCopyLink,
                                onSubmit: this.handleShareSubmit,
                                onDismiss: this.handleFormDismiss,
                                onDialogClose: this.handleCloseDialog,
                                onTabChange: this.onTabChange,
                                onMenuItemChange: this.onMenuItemChange,
                                //ref
                                selectPortalRef: this.selectPortalRef,
                                isBrowseUsersDisabled: isBrowseUsersDisabled,
                                userPickerOptions: userPickerOptions,
                                additionalUserFields: additionalUserFields,
                                isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                                CustomSubmitButton: CustomSubmitButton
                            })
                        }),
                    isOpen: isDialogOpen,
                    onClose: this.handleCloseDialog,
                    placement: dialogPlacement,
                    trigger: this.renderShareTriggerButton,
                    zIndex: dialogZIndex,
                    label: this.props.intl.formatMessage((0, $idKBS.messages).sharePopupLabel),
                    role: "dialog",
                    // TODO: remove after https://hello.atlassian.net/wiki/x/SoEGzQ experiment is finished
                    offset: this.calculatePopupOffset({
                        isMenuItemSelected: isMenuItemSelected,
                        dialogPlacement: dialogPlacement
                    }),
                    shouldRenderToParent: (0, $VSDnB.fg)('enable-appropriate-reading-order-in-share-dialog')
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
                    zIndex: (0, $4gTjW.generateSelectZIndex)(dialogZIndex),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ref: this.selectPortalRef
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), /**
   * Because the PopUp component has a higher zIndex it causes
   * the select to be rendered within it, and add scrollbars.
   * We will render the select options the PopUp outside,
   */ this.selectPortalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.start = 0, this.state = {
            isDialogOpen: false,
            isSharing: false,
            ignoreIntermediateState: false,
            defaultValue: $38a31715b9b420dd$export$4d9147e1bc6c176,
            isUsingSplitButton: false,
            showIntegrationForm: false,
            selectedIntegration: null,
            tabIndex: 0,
            isMenuItemSelected: false,
            isLoading: false
        }, this.closeAndResetDialog = ()=>{
            this.setState({
                defaultValue: $38a31715b9b420dd$export$4d9147e1bc6c176,
                ignoreIntermediateState: true,
                shareError: undefined,
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                isMenuItemSelected: false
            });
            const { onUserSelectionChange: onUserSelectionChange, onDialogClose: onDialogClose } = this.props;
            if (onUserSelectionChange) onUserSelectionChange($38a31715b9b420dd$export$4d9147e1bc6c176.users);
            if (onDialogClose) onDialogClose();
        }, this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, analyticsDecorator: analyticsDecorator } = this.props;
            if (analyticsDecorator) payload = analyticsDecorator(payload);
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $b2oBK.CHANNEL_ID));
        }, this.onTabChange = (index)=>{
            let subjectId = 'shareTab';
            const { shareContentType: shareContentType } = this.props;
            if (index === 1) subjectId = 'shareToSlackTab';
            this.createAndFireEvent((0, $b2oBK.shareTabClicked)(subjectId, shareContentType));
            this.setState({
                tabIndex: index
            });
        }, this.onMenuItemChange = (menuType)=>{
            let subjectId = menuType === 'Slack' ? 'shareToSlackMenuItem' : 'shareMenuItem';
            const { shareContentType: shareContentType } = this.props;
            this.createAndFireEvent((0, $b2oBK.shareMenuItemClicked)(subjectId, shareContentType));
            this.setState({
                isMenuItemSelected: true
            });
        }, this.getFlags = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            // The reason for providing message property is that in jira,
            // the Flag system takes only Message Descriptor as payload
            // and formatMessage is called for every flag
            // if the translation data is not provided, a translated default message
            // will be displayed
            return [
                {
                    appearance: 'success',
                    title: {
                        ...(0, $idKBS.messages).shareSuccessMessage,
                        defaultMessage: formatMessage((0, $idKBS.messages).shareSuccessMessage, {
                            object: this.props.shareContentType.toLowerCase()
                        })
                    },
                    type: (0, $dcbcc8fabc474606$export$9540ac9c843b8743)
                }
            ];
        }, this.setIsLoading = (isLoading)=>{
            this.setState({
                isLoading: isLoading
            });
        }, this.focus = ()=>{
            if (this.containerRef.current) this.containerRef.current.focus();
        }, this.handleKeyDown = (event)=>{
            const { isLoading: isLoading, isDialogOpen: isDialogOpen } = this.state;
            const { shouldCloseOnEscapePress: shouldCloseOnEscapePress } = this.props;
            if (isLoading) {
                event.stopPropagation();
                this.focus();
            }
            if (isDialogOpen) switch(event.key){
                case 'Esc':
                case 'Escape':
                    // The @atlaskit/popup will capture the event and auto-close, we
                    // need to prevent that if the dialog is set to not close on `ESC`
                    if (!shouldCloseOnEscapePress) {
                        event.preventDefault();
                        event.stopPropagation();
                        // put the focus back onto the share dialog so that
                        // the user can press the escape key again to close the dialog
                        this.focus();
                        return;
                    }
                    // The dialog will auto-close in @atlaskit/popup, we just need to fire
                    // the right events.
                    if (shouldCloseOnEscapePress) {
                        // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
                        // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
                        // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
                        (0, $65uFp.renderShareDialogExp).abort();
                        this.createAndFireEvent((0, $b2oBK.cancelShare)(this.start));
                        this.closeAndResetDialog();
                    }
            }
        }, this.handleDialogOpen = ()=>{
            this.setState((state)=>({
                    isDialogOpen: !state.isDialogOpen,
                    ignoreIntermediateState: false,
                    showIntegrationForm: false,
                    selectedIntegration: null
                }), ()=>{
                const { onDialogOpen: onDialogOpen, isPublicLink: isPublicLink } = this.props;
                const { isDialogOpen: isDialogOpen } = this.state;
                if (isDialogOpen) {
                    this.start = Date.now();
                    this.createAndFireEvent((0, $b2oBK.screenEvent)({
                        isPublicLink: isPublicLink
                    }));
                    if (onDialogOpen) onDialogOpen();
                    this.focus();
                } else this.handleCloseDialog();
            });
        }, this.onTriggerClick = ()=>{
            const { onTriggerButtonClick: onTriggerButtonClick } = this.props;
            this.createAndFireEvent((0, $b2oBK.shareTriggerButtonClicked)());
            this.handleDialogOpen();
            if (onTriggerButtonClick) onTriggerButtonClick();
        }, this.handleCloseDialog = ()=>{
            if (this.props.onDialogClose) this.props.onDialogClose();
            // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
            // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
            // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
            (0, $65uFp.renderShareDialogExp).abort();
            this.setState({
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                tabIndex: 0,
                isMenuItemSelected: false
            });
        }, this.handleShareSubmit = (data)=>{
            const { onShareSubmit: onShareSubmit, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, formShareOrigin: formShareOrigin, showFlags: showFlags, isPublicLink: isPublicLink, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled } = this.props;
            if (!onShareSubmit) return;
            (0, $65uFp.shareSubmitExp).start();
            this.setState({
                isSharing: true
            });
            this.createAndFireEvent((0, $b2oBK.formShareSubmitted)({
                start: this.start,
                data: data,
                shareContentType: shareContentType,
                shareOrigin: formShareOrigin,
                isPublicLink: isPublicLink,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
            onShareSubmit(data).then(()=>{
                this.closeAndResetDialog();
                this.setState({
                    isSharing: false
                });
                if (isExtendedShareDialogEnabled && data.users.length === 0) (0, $65uFp.shareSubmitExp).abort();
                else {
                    showFlags(this.getFlags());
                    (0, $65uFp.shareSubmitExp).success();
                }
            }).catch(async (err)=>{
                const shareError = await this.generateShareError(err).catch((errorGenFailed)=>({
                        message: err.message || errorGenFailed.message || 'Unknown error',
                        retryable: true
                    }));
                this.setState({
                    isSharing: false,
                    shareError: shareError
                });
                (0, $hQWyD.isValidFailedExperience)((0, $65uFp.shareSubmitExp), err);
            });
        }, this.handleFormDismiss = (data)=>{
            this.setState(({ ignoreIntermediateState: ignoreIntermediateState })=>ignoreIntermediateState ? null : {
                    defaultValue: data
                });
        }, this.calculatePopupOffset = ({ isMenuItemSelected: isMenuItemSelected, dialogPlacement: dialogPlacement })=>{
            if (isMenuItemSelected && dialogPlacement === 'bottom-end') return [
                -0.1,
                8
            ];
            return [
                0,
                8
            ];
        }, this.handleCopyLink = ()=>{
            const { copyLinkOrigin: copyLinkOrigin, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, isPublicLink: isPublicLink, shareAri: shareAri } = this.props;
            this.createAndFireEvent((0, $b2oBK.copyLinkButtonClicked)({
                start: this.start,
                shareContentType: shareContentType,
                shareOrigin: copyLinkOrigin,
                isPublicLink: isPublicLink,
                ari: shareAri,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
        }, this.handleIntegrationClick = (integration)=>{
            this.setState({
                isUsingSplitButton: false,
                isDialogOpen: true,
                showIntegrationForm: true,
                selectedIntegration: integration
            });
        }, this.renderShareTriggerButton = (triggerProps)=>{
            const { isDialogOpen: isDialogOpen, isUsingSplitButton: isUsingSplitButton } = this.state;
            const { intl: { formatMessage: formatMessage }, isDisabled: isDisabled, renderCustomTriggerButton: renderCustomTriggerButton, triggerButtonIcon: triggerButtonIcon, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, triggerButtonAppearance: triggerButtonAppearance, triggerButtonStyle: triggerButtonStyle, integrationMode: integrationMode, shareIntegrations: shareIntegrations, dialogZIndex: dialogZIndex, dialogPlacement: dialogPlacement } = this.props;
            let button;
            const ShareButtonIcon = triggerButtonIcon || $38a31715b9b420dd$export$55abe7932f6ca981;
            // Render a custom or standard button.
            if (renderCustomTriggerButton) {
                const { shareError: shareError } = this.state;
                button = renderCustomTriggerButton({
                    error: shareError,
                    isDisabled: isDisabled,
                    isSelected: isDialogOpen,
                    onClick: this.onTriggerClick
                }, triggerProps);
            } else button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bked4.default), {
                appearance: triggerButtonAppearance,
                text: triggerButtonStyle !== 'icon-only' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $idKBS.messages).shareTriggerButtonText
                }) : null,
                "aria-label": formatMessage((0, $idKBS.messages).shareTriggerButtonText),
                onClick: this.onTriggerClick,
                iconBefore: triggerButtonStyle !== 'text-only' ? /*#__PURE__*/ (0, $2OMIu.jsx)(ShareButtonIcon, {
                    label: ""
                }) : undefined,
                isSelected: isDialogOpen,
                isDisabled: isDisabled,
                ref: triggerProps.ref,
                // When we autoFocus the dialog, we want to autofocus the trigger as well, that way when the dialog is closed, the trigger is focused
                autoFocus: this.props.isAutoOpenDialog
            });
            // If the button only shows the icon, wrap it in a tooltip containing the button text.
            if (triggerButtonStyle === 'icon-only') button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: !isUsingSplitButton ? triggerButtonTooltipText || formatMessage((0, $idKBS.messages).shareTriggerButtonTooltipText) : null,
                position: triggerButtonTooltipPosition,
                hideTooltipOnClick: true,
                children: button
            });
            // If there are any integrations, wrap the share button in a split button with integrations.
            if (integrationMode === 'split' && shareIntegrations?.length) button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cnQaw.default), {
                shareButton: button,
                handleOpenSplitButton: this.handleOpenSplitButton,
                handleCloseSplitButton: this.handleCloseSplitButton,
                isUsingSplitButton: isUsingSplitButton,
                triggerButtonAppearance: triggerButtonAppearance,
                dialogZIndex: dialogZIndex,
                dialogPlacement: dialogPlacement,
                shareIntegrations: shareIntegrations,
                onIntegrationClick: this.handleIntegrationClick,
                createAndFireEvent: this.createAndFireEvent
            });
            return button;
        }, this.handleOpenSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: true
            }, ()=>this.handleCloseDialog());
            this.createAndFireEvent((0, $b2oBK.shareSplitButtonEvent)());
        }, this.handleCloseSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: false
            });
        }, this.handleOnUserSelectionChange = (value)=>{
            const { onUserSelectionChange: onUserSelectionChange } = this.props;
            this.setState({
                shareError: undefined
            });
            onUserSelectionChange?.(value);
        };
    }
}
const $38a31715b9b420dd$export$c7f8df1e37e7f581 = (0, $cb25w.default)()((0, $8RXs9.default)($38a31715b9b420dd$export$bc20a02e9bc30e54));

});
parcelRegister("cnQaw", function(module, exports) {

$parcel$export(module.exports, "default", () => $595b694e7cdc0462$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $42CjB = parcelRequire("42CjB");
var $7E6BG = parcelRequire("7E6BG");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $kEVMo = parcelRequire("kEVMo");

var $VSDnB = parcelRequire("VSDnB");


var $idKBS = parcelRequire("idKBS");

var $b2oBK = parcelRequire("b2oBK");

var $4kfPc = parcelRequire("4kfPc");
// span
const $595b694e7cdc0462$var$dropDownIntegrationButtonWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    ['button:hover']: {
        background: 'transparent'
    }
});
const $595b694e7cdc0462$var$integrationButtonText = (integrationName)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        ...(0, $idKBS.messages).shareToIntegrationButtonText,
        values: {
            integrationName: integrationName
        }
    });
const $595b694e7cdc0462$var$IntegrationButtonWrapper = ({ children: children })=>// The css has no discernible effect on the button, so it is not included in the migration
    (0, $VSDnB.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null, children) : /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $595b694e7cdc0462$var$dropDownIntegrationButtonWrapperStyles
    }, children);
const $595b694e7cdc0462$var$SplitButtonDropdown = (props)=>{
    const { triggerButtonAppearance: triggerButtonAppearance, isUsingSplitButton: isUsingSplitButton, handleOpenSplitButton: handleOpenSplitButton, handleCloseSplitButton: handleCloseSplitButton, shareIntegrations: shareIntegrations, onIntegrationClick: onIntegrationClick, createAndFireEvent: createAndFireEvent } = props;
    const onOpenChange = (0, $5uXOq.useCallback)(({ isOpen: isOpen })=>{
        if (isOpen) handleOpenSplitButton();
        else handleCloseSplitButton();
    }, [
        handleOpenSplitButton,
        handleCloseSplitButton
    ]);
    const onIntegrationButtonClick = (0, $5uXOq.useCallback)((integration)=>{
        onIntegrationClick(integration);
        createAndFireEvent((0, $b2oBK.shareIntegrationButtonEvent)(integration.type));
    }, [
        createAndFireEvent,
        onIntegrationClick
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $BLPHT.default), {
        testId: "split-button-dropdown",
        trigger: ({ triggerRef: triggerRef, ...providedProps })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $42CjB.default), {
                label: "",
                ...providedProps,
                ref: triggerRef,
                icon: (iconProps)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
                        ...iconProps,
                        size: "small"
                    }),
                appearance: triggerButtonAppearance
            }),
        placement: "bottom-end",
        isOpen: isUsingSplitButton,
        onOpenChange: onOpenChange,
        shouldRenderToParent: (0, $VSDnB.fg)('should-render-to-parent-should-be-true-people-and-')
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aRoVz.default), null, shareIntegrations.map((integration)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6B7KL.default), {
            key: integration.type,
            testId: `split-button-dropdownitem-${integration.type}`
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($595b694e7cdc0462$var$IntegrationButtonWrapper, null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4kfPc.default), {
            textColor: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
            appearance: "subtle",
            onClick: ()=>onIntegrationButtonClick(integration),
            shouldFitContainer: true,
            text: $595b694e7cdc0462$var$integrationButtonText(integration.type),
            IntegrationIcon: integration.Icon
        }))))));
};
$595b694e7cdc0462$var$SplitButtonDropdown.displayName = 'SplitButtonDropdown';
function $595b694e7cdc0462$export$2e2bcd8739ae039({ shareButton: shareButton, handleOpenSplitButton: handleOpenSplitButton, handleCloseSplitButton: handleCloseSplitButton, isUsingSplitButton: isUsingSplitButton, shareIntegrations: shareIntegrations, onIntegrationClick: onIntegrationClick, triggerButtonAppearance: triggerButtonAppearance, createAndFireEvent: createAndFireEvent }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7E6BG.SplitButton), {
        "data-testid": "split-button",
        appearance: triggerButtonAppearance
    }, shareButton, /*#__PURE__*/ (0, $f8Sb3.jsx)($595b694e7cdc0462$var$SplitButtonDropdown, {
        shareIntegrations: shareIntegrations,
        triggerButtonAppearance: triggerButtonAppearance,
        isUsingSplitButton: isUsingSplitButton,
        handleOpenSplitButton: handleOpenSplitButton,
        handleCloseSplitButton: handleCloseSplitButton,
        onIntegrationClick: onIntegrationClick,
        createAndFireEvent: createAndFireEvent
    }));
}

});
parcelRegister("7E6BG", function(module, exports) {

$parcel$export(module.exports, "SplitButton", () => $2f706a5180e21ed2$export$651ad66661acd392);
/* split-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $icwyz = parcelRequire("icwyz");

var $jvAlz = parcelRequire("jvAlz");
const $2f706a5180e21ed2$var$dividerStyles = {
    baseDivider: "_1bsbe4h9 _kqswh2mm _1pbykb7n",
    dividerDisabled: "_bfhkojnm _80om13gf _tzy41uwv",
    dividerDisabledRefreshed: "_bfhk9xzm _80om13gf",
    dividerOffsetRefreshed: "_195g1n1a"
};
const $2f706a5180e21ed2$var$dividerAppearanceStyles = {
    default: "_bfhk1fxt _tzy41uwv",
    primary: "_bfhk15cr _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkdud1 _tzy419lr"
};
const $2f706a5180e21ed2$var$dividerRefreshedAppearanceStyles = {
    default: "_bfhkmuej",
    primary: "_bfhkveue _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkdud1 _tzy419lr"
};
const $2f706a5180e21ed2$var$dividerHeightStyles = {
    default: "_4t3iviql",
    compact: "_4t3i1k8s"
};
// The divider height is calculated by subtracting twice the border width from the button height.
// This ensures the divider does not intersect with the button's border, avoiding visual issues
// caused by overlapping alpha colors (color.border) at the intersection.
const $2f706a5180e21ed2$var$defaultDividerHeightStyles = {
    default: "_4t3im1ee",
    compact: "_4t3i1hvu"
};
const $2f706a5180e21ed2$export$2e0a83ec2e27ecbb = ({ appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    const isDefaultDivider = appearance === 'default' && !isDisabled && (0, $VSDnB.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $2f706a5180e21ed2$var$dividerStyles.baseDivider,
            isDefaultDivider && $2f706a5180e21ed2$var$defaultDividerHeightStyles[spacing],
            !isDefaultDivider && $2f706a5180e21ed2$var$dividerHeightStyles[spacing],
            isDisabled && (0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerStyles.dividerDisabledRefreshed,
            isDisabled && !(0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerStyles.dividerDisabled,
            !isDisabled && (0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerRefreshedAppearanceStyles[appearance],
            !isDisabled && !(0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerAppearanceStyles[appearance],
            (0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerStyles.dividerOffsetRefreshed
        ])
    });
};
const $2f706a5180e21ed2$var$buttonStyles = {
    splitButton: "_1e0c116y _kqswh2mm _4cvr1h6o _o5721q9c",
    primaryButton: "_traeidpf _anlpidpf _p9ykidpf _bepvidpf",
    secondaryButton: "_1j4hidpf _1553idpf _1qgbidpf _y1n3idpf",
    defaultAppearanceContainer: "_2rko1sit _12jimuej _1cwg1n1a _1qu2nqa1 _12y3t94y"
};
const $2f706a5180e21ed2$export$994ba1b4c598f7 = ({ appearance: appearance, children: children, isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            appearance === 'default' && !isDisabled && (0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$buttonStyles.defaultAppearanceContainer,
            $2f706a5180e21ed2$var$buttonStyles.splitButton
        ]),
        children: children
    });
};
const $2f706a5180e21ed2$export$651ad66661acd392 = ({ children: children, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    const { PrimaryAction: PrimaryAction, SecondaryAction: SecondaryAction } = (0, $jvAlz.getActions)(children);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2f706a5180e21ed2$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $icwyz.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2f706a5180e21ed2$var$buttonStyles.primaryButton
                    ]),
                    children: PrimaryAction
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)($2f706a5180e21ed2$export$2e0a83ec2e27ecbb, {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2f706a5180e21ed2$var$buttonStyles.secondaryButton
                    ]),
                    children: SecondaryAction
                })
            ]
        })
    });
};
const $2f706a5180e21ed2$export$e3ca81100b492e15 = ({ primaryAction: primaryAction, secondaryAction: secondaryAction, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2f706a5180e21ed2$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $icwyz.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2f706a5180e21ed2$var$buttonStyles.primaryButton
                    ]),
                    children: primaryAction
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)($2f706a5180e21ed2$export$2e0a83ec2e27ecbb, {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2f706a5180e21ed2$var$buttonStyles.secondaryButton
                    ]),
                    children: secondaryAction
                })
            ]
        })
    });
};

});
parcelRegister("jvAlz", function(module, exports) {

$parcel$export(module.exports, "getActions", () => $425b7dc91147601e$export$fe3955935f564b31);

var $5uXOq = parcelRequire("5uXOq");

var $6cAn5 = parcelRequire("6cAn5");
const $425b7dc91147601e$export$fe3955935f564b31 = (children)=>{
    const [PrimaryAction, SecondaryAction] = (0, $5uXOq.Children).toArray(children);
    typeof $6cAn5;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});


parcelRegister("4kfPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe469c80a3193c7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9yOBd = parcelRequire("9yOBd");

var $VSDnB = parcelRequire("VSDnB");


var $dsMCa = parcelRequire("dsMCa");
function $0fe469c80a3193c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $0fe469c80a3193c7$var$integrationButtonCopyWrapperStyle = {
    name: "16rgrc1",
    styles: "display:flex;justify-content:left"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $0fe469c80a3193c7$var$integrationIconWrapperStyle = {
    name: "mz1ewe",
    styles: "margin:var(--ds-space-025, 2px) var(--ds-space-100, 8px) var(--ds-space-0, 0px) var(--ds-space-0, 0px)"
};
const $0fe469c80a3193c7$var$IntegrationButtonInner = (props)=>{
    const { text: text, textColor: textColor, IntegrationIcon: IntegrationIcon, ...restProps } = props;
    return(// TODO: (from codemod) CustomThemeButton will be deprecated. Please consider migrating to Pressable or Anchor Primitives with custom styles.
    /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9yOBd.default), restProps, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $0fe469c80a3193c7$var$integrationButtonCopyWrapperStyle,
        style: {
            color: textColor || `var(--ds-text, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $0fe469c80a3193c7$var$integrationIconWrapperStyle
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(IntegrationIcon, null)), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null, text))));
};
const $0fe469c80a3193c7$var$IntegrationButton = (props)=>(0, $VSDnB.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dsMCa.default), {
        text: props.text,
        onClick: props.onClick,
        IntegrationIcon: props.IntegrationIcon
    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)($0fe469c80a3193c7$var$IntegrationButtonInner, props);
$0fe469c80a3193c7$var$IntegrationButton.displayName = 'IntegrationButton';
var $0fe469c80a3193c7$export$2e2bcd8739ae039 = $0fe469c80a3193c7$var$IntegrationButton;

});
parcelRegister("dsMCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb233873498bd3e7$export$2e2bcd8739ae039);
/* IntegrationButtonNext.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $3JT92 = parcelRequire("3JT92");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");
const $eb233873498bd3e7$var$styles = {
    integrationButtonCopyWrapperStyle: "_1e0c1txw _1bah1e5h _syaz10s3",
    integrationIconWrapperStyle: "_19pkv77o _2hwxu2gc _otyrze3t _18u0ze3t"
};
const $eb233873498bd3e7$var$IntegrationButton = (props)=>{
    const { text: text, IntegrationIcon: IntegrationIcon } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
        appearance: "subtle",
        shouldFitContainer: true,
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
            as: "span",
            xcss: (0, $3JT92.cx)($eb233873498bd3e7$var$styles.integrationButtonCopyWrapperStyle),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    as: "span",
                    xcss: (0, $3JT92.cx)($eb233873498bd3e7$var$styles.integrationIconWrapperStyle),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(IntegrationIcon, {})
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                    color: "color.text",
                    children: text
                })
            ]
        })
    });
};
$eb233873498bd3e7$var$IntegrationButton.displayName = 'IntegrationButton';
var $eb233873498bd3e7$export$2e2bcd8739ae039 = $eb233873498bd3e7$var$IntegrationButton;

});



parcelRegister("4gTjW", function(module, exports) {

$parcel$export(module.exports, "generateSelectZIndex", () => $e2b0620d8e0c6274$export$eedd642610b90f47);
$parcel$export(module.exports, "getMenuPortalTargetCurrentHTML", () => $e2b0620d8e0c6274$export$e3e96376b61c8ea);
$parcel$export(module.exports, "optionDataToUsers", () => $e2b0620d8e0c6274$export$1c6fd61621efa6e2);
$parcel$export(module.exports, "allowEmails", () => $e2b0620d8e0c6274$export$e3c57815dfd9a32c);
$parcel$export(module.exports, "resolveShareFooter", () => $e2b0620d8e0c6274$export$6900a66855146901);

var $k5uoT = parcelRequire("k5uoT");
const $e2b0620d8e0c6274$export$ff1a1e5addedc4cc = 10;
const $e2b0620d8e0c6274$export$eedd642610b90f47 = (dialogZIndex)=>{
    // If user provided non-number value for zIndex, ignore and return undefined,
    // which will default to `layers.layer()` inside PopUp
    if (typeof dialogZIndex !== 'number' || !dialogZIndex) return (0, $k5uoT.layers).modal() + $e2b0620d8e0c6274$export$ff1a1e5addedc4cc;
    return dialogZIndex + $e2b0620d8e0c6274$export$ff1a1e5addedc4cc;
};
const $e2b0620d8e0c6274$export$e3e96376b61c8ea = (ref)=>{
    if (!ref) return null;
    if (!Object.prototype.hasOwnProperty.call(ref, 'current')) return null;
    // @ts-ignore ts(2339) - ref not having property current
    return ref.current;
};
const $e2b0620d8e0c6274$export$1c6fd61621efa6e2 = (optionDataArray)=>optionDataArray.map((optionData)=>{
        switch(optionData.type){
            case 'email':
                const user = {
                    type: 'user',
                    email: optionData.id
                };
                return user;
            case 'external_user':
                // When optionData.type is 'external_user', we need to convert it to 'user'
                // because 'external_user' isn't a valid type for the '/gateway/api/share' API.
                return {
                    type: 'user',
                    id: optionData.id
                };
            default:
                return {
                    type: optionData.type || 'user',
                    id: optionData.id
                };
        }
    });
const $e2b0620d8e0c6274$export$e3c57815dfd9a32c = (config)=>!(config && config.disableSharingToEmails);
const $e2b0620d8e0c6274$export$6900a66855146901 = (integrationMode, tabIndex, customFooter)=>{
    if (customFooter) {
        if (integrationMode !== 'tabs' || tabIndex === 0) return customFooter;
    }
};

});




parcelRegister("34Vv8", function(module, exports) {

$parcel$export(module.exports, "default", () => $827c4d80e4d41b48$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");
const $827c4d80e4d41b48$var$withFlagService = (WrappedComponent)=>{
    return (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            flagService: (0, $pa9q9.flagService)
        });
};
var $827c4d80e4d41b48$export$2e2bcd8739ae039 = $827c4d80e4d41b48$var$withFlagService;

});

parcelRegister("kAdLR", function(module, exports) {

$parcel$export(module.exports, "createAri", () => $63eb1b2c0e2cfff4$export$594d18a0ad2e0e57);
const $63eb1b2c0e2cfff4$var$getAriResourceOwner = (subProductId)=>{
    switch(subProductId){
        // these options aren't currently valid resource owners
        case 'jira-addon':
        case 'jira-platform':
        case 'jira-polaris':
        case 'jira-portfolio':
        case 'jira-unknown':
            return 'jira';
        // being explicit that these 3 are valid and were not forgotten
        case 'jira-core':
        case 'jira-servicedesk':
        case 'jira-software':
        default:
            return subProductId;
    }
};
const $63eb1b2c0e2cfff4$export$594d18a0ad2e0e57 = (subProductId, cloudId)=>`ari:cloud:${$63eb1b2c0e2cfff4$var$getAriResourceOwner(subProductId)}::site/${cloudId}`;

});

parcelRegister("aYuZy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea05149486244917$export$2e2bcd8739ae039);

var $2gQ83 = parcelRequire("2gQ83");

var $inlXa = parcelRequire("inlXa");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
class $ea05149486244917$export$2e2bcd8739ae039 extends (0, $inlXa.ShareServiceClient) {
    constructor({ getShareEndpoint: getShareEndpoint, getSharePayload: getSharePayload }){
        super(), this.categorizeRecipients = (recipients)=>{
            const accumulator = {
                userIds: [],
                emails: []
            };
            return recipients.reduce((acc, recipient)=>{
                if (recipient.type === 'user') {
                    // @ts-expect-error - TS2339 - Property 'email' does not exist on type 'User'.
                    if (recipient.email !== undefined) // @ts-expect-error - TS2339 - Property 'email' does not exist on type 'User'.
                    acc.emails.push(recipient.email);
                    else if (recipient.id !== undefined) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'User'.
                    acc.userIds.push(recipient.id);
                }
                return acc;
            }, accumulator);
        };
        this.getShareEndpoint = getShareEndpoint;
        this.getSharePayload = getSharePayload;
    }
    share(content, recipients, metadata, comment) {
        const categorizedRecipients = this.categorizeRecipients(recipients);
        const shareRequest = {
            usernames: categorizedRecipients.userIds,
            emails: categorizedRecipients.emails,
            message: comment?.value || '',
            atlOrigin: new (0, $2gQ83.default)({
                id: metadata.atlOriginId,
                product: 'jira'
            }).encode(),
            ...this.getSharePayload ? this.getSharePayload(content) : null
        };
        return (0, $eusud.performPostRequest)(this.getShareEndpoint(content), {
            body: JSON.stringify(shareRequest)
        }).catch((error)=>{
            (0, $jcw0u.default)({
                error: error,
                sendToPrivacyUnsafeSplunk: true,
                meta: {
                    packageName: 'jiraShareButton',
                    id: 'LegacyShareClient.share'
                },
                attributes: {
                    contentType: content.type
                }
            });
            throw error;
        });
    }
}

});

parcelRegister("kwHgU", function(module, exports) {

$parcel$export(module.exports, "loadUsers", () => $2adfecc7864678ee$export$2c3a8e05396a78be);
// @ts-expect-error - TS2305 - Module '"@atlaskit/share"' has no exported member 'OptionData'.

var $7f4tk = parcelRequire("7f4tk");
const $2adfecc7864678ee$var$USER_PICKER_LIMIT = 20;
const $2adfecc7864678ee$export$2c3a8e05396a78be = async (searchText = '')=>{
    const searchTextEncoded = encodeURIComponent(searchText);
    const url = `/rest/api/3/groupuserpicker?maxResults=${$2adfecc7864678ee$var$USER_PICKER_LIMIT}&query=${searchTextEncoded}&showAvatar=true&avatarSize=medium&excludeConnectAddons=true`;
    const groupsAndUsers = await (0, $7f4tk.default)(url);
    return groupsAndUsers.users.users.filter((user)=>user.accountType === 'atlassian').map((user)=>({
            type: 'user',
            id: user.accountId,
            name: user.displayName,
            avatarUrl: user.avatarUrl
        }));
};

});

parcelRegister("8HBuB", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $bbdf16990b710a51$export$eb3485a690c2f0b8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
var $7K5PP = parcelRequire("7K5PP");

var $7O4UO = parcelRequire("7O4UO");
var $bUa6y = parcelRequire("bUa6y");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");
const $bbdf16990b710a51$var$styles = {
    userRoleSelect: "_16jlkb7n _i0dlidpf _1ul91obz _ca0qv47k _19pkv77o"
};
const $bbdf16990b710a51$var$messages = (0, $7VHMR.defineMessages)({
    userRoleLabel: {
        "id": "share-button.user-role.user-role-label.non-final",
        "defaultMessage": "User role"
    }
});
const $bbdf16990b710a51$var$SelectOption = ({ children: children, ...props })=>{
    const { data: data, isSelected: isSelected } = props;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "medium",
        color: isSelected ? 'color.text.selected' : undefined
    }, data.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "small",
        color: "color.text.subtle"
    }, data.description)));
};
const $bbdf16990b710a51$var$getDefaultUserRole = (userRoleOptions)=>userRoleOptions.find((role)=>role.default) || userRoleOptions[0];
const $bbdf16990b710a51$export$eb3485a690c2f0b8 = ({ accessLevel: accessLevel, roles: roles, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formData = (0, $bUa6y.useFormState)({
        values: true
    });
    const shouldShowUserRole = (0, $5uXOq.useMemo)(()=>{
        const projectAccessLevel = formData?.values.projectAccessLevel?.value || accessLevel;
        return roles.length > 0 && projectAccessLevel && projectAccessLevel !== 'OPEN';
    }, [
        accessLevel,
        formData?.values.projectAccessLevel?.value,
        roles.length
    ]);
    const userRoleOptions = (0, $5uXOq.useMemo)(()=>roles.map((role)=>({
                label: role.name,
                value: role.id,
                description: role.description,
                default: role.default || false
            })), [
        roles
    ]);
    const [currentUserRole, setCurrentUserRole] = (0, $5uXOq.useState)($bbdf16990b710a51$var$getDefaultUserRole(userRoleOptions));
    (0, $5uXOq.useEffect)(()=>{
        if (!currentUserRole && userRoleOptions.length > 0) // If currentUserRole is not set, we set it to the default role from options.
        // This happens when the component is rendered before userRoleOptions are fetched.
        setCurrentUserRole($bbdf16990b710a51$var$getDefaultUserRole(userRoleOptions));
    }, [
        currentUserRole,
        userRoleOptions
    ]);
    if (!shouldShowUserRole) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: "userRole",
        defaultValue: currentUserRole
    }, ({ fieldProps: { onChange: onChange, value: value, ...fieldProps } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $bbdf16990b710a51$var$styles.userRoleSelect
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            ...fieldProps,
            isLoading: isLoading,
            options: userRoleOptions,
            value: currentUserRole,
            onChange: (userRoleOption)=>{
                if (!userRoleOption) return;
                onChange(userRoleOption);
                setCurrentUserRole(userRoleOption);
            },
            label: formatMessage($bbdf16990b710a51$var$messages.userRoleLabel),
            components: {
                Option: $bbdf16990b710a51$var$SelectOption
            },
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999
                    }),
                control: (base)=>({
                        ...base,
                        minHeight: '44px',
                        height: '100%',
                        width: '100%'
                    }),
                menu: (base)=>({
                        ...base,
                        width: 'fit-content',
                        position: 'absolute',
                        right: 0
                    }),
                option: (base)=>({
                        ...base,
                        width: '320px'
                    })
            },
            menuPortalTarget: globalThis.document.body
        })));
};

});
parcelRegister("bUa6y", function(module, exports) {

$parcel$export(module.exports, "useFormState", () => $0ed03f14f588391e$export$606f11b2eb45ecc6);

var $5uXOq = parcelRequire("5uXOq");

var $efXp3 = parcelRequire("efXp3");
// Constantized to avoid a new object reference built every call
const $0ed03f14f588391e$var$defaultSubscriptionConfig = {
    values: true
};
/**
 * Build a simple hash for a given subscription object for use in a `useMemo` dependencies array.
 * This is because `{ values: true } !== { values: true }`, but `'values:true|' === 'values:true|'`
 *
 * @example { values: true, dirty: false } => 'values:true|dirty:false|'
 */ const $0ed03f14f588391e$var$getSubscriptionHash = (subscriptionConfig)=>{
    let hash = '';
    for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
    return hash;
};
const $0ed03f14f588391e$export$606f11b2eb45ecc6 = (subscriptionConfig = $0ed03f14f588391e$var$defaultSubscriptionConfig)=>{
    const { subscribe: subscribe } = (0, $5uXOq.useContext)((0, $efXp3.FormContext));
    const [state, setState] = (0, $5uXOq.useState)();
    /**
	 * A hash for us to shallow compare the subscriptionConfig object to react to shallow changes, but avoid referential changes.
	 * We avoid computing the hash if the subscription config has referential equality altogether.
	 */ const subscriptionConfigHash = (0, $5uXOq.useMemo)(()=>$0ed03f14f588391e$var$getSubscriptionHash(subscriptionConfig), [
        subscriptionConfig
    ]);
    /**
	 * Return a memoized version of the subscription config to only react to shallow changes, not referential changes.
	 * Eg. calling `useFormState({ values: true })` twice will result in two different objects by reference, but not by shallow comparison.
	 * This will ensure we don't re-subscribe to the form state when the subscription config is the same.
	 */ const config = (0, $5uXOq.useMemo)(()=>subscriptionConfig, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally controlled with a hash to have an explicit shallow comparison
    [
        subscriptionConfigHash
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subscribe((formState)=>{
            setState(formState);
        }, config);
        return ()=>unsubscribe();
    }, [
        subscribe,
        config
    ]);
    return state;
};

});


parcelRegister("b4Qrh", function(module, exports) {

$parcel$export(module.exports, "CustomShareSubmitButton", () => $0164a6f1ecd00b94$export$acf0d09f1a6f345b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bUa6y = parcelRequire("bUa6y");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");

var $3bDjY = parcelRequire("3bDjY");

var $dD7Zc = parcelRequire("dD7Zc");

var $eCeGD = parcelRequire("eCeGD");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");
const $0164a6f1ecd00b94$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    formSharePublic: {
        "id": "share-button.custom-share-submit.form-share-public",
        "defaultMessage": "Share public link"
    },
    formSendPublic: {
        "id": "share-button.custom-share-submit.form-send-public",
        "defaultMessage": "Send public link"
    },
    formSave: {
        "id": "share-button.custom-share-submit.form-save",
        "defaultMessage": "Save"
    },
    formShare: {
        "id": "share-button.custom-share-submit.form-share",
        "defaultMessage": "Share"
    },
    formRetry: {
        "id": "share-button.custom-share-submit.form-retry",
        "defaultMessage": "Retry"
    },
    shareFailureMessage: {
        "id": "share-button.custom-share-submit.share-failure-message",
        "defaultMessage": "Unable to share"
    },
    shareFailureIconLabel: {
        "id": "share-button.custom-share-submit.share-failure-icon-label",
        "defaultMessage": "Error icon"
    }
});
const $0164a6f1ecd00b94$var$styles = {
    submitButtonWrapper: "_1e0c1txw _18u01wug",
    centerAlignedIconWrapper: "_1rjcze3t _18zrutpp _1e0c1txw _1wpz1h6o"
};
const $0164a6f1ecd00b94$export$acf0d09f1a6f345b = ({ isPublicLink: isPublicLink = false, shareError: shareError, isSharing: isSharing = false, isDisabled: isDisabled = false, isSubmitShareDisabled: isSubmitShareDisabled = false, integrationMode: integrationMode, submitButtonLabel: submitButtonLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formData = (0, $bUa6y.useFormState)({
        dirtyFields: true,
        values: true
    });
    const [shouldShowButton, setShouldShowButton] = (0, $5uXOq.useState)(false); // We use `useLayoutEffect` to ensure we show/hide the button before the button text is updated to avoid content flickering
    (0, $5uXOq.useLayoutEffect)(()=>{
        // If the form has not provided any state, we don't do anything
        if (!formData) return;
         /**
       * We hide the submit button based on 2 fields:
       * - User picker field
       * - Project access level field (provided by consumers)
       *
       * If both are unchanged, we hide the submit button.
       */ 
        const userPickerValues = formData?.values.users;
        if (userPickerValues?.length > 0 || formData?.dirtyFields?.projectAccessLevel) setShouldShowButton(true);
        else setShouldShowButton(false);
    }, [
        formData
    ]);
    const isRetryableError = !!shareError?.retryable;
    const isNonRetryableError = shareError && !shareError.retryable;
    const shouldShowWarning = isRetryableError && !isSharing;
    const buttonAppearance = !shouldShowWarning ? 'primary' : 'warning';
    const tabMode = integrationMode === 'tabs';
    const formPublicLabel = tabMode ? $0164a6f1ecd00b94$export$defe85febe8b728c.formSharePublic : $0164a6f1ecd00b94$export$defe85febe8b728c.formSendPublic;
    const formSendLabel = (0, $5uXOq.useMemo)(()=>{
        /**
     * We change the submit button label based on 2 fields:
     * - User picker field
     * - Project access level field (provided by consumers)
     *
     * If the project access level field is changed but the user picker field is pristine, we show a `Save` button.
     * If the user picker field is changed, we show a `Share` button.
     */ const userPickerValues = formData?.values?.users;
        if (userPickerValues && userPickerValues.length > 0) return $0164a6f1ecd00b94$export$defe85febe8b728c.formShare;
        return $0164a6f1ecd00b94$export$defe85febe8b728c.formSave;
    }, [
        formData?.values.users
    ]);
    const sendLabel = isPublicLink ? formPublicLabel : formSendLabel;
    const buttonLabel = isRetryableError ? $0164a6f1ecd00b94$export$defe85febe8b728c.formRetry : sendLabel;
    const buttonDisabled = isDisabled || isNonRetryableError || isSubmitShareDisabled;
    const ButtonLabelWrapper = buttonAppearance === 'warning' ? 'strong' : (0, $5uXOq.Fragment);
    if (!shouldShowButton) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $0164a6f1ecd00b94$var$styles.submitButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $0164a6f1ecd00b94$var$styles.centerAlignedIconWrapper
    }, shouldShowWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage($0164a6f1ecd00b94$export$defe85febe8b728c.shareFailureMessage),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        label: formatMessage($0164a6f1ecd00b94$export$defe85febe8b728c.shareFailureIconLabel),
        color: "var(--ds-icon-danger, #C9372C)"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: buttonAppearance,
        type: "submit",
        isLoading: isSharing,
        isDisabled: buttonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonLabelWrapper, null, submitButtonLabel || formatMessage(buttonLabel))));
};

});


parcelRegister("ckpyh", function(module, exports) {

$parcel$export(module.exports, "ProjectAccessLevelSelectContainer", () => $324557b9f7ca6aa3$export$be750a3a70b4f271);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $7O4UO = parcelRequire("7O4UO");

var $MHKc7 = parcelRequire("MHKc7");
var $joKkQ = parcelRequire("joKkQ");
var $dS3PR = parcelRequire("dS3PR");

var $fptva = parcelRequire("fptva");

var $bwyQI = parcelRequire("bwyQI");

var $jHgVl = parcelRequire("jHgVl");

var $bChGW = parcelRequire("bChGW");
var $7K5PP = parcelRequire("7K5PP");

var $1wbtX = parcelRequire("1wbtX");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");
const $324557b9f7ca6aa3$var$gridStyles = {
    root: "_yv0e5bpd _1lmcpt3h"
};
const $324557b9f7ca6aa3$var$FIELD_NAME = 'projectAccessLevel';
const $324557b9f7ca6aa3$var$styles = {
    iconContainer: "_nd5l2ec4 _18zr1b66 _1wpz1h6o _18u0r5cr",
    dropdownContainer: "_nd5l1ba5",
    descriptionContainer: "_nd5ltgt2 _1bsb1ns9 _18u0u2gc",
    optionDescriptionContainer: "_nd5ltgt2 _1bsb1ns9",
    field: "_1i53muej _15a5nqa1 _uwhke4h9 _19pk1ejb _otyrutpp _18u010v4 _2hwx10v4 _ca0qu2gc _19bv1ejb _u5f31ejb",
    skeleton: "_otyrutpp"
}; // `css` is used to customise the styles of the Select components, `cssMap` / `xcss` don't work here
const $324557b9f7ca6aa3$var$controlStyles = null;
const $324557b9f7ca6aa3$var$messages = (0, $7VHMR.defineMessages)({
    projectAccessLevelLabel: {
        "id": "share-dialog.fields.ProjectAccessLevelField.project-access-level-label.non-final",
        "defaultMessage": "Project access"
    }
});
const $324557b9f7ca6aa3$var$SelectControl = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Control, {
        ...props,
        appearance: "subtle",
        isCompact: true,
        className: (0, $bwpsq.default)([
            "_1bsb1ns9"
        ])
    });
};
const $324557b9f7ca6aa3$var$SelectOption = ({ children: children, ...props })=>{
    const { data: data, isSelected: isSelected } = props;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $joKkQ.default), {
        xcss: $324557b9f7ca6aa3$var$gridStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.iconContainer
    }, $324557b9f7ca6aa3$export$16b26cd5e98d9100(data.iconName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.dropdownContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        color: isSelected ? 'color.text.selected' : undefined
    }, data.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.optionDescriptionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        color: "color.text.subtle",
        size: "small"
    }, data.description))));
};
const $324557b9f7ca6aa3$export$16b26cd5e98d9100 = (icon)=>{
    const localProps = {
        label: '',
        color: "var(--ds-icon-accent-gray, #758195)",
        LEGACY_size: 'medium',
        spacing: 'spacious'
    };
    switch(icon){
        case 'private':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), localProps);
        case 'limited':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fptva))), localProps);
        case 'open':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jHgVl))), localProps);
    }
};
const $324557b9f7ca6aa3$var$transformToSelectOption = (level)=>({
        label: level.displayName,
        value: level.value,
        iconName: level.iconName,
        description: level.description
    });
const $324557b9f7ca6aa3$export$be750a3a70b4f271 = ({ isLoading: isLoading, currentAccessLevel: currentAccessLevel, accessLevels: accessLevels, getProjectAccessLevels: getProjectAccessLevels })=>{
    (0, $5uXOq.useEffect)(()=>{
        getProjectAccessLevels(); // only used to fetch the project access levels when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!accessLevels && isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.skeleton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.Skeleton), {
        height: "20px"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($324557b9f7ca6aa3$var$ProjectAccessLevelSelect, {
        currentAccessLevel: currentAccessLevel,
        accessLevels: accessLevels,
        getProjectAccessLevels: getProjectAccessLevels
    });
};
const $324557b9f7ca6aa3$var$ProjectAccessLevelSelect = ({ currentAccessLevel: currentAccessLevel, accessLevels: accessLevels })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const selectContainerRef = (0, $5uXOq.useRef)(null);
    const selectOptions = (0, $5uXOq.useMemo)(()=>accessLevels?.map((level)=>$324557b9f7ca6aa3$var$transformToSelectOption(level)), [
        accessLevels
    ]);
    const defaultValue = (0, $5uXOq.useMemo)(()=>selectOptions?.find((option)=>option.value === currentAccessLevel?.value), [
        currentAccessLevel,
        selectOptions
    ]);
    const [currentValue, setCurrentValue] = (0, $5uXOq.useState)(defaultValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.field
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: $324557b9f7ca6aa3$var$FIELD_NAME,
        label: formatMessage($324557b9f7ca6aa3$var$messages.projectAccessLevelLabel),
        defaultValue: defaultValue
    }, ({ fieldProps: { onChange: onChange, ...fieldProps } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $joKkQ.default), {
            xcss: $324557b9f7ca6aa3$var$gridStyles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $324557b9f7ca6aa3$var$styles.iconContainer,
            testId: "share-button.ui.project-access-level.box"
        }, $324557b9f7ca6aa3$export$16b26cd5e98d9100(currentValue?.iconName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $324557b9f7ca6aa3$var$styles.dropdownContainer,
            ref: selectContainerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            ...fieldProps,
            value: currentValue,
            options: selectOptions,
            onChange: (value)=>{
                if (!value) return;
                setCurrentValue(value);
                onChange(value);
            },
            isSearchable: false,
            menuPortalTarget: globalThis.document.body,
            components: {
                Control: $324557b9f7ca6aa3$var$SelectControl,
                Option: $324557b9f7ca6aa3$var$SelectOption
            },
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999,
                        width: selectContainerRef.current?.offsetWidth
                    }),
                dropdownIndicator: (base)=>({
                        ...base,
                        padding: 0,
                        marginLeft: "var(--ds-space-negative-075, -6px)"
                    })
            },
            menuPosition: "fixed",
            spacing: "compact"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $324557b9f7ca6aa3$var$styles.descriptionContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            color: "color.text.subtle",
            size: "small"
        }, currentValue?.description)))));
};

});
parcelRegister("joKkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $975a473d4552aaa0$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $975a473d4552aaa0$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $975a473d4552aaa0$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $975a473d4552aaa0$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $975a473d4552aaa0$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $975a473d4552aaa0$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $975a473d4552aaa0$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $975a473d4552aaa0$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $975a473d4552aaa0$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $bwpsq.default)([
            $975a473d4552aaa0$var$baseStyles.root,
            gap && $975a473d4552aaa0$var$columnGapMap[gap],
            columnGap && $975a473d4552aaa0$var$columnGapMap[columnGap],
            gap && $975a473d4552aaa0$var$rowGapMap[gap],
            rowGap && $975a473d4552aaa0$var$rowGapMap[rowGap],
            alignItems && $975a473d4552aaa0$var$alignItemsMap[alignItems],
            alignContent && $975a473d4552aaa0$var$alignContentMap[alignContent],
            justifyContent && $975a473d4552aaa0$var$justifyContentMap[justifyContent],
            autoFlow && $975a473d4552aaa0$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$975a473d4552aaa0$var$Grid.displayName = 'Grid';
var $975a473d4552aaa0$export$2e2bcd8739ae039 = $975a473d4552aaa0$var$Grid;

});

parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});

parcelRegister("jHgVl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25e57ba6be3183cfa1e359a1a5374e32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e56f2934baaafa03$var$_react = $e56f2934baaafa03$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e56f2934baaafa03$var$_baseNew = $e56f2934baaafa03$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e56f2934baaafa03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e56f2934baaafa03$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $e56f2934baaafa03$var$_react.default.createElement($e56f2934baaafa03$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$e56f2934baaafa03$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $e56f2934baaafa03$var$_default = module.exports.default = $e56f2934baaafa03$var$LockUnlockedIcon;

});

parcelRegister("1wbtX", function(module, exports) {

$parcel$export(module.exports, "getKeyframes", () => $39c21c8edc6f2616$export$b2b5e866b2fbf2ec);
$parcel$export(module.exports, "SkeletonCompiled", () => $39c21c8edc6f2616$export$dc84d515085190e);
$parcel$export(module.exports, "SpacerCompiled", () => $39c21c8edc6f2616$export$e477bb7d17087f28);
$parcel$export(module.exports, "Skeleton", () => $39c21c8edc6f2616$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Spacer", () => $39c21c8edc6f2616$export$d7a54cba636a8cd6);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");
const $39c21c8edc6f2616$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
    const fromPositionX = -Math.abs(offsetX) - 300;
    const toPositionX = fromPositionX + 2000;
    return (0, $47bDC.keyframes)({
        '0%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${fromPositionX}px 0`
        },
        '100%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${toPositionX}px 0`
        }
    });
};
const $39c21c8edc6f2616$var$shimmer = $39c21c8edc6f2616$export$b2b5e866b2fbf2ec();
const $39c21c8edc6f2616$export$1d2144641222f3bd = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ieqbub-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationDelay: props.theme.animationDelay || '0s',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.theme.animationName || $39c21c8edc6f2616$var$shimmer,
        animationTimingFunction: 'linear',
        backgroundColor: "var(--ds-skeleton, #091E420F)",
        backgroundImage: `linear-gradient( to right, ${"var(--ds-skeleton, #091E420F)"} 10%, ${"var(--ds-skeleton-subtle, #091E4208)"} 30%, ${"var(--ds-skeleton, #091E420F)"} 50% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: '2px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width
    }));
const $39c21c8edc6f2616$export$b1deee0d21f1be36 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ieqbub-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height
    }));
const $39c21c8edc6f2616$export$dc84d515085190e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height),
            "--_1gljcou": (0, $lD23V.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkn82g _1itk1kpv _12vemgnk _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $39c21c8edc6f2616$export$e477bb7d17087f28 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});
const $39c21c8edc6f2616$export$8f31e4c4a37b8e9c = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('enghealth-4756-migrate-complex-styled-component'), $39c21c8edc6f2616$export$dc84d515085190e, $39c21c8edc6f2616$export$1d2144641222f3bd);
const $39c21c8edc6f2616$export$d7a54cba636a8cd6 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('enghealth-4756-migrate-complex-styled-component'), $39c21c8edc6f2616$export$e477bb7d17087f28, $39c21c8edc6f2616$export$b1deee0d21f1be36);

});



parcelRegister("8BVfN", function(module, exports) {

$parcel$export(module.exports, "shareButtonEntryPoint", () => $735d063ad5974451$export$ad8b1559c594245d);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $735d063ad5974451$export$ad8b1559c594245d = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>{
        if (!false) return (parcelRequire("1qTOc"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "50ae946e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1qTOc", function(module, exports) {

let $10b38293cb9c1f72$var$load = (parcelRequire("28QjX"))(4);
module.exports = $10b38293cb9c1f72$var$load("lMH7t").then(()=>parcelRequire('8kufr'));

});



parcelRegister("aocZ2", function(module, exports) {

$parcel$export(module.exports, "useHasJpd", () => $ce343aabec446e95$export$885c04e01732e451);
$parcel$export(module.exports, "useFireJpdRoadmapOnTimelineSpotlightTrigger", () => $ce343aabec446e95$export$251f5afd4b360688);
$parcel$export(module.exports, "useResetJpdRoadmapOnTimelineSpotlightTrigger", () => $ce343aabec446e95$export$858259b849b74419);
$parcel$export(module.exports, "pickIssuesToConvert", () => $ce343aabec446e95$export$8bc7e05763b0e01);
$parcel$export(module.exports, "useOpenCrossFlow", () => $ce343aabec446e95$export$f6033fcc5716710c);

var $5uXOq = parcelRequire("5uXOq");

var $bHpB9 = parcelRequire("bHpB9");
var $jWY5k = parcelRequire("jWY5k");

var $jFnH8 = parcelRequire("jFnH8");

var $hqBSi = parcelRequire("hqBSi");

var $lODMY = parcelRequire("lODMY");

var $8uFbT = parcelRequire("8uFbT");

var $4R6GH = parcelRequire("4R6GH");

const $ce343aabec446e95$export$885c04e01732e451 = ()=>{
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    return licensedProducts['jira-product-discovery'] === true;
};
const $ce343aabec446e95$export$e4406211eb6a241e = ()=>{
    const timelineRoutes = new Set([
        'classic-business-timeline',
        'software-timeline',
        'software-timeline-classic'
    ]);
    return (0, $lODMY.useIsActiveRoute)(timelineRoutes);
};
const $ce343aabec446e95$export$251f5afd4b360688 = ()=>{
    const isTimelineRoute = $ce343aabec446e95$export$e4406211eb6a241e();
    const { fireTrigger: fireTrigger } = (0, $8uFbT.useFirePostOfficeTrigger)({
        triggerId: (0, $a42c0505d16c76fe$export$6672f7663a94639)
    });
    const triggerSpotlight = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('grw-880_jpd_roadmap_on_jira_timeline_killswitch')) {
            if (isTimelineRoute) fireTrigger({
                isActive: true
            });
        }
    }, [
        fireTrigger,
        isTimelineRoute
    ]);
    return triggerSpotlight;
};
const $ce343aabec446e95$export$858259b849b74419 = ()=>{
    const { fireTrigger: fireTrigger } = (0, $8uFbT.useFirePostOfficeTrigger)({
        triggerId: (0, $a42c0505d16c76fe$export$6672f7663a94639)
    });
    const triggerSpotlight = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('grw-880_jpd_roadmap_on_jira_timeline_killswitch')) fireTrigger({
            isActive: false
        });
    }, [
        fireTrigger
    ]);
    return triggerSpotlight;
};
const $ce343aabec446e95$var$sortIssuesEpicFirst = (a, b)=>{
    if (a.issueType === 'epic' && b.issueType === 'task') return -1;
    if (a.issueType === 'task' && b.issueType === 'epic') return 1;
    return 0;
};
const $ce343aabec446e95$export$7d33d0f6a9facb15 = '4';
const $ce343aabec446e95$export$2d2b9a257f1cc7e0 = '2';
const $ce343aabec446e95$var$sortIssuesInProgressFirst = (a, b)=>{
    if (a.status.categoryId === $ce343aabec446e95$export$7d33d0f6a9facb15 && b.status.categoryId === $ce343aabec446e95$export$2d2b9a257f1cc7e0) return -1;
    if (a.status.categoryId === $ce343aabec446e95$export$2d2b9a257f1cc7e0 && b.status.categoryId === $ce343aabec446e95$export$7d33d0f6a9facb15) return 1;
    return 0;
};
const $ce343aabec446e95$var$sortIssues = (a, b)=>{
    let result = $ce343aabec446e95$var$sortIssuesEpicFirst(a, b);
    if (result === 0) result = $ce343aabec446e95$var$sortIssuesInProgressFirst(a, b);
    if (result === 0) result = b.id.localeCompare(a.id);
    return result;
};
const $ce343aabec446e95$export$8bc7e05763b0e01 = (issues, maxCount = 5)=>{
    return issues.sort($ce343aabec446e95$var$sortIssues).slice(0, maxCount);
};
const $ce343aabec446e95$export$f6033fcc5716710c = (inwardIssues)=>{
    const crossFlow = (0, $bHpB9.useCrossFlow)();
    const templateId = 'jpd.product-roadmap';
    const inwardIssueIds = inwardIssues.map(({ id: id })=>id);
    const extensions = (0, $jFnH8.createProvisioningApiExtensions)({
        actions: {
            primary: {
                behaviour: (0, $jFnH8.Behaviours).LAND,
                prompt: (0, $jFnH8.Prompts).NEXT,
                options: {
                    targetTab: (0, $jFnH8.TargetTabs).SAME,
                    urlParams: {
                        templateId: templateId,
                        inwardIssueIds: inwardIssueIds.join(',')
                    }
                }
            }
        },
        jobName: 'jira-timeline-jpd-roadmap',
        jobParams: {
            inwardIssueIds: inwardIssueIds
        }
    });
    return (0, $5uXOq.useCallback)(()=>{
        crossFlow.isEnabled && crossFlow.apiV1.open({
            journey: (0, $bHpB9.Journeys).GET_STARTED,
            targetProduct: (0, $jWY5k.Targets).JIRA_PRODUCT_DISCOVERY,
            sourceComponent: 'recJpdOnJiraTimelineMoreSettings',
            sourceContext: 'jpdRoadmapButton',
            extensions: extensions,
            v1: true
        });
    }, [
        crossFlow,
        extensions
    ]);
};

});
parcelRegister("hqBSi", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $7564850c0894983d$export$54d534cc91e54850);

var $9OXo1 = parcelRequire("9OXo1");
const $7564850c0894983d$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("8uFbT", function(module, exports) {

$parcel$export(module.exports, "TriggerContextProvider", () => $30c451df5a2e0ecd$export$e80a5720bb4c8fe3);
$parcel$export(module.exports, "useTrigger", () => $30c451df5a2e0ecd$export$3b196fe93a948c18);
$parcel$export(module.exports, "useFirePostOfficeTrigger", () => $30c451df5a2e0ecd$export$83b33e5fe4cce64);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $30c451df5a2e0ecd$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $30c451df5a2e0ecd$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $30c451df5a2e0ecd$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($30c451df5a2e0ecd$var$initialActiveTriggerState);
const $30c451df5a2e0ecd$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($30c451df5a2e0ecd$var$initialTriggerDispatchState);
const $30c451df5a2e0ecd$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $5uXOq.useState)($30c451df5a2e0ecd$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $5uXOq.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $5uXOq.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $5uXOq.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($30c451df5a2e0ecd$var$TriggerContext.Provider, {
        value: triggerContextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($30c451df5a2e0ecd$var$TriggerDispatchContext.Provider, {
            value: triggerContexDispatchValue,
            children: children
        })
    });
};
const $30c451df5a2e0ecd$export$454c1d7c35958f5e = ()=>(0, $5uXOq.useContext)($30c451df5a2e0ecd$var$TriggerContext);
const $30c451df5a2e0ecd$export$23cbf084e08bdb93 = ()=>(0, $5uXOq.useContext)($30c451df5a2e0ecd$var$TriggerDispatchContext);
const $30c451df5a2e0ecd$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $30c451df5a2e0ecd$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $30c451df5a2e0ecd$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $30c451df5a2e0ecd$export$23cbf084e08bdb93();
    const fireTrigger = (0, $5uXOq.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};

});

const $a42c0505d16c76fe$export$6672f7663a94639 = 'jpd-roadmap-on-timeline-spotlight-trigger';


parcelRegister("hU5v5", function(module, exports) {

$parcel$export(module.exports, "messages", () => $69abc4ea8b10f9cc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $69abc4ea8b10f9cc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shareFormTitle: {
        "id": "horizontal-nav-header.common.share-button.share-form-title",
        "defaultMessage": "Share"
    },
    shareHelperMessage: {
        "id": "horizontal-nav-header.common.share-button.share-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("Bvv5R", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_ROUTES", () => $f129bf3689db09fc$export$f183fe8f38c8cf4f);
$parcel$export(module.exports, "HeaderFullscreenButton", () => $f129bf3689db09fc$export$ca813c374edd850d);
/* eslint-disable jira/integration/test-id-by-folder-structure */ 
var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $99BAr = parcelRequire("99BAr");

var $g7crU = parcelRequire("g7crU");

var $lODMY = parcelRequire("lODMY");
const $f129bf3689db09fc$export$f183fe8f38c8cf4f = [
    'software-boards',
    'software-timeline-classic',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-user-board',
    'software-backlog',
    'software-timeline',
    'classic-business-timeline',
    'classic-business-board',
    'connect-project',
    'connect-general',
    'forge-spa-project',
    'forge-spa-global'
];
const $f129bf3689db09fc$export$ca813c374edd850d = ()=>{
    const [isFullscreen, { setIsFullscreen: setIsFullscreen }] = (0, $g7crU.useIsFullscreen)();
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = (0, $lODMY.addRouteListener)((state)=>{
            // The board settings page is /jira/software/c/projects/TEST/boards/81/?config=filter
            // which matches the RAPIDBOARD_BOARD route, but we want to exclude it from fullscreen
            const isOnBoardConfig = state.route.name === 'rapidboard-board' && !!state.query.config;
            if (isFullscreen && !$f129bf3689db09fc$export$f183fe8f38c8cf4f.includes(state.route.name) || isOnBoardConfig) setIsFullscreen(false);
        });
        return ()=>unsubscribe();
    }, [
        isFullscreen,
        setIsFullscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "jira-horizontal-nav-header-fullscreen-button",
        packageName: "jira-horizontal-nav-header",
        teamName: "Jira Cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99BAr.default), {
        key: "fullscreen",
        "data-vc": "horizontal-nav-header-fullscreen-button",
        testId: "horizontal-nav-header.ui.fullscreen-button.fullscreen-button",
        withContainerStyles: false
    }));
};

});
parcelRegister("99BAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d923fac0cd07eb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $gucb2 = parcelRequire("gucb2");

const $d6d923fac0cd07eb$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: analyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle, isHidden: isHidden })=>{
    const [isFullscreenState, setIsFullscreenState] = (0, $5uXOq.useState)(isFullscreenProp ?? defaultFullscreen);
    const isFullscreen = isFullscreenProp ?? isFullscreenState;
    const handleToggle = (0, $5uXOq.useCallback)((wasFullscreen, globalStyle)=>{
        onToggle(wasFullscreen, globalStyle);
        setIsFullscreenState(!wasFullscreen);
    }, [
        onToggle,
        setIsFullscreenState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gucb2.default), {
        testId: testId,
        onToggle: handleToggle,
        getCustomRefs: getCustomRefs,
        analyticsAttributes: analyticsAttributes,
        withContainerStyles: withContainerStyles,
        defaultFullscreen: defaultFullscreen,
        isFullscreen: isFullscreen,
        renderAsResponsiveButton: renderAsResponsiveButton,
        shouldRenderContent: shouldRenderContent,
        isSubtle: isSubtle,
        isHidden: isHidden
    });
};
$d6d923fac0cd07eb$var$FullscreenButton.defaultProps = {
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    getCustomRefs: ()=>[],
    analyticsAttributes: {}
};
var $d6d923fac0cd07eb$export$2e2bcd8739ae039 = $d6d923fac0cd07eb$var$FullscreenButton;

});
parcelRegister("gucb2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59079bf3589c5a6$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $5JpK2 = parcelRequire("5JpK2");

var $j2iKG = parcelRequire("j2iKG");

var $3bDjY = parcelRequire("3bDjY");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3Tty1 = parcelRequire("3Tty1");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $g7crU = parcelRequire("g7crU");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");

var $22OQR = parcelRequire("22OQR");

var $6lmg7 = parcelRequire("6lmg7");

var $dCm1o = parcelRequire("dCm1o");

var $gydfO = parcelRequire("gydfO");
const $f59079bf3589c5a6$var$removeFullScreenStyle = (customRefs)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.getElementById('fullscreen-global-style')?.remove();
    if (customRefs) customRefs.forEach((ref)=>{
        if (ref !== null) ref.classList.remove('fullscreen');
    });
};
const $f59079bf3589c5a6$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: extraAnalyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle = false, isHidden: isHidden })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const customRefElements = (0, $5uXOq.useRef)(null);
    const [isFullscreenLayout, { setIsFullscreen: setIsFullScreenLayout }] = (0, $g7crU.useIsFullscreen)();
    let globalStyle = null;
    if ((0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) {
        if (!false) globalStyle = document.createElement('style');
    } else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    globalStyle = document.createElement('style');
    const isFullscreen = (0, $3HwlS.getWillShowNav4)() ? isFullscreenLayout : isFullscreenProp;
    const handleKeysInFullScreen = (0, $5uXOq.useCallback)((e)=>{
        // Ignore if it looks like the user is typing something
        if (e.target instanceof HTMLElement && ([
            'INPUT',
            'TEXTAREA',
            'SELECT'
        ].includes(e.target.tagName.toUpperCase()) || e.target.hasAttribute('contenteditable'))) return;
        // Prevent shortcuts
        const shortcutKeysToPrevent = [
            '/',
            // search
            'h' // help
        ];
        if (shortcutKeysToPrevent.includes(e.key)) e.stopPropagation();
        const navigationShortcuts = [
            '1',
            '2',
            '3',
            '4' // number keys
        ];
        if (!(0, $3HwlS.getWillShowNav4)() && navigationShortcuts.includes(e.key)) {
            // In Nav4 these keyboard shortcuts are rendered by the tab navigation
            // so they are not available in fullscreen mode
            onToggle(true, globalStyle ?? undefined);
            const customRefs = customRefElements.current;
            $f59079bf3589c5a6$var$removeFullScreenStyle(customRefs);
        }
    }, [
        globalStyle,
        onToggle
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isFullscreen) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.addEventListener('keydown', handleKeysInFullScreen, true);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.removeEventListener('keydown', handleKeysInFullScreen, true);
         // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return ()=>window?.removeEventListener('keydown', handleKeysInFullScreen, true);
    }, [
        isFullscreen,
        handleKeysInFullScreen
    ]);
    const createFullScreenStyle = (0, $5uXOq.useCallback)(()=>{
        const customElements = customRefElements.current;
        const hiddenStyles = "#ak-jira-navigation, #ak-side-navigation, #right-sidebar-panel-wrapper, [data-skip-link-wrapper='true'] { display: none }"; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const hiddenStylesNode = document.createTextNode(hiddenStyles);
        if (globalStyle) {
            globalStyle.id = 'fullscreen-global-style';
            globalStyle.appendChild(hiddenStylesNode);
        }
        if (customElements) customElements.forEach((ref)=>{
            if (ref !== null) ref.classList.add('fullscreen');
        });
        if (globalStyle) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.head?.appendChild(globalStyle);
    }, [
        globalStyle
    ]);
    const onClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        if ((0, $3HwlS.getWillShowNav4)()) {
            const analyticsAttributes = {
                ...extraAnalyticsAttributes,
                expandToFullscreen: !isFullscreenLayout
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
            setIsFullScreenLayout(!isFullscreenLayout);
            onToggle(!isFullscreenLayout);
        } else {
            customRefElements.current = getCustomRefs();
            const customElements = customRefElements.current;
            const analyticsAttributes = {
                ...extraAnalyticsAttributes,
                expandToFullscreen: !isFullscreen
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
            onToggle(isFullscreen, globalStyle ?? undefined);
            if (isFullscreen) $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
            else createFullScreenStyle();
        }
    }, [
        createFullScreenStyle,
        extraAnalyticsAttributes,
        getCustomRefs,
        globalStyle,
        isFullscreen,
        isFullscreenLayout,
        onToggle,
        setIsFullScreenLayout
    ]);
    (0, $5uXOq.useEffect)(()=>{
        customRefElements.current = getCustomRefs();
        const customElements = customRefElements.current;
        if (isFullscreen) createFullScreenStyle();
        else $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
        return ()=>$f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
    }, [
        createFullScreenStyle,
        getCustomRefs,
        isFullscreen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (defaultFullscreen) createFullScreenStyle();
         // Empty dependency array to only apply fullscreen styling once (on mount).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // remove this useEffect when cleaning up blu-5747-fullscreen-in-nav-header
    (0, $5uXOq.useEffect)(()=>{
        // exit fullscreen mode when moving to a different page
        return ()=>{
            if ((0, $3HwlS.getWillShowNav4)() && !(0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) setIsFullScreenLayout(false);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const renderButtonWithTooltip = (0, $5uXOq.useCallback)(()=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)()) {
            if ((0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $f59079bf3589c5a6$var$KeyboardShortcutContainer
                }, formatMessage(isFullscreen ? (0, $gydfO.default).exitFullScreen : (0, $gydfO.default).enterFullScreen), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $f59079bf3589c5a6$var$KeyboardShortcut
                }, formatMessage((0, $gydfO.default).fullScreenShortcut))),
                position: "top"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
                ...withContainerStyles ? {
                    testId: testId
                } : {
                    testId: 'platform.ui.fullscreen-button.fullscreen-button'
                },
                onClick: onClick,
                "aria-keyshortcuts": "Z",
                iconBefore: isFullscreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j2iKG))), {
                    label: formatMessage((0, $gydfO.default).exitFullScreen),
                    spacing: "spacious",
                    color: (0, $4R6GH.fg)('camptasks1101-update-color-tokens-of-icons') ? "var(--ds-icon-subtle, #626F86)" : 'currentColor'
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))), {
                    label: formatMessage((0, $gydfO.default).enterFullScreen),
                    spacing: "spacious",
                    color: (0, $4R6GH.fg)('camptasks1101-update-color-tokens-of-icons') ? "var(--ds-icon-subtle, #626F86)" : 'currentColor'
                }),
                appearance: isSubtle ? 'subtle' : 'default',
                "aria-hidden": isHidden,
                tabIndex: isHidden ? -1 : 0
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...withContainerStyles ? {
                    testId: testId
                } : {
                    testId: 'platform.ui.fullscreen-button.fullscreen-button'
                },
                label: isFullscreen ? formatMessage((0, $gydfO.default).exitFullScreen) : formatMessage((0, $gydfO.default).enterFullScreen),
                onClick: onClick,
                icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($j2iKG))) : (0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))),
                appearance: isSubtle ? 'subtle' : 'default',
                isTooltipDisabled: false,
                "aria-hidden": isHidden,
                tabIndex: isHidden ? -1 : 0
            });
        }
        if (renderAsResponsiveButton && !(0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lmg7.ResponsiveButton), {
            label: isFullscreen ? formatMessage((0, $gydfO.default).exitFullScreen) : formatMessage((0, $gydfO.default).enterFullScreen),
            icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($j2iKG))) : (0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))),
            onClick: onClick,
            testId: testId ?? 'platform.ui.fullscreen-button.fullscreen-button',
            "aria-hidden": isHidden,
            tabIndex: isHidden ? -1 : 0
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage(isFullscreen ? (0, $gydfO.default).exitFullScreen : (0, $gydfO.default).enterFullScreen),
            position: "top-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...withContainerStyles ? {
                testId: testId
            } : {
                testId: 'platform.ui.fullscreen-button.fullscreen-button'
            },
            appearance: "subtle",
            onClick: onClick,
            iconBefore: isFullscreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j2iKG))), {
                color: "var(--ds-icon, #44546F)",
                label: formatMessage((0, $gydfO.default).exitFullScreen),
                spacing: "spacious"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))), {
                color: "var(--ds-icon, #44546F)",
                label: formatMessage((0, $gydfO.default).enterFullScreen),
                spacing: "spacious"
            }),
            "aria-hidden": isHidden,
            tabIndex: isHidden ? -1 : 0
        }));
    }, [
        formatMessage,
        isFullscreen,
        isHidden,
        isSubtle,
        onClick,
        renderAsResponsiveButton,
        testId,
        withContainerStyles
    ]);
    const keyMap = (0, $5uXOq.useMemo)(()=>({
            z: {
                callback: ()=>{
                    setIsFullScreenLayout(!isFullscreenLayout);
                }
            }
        }), [
        isFullscreenLayout,
        setIsFullScreenLayout
    ]);
    if (!shouldRenderContent) return null;
    return withContainerStyles ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f59079bf3589c5a6$var$FullscreenButtonContainer, {
        "data-testid": "platform.ui.fullscreen-button.fullscreen-button"
    }, renderButtonWithTooltip(), (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderButtonWithTooltip(), (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap
    }));
};
var $f59079bf3589c5a6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f59079bf3589c5a6$var$FullscreenButton;
const $f59079bf3589c5a6$var$FullscreenButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1e0c116y _bfhk1bhr _16qs1cd0",
            __cmplp.className
        ])
    });
});
const $f59079bf3589c5a6$var$KeyboardShortcutContainer = (0, $8CUq3.xcss)({
    display: 'flex',
    lineHeight: 'space.200',
    alignItems: 'center',
    paddingBottom: 'space.025',
    paddingTop: 'space.025'
});
const $f59079bf3589c5a6$var$KeyboardShortcut = (0, $8CUq3.xcss)({
    border: `1px solid ${"var(--ds-text-inverse, #FFFFFF)"}`,
    borderRadius: '2px',
    marginLeft: 'space.050',
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    paddingRight: 'space.100',
    paddingLeft: 'space.100',
    lineHeight: 'space.200'
});

});
parcelRegister("5JpK2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95f2961def649e58284c9134f09a8716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42c51f70ef43f1c0$var$_react = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42c51f70ef43f1c0$var$_growDiagonal = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("l14Zy")));

var $42c51f70ef43f1c0$var$_actualSize = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("6LXPU")));
function $42c51f70ef43f1c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42c51f70ef43f1c0$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $42c51f70ef43f1c0$var$_react.default.createElement($42c51f70ef43f1c0$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $42c51f70ef43f1c0$var$_actualSize.default
    }, props));
$42c51f70ef43f1c0$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $42c51f70ef43f1c0$var$_default = module.exports.default = $42c51f70ef43f1c0$var$GrowDiagonalIcon;

});
parcelRegister("l14Zy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fa3a459488ae98c9a4dea821f09e885>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4cd903aabaa4c53$var$_react = $f4cd903aabaa4c53$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f4cd903aabaa4c53$var$_baseNew = $f4cd903aabaa4c53$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $f4cd903aabaa4c53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f4cd903aabaa4c53$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $f4cd903aabaa4c53$var$_react.default.createElement($f4cd903aabaa4c53$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$f4cd903aabaa4c53$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $f4cd903aabaa4c53$var$_default = module.exports.default = $f4cd903aabaa4c53$var$GrowDiagonalIcon;

});

parcelRegister("6LXPU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ee58c13163bfe09$var$_react = $4ee58c13163bfe09$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4ee58c13163bfe09$var$_growDiagonal = $4ee58c13163bfe09$var$_interopRequireDefault((parcelRequire("l14Zy")));
function $4ee58c13163bfe09$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4ee58c13163bfe09$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $4ee58c13163bfe09$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props, {
        newIcon: $4ee58c13163bfe09$var$_growDiagonal.default
    }));
$4ee58c13163bfe09$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $4ee58c13163bfe09$var$_default = module.exports.default = $4ee58c13163bfe09$var$MediaServicesActualSizeIcon;

});


parcelRegister("j2iKG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1977529ed36a56b31b9b9f03121ff6d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ddbcbff50c42c269$var$_react = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ddbcbff50c42c269$var$_shrinkDiagonal = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("8KRBa")));

var $ddbcbff50c42c269$var$_fitToPage = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("2bcm3")));
function $ddbcbff50c42c269$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShrinkDiagonalIcon.
 * This component is ShrinkDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesFitToPageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ddbcbff50c42c269$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $ddbcbff50c42c269$var$_react.default.createElement($ddbcbff50c42c269$var$_shrinkDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $ddbcbff50c42c269$var$_fitToPage.default
    }, props));
$ddbcbff50c42c269$var$ShrinkDiagonalIcon.Name = 'ShrinkDiagonalIconMigration';
var $ddbcbff50c42c269$var$_default = module.exports.default = $ddbcbff50c42c269$var$ShrinkDiagonalIcon;

});
parcelRegister("8KRBa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5830a86fa64b71ea84cc4eb2a6e1075>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65fc322a3db160cb$var$_react = $65fc322a3db160cb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $65fc322a3db160cb$var$_baseNew = $65fc322a3db160cb$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $65fc322a3db160cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $65fc322a3db160cb$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $65fc322a3db160cb$var$_react.default.createElement($65fc322a3db160cb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.72 6.22 13.97.97l1.06 1.06-5.25 5.25zM7.28 9.78l-5.25 5.25-1.06-1.06 5.25-5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M10 6V2H8.5v4.75c0 .414.336.75.75.75H14V6zM2 8.5h4.75a.75.75 0 0 1 .75.75V14H6v-4H2z" clip-rule="evenodd"/>`
    }, props));
$65fc322a3db160cb$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
var $65fc322a3db160cb$var$_default = module.exports.default = $65fc322a3db160cb$var$ShrinkDiagonalIcon;

});

parcelRegister("2bcm3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1966313a87133c34$var$_react = $1966313a87133c34$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1966313a87133c34$var$_shrinkDiagonal = $1966313a87133c34$var$_interopRequireDefault((parcelRequire("8KRBa")));
function $1966313a87133c34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1966313a87133c34$var$MediaServicesFitToPageIcon = (props)=>/*#__PURE__*/ $1966313a87133c34$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.413 8.997H18A1 1 0 0 1 18 11h-3.9l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 13 9.946V6.002a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374zm-8.826 6.006H6A1 1 0 0 1 6 13h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0v-1.587l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374z"/></svg>`
    }, props, {
        newIcon: $1966313a87133c34$var$_shrinkDiagonal.default
    }));
$1966313a87133c34$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
var $1966313a87133c34$var$_default = module.exports.default = $1966313a87133c34$var$MediaServicesFitToPageIcon;

});


parcelRegister("3Tty1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ba57d5dc6c0de0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $9IeM0 = parcelRequire("9IeM0");

var $4lkOX = parcelRequire("4lkOX");

var $h0GOb = parcelRequire("h0GOb");

var $k4r7E = parcelRequire("k4r7E");

var $9fuVs = parcelRequire("9fuVs");

var $kspvB = parcelRequire("kspvB");
let $6ba57d5dc6c0de0a$var$shortcutsCount = 0;
let $6ba57d5dc6c0de0a$var$subscription = null;
const $6ba57d5dc6c0de0a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $5uXOq.useContext)((0, $9fuVs.ShortcutRegistryContext)) || (0, $k4r7E.rootRegistry);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const addKeyMap = (0, $5uXOq.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $kspvB.bindKeyMapWithErrorHandling)(keyMap, location, createAnalyticsEvent({
                    action: 'pressed',
                    actionSubject: 'keyboardShortcut'
                })),
                label: label
            })), [
        parentRegistry,
        keyMap,
        location,
        createAnalyticsEvent,
        label
    ]);
    (0, $5uXOq.useEffect)(()=>{
        $6ba57d5dc6c0de0a$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $6ba57d5dc6c0de0a$var$shortcutsCount -= 1;
            if ($6ba57d5dc6c0de0a$var$subscription && $6ba57d5dc6c0de0a$var$shortcutsCount === 0) {
                $6ba57d5dc6c0de0a$var$subscription.unsubscribe();
                $6ba57d5dc6c0de0a$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $5uXOq.useEffect)(()=>{
        $6ba57d5dc6c0de0a$var$subscription = $6ba57d5dc6c0de0a$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $h0GOb.default)().subscribe((0, $4lkOX.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6ba57d5dc6c0de0a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $9IeM0.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba57d5dc6c0de0a$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("9IeM0", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $dc712fc9bec05022$export$a33a81f1fc5458ad);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $dc712fc9bec05022$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $dc712fc9bec05022$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$dc712fc9bec05022$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $eusud.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $dc712fc9bec05022$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $j8DrX.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $dc712fc9bec05022$export$b62f67be35e65859
    }
});
const $dc712fc9bec05022$export$a33a81f1fc5458ad = (0, $3sQ5x.createHook)($dc712fc9bec05022$var$Store);

});

parcelRegister("4lkOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f11d50ddafbb6f85$export$2e2bcd8739ae039);

var $h0GOb = parcelRequire("h0GOb");

var $k4r7E = parcelRequire("k4r7E");
const $f11d50ddafbb6f85$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f11d50ddafbb6f85$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $k4r7E.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $h0GOb.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f11d50ddafbb6f85$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $h0GOb.flush)();
    }
};

});
parcelRegister("h0GOb", function(module, exports) {

$parcel$export(module.exports, "default", () => $849cd54ac4017470$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $849cd54ac4017470$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $kVLXA = parcelRequire("kVLXA");

var $cab1K = parcelRequire("cab1K");
parcelRequire("jG6Un");
parcelRequire("eSGL3");
parcelRequire("1oQta");
parcelRequire("4kRRr");
parcelRequire("d0pqD");
parcelRequire("iQCJJ");
parcelRequire("fjPtF");
parcelRequire("2R2to");

var $lIZQG = parcelRequire("lIZQG");
const $849cd54ac4017470$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $849cd54ac4017470$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $849cd54ac4017470$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$849cd54ac4017470$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $849cd54ac4017470$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$849cd54ac4017470$var$isEditable(e.target) && !$849cd54ac4017470$var$ignoredKeys[e.key]);
const $849cd54ac4017470$export$25d1b8252b4c49b7 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $849cd54ac4017470$var$key$;
const $849cd54ac4017470$var$flush$ = new (0, $cab1K.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$849cd54ac4017470$export$2e2bcd8739ae039 = ()=>{
    if (!$849cd54ac4017470$var$key$) {
        $849cd54ac4017470$var$key$ = false ? new (0, $cab1K.Subject)() : (0, $kVLXA.Observable).fromEvent(document, 'keydown').filter($849cd54ac4017470$var$isRelevantKeyEvent).filter($849cd54ac4017470$export$25d1b8252b4c49b7).map((0, $lIZQG.toKeyWithModifiers));
        const sequence$ = $849cd54ac4017470$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $849cd54ac4017470$var$key$ = $849cd54ac4017470$var$key$.debounceTime(1000).startWith(null).merge($849cd54ac4017470$var$flush$).switchMapTo(sequence$);
    }
    return $849cd54ac4017470$var$key$;
};
const $849cd54ac4017470$export$4909b86c8034bf73 = ()=>{
    $849cd54ac4017470$var$flush$.next();
};

});


parcelRegister("kspvB", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $f9e30ab2465f6f16$export$77477772a9b904da);

var $2YZCu = parcelRequire("2YZCu");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");
const $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common', analyticsEvent)=>(e)=>{
        try {
            if (analyticsEvent && (0, $4R6GH.fg)('log-hotkey-analytics')) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'keyboardShortcut pressed', {
                key: key
            });
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $f9e30ab2465f6f16$export$77477772a9b904da = (keyMap, location, analyticsEvent)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location, analyticsEvent)
            }
        }), {});

});


parcelRegister("6lmg7", function(module, exports) {

$parcel$export(module.exports, "ResponsiveButton", () => $aeaed609d1db7293$export$47e82d861696e68c);
$parcel$export(module.exports, "ResponsiveLinkButton", () => $aeaed609d1db7293$export$50fd17babcd996ef);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");
var $krXdA = parcelRequire("krXdA");

var $c0aEF = parcelRequire("c0aEF");

var $1kVqg = parcelRequire("1kVqg");
var $oGXFy = parcelRequire("oGXFy");

var $3bDjY = parcelRequire("3bDjY");

var $hCCtP = parcelRequire("hCCtP");

const $aeaed609d1db7293$export$47e82d861696e68c = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, isThemed: isThemed, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $oGXFy.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});
const $aeaed609d1db7293$export$50fd17babcd996ef = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, isThemed: isThemed, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $oGXFy.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
    const IconButtonComponent = isThemed ? (0, $hCCtP.ThemedLinkIconButton) : (0, $krXdA.default);
    const ButtonComponent = isThemed ? (0, $hCCtP.ThemedLinkButton) : (0, $1GGwS.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconButtonComponent, {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
        href: restProps.href,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
        href: restProps.href,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});

});
parcelRegister("1kVqg", function(module, exports) {

$parcel$export(module.exports, "Show", () => $7b5b5f6fd54f1de9$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8CUq3 = parcelRequire("8CUq3");

var $2pf2j = parcelRequire("2pf2j");
function $7b5b5f6fd54f1de9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7b5b5f6fd54f1de9$var$showAboveQueries = (0, $2pf2j.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $7b5b5f6fd54f1de9$var$showBelowQueries = (0, $2pf2j.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $7b5b5f6fd54f1de9$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7b5b5f6fd54f1de9$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $8CUq3.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $7b5b5f6fd54f1de9$var$defaultHiddenStyles,
            above && $7b5b5f6fd54f1de9$var$showAboveQueries[above],
            below && $7b5b5f6fd54f1de9$var$showBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});
parcelRegister("2pf2j", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $f32e5b846e53517d$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $f32e5b846e53517d$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $eXt4g = parcelRequire("eXt4g");

var $h9kUS = parcelRequire("h9kUS");
const $f32e5b846e53517d$export$918f8818cfbbeb2c = (input)=>{
    return (0, $eXt4g.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $h9kUS.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $f32e5b846e53517d$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $eXt4g.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $h9kUS.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("eXt4g", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $3f07a1aff81e4a42$export$2d293d9871c38e91);
const $3f07a1aff81e4a42$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $3f07a1aff81e4a42$export$2d293d9871c38e91 = Object.keys($3f07a1aff81e4a42$export$e5ee4fe8b989fd09);
const $3f07a1aff81e4a42$export$b7ed752a57b4177b = $3f07a1aff81e4a42$export$2d293d9871c38e91[0];

});



const $7c15fdea32a398a0$export$9c51afe8741be906 = 'responsive-button.ui.responsive-button';


parcelRegister("gydfO", function(module, exports) {

$parcel$export(module.exports, "default", () => $50014cef8f43c127$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50014cef8f43c127$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    enterFullScreen: {
        "id": "platform.fullscreen-button.enter-full-screen",
        "defaultMessage": "Enter full screen"
    },
    exitFullScreen: {
        "id": "platform.fullscreen-button.exit-full-screen",
        "defaultMessage": "Exit full screen"
    },
    fullScreenShortcut: {
        "id": "platform.fullscreen-button.full-screen-shortcut",
        "defaultMessage": "Z"
    }
});

});




parcelRegister("2yK1M", function(module, exports) {

$parcel$export(module.exports, "AutomationButton", () => $d60cfa0788e5dce0$export$bf7bacbbcbf7d755);

var $5uXOq = parcelRequire("5uXOq");

var $4ldhu = parcelRequire("4ldhu");

var $3bDjY = parcelRequire("3bDjY");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $22OQR = parcelRequire("22OQR");

var $47gW9 = parcelRequire("47gW9");

var $dCm1o = parcelRequire("dCm1o");

var $j4hty = parcelRequire("j4hty");

var $34BMx = parcelRequire("34BMx");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $6m2h7 = parcelRequire("6m2h7");
const $d60cfa0788e5dce0$export$bf7bacbbcbf7d755 = ()=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const projectIdOrKey = (0, $j4hty.useProjectIdOrKey)() ?? '';
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $34BMx.automationMenuContentEntrypoint), (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey
        }), [
        cloudId,
        projectIdOrKey
    ]));
    const buttonTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const handleClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onClose: handleClose
        }), [
        handleClose
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "horizontal-nav-header-automation",
            packageName: "@atlassian/jira-horizontal-nav-header",
            runtimeProps: runtimeProps
        }), [
        entryPointReferenceSubject,
        runtimeProps
    ]);
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $6m2h7.default).automationButton),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
            ...triggerProps,
            ref: (element)=>{
                buttonTrigger(element);
                if (typeof triggerProps.ref === 'function') triggerProps.ref(element);
            },
            onClick: ()=>{
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'automationBolt',
                    action: 'opened'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
                setIsOpen(!isOpen);
            },
            appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
            isSelected: isOpen,
            "data-vc": "automation-menu-button",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))), {
                label: formatMessage((0, $6m2h7.default).automationButton),
                color: (0, $4R6GH.fg)('camptasks1101-update-color-tokens-of-icons') ? "var(--ds-icon-subtle, #626F86)" : 'currentColor',
                spacing: "spacious"
            })
        })), [
        buttonTrigger,
        createAnalyticsEvent,
        formatMessage,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-end",
        messageId: "horizontal-nav.ui.content.header.extra-components-far.automation-button.popup",
        messageType: "transactional",
        content: content,
        trigger: trigger,
        shouldRenderToParent: true
    });
};

});
parcelRegister("4ldhu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $32936cf628dec798$var$_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $32936cf628dec798$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32936cf628dec798$var$AutomationIcon = (props)=>/*#__PURE__*/ $32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;

});

parcelRegister("j4hty", function(module, exports) {

$parcel$export(module.exports, "useProjectIdOrKey", () => $b3dce18eb6886925$export$12b007aa97244648);
$parcel$export(module.exports, "getConnection", () => $b3dce18eb6886925$export$26b2f38d0fc342a3);
$parcel$export(module.exports, "getStoreEdges", () => $b3dce18eb6886925$export$137f3eb02a91737e);
$parcel$export(module.exports, "getAnalyticsTabOrder", () => $b3dce18eb6886925$export$58da6593ae071994);

var $iJZ8l = parcelRequire("iJZ8l");

var $lODMY = parcelRequire("lODMY");

var $1nb22 = parcelRequire("1nb22");

const $b3dce18eb6886925$export$12b007aa97244648 = (0, $lODMY.createRouterSelector)((state)=>(0, $1nb22.getProjectIdOrKey)(state.match, state.query));
const $b3dce18eb6886925$export$26b2f38d0fc342a3 = (store, containerNavigationId)=>{
    const dataId = (0, $iJZ8l.default)({
        id: containerNavigationId
    }, 'JiraContainerNavigation');
    return dataId && store.get(dataId)?.getLinkedRecord('navigationItems', {
        first: (0, $f764d292f97c6de7$export$4653cda61a4943d6)
    });
};
const $b3dce18eb6886925$export$137f3eb02a91737e = (store, containerNavigationId)=>{
    const connection = $b3dce18eb6886925$export$26b2f38d0fc342a3(store, containerNavigationId);
    if (!connection) return undefined;
    return connection.getLinkedRecords('edges');
};
const $b3dce18eb6886925$export$58da6593ae071994 = (store, containerNavigationId)=>{
    const edges = $b3dce18eb6886925$export$137f3eb02a91737e(store, containerNavigationId);
    if (!edges) return [];
    return edges.map((edge)=>{
        const node = edge?.getLinkedRecord('node');
        const tabId = node?.getValue('appId');
        return {
            itemType: String(node?.getValue('typeKey')).toLowerCase(),
            itemId: tabId ? String(tabId) : undefined,
            // relay will have already updated the changed item, exclude the new default to restore the original values
            defaultTab: Boolean(node?.getValue('isDefault'))
        };
    });
};

});
const $f764d292f97c6de7$export$4653cda61a4943d6 = 75;


parcelRegister("34BMx", function(module, exports) {

$parcel$export(module.exports, "automationMenuContentEntrypoint", () => $580b12aeb8052638$export$4606319c52466ef3);

var $a2DYS = parcelRequire("a2DYS");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $580b12aeb8052638$export$4606319c52466ef3 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("9KH2e")).then((module)=>module.AutomationPopupMenuContent), {
        moduleId: "21f1ab04",
        moduleName: "AutomationPopupMenuContent",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectIdOrKey: projectIdOrKey })=>{
        return {
            queries: {
                mainQuery: {
                    parameters: $a2DYS.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});

});
parcelRegister("a2DYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b62eaa5f94455d00$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3db9d4bc8d19d19d9cfe37c02c44f0d6>>
 * @relayHash f760e3b2d740a1f6e9c4d2cb3cc89946
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 26cbceefe67b9367507439f022ac920e1087387c6a303ca20df7285fc00ce6fc
const $b62eaa5f94455d00$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "26cbceefe67b9367507439f022ac920e1087387c6a303ca20df7285fc00ce6fc",
        "metadata": {},
        "name": "AutomationPopupMenuContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b62eaa5f94455d00$export$2e2bcd8739ae039 = $b62eaa5f94455d00$var$node;

});

parcelRegister("9KH2e", function(module, exports) {

let $7199cacb3058f878$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7199cacb3058f878$var$load("ffQaD"),
    $7199cacb3058f878$var$load("kvRbA"),
    $7199cacb3058f878$var$load("kNFvF"),
    $7199cacb3058f878$var$load("iJ3Fs")
]).then(()=>parcelRequire('97LNn'));

});


parcelRegister("6m2h7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ae77624dfe3b540$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3ae77624dfe3b540$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    automationButton: {
        "id": "horizontal-nav-header.extra-components-far.automation-button.automation-button",
        "defaultMessage": "Automation"
    }
});

});



parcelRegister("hjXMc", function(module, exports) {

$parcel$export(module.exports, "HorizontalNavProjectBreadcrumbs", () => $b0980bff75b13480$export$da30c3ec9be0517b);

var $kyIvz = parcelRequire("kyIvz");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fuUnn = parcelRequire("fuUnn");
var $jbeEq = parcelRequire("jbeEq");

var $koVbs = parcelRequire("koVbs");

var $4iSVn = parcelRequire("4iSVn");
const $b0980bff75b13480$var$createProjectUrl = (projectKey)=>`/browse/${encodeURIComponent(projectKey)}`;
const $b0980bff75b13480$export$da30c3ec9be0517b = ({ projectFragment: projectFragment, shouldShowProjectName: shouldShowProjectName = false })=>{
    const project = (0, $8Uumt.useFragment)((0, $kyIvz.default), projectFragment);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1tke1tcg _nwukvy9e _1o8h13fh"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbeEq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
        href: "/jira/projects",
        text: formatMessage((0, $4iSVn.default).projectsTitle)
    }), shouldShowProjectName && project && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
        href: $b0980bff75b13480$var$createProjectUrl(project?.key),
        text: project?.name
    })));
};
const $b0980bff75b13480$var$breadcrumbStyles = null;

});
parcelRegister("kyIvz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc32ea129d13e4b0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d8c448f51169523f40ef830f3470245>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fc32ea129d13e4b0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraProject"
};
$fc32ea129d13e4b0$var$node.hash = "ed2f4bc001a364f753ffebfa5a1fa48e";
var $fc32ea129d13e4b0$export$2e2bcd8739ae039 = $fc32ea129d13e4b0$var$node;

});

parcelRegister("fuUnn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa85d0f49630632$export$2e2bcd8739ae039);
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $hVWqN = parcelRequire("hVWqN");

var $6hWJD = parcelRequire("6hWJD");
const $8fa85d0f49630632$var$itemWrapperStyles = null;
const $8fa85d0f49630632$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $8fa85d0f49630632$var$ICON_WIDTH_ESTIMATE = 24;
const $8fa85d0f49630632$var$staticItemStyles = null;
const $8fa85d0f49630632$var$staticItemWithTruncationStyles = null;
const $8fa85d0f49630632$var$staticItemWithoutTruncationStyles = null;
const $8fa85d0f49630632$var$BreadcrumbsItem = /*#__PURE__*/ (0, $5uXOq.memo)(({ analyticsContext: analyticsContext, component: component, href: // `createAnalyticsEvent` should be here, but throws errors on render since
// it ends up being spread on a DOM element at the very end
href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, ref: // This is overridden by the `buttonRef` below
ref, target: target, testId: testId, text: text, truncationWidth: truncationWidth, // I believe there is only `createAnalyticsEvent` left on here, but leaving
// it here to allow this to be a patch and not a major
...rest })=>{
    const buttonRef = (0, $5uXOq.useRef)(null);
    // If icons are provided we include their width in the truncation calculation to ensure we're as accurate as possible.
    // Note: this assumes icons are 24px wide which should be almost always.
    // Not really an issue if the icons are smaller, just that truncation occurs slightly earlier than you may want.
    let iconWidthAllowance = 0;
    if (iconBefore) iconWidthAllowance += $8fa85d0f49630632$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $8fa85d0f49630632$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, showTooltip] = (0, $6hWJD.default)(truncationWidth, buttonRef.current, iconWidthAllowance);
    // This should be a part of staticItemStyles but it requires the !important flag to prevent the padding from being overridden by the button styles
    // compiled treats `${token(xxx)} !important` differently when concat !important in es2019 and esm built files
    // the padding and font weight were not sourced correctly in the esm build
    const buttonOverrideStyles = {
        paddingBlock: "var(--ds-space-025, 2px)",
        fontWeight: "var(--ds-font-weight-regular, 400)"
    };
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$8fa85d0f49630632$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hVWqN.default), {
        ...rest,
        analyticsContext: analyticsContext,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: buttonRef,
        target: target,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: truncationWidth ? {
            ...dynamicItemStyles,
            ...buttonOverrideStyles
        } : buttonOverrideStyles,
        className: (0, $bwpsq.default)([
            "_vwz41txs",
            truncationWidth ? "_p12f8zc4" : "_1ul9grf3 _1o9zzg3v"
        ]),
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _ect41gqc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsoftgi _toskidpf _15621n76 _191d1h6o"
        ]),
        children: showTooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: step
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8fa85d0f49630632$export$2e2bcd8739ae039 = $8fa85d0f49630632$var$BreadcrumbsItem;

});
parcelRegister("hVWqN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a95af0809bc014a8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $fVnbM = parcelRequire("fVnbM");

var $eGmKJ = parcelRequire("eGmKJ");
const $a95af0809bc014a8$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $a95af0809bc014a8$var$noop = (0, $eGmKJ.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $a95af0809bc014a8$var$Step = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $a95af0809bc014a8$var$noop, target: target, testId: testId, // Button does not take `createAnalyticsEvent`, but it is spread on anyway
...props }, ref)=>{
    const handleClicked = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$a95af0809bc014a8$var$analyticsAttributes
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        ...props,
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: hasOverflow ? undefined : iconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    });
});
var $a95af0809bc014a8$export$2e2bcd8739ae039 = $a95af0809bc014a8$var$Step;

});

parcelRegister("6hWJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $39e9e81e9bc6c25a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
function $39e9e81e9bc6c25a$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $5uXOq.useState)((0, $VSDnB.fg)('platform_fix_unnessesary_re-renders_in_breadcrumbs') ? Boolean(shouldCheckWidth) : true);
    const [showTooltip, setShowTooltip] = (0, $5uXOq.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $5uXOq.useEffect)(()=>{
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});


parcelRegister("jbeEq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f33b456747f6edef$export$2e2bcd8739ae039);
/* breadcrumbs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");

var $eGmKJ = parcelRequire("eGmKJ");

var $iidvu = parcelRequire("iidvu");

var $5djWe = parcelRequire("5djWe");
const $f33b456747f6edef$var$defaultMaxItems = 8;
const $f33b456747f6edef$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $f33b456747f6edef$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $f33b456747f6edef$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children;
const $f33b456747f6edef$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $f33b456747f6edef$var$noop = (0, $eGmKJ.default);
const $f33b456747f6edef$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $f33b456747f6edef$var$breadcrumbStyles = null;
const $f33b456747f6edef$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $f33b456747f6edef$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $f33b456747f6edef$var$noop, analyticsContext: analyticsContext, label: label = $f33b456747f6edef$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $f33b456747f6edef$var$defaultEllipsisLabel } = props;
    const [expanded, setExpanse] = (0, $5uXOq.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $5uXOq.useState)(false);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $f33b456747f6edef$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealed = ()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($f33b456747f6edef$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    };
    (0, $5djWe.useOnRevealed)(focusFirstRevealed, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$f33b456747f6edef$var$analyticsAttributes
    });
    const childrenArray = $f33b456747f6edef$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(childrenArray, (child, index)=>{
        //To avoid error if child is a string
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray; // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iidvu.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $2OMIu.jsx)("nav", {
        "aria-label": label,
        ref: (0, $5JjdN.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("ol", {
            "data-testid": testId,
            className: (0, $bwpsq.default)([
                "_1e0c1txw _1n261g80 _syaz1wmz _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
            ]),
            children: breadcrumbsItems
        })
    });
});
const $f33b456747f6edef$var$Breadcrumbs = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)($f33b456747f6edef$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        ref: ref,
        testId: testId
    }))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $f33b456747f6edef$export$2e2bcd8739ae039 = $f33b456747f6edef$var$Breadcrumbs;

});
parcelRegister("iidvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3f2526167b8235c$export$2e2bcd8739ae039);
/* ellipsis-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $eGmKJ = parcelRequire("eGmKJ");
const $b3f2526167b8235c$var$noop = (0, $eGmKJ.default);
const $b3f2526167b8235c$var$itemWrapperStyles = null;
const $b3f2526167b8235c$var$staticItemStyles = null;
const $b3f2526167b8235c$var$EllipsisItem = /*#__PURE__*/ (0, $5uXOq.memo)(({ label: label, onClick: onClick = $b3f2526167b8235c$var$noop, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _15621n76 _191d1h6o"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
            appearance: "subtle-link",
            "aria-label": label,
            onClick: onClick,
            spacing: "none",
            testId: testId,
            className: (0, $bwpsq.default)([
                "_1rjc1tvq _k48p1hhk _vwz41txs"
            ]),
            children: "\u2026"
        })
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b3f2526167b8235c$export$2e2bcd8739ae039 = $b3f2526167b8235c$var$EllipsisItem;

});

parcelRegister("5djWe", function(module, exports) {

$parcel$export(module.exports, "useOnRevealed", () => $16bf9036c9802d42$export$e9c4922b2ecf808a);

var $5uXOq = parcelRequire("5uXOq");

var $lp9re = parcelRequire("lp9re");
function $16bf9036c9802d42$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $lp9re.default)(isExpanded);
    (0, $5uXOq.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});


parcelRegister("4iSVn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f0d02585d9d2048$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2f0d02585d9d2048$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectsTitle: {
        "id": "horizontal-nav-header.breadcrumbs.project",
        "defaultMessage": "Projects"
    }
});

});


parcelRegister("2qjHu", function(module, exports) {

$parcel$export(module.exports, "NavigationTeamButton", () => $6eec8805144787da$export$df0da44d232d7c73);

var $1qITH = parcelRequire("1qITH");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1jau2 = parcelRequire("1jau2");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $14XJw = parcelRequire("14XJw");

var $6s1PB = parcelRequire("6s1PB");

var $cZpsT = parcelRequire("cZpsT");
const $6eec8805144787da$export$df0da44d232d7c73 = ({ scope: scope, projectFragment: projectFragment })=>{
    const project = (0, $8Uumt.useFragment)((0, $1qITH.default), projectFragment);
    const attributes = (0, $5uXOq.useMemo)(()=>({
            scope: scope
        }), [
        scope
    ]);
    if (project?.id && project?.teamsConnected === undefined && (0, $6s1PB.expVal)('team-bi-directional-container-connection', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6eec8805144787da$var$M2TeamButtonComponent, {
        projectId: project.id,
        attributes: attributes
    });
    if (project?.teamsConnected?.totalCount == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jira-horizontal-nav-header-team-button",
        packageName: "jira-horizontal-nav",
        fallback: "unmount",
        teamName: "Jira Cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "horizontal-nav-header",
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1jau2.TeamButtonComponent), {
        numberOfTeams: project.teamsConnected.totalCount,
        containerId: project.id,
        Wrapper: $6eec8805144787da$var$CustomWrapper
    })));
};
const $6eec8805144787da$var$M2TeamButtonComponent = ({ projectId: projectId, attributes: attributes })=>{
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    if (isAnonymous) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jira-horizontal-nav-header-team-button",
        packageName: "jira-horizontal-nav",
        fallback: "unmount",
        teamName: "Jira Cosmos"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "horizontal-nav-header",
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1jau2.TeamButtonComponent), {
        numberOfTeams: 1,
        containerId: projectId,
        orgId: orgId,
        Wrapper: $6eec8805144787da$var$CustomWrapper
    })));
};
const $6eec8805144787da$var$CustomWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_fsjd4zrn _nwukvy9e _2hwx12x7"
        ])
    }, children);
const $6eec8805144787da$var$wrapperStyle = null;

});
parcelRegister("1qITH", function(module, exports) {

$parcel$export(module.exports, "default", () => $55af27551e9270fb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b817b117a8785cafd7776154f5047087>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $55af27551e9270fb$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "NavigationTeamButton_project",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
                    "kind": "LinkedField",
                    "name": "teamsConnected",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$55af27551e9270fb$var$node.hash = "3b9f9c19a3b51f50bca5f46f2c43543d";
var $55af27551e9270fb$export$2e2bcd8739ae039 = $55af27551e9270fb$var$node;

});

parcelRegister("1jau2", function(module, exports) {

$parcel$export(module.exports, "TeamButtonComponent", () => $3217ee3707319cec$export$e396067aa8e1cdf9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bKCvK = parcelRequire("bKCvK");

var $6mahi = parcelRequire("6mahi");

var $epiY4 = parcelRequire("epiY4");

var $3FH71 = parcelRequire("3FH71");

var $kyozp = parcelRequire("kyozp");

var $cZpu3 = parcelRequire("cZpu3");

var $5huan = parcelRequire("5huan");

var $86JIW = parcelRequire("86JIW");

var $cmEwj = parcelRequire("cmEwj");

var $hxK7J = parcelRequire("hxK7J");

var $djDYO = parcelRequire("djDYO");

var $6ZsNX = parcelRequire("6ZsNX");

var $6sfvM = parcelRequire("6sfvM");
const $3217ee3707319cec$export$1ec70ef85047a4d5 = ({ numberOfTeams: numberOfTeams, containerId: containerId, Wrapper: Wrapper = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment })=>{
    const { fireEvent: fireEvent } = (0, $3FH71.usePeopleTeamAnalyticsEvents)();
    const triggerRef = (0, $5uXOq.useRef)(null);
    const { isTeamBiDirectionalEnabled: isExperimentEnabled } = (0, $hxK7J.useTeamBiDirectionalExp)();
    const handleButtonClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        const element = event.currentTarget;
        const isExpanded = isExperimentEnabled ? element.getAttribute('aria-expanded') === 'true' : true;
        if (isExpanded) {
            const result = analyticsEvent?.context.find((item)=>item.attributes && item.attributes.scope !== undefined);
            fireEvent('ui.teamButton.clicked', {
                teamsCount: numberOfTeams ?? 0,
                scope: result?.attributes?.scope ?? '',
                version: isExperimentEnabled ? 'm2' : 'm1'
            });
        }
    }, [
        fireEvent,
        numberOfTeams,
        isExperimentEnabled
    ]);
    const getTriggerProps = (0, $5uXOq.useCallback)((triggerProps)=>{
        if (!isExperimentEnabled) return triggerProps;
        const setRef = (node)=>{
            triggerRef.current = node;
            if (typeof triggerProps.ref === 'function') triggerProps.ref(node);
            else if (triggerProps.ref) triggerProps.ref.current = node;
        };
        return {
            ...triggerProps,
            ref: setRef
        };
    }, [
        isExperimentEnabled
    ]);
    const onFocusTrigger = (0, $5uXOq.useCallback)(()=>{
        setTimeout(()=>{
            if (triggerRef.current) triggerRef.current.focus();
        }, 0);
    }, [
        triggerRef
    ]);
    if (numberOfTeams === undefined) return null;
    if (numberOfTeams === 0 && !isExperimentEnabled) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bKCvK.FlagsProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6mahi.ModalContextProvider), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epiY4.PopupTrigger), {
                entryPoint: (0, $cmEwj.asyncTeamSelectorEntryPoint),
                entryPointProps: {
                    // Remove as part of M1 FG cleanup
                    ...isExperimentEnabled ? {} : {
                        containerId: containerId
                    },
                    onModalCloseComplete: onFocusTrigger
                },
                entryPointParams: {
                    containerId: containerId
                },
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6sfvM.TeamButtonTrigger), {
                            triggerProps: getTriggerProps(triggerProps),
                            numberOfTeams: numberOfTeams,
                            onClick: handleButtonClick
                        })
                    }),
                fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $djDYO.default), {}),
                placement: "bottom-start",
                strategy: "absolute",
                popupComponent: (0, $kyozp.default)
            })
        })
    });
};
const $3217ee3707319cec$export$e396067aa8e1cdf9 = (props)=>{
    const { containerId: containerId, orgId: orgId } = props;
    const containerType = (0, $6ZsNX.getContainerType)(containerId);
    const isExperimentEnabled = (0, $5huan.isTeamBiDirectionalEnabled)(containerType);
    if (isExperimentEnabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $86JIW.TeamSelectorProvider), {
        containerId: containerId,
        containerType: containerType,
        // cloudId is guaranteed to be a string as we will always receive a valid containerId
        cloudId: (0, $cZpu3.getSiteId)(containerId) || '',
        // orgId will always be available if isTeamBiDirectionalEnabled is true
        orgId: orgId || '',
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($3217ee3707319cec$export$1ec70ef85047a4d5, {
            ...props
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3217ee3707319cec$export$1ec70ef85047a4d5, {
        ...props
    });
};

});
parcelRegister("3FH71", function(module, exports) {

$parcel$export(module.exports, "usePeopleTeamAnalyticsEvents", () => $26f504506e3b41ef$export$48acf7e27d4331f);
$parcel$export(module.exports, "useTeamsExperienceTracker", () => $26f504506e3b41ef$export$5792e6ebc464482e);

var $5uXOq = parcelRequire("5uXOq");

var $jZ6HJ = parcelRequire("jZ6HJ");

var $1URky = parcelRequire("1URky");

var $bwDHF = parcelRequire("bwDHF");

var $jsDzq = parcelRequire("jsDzq");
const $26f504506e3b41ef$export$48acf7e27d4331f = ()=>{
    const [{ eventAttributes: injectedEventAttributes }, { setEventAttributes: setEventAttributes }] = (0, $jZ6HJ.usePeopleTeamsAnalyticsSubcontext)();
    const { fireEvent: fireEvent } = (0, $bwDHF.useAnalyticsEvents)();
    const fireEventWithSubcontextAttributesInjected = (0, $5uXOq.useCallback)((...params)=>{
        const [event, attributes] = params;
        const eventWithSubcontextAttributes = {
            ...attributes,
            ...injectedEventAttributes
        };
        // @ts-ignore allow injecting subcontext attributes
        fireEvent(event, eventWithSubcontextAttributes);
    }, [
        fireEvent,
        injectedEventAttributes
    ]);
    return {
        fireEvent: fireEventWithSubcontextAttributesInjected,
        setInjectedEventAttributes: setEventAttributes
    };
};
const $26f504506e3b41ef$export$b72f2eb2a11f7b8 = ()=>(0, $jsDzq.useAnalyticsEventsWithTags)();
const $26f504506e3b41ef$export$5792e6ebc464482e = ()=>{
    const { fireEvent: fireEvent } = $26f504506e3b41ef$export$48acf7e27d4331f();
    const fireExperienceEvent = (0, $5uXOq.useCallback)((action, subject, attributes)=>{
        // @ts-ignore TODO: we may need to declare the keys to a const in the types file so we can do a check here
        fireEvent(`operational.${subject.replace(/[\/-]/g, '_')}.${action}`, {
            ...attributes,
            source: 'clientMetrics'
        });
    }, [
        fireEvent
    ]);
    const experienceTracker = (0, $5uXOq.useMemo)(()=>(0, $1URky.createTeamsExperienceTracker)(fireExperienceEvent), [
        fireExperienceEvent
    ]);
    return experienceTracker;
};

});
parcelRegister("jZ6HJ", function(module, exports) {

$parcel$export(module.exports, "usePeopleTeamsAnalyticsSubcontext", () => $3a57dd04b5affe69$export$86448e866930ba8d);
$parcel$export(module.exports, "useInjectedEventAttribute", () => $3a57dd04b5affe69$export$831917a198e22e70);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $3a57dd04b5affe69$var$initialState = {
    eventAttributes: {}
};
const $3a57dd04b5affe69$var$actions = {
    setEventAttributes: (eventAttributes)=>({ setState: setState, getState: getState })=>{
            const existingEventAttributes = getState().eventAttributes;
            const newEventAttributes = {
                ...existingEventAttributes,
                ...eventAttributes
            };
            Object.keys(newEventAttributes).forEach((keyString)=>{
                const key = keyString;
                if (newEventAttributes[key] === undefined) delete newEventAttributes[key];
            });
            setState({
                eventAttributes: newEventAttributes
            });
        }
};
const $3a57dd04b5affe69$var$AnalyticsSubcontextStore = (0, $iXqE5.createStore)({
    initialState: $3a57dd04b5affe69$var$initialState,
    actions: $3a57dd04b5affe69$var$actions
});
const $3a57dd04b5affe69$export$86448e866930ba8d = (0, $3sQ5x.createHook)($3a57dd04b5affe69$var$AnalyticsSubcontextStore);
const $3a57dd04b5affe69$export$831917a198e22e70 = (key, value)=>{
    const { setEventAttributes: setEventAttributes } = $3a57dd04b5affe69$export$86448e866930ba8d()[1];
    (0, $5uXOq.useEffect)(()=>{
        setEventAttributes({
            [key]: value
        });
        return ()=>setEventAttributes({
                [key]: undefined
            });
    }, [
        key,
        value,
        setEventAttributes
    ]);
};

});

parcelRegister("1URky", function(module, exports) {

$parcel$export(module.exports, "createTeamsExperienceTracker", () => $f8ce0cd94612cc89$export$c0c885a04612b38d);

var $cBeZP = parcelRequire("cBeZP");

var $7i7RM = parcelRequire("7i7RM");

var $hnAwz = parcelRequire("hnAwz");
function $f8ce0cd94612cc89$export$c0c885a04612b38d(fireExperienceEvent, options) {
    const tracker = new (0, $7i7RM.TeamsExperienceTracker)({
        isNetworkOfflineError: (0, $hnAwz.isNetworkError)
    });
    tracker.subscribe((event)=>{
        if (event.action === 'taskStart' || event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail') {
            const performanceAttributes = (0, $hnAwz.computePerformanceAttributes)(event);
            const errorAttributes = (0, $hnAwz.computeErrorAttributes)(event);
            const finalErrorDetails = Object.assign(errorAttributes, performanceAttributes, event.attributes, {
                // Because standalone app is deployed to prod quickly,
                // we will use this attribute to query in Splunk sooner.
                isStandalone: !!options?.isStandalone,
                hasBrowseUsersPermission: !!options?.hasBrowseUsersPermission
            });
            fireExperienceEvent(event.action, event.name, finalErrorDetails);
            if (event.action === 'taskFail' && options?.logErrorMessage) options.logErrorMessage(`taskFail:${event.name}`, finalErrorDetails);
        }
    });
    (0, $cBeZP.bindAll)(window, [
        {
            type: 'unload',
            listener: ()=>tracker.abort({
                    reason: 'Abort due to Window unloading',
                    attributes: {
                        cause: 'WINDOW_UNLOAD'
                    }
                })
        },
        {
            type: 'pagehide',
            listener: ()=>{
                tracker.abort({
                    reason: 'Window unloading',
                    attributes: {
                        cause: 'PAGE_HIDE'
                    }
                });
            }
        }
    ]);
    return tracker;
}

});
parcelRegister("7i7RM", function(module, exports) {

$parcel$export(module.exports, "TeamsExperienceTracker", () => $df8b2ce13ecbfe34$export$9e9a48cf2c297bd1);

var $ha42n = parcelRequire("ha42n");

var $15mL0 = parcelRequire("15mL0");
class $df8b2ce13ecbfe34$export$9e9a48cf2c297bd1 extends (0, $ha42n.ExperienceTracker) {
    _errorNameInIgnoredList(error) {
        const name = error && error.constructor.name;
        return this._ignoredErrors.includes(name) ? name : undefined;
    }
    constructor(options){
        super(options), // error names here will also be sent in the attribute `cause`
        this._ignoredErrors = [
            'SentryIgnoreError'
        ];
    }
    stopOnError({ name: name, error: error }) {
        if ((0, $15mL0.isAuthError)(error)) {
            this.abort({
                name: name,
                reason: 'Abort due to user unauthenticated',
                attributes: {
                    cause: 'USER_UNAUTHENTICATED',
                    error: error
                },
                checkForTimeout: false
            });
            return;
        }
        if ((0, $15mL0.isErrorStatusCode)((0, $15mL0.StatusCode).GONE, error)) {
            this.abort({
                name: name,
                reason: 'Abort due to unavailable resource',
                attributes: {
                    cause: 'GONE',
                    error: error
                },
                checkForTimeout: false
            });
            return;
        }
        const ignoredErrorName = this._errorNameInIgnoredList(error);
        if (ignoredErrorName) {
            this.abort({
                name: name,
                reason: 'Abort due to an error in ignore list',
                attributes: {
                    cause: ignoredErrorName
                },
                checkForTimeout: false
            });
            return;
        }
        super.stopOnError({
            name: name,
            error: error
        });
    }
}

});
parcelRegister("15mL0", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $d52079d97606e8b0$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $d52079d97606e8b0$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $d52079d97606e8b0$export$9677d7c364ada66c);
var $d52079d97606e8b0$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $d52079d97606e8b0$export$cde1786a482f9a1c(error) {
    return $d52079d97606e8b0$export$9677d7c364ada66c(401, error) || $d52079d97606e8b0$export$9677d7c364ada66c(403, error);
}
function $d52079d97606e8b0$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}

});


parcelRegister("hnAwz", function(module, exports) {

$parcel$export(module.exports, "isNetworkError", () => $f0235a5352096b37$export$476aa014e2fd89d5);
$parcel$export(module.exports, "computeErrorAttributes", () => $f0235a5352096b37$export$5e7501d1cb9a5aa0);
$parcel$export(module.exports, "computePerformanceAttributes", () => $f0235a5352096b37$export$b978343735080139);

var $hhYjW = parcelRequire("hhYjW");
function $f0235a5352096b37$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}
function $f0235a5352096b37$export$5e7501d1cb9a5aa0(event) {
    const attributes = {};
    if ($f0235a5352096b37$var$isFailEvent(event)) attributes.failError = event.error;
    if ($f0235a5352096b37$var$isAbortEvent(event)) attributes.abortReason = event.reason;
    return attributes;
}
function $f0235a5352096b37$export$b978343735080139(event) {
    if ($f0235a5352096b37$var$isStopEvent(event)) {
        const duration = event.duration;
        const latencySlo = event.attributes && $f0235a5352096b37$var$hasLatencySLO(event.attributes) && event.attributes['latencySlo'];
        if (typeof duration !== 'number' || typeof latencySlo !== 'number') return {};
        return {
            sloSatisfied: duration <= latencySlo,
            taskDuration: duration,
            latencySlo: latencySlo
        };
    }
    return {};
}
function $f0235a5352096b37$var$isStopEvent(e) {
    return (0, $hhYjW.isStop)(e);
}
function $f0235a5352096b37$var$isFailEvent(e) {
    return e.action === 'taskFail';
}
function $f0235a5352096b37$var$isAbortEvent(e) {
    return e.action === 'taskAbort';
}
function $f0235a5352096b37$var$hasLatencySLO(attributes) {
    return Object(attributes).hasOwnProperty('latencySlo');
}

});
parcelRegister("hhYjW", function(module, exports) {

$parcel$export(module.exports, "isStop", () => $aa0bafdc1aa29e5b$export$16e3f1b03b231b35);
$parcel$export(module.exports, "hasName", () => $aa0bafdc1aa29e5b$export$57069f5b2ecc9128);
const $aa0bafdc1aa29e5b$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $aa0bafdc1aa29e5b$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);

});



parcelRegister("bwDHF", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $39c115f9536efeab$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::c3d283871d950ad96ce62ded8c21524b>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen people-teams-ui
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $44uzI = parcelRequire("44uzI");

var $2RmMy = parcelRequire("2RmMy");
const $39c115f9536efeab$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireEvent = (0, $5uXOq.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $2RmMy.default)(...params));
        event.fire((0, $44uzI.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("44uzI", function(module, exports) {

$parcel$export(module.exports, "EVENT_CHANNEL", () => $ed8690ca9a47d1ea$export$3f072f06b90c3985);

var $dWAZk = parcelRequire("dWAZk");
const $ed8690ca9a47d1ea$export$3f072f06b90c3985 = (0, $dWAZk.FabricChannel).peopleTeams;

});

parcelRegister("2RmMy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed85a00ce3587d53$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::f6bdf2649443a00944d1014ec7e17d50>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen people-teams-ui
 */ const $ed85a00ce3587d53$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $ed85a00ce3587d53$export$2e2bcd8739ae039 = $ed85a00ce3587d53$var$createEventPayload;

});


parcelRegister("jsDzq", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEventsWithTags", () => $44e55e13c7ee3294$export$e8e0cef07f76dd91);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $44uzI = parcelRequire("44uzI");

var $2RmMy = parcelRequire("2RmMy");
const $44e55e13c7ee3294$export$e8e0cef07f76dd91 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireEventWithTags = (0, $5uXOq.useCallback)((tags, ...params)=>{
        const event = createAnalyticsEvent((0, $2RmMy.default)(...params));
        if (event.payload) event.payload.tags = tags;
        event.fire((0, $44uzI.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEventWithTags: fireEventWithTags
    };
};

});


parcelRegister("kyozp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ed62fe4671fa43b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $8ed62fe4671fa43b$var$popupStyles = (0, $8CUq3.xcss)({
    zIndex: '1',
    backgroundColor: 'color.background.neutral.subtle'
});
const $8ed62fe4671fa43b$var$PopupComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ 'data-testid': testId, ...props }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        ...props,
        ref: ref,
        xcss: $8ed62fe4671fa43b$var$popupStyles,
        testId: testId
    }));
var $8ed62fe4671fa43b$export$2e2bcd8739ae039 = $8ed62fe4671fa43b$var$PopupComponent;

});

parcelRegister("cZpu3", function(module, exports) {

$parcel$export(module.exports, "getTeamId", () => $30871f66e9a0bdfd$export$e8eac31981efe1fb);
$parcel$export(module.exports, "getTeamProfileUrl", () => $30871f66e9a0bdfd$export$782629dc0d11ee5c);
$parcel$export(module.exports, "getSiteId", () => $30871f66e9a0bdfd$export$3ae2d1e732b25194);
$parcel$export(module.exports, "getTeamAri", () => $30871f66e9a0bdfd$export$4182db567773f894);

var $h29WZ = parcelRequire("h29WZ");
var $54rcm = parcelRequire("54rcm");
var $a80aC = parcelRequire("a80aC");
var $kV9ss = parcelRequire("kV9ss");

var $2bf04 = parcelRequire("2bf04");
const $30871f66e9a0bdfd$export$e8eac31981efe1fb = (teamAri)=>{
    let teamId;
    const isIdentityTeamsAri = (0, $a80aC.IdentityTeamAri).check(teamAri);
    if (isIdentityTeamsAri) {
        const identityTeamId = (0, $a80aC.IdentityTeamAri).parse(teamAri).teamId;
        if (identityTeamId !== 'unidentified') teamId = identityTeamId;
        else (0, $2bf04.logErrorMessage)('Team ID has value "unidentified" in getTeamId', {
            teamAri: teamAri
        });
    } else (0, $2bf04.logErrorMessage)('Cannot parse IdentityTeamARI in getTeamId', {
        teamAri: teamAri
    });
    return teamId;
};
const $30871f66e9a0bdfd$export$782629dc0d11ee5c = (containerAri, teamAri)=>{
    let teamProfileUrl;
    const productPath = (0, $54rcm.ConfluenceSpaceAri).check(containerAri) ? 'wiki' : (0, $kV9ss.JiraProjectAri).check(containerAri) ? 'jira' : undefined;
    let teamId;
    teamId = $30871f66e9a0bdfd$export$e8eac31981efe1fb(teamAri);
    if (productPath && teamId) teamProfileUrl = `${window.location.origin}/${productPath}/people/team/${teamId}`;
    else (0, $2bf04.logErrorMessage)('Cannot create teamProfileUrl in getTeamProfileUrl', {
        containerAri: containerAri,
        teamAri: teamAri
    });
    return teamProfileUrl;
};
const $30871f66e9a0bdfd$export$3ae2d1e732b25194 = (containerAri)=>{
    const siteId = (0, $h29WZ.AnyAri).check(containerAri) && (0, $h29WZ.AnyAri).parse(containerAri).cloudId;
    if (!siteId) {
        (0, $2bf04.logErrorMessage)('Cannot parse containerAri in getSiteId', {
            containerAri: containerAri
        });
        return;
    }
    return siteId;
};
const $30871f66e9a0bdfd$export$4182db567773f894 = (teamId)=>{
    try {
        return (0, $a80aC.IdentityTeamAri).create({
            teamId: teamId
        }).toString();
    } catch (error) {
        (0, $2bf04.logErrorMessage)('Cannot create IdentityTeamAri in getTeamAri', {
            teamId: teamId
        });
    }
};

});
parcelRegister("54rcm", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSpaceAri", () => $3b126c801e45d086$export$4e1bd9257e1b7213);

var $5OaBv = parcelRequire("5OaBv");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/confluence/space/manifest.ts
var $3b126c801e45d086$var$confluenceSpaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $5OaBv.ConfluenceSpaceAriResourceOwner),
    resourceType: (0, $5OaBv.ConfluenceSpaceAriResourceType),
    resourceIdSlug: "{spaceId}",
    resourceIdSegmentFormats: {
        spaceId: /[0-9]+/
    }
};
// src/confluence/space/index.ts
var $3b126c801e45d086$export$4e1bd9257e1b7213 = class _ConfluenceSpaceAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._spaceId = opts.resourceIdSegmentValues.spaceId;
    }
    get siteId() {
        return this._siteId;
    }
    get spaceId() {
        return this._spaceId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $3b126c801e45d086$var$confluenceSpaceAriStaticOpts.qualifier,
            platformQualifier: $3b126c801e45d086$var$confluenceSpaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $3b126c801e45d086$var$confluenceSpaceAriStaticOpts.resourceOwner,
            resourceType: $3b126c801e45d086$var$confluenceSpaceAriStaticOpts.resourceType,
            resourceId: `${opts.spaceId}`,
            resourceIdSegmentValues: {
                spaceId: opts.spaceId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $3b126c801e45d086$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $3b126c801e45d086$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            spaceId: this.spaceId
        };
    }
};

});
parcelRegister("5OaBv", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSpaceAriResourceOwner", () => $43a9d8fb9c1ae9fc$export$204c4c730af505ce);
$parcel$export(module.exports, "ConfluenceSpaceAriResourceType", () => $43a9d8fb9c1ae9fc$export$7c78a678ea7a8ac7);
// src/confluence/space/types.ts
var $43a9d8fb9c1ae9fc$export$204c4c730af505ce = "confluence", $43a9d8fb9c1ae9fc$export$7c78a678ea7a8ac7 = "space";

});


parcelRegister("a80aC", function(module, exports) {

$parcel$export(module.exports, "IdentityTeamAri", () => $75fac8918c8a8f55$export$33bbb2d79e520118);

var $b24Fz = parcelRequire("b24Fz");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/identity/team/manifest.ts
var $75fac8918c8a8f55$var$identityTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $b24Fz.IdentityTeamAriResourceOwner),
    resourceType: (0, $b24Fz.IdentityTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/identity/team/index.ts
var $75fac8918c8a8f55$export$33bbb2d79e520118 = class _IdentityTeamAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._teamId = opts.resourceIdSegmentValues.teamId;
    }
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $75fac8918c8a8f55$var$identityTeamAriStaticOpts.qualifier,
            platformQualifier: $75fac8918c8a8f55$var$identityTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $75fac8918c8a8f55$var$identityTeamAriStaticOpts.resourceOwner,
            resourceType: $75fac8918c8a8f55$var$identityTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $75fac8918c8a8f55$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $75fac8918c8a8f55$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
};

});
parcelRegister("b24Fz", function(module, exports) {

$parcel$export(module.exports, "IdentityTeamAriResourceOwner", () => $808380e2662a0eb8$export$49beddf48ffb3f35);
$parcel$export(module.exports, "IdentityTeamAriResourceType", () => $808380e2662a0eb8$export$b2079a2a841afe32);
// src/identity/team/types.ts
var $808380e2662a0eb8$export$49beddf48ffb3f35 = "identity", $808380e2662a0eb8$export$b2079a2a841afe32 = "team";

});


parcelRegister("2bf04", function(module, exports) {

$parcel$export(module.exports, "logException", () => $fe9042edcf886c67$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $fe9042edcf886c67$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $fe9042edcf886c67$export$386587bcf05ee8ea);

var $6laLp = parcelRequire("6laLp");
const $fe9042edcf886c67$var$packageContext = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $fe9042edcf886c67$export$f86b2a1a2ce291b3 = (0, $6laLp.logExceptionWithPackageContext)($fe9042edcf886c67$var$packageContext);
const $fe9042edcf886c67$export$ece28f5cfa04608 = (0, $6laLp.logErrorMessageWithPackageContext)($fe9042edcf886c67$var$packageContext);
const $fe9042edcf886c67$export$386587bcf05ee8ea = (0, $6laLp.logInfoMessageWithPackageContext)($fe9042edcf886c67$var$packageContext);
const $fe9042edcf886c67$export$9edc7d6f1c33ddc = (0, $6laLp.createErrorHandlerWithPackageContext)($fe9042edcf886c67$var$packageContext);

});
parcelRegister("6laLp", function(module, exports) {

$parcel$export(module.exports, "logException", () => $b8ae333ac130caf8$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $b8ae333ac130caf8$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $b8ae333ac130caf8$export$386587bcf05ee8ea);
$parcel$export(module.exports, "logExceptionWithPackageContext", () => $b8ae333ac130caf8$export$7208e9272a946c36);
$parcel$export(module.exports, "logErrorMessageWithPackageContext", () => $b8ae333ac130caf8$export$dbd2da61a76fb8d2);
$parcel$export(module.exports, "logInfoMessageWithPackageContext", () => $b8ae333ac130caf8$export$f242834c5699e597);
$parcel$export(module.exports, "createErrorHandlerWithPackageContext", () => $b8ae333ac130caf8$export$6b2a307bf7c6c1dc);
$parcel$export(module.exports, "addBreadcrumb", () => $b8ae333ac130caf8$export$efda9a273d7a036d);
// See Sentry accepted options in here https://docs.sentry.io/error-reporting/configuration/?platform=javascript

var $6jQUd = parcelRequire("6jQUd");
function $b8ae333ac130caf8$var$decorateScope(scope, context) {
    const { tags: tags, ...otherContext } = context;
    if (tags) scope.setTags(tags);
    if (Object.keys(otherContext).length) scope.setExtras(otherContext);
    return scope;
}
async function $b8ae333ac130caf8$export$f86b2a1a2ce291b3(ex, name, context = {}) {
    try {
        const sentryClient = await (0, $6jQUd.getSentryClient)();
        if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
        sentryClient.withScope((scope)=>{
            $b8ae333ac130caf8$var$decorateScope(scope, context);
            scope.setTag('name', name);
            scope.setTag('packageName', context.packageName ?? 'unknown');
            scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
            sentryClient.captureException(ex, scope);
        });
    } catch  {
    // silence sentry exceptions
    }
}
async function $b8ae333ac130caf8$var$logMessage(severity, message, context = {}) {
    const sentryClient = await (0, $6jQUd.getSentryClient)();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        $b8ae333ac130caf8$var$decorateScope(scope, context);
        // The Severity enum is being replaced by SeverityLevel type in v7 anyway
        scope.setLevel(severity);
        scope.setTag('packageName', context.packageName ?? 'unknown');
        scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
        sentryClient.captureMessage(message, scope);
    });
}
function $b8ae333ac130caf8$export$ece28f5cfa04608(message, context = {}) {
    $b8ae333ac130caf8$var$logMessage('error', message, context).catch(()=>{});
}
function $b8ae333ac130caf8$export$386587bcf05ee8ea(message, context = {}) {
    $b8ae333ac130caf8$var$logMessage('info', message, context).catch(()=>{});
}
const $b8ae333ac130caf8$export$9edc7d6f1c33ddc = (details)=>{
    return (error, message, tags = {})=>{
        $b8ae333ac130caf8$export$f86b2a1a2ce291b3(error, message, {
            tags: {
                ...details,
                ...tags
            }
        });
    };
};
const $b8ae333ac130caf8$export$7208e9272a946c36 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $b8ae333ac130caf8$export$f86b2a1a2ce291b3(args[0], args[1], {
            ...args[2],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $b8ae333ac130caf8$export$dbd2da61a76fb8d2 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $b8ae333ac130caf8$export$ece28f5cfa04608(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $b8ae333ac130caf8$export$f242834c5699e597 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $b8ae333ac130caf8$export$386587bcf05ee8ea(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $b8ae333ac130caf8$export$6b2a307bf7c6c1dc = (packageContext)=>(...args)=>$b8ae333ac130caf8$export$9edc7d6f1c33ddc({
            ...args[0],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
async function $b8ae333ac130caf8$export$efda9a273d7a036d(crumb) {
    const sentryClient = await (0, $6jQUd.getSentryClient)();
    sentryClient.withScope((scope)=>{
        scope.addBreadcrumb(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
    });
}

});
parcelRegister("6jQUd", function(module, exports) {

$parcel$export(module.exports, "sentryClient", () => $1a080a899118f506$export$ac71c212168fcd2b);
$parcel$export(module.exports, "setSentryClient", () => $1a080a899118f506$export$7d446c6f4e54de82);
$parcel$export(module.exports, "getSentryClient", () => $1a080a899118f506$export$f553e8b08ef59d31);
$parcel$export(module.exports, "setupSentryClient", () => $1a080a899118f506$export$d8bd0edf6c978788);

var $cESX7 = parcelRequire("cESX7");

var $f90f5 = parcelRequire("f90f5");
let $1a080a899118f506$export$ac71c212168fcd2b;
const $1a080a899118f506$export$7d446c6f4e54de82 = (client)=>{
    $1a080a899118f506$export$ac71c212168fcd2b = client;
};
const $1a080a899118f506$export$f553e8b08ef59d31 = async ()=>{
    if (!$1a080a899118f506$export$ac71c212168fcd2b) await $1a080a899118f506$export$d8bd0edf6c978788({});
    return $1a080a899118f506$export$ac71c212168fcd2b;
};
async function $1a080a899118f506$export$d8bd0edf6c978788({ appName: appName, env: env }) {
    const sentryClient = await $1a080a899118f506$var$requireSentryLib();
    if (!sentryClient) return;
    // initialiseSentry sets the sentry client
    (0, $f90f5.initialiseSentry)(sentryClient, {
        initialScope: {
            tags: {
                renderMode: appName || 'unknown',
                productBuild: // @ts-ignore Jira  - window.BUILD_KEY, confluence - window.__buildInfo
                window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION || 'unknown',
                product: $1a080a899118f506$var$getProduct()
            }
        },
        env: env,
        noGlobals: true,
        dsn: (0, $cESX7.SENTRY_DSN),
        attachStacktrace: true
    });
}

async function $1a080a899118f506$var$requireSentryLib() {
    // saving ~40K
    try {
        return (parcelRequire("61QSy"));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Ignoring rejected promise when loading sentry resource.', error);
    }
}
function $1a080a899118f506$var$getProduct() {
    const path = window.location.pathname;
    if (path.includes('/jira/people')) return 'jira';
    else if (path.includes('/wiki/people')) return 'confluence';
    return 'unknown';
}

});
parcelRegister("cESX7", function(module, exports) {

$parcel$export(module.exports, "SENTRY_DSN", () => $7172257c54583cfa$export$6faa4a850bc4d0ce);

var $c04PQ = parcelRequire("c04PQ");
const $7172257c54583cfa$export$9cf97fd92bea5d81 = '1dc056d49dfe4df8961dc1b810e4620d';
const $7172257c54583cfa$export$68c35ed3898e185a = '5988845';
const $7172257c54583cfa$export$b03be5cdb5af5197 = '067abcc494be9a87b3cdf9416f2b97d5';
const $7172257c54583cfa$export$97db6664a1e55fa6 = '47';
const $7172257c54583cfa$var$SENTRY_COMMERCIAL_DSN = `https://${$7172257c54583cfa$export$9cf97fd92bea5d81}@o55978.ingest.sentry.io/${$7172257c54583cfa$export$68c35ed3898e185a}`;
const $7172257c54583cfa$var$SENTRY_FEDRAMP_DSN = `https://${$7172257c54583cfa$export$b03be5cdb5af5197}@sentry.atlassian-us-gov-mod.com/${$7172257c54583cfa$export$97db6664a1e55fa6}`;
const $7172257c54583cfa$export$6faa4a850bc4d0ce = (0, $c04PQ.isFedRamp)() ? $7172257c54583cfa$var$SENTRY_FEDRAMP_DSN : $7172257c54583cfa$var$SENTRY_COMMERCIAL_DSN;

});

parcelRegister("f90f5", function(module, exports) {

$parcel$export(module.exports, "initialiseSentry", () => $bb873a2430dbd9e0$export$357606956af25316);

var $lqMqM = parcelRequire("lqMqM");

var $6jQUd = parcelRequire("6jQUd");
const $bb873a2430dbd9e0$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
async function $bb873a2430dbd9e0$export$357606956af25316(client, options) {
    if (0, $6jQUd.sentryClient) return;
    if (!client) return;
    (0, $6jQUd.setSentryClient)(client);
    const sentryConfig = (0, $lqMqM.getSentryConfig)(options);
    (0, $6jQUd.sentryClient).init({
        ...sentryConfig,
        integrations: function(integrations) {
            return integrations.filter(function(integration) {
                return $bb873a2430dbd9e0$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        }
    });
}

});
parcelRegister("lqMqM", function(module, exports) {

$parcel$export(module.exports, "getSentryConfig", () => $0ea77fabdacad2ed$export$5580e6304e95c792);

var $cESX7 = parcelRequire("cESX7");
const $0ea77fabdacad2ed$var$DEFAULT_SENTRY_CONFIG = {
    whitelistUrls: [
        /atl-paas.net/,
        // test local host
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/,
        // Network related errors
        'The operation was aborted',
        'Software caused connection abort',
        'GraphQL error: Failed to fetch',
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
        'AbortError: The user aborted a request.',
        /^network error/i,
        /^network failure/i,
        /^NetworkError/i,
        /^Unexpected token ..*/
    ],
    ignoreUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i
    ],
    dsn: (0, $cESX7.SENTRY_DSN),
    attachStacktrace: true
};
function $0ea77fabdacad2ed$export$5580e6304e95c792(options) {
    const { env: env, version: version, noGlobals: _, ...otherOptions } = options;
    return {
        ...otherOptions,
        ...$0ea77fabdacad2ed$var$DEFAULT_SENTRY_CONFIG,
        // Standalone __VERSION__ is set from `bin/set-release-version.sh`
        // when building to deploy to production
        release: `${"platform-pkg"}@${"0.0.0-use.local"}` || // @ts-ignore Jira  - window.BUILD_KEY
        window.BUILD_KEY || // @ts-ignore Confluence - window.__buildInfo
        window.__buildInfo?.FRONTEND_VERSION || '---',
        environment: env || 'prod'
    };
}

});


parcelRegister("61QSy", function(module, exports) {

let $463bdab5e8d2e224$var$load = (parcelRequire("28QjX"))(4);
module.exports = $463bdab5e8d2e224$var$load("cc1Au").then(()=>parcelRequire('godCI'));

});





parcelRegister("5huan", function(module, exports) {

$parcel$export(module.exports, "isTeamBiDirectionalEnabled", () => $b5bc9fc5e000945d$export$444827debf3aeb22);

var $iEN9D = parcelRequire("iEN9D");
const $b5bc9fc5e000945d$export$444827debf3aeb22 = (containerType, fireExperimentExposure = false)=>{
    if ((0, $iEN9D.default).initializeCompleted()) return containerType === 'Jira' && (0, $iEN9D.default).checkGate('team-bi-directional-container-connection-gate') && (0, $iEN9D.default).getExperimentValue('team-bi-directional-container-connection', 'isEnabled', false, {
        fireExperimentExposure: fireExperimentExposure
    }) || containerType === 'Confluence' && (0, $iEN9D.default).getExperimentValue('edit-team-connection-from-confluence', 'isEnabled', false, {
        fireExperimentExposure: fireExperimentExposure
    });
    return false;
};

});

parcelRegister("86JIW", function(module, exports) {

$parcel$export(module.exports, "TeamSelectorProvider", () => $0f0df13761abfa42$export$71d1921e4d5a0198);
$parcel$export(module.exports, "useTeamSelectorContext", () => $0f0df13761abfa42$export$1e7dbad964b23e80);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $0f0df13761abfa42$var$TeamSelectorContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    cloudId: '',
    orgId: '',
    containerId: ''
});
function $0f0df13761abfa42$export$71d1921e4d5a0198({ children: children, cloudId: cloudId, orgId: orgId, containerId: containerId, containerType: containerType }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($0f0df13761abfa42$var$TeamSelectorContext.Provider, {
        value: {
            cloudId: cloudId,
            orgId: orgId,
            containerId: containerId,
            containerType: containerType
        },
        children: children
    });
}
const $0f0df13761abfa42$export$1e7dbad964b23e80 = ()=>(0, $5uXOq.useContext)($0f0df13761abfa42$var$TeamSelectorContext);

});

parcelRegister("cmEwj", function(module, exports) {

$parcel$export(module.exports, "asyncTeamSelectorEntryPoint", () => $78f3a540eec60583$export$735620207607ea13);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $389Od = parcelRequire("389Od");
const $78f3a540eec60583$var$fetchPolicy = 'network-only';

const $78f3a540eec60583$export$735620207607ea13 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("62cLU")).then(({ AsyncTeamSelectorWithQuery: AsyncTeamSelectorWithQuery })=>AsyncTeamSelectorWithQuery), {
        moduleId: "be449799",
        moduleName: "AsyncTeamSelector",
        priority: "interaction",
        moduleId: 'team-selector-entrypoint'
    }),
    getPreloadProps: ({ containerId: containerId })=>({
            queries: {
                getTeamsForContainerQuery: {
                    parameters: $389Od.default,
                    variables: {
                        containerId: containerId
                    },
                    options: {
                        fetchPolicy: $78f3a540eec60583$var$fetchPolicy
                    }
                }
            },
            extraProps: {
                containerId: containerId
            }
        })
});

});
parcelRegister("389Od", function(module, exports) {

$parcel$export(module.exports, "default", () => $bddad1219e6c0636$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0abfe75f87727625472ca1040fa857bd>>
 * @relayHash a5822def1b8d2a45a02bc5ec3978395f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9fe29aba3388dd2cef2edce3e631712f20a2200a38874c6924ce95d61e1464e1
const $bddad1219e6c0636$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "containerId"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "consistentRead",
            "value": true
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "containerId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AsyncTeamSelectorQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
                            "kind": "LinkedField",
                            "name": "teamConnectedToContainerInverse",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "TeamCard_team"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "TeamItem_team"
                                                        }
                                                    ],
                                                    "type": "TeamV2"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "AsyncManageTeams"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AsyncTeamSelectorQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
                            "kind": "LinkedField",
                            "name": "teamConnectedToContainerInverse",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "displayName"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "smallAvatarImageUrl"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "smallHeaderImageUrl"
                                                        },
                                                        {
                                                            "concreteType": "TeamMemberConnectionV2",
                                                            "kind": "LinkedField",
                                                            "name": "members",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TeamMemberV2",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "member",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v2 /*: any*/ ,
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "name"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "picture"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "hasNextPage"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isVerified"
                                                        }
                                                    ],
                                                    "type": "TeamV2"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9fe29aba3388dd2cef2edce3e631712f20a2200a38874c6924ce95d61e1464e1",
            "metadata": {},
            "name": "AsyncTeamSelectorQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bddad1219e6c0636$var$node.hash = "10fc2cbf2c01fe8383ceb0cfa1df2b97";
var $bddad1219e6c0636$export$2e2bcd8739ae039 = $bddad1219e6c0636$var$node;

});

parcelRegister("62cLU", function(module, exports) {

let $464cd62816449824$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $464cd62816449824$var$load("76n7a"),
    $464cd62816449824$var$load("l253H"),
    $464cd62816449824$var$load("ffQaD"),
    $464cd62816449824$var$load("kvRbA"),
    $464cd62816449824$var$load("cLMGV")
]).then(()=>parcelRequire('25Pra'));

});


parcelRegister("hxK7J", function(module, exports) {

$parcel$export(module.exports, "useTeamBiDirectionalExp", () => $eeefc386844b3f59$export$bfdf61bc95e5d014);

var $5huan = parcelRequire("5huan");

var $86JIW = parcelRequire("86JIW");
const $eeefc386844b3f59$export$bfdf61bc95e5d014 = ()=>{
    const { containerType: containerType } = (0, $86JIW.useTeamSelectorContext)();
    const isTeamBiDirectionalEnabled = (0, $5huan.isTeamBiDirectionalEnabled)(containerType);
    return {
        isTeamBiDirectionalEnabled: isTeamBiDirectionalEnabled
    };
};

});

parcelRegister("djDYO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a040f1851383e10a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $hxK7J = parcelRequire("hxK7J");

var $FhEqZ = parcelRequire("FhEqZ");
const $a040f1851383e10a$var$loadingContainerStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.overlay',
    width: '320px',
    display: 'block',
    alignItems: 'center',
    justifyContent: 'center'
});
const $a040f1851383e10a$var$styles = {
    headerSkeleton: "_ca0qv47k _n3tdu2gc _19bvpxbi _u5f3pxbi",
    badgeSkeleton: "_2rkoiti9 _4t3i7vkz _1bsb1tcg",
    titleSkeleton: "_2rko1q77 _4t3i7vkz _1bsb1lit"
};
const $a040f1851383e10a$var$TeamSelectorSkeleton = ()=>{
    const { isTeamBiDirectionalEnabled: isTeamBiDirectionalEnabled } = (0, $hxK7J.useTeamBiDirectionalExp)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dC5iT.default), {
        testId: "testId-team-selector-skeleton",
        xcss: $a040f1851383e10a$var$loadingContainerStyles,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $f5TWP.default), {
                xcss: $a040f1851383e10a$var$styles.headerSkeleton,
                spread: "space-between",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        xcss: $a040f1851383e10a$var$styles.titleSkeleton,
                        backgroundColor: "color.background.neutral"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        xcss: $a040f1851383e10a$var$styles.badgeSkeleton,
                        backgroundColor: "color.background.neutral"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UCCQ.default), {
                isList: true,
                children: [
                    ...Array(3)
                ].map((_, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $FhEqZ.ItemSkeleton), {}, index))
            }),
            isTeamBiDirectionalEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9UCCQ.default), {
                hasSeparator: true,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $FhEqZ.ItemSkeleton), {
                    showControl: false
                })
            })
        ]
    });
};
var $a040f1851383e10a$export$2e2bcd8739ae039 = $a040f1851383e10a$var$TeamSelectorSkeleton;

});
parcelRegister("FhEqZ", function(module, exports) {

$parcel$export(module.exports, "ItemSkeleton", () => $504a26932af2affb$export$84345645841732c3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
const $504a26932af2affb$var$styles = {
    containerWrapperSkeleton: "_4cvr1h6o _1p57utpp _syaz1fxt _ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi",
    containerIconSkeleton: "_2rkoiti9 _4t3i1tcg _1bsb1tcg _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    labelSkeleton: "_2rko1q77 _1rjc1b66 _4t3irdoj _1bsb1osq",
    controlSkeleton: "_2rkogqwt _4t3i1crf _1bsb1crf"
};
const $504a26932af2affb$export$84345645841732c3 = ({ showControl: showControl = true })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
        space: "space.100",
        xcss: $504a26932af2affb$var$styles.containerWrapperSkeleton,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $504a26932af2affb$var$styles.containerIconSkeleton,
                backgroundColor: "color.background.neutral"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $504a26932af2affb$var$styles.labelSkeleton,
                backgroundColor: "color.background.neutral"
            }),
            showControl && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $504a26932af2affb$var$styles.controlSkeleton,
                backgroundColor: "color.background.neutral"
            })
        ]
    });
};

});


parcelRegister("6ZsNX", function(module, exports) {

$parcel$export(module.exports, "getContainerType", () => $8e1c841356089e70$export$acc6f3e19803b3dc);

var $54rcm = parcelRequire("54rcm");
var $kV9ss = parcelRequire("kV9ss");
var $gvMOt = parcelRequire("gvMOt");
const $8e1c841356089e70$export$acc6f3e19803b3dc = (containerAri)=>{
    const isConfluenceSpace = (0, $54rcm.ConfluenceSpaceAri).check(containerAri);
    const isJiraProject = (0, $kV9ss.JiraProjectAri).check(containerAri);
    const isLoomSpace = (0, $gvMOt.LoomSpaceAri).check(containerAri);
    if (isConfluenceSpace) return 'Confluence';
    if (isJiraProject) return 'Jira';
    if (isLoomSpace) return 'Loom';
};

});
parcelRegister("gvMOt", function(module, exports) {

$parcel$export(module.exports, "LoomSpaceAri", () => $c05567dfb19ac430$export$d1493cc5b72a4537);

var $hKbLn = parcelRequire("hKbLn");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/loom/space/manifest.ts
var $c05567dfb19ac430$var$loomSpaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $hKbLn.LoomSpaceAriResourceOwner),
    resourceType: (0, $hKbLn.LoomSpaceAriResourceType),
    resourceIdSlug: "activation/{activationId}/{spaceId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        spaceId: /[0-9]+/
    }
};
// src/loom/space/index.ts
var $c05567dfb19ac430$export$d1493cc5b72a4537 = class _LoomSpaceAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._spaceId = opts.resourceIdSegmentValues.spaceId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get spaceId() {
        return this._spaceId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c05567dfb19ac430$var$loomSpaceAriStaticOpts.qualifier,
            platformQualifier: $c05567dfb19ac430$var$loomSpaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $c05567dfb19ac430$var$loomSpaceAriStaticOpts.resourceOwner,
            resourceType: $c05567dfb19ac430$var$loomSpaceAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.spaceId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                spaceId: opts.spaceId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $c05567dfb19ac430$var$loomSpaceAriStaticOpts);
        return new _LoomSpaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $c05567dfb19ac430$var$loomSpaceAriStaticOpts);
        return new _LoomSpaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            spaceId: this.spaceId
        };
    }
};

});
parcelRegister("hKbLn", function(module, exports) {

$parcel$export(module.exports, "LoomSpaceAriResourceOwner", () => $ceafdb793704d3c0$export$4d15ef33e3a923ce);
$parcel$export(module.exports, "LoomSpaceAriResourceType", () => $ceafdb793704d3c0$export$ccb8092d14ea132d);
// src/loom/space/types.ts
var $ceafdb793704d3c0$export$4d15ef33e3a923ce = "loom", $ceafdb793704d3c0$export$ccb8092d14ea132d = "space";

});



parcelRegister("6sfvM", function(module, exports) {

$parcel$export(module.exports, "TeamButtonTrigger", () => $a0c71eda19920b55$export$3fe916959ce1a733);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $dZbEw = parcelRequire("dZbEw");

var $c781K = parcelRequire("c781K");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $3FH71 = parcelRequire("3FH71");

var $hxK7J = parcelRequire("hxK7J");

var $6vpC9 = parcelRequire("6vpC9");
const $a0c71eda19920b55$var$engagementId = 'team-button-onboarding';
const $a0c71eda19920b55$var$buttonStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'border.radius.100',
    display: 'flex',
    alignItems: 'center',
    height: '32px',
    width: '32px',
    justifyContent: 'center',
    color: 'color.text.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $a0c71eda19920b55$var$buttonStylesWithNumber = (0, $8CUq3.xcss)({
    width: '56px'
});
const $a0c71eda19920b55$export$3fe916959ce1a733 = ({ triggerProps: triggerProps, numberOfTeams: numberOfTeams, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { fireEvent: fireEvent } = (0, $3FH71.usePeopleTeamAnalyticsEvents)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { isTeamBiDirectionalEnabled: isTeamBiDirectionalEnabled } = (0, $hxK7J.useTeamBiDirectionalExp)();
    (0, $5uXOq.useEffect)(()=>{
        const result = createAnalyticsEvent({})?.context.find((item)=>item.attributes && item.attributes.scope !== undefined);
        fireEvent('ui.teamButton.viewed', {
            teamsCount: numberOfTeams,
            scope: result?.attributes?.scope ?? '',
            version: isTeamBiDirectionalEnabled ? 'm2' : 'm1'
        });
    }, [
        createAnalyticsEvent,
        fireEvent,
        isTeamBiDirectionalEnabled,
        numberOfTeams
    ]);
    const content = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5ILhZ.default), {
        ...triggerProps,
        onClick: onClick,
        xcss: [
            $a0c71eda19920b55$var$buttonStyles,
            numberOfTeams !== 1 && $a0c71eda19920b55$var$buttonStylesWithNumber
        ],
        testId: "team-button-trigger",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c781K))), {
                color: "currentColor",
                label: formatMessage((0, $6vpC9.default).iconLabel)
            }),
            numberOfTeams > 1 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                as: "span",
                paddingInlineStart: "space.100",
                children: numberOfTeams
            }),
            numberOfTeams === 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                as: "span",
                paddingInlineStart: "space.050",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                    color: "currentColor",
                    label: formatMessage((0, $6vpC9.default).addTeamIconLabel)
                })
            })
        ]
    });
    if (!isTeamBiDirectionalEnabled) return content;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $imZsD.default), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Fk4Z.default), {
                name: $a0c71eda19920b55$var$engagementId,
                children: content
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jZ4fr.EngagementSpotlight), {
                name: $a0c71eda19920b55$var$engagementId
            })
        ]
    });
};

});
parcelRegister("6vpC9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e8b26601dbf0518$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2e8b26601dbf0518$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    iconLabel: {
        id: 'team-button-trigger.icon.label',
        defaultMessage: 'Team button',
        description: 'Label for the team button icon'
    },
    addTeamIconLabel: {
        id: 'team-button-trigger.add-team-icon.label',
        defaultMessage: 'Add team',
        description: 'Label for the add team icon'
    }
});

});





parcelRegister("hzZnF", function(module, exports) {

$parcel$export(module.exports, "ProjectHeader", () => $bc92ae250591be70$export$69277e177204bdfd);

var $d9qlz = parcelRequire("d9qlz");

var $hnzkw = parcelRequire("hnzkw");

var $gKnzp = parcelRequire("gKnzp");

var $7FRWc = parcelRequire("7FRWc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $g7crU = parcelRequire("g7crU");


var $9IFFl = parcelRequire("9IFFl");

var $ccuaM = parcelRequire("ccuaM");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $44kzF = parcelRequire("44kzF");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $eC0BO = parcelRequire("eC0BO");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $krB5y = parcelRequire("krB5y");

var $2IzXv = parcelRequire("2IzXv");

var $hjXMc = parcelRequire("hjXMc");

var $2qjHu = parcelRequire("2qjHu");

var $4DmRP = parcelRequire("4DmRP");
const $bc92ae250591be70$export$69277e177204bdfd = (props)=>{
    const { queryFragment: queryFragment, projectFragment: projectFragment } = props;
    const data = (0, $8Uumt.useFragment)((0, $7FRWc.default), queryFragment);
    const project = (0, $8Uumt.useFragment)((0, $gKnzp.default), projectFragment);
    const analyticsData = (0, $5uXOq.useMemo)(()=>({
            navigationContainer: (0, $68cb678dc917978e$export$b83d0ee9325a2d0a)
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bc92ae250591be70$var$ProjectHeaderInner, {
        ...props,
        queryFragment: data,
        projectFragment: project
    }));
};
const $bc92ae250591be70$var$ProjectHeaderInner = ({ queryFragment: queryFragment, projectFragment: projectFragment })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isFullscreen] = (0, $g7crU.useIsFullscreen)();
    const { updateProjectName: updateProjectName, validateProjectName: validateProjectName } = (0, $2IzXv.useRenameProject)();
    const { hasSoftwareTheming: hasSoftwareTheming } = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false
    };
    const data = (0, $8Uumt.useFragment)((0, $hnzkw.default), queryFragment);
    const project = (0, $8Uumt.useFragment)((0, $d9qlz.default), projectFragment);
    const isBusinessProject = project.projectType === 'BUSINESS';
    const isSoftwareProject = project.projectType === 'SOFTWARE';
    const withInlineEdit = isBusinessProject;
    const isCorePremiumUserSeat = data.jira?.jwmLicensing?.currentUserSeatEdition === 'PREMIUM';
    const canEditProjectConfig = project?.canEditProjectConfig?.canPerform ?? false;
    const hasChangeTheme = canEditProjectConfig && (hasSoftwareTheming || isBusinessProject);
    const icon = (0, $5uXOq.useMemo)(()=>{
        const avatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $bc92ae250591be70$var$iconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4DmRP.default), {
            projectRef: project
        }));
        if (withInlineEdit) return avatar;
        if (!project?.avatar?.large) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9IFFl.ProjectIcon), {
            "data-testid": "horizontal-nav-header.ui.project-header.project-icon",
            "data-vc": "horizontal-nav-project-icon",
            src: project.avatar.large,
            alt: ""
        });
    }, [
        project,
        withInlineEdit
    ]);
    const handleProjectActionDropDownClick = (0, $5uXOq.useCallback)(()=>(0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'projectActionsDropdown', {}), [
        createAnalyticsEvent
    ]);
    const onUpdateProjectName = (0, $5uXOq.useCallback)((name)=>updateProjectName(Number(project?.projectId), name), [
        project?.projectId,
        updateProjectName
    ]);
    let headerProps = {};
    if (withInlineEdit && project?.projectId) {
        const inlineEditProps = {
            withInlineEdit: true,
            onConfirm: onUpdateProjectName,
            onValidate: validateProjectName,
            id: Number(project.projectId)
        };
        headerProps = canEditProjectConfig ? inlineEditProps : {};
    }
    const showTeamButton = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('team-connection-visibility-in-jira') && (0, $6s1PB.expVal)('team_and_container_m1', 'isEnabled', false);
    const extraComponentsClose = (0, $5uXOq.useMemo)(()=>{
        if (!project) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showTeamButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2qjHu.NavigationTeamButton), {
            projectFragment: project,
            scope: "project"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ccuaM.ProjectActionMenu), {
            "data-testid": "horizontal-nav-header.ui.project-header.project-action-menu",
            key: "ProjectActions",
            projectKey: project.key,
            isCorePremiumUserSeat: isCorePremiumUserSeat,
            additionalMenuItems: hasChangeTheme && !!project.projectId && !(0, $lmBAt.getIsSoftwareThemingM2Enabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44kzF.ThemePicker), {
                projectId: Number(project.projectId),
                withAdaptiveColorTheme: isSoftwareProject && (0, $lmBAt.getIsSoftwareThemingEnabled)(),
                /*
       * Render the theme picker popup inside a portal, this ensures it appears above other
       * elements, even when nested deep inside a container.
       * This SHOULD NOT be changed as it will cause the popup to be
       * rendered inside the parent container, which will cause it to appear behind other elements.
       */ shouldRenderToParent: false
            }),
            ...hasChangeTheme && !!project.projectId && (0, $lmBAt.getIsSoftwareThemingM2Enabled)() && {
                themePicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44kzF.ThemePicker), {
                    projectId: Number(project.projectId),
                    withAdaptiveColorTheme: isSoftwareProject && (0, $lmBAt.getIsSoftwareThemingEnabled)(),
                    /*
         * Render the theme picker popup inside a portal, this ensures it appears above other
         * elements, even when nested deep inside a container.
         * This SHOULD NOT be changed as it will cause the popup to be
         * rendered inside the parent container, which will cause it to appear behind other elements.
         */ shouldRenderToParent: false
                })
            },
            withThemedTrigger: true,
            onClick: handleProjectActionDropDownClick,
            shouldRenderToParent: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $4R6GH.fg)('bugfix_stacking_context_of_navigation') && (0, $4R6GH.fg)('blu-7153_shouldrendertoparent_with_prereq')
        }));
    }, [
        project,
        showTeamButton,
        isCorePremiumUserSeat,
        hasChangeTheme,
        isSoftwareProject,
        handleProjectActionDropDownClick
    ]);
    if (!project) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eC0BO.default), {
        title: project.name,
        ...headerProps,
        icon: icon,
        isLoading: project == null,
        extraComponentsClose: extraComponentsClose,
        testId: "horizontal-nav-header.ui.project-header.header",
        extraComponentsFar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krB5y.ExtraComponentsFar), {
            projectFragment: project
        }),
        extraComponentsAbove: !isFullscreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjXMc.HorizontalNavProjectBreadcrumbs), {
            projectFragment: project
        })
    });
};
const $bc92ae250591be70$var$iconStyles = (0, $8CUq3.xcss)({
    width: '20px',
    height: '20px',
    boxSizing: 'border-box'
});

});
parcelRegister("d9qlz", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b7ad977298e8b4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1f97863cc435b31a11fe6745855512d4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $31b7ad977298e8b4$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "ProjectHeader_inner_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ProjectAvatar"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "NavigationTeamButton_project"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "projectType"
            },
            "action": "THROW",
            "path": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        },
        {
            "alias": "canEditProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "extraComponentsFar_horizontalNav"
        },
        {
            "kind": "FragmentSpread",
            "name": "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs"
        }
    ],
    "type": "JiraProject"
};
$31b7ad977298e8b4$var$node.hash = "470801e5fae5e2ecdc7e34a5f0a614a1";
var $31b7ad977298e8b4$export$2e2bcd8739ae039 = $31b7ad977298e8b4$var$node;

});

parcelRegister("hnzkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $afec814313b38ae0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7d7b22ff370d9e9a7a741a37c508a145>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $afec814313b38ae0$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "ProjectHeader_inner_query",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            }
                        ],
                        "concreteType": "JiraWorkManagementLicensing",
                        "kind": "LinkedField",
                        "name": "jwmLicensing",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "currentUserSeatEdition"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$afec814313b38ae0$var$node.hash = "6b10db5d77a3ec3bb1e3665b0de46b2f";
var $afec814313b38ae0$export$2e2bcd8739ae039 = $afec814313b38ae0$var$node;

});

parcelRegister("gKnzp", function(module, exports) {

$parcel$export(module.exports, "default", () => $42567f0c5be6bba1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<718f44a9e92e1d7dd77b78909d0471cb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $42567f0c5be6bba1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ProjectHeader_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ProjectHeader_inner_project"
        }
    ],
    "type": "JiraProject"
};
$42567f0c5be6bba1$var$node.hash = "78893912e046c1d6733f1058dcb592a0";
var $42567f0c5be6bba1$export$2e2bcd8739ae039 = $42567f0c5be6bba1$var$node;

});

parcelRegister("7FRWc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1082e95b8a54cc0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bc8a0e19e9b9d644207c1ba1389c2482>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f1082e95b8a54cc0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ProjectHeader_query",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ProjectHeader_inner_query"
        }
    ],
    "type": "Query"
};
$f1082e95b8a54cc0$var$node.hash = "d1740bc312d925b4121b692ded4c84ed";
var $f1082e95b8a54cc0$export$2e2bcd8739ae039 = $f1082e95b8a54cc0$var$node;

});

parcelRegister("ccuaM", function(module, exports) {

$parcel$export(module.exports, "ProjectActionMenu", () => $8b67ffb58d27733b$export$b71a0a4e7f29cfd6);

var $5uXOq = parcelRequire("5uXOq");

var $8U6zd = parcelRequire("8U6zd");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $22OQR = parcelRequire("22OQR");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $lmBAt = parcelRequire("lmBAt");

var $03DFc = parcelRequire("03DFc");

var $bMW22 = parcelRequire("bMW22");
const $8b67ffb58d27733b$var$CustomTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const triggerButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        ...props,
        ref: ref,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
            label: formatMessage((0, $bMW22.default).moreActions),
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "navigation-project-action-menu.ui.themed-button"
    });
    return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $bMW22.default).moreActions),
        hideTooltipOnClick: true
    }, triggerButton) : triggerButton;
});
const $8b67ffb58d27733b$export$b71a0a4e7f29cfd6 = ({ additionalMenuItems: additionalMenuItems, isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled = false, isCorePremiumUserSeat: isCorePremiumUserSeat = false, withThemedTrigger: withThemedTrigger = false, projectKey: projectKey, onClick: onClick, shouldRenderToParent: shouldRenderToParent, themePicker: themePicker, projectName: projectName })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $03DFc.EntryPointContent), {
        ...(0, $4R6GH.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
            projectName: projectName
        } : {},
        isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled,
        additionalMenuItems: additionalMenuItems,
        onClick: onClick,
        isCorePremiumUserSeat: isCorePremiumUserSeat,
        CustomTrigger: withThemedTrigger && (0, $3HwlS.getWillShowNav4)() ? $8b67ffb58d27733b$var$CustomTrigger : undefined,
        projectKey: projectKey,
        shouldRenderToParent: shouldRenderToParent,
        ...(0, $lmBAt.getIsSoftwareThemingM2Enabled)() && {
            themePicker: themePicker
        }
    });
};

});
parcelRegister("03DFc", function(module, exports) {

$parcel$export(module.exports, "EntryPointContent", () => $507768618964e449$export$912f81dce8d58e46);

var $5uXOq = parcelRequire("5uXOq");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $2oEQb = parcelRequire("2oEQb");

var $7ju32 = parcelRequire("7ju32");

var $eSIes = parcelRequire("eSIes");
const $507768618964e449$export$912f81dce8d58e46 = ({ CustomTrigger: CustomTrigger, onClick: onClick, additionalMenuItems: additionalMenuItems, isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled = false, isCorePremiumUserSeat: isCorePremiumUserSeat = false, projectKey: projectKey, shouldRenderToParent: shouldRenderToParent, themePicker: themePicker, projectName: projectName })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $2oEQb.projectActionMenuEntryPoint), (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]));
    const buttonTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const content = (0, $5uXOq.useCallback)((contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "project-actions-menu-popup-content",
            packageName: "jira-navigation-apps-project-action-menu",
            runtimeProps: (0, $4R6GH.fg)('jfp-magma-stability-check-nav4-batch-1') ? (0, $5uXOq.useMemo)(()=>({
                    isCorePremiumUserSeat: isCorePremiumUserSeat,
                    additionalMenuItems: additionalMenuItems,
                    isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled,
                    contentProps: contentProps,
                    themePicker: themePicker
                }), [
                contentProps
            ]) : {
                isCorePremiumUserSeat: isCorePremiumUserSeat,
                additionalMenuItems: additionalMenuItems,
                isProjectMenuReorderingEnabled: isProjectMenuReorderingEnabled,
                contentProps: contentProps,
                themePicker: themePicker
            },
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eSIes.Skeleton), null)
        }), [
        entryPointReferenceSubject,
        additionalMenuItems,
        isCorePremiumUserSeat,
        isProjectMenuReorderingEnabled,
        themePicker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7ju32.MenuContainer), {
        ...(0, $4R6GH.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
            projectName: projectName
        } : {},
        content: content,
        CustomTrigger: CustomTrigger,
        onClick: onClick,
        buttonTriggerRef: buttonTriggerRef,
        shouldRenderToParent: shouldRenderToParent
    });
};

});
parcelRegister("2oEQb", function(module, exports) {

$parcel$export(module.exports, "projectActionMenuEntryPoint", () => $a5951ff1cd0da4db$export$30ec6de22da54fa0);

var $lvLIW = parcelRequire("lvLIW");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");
const $a5951ff1cd0da4db$var$fetchPolicy = 'network-only';

const $a5951ff1cd0da4db$export$30ec6de22da54fa0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("feSzL")).then((module)=>module.AsyncMenuWithQuery), {
        moduleId: "eb74dcae",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>{
        const projectActionMenuQuery = {
            parameters: (0, $lvLIW.default),
            variables: {
                cloudId: cloudId,
                projectKey: projectKey
            },
            options: {
                fetchPolicy: $a5951ff1cd0da4db$var$fetchPolicy
            }
        };
        return {
            queries: {
                projectActionMenuQuery: projectActionMenuQuery
            }
        };
    }
});

});
parcelRegister("lvLIW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f29594fd996b113$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d360e49d5eb693192c7fbc1eac496f85>>
 * @relayHash a9a48f3ed05422d23cacd580dcce751d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e05d6d8357d9d7fabad007766bd445c51b79afe818cc226061c1c9209b8fd76e
const $8f29594fd996b113$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "e05d6d8357d9d7fabad007766bd445c51b79afe818cc226061c1c9209b8fd76e",
        "metadata": {},
        "name": "async_AsyncMenuContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $8f29594fd996b113$export$2e2bcd8739ae039 = $8f29594fd996b113$var$node;

});

parcelRegister("feSzL", function(module, exports) {

let $b1827f6d33f94957$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $b1827f6d33f94957$var$load("76n7a"),
    $b1827f6d33f94957$var$load("l253H"),
    $b1827f6d33f94957$var$load("6KG9e")
]).then(()=>parcelRequire('aSeFh'));

});


parcelRegister("7ju32", function(module, exports) {

$parcel$export(module.exports, "MenuContainer", () => $12b2a0349669ab51$export$b286f91cddfedb5a);

var $5uXOq = parcelRequire("5uXOq");

var $3HwlS = parcelRequire("3HwlS");

var $cDvOQ = parcelRequire("cDvOQ");

var $6jY6G = parcelRequire("6jY6G");

var $jgJNO = parcelRequire("jgJNO");

var $4R6GH = parcelRequire("4R6GH");

var $1aCfv = parcelRequire("1aCfv");
const $12b2a0349669ab51$export$b286f91cddfedb5a = ({ content: content, CustomTrigger: CustomTrigger, onClick: onClick, onClose: onCloseCustom, buttonTriggerRef: buttonTriggerRef, shouldRenderToParent: shouldRenderToParent = true, projectName: projectName })=>{
    const { isOpen: isOpen, onClose: onClose, onToggle: onToggle } = (0, $cDvOQ.useOpenable)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const handleClose = (0, $5uXOq.useCallback)((e)=>{
        try {
            onCloseCustom?.(e);
        } finally{
            onClose();
        }
    }, [
        onCloseCustom,
        onClose
    ]);
    const onClickHandler = (0, $5uXOq.useCallback)(()=>{
        onToggle();
        onClick?.();
    }, [
        onClick,
        onToggle
    ]);
    const trigger = (triggerProps)=>{
        const { ref: ref, ...restTriggerProps } = triggerProps;
        return CustomTrigger ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomTrigger, {
            isSelected: isOpen,
            onClick: onClickHandler,
            ref: (element)=>{
                buttonTriggerRef && buttonTriggerRef(element);
                if (typeof ref === 'function') ref(element);
            },
            ...restTriggerProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1aCfv.MenuTriggerButton), {
            ...(0, $4R6GH.fg)('jsm_aiiy_for_nav_item_sidebar') ? {
                name: projectName
            } : {},
            isSelected: isOpen,
            onClick: onClickHandler,
            ref: (element)=>{
                buttonTriggerRef && buttonTriggerRef(element);
                if (typeof ref === 'function') ref(element);
            },
            ...restTriggerProps
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        content: content,
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-start",
        messageId: "navigation-project-action-menu.ui.menu-container.popup",
        messageType: "transactional",
        trigger: trigger,
        shouldRenderToParent: // eslint-disable-next-line no-nested-ternary
        (0, $3HwlS.getWillShowNav4)() ? route.name.includes('legacy') ? false : shouldRenderToParent : true,
        strategy: (0, $3HwlS.getWillShowNav4)() ? 'absolute' : 'fixed'
    });
};

});
parcelRegister("cDvOQ", function(module, exports) {

$parcel$export(module.exports, "useOpenable", () => $89d72d59f9676a7b$export$e07f550759260fd7);

var $5uXOq = parcelRequire("5uXOq");
const $89d72d59f9676a7b$export$e07f550759260fd7 = (initialState = false)=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(initialState);
    const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const onOpen = (0, $5uXOq.useCallback)(()=>setIsOpen(true), [
        setIsOpen
    ]);
    const onToggle = (0, $5uXOq.useCallback)(()=>setIsOpen((value)=>!value), [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        onOpen: onOpen,
        onToggle: onToggle,
        setIsOpen: setIsOpen
    };
};

});

parcelRegister("1aCfv", function(module, exports) {

$parcel$export(module.exports, "MenuTriggerButton", () => $697832058741b131$export$a24e6f6ddd974e33);

var $5uXOq = parcelRequire("5uXOq");

var $8U6zd = parcelRequire("8U6zd");

var $42CjB = parcelRequire("42CjB");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $UPOcN = parcelRequire("UPOcN");
const $697832058741b131$export$a24e6f6ddd974e33 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, name: name, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...props,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                ...iconProps,
                color: "var(--ds-icon, #44546F)",
                size: "small"
            }),
        label: (0, $4R6GH.fg)('jsm_aiiy_for_nav_item_sidebar') ? formatMessage((0, $UPOcN.default).projectActionsMenuName, {
            name: name
        }) : formatMessage((0, $UPOcN.default).projectActionsMenu),
        onClick: onClick,
        ref: ref,
        spacing: "compact",
        appearance: "subtle",
        testId: "navigation-project-action-menu.ui.menu-container.themed-button",
        ...(0, $dCm1o.isVisualRefreshEnabled)() ? {
            isTooltipDisabled: false,
            tooltip: {
                content: formatMessage((0, $UPOcN.default).projectActionsMenu),
                hideTooltipOnClick: true
            }
        } : {}
    });
});

});
parcelRegister("UPOcN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5484f6b90ae9d06c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5484f6b90ae9d06c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectActionsMenu: {
        "id": "navigation-project-action-menu.menu-container.project-actions-menu",
        "defaultMessage": "More actions"
    },
    projectActionsMenuName: {
        "id": "navigation-project-action-menu.menu-container.project-actions-menu-name",
        "defaultMessage": "More actions for {name}"
    }
});

});



parcelRegister("eSIes", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $618f6270b8f60e9b$export$8f31e4c4a37b8e9c);

var $5uXOq = parcelRequire("5uXOq");

var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");
var $iwwXK = parcelRequire("iwwXK");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $4DrQd = parcelRequire("4DrQd");
const $618f6270b8f60e9b$export$8f31e4c4a37b8e9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $618f6270b8f60e9b$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
        minWidth: (0, $4DrQd.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        isList: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        isList: true,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $618f6270b8f60e9b$var$projectTileSkeleton
    }))));
const $618f6270b8f60e9b$var$wrapperStyles = (0, $8CUq3.xcss)({
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    inlineSize: `${(0, $4DrQd.MENU_GROUP_MIN_WIDTH)}px`
});
const $618f6270b8f60e9b$var$projectTileSkeleton = (0, $8CUq3.xcss)({
    backgroundColor: 'color.skeleton',
    height: "var(--ds-space-600, 48px)",
    flex: 1
});

});
parcelRegister("4DrQd", function(module, exports) {

$parcel$export(module.exports, "MENU_GROUP_MIN_WIDTH", () => $e2413e530566d4f6$export$47f3715a07cde7e8);
$parcel$export(module.exports, "CONFIGURABLE_MENU_IDS_AS_STRINGS", () => $e2413e530566d4f6$export$f5a7bd7eb586e4e8);
$parcel$export(module.exports, "GLOBAL_APP_MENU_IDS_AS_STRINGS", () => $e2413e530566d4f6$export$de634ec0f98ab74b);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP", () => $e2413e530566d4f6$export$6a976dc7193b8a18);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_AND_ICON_MAP", () => $e2413e530566d4f6$export$5034ad0032cd499d);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_STRING", () => $e2413e530566d4f6$export$b66ae8c18ec95bc6);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_STRING", () => $e2413e530566d4f6$export$da92a6698d96e3f2);
$parcel$export(module.exports, "LEFT_SIDEBAR_EXPANDED_MIN_WIDTH", () => $e2413e530566d4f6$export$9fcc53f3b36e0949);
$parcel$export(module.exports, "IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT", () => $e2413e530566d4f6$export$2eb8dda9e83d33ff);
$parcel$export(module.exports, "NAV4_OPT_OUT_FEEDBACK_GROUP_ID", () => $e2413e530566d4f6$export$9cf873ba2e9a3ce0);
$parcel$export(module.exports, "NAV4_GENERAL_FEEDBACK_GROUP_ID", () => $e2413e530566d4f6$export$a495ba70b16d4d90);
$parcel$export(module.exports, "NO_OF_BOARDS_TO_SHOW", () => $e2413e530566d4f6$export$89de709e88232646);

var $5Trwl = parcelRequire("5Trwl");

var $1ZDWg = parcelRequire("1ZDWg");

var $ls0mX = parcelRequire("ls0mX");

var $hyKRO = parcelRequire("hyKRO");

var $gsyzJ = parcelRequire("gsyzJ");

var $jX361 = parcelRequire("jX361");

var $9x5pH = parcelRequire("9x5pH");

var $4iV1e = parcelRequire("4iV1e");

var $ecqyi = parcelRequire("ecqyi");

var $kjHmv = parcelRequire("kjHmv");

var $1U4EY = parcelRequire("1U4EY");

var $9bk6s = parcelRequire("9bk6s");

var $by9zw = parcelRequire("by9zw");

var $hT1xk = parcelRequire("hT1xk");

var $lV2o9 = parcelRequire("lV2o9");

var $dXQDI = parcelRequire("dXQDI");

var $ifnb0 = parcelRequire("ifnb0");

var $dAf5R = parcelRequire("dAf5R");

var $c781K = parcelRequire("c781K");

var $bdVbi = parcelRequire("bdVbi");

var $bfgl4 = parcelRequire("bfgl4");

var $8bDjo = parcelRequire("8bDjo");

var $7EZ5v = parcelRequire("7EZ5v");

var $empdx = parcelRequire("empdx");

var $jhS4y = parcelRequire("jhS4y");

var $6x874 = parcelRequire("6x874");

var $ih7ba = parcelRequire("ih7ba");

var $46Cti = parcelRequire("46Cti");
const $e2413e530566d4f6$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Common';
const $e2413e530566d4f6$export$d57b6b390e78d90f = 'jira-cosmos';
const $e2413e530566d4f6$export$47f3715a07cde7e8 = 250;
const $e2413e530566d4f6$export$421b92818c76ee2d = Object.values((0, $jhS4y.CONFIGURABLE_MENU_ID));
const $e2413e530566d4f6$export$f5a7bd7eb586e4e8 = $e2413e530566d4f6$export$421b92818c76ee2d;
const $e2413e530566d4f6$export$c52c93cc28495ab0 = Object.values((0, $jhS4y.GLOBAL_APP_MENU_ID));
const $e2413e530566d4f6$export$de634ec0f98ab74b = $e2413e530566d4f6$export$c52c93cc28495ab0;
const $e2413e530566d4f6$export$6a976dc7193b8a18 = {
    [(0, $46Cti.L1_MENU_ID).APPS]: {
        message: (0, $ih7ba.default).apps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1ZDWg)))
    },
    [(0, $46Cti.L1_MENU_ID).GOALS]: {
        message: (0, $ih7ba.default).goals,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($4iV1e)))
    },
    [(0, $46Cti.L1_MENU_ID).ROADMAPS]: {
        message: (0, $ih7ba.default).roadmaps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Trwl)))
    },
    [(0, $46Cti.L1_MENU_ID).PLANS]: {
        message: (0, $ih7ba.default).plans,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ifnb0)))
    },
    [(0, $46Cti.L1_MENU_ID).PROJECTS]: {
        message: (0, $ih7ba.default).projects,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dXQDI)))
    },
    [(0, $46Cti.L1_MENU_ID).FILTERS]: {
        message: (0, $ih7ba.default).filters,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jX361)))
    },
    [(0, $46Cti.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $ih7ba.default).dashboards,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gsyzJ)))
    },
    [(0, $46Cti.L1_MENU_ID).COMMUNICATION]: {
        message: (0, $ih7ba.default).communication,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($empdx)))
    },
    [(0, $46Cti.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $ih7ba.default).overviews,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9x5pH)))
    },
    [(0, $46Cti.L1_MENU_ID).OPERATIONS]: {
        message: (0, $ih7ba.default).operations,
        Icon: (0, $6x874.default)
    },
    [(0, $46Cti.L1_MENU_ID).ASSETS]: {
        message: (0, $ih7ba.default).assets,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ls0mX)))
    },
    [(0, $46Cti.L1_MENU_ID).TEAMS]: {
        message: (0, $ih7ba.default).teams,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c781K)))
    },
    [(0, $46Cti.L1_MENU_ID).RECENT]: {
        message: (0, $ih7ba.default).recent,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hyKRO)))
    },
    [(0, $46Cti.L1_MENU_ID).STARRED]: {
        message: (0, $ih7ba.default).starred,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dAf5R)))
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $ih7ba.default).customerService,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ecqyi)))
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_HUBS]: {
        message: (0, $ih7ba.default).customerHubs,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kjHmv)))
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $ih7ba.default).customerServiceAnalytics,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EZ5v)))
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $ih7ba.default).assets,
        Icon: (0, $bfgl4.AssetsIcon)
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $ih7ba.default).goals,
        Icon: (0, $8bDjo.GoalsIcon)
    },
    // App Shortcuts for Platform Component
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: (0, $ih7ba.default).confluence,
        Icon: (0, $1U4EY.ConfluenceIcon)
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: (0, $ih7ba.default).loom,
        Icon: (0, $9bk6s.LoomIcon)
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: (0, $ih7ba.default).projects,
        Icon: (0, $hT1xk.ProjectsIcon)
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: (0, $ih7ba.default).teams,
        Icon: (0, $by9zw.TeamsIcon)
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: (0, $ih7ba.default).opsgenie,
        Icon: (0, $lV2o9.OpsgenieIcon)
    }
};
const $e2413e530566d4f6$export$5034ad0032cd499d = {
    message: (0, $ih7ba.default).forYou,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bdVbi)))
};
const $e2413e530566d4f6$export$b66ae8c18ec95bc6 = {
    message: (0, $ih7ba.default).forYou.defaultMessage
};
const $e2413e530566d4f6$export$da92a6698d96e3f2 = {
    [(0, $46Cti.L1_MENU_ID).APPS]: {
        message: (0, $ih7ba.default).apps.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GOALS]: {
        message: (0, $ih7ba.default).goals.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).ROADMAPS]: {
        message: (0, $ih7ba.default).roadmaps.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).PLANS]: {
        message: (0, $ih7ba.default).plans.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).PROJECTS]: {
        message: (0, $ih7ba.default).projects.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).FILTERS]: {
        message: (0, $ih7ba.default).filters.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $ih7ba.default).dashboards.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $ih7ba.default).overviews.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).COMMUNICATION]: {
        message: (0, $ih7ba.default).communication.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).OPERATIONS]: {
        message: (0, $ih7ba.default).operations.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).ASSETS]: {
        message: (0, $ih7ba.default).assets.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).TEAMS]: {
        message: (0, $ih7ba.default).teams.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).RECENT]: {
        message: (0, $ih7ba.default).recent.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).STARRED]: {
        message: (0, $ih7ba.default).starred.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $ih7ba.default).customerService.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_HUBS]: {
        message: (0, $ih7ba.default).customerHubs.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $ih7ba.default).customerServiceAnalytics.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $ih7ba.default).assets.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $ih7ba.default).goals.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: (0, $ih7ba.default).confluence.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: (0, $ih7ba.default).loom.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: (0, $ih7ba.default).projects.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: (0, $ih7ba.default).teams.defaultMessage
    },
    [(0, $46Cti.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: (0, $ih7ba.default).opsgenie.defaultMessage
    }
};
const $e2413e530566d4f6$export$9fcc53f3b36e0949 = 240; // in pixels
const $e2413e530566d4f6$export$6621cd553335536a = 320; // in pixels
const $e2413e530566d4f6$export$2eb8dda9e83d33ff = false;
const $e2413e530566d4f6$export$b4b2658405615c86 = 'TEAM_MANAGED_PROJECT';
const $e2413e530566d4f6$export$2336313834642df = 'COMPANY_MANAGED_PROJECT';
const $e2413e530566d4f6$export$9cf873ba2e9a3ce0 = 'nav4-opt-out';
const $e2413e530566d4f6$export$a495ba70b16d4d90 = 'nav4-sidebar';
const $e2413e530566d4f6$export$89de709e88232646 = 25;

});
parcelRegister("6x874", function(module, exports) {

$parcel$export(module.exports, "default", () => $079d8146cc6d581f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fJMTr = parcelRequire("fJMTr");

var $llvRa = parcelRequire("llvRa");

var $4R6GH = parcelRequire("4R6GH");
const $079d8146cc6d581f$var$OperationsIcon = ({ ...props })=>{
    if ((0, $4R6GH.fg)('nav4_operations_icon_update')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fJMTr))), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($llvRa))), props);
};
var $079d8146cc6d581f$export$2e2bcd8739ae039 = $079d8146cc6d581f$var$OperationsIcon;

});

parcelRegister("ih7ba", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c16ecaa1449e546$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7c16ecaa1449e546$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projects: {
        "id": "navigation-apps-sidebar-nav4-common.common.projects",
        "defaultMessage": "Projects"
    },
    filters: {
        "id": "navigation-apps-sidebar-nav4-common.common.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "navigation-apps-sidebar-nav4-common.common.dashboards",
        "defaultMessage": "Dashboards"
    },
    overviews: {
        "id": "navigation-apps-sidebar-nav4-common.common.overviews",
        "defaultMessage": "Overviews"
    },
    teams: {
        "id": "navigation-apps-sidebar-nav4-common.common.teams",
        "defaultMessage": "Teams"
    },
    assets: {
        "id": "navigation-apps-sidebar-nav4-common.common.assets",
        "defaultMessage": "Assets"
    },
    plans: {
        "id": "navigation-apps-sidebar-nav4-common.common.plans",
        "defaultMessage": "Plans"
    },
    apps: {
        "id": "navigation-apps-sidebar-nav4-common.common.apps",
        "defaultMessage": "Apps"
    },
    operations: {
        "id": "navigation-apps-sidebar-nav4-common.common.operations",
        "defaultMessage": "Operations"
    },
    goals: {
        "id": "navigation-apps-sidebar-nav4-common.common.goals",
        "defaultMessage": "Goals"
    },
    recent: {
        "id": "navigation-apps-sidebar-nav4-common.common.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-common.common.starred",
        "defaultMessage": "Starred"
    },
    roadmaps: {
        "id": "navigation-apps-sidebar-nav4-common.common.roadmaps",
        "defaultMessage": "Roadmaps"
    },
    customerService: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-service",
        "defaultMessage": "Customer service"
    },
    customerHubs: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-hubs",
        "defaultMessage": "Customer hubs"
    },
    customerServiceAnalytics: {
        "id": "navigation-apps-sidebar-nav4-common.common.customerServiceAnalytics",
        "defaultMessage": "Insights"
    },
    forYou: {
        "id": "navigation-apps-sidebar-nav4-common.common.forYou",
        "defaultMessage": "For you"
    },
    confluence: {
        "id": "navigation-apps-sidebar-nav4-common.common.confluence",
        "defaultMessage": "Confluence"
    },
    loom: {
        "id": "navigation-apps-sidebar-nav4-common.common.loom",
        "defaultMessage": "Loom"
    },
    opsgenie: {
        "id": "navigation-apps-sidebar-nav4-common.common.opsgenie",
        "defaultMessage": "Opsgenie"
    },
    communication: {
        "id": "navigation-apps-sidebar-nav4-common.common.communication",
        "defaultMessage": "Communications"
    }
});

});

parcelRegister("46Cti", function(module, exports) {

$parcel$export(module.exports, "L1_MENU_ID", () => $2d5b83df0b5ff159$export$918aea3cf024d90b);

var $jhS4y = parcelRequire("jhS4y");
const $2d5b83df0b5ff159$var$OPERATIONS_MENU_ID = {
    OPERATIONS_ALERT_SAVED_SEARCH_SHARED_WITH_ME: 'jira.sidebar.operations.alert.savedSearches.sharedWithMe',
    OPERATIONS_ALERT_SAVED_SEARCH_CREATED_BY_ME: 'jira.sidebar.operations.alert.savedSearches.createdByMe'
};
const $2d5b83df0b5ff159$export$bb47524d7f3cb1f8 = {
    ...(0, $jhS4y.CONFIGURABLE_MENU_ID),
    BOARDS: 'jira.sidebar.boards',
    QUEUES: 'jira.sidebar.queues',
    ALL: 'jira.sidebar.all'
};
const $2d5b83df0b5ff159$export$918aea3cf024d90b = {
    YOUR_WORK: 'jira.sidebar.yourWork',
    ...(0, $jhS4y.CONFIGURABLE_MENU_ID),
    ...$2d5b83df0b5ff159$var$OPERATIONS_MENU_ID
};

});




parcelRegister("bMW22", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5136b67e6c38f9a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f5136b67e6c38f9a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectSettings: {
        "id": "navigation-project-action-menu.project-settings",
        "defaultMessage": "Project settings"
    },
    moreActions: {
        "id": "navigation-project-action-menu.more-actions",
        "defaultMessage": "More actions"
    }
});

});


parcelRegister("44kzF", function(module, exports) {

$parcel$export(module.exports, "ThemePicker", () => $f5453100331219b3$export$75505f096a733fb9);

var $5uXOq = parcelRequire("5uXOq");

var $jgJNO = parcelRequire("jgJNO");

var $kV9ss = parcelRequire("kV9ss");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $kaHBi = parcelRequire("kaHBi");

var $pa9q9 = parcelRequire("pa9q9");

var $7VHMR = parcelRequire("7VHMR");

var $g8I5C = parcelRequire("g8I5C");

var $6jY6G = parcelRequire("6jY6G");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ky2ui = parcelRequire("ky2ui");

var $koeKL = parcelRequire("koeKL");

var $jpH5a = parcelRequire("jpH5a");

var $ca7Zi = parcelRequire("ca7Zi");

var $lwRIP = parcelRequire("lwRIP");

var $3LH0C = parcelRequire("3LH0C");

var $gHWtm = parcelRequire("gHWtm");

var $9yzIq = parcelRequire("9yzIq");
const $f5453100331219b3$var$SOURCE_NAME = 'projectThemePicker';
const $f5453100331219b3$var$messages = (0, $7VHMR.defineMessages)({
    errorFlagTitle: {
        "id": "business-theme-components.theme-picker.error-flag-title",
        "defaultMessage": "Something's gone wrong"
    },
    errorFlagDescription: {
        "id": "business-theme-components.theme-picker.error-flag-description",
        "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian Support."
    }
});
const $f5453100331219b3$export$bb0d35c1fc48487f = {
    id: 'open-theme-picker-error',
    type: 'error',
    title: $f5453100331219b3$var$messages.errorFlagTitle,
    description: $f5453100331219b3$var$messages.errorFlagDescription,
    isAutoDismiss: true,
    messageId: 'project-theme-components.ui.theme-picker.popup-entrypoint-error-flag.error.open-theme-picker-error',
    messageType: 'transactional'
};
const $f5453100331219b3$export$75505f096a733fb9 = /*#__PURE__*/ (0, $5uXOq.memo)(({ projectId: projectId, withAdaptiveColorTheme: withAdaptiveColorTheme, shouldRenderToParent: shouldRenderToParent = true })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const projectAri = (0, $kV9ss.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(projectId)
    }).toString();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $gHWtm.backgroundPickerPopupContentEntryPoint), (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectAri: projectAri
        }), [
        cloudId,
        projectAri
    ]));
    const startExperience = (0, $kaHBi.useExperienceStart)((0, $jpH5a.VIEW_THEME_PICKER_EXPERIENCE));
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [flagShown, setFlagShown] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isThemePickerOpen, setIsThemePickerOpen] = (0, $5uXOq.useState)(false);
    const toggleThemePicker = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (_, analyticsEvent)=>{
        // If we are about to open the theme picker, start the experience
        if (!isThemePickerOpen) startExperience();
        setIsThemePickerOpen((oldValue)=>!oldValue);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent ?? createAnalyticsEvent({}), 'button clicked', 'themePickerButton');
        setFlagShown(false);
    }, [
        isThemePickerOpen,
        startExperience,
        setIsThemePickerOpen,
        createAnalyticsEvent
    ]);
    const renderNudgeWrapper = (0, $5uXOq.useCallback)((children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ky2ui.BackgroundColourNudgeAsync), null, children), []);
    const buttonTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isThemePickerOpen);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onOpenChange: setIsThemePickerOpen,
            withAdaptiveColorTheme: withAdaptiveColorTheme
        }), [
        setIsThemePickerOpen,
        withAdaptiveColorTheme
    ]);
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3LH0C.ThemePickerButtonItem), {
            ...triggerProps,
            isSelected: isThemePickerOpen,
            testId: "project-theme-components.ui.theme-picker.trigger",
            ref: (element)=>{
                buttonTrigger(element);
                if (typeof triggerProps.ref === 'function') triggerProps.ref(element);
            },
            onClick: toggleThemePicker
        }), [
        buttonTrigger,
        isThemePickerOpen,
        toggleThemePicker
    ]);
    const errorFallback = (0, $5uXOq.useCallback)(({ error: error })=>{
        if (!flagShown) {
            showFlag($f5453100331219b3$export$bb0d35c1fc48487f);
            setFlagShown(true);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ca7Zi.ExperienceFailed), {
            experience: (0, $jpH5a.VIEW_THEME_PICKER_EXPERIENCE),
            error: error
        });
    }, [
        flagShown,
        showFlag
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "background-picker-popup-content",
            packageName: "@atlassian/jira-project-theme-components",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yzIq.ThemePickerSkeleton), null),
            errorFallback: errorFallback,
            runtimeProps: runtimeProps
        }), [
        errorFallback,
        entryPointReferenceSubject,
        runtimeProps
    ]);
    const onCloseHandler = (0, $5uXOq.useCallback)(()=>setIsThemePickerOpen(false), [
        setIsThemePickerOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g8I5C.QuickstartNudge), {
        renderWrapper: renderNudgeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: $f5453100331219b3$var$SOURCE_NAME,
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isThemePickerOpen,
        onClose: onCloseHandler,
        shouldRenderToParent: route.name.includes('legacy') ? false : shouldRenderToParent,
        content: content,
        trigger: trigger,
        placement: "right-start",
        id: (0, $lwRIP.THEME_PICKER_ELEMENT_ID),
        messageId: "project-theme-components.ui.theme-picker.popup.theme-picker",
        messageType: "transactional"
    })));
});

});
parcelRegister("g8I5C", function(module, exports) {

$parcel$export(module.exports, "QuickstartNudge", () => $0174d522ba9dfb06$export$bd61ee610c74db6c);

var $5uXOq = parcelRequire("5uXOq");

var $6OJ73 = parcelRequire("6OJ73");

var $axUP7 = parcelRequire("axUP7");
const $0174d522ba9dfb06$export$bd61ee610c74db6c = (0, $axUP7.withNestingOptimisation)(({ renderWrapper: renderWrapper, children: children })=>{
    const isFullyExpanded = (0, $6OJ73.useIsFullyExpanded)();
    return isFullyExpanded ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
});

});
parcelRegister("6OJ73", function(module, exports) {

$parcel$export(module.exports, "useIsFullyExpanded", () => $c20291d4f7970c77$export$7212b6b01271f5d1);

var $5uXOq = parcelRequire("5uXOq");

var $gPQRI = parcelRequire("gPQRI");
const $c20291d4f7970c77$var$TIMEOUT = 500;
const $c20291d4f7970c77$export$7212b6b01271f5d1 = ()=>{
    const [ready, setReady] = (0, $5uXOq.useState)(false);
    const { isCollapsed: isCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setReady(!isCollapsed);
        }, $c20291d4f7970c77$var$TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, [
        isCollapsed
    ]);
    return ready && !isCollapsed;
};

});
parcelRegister("gPQRI", function(module, exports) {

$parcel$export(module.exports, "useLeftSidebarState", () => $b19712b3cdd78134$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $b19712b3cdd78134$export$900f29014a48fb23);

var $5uXOq = parcelRequire("5uXOq");

var $iqLcb = parcelRequire("iqLcb");

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $b19712b3cdd78134$var$useSweetStateLeftSidebarState = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $b19712b3cdd78134$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $b19712b3cdd78134$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $b19712b3cdd78134$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $iqLcb.usePageLayoutResize)();
    return (0, $5uXOq.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});
parcelRegister("iqLcb", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $3d7d84f3bc65155e$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $3d7d84f3bc65155e$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $3d7d84f3bc65155e$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "LeftPanel", () => $3d7d84f3bc65155e$export$110709f040143804);
$parcel$export(module.exports, "LeftSidebar", () => $3d7d84f3bc65155e$export$3cabf771c4f2de);
$parcel$export(module.exports, "Main", () => $3d7d84f3bc65155e$export$861edd1ccea2f746);
$parcel$export(module.exports, "Content", () => $3d7d84f3bc65155e$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "RightSidebar", () => $3d7d84f3bc65155e$export$84d58c19c21f637f);
$parcel$export(module.exports, "RightPanel", () => $3d7d84f3bc65155e$export$364a989a35814102);
$parcel$export(module.exports, "useCustomSkipLink", () => $3d7d84f3bc65155e$export$ee6b12c2613bdf8e);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $3d7d84f3bc65155e$export$94561f6055639ef7);
$parcel$export(module.exports, "usePageLayoutResize", () => $3d7d84f3bc65155e$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $3d7d84f3bc65155e$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$7eaf986ecb4d5cac);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$e95b388ca8c92019);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $3d7d84f3bc65155e$export$d697087c06fd5e25);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4ZIaA = parcelRequire("4ZIaA");
var $c8E4X = parcelRequire("c8E4X");
var $eX4XX = parcelRequire("eX4XX");
var $aKz2G = parcelRequire("aKz2G");
var $aj7M6 = parcelRequire("aj7M6");
var $kUAkd = parcelRequire("kUAkd");
var $3WK4F = parcelRequire("3WK4F");
var $4CWca = parcelRequire("4CWca");
var $9xmqY = parcelRequire("9xmqY");
var $31ERv = parcelRequire("31ERv");
var $cIcFn = parcelRequire("cIcFn");
var $j3yGs = parcelRequire("j3yGs");

var $3HwlS = parcelRequire("3HwlS");

var $2MLVq = parcelRequire("2MLVq");
var $jjRN8 = parcelRequire("jjRN8");
var $hOWCC = parcelRequire("hOWCC");
var $ZlCus = parcelRequire("ZlCus");
var $1EWMr = parcelRequire("1EWMr");
var $kTus1 = parcelRequire("kTus1");
var $7g4r8 = parcelRequire("7g4r8");
function $3d7d84f3bc65155e$export$6d1402fb58384e4f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1EWMr.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3WK4F.default), props);
}
function $3d7d84f3bc65155e$export$3b4e64e77073e307(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjRN8.Banner), {
        height: props.height,
        testId: props.testId,
        id: props.id
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ZIaA.default), props);
}
function $3d7d84f3bc65155e$export$8a421bddecb2bf5b(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7g4r8.TopNav), {
        height: props.height,
        testId: props.testId,
        UNSAFE_theme: props.theme
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $31ERv.default), props);
}
function $3d7d84f3bc65155e$export$110709f040143804(props) {
    // LeftPanel is not supported in new page layout
    return (0, $3HwlS.getWillShowNav4)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eX4XX.default), props);
}
function $3d7d84f3bc65155e$export$43ae342508cf8cc9(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kTus1.SideNav), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aj7M6.default), props);
}
function $3d7d84f3bc65155e$export$3cabf771c4f2de(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kTus1.SideNav), {
        defaultCollapsed: props.collapsedState === 'collapsed',
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aKz2G.default), props);
}
function $3d7d84f3bc65155e$export$861edd1ccea2f746(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hOWCC.Main), {
        isFixed: props.isFixed,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kUAkd.default), props);
}
function $3d7d84f3bc65155e$export$7c6e2c02157bb7d2(props) {
    return (0, $3HwlS.getWillShowNav4)() ? // There isn't a concept of a `Content` wrapper component in the new page layout
    props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8E4X.default), props);
}
function $3d7d84f3bc65155e$export$84d58c19c21f637f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2MLVq.Aside), {
        isFixed: props.isFixed,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9xmqY.default), props);
}
function $3d7d84f3bc65155e$export$364a989a35814102(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ZlCus.Panel), {
        xcss: $3d7d84f3bc65155e$var$rightPanelStyles.root,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CWca.default), props);
}
const $3d7d84f3bc65155e$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $cIcFn.useCustomSkipLink)(id, title, index);
const $3d7d84f3bc65155e$export$94561f6055639ef7 = ()=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $j3yGs.useLeftSidebarFlyoutLock)();
// A mock value is needed to match the signature of the hook
const $3d7d84f3bc65155e$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    collapseLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    },
    setLeftSidebarState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    toggleLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $3d7d84f3bc65155e$export$10c7104037a7af62 = ()=>(0, $3HwlS.getWillShowNav4)() ? $3d7d84f3bc65155e$var$mockPageLayoutResize : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $j3yGs.usePageLayoutResize)();
const $3d7d84f3bc65155e$var$rightPanelStyles = {
    root: "_bfhk1bhr"
};
const $3d7d84f3bc65155e$export$991ef8098f87814a = (0, $565cb8192fc4e070$export$ed7cc0d417ee89e);
const $3d7d84f3bc65155e$export$7eaf986ecb4d5cac = (0, $565cb8192fc4e070$export$f963aecf2d4465bd);
const $3d7d84f3bc65155e$export$e95b388ca8c92019 = (0, $565cb8192fc4e070$export$f897e1ed9f8ed251);
const $3d7d84f3bc65155e$export$2ab8b83eed76656c = (0, $565cb8192fc4e070$export$750459958906793);
const $3d7d84f3bc65155e$export$ac017575d43f5da = (0, $565cb8192fc4e070$export$b44ab66843c05a69);
const $3d7d84f3bc65155e$export$d697087c06fd5e25 = (0, $565cb8192fc4e070$export$aeff86a16f13529);

});
// dimension vars
const $565cb8192fc4e070$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $565cb8192fc4e070$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $565cb8192fc4e070$export$c103b605cd368aed = 'rightSidebarWidth';
const $565cb8192fc4e070$export$fa34f417972d6341 = 'rightPanelWidth';
const $565cb8192fc4e070$export$3a6a779d9181047c = 'topNavigationHeight';
const $565cb8192fc4e070$export$bcd94a6a792e7f96 = 'bannerHeight';
const $565cb8192fc4e070$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $565cb8192fc4e070$export$344062f7cfc9528e = 'left-panel';
const $565cb8192fc4e070$export$c7139cc2d6110b5f = 'right-panel';
const $565cb8192fc4e070$export$238d30785c4bca84 = 'banner';
const $565cb8192fc4e070$export$bec6dca2e63de4ae = 'top-navigation';
const $565cb8192fc4e070$export$d1213e82613ff4df = 'content';
const $565cb8192fc4e070$export$be83e7118304b28e = 56;
const $565cb8192fc4e070$export$4a98ee0bd1ae362 = 56;
const $565cb8192fc4e070$export$539e68c09584883a = 240;
const $565cb8192fc4e070$export$b92df8810d2fcd01 = 280;
const $565cb8192fc4e070$export$c3e41153b9288bcf = 368;
const $565cb8192fc4e070$export$c4d6152f86ea28f6 = 368;
const $565cb8192fc4e070$export$46acf8758e9e2636 = 20;
const $565cb8192fc4e070$export$70740f5ad8360a78 = 16;
const $565cb8192fc4e070$export$991d5285ad765a3d = 240;
const $565cb8192fc4e070$export$6949d4f32b161684 = 200;
const $565cb8192fc4e070$export$d6e7e8af042815bb = 350;
const $565cb8192fc4e070$export$3749e1104328fde4 = 300;
const $565cb8192fc4e070$export$1074d925b0b82be5 = 200;
const $565cb8192fc4e070$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $565cb8192fc4e070$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $565cb8192fc4e070$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $565cb8192fc4e070$export$70c702a8c5895f03 = 'data-grab-area-line';
const $565cb8192fc4e070$export$48a43f91e4becf4e = 'data-grab-area';
const $565cb8192fc4e070$export$dac2fb31a9f6844d = 'data-resize-button';
const $565cb8192fc4e070$export$9ecd22db14e6c70e = 'data-resize-control';
const $565cb8192fc4e070$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $565cb8192fc4e070$export$206a08f7f8beb554 = 'Skip to:';
const $565cb8192fc4e070$export$659ee746b31b360d = 'data-layout-container';
const $565cb8192fc4e070$export$f963aecf2d4465bd = `var(--${$565cb8192fc4e070$export$cbfb0f5b2869b17b}, 0px)`;
const $565cb8192fc4e070$export$750459958906793 = `var(--${$565cb8192fc4e070$export$fa34f417972d6341}, 0px)`;
const $565cb8192fc4e070$export$f897e1ed9f8ed251 = `var(--${$565cb8192fc4e070$export$a30f2e00489a8957}, 0px)`;
const $565cb8192fc4e070$export$b44ab66843c05a69 = `var(--${$565cb8192fc4e070$export$c103b605cd368aed}, 0px)`;
const $565cb8192fc4e070$export$aeff86a16f13529 = `var(--${$565cb8192fc4e070$export$3a6a779d9181047c}, 0px)`;
const $565cb8192fc4e070$export$ed7cc0d417ee89e = `var(--${$565cb8192fc4e070$export$bcd94a6a792e7f96}, 0px)`;
const $565cb8192fc4e070$export$d2fa14f05b61e66 = `var(--${$565cb8192fc4e070$export$b6744d31294864fd}, ${$565cb8192fc4e070$export$991d5285ad765a3d}px)`;




parcelRegister("axUP7", function(module, exports) {

$parcel$export(module.exports, "withNestingOptimisation", () => $c861ce2b697701b9$export$ee1cb2a8280d8710);

var $5uXOq = parcelRequire("5uXOq");

var $j9VTE = parcelRequire("j9VTE");

var $9sGI6 = parcelRequire("9sGI6");
const $c861ce2b697701b9$export$ee1cb2a8280d8710 = (Component)=>{
    const WithNestingOptimisation = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
        const children = // @ts-expect-error - Property 'children' does not exist on type 'Props'.ts(2339)
        typeof props === 'object' && props != null ? props.children : null;
        return (0, $j9VTE.useShouldNestedElementRender)().shouldRender && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            ref: ref
        }) : children;
    });
    WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, $9sGI6.getDisplayName)(Component)})`;
    return WithNestingOptimisation;
};

});
parcelRegister("9sGI6", function(module, exports) {

$parcel$export(module.exports, "getDisplayName", () => $0d4ebae82d1d47ab$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $0d4ebae82d1d47ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $0d4ebae82d1d47ab$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $0d4ebae82d1d47ab$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$0d4ebae82d1d47ab$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $0d4ebae82d1d47ab$export$2e2bcd8739ae039 = $0d4ebae82d1d47ab$var$withInjectedProps;

});



parcelRegister("ky2ui", function(module, exports) {

$parcel$export(module.exports, "BackgroundColourNudgeAsync", () => $cb3deafbb4dbbb82$export$a3dbb521061a599a);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cb3deafbb4dbbb82$var$BackgroundColourNudgeLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("itvQz")).then((exportedModule)=>exportedModule.BackgroundColourNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges-jwm-background-color/src/index.tsx"
});
const $cb3deafbb4dbbb82$export$a3dbb521061a599a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $d231c4839441ff18$export$eb0b199de90a7ec2),
        fallback: children,
        attributes: {
            nudgeId: (0, $d231c4839441ff18$export$eb0b199de90a7ec2)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "background-colour-onboarding-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb3deafbb4dbbb82$var$BackgroundColourNudgeLazy, null, children)));
$cb3deafbb4dbbb82$export$a3dbb521061a599a.displayName = 'BackgroundColourNudgeAsync';

});
parcelRegister("bBbEG", function(module, exports) {

$parcel$export(module.exports, "OnboardingNudgeErrorBoundary", () => $383be1d115a6551b$export$3915a8814b99f0b);

var $5uXOq = parcelRequire("5uXOq");

var $lkem5 = parcelRequire("lkem5");

var $8Bc5A = parcelRequire("8Bc5A");
const $383be1d115a6551b$export$3915a8814b99f0b = (props)=>{
    const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lkem5.ErrorBoundaryWithChunkErrorLogging), {
        id: id,
        packageName: (0, $8Bc5A.PACKAGE_NAME),
        render: ()=>fallback,
        attributes: attributes
    }, children);
};

});
parcelRegister("lkem5", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", () => $3df8b034ebbd68e5$export$9171acf2e93b7d4d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $30rnQ = parcelRequire("30rnQ");
const $3df8b034ebbd68e5$export$9171acf2e93b7d4d = (props)=>{
    const { attributes: attributes, children: children, ...rest } = props;
    const addErrorBoundaryAnalyticsAttributes = (0, $30rnQ.useAddErrorBoundaryAnalyticsAttributes)(attributes);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        ...rest,
        attributes: addErrorBoundaryAnalyticsAttributes
    }, children);
};

});
parcelRegister("30rnQ", function(module, exports) {

$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $53c68ff9a9edd0fe$export$807be5f3f1ea996);

var $5uXOq = parcelRequire("5uXOq");

var $bCf8q = parcelRequire("bCf8q");
const $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $bCf8q.isLoaderError)(error)
    });
const $53c68ff9a9edd0fe$export$807be5f3f1ea996 = (attributes = {})=>(0, $5uXOq.useCallback)((error)=>({
            ...attributes,
            ...$53c68ff9a9edd0fe$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});


parcelRegister("8Bc5A", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $5f07ce956337ba8b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $5f07ce956337ba8b$export$2b3151a089bc8780);
$parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", () => $5f07ce956337ba8b$export$6826d33e9a2c0119);
$parcel$export(module.exports, "ROOT_TASK", () => $5f07ce956337ba8b$export$b580da85daad7757);
$parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", () => $5f07ce956337ba8b$export$5eef19b26a4bbe70);
$parcel$export(module.exports, "QUICKSTART_TYPE", () => $5f07ce956337ba8b$export$c57d251ae83aff51);
$parcel$export(module.exports, "getBackendVisibilityKey", () => $5f07ce956337ba8b$export$d9df7fd23ab00c49);
$parcel$export(module.exports, "KEY_OPEN", () => $5f07ce956337ba8b$export$93a67c1026e8cb7c);
$parcel$export(module.exports, "KEY_DISMISSED", () => $5f07ce956337ba8b$export$a7dcb0b5013e932b);
$parcel$export(module.exports, "KEY_TASK_GROUP", () => $5f07ce956337ba8b$export$f962b14e410d598f);
$parcel$export(module.exports, "KEY_OPEN_TASK", () => $5f07ce956337ba8b$export$21e8355b28449456);
$parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", () => $5f07ce956337ba8b$export$536a90031123e004);
$parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", () => $5f07ce956337ba8b$export$3ccd291a1a3a4f6d);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $5f07ce956337ba8b$export$9957974f8b4d8f74);
$parcel$export(module.exports, "SOURCE", () => $5f07ce956337ba8b$export$83c8d7110915321e);
$parcel$export(module.exports, "KEY_JSW_ONBOARDING", () => $5f07ce956337ba8b$export$8b9bd2a9275b0187);
$parcel$export(module.exports, "convertToHaveSeenItTask", () => $5f07ce956337ba8b$export$ec43e7bf5973b10f);
$parcel$export(module.exports, "ADD_COLUMNS_TASK", () => $5f07ce956337ba8b$export$cbeb719208f32c8a);
$parcel$export(module.exports, "CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$88c918f2cfaff86);
$parcel$export(module.exports, "CREATE_ISSUE_TASK", () => $5f07ce956337ba8b$export$abbbea7c37c93cb5);
$parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", () => $5f07ce956337ba8b$export$2a0253cb20f48a8);
$parcel$export(module.exports, "INVITE_TEAMMATES_TASK", () => $5f07ce956337ba8b$export$f97428bb4b1991ec);
$parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", () => $5f07ce956337ba8b$export$45eaf4204fcc7);
$parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", () => $5f07ce956337ba8b$export$af57685e201438e8);
$parcel$export(module.exports, "FIND_HELP_TASK", () => $5f07ce956337ba8b$export$d6c67e9aab4e2b26);
$parcel$export(module.exports, "SET_UP_BOARD_TASK", () => $5f07ce956337ba8b$export$3de8c242d2b82f26);
$parcel$export(module.exports, "GET_MOBILE_APP_TASK", () => $5f07ce956337ba8b$export$a01fa44f793dbfac);
$parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", () => $5f07ce956337ba8b$export$6a4507e462fd41da);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", () => $5f07ce956337ba8b$export$e64c1dced6ac4458);
$parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", () => $5f07ce956337ba8b$export$63b0e55f9c6454ac);
$parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", () => $5f07ce956337ba8b$export$c1effb1c8979fe22);
$parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", () => $5f07ce956337ba8b$export$d97d31d934dbb194);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$cafb5bd13b02056b);
$parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", () => $5f07ce956337ba8b$export$e55c18b809946e72);
$parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", () => $5f07ce956337ba8b$export$de5640b9ae8140a7);
$parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", () => $5f07ce956337ba8b$export$540b5c3c4b6ce459);
$parcel$export(module.exports, "CHANGE_CONTROL_TASK", () => $5f07ce956337ba8b$export$6f71dff531ff592);
$parcel$export(module.exports, "AUTOMATIONS_TASK", () => $5f07ce956337ba8b$export$83255ab79e45f34f);
$parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", () => $5f07ce956337ba8b$export$b57d172af9ad7647);
$parcel$export(module.exports, "USER_MANAGEMENT_TASK", () => $5f07ce956337ba8b$export$ff4c933c1fe90b68);
$parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$3e2776d61f3662dc);
$parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", () => $5f07ce956337ba8b$export$9048315f2c03fd9d);
$parcel$export(module.exports, "GET_TO_KNOW_YOUR_TEMPLATE_TASK", () => $5f07ce956337ba8b$export$a333714599f14a6);
$parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", () => $5f07ce956337ba8b$export$4145c2cec2da6f9b);
$parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$4957a1ad203cf6dd);
$parcel$export(module.exports, "CALENDAR_VIEW_TASK", () => $5f07ce956337ba8b$export$190b5dd0a1322552);
$parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", () => $5f07ce956337ba8b$export$501166b25f254aab);
$parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$94ad6507a703f4eb);
$parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", () => $5f07ce956337ba8b$export$be1c522400a1bd7c);
$parcel$export(module.exports, "JWM_CALENDAR_TASK", () => $5f07ce956337ba8b$export$2aa6e7b6e24a04f5);
$parcel$export(module.exports, "JWM_TIMELINE_TASK", () => $5f07ce956337ba8b$export$f3b53199b07af2a1);
$parcel$export(module.exports, "JWM_BUILD_FORM_TASK", () => $5f07ce956337ba8b$export$d37415ffddcf2142);
$parcel$export(module.exports, "JWM_FEEDBACK_TASK", () => $5f07ce956337ba8b$export$2ae00586da7cb606);
$parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", () => $5f07ce956337ba8b$export$b86266e6594a97bb);
$parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", () => $5f07ce956337ba8b$export$20bc3dc137ac1c38);
$parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", () => $5f07ce956337ba8b$export$77071b77e2801b18);
$parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", () => $5f07ce956337ba8b$export$9c89f946f05d884a);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", () => $5f07ce956337ba8b$export$b52a7c936684cfc5);
$parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", () => $5f07ce956337ba8b$export$b5555f24061f9fb);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", () => $5f07ce956337ba8b$export$ff25449f34b8abf);
$parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", () => $5f07ce956337ba8b$export$3380e677209260fe);
$parcel$export(module.exports, "GET_STARTED_LIST_TASK", () => $5f07ce956337ba8b$export$7a2fcaad1564e6b7);
$parcel$export(module.exports, "OPS_JTBD_1_LIST", () => $5f07ce956337ba8b$export$da23b72d32bfad9e);
$parcel$export(module.exports, "OPS_JTBD_2_BOARD", () => $5f07ce956337ba8b$export$4b064659282e0238);
$parcel$export(module.exports, "OPS_JTBD_2_FORMS", () => $5f07ce956337ba8b$export$3ab51851f6d823e);
$parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", () => $5f07ce956337ba8b$export$e4a1a37a9a1350ad);
$parcel$export(module.exports, "OPS_JTBD_3_LIST", () => $5f07ce956337ba8b$export$b7f7da5e795f0327);
$parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", () => $5f07ce956337ba8b$export$80a401c1aa47a377);
$parcel$export(module.exports, "OPS_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$934ac7a251b26dc7);
$parcel$export(module.exports, "OPS_JTBD_4_LIST", () => $5f07ce956337ba8b$export$4634f6395df3ebbe);
$parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", () => $5f07ce956337ba8b$export$768fb41107a1e8d7);
$parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", () => $5f07ce956337ba8b$export$d797a81bace17184);
$parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$746102c94db9df1f);
$parcel$export(module.exports, "OPS_JTBD_5_LIST", () => $5f07ce956337ba8b$export$5f1efd797d65e349);
$parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$cccc812ccafbf11f);
$parcel$export(module.exports, "OPS_JTBD_5_PAGES", () => $5f07ce956337ba8b$export$64822db87abd8a47);
$parcel$export(module.exports, "OPS_JTBD_6_PAGES", () => $5f07ce956337ba8b$export$64f764d8be495c82);
$parcel$export(module.exports, "OPS_JTBD_7_LIST", () => $5f07ce956337ba8b$export$24eae23dc1c68bbd);
$parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", () => $5f07ce956337ba8b$export$50fa92eba6f82feb);
$parcel$export(module.exports, "OPS_JTBD_0_LIST", () => $5f07ce956337ba8b$export$4155d22fe3f14cd6);
$parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$76813cbead887191);
$parcel$export(module.exports, "OPS_JTBD_0_PAGES", () => $5f07ce956337ba8b$export$90aab2ff89daf770);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$a2bc0cbad2e6e605);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$f90872a1280728bb);
$parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$bce644e96518cbd2);
$parcel$export(module.exports, "MKT_JTBD_1_LIST", () => $5f07ce956337ba8b$export$241aaebffac0a3e5);
$parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", () => $5f07ce956337ba8b$export$f9dfc43b5b31c4b7);
$parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", () => $5f07ce956337ba8b$export$79759e9e62fb9312);
$parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", () => $5f07ce956337ba8b$export$992d1e0dce255d19);
$parcel$export(module.exports, "MKT_JTBD_2_PAGES", () => $5f07ce956337ba8b$export$d28c1b0e5b3e768);
$parcel$export(module.exports, "MKT_JTBD_3_PAGES", () => $5f07ce956337ba8b$export$ca714ee197bed4ec);
$parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", () => $5f07ce956337ba8b$export$faae55ceea4b6073);
$parcel$export(module.exports, "MKT_JTBD_4_LIST", () => $5f07ce956337ba8b$export$200bc24cd120667e);
$parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", () => $5f07ce956337ba8b$export$a0d784a48b4e886c);
$parcel$export(module.exports, "MKT_JTBD_4_PAGES", () => $5f07ce956337ba8b$export$baf5bd09b4b33b8a);
$parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", () => $5f07ce956337ba8b$export$4702007eedbca8ab);
$parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", () => $5f07ce956337ba8b$export$aa9d2d635ea63898);
$parcel$export(module.exports, "MKT_JTBD_6_FORMS", () => $5f07ce956337ba8b$export$2ea449225c1f6cac);
$parcel$export(module.exports, "MKT_JTBD_0_LIST", () => $5f07ce956337ba8b$export$deb8b557e735e26a);
$parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", () => $5f07ce956337ba8b$export$d45754df44e4c309);
$parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", () => $5f07ce956337ba8b$export$78b2913b550edbb);
$parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", () => $5f07ce956337ba8b$export$71243272608c58ab);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", () => $5f07ce956337ba8b$export$39a08f215c33bc39);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", () => $5f07ce956337ba8b$export$d2377f6a6fa3b49c);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", () => $5f07ce956337ba8b$export$befa8f6533309779);
$parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", () => $5f07ce956337ba8b$export$736b40db8701ba6c);
$parcel$export(module.exports, "TAILORED_ONBOARDING_SUMMARY", () => $5f07ce956337ba8b$export$11eff6ae2f70b67b);
$parcel$export(module.exports, "TAILORED_ONBOARDING_LIST", () => $5f07ce956337ba8b$export$fb2d23e5315a67a9);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CALENDAR", () => $5f07ce956337ba8b$export$32e794bb49d60b6);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BOARD", () => $5f07ce956337ba8b$export$fed256238b27db06);
$parcel$export(module.exports, "TAILORED_ONBOARDING_TIMELINE", () => $5f07ce956337ba8b$export$132eecb4d35a590d);
$parcel$export(module.exports, "TAILORED_ONBOARDING_PAGES", () => $5f07ce956337ba8b$export$2579c51cadd45eca);
$parcel$export(module.exports, "TAILORED_ONBOARDING_FORM", () => $5f07ce956337ba8b$export$4b1a0cefa966ea0);
$parcel$export(module.exports, "TAILORED_ONBOARDING_INVITE", () => $5f07ce956337ba8b$export$f6558daacc312a65);
$parcel$export(module.exports, "TAILORED_ONBOARDING_BACKLOG", () => $5f07ce956337ba8b$export$925efa2e24e86b88);
$parcel$export(module.exports, "TAILORED_ONBOARDING_CODE", () => $5f07ce956337ba8b$export$40454d3e062dcd44);
$parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", () => $5f07ce956337ba8b$export$99b0e09ff6f00490);
$parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", () => $5f07ce956337ba8b$export$2a82344eb273eeff);
$parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", () => $5f07ce956337ba8b$export$1de5766b7e640d6b);
$parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", () => $5f07ce956337ba8b$export$11c0696d49e68c93);
$parcel$export(module.exports, "ACCOUNT_ID", () => $5f07ce956337ba8b$export$c8ab6996f562d0db);
$parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", () => $5f07ce956337ba8b$export$2b5f951ad8e70cfe);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => $5f07ce956337ba8b$export$5703447487aaccdf);
$parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", () => $5f07ce956337ba8b$export$e0197e09cccd4e50);
$parcel$export(module.exports, "PROJECT_SETTING_PAGES", () => $5f07ce956337ba8b$export$f779bbfe667acddc);
$parcel$export(module.exports, "JSM_BUSINESS_TASKS", () => $5f07ce956337ba8b$export$38fbac7a5bf4aa33);
$parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", () => $5f07ce956337ba8b$export$7578902c7f420a3);
$parcel$export(module.exports, "SAMPLE_DATA_PROJECT_KEYS_TO_HIDE_ON", () => $5f07ce956337ba8b$export$5980f41aa657f9c7);

var $g5X3G = parcelRequire("g5X3G");
const $5f07ce956337ba8b$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
const $5f07ce956337ba8b$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
const $5f07ce956337ba8b$export$2b3151a089bc8780 = 'jlove-makkuro';
const $5f07ce956337ba8b$export$6826d33e9a2c0119 = 320;
const $5f07ce956337ba8b$export$b580da85daad7757 = 'root';
const $5f07ce956337ba8b$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
const $5f07ce956337ba8b$export$c57d251ae83aff51 = {
    JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
    OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
};
const $5f07ce956337ba8b$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
const $5f07ce956337ba8b$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
const $5f07ce956337ba8b$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
const $5f07ce956337ba8b$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
const $5f07ce956337ba8b$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
const $5f07ce956337ba8b$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
const $5f07ce956337ba8b$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
const $5f07ce956337ba8b$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
const $5f07ce956337ba8b$export$8b9bd2a9275b0187 = 'jsw.onboarding';
const $5f07ce956337ba8b$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
const $5f07ce956337ba8b$export$cbeb719208f32c8a = $5f07ce956337ba8b$var$completeJswTaskName('add-columns-task');
const $5f07ce956337ba8b$export$88c918f2cfaff86 = $5f07ce956337ba8b$var$completeJswTaskName('create-project-task');
const $5f07ce956337ba8b$export$abbbea7c37c93cb5 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task');
const $5f07ce956337ba8b$export$2a0253cb20f48a8 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task-simplified');
const $5f07ce956337ba8b$export$f97428bb4b1991ec = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-task');
const $5f07ce956337ba8b$export$45eaf4204fcc7 = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-video-task');
const $5f07ce956337ba8b$export$af57685e201438e8 = $5f07ce956337ba8b$var$completeJswTaskName('capture-integrations-task');
const $5f07ce956337ba8b$export$d6c67e9aab4e2b26 = $5f07ce956337ba8b$var$completeJswTaskName('find-help-task');
const $5f07ce956337ba8b$export$3de8c242d2b82f26 = $5f07ce956337ba8b$var$completeJswTaskName('set-up-board-task');
const $5f07ce956337ba8b$export$a01fa44f793dbfac = $5f07ce956337ba8b$var$completeJswTaskName('get-mobile-app-task');
const $5f07ce956337ba8b$export$6a4507e462fd41da = $5f07ce956337ba8b$var$completeJswTaskName('map-out-your-project-goals');
const $5f07ce956337ba8b$export$e64c1dced6ac4458 = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work');
const $5f07ce956337ba8b$export$63b0e55f9c6454ac = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
const $5f07ce956337ba8b$export$c1effb1c8979fe22 = $5f07ce956337ba8b$var$completeJswTaskName('monitor-manage-risk');
const $5f07ce956337ba8b$export$d97d31d934dbb194 = $5f07ce956337ba8b$var$completeJswTaskName('premium-reverse-trial-task');
const $5f07ce956337ba8b$export$cafb5bd13b02056b = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task');
const $5f07ce956337ba8b$export$e55c18b809946e72 = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task-non-admin');
const $5f07ce956337ba8b$export$de5640b9ae8140a7 = $5f07ce956337ba8b$var$completeJswTaskName('standard-edition-overview-task');
const $5f07ce956337ba8b$export$540b5c3c4b6ce459 = $5f07ce956337ba8b$var$completeJswTaskName('advanced-roadmaps-task');
const $5f07ce956337ba8b$export$6f71dff531ff592 = $5f07ce956337ba8b$var$completeJswTaskName('change-control-task');
const $5f07ce956337ba8b$export$83255ab79e45f34f = $5f07ce956337ba8b$var$completeJswTaskName('automations-task');
const $5f07ce956337ba8b$export$b57d172af9ad7647 = $5f07ce956337ba8b$var$completeJswTaskName('site-administrations-task');
const $5f07ce956337ba8b$export$ff4c933c1fe90b68 = $5f07ce956337ba8b$var$completeJswTaskName('user-management-task');
const $5f07ce956337ba8b$export$3e2776d61f3662dc = $5f07ce956337ba8b$var$completeJswTaskName('scrum-onboarding-task');
const $5f07ce956337ba8b$export$9048315f2c03fd9d = $5f07ce956337ba8b$var$completeJswTaskName('customize-site-name-task');
const $5f07ce956337ba8b$export$a333714599f14a6 = $5f07ce956337ba8b$var$completeJswTaskName('get-to-know-your-template-task');
const $5f07ce956337ba8b$export$4145c2cec2da6f9b = $5f07ce956337ba8b$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
const $5f07ce956337ba8b$export$4957a1ad203cf6dd = $5f07ce956337ba8b$var$completeJswTaskName('try-atlassian-university-task');
const $5f07ce956337ba8b$export$190b5dd0a1322552 = $5f07ce956337ba8b$var$completeJswTaskName('calendar-view-task');
const $5f07ce956337ba8b$export$501166b25f254aab = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-project-summary-task');
const $5f07ce956337ba8b$export$94ad6507a703f4eb = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-sample-project-task');
const $5f07ce956337ba8b$export$be1c522400a1bd7c = $5f07ce956337ba8b$var$completeJwmTaskName('background-color-task');
const $5f07ce956337ba8b$export$2aa6e7b6e24a04f5 = $5f07ce956337ba8b$var$completeJwmTaskName('calendar-task');
const $5f07ce956337ba8b$export$f3b53199b07af2a1 = $5f07ce956337ba8b$var$completeJwmTaskName('timeline-task');
const $5f07ce956337ba8b$export$d37415ffddcf2142 = $5f07ce956337ba8b$var$completeJwmTaskName('build-form-task');
const $5f07ce956337ba8b$export$2ae00586da7cb606 = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-task');
const $5f07ce956337ba8b$export$b86266e6594a97bb = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-sample-project-task');
const $5f07ce956337ba8b$export$20bc3dc137ac1c38 = $5f07ce956337ba8b$var$completeJwmTaskName('create-your-own-project-task');
const $5f07ce956337ba8b$export$77071b77e2801b18 = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-project-task');
const $5f07ce956337ba8b$export$9c89f946f05d884a = $5f07ce956337ba8b$var$completeJwmTaskName('share-project-task');
const $5f07ce956337ba8b$export$b52a7c936684cfc5 = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-import');
const $5f07ce956337ba8b$export$b5555f24061f9fb = $5f07ce956337ba8b$var$completeJwmTaskName('summary-and-reports-task');
const $5f07ce956337ba8b$export$ff25449f34b8abf = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
const $5f07ce956337ba8b$export$3380e677209260fe = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-key-differences');
const $5f07ce956337ba8b$export$7a2fcaad1564e6b7 = $5f07ce956337ba8b$var$completeJwmTaskName('get-started-list-task');
const $5f07ce956337ba8b$export$da23b72d32bfad9e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_1_LIST');
const $5f07ce956337ba8b$export$4b064659282e0238 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
const $5f07ce956337ba8b$export$3ab51851f6d823e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
const $5f07ce956337ba8b$export$e4a1a37a9a1350ad = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
const $5f07ce956337ba8b$export$b7f7da5e795f0327 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_LIST');
const $5f07ce956337ba8b$export$80a401c1aa47a377 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
const $5f07ce956337ba8b$export$934ac7a251b26dc7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$4634f6395df3ebbe = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_LIST');
const $5f07ce956337ba8b$export$768fb41107a1e8d7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
const $5f07ce956337ba8b$export$d797a81bace17184 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
const $5f07ce956337ba8b$export$746102c94db9df1f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$5f1efd797d65e349 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_LIST');
const $5f07ce956337ba8b$export$cccc812ccafbf11f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$64822db87abd8a47 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
const $5f07ce956337ba8b$export$64f764d8be495c82 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
const $5f07ce956337ba8b$export$24eae23dc1c68bbd = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_LIST');
const $5f07ce956337ba8b$export$50fa92eba6f82feb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
const $5f07ce956337ba8b$export$4155d22fe3f14cd6 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_LIST');
const $5f07ce956337ba8b$export$76813cbead887191 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$90aab2ff89daf770 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
const $5f07ce956337ba8b$export$a2bc0cbad2e6e605 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$f90872a1280728bb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$bce644e96518cbd2 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$241aaebffac0a3e5 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_LIST');
const $5f07ce956337ba8b$export$f9dfc43b5b31c4b7 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
const $5f07ce956337ba8b$export$79759e9e62fb9312 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
const $5f07ce956337ba8b$export$992d1e0dce255d19 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
const $5f07ce956337ba8b$export$d28c1b0e5b3e768 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
const $5f07ce956337ba8b$export$ca714ee197bed4ec = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
const $5f07ce956337ba8b$export$faae55ceea4b6073 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
const $5f07ce956337ba8b$export$200bc24cd120667e = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_LIST');
const $5f07ce956337ba8b$export$a0d784a48b4e886c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
const $5f07ce956337ba8b$export$baf5bd09b4b33b8a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
const $5f07ce956337ba8b$export$4702007eedbca8ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
const $5f07ce956337ba8b$export$aa9d2d635ea63898 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
const $5f07ce956337ba8b$export$2ea449225c1f6cac = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
const $5f07ce956337ba8b$export$deb8b557e735e26a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_LIST');
const $5f07ce956337ba8b$export$d45754df44e4c309 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
const $5f07ce956337ba8b$export$78b2913b550edbb = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
const $5f07ce956337ba8b$export$71243272608c58ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
const $5f07ce956337ba8b$export$39a08f215c33bc39 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
const $5f07ce956337ba8b$export$d2377f6a6fa3b49c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
const $5f07ce956337ba8b$export$befa8f6533309779 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
const $5f07ce956337ba8b$export$736b40db8701ba6c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
const $5f07ce956337ba8b$export$11eff6ae2f70b67b = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_SUMMARY');
const $5f07ce956337ba8b$export$fb2d23e5315a67a9 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_LIST');
const $5f07ce956337ba8b$export$32e794bb49d60b6 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CALENDAR');
const $5f07ce956337ba8b$export$fed256238b27db06 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BOARD');
const $5f07ce956337ba8b$export$132eecb4d35a590d = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_TIMELINE');
const $5f07ce956337ba8b$export$2579c51cadd45eca = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_PAGES');
const $5f07ce956337ba8b$export$4b1a0cefa966ea0 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_FORM');
const $5f07ce956337ba8b$export$f6558daacc312a65 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_INVITE');
const $5f07ce956337ba8b$export$925efa2e24e86b88 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_BACKLOG');
const $5f07ce956337ba8b$export$40454d3e062dcd44 = $5f07ce956337ba8b$var$completeJswTaskName('TAILORED_ONBOARDING_CODE');
const $5f07ce956337ba8b$export$99b0e09ff6f00490 = $5f07ce956337ba8b$var$completeJsmTaskName('customize-your-request-types-task');
const $5f07ce956337ba8b$export$2a82344eb273eeff = $5f07ce956337ba8b$var$completeJsmTaskName('review-your-channels-task');
const $5f07ce956337ba8b$export$1de5766b7e640d6b = $5f07ce956337ba8b$var$completeJsmTaskName('invite-your-team-task');
const $5f07ce956337ba8b$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
const $5f07ce956337ba8b$export$c8ab6996f562d0db = (0, $g5X3G.toAccountId)('accountId');
const $5f07ce956337ba8b$export$2b5f951ad8e70cfe = $5f07ce956337ba8b$var$completeJswTaskName('kanban-onboarding-task');
const $5f07ce956337ba8b$export$5703447487aaccdf = {
    NOT_LOADED: 'NOT_LOADED',
    OPEN: 'OPEN',
    MINIMIZED: 'MINIMIZED',
    DISMISSED: 'DISMISSED'
};
const $5f07ce956337ba8b$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $5f07ce956337ba8b$export$f779bbfe667acddc = [
    'legacy-project-settings-people',
    'project-settings-software-access'
];
const $5f07ce956337ba8b$export$38fbac7a5bf4aa33 = [
    $5f07ce956337ba8b$export$2a82344eb273eeff,
    $5f07ce956337ba8b$export$99b0e09ff6f00490,
    $5f07ce956337ba8b$export$1de5766b7e640d6b
];
const $5f07ce956337ba8b$export$7578902c7f420a3 = [
    $5f07ce956337ba8b$export$88c918f2cfaff86,
    $5f07ce956337ba8b$export$6a4507e462fd41da,
    $5f07ce956337ba8b$export$e64c1dced6ac4458,
    $5f07ce956337ba8b$export$63b0e55f9c6454ac,
    $5f07ce956337ba8b$export$c1effb1c8979fe22,
    $5f07ce956337ba8b$export$cbeb719208f32c8a,
    $5f07ce956337ba8b$export$abbbea7c37c93cb5,
    $5f07ce956337ba8b$export$2a0253cb20f48a8,
    $5f07ce956337ba8b$export$f97428bb4b1991ec,
    $5f07ce956337ba8b$export$d6c67e9aab4e2b26,
    $5f07ce956337ba8b$export$3de8c242d2b82f26,
    $5f07ce956337ba8b$export$a01fa44f793dbfac,
    $5f07ce956337ba8b$export$45eaf4204fcc7,
    $5f07ce956337ba8b$export$af57685e201438e8,
    $5f07ce956337ba8b$export$d97d31d934dbb194,
    $5f07ce956337ba8b$export$cafb5bd13b02056b,
    $5f07ce956337ba8b$export$e55c18b809946e72,
    $5f07ce956337ba8b$export$de5640b9ae8140a7,
    $5f07ce956337ba8b$export$540b5c3c4b6ce459,
    $5f07ce956337ba8b$export$6f71dff531ff592,
    $5f07ce956337ba8b$export$83255ab79e45f34f,
    $5f07ce956337ba8b$export$b57d172af9ad7647,
    $5f07ce956337ba8b$export$ff4c933c1fe90b68,
    $5f07ce956337ba8b$export$77071b77e2801b18,
    $5f07ce956337ba8b$export$94ad6507a703f4eb,
    $5f07ce956337ba8b$export$501166b25f254aab,
    $5f07ce956337ba8b$export$be1c522400a1bd7c,
    $5f07ce956337ba8b$export$2aa6e7b6e24a04f5,
    $5f07ce956337ba8b$export$f3b53199b07af2a1,
    $5f07ce956337ba8b$export$d37415ffddcf2142,
    $5f07ce956337ba8b$export$2ae00586da7cb606,
    $5f07ce956337ba8b$export$9c89f946f05d884a,
    $5f07ce956337ba8b$export$20bc3dc137ac1c38,
    $5f07ce956337ba8b$export$b52a7c936684cfc5,
    $5f07ce956337ba8b$export$b5555f24061f9fb,
    $5f07ce956337ba8b$export$ff25449f34b8abf,
    $5f07ce956337ba8b$export$3380e677209260fe,
    $5f07ce956337ba8b$export$b86266e6594a97bb,
    $5f07ce956337ba8b$export$3e2776d61f3662dc,
    $5f07ce956337ba8b$export$2b5f951ad8e70cfe,
    $5f07ce956337ba8b$export$9048315f2c03fd9d,
    $5f07ce956337ba8b$export$a333714599f14a6,
    $5f07ce956337ba8b$export$4145c2cec2da6f9b,
    $5f07ce956337ba8b$export$4957a1ad203cf6dd,
    $5f07ce956337ba8b$export$7a2fcaad1564e6b7,
    $5f07ce956337ba8b$export$190b5dd0a1322552,
    $5f07ce956337ba8b$export$da23b72d32bfad9e,
    $5f07ce956337ba8b$export$4b064659282e0238,
    $5f07ce956337ba8b$export$3ab51851f6d823e,
    $5f07ce956337ba8b$export$e4a1a37a9a1350ad,
    $5f07ce956337ba8b$export$b7f7da5e795f0327,
    $5f07ce956337ba8b$export$80a401c1aa47a377,
    $5f07ce956337ba8b$export$934ac7a251b26dc7,
    $5f07ce956337ba8b$export$4634f6395df3ebbe,
    $5f07ce956337ba8b$export$768fb41107a1e8d7,
    $5f07ce956337ba8b$export$d797a81bace17184,
    $5f07ce956337ba8b$export$746102c94db9df1f,
    $5f07ce956337ba8b$export$5f1efd797d65e349,
    $5f07ce956337ba8b$export$cccc812ccafbf11f,
    $5f07ce956337ba8b$export$64822db87abd8a47,
    $5f07ce956337ba8b$export$64f764d8be495c82,
    $5f07ce956337ba8b$export$24eae23dc1c68bbd,
    $5f07ce956337ba8b$export$50fa92eba6f82feb,
    $5f07ce956337ba8b$export$4155d22fe3f14cd6,
    $5f07ce956337ba8b$export$76813cbead887191,
    $5f07ce956337ba8b$export$90aab2ff89daf770,
    $5f07ce956337ba8b$export$a2bc0cbad2e6e605,
    $5f07ce956337ba8b$export$f90872a1280728bb,
    $5f07ce956337ba8b$export$bce644e96518cbd2,
    $5f07ce956337ba8b$export$241aaebffac0a3e5,
    $5f07ce956337ba8b$export$f9dfc43b5b31c4b7,
    $5f07ce956337ba8b$export$79759e9e62fb9312,
    $5f07ce956337ba8b$export$992d1e0dce255d19,
    $5f07ce956337ba8b$export$d28c1b0e5b3e768,
    $5f07ce956337ba8b$export$ca714ee197bed4ec,
    $5f07ce956337ba8b$export$faae55ceea4b6073,
    $5f07ce956337ba8b$export$200bc24cd120667e,
    $5f07ce956337ba8b$export$a0d784a48b4e886c,
    $5f07ce956337ba8b$export$baf5bd09b4b33b8a,
    $5f07ce956337ba8b$export$4702007eedbca8ab,
    $5f07ce956337ba8b$export$aa9d2d635ea63898,
    $5f07ce956337ba8b$export$2ea449225c1f6cac,
    $5f07ce956337ba8b$export$deb8b557e735e26a,
    $5f07ce956337ba8b$export$d45754df44e4c309,
    $5f07ce956337ba8b$export$78b2913b550edbb,
    $5f07ce956337ba8b$export$71243272608c58ab,
    $5f07ce956337ba8b$export$39a08f215c33bc39,
    $5f07ce956337ba8b$export$d2377f6a6fa3b49c,
    $5f07ce956337ba8b$export$befa8f6533309779,
    $5f07ce956337ba8b$export$736b40db8701ba6c,
    // Tailored onboarding M3
    $5f07ce956337ba8b$export$11eff6ae2f70b67b,
    $5f07ce956337ba8b$export$fb2d23e5315a67a9,
    $5f07ce956337ba8b$export$32e794bb49d60b6,
    $5f07ce956337ba8b$export$fed256238b27db06,
    $5f07ce956337ba8b$export$132eecb4d35a590d,
    $5f07ce956337ba8b$export$2579c51cadd45eca,
    $5f07ce956337ba8b$export$4b1a0cefa966ea0,
    $5f07ce956337ba8b$export$f6558daacc312a65,
    $5f07ce956337ba8b$export$925efa2e24e86b88,
    $5f07ce956337ba8b$export$40454d3e062dcd44
];
const $5f07ce956337ba8b$export$5980f41aa657f9c7 = [
    'SAM1'
];

});


// JWM Background Colour tour
const $d231c4839441ff18$export$eb0b199de90a7ec2 = 'backgroundColorNudge';

parcelRegister("itvQz", function(module, exports) {

let $d733a39467fe46a6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d733a39467fe46a6$var$load("76n7a"),
    $d733a39467fe46a6$var$load("l253H"),
    $d733a39467fe46a6$var$load("bw1yb")
]).then(()=>parcelRequire('8uIuW'));

});


parcelRegister("jpH5a", function(module, exports) {

$parcel$export(module.exports, "VIEW_THEME_PICKER_EXPERIENCE", () => $34fd6f1472f32723$export$9a8c95b97c1ee885);
const $34fd6f1472f32723$export$47a1a20f3722c8ce = {
    experience: 'viewThemePicker',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $34fd6f1472f32723$export$9a8c95b97c1ee885 = {
    experience: 'viewThemePicker',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};

});

parcelRegister("ca7Zi", function(module, exports) {

$parcel$export(module.exports, "useExperienceFail", () => $99088cc1a7014505$export$606da7704d8eaf06);
$parcel$export(module.exports, "ExperienceFailed", () => $99088cc1a7014505$export$ae65a9e09c4516b3);
$parcel$export(module.exports, "ExperienceSuccess", () => $99088cc1a7014505$export$4962f3898bd5c829);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $93jKl = parcelRequire("93jKl");

var $3bQtK = parcelRequire("3bQtK");

var $jJZqs = parcelRequire("jJZqs");
const $99088cc1a7014505$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, teamName: teamName })=>{
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: experience
    });
    const onFail = (0, $5uXOq.useCallback)((location, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, extraAttributes)=>{
        const relevantError = error?.networkError ?? error;
        if (relevantError instanceof (0, $jJZqs.ValidationError) && relevantError.message === '' && relevantError.errors.length) relevantError.message = relevantError.errors[0].error;
        extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
        (0, $jcw0u.default)({
            meta: {
                id: `experience-tracker-${experienceId ?? experience}`,
                packageName: analyticsSource,
                teamName: teamName
            },
            attributes: {
                location: location
            },
            error: relevantError,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail,
        experienceId,
        experience,
        analyticsSource,
        teamName
    ]);
    return onFail;
};
const $99088cc1a7014505$export$ae65a9e09c4516b3 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, error: error, attributes: attributes })=>{
    const onFail = $99088cc1a7014505$export$606da7704d8eaf06(experience);
    (0, $5uXOq.useEffect)(()=>{
        onFail(experience.experience, error, attributes);
    }, [
        attributes,
        error,
        experience,
        onFail
    ]);
    return null;
});
const $99088cc1a7014505$export$4962f3898bd5c829 = /*#__PURE__*/ (0, $5uXOq.memo)(({ experience: experience, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bQtK.ExperienceSuccess), {
        experience: experience.experience,
        attributes: {
            ...experience.experienceId == null ? undefined : {
                experienceId: experience.experienceId
            },
            ...attributes
        }
    }));

});

parcelRegister("lwRIP", function(module, exports) {

$parcel$export(module.exports, "CREATE_CUSTOM_BACKGROUND_EXPERIENCE", () => $9162f72ca6991e19$export$46e0706742711dad);
$parcel$export(module.exports, "UPDATE_ALT_TEXT_EXPERIENCE", () => $9162f72ca6991e19$export$678653f2c10961c5);
$parcel$export(module.exports, "DELETE_CUSTOM_BACKGROUND_EXPERIENCE", () => $9162f72ca6991e19$export$f84f0c56982ddf9a);
$parcel$export(module.exports, "THEME_PICKER_ELEMENT_ID", () => $9162f72ca6991e19$export$8dde8522a4856b87);
const $9162f72ca6991e19$export$91a4460f34f2ee75 = {
    experience: 'createCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$46e0706742711dad = {
    experience: 'createCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$3b5b01b3ae53bee3 = {
    experience: 'updateCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$678653f2c10961c5 = {
    experience: 'updateCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$da5da525dec4b73a = {
    experience: 'deleteCustomBackground',
    packageName: 'jiraBusinessThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$f84f0c56982ddf9a = {
    experience: 'deleteCustomBackground',
    analyticsSource: 'jiraProjectThemeComponents',
    teamName: 'work-management-frontier'
};
const $9162f72ca6991e19$export$8dde8522a4856b87 = 'background-picker-popup-wrapper';

});

parcelRegister("3LH0C", function(module, exports) {

$parcel$export(module.exports, "ThemePickerButtonItem", () => $bf1403620c7d37d2$export$27d1624818d3e0be);

var $5uXOq = parcelRequire("5uXOq");

var $3uzfU = parcelRequire("3uzfU");

var $dmnFy = parcelRequire("dmnFy");

var $kJpBP = parcelRequire("kJpBP");

var $koVbs = parcelRequire("koVbs");

var $eCaG4 = parcelRequire("eCaG4");
const $bf1403620c7d37d2$export$27d1624818d3e0be = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, testId: testId, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmnFy))), {
            label: "",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3uzfU))), {
            label: "",
            LEGACY_size: "medium",
            spacing: "spacious",
            size: "small"
        }),
        onClick: onClick,
        testId: testId,
        isSelected: isSelected,
        ref: ref,
        ...props
    }, formatMessage((0, $eCaG4.default).setProjectBackgroundMenuItem));
}));

});
parcelRegister("dmnFy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7b72e4cfb1948d4b5694556923ff149>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b9fb0a3472b1330$var$_react = $9b9fb0a3472b1330$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9b9fb0a3472b1330$var$_paintBucket = $9b9fb0a3472b1330$var$_interopRequireDefault((parcelRequire("ciYaM")));

var $9b9fb0a3472b1330$var$_backgroundColor = $9b9fb0a3472b1330$var$_interopRequireDefault((parcelRequire("dRNbD")));
function $9b9fb0a3472b1330$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PaintBucketIcon.
 * This component is PaintBucketIcon, with `UNSAFE_fallbackIcon` set to "EditorBackgroundColorIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b9fb0a3472b1330$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $9b9fb0a3472b1330$var$_react.default.createElement($9b9fb0a3472b1330$var$_paintBucket.default, Object.assign({
        LEGACY_fallbackIcon: $9b9fb0a3472b1330$var$_backgroundColor.default
    }, props));
$9b9fb0a3472b1330$var$PaintBucketIcon.Name = 'PaintBucketIconMigration';
var $9b9fb0a3472b1330$var$_default = module.exports.default = $9b9fb0a3472b1330$var$PaintBucketIcon;

});
parcelRegister("ciYaM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83080ad07e1bfea64637edcdcb5973cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f55d7939f8010e4$var$_react = $8f55d7939f8010e4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8f55d7939f8010e4$var$_baseNew = $8f55d7939f8010e4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8f55d7939f8010e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintBucket".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Customize fill color.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f55d7939f8010e4$var$PaintBucketIcon = (props)=>/*#__PURE__*/ $8f55d7939f8010e4$var$_react.default.createElement($8f55d7939f8010e4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.655.095 13.78 8.22a.75.75 0 0 1 0 1.06l-5.616 5.617a2 2 0 0 1-2.828 0L.604 10.164a2 2 0 0 1 0-2.828L5.689 2.25 4.595 1.155zM6.75 3.31 2.06 8h9.38zm4.69 6.19H2.06l4.336 4.335a.5.5 0 0 0 .708 0z" clip-rule="evenodd"/><path fill="currentcolor" d="M14.5 12a.75.75 0 0 0-.654.383v.002l-.003.003-.007.013-.026.046a16 16 0 0 0-.36.695 8 8 0 0 0-.283.642c-.068.176-.167.457-.167.716a1.5 1.5 0 0 0 3 0c0-.259-.1-.54-.167-.716a8 8 0 0 0-.284-.642 16 16 0 0 0-.36-.695l-.025-.046-.007-.013-.002-.004-.001-.001A.75.75 0 0 0 14.5 12"/>`
    }, props));
$8f55d7939f8010e4$var$PaintBucketIcon.displayName = 'PaintBucketIcon';
var $8f55d7939f8010e4$var$_default = module.exports.default = $8f55d7939f8010e4$var$PaintBucketIcon;

});

parcelRegister("dRNbD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a186610b26bee8b1$var$_react = $a186610b26bee8b1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $a186610b26bee8b1$var$_paintBucket = $a186610b26bee8b1$var$_interopRequireDefault((parcelRequire("ciYaM")));
function $a186610b26bee8b1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a186610b26bee8b1$var$EditorBackgroundColorIcon = (props)=>/*#__PURE__*/ $a186610b26bee8b1$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m7.818 12.56 4.243 4.243 4.242-4.242-4.242-4.243zm-1.414 1.415a1.995 1.995 0 0 1 0-2.828l4.243-4.243a1.995 1.995 0 0 1 2.828 0l4.243 4.243c.78.78.786 2.041 0 2.828l-4.243 4.243a1.996 1.996 0 0 1-2.828 0zM6.5 13h11l-5.44 5.218zm2.732-8.925a1 1 0 0 1 1.414 0l3.536 3.536-1.414 1.414L9.232 5.49a1 1 0 0 1 0-1.415M18 16s1.5 2 1.5 3.5c0 1-1 1.5-1.5 1.5s-1.5-.4-1.5-1.5C16.5 18 18 16 18 16"/></svg>`
    }, props, {
        newIcon: $a186610b26bee8b1$var$_paintBucket.default
    }));
$a186610b26bee8b1$var$EditorBackgroundColorIcon.displayName = 'EditorBackgroundColorIcon';
var $a186610b26bee8b1$var$_default = module.exports.default = $a186610b26bee8b1$var$EditorBackgroundColorIcon;

});


parcelRegister("eCaG4", function(module, exports) {

$parcel$export(module.exports, "default", () => $375a1027f7dcdae1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $375a1027f7dcdae1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    setProjectBackgroundMenuItem: {
        "id": "business-theme-components.theme-picker-button-item.set-project-background-menu-item",
        "defaultMessage": "Set project background"
    }
});

});


parcelRegister("gHWtm", function(module, exports) {

$parcel$export(module.exports, "backgroundPickerPopupContentEntryPoint", () => $52bb029027935944$export$e02fb03d7ff1aabe);

var $22q3R = parcelRequire("22q3R");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");
const $52bb029027935944$var$fetchPolicy = 'network-only';

const $52bb029027935944$export$e02fb03d7ff1aabe = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("6lGsN")).then((module)=>module.BackgroundPickerPopupContent), {
        moduleId: "e1737386",
        moduleName: "PopupContent",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectAri: projectAri })=>{
        const popupContentQuery = {
            parameters: (0, $22q3R.default),
            variables: {
                cloudId: cloudId,
                entityId: projectAri,
                durationInSeconds: 900,
                imageCount: 50
            },
            options: {
                fetchPolicy: $52bb029027935944$var$fetchPolicy
            }
        };
        return {
            queries: {
                popupContentQuery: popupContentQuery
            }
        };
    }
});

});
parcelRegister("22q3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $201654d4ad1f249e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<271df4939a3f94b3a679eedb3fe369f3>>
 * @relayHash 6fd96fa79cd88f4daa1afa95da0e618f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a3cdad9d85a286735d160e36b6fc0ee43535f10938f2aeaa4af8baeaabc58549
const $201654d4ad1f249e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a3cdad9d85a286735d160e36b6fc0ee43535f10938f2aeaa4af8baeaabc58549",
        "metadata": {},
        "name": "PopupContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $201654d4ad1f249e$export$2e2bcd8739ae039 = $201654d4ad1f249e$var$node;

});

parcelRegister("6lGsN", function(module, exports) {

let $49f5a4976207582d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $49f5a4976207582d$var$load("kNFvF"),
    $49f5a4976207582d$var$load("80Kqm")
]).then(()=>parcelRequire('97vnf'));

});


parcelRegister("9yzIq", function(module, exports) {

$parcel$export(module.exports, "ThemePickerSkeleton", () => $828cc9a1e99f3131$export$c3dc17aa42c33254);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");
const $828cc9a1e99f3131$export$c3dc17aa42c33254 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $828cc9a1e99f3131$var$skeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    }));
const $828cc9a1e99f3131$var$skeletonStyles = (0, $8CUq3.xcss)({
    width: '346px',
    height: '240px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});


parcelRegister("a2e2Q", function(module, exports) {

$parcel$export(module.exports, "useSoftwareProjectTheming", () => $376b82e4729cc4d4$export$4c26676caf6bb553);

var $lODMY = parcelRequire("lODMY");

var $dAfqg = parcelRequire("dAfqg");

var $2vSU6 = parcelRequire("2vSU6");

var $lmBAt = parcelRequire("lmBAt");

var $86GR9 = parcelRequire("86GR9");
const $376b82e4729cc4d4$export$c4b7ea2942f2d0e = (0, $lODMY.createRouterSelector)((state)=>state.route.name);
const $376b82e4729cc4d4$export$4c26676caf6bb553 = ()=>{
    if (!(0, $lmBAt.getIsSoftwareThemingEnabled)()) return {
        hasSoftwareTheming: false,
        isSoftwareFullTheming: false,
        isSoftwareProject: false
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: projectData } = (0, $dAfqg.useProjectContext)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const currentRoute = $376b82e4729cc4d4$export$c4b7ea2942f2d0e();
    const isSoftwareProject = projectData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    // temporarily disable theming for calendar
    // the logic matches with the one in src/packages/platform/project-theme/page-container/src/controllers/project-theme/index.tsx
    const isSoftwareCalendarRoute = currentRoute === 'software-calendar' || currentRoute === 'software-calendar-classic';
    const hasSoftwareTheming = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? isSoftwareProject && (0, $86GR9.SOFTWARE_THEME_ROUTES_M2).includes(currentRoute) : isSoftwareProject && (0, $86GR9.SOFTWARE_THEME_ROUTES).includes(currentRoute) && !isSoftwareCalendarRoute;
    const isSoftwareFullTheming = (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? hasSoftwareTheming && (0, $86GR9.SOFTWARE_FULL_THEME_ROUTES_M2).includes(currentRoute) : hasSoftwareTheming && (0, $86GR9.SOFTWARE_FULL_THEME_ROUTES).includes(currentRoute);
    return {
        hasSoftwareTheming: hasSoftwareTheming,
        isSoftwareFullTheming: isSoftwareFullTheming,
        isSoftwareProject: isSoftwareProject
    };
};

});
parcelRegister("86GR9", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_FULL_THEME_ROUTES", () => $ef531902bffb6540$export$891915f6cf3ec6e7);
$parcel$export(module.exports, "SOFTWARE_FULL_THEME_ROUTES_M2", () => $ef531902bffb6540$export$1c7e7f18d2f498fe);
$parcel$export(module.exports, "SOFTWARE_THEME_ROUTES", () => $ef531902bffb6540$export$4edc7739f219df7c);
$parcel$export(module.exports, "SOFTWARE_THEME_ROUTES_M2", () => $ef531902bffb6540$export$587ac1561f46cfdc);
const $ef531902bffb6540$export$671a416a5ddfe0ea = [
    'issue',
    'software-backlog',
    'rapidboard-backlog',
    'software-timeline',
    'software-timeline-classic',
    'software-issue-navigator',
    'issue-navigator-classic'
];
const $ef531902bffb6540$export$891915f6cf3ec6e7 = [
    'software-boards',
    'rapidboard-board',
    'software-calendar',
    'software-calendar-classic',
    'software-list',
    'software-list-classic',
    'software-summary',
    'software-summary-classic'
];
const $ef531902bffb6540$export$1c7e7f18d2f498fe = [
    'software-boards',
    'rapidboard-board',
    'software-calendar',
    'software-calendar-classic',
    'software-list',
    'software-list-classic',
    'software-summary',
    'software-summary-classic',
    'software-backlog',
    'rapidboard-backlog',
    'project-pages',
    'software-form-classic',
    'software-form',
    'software-form-builder-classic',
    'software-form-builder'
];
const $ef531902bffb6540$export$4edc7739f219df7c = [
    ...$ef531902bffb6540$export$671a416a5ddfe0ea,
    ...$ef531902bffb6540$export$891915f6cf3ec6e7
];
const $ef531902bffb6540$export$587ac1561f46cfdc = [
    ...$ef531902bffb6540$export$671a416a5ddfe0ea,
    ...$ef531902bffb6540$export$1c7e7f18d2f498fe
];

});


parcelRegister("2IzXv", function(module, exports) {

$parcel$export(module.exports, "useRenameProject", () => $7ed15a1d5fe6d0a8$export$b7c373d314ddf2d4);

var $dJaJK = parcelRequire("dJaJK");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kV9ss = parcelRequire("kV9ss");

var $cbTlr = parcelRequire("cbTlr");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $iJZ8l = parcelRequire("iJZ8l");

var $9F7ed = parcelRequire("9F7ed");
const $7ed15a1d5fe6d0a8$export$b7c373d314ddf2d4 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $dJaJK.default));
    const updateProjectName = (0, $5uXOq.useCallback)((projectId, name)=>{
        if (!projectId) return;
        const newName = name.trim();
        const nameUpdater = (store)=>{
            const ari = (0, $kV9ss.JiraProjectAri).create({
                siteId: cloudId,
                projectId: String(projectId)
            });
            const relayDataId = (0, $iJZ8l.default)({
                id: ari
            }, 'JiraProject');
            if (!relayDataId) return;
            const project = store.get(relayDataId);
            if (project) project.setValue(newName, 'name');
        };
        commitMutation({
            variables: {
                cloudId: cloudId,
                projectIdOrKey: String(projectId),
                name: newName
            },
            optimisticUpdater: nameUpdater,
            updater: (store, response)=>{
                if (response?.jira?.updateProjectName?.success) nameUpdater(store);
            },
            onCompleted: (response)=>{
                const { success: success, errors: errors } = response?.jira?.updateProjectName ?? {};
                const error = errors?.find((e)=>e.message);
                if (success) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectName updated');
                else if (error) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectName update failed', {
                    error: error
                });
            }
        });
    }, [
        commitMutation,
        cloudId,
        createAnalyticsEvent
    ]);
    const validate = async (title, newValue)=>{
        try {
            const { errors: errors } = await (0, $cbTlr.get)('', newValue);
            if (errors.projectName) {
                // There's an error if the value is being updated to an existing project
                // name, but we can skip this if the value is the current project name
                if (newValue === title) return undefined;
                return errors.projectName;
            }
            return undefined;
        } catch  {
            return formatMessage((0, $9F7ed.default).updateProjectNameError);
        }
    };
    return {
        updateProjectName: updateProjectName,
        validateProjectName: validate
    };
};

});
parcelRegister("dJaJK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aaf8f415dbd862d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<32f9a62e16ee97abad9b6bce0f869388>>
 * @relayHash 8c9db70971a948f9ab739dd426a6a254
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8a78e8e6a76a67b8b61e1768b5930f5d44cac440c88d67026b4869d026d70386
const $5aaf8f415dbd862d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "name"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "name",
                    "variableName": "name"
                },
                {
                    "kind": "Variable",
                    "name": "projectIdOrKey",
                    "variableName": "projectIdOrKey"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v7 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "renameProjectMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectUpdateNameMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateProjectName",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "renameProjectMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProjectUpdateNameMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateProjectName",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8a78e8e6a76a67b8b61e1768b5930f5d44cac440c88d67026b4869d026d70386",
            "metadata": {},
            "name": "renameProjectMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$5aaf8f415dbd862d$var$node.hash = "4eb2a9d3f2e1dbb64dd9331c62625de5";
var $5aaf8f415dbd862d$export$2e2bcd8739ae039 = $5aaf8f415dbd862d$var$node;

});

parcelRegister("cbTlr", function(module, exports) {

$parcel$export(module.exports, "constructEndpoint", () => $e9cd8f4f70921922$export$a5b7a8c3b1c6e775);
$parcel$export(module.exports, "get", () => $e9cd8f4f70921922$export$3988ae62b71be9a3);

var $eusud = parcelRequire("eusud");
const $e9cd8f4f70921922$export$a5b7a8c3b1c6e775 = (baseUrl, projectName)=>`/rest/simplified/latest/project/validate?projectName=${encodeURIComponent(projectName)}`;
const $e9cd8f4f70921922$export$3988ae62b71be9a3 = (baseUrl, projectKey, abortSignal)=>{
    const url = $e9cd8f4f70921922$export$a5b7a8c3b1c6e775(baseUrl, projectKey);
    return (0, $eusud.performGetRequest)(url, {
        signal: abortSignal
    });
};

});

parcelRegister("9F7ed", function(module, exports) {

$parcel$export(module.exports, "default", () => $6672c219cbb24069$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6672c219cbb24069$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    updateProjectNameError: {
        "id": "horizontal-nav-common.services.rename-project.update-project-name-error",
        "defaultMessage": "We couldn't update your project name. Try again."
    }
});

});


parcelRegister("4DmRP", function(module, exports) {

$parcel$export(module.exports, "default", () => $67664dfa27d6cde7$export$2e2bcd8739ae039);

var $5TjxH = parcelRequire("5TjxH");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9IFFl = parcelRequire("9IFFl");

var $dN3HT = parcelRequire("dN3HT");
const $67664dfa27d6cde7$var$ProjectAvatar = ({ projectRef: projectRef })=>{
    const data = (0, $8Uumt.useFragment)((0, $5TjxH.default), projectRef);
    if (data?.projectType === 'BUSINESS') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dN3HT.NavigationKitAvatarPopup), {
        canEdit: data?.canEditProjectConfig?.canPerform ?? false,
        projectId: Number(data?.projectId),
        selectedAvatarUrl: data?.avatar?.large ?? ''
    });
    if (!data.avatar) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9IFFl.ProjectIcon), {
        src: `${data.avatar.large}?size=xlarge`,
        alt: "",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "horizontal-nav.ui.content.project-avatar",
        "data-vc": "jira-horizontal-nav-project-icon"
    });
};
var $67664dfa27d6cde7$export$2e2bcd8739ae039 = $67664dfa27d6cde7$var$ProjectAvatar;

});
parcelRegister("5TjxH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b3dcb1e1e6b610c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<08604d5776b50fb6002cfdeffab34bbc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6b3dcb1e1e6b610c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ProjectAvatar",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "large"
                }
            ]
        },
        {
            "alias": "canEditProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        }
    ],
    "type": "JiraProject"
};
$6b3dcb1e1e6b610c$var$node.hash = "bf24cf4ceac2f687267bc6a885231cc1";
var $6b3dcb1e1e6b610c$export$2e2bcd8739ae039 = $6b3dcb1e1e6b610c$var$node;

});

parcelRegister("dN3HT", function(module, exports) {

$parcel$export(module.exports, "NavigationKitAvatarPopup", () => $7260ed61cff550ef$export$500ef2645bac918e);

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koVbs = parcelRequire("koVbs");

var $9KMcd = parcelRequire("9KMcd");

var $jgJNO = parcelRequire("jgJNO");

var $ccste = parcelRequire("ccste");

var $aEzXU = parcelRequire("aEzXU");
const $7260ed61cff550ef$export$500ef2645bac918e = ({ canEdit: canEdit, projectId: projectId, selectedAvatarUrl: selectedAvatarUrl })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onAvatarClick = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(true);
    }, [
        setIsOpen
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const selectedAvatarId = Number(selectedAvatarUrl.substring(selectedAvatarUrl.lastIndexOf('/') + 1));
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $aEzXU.navigationKitAvatarPopupContentEntrypoint), {});
    const entrypointTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onClose,
            projectId: projectId,
            selectedAvatarId: selectedAvatarId,
            selectedAvatarUrl: selectedAvatarUrl
        }), [
        onClose,
        projectId,
        selectedAvatarId,
        selectedAvatarUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        messageId: "horizontal-nav.ui.content.header.project-header.project-avatar.navigation-kit-avatar-popup.jira-popup.popup",
        messageType: "transactional",
        placement: "bottom-start",
        role: "dialog",
        label: formatMessage((0, $ccste.default).title),
        isOpen: isOpen,
        onClose: onClose,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                id: "navigation-kit-avatar.popup-content",
                packageName: "jiraNavigationKitAvatarPopupContent",
                entryPointReferenceSubject: entryPointReferenceSubject,
                runtimeProps: runtimeProps
            }),
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
                ref: entrypointTrigger
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9KMcd.EditableAvatar), {
                avatarUrl: selectedAvatarUrl,
                canEdit: canEdit,
                onClick: onAvatarClick,
                triggerProps: triggerProps
            }));
        }
    });
};

});
parcelRegister("9KMcd", function(module, exports) {

$parcel$export(module.exports, "EditableAvatar", () => $7f651364a7a8bfa5$export$fd3a492e0b2eddae);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $1ywCO = parcelRequire("1ywCO");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $9IFFl = parcelRequire("9IFFl");

var $9nJ5Z = parcelRequire("9nJ5Z");
const $7f651364a7a8bfa5$var$EditIconWithTransparentBackground = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7f651364a7a8bfa5$var$iconBackgroundStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1ywCO))), {
        label: "",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }));
const $7f651364a7a8bfa5$var$ProjectAvatar = ({ src: src, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9IFFl.ProjectIcon), {
        "data-testid": testId && `${testId}--image`,
        "data-vc": "editable-avatar-project",
        src: src,
        alt: ""
    });
const $7f651364a7a8bfa5$export$fd3a492e0b2eddae = (props)=>{
    const { avatarUrl: avatarUrl, canEdit: canEdit, triggerProps: triggerProps = {}, onClick: onClick } = props;
    const [isHover, setIsHover] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false)
    }, canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $9nJ5Z.default).editIconLabel),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $7f651364a7a8bfa5$var$editableAvatarContainerStyles
        }, isHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $7f651364a7a8bfa5$var$iconButtonWrapperStyles,
            ...tooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            appearance: "subtle",
            icon: $7f651364a7a8bfa5$var$EditIconWithTransparentBackground,
            label: formatMessage((0, $9nJ5Z.default).editIconLabel),
            spacing: "compact",
            ...triggerProps,
            onClick: onClick
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7f651364a7a8bfa5$var$ProjectAvatar, {
            src: avatarUrl ? `${avatarUrl}?size=xlarge` : avatarUrl,
            testId: "navigation-apps-sidebar-inline-config-project-header.ui.editable-avatar.project-icon-editable"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7f651364a7a8bfa5$var$ProjectAvatar, {
        src: avatarUrl ? `${avatarUrl}?size=xlarge` : avatarUrl,
        testId: "navigation-apps-sidebar-inline-config-project-header.ui.editable-avatar.project-icon"
    })));
};
const $7f651364a7a8bfa5$var$iconBackgroundStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.pressed',
    borderRadius: '2px'
});
const $7f651364a7a8bfa5$var$editableAvatarContainerStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});
const $7f651364a7a8bfa5$var$iconButtonWrapperStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    zIndex: 'card',
    left: "var(--ds-space-negative-025, -2px)",
    top: "var(--ds-space-negative-025, -2px)"
});

});
parcelRegister("1ywCO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8d8183d86255e266d89dc1fd99bbc4dd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $122246161208ff48$var$_react = $122246161208ff48$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $122246161208ff48$var$_edit = $122246161208ff48$var$_interopRequireDefault((parcelRequire("5nRKm")));

var $122246161208ff48$var$_editFilled = $122246161208ff48$var$_interopRequireDefault((parcelRequire("avBcG")));
function $122246161208ff48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $122246161208ff48$var$EditIcon = (props)=>/*#__PURE__*/ $122246161208ff48$var$_react.default.createElement($122246161208ff48$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $122246161208ff48$var$_editFilled.default
    }, props));
$122246161208ff48$var$EditIcon.Name = 'EditIconMigration';
var $122246161208ff48$var$_default = module.exports.default = $122246161208ff48$var$EditIcon;

});
parcelRegister("5nRKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3eb8cab3ab465b93$var$_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb8cab3ab465b93$var$EditIcon = (props)=>/*#__PURE__*/ $3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;

});

parcelRegister("avBcG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a69a877f42e31b8$var$_react = $7a69a877f42e31b8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7a69a877f42e31b8$var$_edit = $7a69a877f42e31b8$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $7a69a877f42e31b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a69a877f42e31b8$var$EditFilledIcon = (props)=>/*#__PURE__*/ $7a69a877f42e31b8$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $7a69a877f42e31b8$var$_edit.default
    }));
$7a69a877f42e31b8$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $7a69a877f42e31b8$var$_default = module.exports.default = $7a69a877f42e31b8$var$EditFilledIcon;

});


parcelRegister("9nJ5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $51c30433ca2f8a3a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $51c30433ca2f8a3a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editIconLabel: {
        "id": "navigation-apps-sidebar-inline-config-project-header.editable-avatar.edit-icon-label",
        "defaultMessage": "Edit project icon"
    }
});

});


parcelRegister("ccste", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9146bab84326dfb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d9146bab84326dfb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "navigation-kit-avatar.title",
        "defaultMessage": "Select an avatar"
    },
    close: {
        "id": "navigation-kit-avatar.close",
        "defaultMessage": "Close avatar selection"
    },
    error: {
        "id": "navigation-kit-avatar.error",
        "defaultMessage": "Error updating project avatar."
    },
    cancelUpload: {
        "id": "navigation-kit-avatar.cancel-upload",
        "defaultMessage": "Cancel"
    },
    submitUpload: {
        "id": "navigation-kit-avatar.submit-upload",
        "defaultMessage": "Submit"
    },
    uploadImageErrorMessage: {
        "id": "navigation-kit-avatar.upload-image-error-message",
        "defaultMessage": "We couldn't upload the image. Check your connection and try again."
    },
    updateAvatarErrorMessage: {
        "id": "navigation-kit-avatar.update-avatar-error-message",
        "defaultMessage": "We couldn't save the changes. Check your connection and try again."
    },
    imageUrlInvalidError: {
        "id": "navigation-kit-avatar.image-url-invalid-error",
        "defaultMessage": "Could not load image, the url is invalid."
    },
    imageFormatInvalidError: {
        "id": "navigation-kit-avatar.image-format-invalid-error",
        "defaultMessage": "Could not load image, the format is invalid."
    },
    imageSizeTooLargeError: {
        "id": "navigation-kit-avatar.image-size-too-large-error",
        "defaultMessage": "Image is too large, must be no larger than {MAX_SIZE_MB}Mb"
    },
    selectImageToUploadOrDragAndDrop: {
        "id": "navigation-kit-avatar.select-image-to-upload-or-drag-and-drop",
        "defaultMessage": "<link>Select an image to upload</link> or drag and drop it here"
    }
});

});

parcelRegister("aEzXU", function(module, exports) {

$parcel$export(module.exports, "navigationKitAvatarPopupContentEntrypoint", () => $9fb8f38fe799294e$export$6c49070d2ac14f7c);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $9fb8f38fe799294e$export$6c49070d2ac14f7c = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("5zAAt")).then((module)=>module.NavigationKitAvatarPopupContentEntryPoint), {
        moduleId: "48abd2fb",
        moduleName: "NavigationKitAvatarPopupContent",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5zAAt", function(module, exports) {

let $40ec9a153d878281$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $40ec9a153d878281$var$load("76n7a"),
    $40ec9a153d878281$var$load("l253H"),
    $40ec9a153d878281$var$load("ffQaD"),
    $40ec9a153d878281$var$load("kvRbA"),
    $40ec9a153d878281$var$load("kNFvF"),
    $40ec9a153d878281$var$load("DT4aI")
]).then(()=>parcelRequire('7rm6U'));

});





parcelRegister("4VBHB", function(module, exports) {

$parcel$export(module.exports, "UserBoardHeader", () => $37b9529943499b75$export$adc7514276e418cb);

var $bgCb0 = parcelRequire("bgCb0");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $eC0BO = parcelRequire("eC0BO");

var $9FHy9 = parcelRequire("9FHy9");

var $Bvv5R = parcelRequire("Bvv5R");
const $37b9529943499b75$export$adc7514276e418cb = ({ boardFragment: boardFragment })=>{
    const boardData = (0, $8Uumt.useFragment)((0, $bgCb0.default), boardFragment);
    const extraComponentsFar = (0, $5uXOq.useMemo)(()=>{
        const board = {
            id: boardData.boardId,
            name: boardData.name,
            type: boardData.boardType === 'SCRUM' ? 'scrum' : 'kanban',
            isProjectBoard: false
        };
        const components = [];
        if ((0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) components.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Bvv5R.HeaderFullscreenButton), {
            key: "fullscreen"
        }));
        components.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FHy9.ShareButton), {
            key: "share",
            data: board
        }));
        return components;
    }, [
        boardData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eC0BO.default), {
        testId: "horizontal-nav-header.ui.user-board-header",
        title: boardData.name,
        extraComponentsClose: [],
        extraComponentsFar: extraComponentsFar
    });
};

});
parcelRegister("bgCb0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6f01c9de42ceb21$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<daca393877d4cdc54117aeb3cb333c2f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e6f01c9de42ceb21$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "UserBoardHeader_board",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "boardId"
            },
            "action": "THROW",
            "path": "boardId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "boardType"
            },
            "action": "THROW",
            "path": "boardType"
        }
    ],
    "type": "JiraBoard"
};
$e6f01c9de42ceb21$var$node.hash = "8e9eefe98b582988ed6ecfcea8baeeac";
var $e6f01c9de42ceb21$export$2e2bcd8739ae039 = $e6f01c9de42ceb21$var$node;

});



parcelRegister("inpPZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff0fd34946c90537$export$2e2bcd8739ae039);
/* NavWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bgrar = parcelRequire("bgrar");
var $8CUq3 = parcelRequire("8CUq3");

var $8Ec39 = parcelRequire("8Ec39");

var $5NiYd = parcelRequire("5NiYd");

var $6cG4N = parcelRequire("6cG4N");

var $g7crU = parcelRequire("g7crU");

var $4R6GH = parcelRequire("4R6GH");

var $7CMCs = parcelRequire("7CMCs");
const $ff0fd34946c90537$var$NavWrapper = ({ children: children })=>{
    const [isFullscreen] = (0, $g7crU.useIsFullscreen)();
    return /*#__PURE__*/ $5uXOq.createElement((0, $8Ec39.default), {
        name: "jira-horizontal-nav"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $7CMCs.JSErrorBoundary), {
        id: "HorizontalNavErrorBoundary",
        packageName: "jiraHorizontalNav",
        fallback: (0, $5NiYd.HorizontalNavSkeleton)
    }, /*#__PURE__*/ $5uXOq.createElement("header", {
        id: "ak-project-view-navigation",
        "data-testid": "horizontal-nav.ui.content.horizontal-nav",
        ...(0, $4R6GH.fg)('horizontal_nav_ssr_placeholder_attrs') ? false ? {
            'data-ssr-placeholder': 'project-view-navigation'
        } : {
            'data-ssr-placeholder-replace': 'project-view-navigation'
        } : {},
        className: (0, $bwpsq.default)([
            !(0, $4R6GH.fg)('bugfix_stacking_context_of_navigation') && "_11q71iew _vchhusvi _18k9ad7r",
            (0, $4R6GH.fg)('bugfix_stacking_context_of_navigation') && "_11q71iew _vchhusvi _kqswh2mm _1kt9f705 _1cs8stnw _kfgt1osq _1mp41osq _m9csad7r _1aukidpf _qnecidpf"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $bgrar.default), {
        gap: "space.050",
        alignItems: "end",
        xcss: [
            $ff0fd34946c90537$var$contentStyles,
            !isFullscreen && $ff0fd34946c90537$var$minHeightStyle,
            (0, $4R6GH.fg)('bugfix_stacking_context_of_navigation') && $ff0fd34946c90537$var$relativePositionStyle
        ]
    }, children))));
};
var $ff0fd34946c90537$export$2e2bcd8739ae039 = $ff0fd34946c90537$var$NavWrapper;
const $ff0fd34946c90537$var$minHeightStyle = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    minHeight: `${(0, $6cG4N.NAV4_HORIZONTAL_NAV_HEIGHT)}px`
});
const $ff0fd34946c90537$var$contentStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.150'
});
const $ff0fd34946c90537$var$headerStyles = null;
const $ff0fd34946c90537$var$headerStylesOld = null;
const $ff0fd34946c90537$var$relativePositionStyle = (0, $8CUq3.xcss)({
    position: 'relative'
});

});

parcelRegister("jPgWz", function(module, exports) {

$parcel$export(module.exports, "default", () => $07f2eb1c78758048$export$2e2bcd8739ae039);

var $5dQAY = parcelRequire("5dQAY");

var $gR1iK = parcelRequire("gR1iK");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $c9Ur7 = parcelRequire("c9Ur7");

var $5NiYd = parcelRequire("5NiYd");

var $bJYvM = parcelRequire("bJYvM");

var $pa9q9 = parcelRequire("pa9q9");


var $7UhxN = parcelRequire("7UhxN");

var $k1ALc = parcelRequire("k1ALc");



var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $iqMDF = parcelRequire("iqMDF");

var $2DNQF = parcelRequire("2DNQF");

var $5Ha3o = parcelRequire("5Ha3o");

var $3hiNj = parcelRequire("3hiNj");

var $aQoCL = parcelRequire("aQoCL");
const $07f2eb1c78758048$var$TabsContent = ({ queryFragment: queryFragment, projectFragment: projectFragment = null })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $gR1iK.default), queryFragment);
    const projectData = (0, $8Uumt.useFragment)((0, $5dQAY.default), projectFragment);
    const { data: shortcutsData, loading: loading } = (0, $7UhxN.useShortcutsData)();
    const handleError = (0, $5uXOq.useCallback)((error)=>{
        const statusCode = error && 'statusCode' in error ? Number(error.statusCode) : 0;
        const flagDetails = (0, $2DNQF.getFlagDetails)(statusCode);
        (0, $pa9q9.showFlag)(flagDetails);
        if ((0, $bJYvM.HANDLED_STATUS_CODES).includes(statusCode)) return;
        throw error;
    }, []);
    const containerNavigation = data.jira.containerNavigation?.__typename === 'JiraContainerNavigation' ? data.jira.containerNavigation : null;
    const navigationItems = containerNavigation ? containerNavigation?.navigationItems : null;
    (0, $5uXOq.useEffect)(()=>{
        const containerNavigationQueryError = data.jira.containerNavigation?.__typename === 'QueryError' ? data.jira.containerNavigation : null;
        if (navigationItems?.errors && navigationItems?.errors?.length > 0) {
            const error = navigationItems.errors[0];
            handleError(new (0, $c9Ur7.QueryError)(error));
        } else if (containerNavigationQueryError) handleError(new (0, $c9Ur7.QueryError)(containerNavigationQueryError));
        else if (navigationItems?.edges == null) handleError(new Error('navigationItems.edges failed to load'));
    }, [
        containerNavigation?.navigationItems,
        data,
        handleError,
        navigationItems?.edges,
        navigationItems?.errors
    ]);
    const attributes = (0, $5uXOq.useMemo)(()=>({
            projectType: (projectData?.projectType ?? '').toLowerCase(),
            navigationContainer: (0, $68cb678dc917978e$export$f1c9dd0f5207dd5e),
            navigationLayer: (0, $ce9c0831aed9ffb3$export$33d8c916a600c5e9),
            tabIds: navigationItems?.edges?.map((edge)=>edge?.node?.id) ?? []
        }), [
        projectData?.projectType,
        navigationItems?.edges
    ]);
    const renderWithTab = (0, $5uXOq.useCallback)((tabData)=>tabData.typeKey === 'PAGES' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ha3o.PagesSpotlightEntrypointContainer), {
            tabData: tabData
        }) : null, []);
    return containerNavigation && navigationItems && !navigationItems.errors && navigationItems?.edges ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "horizontalNavJiraTabsContent",
        containerType: (0, $5da7873a71c45b64$export$fe791c4fa892e400),
        containerId: projectData?.projectId ?? '',
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1ALc.ShortcutsContainer), {
        data: shortcutsData,
        loading: loading,
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iqMDF.ContainerNavigationTabs), {
        containerFragment: data.jira.containerNavigation,
        tabsDescriptor: (0, $3hiNj.JIRA_TABS),
        label: formatMessage((0, $aQoCL.default).projectNavigation),
        renderWithTab: renderWithTab
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        key: projectData?.projectId ?? ''
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5NiYd.TabsSkeleton), null);
};
var $07f2eb1c78758048$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($07f2eb1c78758048$var$TabsContent);

});
parcelRegister("5dQAY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70b2fdb44f41a91$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39573effa1e570b3c0fd3e77351ee0aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d70b2fdb44f41a91$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TabsContent_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        }
    ],
    "type": "JiraProject"
};
$d70b2fdb44f41a91$var$node.hash = "abf520acd7725543508b669e38084bfa";
var $d70b2fdb44f41a91$export$2e2bcd8739ae039 = $d70b2fdb44f41a91$var$node;

});

parcelRegister("gR1iK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ee72a00e43d51bd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7b0a007f5bf10cbd113fda096d9d1392>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3ee72a00e43d51bd$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "containerNavigationInput"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "name": "TabsContent_query",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "input",
                                        "variableName": "containerNavigationInput"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "containerNavigation",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ContainerNavigationTabs_container"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "first",
                                                        "variableName": "first"
                                                    }
                                                ],
                                                "concreteType": "JiraNavigationItemConnection",
                                                "kind": "LinkedField",
                                                "name": "navigationItems",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraNavigationItemEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "kind": "ScalarField",
                                                                                "name": "id"
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.containerNavigation.navigationItems.edges.node.id"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "jira.containerNavigation.navigationItems.edges.node"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "errors",
                                                        "plural": true,
                                                        "selections": v1 /*: any*/ 
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "JiraContainerNavigation"
                                    },
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v1 /*: any*/ ,
                                        "type": "QueryError"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.containerNavigation"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$3ee72a00e43d51bd$var$node.hash = "b84967efe9fe4129379add71246146c1";
var $3ee72a00e43d51bd$export$2e2bcd8739ae039 = $3ee72a00e43d51bd$var$node;

});

parcelRegister("c9Ur7", function(module, exports) {

$parcel$export(module.exports, "QueryError", () => $835bdf2aa5daa049$export$83dcbdfe8cbc1e17);
const $835bdf2aa5daa049$export$f215947b3d76a6b7 = 'QueryError';
class $835bdf2aa5daa049$export$83dcbdfe8cbc1e17 extends Error {
    constructor(payload){
        super(payload.message ?? undefined);
        this.extensions = payload.extensions;
        this.message = payload.message ?? '';
        this.statusCode = payload.extensions?.[0]?.statusCode ?? -1;
    }
}

});

parcelRegister("bJYvM", function(module, exports) {

$parcel$export(module.exports, "VIEW_JIRA_HORIZONTAL_NAVIGATION_EXPERIENCE", () => $def0ba677e839891$export$416a2d57dd33ec31);
$parcel$export(module.exports, "HANDLED_STATUS_CODES", () => $def0ba677e839891$export$ad73a344b1bd5415);
const $def0ba677e839891$export$416a2d57dd33ec31 = {
    experience: 'viewHorizontalNavigation',
    analyticsSource: 'jiraHorizontalNav'
};
const $def0ba677e839891$export$ad73a344b1bd5415 = [
    401,
    403,
    404
];

});

// TopNav or sidebar
const $ce9c0831aed9ffb3$export$17ff3f7e02c6ac22 = 'global';
const $ce9c0831aed9ffb3$export$33d8c916a600c5e9 = 'container';

parcelRegister("7UhxN", function(module, exports) {

$parcel$export(module.exports, "useShortcutsData", () => $799685b63be28a3b$export$47d387d66bf16cb);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $iEUaw = parcelRequire("iEUaw");

var $324W5 = parcelRequire("324W5");

var $5hv0u = parcelRequire("5hv0u");

var $89Akw = parcelRequire("89Akw");
const $799685b63be28a3b$var$transformShortcutsMemo = (0, $8QpSo.default)((a, b)=>(0, $89Akw.transformShortcuts)(a, b));
const $799685b63be28a3b$var$emptyData = [];
const $799685b63be28a3b$export$47d387d66bf16cb = (customContext)=>{
    const canEdit = (0, $5hv0u.useCanEditShortcuts)(customContext);
    const { data: data, loading: loading, error: error } = (0, $324W5.useResourceWithCustomRouterContext)((0, $iEUaw.staticSidebarShortcutsResource), customContext);
    const items = (0, $5uXOq.useMemo)(()=>data && $799685b63be28a3b$var$transformShortcutsMemo(data, canEdit), [
        data,
        canEdit
    ]); // canEdit should be the same for all shortcuts per person, per project
    return {
        data: items || $799685b63be28a3b$var$emptyData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("5hv0u", function(module, exports) {

$parcel$export(module.exports, "useCanEditShortcuts", () => $e888d8394c5baf80$export$cf4f3a9f01fdc8a7);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $dhuBw = parcelRequire("dhuBw");
const $e888d8394c5baf80$export$cf4f3a9f01fdc8a7 = (customContext)=>{
    const { data: data } = (0, $1J3t1.useProjectSidebarNavigation)(customContext);
    return (0, $5uXOq.useMemo)(()=>data && (0, $dhuBw.getCanEditShortcuts)(data), [
        data
    ]) || false;
};

});
parcelRegister("dhuBw", function(module, exports) {

$parcel$export(module.exports, "getCanEditShortcuts", () => $050e711b4fac24d4$export$c64b03ccce2c3de);
const $050e711b4fac24d4$var$isProjectOrJiraAdmin = (permissionInfo)=>permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS || false;
const $050e711b4fac24d4$export$c64b03ccce2c3de = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraWorkManagementNavData.permissionInfo) : false;
        case 'jira_software':
            return jiraSoftwareNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraSoftwareNavData.permissionInfo) : false;
        case 'jira_service_management':
            return jiraServiceManagementNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraServiceManagementNavData.permissionInfo) : false;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraProductDiscoveryNavData.permissionInfo) : false;
        case null:
            return false;
        default:
            return false;
    }
};

});


parcelRegister("89Akw", function(module, exports) {

$parcel$export(module.exports, "transformShortcuts", () => $c195049077f99f76$export$1fc4378e3ea910d0);
const $c195049077f99f76$var$getShortcutIcon = (type)=>{
    if (type == null || type === 'unknown' || type === 'unsupported') return 'shortcut';
    if (type === 'github') return 'repos';
    return type;
};
const $c195049077f99f76$export$1fc4378e3ea910d0 = (arrayOfShortcuts, canEditOld)=>{
    if (arrayOfShortcuts && Array.isArray(arrayOfShortcuts)) {
        const links = [];
        const repos = [];
        arrayOfShortcuts.forEach((shortcut)=>{
            const shortcutIcon = $c195049077f99f76$var$getShortcutIcon(shortcut.dvcsType);
            const s = {
                id: shortcut.type == null ? `com.atlassian.jira.jira-projects-plugin:project.shortcut.default.link.${shortcut.id}` : `com.atlassian.jira.jira-projects-plugin:${shortcut.type}.${shortcut.id}`,
                name: shortcut.name,
                icon: shortcutIcon,
                url: shortcut.url,
                selected: false,
                section: false,
                separator: false,
                showDot: false,
                hasLandingPage: false,
                canEdit: canEditOld,
                showSync: false,
                canDismiss: false,
                sortable: false,
                target: '_blank'
            };
            shortcut.type === 'source.code.link' ? repos.push(s) : links.push(s);
        });
        return repos.concat(links);
    }
    return [];
};

});


parcelRegister("k1ALc", function(module, exports) {

$parcel$export(module.exports, "ShortcutsContainer", () => $6885b5bf730cd03e$export$df449cf702d8e0fd);
$parcel$export(module.exports, "useShortcutItems", () => $6885b5bf730cd03e$export$2c1990af0fa688a3);

var $5uXOq = parcelRequire("5uXOq");

var $7paD5 = parcelRequire("7paD5");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4bqWq = parcelRequire("4bqWq");
const $6885b5bf730cd03e$var$renderShortcutIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
        spacing: "spacious",
        label: "shortcut"
    });
const $6885b5bf730cd03e$export$fb9705de59d96855 = (item)=>({ setState: setState, getState: getState })=>{
        const { shortcutType: shortcutType } = item;
        const state = getState();
        const index = state.data.map((i)=>i.shortcutType).lastIndexOf(shortcutType);
        const newItem = {
            before: $6885b5bf730cd03e$var$renderShortcutIcon,
            ...item,
            target: '_blank',
            canEdit: true,
            itemType: 'shortcut'
        };
        // Append new item to same shortcuts group
        if (index === -1) // @ts-expect-error - TS2322 - Type 'ShortcutItem | { target: string; canEdit: boolean; itemType: string; before: ComponentType<Record<any, any>> | (() => Element); href?: string | undefined; ... 7 more ...; text?: string | undefined; }' is not assignable to type 'ShortcutItem'. | TS2322 - Type '{ target: string; canEdit: boolean; itemType: string; before: React.ComponentType<Record<any, any>> | (() => JSX.Element); href?: string | undefined; icon?: string | undefined; ... 6 more ...; text?: string | undefined; }' is not assignable to type 'ShortcutItem'.
        setState({
            data: [
                ...state.data,
                newItem
            ]
        });
        else setState({
            // @ts-expect-error - TS2322 - Type '(ShortcutItem | { target: string; canEdit: boolean; itemType: string; before: ComponentType<Record<any, any>> | (() => Element); href?: string | undefined; ... 7 more ...; text?: string | undefined; })[]' is not assignable to type 'ShortcutItem[]'.
            data: [
                ...state.data.slice(0, index + 1),
                newItem,
                ...state.data.slice(index + 1)
            ]
        });
    };
const $6885b5bf730cd03e$export$8d8542dbbc23fe1a = (id)=>({ setState: setState, getState: getState })=>{
        const { data: data } = getState();
        const newItems = data.filter((existingItem)=>existingItem.id !== id);
        setState({
            data: newItems
        });
    };
const $6885b5bf730cd03e$export$60832f4899fbf6a1 = (item)=>({ setState: setState, getState: getState })=>{
        const { data: data } = getState();
        const newItems = data.map((existingItem)=>existingItem.id !== item.id ? existingItem : item);
        setState({
            data: newItems
        });
    };
const $6885b5bf730cd03e$export$8c896bccb18e1db1 = (items)=>({ setState: setState, getState: getState })=>{
        if (!items.length) return;
        const { data: data } = getState();
        const newItems = data.map((existingItem)=>items.find((item)=>item.id === existingItem.id) || existingItem);
        setState({
            data: newItems
        });
    };
const $6885b5bf730cd03e$export$ed2a7beca2c9674 = (data, loading)=>({ setState: setState, getState: getState })=>{
        const items = (data || []).map((0, $4bqWq.getItemFromLink));
        const state = getState();
        return setState({
            ...state,
            loading: loading,
            data: items,
            oldData: items,
            isLoaded: true
        });
    };
const $6885b5bf730cd03e$export$e324594224ef24da = {
    addItem: $6885b5bf730cd03e$export$fb9705de59d96855,
    deleteItem: $6885b5bf730cd03e$export$8d8542dbbc23fe1a,
    editItem: $6885b5bf730cd03e$export$60832f4899fbf6a1,
    editItems: $6885b5bf730cd03e$export$8c896bccb18e1db1,
    updateContainer: $6885b5bf730cd03e$export$ed2a7beca2c9674
};
const $6885b5bf730cd03e$export$d4c72bab9d6cc13a = {
    data: [],
    oldData: null,
    loading: false,
    isLoaded: false
};
/**
 * Instance
 */ const $6885b5bf730cd03e$var$Store = (0, $iXqE5.createStore)({
    name: 'shortcuts',
    initialState: $6885b5bf730cd03e$export$d4c72bab9d6cc13a,
    actions: $6885b5bf730cd03e$export$e324594224ef24da
});
var $6885b5bf730cd03e$export$2e2bcd8739ae039 = $6885b5bf730cd03e$var$Store;
const $6885b5bf730cd03e$export$df449cf702d8e0fd = (0, $gg7kZ.createContainer)($6885b5bf730cd03e$var$Store, {
    onInit: ()=>({ dispatch: dispatch }, { data: data, loading: loading })=>{
            dispatch($6885b5bf730cd03e$export$e324594224ef24da.updateContainer(data, loading));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { data: data, loading: loading })=>{
            dispatch($6885b5bf730cd03e$export$e324594224ef24da.updateContainer(data, loading));
        }
});
const $6885b5bf730cd03e$export$2c1990af0fa688a3 = (0, $3sQ5x.createHook)($6885b5bf730cd03e$var$Store);

});
parcelRegister("4bqWq", function(module, exports) {

$parcel$export(module.exports, "getItemFromLink", () => $5f237ed4c010c05c$export$60d4c4ef6da272ad);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $ixUGT = parcelRequire("ixUGT");

var $hYfgW = parcelRequire("hYfgW");

var $7Jlas = parcelRequire("7Jlas");

var $17Ngn = parcelRequire("17Ngn");

var $letJZ = parcelRequire("letJZ");
const $5f237ed4c010c05c$var$getLinkParts = (linkId)=>linkId.split(':')[1].split('.');
// @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
const $5f237ed4c010c05c$var$SizedBitBucketIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $letJZ.BitbucketIcon), {
        ...props,
        size: "small"
    });
const $5f237ed4c010c05c$export$16b26cd5e98d9100 = (iconName)=>{
    switch(iconName){
        case 'bitbucket':
            return $5f237ed4c010c05c$var$SizedBitBucketIcon;
        case 'github':
        case 'repos':
            // @ts-expect-error - TS2322 - Type 'typeof default' is not assignable to type 'ComponentType<GlyphProps | Props | (Pick<GlyphProps, "testId" | "primaryColor" | "secondaryColor"> & Partial<Pick<GlyphProps, "label" | "size">> & Partial<...>) | (Pick<...> & ... 1 more ... & Partial<...>)>'.
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($7Jlas));
        default:
            // @ts-expect-error - TS2322 - Type 'typeof default' is not assignable to type 'ComponentType<GlyphProps | Props | (Pick<GlyphProps, "testId" | "primaryColor" | "secondaryColor"> & Partial<Pick<GlyphProps, "label" | "size">> & Partial<...>) | (Pick<...> & ... 1 more ... & Partial<...>)>'.
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($17Ngn));
    }
};
const $5f237ed4c010c05c$export$3cec694c50bc695d = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($5f237ed4c010c05c$var$getLinkParts(linkId));
const $5f237ed4c010c05c$export$d37d2882f5261346 = (linkId)=>linkId;
const $5f237ed4c010c05c$export$92a97f8239a551c5 = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($ixUGT)))($5f237ed4c010c05c$var$getLinkParts(linkId)).join('.');
const $5f237ed4c010c05c$export$60d4c4ef6da272ad = (link)=>{
    const { id: linkId, icon: icon } = link;
    const id = $5f237ed4c010c05c$export$3cec694c50bc695d(linkId);
    const shortcutType = $5f237ed4c010c05c$export$92a97f8239a551c5(linkId);
    const target = link.target ?? '_blank';
    const Icon = $5f237ed4c010c05c$export$16b26cd5e98d9100(icon);
    return {
        id: id,
        icon: icon,
        legacyId: linkId,
        target: target,
        shortcutType: shortcutType,
        text: link.name,
        before: Icon,
        href: link.url,
        canEdit: link.canEdit,
        showSync: link.showSync,
        itemType: 'shortcut'
    };
};

});
parcelRegister("ixUGT", function(module, exports) {

var $dM3Z8 = parcelRequire("dM3Z8");
/**
 * Gets all but the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.initial([1, 2, 3]);
 * // => [1, 2]
 */ function $d80748aee2c24c33$var$initial(array) {
    var length = array == null ? 0 : array.length;
    return length ? $dM3Z8(array, 0, -1) : [];
}
module.exports = $d80748aee2c24c33$var$initial;

});

parcelRegister("7Jlas", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a0d27d0abcfe15c$var$_react = $5a0d27d0abcfe15c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5a0d27d0abcfe15c$var$_angleBrackets = $5a0d27d0abcfe15c$var$_interopRequireDefault((parcelRequire("jSlaY")));
function $5a0d27d0abcfe15c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5a0d27d0abcfe15c$var$BitbucketReposIcon = (props)=>/*#__PURE__*/ $5a0d27d0abcfe15c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 5v14h14V5zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/><path d="M9.23 8.31 6.3 11.26a1.06 1.06 0 0 0 0 1.48l2.93 2.96a1.03 1.03 0 0 0 1.47 0 1.05 1.05 0 0 0 0-1.48L8.5 12l2.2-2.22a1.05 1.05 0 0 0 0-1.48 1.02 1.02 0 0 0-.73-.3c-.27 0-.53.1-.73.31m4.06 0a1.05 1.05 0 0 0 0 1.48L15.5 12l-2.2 2.22a1.05 1.05 0 0 0 0 1.48c.4.41 1.06.41 1.46 0l2.93-2.95a1.05 1.05 0 0 0 0-1.48l-2.93-2.96a1.03 1.03 0 0 0-1.46 0"/></g></svg>`
    }, props, {
        newIcon: $5a0d27d0abcfe15c$var$_angleBrackets.default
    }));
$5a0d27d0abcfe15c$var$BitbucketReposIcon.displayName = 'BitbucketReposIcon';
var $5a0d27d0abcfe15c$var$_default = module.exports.default = $5a0d27d0abcfe15c$var$BitbucketReposIcon;

});
parcelRegister("jSlaY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7837c8d7e1becd0$var$_react = $e7837c8d7e1becd0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e7837c8d7e1becd0$var$_baseNew = $e7837c8d7e1becd0$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e7837c8d7e1becd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e7837c8d7e1becd0$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $e7837c8d7e1becd0$var$_react.default.createElement($e7837c8d7e1becd0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$e7837c8d7e1becd0$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $e7837c8d7e1becd0$var$_default = module.exports.default = $e7837c8d7e1becd0$var$AngleBracketsIcon;

});




const $5da7873a71c45b64$export$fe791c4fa892e400 = 'project';
const $5da7873a71c45b64$export$b83d0ee9325a2d0a = 'projectTitle';

parcelRegister("iqMDF", function(module, exports) {

$parcel$export(module.exports, "ContainerNavigationTabs", () => $2073bb46d233bc8a$export$90f95fd237a475b3);

var $g1Isn = parcelRequire("g1Isn");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $lODMY = parcelRequire("lODMY");
var $lVJAU = parcelRequire("lVJAU");

var $goodq = parcelRequire("goodq");

var $585q9 = parcelRequire("585q9");
var $8mXqE = parcelRequire("8mXqE");

var $7z86O = parcelRequire("7z86O");

var $bYbah = parcelRequire("bYbah");

var $cUcEa = parcelRequire("cUcEa");

var $4R6GH = parcelRequire("4R6GH");

var $fFClA = parcelRequire("fFClA");

var $5QXyw = parcelRequire("5QXyw");
const $2073bb46d233bc8a$export$45d76561a5302f2b = (0, $lODMY.createRouterSelector)((state)=>state.location);
/**
 * The logic in this hook determines the selected tab in the horizontal navigation and
 * redirects the user to the not found page if the selected tab is not found.
 *
 * There are a few caveats to this logic:
 * - We do not want to redirect to the not found page if the user is on the browse page.
 * - We do not want to redirect to the not found page if the user just removed the tab
 *   they were on and redirection to the default tab is yet to happen.
 *
 * For this reason, we only recalculate the selected tab id when the route or the navigation container has changed.
 */ const $2073bb46d233bc8a$var$useSelectedTabId = (containerData)=>{
    const prevUrl = (0, $5uXOq.useRef)(null);
    const { replace: replace } = (0, $lVJAU.useRouterActions)();
    const location = $2073bb46d233bc8a$export$45d76561a5302f2b();
    const currentUrl = (0, $4R6GH.fg)('blu-7656-personal-boards-decode-url') ? decodeURIComponent(location.pathname) + location.search : location.pathname + location.search;
    const selectedTabIdRef = (0, $5uXOq.useRef)(null);
    const notFoundUrl = `${containerData.scopeUrl}/not-found`;
    // if the current URL or the container has changed, reset the selected tab id
    if (prevUrl.current !== currentUrl) {
        selectedTabIdRef.current = null;
        prevUrl.current = currentUrl;
    }
    // if the selected tab id hasn't been set yet, try to find it
    if (selectedTabIdRef.current == null && containerData?.navigationItems?.edges && location.pathname !== notFoundUrl) {
        let fullMatchResult = null;
        let partialMatchResult = null;
        const sortedItems = containerData.navigationItems.edges.flatMap((edge)=>{
            const url = edge?.node.url;
            if (!url) return [];
            const id = edge.node.id;
            const item = {
                url: url,
                id: id
            };
            // consider URLs of nested apps
            if (edge.node.typeKey === 'APP') {
                const sections = edge.node.sections;
                if (sections) {
                    const appItems = [];
                    sections.forEach((section)=>{
                        section?.links?.forEach((link)=>{
                            if (link?.url) appItems.push({
                                url: link.url,
                                id: id
                            });
                        });
                    });
                    return [
                        item,
                        ...appItems
                    ];
                }
            }
            return item;
        }).sort((a, b)=>{
            if (!a.url || !b.url) return 0;
            return a.url.length - b.url.length;
        });
        const legacySelectedItem = new URLSearchParams(location.search).get('selectedItem');
        // check for matches of the tab url with the current url
        for (const item of sortedItems){
            // in case of legacy pages, we only check for the selectedItem query param
            if (legacySelectedItem) {
                const itemQueryParams = new URLSearchParams(item.url.split('?')[1]);
                if (itemQueryParams.get('selectedItem') === legacySelectedItem) {
                    fullMatchResult = item.id;
                    break;
                }
                continue;
            }
            // if the url is a full match, return straight away
            if (item.url === currentUrl) {
                fullMatchResult = item.id;
                break;
            }
            // if the start of the path matches, store the id and continue checking
            if (item.url && currentUrl.startsWith(item.url)) partialMatchResult = item.id;
        }
        selectedTabIdRef.current = fullMatchResult ?? partialMatchResult;
    }
    const selectedTabId = selectedTabIdRef.current;
    const shouldRedirectToNotFound = !selectedTabId && location.pathname !== notFoundUrl && !location.pathname.startsWith('/browse/');
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRedirectToNotFound) replace(notFoundUrl);
    }, [
        shouldRedirectToNotFound,
        notFoundUrl,
        replace
    ]);
    return selectedTabId;
};
const $2073bb46d233bc8a$export$90f95fd237a475b3 = ({ containerFragment: containerFragment, tabsDescriptor: tabsDescriptor, label: label, renderWithTab: renderWithTab })=>{
    const [itemWithRename, setItemWithRename] = (0, $5uXOq.useState)(null);
    const tabListRef = (0, $5uXOq.useRef)(null);
    const containerData = (0, $8Uumt.useFragment)((0, $g1Isn.default), containerFragment);
    const selectedTabId = $2073bb46d233bc8a$var$useSelectedTabId(containerData);
    const onAddItem = (0, $5uXOq.useCallback)(({ id: id, typeKey: typeKey })=>{
        if (typeKey === 'APP' || !containerData?.navigationItems?.edges) // ignore apps
        return;
        // check whether there is already a tab with the same typeKey
        const hasItemOfType = containerData.navigationItems.edges.some((edge)=>edge?.node.typeKey === typeKey);
        // if an item with the same typeKey already exists, trigger the rename form for it
        if (hasItemOfType) setItemWithRename(id);
    }, [
        containerData?.navigationItems?.edges
    ]);
    const { tabsAndIds: tabsAndIds, droppableTabs: droppableTabs } = (0, $5uXOq.useMemo)(()=>{
        const tabs = Array.from(containerData?.navigationItems?.edges ?? []).filter(Boolean);
        const tabElements = tabs?.map((edge, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: edge.node.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5QXyw.NavigationItemTab), {
                position: index,
                tabFragment: edge.node,
                containerFragment: containerData,
                beforeItemId: index === 0 ? null : tabs[index - 1]?.node?.id,
                afterItemId: index === tabs.length - 1 ? null : tabs[index + 1]?.node?.id,
                tabsDescriptor: tabsDescriptor,
                isRenaming: edge.node.id === itemWithRename,
                onRenamingChange: (isRenaming)=>setItemWithRename(isRenaming ? edge.node.id : null)
            }), renderWithTab?.(edge.node)));
        return {
            tabsAndIds: tabs?.map((edge, index)=>({
                    id: edge?.node?.id,
                    tab: tabElements[index]
                })) ?? [],
            droppableTabs: tabs.map((tab)=>({
                    id: tab.node.id,
                    typeKey: tab.node.typeKey,
                    appId: tab.node.appId,
                    dataId: tab.node.__id
                }))
        };
    }, [
        containerData,
        itemWithRename,
        tabsDescriptor,
        renderWithTab
    ]);
    (0, $fFClA.useDroppableTabList)(droppableTabs, containerData.id ?? '', containerData.scopeId ?? '');
    const projectNavigationId = (0, $8mXqE.useSkipLinkId)();
    (0, $585q9.useSkipLink)(projectNavigationId, label, 3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYbah.TabShortcutsContextProvider), {
        navigationName: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $goodq.TabListWithAnalytics), {
        id: projectNavigationId,
        ref: tabListRef,
        label: label,
        addTab: containerData.canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
            name: "container-navigation-tabs-add-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7z86O.default), {
            containerFragment: containerData,
            tabsDescriptor: tabsDescriptor,
            onAddItem: onAddItem
        })),
        selectedTabId: selectedTabId,
        tabs: tabsAndIds
    }), containerData.canEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cUcEa.SavedViewsOnboardingInitializer), null));
};

});
parcelRegister("g1Isn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f3a7d8a6d923ba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9474c50d6dcef05bf6e97ec35f61d531>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f4f3a7d8a6d923ba$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "name": "ContainerNavigationTabs_container",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "NavigationItemTab_container"
            },
            {
                "kind": "FragmentSpread",
                "name": "AddTab_container"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": v0 /*: any*/ ,
                        "action": "THROW",
                        "path": "id"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "canEdit"
                        },
                        "action": "THROW",
                        "path": "canEdit"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "scopeUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "scopeId"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "first",
                                "variableName": "first"
                            }
                        ],
                        "concreteType": "JiraNavigationItemConnection",
                        "kind": "LinkedField",
                        "name": "navigationItems",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraNavigationItemEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "navigationItems.edges.node.id"
                                                },
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "typeKey"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "appId"
                                                        },
                                                        {
                                                            "concreteType": "JiraAppSection",
                                                            "kind": "LinkedField",
                                                            "name": "sections",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                    "kind": "LinkedField",
                                                                    "name": "links",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v1 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraAppNavigationItem"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "NavigationItemTab_tab"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "navigationItems.edges.node"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraContainerNavigation"
            }
        ],
        "type": "JiraContainerNavigationResult",
        "abstractKey": "__isJiraContainerNavigationResult"
    };
}();
$f4f3a7d8a6d923ba$var$node.hash = "109e1b7e3cf26fe989509a4a6ab41afc";
var $f4f3a7d8a6d923ba$export$2e2bcd8739ae039 = $f4f3a7d8a6d923ba$var$node;

});

parcelRegister("goodq", function(module, exports) {

$parcel$export(module.exports, "TabListWithAnalytics", () => $e8ac0b46fbab5182$export$3bb2a319997eb2f8);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $byTKd = parcelRequire("byTKd");




var $3F9p6 = parcelRequire("3F9p6");

var $7nzVS = parcelRequire("7nzVS");

var $6Lyip = parcelRequire("6Lyip");

var $5NM6P = parcelRequire("5NM6P");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $e8ac0b46fbab5182$export$3bb2a319997eb2f8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ addTab: addTab, id: id, label: label, selectedTabId: selectedTabId, tabs: tabs }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const triggerAnalytics = (0, $byTKd.useNavigationItemAnalyticsWithContext)({
        itemType: 'more',
        navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
        stage: (0, $3F9p6.getNav4Rollout)().stage,
        navigationLayer: (0, $ce9c0831aed9ffb3$export$33d8c916a600c5e9),
        navigationContainer: (0, $68cb678dc917978e$export$f1c9dd0f5207dd5e),
        isInMore: false
    });
    const onMoreClick = (0, $5uXOq.useCallback)(({ overflowingTabCount: overflowingTabCount })=>{
        triggerAnalytics({
            childCount: overflowingTabCount
        });
    }, [
        triggerAnalytics
    ]);
    const onMoreContentChanged = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(({ overflowingTabIds: overflowingTabIds, visibleTabIds: visibleTabIds })=>{
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'horizontalNavJiraTabsContent changed', {
                hiddenTabIds: overflowingTabIds,
                visibleTabIds: visibleTabIds
            });
        }, 300), [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lyip.OnboardingSpotlightMaybe), {
        spotlight: (0, $5NM6P.Nav4OnboardingComponentNames).TAB_NAV_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7nzVS.default), {
        addTab: addTab,
        id: id,
        label: label,
        onMoreClick: onMoreClick,
        onMoreContentChanged: onMoreContentChanged,
        ref: ref,
        selectedTabId: selectedTabId,
        tabs: tabs
    }));
});

});
parcelRegister("byTKd", function(module, exports) {

$parcel$export(module.exports, "useNavigationItemAnalyticsWithContext", () => $5d900e51da8fced2$export$38dbad9cfa07995);
$parcel$export(module.exports, "useNavigationItemAnalytics", () => $5d900e51da8fced2$export$444d136efe970fd3);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $5d900e51da8fced2$export$38dbad9cfa07995 = (analytics)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((context)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        const { childCount: childCount } = context ?? {};
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'projectNavigationTab', {
            ...analytics,
            childCount: childCount ?? analytics.childCount
        });
    }, [
        analytics,
        createAnalyticsEvent
    ]);
};
const $5d900e51da8fced2$export$444d136efe970fd3 = (analytics)=>{
    const triggerAnalytics = $5d900e51da8fced2$export$38dbad9cfa07995(analytics);
    return (0, $5uXOq.useCallback)(()=>{
        triggerAnalytics();
    }, [
        triggerAnalytics
    ]);
};

});

const $1520d876660a71bd$export$d2aa6c54a5925f01 = 'v3';
const $1520d876660a71bd$export$2bd315ece9f68967 = 'v4';

parcelRegister("3F9p6", function(module, exports) {

$parcel$export(module.exports, "getNav4Rollout", () => $826ce4e4d6cfd68d$export$84a05d3b37ec5d2);

var $9glig = parcelRequire("9glig");

var $cxSdl = parcelRequire("cxSdl");

var $hMlwW = parcelRequire("hMlwW");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7qZOo = parcelRequire("7qZOo");

var $hUCm2 = parcelRequire("hUCm2");

var $8O1QZ = parcelRequire("8O1QZ");

var $32Frn = parcelRequire("32Frn");

var $laQnH = parcelRequire("laQnH");
const $826ce4e4d6cfd68d$export$84a05d3b37ec5d2 = (0, (/*@__PURE__*/$parcel$interopDefault($9glig)))([
    [
        ()=>!(0, $4R6GH.fg)('jira_nav4'),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_NONE))
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding'),
        (0, $8O1QZ.getNav4RolloutForDogfooding)
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_eap'),
        (0, $32Frn.getNav4RolloutForEap)
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_beta_existing-customers'),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('existing-customers')
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_beta_sandboxes'),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('sandboxes')
    ],
    [
        ()=>(0, $6s1PB.expVal)('jira_nav4_beta_free-customers', 'willShowNav4', false),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('free-customers')
    ],
    [
        ()=>(0, $6s1PB.expVal)('jira_nav4_beta_new-customers', 'willShowNav4', false),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('new-customers')
    ],
    [
        ()=>(0, $6s1PB.expVal)('confluence_jira_nav4_new_customers', 'willShowNav4', false),
        (0, $hUCm2.getNav4RolloutForBetaCohort)('new-customers-x')
    ],
    // Break up cond for easier testing.
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($hMlwW))),
        (0, $laQnH.getNav4RolloutForGaAndBeyond)
    ]
]);

});
parcelRegister("7qZOo", function(module, exports) {

$parcel$export(module.exports, "NAV4_ROLLOUT_NONE", () => $92928f70e02753a5$export$3b602cac1f385c06);
$parcel$export(module.exports, "NAV4_ROLLOUT_MOBILE", () => $92928f70e02753a5$export$e748a16828d2f61f);
const $92928f70e02753a5$export$3b602cac1f385c06 = {
    stage: 'none'
};
const $92928f70e02753a5$export$e748a16828d2f61f = {
    stage: 'mobile'
};

});

parcelRegister("hUCm2", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForBetaCohort", () => $8194d49fe31934aa$export$d0b7d7e3a8d0a0c9);

var $1i1R1 = parcelRequire("1i1R1");
const $8194d49fe31934aa$export$d0b7d7e3a8d0a0c9 = (cohort)=>()=>cohort !== 'existing-customers' ? {
            stage: 'beta',
            cohort: cohort
        } : {
            stage: 'beta',
            cohort: cohort,
            isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
        };

});

parcelRegister("8O1QZ", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForDogfooding", () => $48ac6742e168ff29$export$f1e751a9a9d68fb5);

var $9glig = parcelRequire("9glig");

var $hMlwW = parcelRequire("hMlwW");

var $4R6GH = parcelRequire("4R6GH");

var $1i1R1 = parcelRequire("1i1R1");
const $48ac6742e168ff29$var$dogfoodingPhase = (phase)=>()=>phase !== 3 ? {
            stage: 'dogfooding',
            phase: phase,
            isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
        } : {
            stage: 'dogfooding',
            phase: phase
        };
const $48ac6742e168ff29$export$f1e751a9a9d68fb5 = (0, (/*@__PURE__*/$parcel$interopDefault($9glig)))([
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding_phase-2'),
        $48ac6742e168ff29$var$dogfoodingPhase(2)
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_dogfooding_phase-1'),
        $48ac6742e168ff29$var$dogfoodingPhase(1)
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($hMlwW))),
        $48ac6742e168ff29$var$dogfoodingPhase(3)
    ]
]);

});

parcelRegister("32Frn", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForEap", () => $d3197687d5551826$export$42dd8c002a342b8);

var $1i1R1 = parcelRequire("1i1R1");
const $d3197687d5551826$export$42dd8c002a342b8 = ()=>({
        stage: 'eap',
        isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
    });

});

parcelRegister("laQnH", function(module, exports) {

$parcel$export(module.exports, "getNav4RolloutForGaAndBeyond", () => $8c7cc40a2449f7a7$export$99bed161b1040362);

var $9glig = parcelRequire("9glig");

var $cxSdl = parcelRequire("cxSdl");

var $hMlwW = parcelRequire("hMlwW");

var $4R6GH = parcelRequire("4R6GH");

var $c0dQj = parcelRequire("c0dQj");

var $1i1R1 = parcelRequire("1i1R1");

var $7qZOo = parcelRequire("7qZOo");
const $8c7cc40a2449f7a7$export$99bed161b1040362 = (0, (/*@__PURE__*/$parcel$interopDefault($9glig)))([
    // Later GA phases eclipse earlier phases.
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-3'),
        ()=>({
                stage: 'ga',
                phase: 3
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-2'),
        ()=>({
                stage: 'ga',
                phase: 2,
                isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-1-5'),
        ()=>({
                stage: 'ga',
                phase: 1.5,
                isAdmin: (0, $1i1R1.getIsAdmin)(),
                isTenantOptOut: (0, $1i1R1.getIsNav4TenantOptOut)(),
                isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_phase-1'),
        ()=>({
                stage: 'ga',
                phase: 1,
                isAdmin: (0, $1i1R1.getIsAdmin)(),
                isTenantOptIn: (0, $1i1R1.getIsNav4TenantOptIn)(),
                isUserOptIn: (0, $1i1R1.getIsNav4UserOptIn)(),
                isUserOptOut: (0, $1i1R1.getIsNav4UserOptOut)()
            })
    ],
    [
        ()=>(0, $4R6GH.fg)('jira_nav4_ga_sandboxes'),
        ()=>({
                stage: 'ga',
                cohort: 'sandboxes',
                isUserOptIn: (0, $1i1R1.getIsNav4UserOptIn)()
            })
    ],
    [
        ()=>(0, $c0dQj.isMobileAndInMvpOrExistingUsersExperiment)(),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_MOBILE))
    ],
    [
        (0, (/*@__PURE__*/$parcel$interopDefault($hMlwW))),
        (0, (/*@__PURE__*/$parcel$interopDefault($cxSdl)))((0, $7qZOo.NAV4_ROLLOUT_NONE))
    ]
]);

});


parcelRegister("7nzVS", function(module, exports) {

$parcel$export(module.exports, "default", () => $abb2a2838602fbd0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $3Du7S = parcelRequire("3Du7S");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");


var $1WfM5 = parcelRequire("1WfM5");

var $d6ekp = parcelRequire("d6ekp");

var $7qDUa = parcelRequire("7qDUa");

var $abm80 = parcelRequire("abm80");

var $8ndnW = parcelRequire("8ndnW");
const $abb2a2838602fbd0$var$calculateOverflowTabs = (tabContainer, showMoreButton, selectedTabIndex)=>{
    const overflowTabs = new Set();
    if (tabContainer.current == null) return overflowTabs;
    // All the tabs fit in the container, no need to calculate overflow.
    if (tabContainer.current.scrollWidth <= tabContainer.current.offsetWidth) return overflowTabs;
    // Show the more button as it takes up space in the tab list. This ensures we
    // calculate the tab container width correctly below.
    const resetMoreButtonStyles = showMoreButton();
    // Calculate the tab container width by subtracting padding from the tab container offset width.
    const tabContainerComputedStyle = window.getComputedStyle(tabContainer.current);
    const tabContainerPadding = parseFloat(tabContainerComputedStyle.paddingLeft) + parseFloat(tabContainerComputedStyle.paddingRight);
    const tabContainerWidth = tabContainer.current.offsetWidth - tabContainerPadding;
    const tabs = tabContainer.current.children;
    const selectedTabWidth = tabs[selectedTabIndex]?.offsetWidth || 0;
    const selectedTabGap = selectedTabIndex === -1 ? 0 : (0, $5b25b2eb4e8be764$export$b61e6f89a9db76de);
    const availableWidth = tabContainerWidth - selectedTabWidth - selectedTabGap;
    let tabsWidth = 0;
    let gapCount = 0;
    for(let i = 0; i < tabs.length; i++){
        // Skip the selected tab, as it should always be visible. Its width and gap are already accounted for above.
        if (i === selectedTabIndex) continue;
        tabsWidth += tabs[i].offsetWidth;
        if (tabsWidth > availableWidth - (0, $5b25b2eb4e8be764$export$b61e6f89a9db76de) * gapCount) overflowTabs.add(i);
        gapCount++;
    }
    resetMoreButtonStyles();
    return overflowTabs;
};
const $abb2a2838602fbd0$var$initialOverflowState = {
    mustRecalculateOverflowTabs: false,
    overflowTabs: new Set(),
    overflowedTabs: new Set()
};
const $abb2a2838602fbd0$var$overflowReducer = (state, action)=>{
    switch(action.type){
        case 'SET_MUST_RECALCULATE':
            return {
                ...state,
                mustRecalculateOverflowTabs: true,
                overflowTabs: new Set()
            };
        case 'SET_OVERFLOW_TABS':
            return {
                ...state,
                mustRecalculateOverflowTabs: false,
                overflowTabs: action.payload,
                overflowedTabs: new Set([
                    ...state.overflowedTabs,
                    ...action.payload
                ])
            };
        default:
            return state;
    }
};
const $abb2a2838602fbd0$var$TabList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ addTab: addTab, id: id, label: label, onMoreClick: onMoreClick, onMoreContentChanged: onMoreContentChanged = ()=>{}, selectedTabId: selectedTabId, tabs: tabs }, ref)=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $5uXOq.useState)(false);
    const navRef = (0, $5uXOq.useRef)(null);
    const internalTabContainerRef = (0, $5uXOq.useRef)(null);
    const tabContainerRef = (0, $3Du7S.useMergeRefs)([
        ref,
        internalTabContainerRef
    ]);
    const moreButtonWrapperRef = (0, $5uXOq.useRef)(null);
    const [{ mustRecalculateOverflowTabs: mustRecalculateOverflowTabs, overflowTabs: overflowTabs, overflowedTabs: overflowedTabs }, dispatch] = (0, $5uXOq.useReducer)($abb2a2838602fbd0$var$overflowReducer, $abb2a2838602fbd0$var$initialOverflowState);
    const selectedTabIndex = tabs.findIndex(({ id: id })=>id === selectedTabId);
    const overflowingTabCount = overflowTabs.size;
    const hasOverflowTabs = overflowingTabCount > 0;
    const debouncedCalculateOverflowTabs = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            dispatch({
                type: 'SET_MUST_RECALCULATE'
            });
        }, 300, {
            leading: true
        }), []);
    (0, $5uXOq.useLayoutEffect)(()=>{
        debouncedCalculateOverflowTabs();
    }, [
        debouncedCalculateOverflowTabs,
        selectedTabId,
        tabs
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (mustRecalculateOverflowTabs) {
            const showMoreButton = ()=>{
                if (moreButtonWrapperRef.current != null) moreButtonWrapperRef.current.style.display = 'block';
                return ()=>{
                    if (moreButtonWrapperRef.current != null) moreButtonWrapperRef.current.removeAttribute('style');
                };
            };
            dispatch({
                type: 'SET_OVERFLOW_TABS',
                payload: $abb2a2838602fbd0$var$calculateOverflowTabs(internalTabContainerRef, showMoreButton, selectedTabIndex)
            });
        }
    }, [
        mustRecalculateOverflowTabs,
        selectedTabIndex
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        const resizeObserver = new ResizeObserver(debouncedCalculateOverflowTabs);
        if (navRef.current) resizeObserver.observe(navRef.current);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        debouncedCalculateOverflowTabs
    ]);
    const onMoreTabClick = (0, $5uXOq.useCallback)(()=>{
        setIsMoreOpen((prev)=>!prev);
        if (onMoreClick) onMoreClick({
            overflowingTabCount: overflowingTabCount
        });
    }, [
        onMoreClick,
        overflowingTabCount
    ]);
    const { overflowingTabs: overflowingTabs, overflowingTabIds: overflowingTabIds, visibleTabs: visibleTabs, visibleTabIds: visibleTabIds } = (0, $5uXOq.useMemo)(()=>{
        const visibleTabs = [];
        const overflowingTabs = [];
        const overflowingTabIds = [];
        const visibleTabIds = [];
        tabs.forEach(({ tab: tab, id: id }, index)=>{
            const tabContent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1WfM5.TabProvider), {
                id: id,
                isOverflowing: overflowTabs.has(index),
                hasOverflowed: overflowedTabs.has(index),
                isSelected: id === selectedTabId,
                children: tab
            }, id);
            if (overflowTabs.has(index)) {
                overflowingTabs.push(tabContent);
                overflowingTabIds.push(id);
            } else {
                visibleTabs.push(tabContent);
                visibleTabIds.push(id);
            }
        });
        return {
            overflowingTabs: overflowingTabs,
            overflowingTabIds: overflowingTabIds,
            visibleTabs: visibleTabs,
            visibleTabIds: visibleTabIds
        };
    }, [
        overflowedTabs,
        overflowTabs,
        selectedTabId,
        tabs
    ]);
    // overflowingTabIds flickers between empty and non-empty array
    // therefore using useDeferredValue to un-flicker the value as well as JSON.stringify
    // to ensure the effect is triggered based on the value of overflowingTabIds and not the reference.
    const overflowingTabIdsStr = (0, $5uXOq.useDeferredValue)(JSON.stringify(overflowingTabIds));
    (0, $5uXOq.useEffect)(()=>{
        onMoreContentChanged({
            overflowingTabIds: overflowingTabIds,
            visibleTabIds: visibleTabIds
        });
    }, [
        overflowingTabIdsStr
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const closeMore = (0, $5uXOq.useCallback)(()=>setIsMoreOpen(false), []);
    const renderPopupContent = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $abm80.MoreMenuContents), {
            close: closeMore,
            selectedTabId: selectedTabId,
            children: overflowingTabs
        });
    }, [
        closeMore,
        overflowingTabs,
        selectedTabId
    ]);
    const renderPopupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: moreButtonWrapperRef,
            className: (0, $bwpsq.default)([
                $abb2a2838602fbd0$var$styles.moreButtonWrapper,
                !hasOverflowTabs && $abb2a2838602fbd0$var$styles.moreButtonWrapperHidden
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8ndnW.MoreTrigger), {
                onClick: onMoreTabClick,
                count: overflowingTabCount,
                ...triggerProps,
                isOpen: isMoreOpen
            })
        }), [
        hasOverflowTabs,
        isMoreOpen,
        onMoreTabClick,
        overflowingTabCount
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $d6ekp.default), {
        id: id,
        ref: navRef,
        label: label,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7qDUa.default), {
                ref: tabContainerRef,
                children: visibleTabs
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
                content: renderPopupContent,
                isOpen: isMoreOpen,
                onClose: closeMore,
                placement: "bottom-end",
                testId: "navigation-kit-ui-tab-list.ui.more-popup",
                trigger: renderPopupTrigger,
                shouldRenderToParent: (0, $VSDnB.fg)('should-render-to-parent-should-be-true-nav')
            }),
            addTab && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $abb2a2838602fbd0$var$styles.addTabWrapper
                ]),
                children: addTab
            })
        ]
    });
});
const $abb2a2838602fbd0$var$styles = {
    addTabWrapper: "_16jlidpf _1o9zidpf _i0dl1wug _1rjc1b66 _1e0c1txw",
    moreButtonWrapper: "_16jlidpf _1o9zidpf _i0dl1wug",
    moreButtonWrapperHidden: "_1e0cglyw"
};
var $abb2a2838602fbd0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($abb2a2838602fbd0$var$TabList);

});
const $5b25b2eb4e8be764$export$d1b9ea3245b6a5de = 3;
const $5b25b2eb4e8be764$export$d07bba395c9390f1 = 32;
const $5b25b2eb4e8be764$export$29911ec08ab2ca2d = 5;
const $5b25b2eb4e8be764$export$b61e6f89a9db76de = 4;
const $5b25b2eb4e8be764$export$7fd2e391116c6ef5 = 9;
const $5b25b2eb4e8be764$export$e1633e494d305bfb = 'MORE';
const $5b25b2eb4e8be764$export$1cfe9795423425c = '--horizontal-navigation-color-background-neutral-hovered';
const $5b25b2eb4e8be764$export$539c074adec2188a = '--horizontal-navigation-color-link';
const $5b25b2eb4e8be764$export$6f76912df5477959 = '--horizontal-navigation-color-link-pressed';
const $5b25b2eb4e8be764$export$fac615ceaa871e35 = '--horizontal-navigation-color-text-subtle';
const $5b25b2eb4e8be764$export$7748fdcd335afdc0 = '--horizontal-navigation-color-text';
const $5b25b2eb4e8be764$export$88e550ed188132a7 = '--horizontal-navigation-color-elevation-surface';
const $5b25b2eb4e8be764$export$e2e8fadb946a45d2 = '--horizontal-navigation-color-border-selected';
const $5b25b2eb4e8be764$export$4cd72d361867c565 = '--horizontal-navigation-color-border';
const $5b25b2eb4e8be764$export$be4d7e23cb48401e = '--horizontal-navigation-color-background-neutral';
const $5b25b2eb4e8be764$export$8dd437f6d09d567 = '--horizontal-navigation-color-background-neutral-selected';
const $5b25b2eb4e8be764$export$cf26c31143daa350 = '--hn-yjlbv';

parcelRegister("1WfM5", function(module, exports) {

$parcel$export(module.exports, "TabProvider", () => $b5fb3c628c30d966$export$c0b2172d40e0c73a);
$parcel$export(module.exports, "useTabContext", () => $b5fb3c628c30d966$export$5a3bad273ac578e0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $b5fb3c628c30d966$var$TabContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b5fb3c628c30d966$export$c0b2172d40e0c73a = ({ children: children, id: id, isOverflowing: isOverflowing, hasOverflowed: hasOverflowed, isSelected: isSelected })=>{
    const value = (0, $5uXOq.useMemo)(()=>({
            id: id,
            isOverflowing: isOverflowing,
            hasOverflowed: hasOverflowed,
            isSelected: isSelected
        }), [
        id,
        isOverflowing,
        hasOverflowed,
        isSelected
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b5fb3c628c30d966$var$TabContext.Provider, {
        value: value,
        children: children
    });
};
const $b5fb3c628c30d966$export$5a3bad273ac578e0 = ()=>{
    const context = (0, $5uXOq.useContext)($b5fb3c628c30d966$var$TabContext);
    if (!context) throw new Error('useTab must be used within a TabProvider');
    return context;
};

});

parcelRegister("d6ekp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c883a5a6fe9ccfbd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $c883a5a6fe9ccfbd$var$ResponsiveNav = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, label: label, id: id }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)("nav", {
        "aria-label": label,
        ref: ref,
        id: id,
        className: (0, $bwpsq.default)([
            $c883a5a6fe9ccfbd$var$styles.root
        ]),
        children: children
    }));
const $c883a5a6fe9ccfbd$var$styles = {
    root: "_zulp1y44 _1e0c1txw _kqswh2mm _1ul9idpf _19bvpxbi _u5f3pxbi _1s6km7gv _1kt9b3bt _1cs8stnw _19woidpf _kfgtt94y _qnecidpf _oounidpf"
};
var $c883a5a6fe9ccfbd$export$2e2bcd8739ae039 = $c883a5a6fe9ccfbd$var$ResponsiveNav;

});

parcelRegister("7qDUa", function(module, exports) {

$parcel$export(module.exports, "default", () => $e02e62409dcea79d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");
const $e02e62409dcea79d$var$TabWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>{
    if ((0, $VSDnB.fg)('jfp_a11y_team_board_missing_unordered_list_mark-up')) return /*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        ref: ref,
        className: (0, $bwpsq.default)([
            $e02e62409dcea79d$var$styles.root,
            $e02e62409dcea79d$var$listStyles.ulRoot
        ]),
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        className: (0, $bwpsq.default)([
            $e02e62409dcea79d$var$styles.root
        ]),
        children: children
    });
});
const $e02e62409dcea79d$var$styles = {
    root: "_zulp1y44 _1reo15vq _18m915vq _vchhusvi _1e0c1txw _2lx2vrvc _1n261q9c _4t3izwfg _otyrze3t _18u0xmi2 _2hwxxmi2 _19pkze3t _n3tdze3t _19bvutpp _u5f3utpp _ca0qze3t"
};
const $e02e62409dcea79d$var$listStyles = {
    ulRoot: "_2mzuglyw"
};
var $e02e62409dcea79d$export$2e2bcd8739ae039 = $e02e62409dcea79d$var$TabWrapper;

});

parcelRegister("abm80", function(module, exports) {

$parcel$export(module.exports, "MoreMenuContents", () => $748b87e099e93db3$export$acf06d2aac619450);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $3KYe6 = parcelRequire("3KYe6");
const $748b87e099e93db3$export$acf06d2aac619450 = ({ children: children, close: close, selectedTabId: selectedTabId })=>{
    const menuContentsRef = (0, $5uXOq.useRef)(null);
    const previousSelectedTabId = (0, $5uXOq.useRef)(selectedTabId);
    (0, $5uXOq.useEffect)(()=>{
        if (selectedTabId !== previousSelectedTabId.current && close) close();
        else previousSelectedTabId.current = selectedTabId;
    }, [
        selectedTabId,
        close
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!menuContentsRef.current) return;
        (0, $3KYe6.autoScrollForElements)({
            element: menuContentsRef.current
        });
    }, []);
    if ((0, $VSDnB.fg)('jfp_a11y_team_board_missing_unordered_list_mark-up')) return /*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        ref: menuContentsRef,
        onClick: (e)=>{
            e.stopPropagation();
        },
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1rjct94y _c71lyly2 _18m91wug _2mzuglyw"
        ]),
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: menuContentsRef,
        onClick: (e)=>{
            e.stopPropagation();
        },
        className: (0, $bwpsq.default)([
            "_1rjct94y _c71lyly2 _18m91wug"
        ]),
        children: children
    });
};
const $748b87e099e93db3$var$moreMenuContentsStyles = null;
const $748b87e099e93db3$var$moreMenuContentsUlStyles = null;

});
parcelRegister("3KYe6", function(module, exports) {

$parcel$export(module.exports, "autoScrollForElements", () => $5ea44a3a02963798$export$4b66ee8317094cdb);

var $7gWdR = parcelRequire("7gWdR");

var $1XBB4 = parcelRequire("1XBB4");
const $5ea44a3a02963798$var$api = (0, $1XBB4.makeApi)({
    monitor: (0, $7gWdR.monitorForElements)
});
const $5ea44a3a02963798$export$4b66ee8317094cdb = $5ea44a3a02963798$var$api.autoScroll;
const $5ea44a3a02963798$export$c9168f41de61f525 = $5ea44a3a02963798$var$api.autoScrollWindow;

});
parcelRegister("1XBB4", function(module, exports) {

$parcel$export(module.exports, "makeApi", () => $7c9f5b9e5aad06df$export$b8fa21320a811083);

var $4hDdm = parcelRequire("4hDdm");
parcelRequire("5p5cl");
var $jjNE9 = parcelRequire("jjNE9");

var $4HETl = parcelRequire("4HETl");

var $5DMYW = parcelRequire("5DMYW");

var $dN2fr = parcelRequire("dN2fr");
function $7c9f5b9e5aad06df$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        const cleanup = (0, $4hDdm.combine)((0, $5DMYW.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
        return (0, $jjNE9.once)(cleanup);
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        function cleanup() {
            windowRegistry.delete(unique);
        }
        return (0, $jjNE9.once)(cleanup);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $dN2fr.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $4HETl.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}

});
parcelRegister("5p5cl", function(module, exports) {

$parcel$export(module.exports, "once", () => (parcelRequire("jjNE9")).once);

var $jjNE9 = parcelRequire("jjNE9");

});

parcelRegister("4HETl", function(module, exports) {

$parcel$export(module.exports, "getScheduler", () => $76249ae4e9f30f38$export$5cff7ac265db316a);
parcelRequire("i6e0j");
var $kKgsQ = parcelRequire("kKgsQ");

var $3d4ga = parcelRequire("3d4ga");
// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $76249ae4e9f30f38$var$schedulers = new Map();
function $76249ae4e9f30f38$export$5cff7ac265db316a(monitor) {
    const scheduler = $76249ae4e9f30f38$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $76249ae4e9f30f38$var$makeScheduler(monitor);
    $76249ae4e9f30f38$var$schedulers.set(monitor, created);
    return created;
}
function $76249ae4e9f30f38$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $kKgsQ.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $3d4ga.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $3d4ga.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}

});
parcelRegister("i6e0j", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("kKgsQ")).getElementFromPointWithoutHoneypot);

var $kKgsQ = parcelRequire("kKgsQ");

});

parcelRegister("3d4ga", function(module, exports) {

$parcel$export(module.exports, "markAndGetEngagement", () => $cdcee60ad04716da$export$8c764c3f2fc3d2d2);
$parcel$export(module.exports, "clearUnusedEngagements", () => $cdcee60ad04716da$export$991e77dd347f3df1);
$parcel$export(module.exports, "clearEngagementHistory", () => $cdcee60ad04716da$export$13ae770ed39b71ea);
const $cdcee60ad04716da$var$ledger = new Map();
const $cdcee60ad04716da$var$requested = new Set();
function $cdcee60ad04716da$export$8c764c3f2fc3d2d2(element) {
    $cdcee60ad04716da$export$1cb7cbb266b6f6fa(element);
    const entry = $cdcee60ad04716da$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $cdcee60ad04716da$var$ledger.set(element, fresh);
    return fresh;
}
function $cdcee60ad04716da$export$1cb7cbb266b6f6fa(element) {
    $cdcee60ad04716da$var$requested.add(element);
}
function $cdcee60ad04716da$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $cdcee60ad04716da$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $cdcee60ad04716da$var$ledger.forEach((_, element)=>{
        if (!$cdcee60ad04716da$var$requested.has(element)) $cdcee60ad04716da$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $cdcee60ad04716da$var$requested.clear();
}
function $cdcee60ad04716da$export$13ae770ed39b71ea() {
    $cdcee60ad04716da$var$ledger.clear();
}

});


parcelRegister("5DMYW", function(module, exports) {

$parcel$export(module.exports, "selector", () => $05e8460564c70d18$export$aea217a45095ce11);
$parcel$export(module.exports, "addScrollableAttribute", () => $05e8460564c70d18$export$4ec12fb57dfebd53);
const $05e8460564c70d18$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $05e8460564c70d18$export$aea217a45095ce11 = `[${$05e8460564c70d18$export$4b152ab55cad4fd6}="true"]`;
function $05e8460564c70d18$export$4ec12fb57dfebd53(element) {
    element.setAttribute($05e8460564c70d18$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($05e8460564c70d18$export$4b152ab55cad4fd6);
}

});

parcelRegister("dN2fr", function(module, exports) {

$parcel$export(module.exports, "tryScroll", () => $95daf559d8aa786a$export$233199807749476d);

var $kjAuM = parcelRequire("kjAuM");

var $3d4ga = parcelRequire("3d4ga");

var $5DMYW = parcelRequire("5DMYW");

var $i4SSA = parcelRequire("i4SSA");
function $95daf559d8aa786a$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $95daf559d8aa786a$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$95daf559d8aa786a$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $5DMYW.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $95daf559d8aa786a$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $3d4ga.markAndGetEngagement)(element);
    const config = (0, $kjAuM.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $i4SSA.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $95daf559d8aa786a$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $3d4ga.markAndGetEngagement)(element);
        const config = (0, $kjAuM.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $i4SSA.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $95daf559d8aa786a$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $95daf559d8aa786a$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$95daf559d8aa786a$var$isScrollingAvailable(remainder)) return;
    $95daf559d8aa786a$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}

});
parcelRegister("kjAuM", function(module, exports) {

$parcel$export(module.exports, "getInternalConfig", () => $8aedd24a4f7bb643$export$e96028ec7ff9d079);
const $8aedd24a4f7bb643$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $8aedd24a4f7bb643$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $8aedd24a4f7bb643$export$e96028ec7ff9d079(provided) {
    return {
        ...$8aedd24a4f7bb643$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $8aedd24a4f7bb643$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}

});

parcelRegister("i4SSA", function(module, exports) {

$parcel$export(module.exports, "getScrollBy", () => $f221acff344cd122$export$6cfa6dfe6898b98f);

var $iduok = parcelRequire("iduok");

var $ffSUw = parcelRequire("ffSUw");

var $c3M8M = parcelRequire("c3M8M");

var $gfxd2 = parcelRequire("gfxd2");

var $hTDOm = parcelRequire("hTDOm");

var $2dwAb = parcelRequire("2dwAb");
function $f221acff344cd122$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $f221acff344cd122$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $f221acff344cd122$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $ffSUw.edges).reduce((map, edge)=>{
        const hitbox = (0, $c3M8M.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $ffSUw.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $hTDOm.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $2dwAb.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $iduok.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $gfxd2.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("iduok", function(module, exports) {

$parcel$export(module.exports, "canScrollOnEdge", () => $dc24cd2fd79e74bd$export$ccd6d9407403fcad);
const $dc24cd2fd79e74bd$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};

});

parcelRegister("ffSUw", function(module, exports) {

$parcel$export(module.exports, "edges", () => $77e5ecf85ecb98dd$export$4544a00f8eb65eb2);
$parcel$export(module.exports, "edgeAxisLookup", () => $77e5ecf85ecb98dd$export$7fc144124ccf8292);
const $77e5ecf85ecb98dd$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $77e5ecf85ecb98dd$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};

});

parcelRegister("c3M8M", function(module, exports) {

$parcel$export(module.exports, "getOverElementHitbox", () => $4e0c1489e6f6f1ed$export$b9a449c20abb0e9);

var $9w8nT = parcelRequire("9w8nT");

var $aHtK2 = parcelRequire("aHtK2");
function $4e0c1489e6f6f1ed$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $9w8nT.axisLookup)[axis];
        const side = (0, $aHtK2.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $4e0c1489e6f6f1ed$export$b9a449c20abb0e9 = {
    top: $4e0c1489e6f6f1ed$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $4e0c1489e6f6f1ed$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $4e0c1489e6f6f1ed$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $4e0c1489e6f6f1ed$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};

});
parcelRegister("9w8nT", function(module, exports) {

$parcel$export(module.exports, "axisLookup", () => $4007ed2af13415f1$export$42e42cdab35a2b96);
const $4007ed2af13415f1$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $4007ed2af13415f1$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $4007ed2af13415f1$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $4007ed2af13415f1$var$vertical,
        crossAxis: $4007ed2af13415f1$var$horizontal
    },
    horizontal: {
        mainAxis: $4007ed2af13415f1$var$horizontal,
        crossAxis: $4007ed2af13415f1$var$vertical
    }
};

});

parcelRegister("aHtK2", function(module, exports) {

$parcel$export(module.exports, "mainAxisSideLookup", () => $4b97aced6f7f08e4$export$a45c0cd714a4dbaa);
const $4b97aced6f7f08e4$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};

});


parcelRegister("gfxd2", function(module, exports) {

$parcel$export(module.exports, "getScrollChange", () => $b3ae2158089b2ceb$export$470a2ff46db8cee8);

var $9w8nT = parcelRequire("9w8nT");

var $lUX3m = parcelRequire("lUX3m");

var $aHtK2 = parcelRequire("aHtK2");
// We want a consistent scroll speed across devices, regardless of framerate
function $b3ae2158089b2ceb$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $b3ae2158089b2ceb$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $9w8nT.axisLookup)[axis];
    const side = (0, $aHtK2.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $lUX3m.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $lUX3m.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $b3ae2158089b2ceb$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $b3ae2158089b2ceb$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $b3ae2158089b2ceb$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $lUX3m.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $aHtK2.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}

});
parcelRegister("lUX3m", function(module, exports) {

$parcel$export(module.exports, "getPercentageInRange", () => $15bc8d2c21c8e1e4$export$1a29de000a332d74);
function $15bc8d2c21c8e1e4$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}

});


parcelRegister("hTDOm", function(module, exports) {

$parcel$export(module.exports, "isAxisAllowed", () => $9d9969f3e7f53880$export$7120fdbd90bd1292);
function $9d9969f3e7f53880$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}

});

parcelRegister("2dwAb", function(module, exports) {

$parcel$export(module.exports, "isWithin", () => $df40d0415a8c41aa$export$cda7a9d4399bf2e3);
function $df40d0415a8c41aa$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}

});






parcelRegister("8ndnW", function(module, exports) {

$parcel$export(module.exports, "MoreTrigger", () => $6b06b3843d3cff3d$export$8220169239c5b5cd);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $16T6Y = parcelRequire("16T6Y");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $dcuaN = parcelRequire("dcuaN");
var $1WfM5 = parcelRequire("1WfM5");

var $g06jW = parcelRequire("g06jW");
const $6b06b3843d3cff3d$var$ThemedBadge = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $16T6Y.default), {
        ...props,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color: `var(${(0, $5b25b2eb4e8be764$export$cf26c31143daa350)}, ${"var(--ds-text-subtle, #44546F)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            backgroundColor: `var(${(0, $5b25b2eb4e8be764$export$be4d7e23cb48401e)}, ${"var(--ds-background-neutral, #091E420F)"})`
        }
    });
};
const $6b06b3843d3cff3d$export$8220169239c5b5cd = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ count: count, ...rest }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1WfM5.TabProvider), {
        id: (0, $5b25b2eb4e8be764$export$e1633e494d305bfb),
        isOverflowing: false,
        isSelected: false,
        hasOverflowed: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dcuaN.default), {
            ...rest,
            ref: ref,
            name: formatMessage((0, $g06jW.default).moreTabWithBadge),
            "aria-label": formatMessage((0, $g06jW.default).moreTabsWithBadgeLabel, {
                tabCount: count
            }),
            type: "dropdown-trigger",
            isMoreMenu: true,
            isChevronHidden: true,
            testId: "navigation-kit-ui-tab-list.ui.more-trigger.more-tab",
            elemAfter: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    ' ',
                    // no wrapper is required for count > 9 as the badge will always contain 9+ so will be the same width
                    count > (0, $5b25b2eb4e8be764$export$7fd2e391116c6ef5) ? /*#__PURE__*/ (0, $2OMIu.jsx)($6b06b3843d3cff3d$var$ThemedBadge, {
                        max: (0, $5b25b2eb4e8be764$export$7fd2e391116c6ef5),
                        children: count
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                        as: "span",
                        xcss: $6b06b3843d3cff3d$var$moreDigitBadgeWrapperStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)($6b06b3843d3cff3d$var$ThemedBadge, {
                            max: (0, $5b25b2eb4e8be764$export$7fd2e391116c6ef5),
                            children: count
                        })
                    })
                ]
            })
        })
    });
});
const $6b06b3843d3cff3d$var$moreDigitBadgeWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    minWidth: "var(--ds-space-250, 20px)"
});

});
parcelRegister("dcuaN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b24ed4b325bed49$export$2e2bcd8739ae039);

var $8yLC7 = parcelRequire("8yLC7");

var $1WfM5 = parcelRequire("1WfM5");
var $9b24ed4b325bed49$export$2e2bcd8739ae039 = (0, $8yLC7.default);

});
parcelRegister("8yLC7", function(module, exports) {

$parcel$export(module.exports, "default", () => $48cbcdec0834c439$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bNCjH = parcelRequire("bNCjH");

var $cvb1C = parcelRequire("cvb1C");
const $48cbcdec0834c439$var$OuterTab = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, outerRef)=>{
    if (props.type === 'dropdown-trigger') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bNCjH.default), {
        ...props,
        ref: outerRef
    });
    if (props.type === 'anchor' || props.type === 'router-link' || props.type === undefined) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cvb1C.default), {
        ...props,
        ref: outerRef
    });
    return null;
}));
var $48cbcdec0834c439$export$2e2bcd8739ae039 = $48cbcdec0834c439$var$OuterTab;

});
parcelRegister("bNCjH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca6df9b0c307c681$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3Du7S = parcelRequire("3Du7S");

var $kEVMo = parcelRequire("kEVMo");

var $3uzfU = parcelRequire("3uzfU");

var $kJpBP = parcelRequire("kJpBP");
var $1aogK = parcelRequire("1aogK");

var $c0aEF = parcelRequire("c0aEF");

var $8uoun = parcelRequire("8uoun");

var $biyM9 = parcelRequire("biyM9");

var $88yhS = parcelRequire("88yhS");

var $68HIH = parcelRequire("68HIH");

var $fPjW7 = parcelRequire("fPjW7");

var $klBEJ = parcelRequire("klBEJ");

var $4qRir = parcelRequire("4qRir");

var $aiFA8 = parcelRequire("aiFA8");

var $1WfM5 = parcelRequire("1WfM5");

var $cJnqb = parcelRequire("cJnqb");
const $ca6df9b0c307c681$var$HeadingWhenSelected = ({ isSelected: isSelected, children: children })=>{
    /* eslint-disable-next-line @atlaskit/design-system/use-heading */ return isSelected ? /*#__PURE__*/ (0, $2OMIu.jsx)($ca6df9b0c307c681$var$HeadingWrapper, {
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};
const $ca6df9b0c307c681$export$471d16b0e03bf864 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ elemAfter: elemAfter, elemBefore: elemBefore, handleDrag: handleDrag, isChevronHidden: isChevronHidden = false, isDraggable: isDraggable = false, isMoreMenu: isMoreMenu, isOpen: isOpen = false, isRenaming: isRenaming, name: name, onClick: onClick, onRenameCancel: onRenameCancel, onRenameComplete: onRenameComplete, position: position, renderMenu: renderMenu, testId: testId, ...buttonPassthroughProps }, outerRef)=>{
    const { id: id, isSelected: isSelected, isOverflowing: isOverflowing } = (0, $1WfM5.useTabContext)();
    const elementRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $3Du7S.useMergeRefs)([
        outerRef,
        elementRef
    ]);
    const isActive = isOpen || isSelected;
    const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(false);
    const { closestEdge: closestEdge, isActiveDropZone: isActiveDropZone, dragState: dragState, isDragging: isDragging } = (0, $cJnqb.useDraggableTabs)({
        isDragEnabled: isDraggable,
        isDropEnabled: true,
        position: position,
        id: id,
        handleDrag: handleDrag,
        isSelected: isSelected,
        isOverflowing: isOverflowing,
        isMoreMenu: isMoreMenu,
        elementRef: elementRef
    });
    const hasMenu = renderMenu != null;
    const rightChevron = isChevronHidden ? undefined : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3uzfU))), {
        color: "currentColor",
        spacing: "spacious",
        label: "",
        size: "small"
    });
    const downChevron = isChevronHidden ? undefined : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
        color: "currentColor",
        spacing: "spacious",
        label: "",
        size: "small"
    });
    if (isOverflowing) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $68HIH.default), {
            isOverflowing: true,
            isOpen: isMenuOpen,
            isSelected: isActive,
            hasMenu: hasMenu,
            isRenaming: isRenaming,
            children: [
                isRenaming ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1aogK.default), {
                    component: (0, $klBEJ.RenameMenuItemComponent),
                    iconBefore: elemBefore,
                    iconAfter: elemAfter ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                        alignBlock: "center",
                        children: [
                            elemAfter,
                            rightChevron
                        ]
                    }) : rightChevron,
                    ref: mergedRefs,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            className: (0, $bwpsq.default)([
                                hasMenu && "_u5f3utpp _2hwx1ejb"
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4qRir.default), {
                                defaultValue: name,
                                onCancel: onRenameCancel,
                                onConfirm: onRenameComplete
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $biyM9.default), {
                            elemBefore: elemBefore,
                            elemAfter: elemAfter ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                                alignBlock: "center",
                                children: [
                                    elemAfter,
                                    rightChevron
                                ]
                            }) : rightChevron,
                            closestEdge: closestEdge,
                            dragState: dragState,
                            name: name
                        })
                    ]
                }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $kJpBP.default), {
                    ...buttonPassthroughProps,
                    ref: mergedRefs,
                    onClick: onClick,
                    testId: testId,
                    "aria-current": isSelected ? 'page' : undefined,
                    iconBefore: elemBefore,
                    iconAfter: elemAfter ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                        alignBlock: "center",
                        children: [
                            elemAfter,
                            rightChevron
                        ]
                    }) : rightChevron,
                    isSelected: isActive,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            className: (0, $bwpsq.default)([
                                hasMenu && "_u5f3utpp _2hwx1ejb"
                            ]),
                            children: name
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $biyM9.default), {
                            elemBefore: elemBefore,
                            elemAfter: elemAfter ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                                alignBlock: "center",
                                children: [
                                    elemAfter,
                                    rightChevron
                                ]
                            }) : rightChevron,
                            closestEdge: closestEdge,
                            dragState: dragState,
                            name: name
                        })
                    ]
                }),
                hasMenu && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fPjW7.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_zulp1b66 _kqswstnw _1e0c1txw _4cvr1h6o _1xi21jfw _154iu2gc"
                        ]),
                        children: renderMenu != null && renderMenu({
                            isOverflowing: isOverflowing,
                            isOpen: isMenuOpen,
                            setIsOpen: setIsMenuOpen
                        })
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $68HIH.default), {
        isSelected: isActive,
        isOpen: isMenuOpen,
        hasMenu: hasMenu,
        isRenaming: isRenaming,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $aiFA8.default), {
            isSelected: isActive,
            isDragging: isDragging,
            ref: mergedRefs,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    "data-testid": "navigation-kit-ui-tab.ui.dropdown-trigger-tab.tab-button",
                    className: (0, $bwpsq.default)([
                        "_1ul91ris",
                        isActiveDropZone && "_bfhk1af1"
                    ]),
                    children: isRenaming ? /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                        "data-delegated-focus-ring": true,
                        "data-testid": testId,
                        className: (0, $bwpsq.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _zulp1b66 _19itglyw _1e0c1txw _kqswh2mm _1q51pxbi _y4tize3t _85i5pxbi _bozg1b66 _k48p1wq8 _1wybdlk8 _1dyz4jg8 _o5721q9c _4t3izwfg _vwz4n7od _vchhusvi _1ul91ris _syaz1ked _4cvr1h6o _bfhk18uv _80omtlke _nt751r31 _mizu1r31 _49pcglyw _ra3xglyw _1hvw1o36 _128m1o36 _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _9h8h1yx7 _f8pj1yx7 _v0vw1yx7 _30l31yx7 _9h8hhppw _gcm1hppw",
                            isMoreMenu && "_3ll11ked _12gy1yx7 _1ux11yx7 _1vg51yx7 _1qdthppw",
                            isSelected && "_syaz1yx7"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $88yhS.default), {
                                elementBefore: elemBefore
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4qRir.default), {
                                defaultValue: name,
                                onCancel: onRenameCancel,
                                onConfirm: onRenameComplete
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8uoun.default), {
                                elemAfter: elemAfter ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                                    alignBlock: "center",
                                    children: [
                                        elemAfter,
                                        downChevron
                                    ]
                                }) : downChevron,
                                closestEdge: closestEdge,
                                dragState: dragState,
                                name: name
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($ca6df9b0c307c681$var$HeadingWhenSelected, {
                        isSelected: isSelected,
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("button", {
                            ...buttonPassthroughProps,
                            "data-delegated-focus-ring": true,
                            "data-testid": testId,
                            type: "button",
                            onClick: onClick,
                            "aria-current": isSelected ? 'page' : undefined,
                            className: (0, $bwpsq.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _zulp1b66 _19itglyw _1e0c1txw _kqswh2mm _1q51pxbi _y4tize3t _85i5pxbi _bozg1b66 _k48p1wq8 _1wybdlk8 _1dyz4jg8 _o5721q9c _4t3izwfg _vwz4n7od _vchhusvi _1ul91ris _syaz1ked _4cvr1h6o _bfhk18uv _80omtlke _nt751r31 _mizu1r31 _49pcglyw _ra3xglyw _1hvw1o36 _128m1o36 _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _9h8h1yx7 _f8pj1yx7 _v0vw1yx7 _30l31yx7 _9h8hhppw _gcm1hppw",
                                isMoreMenu && "_3ll11ked _12gy1yx7 _1ux11yx7 _1vg51yx7 _1qdthppw",
                                isSelected && "_syaz1yx7"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $88yhS.default), {
                                    elementBefore: elemBefore
                                }),
                                name,
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8uoun.default), {
                                    elemAfter: elemAfter ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                                        alignBlock: "center",
                                        children: [
                                            elemAfter,
                                            downChevron
                                        ]
                                    }) : downChevron,
                                    closestEdge: closestEdge,
                                    dragState: dragState,
                                    name: name
                                })
                            ]
                        })
                    })
                }),
                hasMenu && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fPjW7.default), {
                    children: renderMenu != null && renderMenu({
                        isOpen: isMenuOpen,
                        setIsOpen: setIsMenuOpen
                    })
                })
            ]
        })
    });
}));
const $ca6df9b0c307c681$var$boxStyles = null;
const $ca6df9b0c307c681$var$boxHighlightedStyles = null;
const $ca6df9b0c307c681$var$currentTabLabelStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $ca6df9b0c307c681$var$HeadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz4n7od",
            __cmplp.className
        ])
    });
});
const $ca6df9b0c307c681$var$tabStyles = null;
const $ca6df9b0c307c681$var$overflowItemWrapperStyles = null;
const $ca6df9b0c307c681$var$overflowNameWrapperStyles = null;
const $ca6df9b0c307c681$var$actionItemsWrapperStyles = null;
/**
 * Although these variables are used in the Badge, they are defined here so they can change on tab
 * hover/focus/active states.
 */ const $ca6df9b0c307c681$var$moreButtonBadgeStyles = null;
var $ca6df9b0c307c681$export$2e2bcd8739ae039 = $ca6df9b0c307c681$export$471d16b0e03bf864;

});
parcelRegister("8uoun", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea47a07ee23f3d8a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7nsd3 = parcelRequire("7nsd3");

var $bJeNF = parcelRequire("bJeNF");

var $5uJ9N = parcelRequire("5uJ9N");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $k7xpN = parcelRequire("k7xpN");
const $ea47a07ee23f3d8a$var$DropIndicator = ({ closestEdge: closestEdge, testId: testId })=>(closestEdge && /*#__PURE__*/ (0, $2OMIu.jsx)($ea47a07ee23f3d8a$var$DropIndicatorWrapper, {
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uJ9N.DropIndicator), {
            edge: closestEdge,
            gap: `${(0, $5b25b2eb4e8be764$export$b61e6f89a9db76de)}px`
        })
    })) ?? null;
const $ea47a07ee23f3d8a$export$905ab40ac2179daa = ({ elemAfter: elemAfter, name: name })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": "navigation-kit-ui-tab-common.ui.after-elements.drag-preview",
        className: (0, $bwpsq.default)([
            "_zulp1b66 _h7al1vdr _1e0c1txw _4cvr1h6o _13lipd34 _qrwqpd34 _syaz1f7t _bfhk1h36 _ca0qidpf _u5f3u2gc _n3tdidpf _19bv1b66 _4t3izwfg _qdn51txw",
            !(0, $k7xpN.isSafari)() && "_139e1smy"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                color: "currentColor",
                label: "",
                LEGACY_size: "small"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                children: name
            }),
            elemAfter && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: $ea47a07ee23f3d8a$var$elemAfterContainerStyle,
                children: elemAfter
            })
        ]
    });
const $ea47a07ee23f3d8a$var$AfterElements = ({ elemAfter: elemAfter, closestEdge: closestEdge, dragState: dragState, name: name })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            elemAfter && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
                xcss: $ea47a07ee23f3d8a$var$elemAfterContainerStyle,
                children: elemAfter
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($ea47a07ee23f3d8a$var$DropIndicator, {
                testId: "navigation-kit-ui-tab-common.ui.after-elements.drag-indicator",
                closestEdge: closestEdge
            }),
            dragState && dragState.type === 'preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, $2OMIu.jsx)($ea47a07ee23f3d8a$export$905ab40ac2179daa, {
                elemAfter: elemAfter,
                name: name
            }), dragState.container) : null
        ]
    });
const $ea47a07ee23f3d8a$var$elemAfterContainerStyle = (0, $8CUq3.xcss)({
    display: 'flex'
});
const $ea47a07ee23f3d8a$var$tiltStyles = null;
const $ea47a07ee23f3d8a$var$previewStyles = null;
var $ea47a07ee23f3d8a$export$2e2bcd8739ae039 = $ea47a07ee23f3d8a$var$AfterElements;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ea47a07ee23f3d8a$var$DropIndicatorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154i1b66 _1ltvidpf _1bsb1osq _4t3imslj _z1i310m9",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5uJ9N", function(module, exports) {

$parcel$export(module.exports, "DropIndicator", () => $057503bea847bf4c$export$62ed72bc21f6b8a6);
$parcel$export(module.exports, "default", () => $057503bea847bf4c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $40bhS = parcelRequire("40bhS");

var $choBO = parcelRequire("choBO");
function $057503bea847bf4c$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $40bhS.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $choBO.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$057503bea847bf4c$export$2e2bcd8739ae039 = $057503bea847bf4c$export$62ed72bc21f6b8a6;

});
parcelRegister("40bhS", function(module, exports) {

$parcel$export(module.exports, "Line", () => $5554523a258e458d$export$17d680238e50603e);
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $choBO = parcelRequire("choBO");
const $5554523a258e458d$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $5554523a258e458d$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $5554523a258e458d$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $5554523a258e458d$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $5554523a258e458d$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $5554523a258e458d$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $choBO.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $choBO.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $5554523a258e458d$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $5554523a258e458d$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $bwpsq.default)([
            $5554523a258e458d$var$baseStyles.root,
            $5554523a258e458d$var$orientationStyles[orientation],
            $5554523a258e458d$var$edgeStyles[edge]
        ])
    });
}
var // For React.lazy
$5554523a258e458d$export$2e2bcd8739ae039 = $5554523a258e458d$export$17d680238e50603e;

});
parcelRegister("choBO", function(module, exports) {

$parcel$export(module.exports, "presetStrokeColors", () => $9f99301ec58274c5$export$477fafec326bfca0);
$parcel$export(module.exports, "presetStrokeWidth", () => $9f99301ec58274c5$export$45db03aa04b685e3);
const $9f99301ec58274c5$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #0C66E4)",
    warning: "var(--ds-border-warning, #E56910)"
};
const $9f99301ec58274c5$export$45db03aa04b685e3 = "var(--ds-border-width-outline, 2px)";

});



parcelRegister("k7xpN", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $c43e84c8c59e922b$export$95df08bae54cb4df);
const $c43e84c8c59e922b$export$95df08bae54cb4df = ()=>{
    if (typeof navigator !== 'undefined') /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return false;
};

});


parcelRegister("biyM9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e00e9cf23647106d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $3Z96c = parcelRequire("3Z96c");

var $5uJ9N = parcelRequire("5uJ9N");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");


var $k7xpN = parcelRequire("k7xpN");
const $e00e9cf23647106d$var$DropIndicator = ({ closestEdge: closestEdge })=>closestEdge ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": "navigation-kit-ui-tab-common.ui.after-elements-more-item.drag-indicator",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uJ9N.DropIndicator), {
            edge: closestEdge
        })
    }) : null;
const $e00e9cf23647106d$export$905ab40ac2179daa = ({ elemBefore: elemBefore, elemAfter: elemAfter, name: name })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: [
            $e00e9cf23647106d$var$previewStyles,
            !(0, $k7xpN.isSafari)() && $e00e9cf23647106d$var$tiltStyles
        ],
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z96c.default), {
            iconBefore: elemBefore,
            iconAfter: elemAfter,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                children: name
            })
        })
    });
const $e00e9cf23647106d$var$AfterElementsMoreItem = ({ elemBefore: elemBefore, elemAfter: elemAfter, closestEdge: closestEdge, dragState: dragState, name: name })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($e00e9cf23647106d$var$DropIndicator, {
                closestEdge: closestEdge
            }),
            dragState && dragState.type === 'preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, $2OMIu.jsx)($e00e9cf23647106d$export$905ab40ac2179daa, {
                elemBefore: elemBefore,
                elemAfter: elemAfter,
                name: name
            }), dragState.container) : null
        ]
    });
const $e00e9cf23647106d$var$tiltStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    rotate: `${(0, $5b25b2eb4e8be764$export$29911ec08ab2ca2d)}deg`
});
const $e00e9cf23647106d$var$previewStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface'
});
var $e00e9cf23647106d$export$2e2bcd8739ae039 = $e00e9cf23647106d$var$AfterElementsMoreItem;

});

parcelRegister("88yhS", function(module, exports) {

$parcel$export(module.exports, "default", () => $76ee7c3ec984aa57$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $76ee7c3ec984aa57$var$BeforeTab = ({ elementBefore: elementBefore })=>elementBefore ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
            xcss: $76ee7c3ec984aa57$var$elementBeforeStyles,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'var(--display-icon-before, flex)'
            },
            children: elementBefore
        })
    }) : null;
const $76ee7c3ec984aa57$var$elementBeforeStyles = (0, $8CUq3.xcss)({
    inlineSize: "var(--ds-space-300, 24px)",
    blockSize: "var(--ds-space-300, 24px)",
    alignItems: 'center',
    justifyContent: 'center'
});
var $76ee7c3ec984aa57$export$2e2bcd8739ae039 = $76ee7c3ec984aa57$var$BeforeTab;

});

parcelRegister("68HIH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6094786e572a1424$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $6094786e572a1424$var$MenuContainerWrapper = ({ isSelected: isSelected, isOpen: isOpen, hasMenu: hasMenu, children: children, isOverflowing: isOverflowing, isRenaming: isRenaming })=>{
    const [delayedIsOpen, setDelayedIsOpen] = (0, $5uXOq.useState)(isOpen);
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen) window.setTimeout(()=>{
            // we need the menu trigger to stick around to allow focus to return to it when it is closed
            setDelayedIsOpen(false);
        }, 500);
        else setDelayedIsOpen(true);
    }, [
        isOpen,
        setDelayedIsOpen
    ]);
    const isOpenOrDelayed = isOpen || delayedIsOpen;
    const withMenu = hasMenu && !isRenaming;
    const withPeekMenu = withMenu && (isSelected || isOverflowing);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_qdn51txw _1ifwglyw",
            withMenu && isOpen && "_qdn5glyw _1ifw1ule",
            withMenu && "_15y3glyw _1k7x1ule",
            withPeekMenu && "_1v2gglyw _y07k1ule",
            withPeekMenu && isOpenOrDelayed && "_qdn5glyw _1ifw1ule"
        ]),
        children: children
    });
};
const $6094786e572a1424$var$wrapperTabStyles = null;
const $6094786e572a1424$var$showingMenuStyles = null;
const $6094786e572a1424$var$focusMenuStyles = null;
const $6094786e572a1424$var$hoverMenuStyles = null;
var $6094786e572a1424$export$2e2bcd8739ae039 = $6094786e572a1424$var$MenuContainerWrapper;

});

parcelRegister("fPjW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $431c0643adf04838$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $431c0643adf04838$var$MenuWrapper = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c16ua _2hwx1b66"
        ]),
        children: children
    });
const $431c0643adf04838$var$menuWrapperStyles = null;
var $431c0643adf04838$export$2e2bcd8739ae039 = $431c0643adf04838$var$MenuWrapper;

});

parcelRegister("klBEJ", function(module, exports) {

$parcel$export(module.exports, "RenameMenuItemComponent", () => $2790af07a8fffed9$export$26e03447880d5bba);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $2790af07a8fffed9$export$26e03447880d5bba = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1a37ugt7 _1cwg1i6y"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ...props,
            children: children
        })
    });
const $2790af07a8fffed9$var$tabRenamingStyles = null;

});

parcelRegister("4qRir", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae44805fd61694a7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $efXp3 = parcelRequire("efXp3");

var $70T7f = parcelRequire("70T7f");
const $ae44805fd61694a7$var$TabRenameForm = ({ defaultValue: defaultValue, onCancel: onCancel, onConfirm: onConfirm })=>{
    const [value, setValue] = (0, $5uXOq.useState)(defaultValue);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const inputRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        setTimeout(()=>{
            // automatically focus and select the text of the input on mount
            inputRef.current?.focus();
            inputRef.current?.select();
        }, 0);
    }, []);
    const handleSubmitAndBlur = ()=>{
        if (value === defaultValue || value.trim() === '') {
            onCancel?.();
            return;
        }
        onConfirm?.(value.trim());
    };
    const handleChange = (e)=>{
        setValue(e.target.value);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Escape') {
            e.stopPropagation();
            onCancel?.();
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $efXp3.default), {
        onSubmit: handleSubmitAndBlur,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)("form", {
                ...formProps,
                className: (0, $bwpsq.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    "data-value": value,
                    className: (0, $bwpsq.default)([
                        "_1e0c1n7u _4cvr1h6o _ckog1yjy _aetrzxco _uy7x15vq _1qjl1jtm"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                        "aria-label": formatMessage((0, $70T7f.default).tabNameInputLabel),
                        autoComplete: "off",
                        "data-delegated-focus-ring": true,
                        maxLength: 80,
                        name: "tab-name",
                        onBlur: handleSubmitAndBlur,
                        onChange: handleChange,
                        onKeyDown: handleKeyDown,
                        ref: inputRef,
                        required: true,
                        /*
         * We set the size to 1 to ensure the input will not be wider than the
         * text it contains. Without this the input width will be the default width
         * based on the user agent.
         */ size: 1,
                        type: "text",
                        value: value,
                        className: (0, $bwpsq.default)([
                            "_11q7glyw _19itglyw _11c81kw7 _nd5l1yjy _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4bfu18uv _1hms1kw7 _ajmmnqa1 _syaz1kw7 _o5721kw7 _nt751r31 _49pcglyw _1hvw1o36"
                        ])
                    })
                })
            })
    });
};
const $ae44805fd61694a7$var$formStyles = null;
/**
 * This allows the input to grow & shrink as the user types in it.
 * See: https://css-tricks.com/auto-growing-inputs-textareas/
 *
 * This can be replaced by the `field-sizing: content;` property when/if it
 * becomes available in browsers.
 * See: https://developer.mozilla.org/en-US/docs/Web/CSS/field-sizing
 */ const $ae44805fd61694a7$var$inputSizerStyles = null;
const $ae44805fd61694a7$var$inputStyles = null;
var $ae44805fd61694a7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($ae44805fd61694a7$var$TabRenameForm);

});
parcelRegister("70T7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb556302843952b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6bb556302843952b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tabNameInputLabel: {
        id: 'navigation-kit-ui-tab-list.tab-rename-form.tab-name-input-label',
        defaultMessage: 'Tab name',
        description: 'This text is used as aria-label text for the input element in the tab rename form'
    }
});

});


parcelRegister("aiFA8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d653a3af6b3f7933$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d653a3af6b3f7933$var$TabWrapper = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isSelected: isSelected = false, isDragging: isDragging = false }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1pbykb7n"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: ref,
            className: (0, $bwpsq.default)([
                "_2rkoiti9 _1rjc1b66 _19bv12x7 _u5f312x7 _1e0c1txw _kqswh2mm _1kz6zwfg _vchhusvi _uhwn1ris _4cvr1h6o _2lx21sbv _1cwg1i6y _y31iugt7 _ixiwstnw _1wtq12x7 _1j2w12x7 _9di1ze3t _l3ja1wug _1boqb3bt _1kmz1l7b _4tpu1yx7 _x2d61mrw",
                isDragging && "_tzy41kuy",
                isSelected && "_18postnw _19do12x7 _32rx12x7 _1x88ze3t _15l21wug _aetrb3bt _1qdg1l7b _1hfk1yx7 _1bqq1mrw"
            ]),
            children: children
        })
    });
}));
const $d653a3af6b3f7933$var$wrapperTabStyles = null;
const $d653a3af6b3f7933$var$selectedWrapperTabStyles = null;
/*
	This container is used to ensure that the outline is above the tab underline by creating a new stacking context
	around the tab wrapper (which has the ::after pseudo-element inside it).
*/ const $d653a3af6b3f7933$var$containerStyles = null;
const $d653a3af6b3f7933$var$draggingTabStyles = null;
var $d653a3af6b3f7933$export$2e2bcd8739ae039 = $d653a3af6b3f7933$var$TabWrapper;

});

parcelRegister("cJnqb", function(module, exports) {

$parcel$export(module.exports, "useDraggableTabs", () => $0a595c587c0e732d$export$9fa04411e270c5cb);

var $5uXOq = parcelRequire("5uXOq");

var $biEfA = parcelRequire("biEfA");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("4FF5h");
var $hOQcA = parcelRequire("hOQcA");
parcelRequire("erBEN");
var $kpXwZ = parcelRequire("kpXwZ");
function $0a595c587c0e732d$export$9fa04411e270c5cb({ isDragEnabled: isDragEnabled, isDropEnabled: isDropEnabled = true, position: position, id: id, handleDrag: handleDrag, isSelected: isSelected, isOverflowing: isOverflowing, isMoreMenu: isMoreMenu, elementRef: elementRef }) {
    const [isActiveDropZone, setIsActiveDropZone] = (0, $5uXOq.useState)(false);
    const [closestEdge, setClosestEdge] = (0, $5uXOq.useState)(null);
    const [dragState, setDragState] = (0, $5uXOq.useState)({
        type: 'idle'
    });
    (0, $5uXOq.useEffect)(()=>{
        const element = elementRef.current;
        if (!element) return;
        // the more menu is configured differently,
        // and works as a single drop zone that cannot be dragged
        if (isMoreMenu) return (0, $7gWdR.dropTargetForElements)({
            element: element,
            canDrop: (args)=>args.source.data.type === 'tab',
            getIsSticky: ()=>true,
            getData: ()=>({
                    id: id,
                    position: position,
                    isMoreMenu: isMoreMenu
                }),
            onDragEnter: ()=>{
                setIsActiveDropZone(true);
            },
            onDragLeave: ()=>{
                setIsActiveDropZone(false);
            },
            onDrop: ()=>{
                setIsActiveDropZone(false);
            }
        });
        return (0, $4hDdm.combine)((0, $7gWdR.draggable)({
            element: element,
            onGenerateDragPreview ({ location: location, nativeSetDragImage: nativeSetDragImage }) {
                (0, $kpXwZ.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $hOQcA.preserveOffsetOnSource)({
                        element: element,
                        input: location.current.input
                    }),
                    render ({ container: container }) {
                        setDragState({
                            type: 'preview',
                            container: container
                        });
                        return ()=>setDragState({
                                type: 'dragging'
                            });
                    }
                });
            },
            canDrag: ()=>isDragEnabled,
            onDragStart: handleDrag,
            onDrag: ()=>{
                setDragState({
                    type: 'dragging'
                });
            },
            onDrop: ()=>{
                setDragState({
                    type: 'idle'
                });
            },
            getInitialData () {
                return {
                    position: position,
                    id: id,
                    type: 'tab',
                    isOverflowing: isOverflowing
                };
            }
        }), (0, $7gWdR.dropTargetForElements)({
            element: element,
            canDrop: (args)=>args.source.data.type === 'tab' && isDropEnabled,
            getIsSticky: ()=>true,
            getData: ({ input: input, element: dataElement })=>{
                const data = {
                    id: id,
                    position: position,
                    isMoreMenu: isMoreMenu,
                    isOverflowing: isOverflowing
                };
                return (0, $biEfA.attachClosestEdge)(data, {
                    input: input,
                    element: dataElement,
                    allowedEdges: isOverflowing ? [
                        'top',
                        'bottom'
                    ] : [
                        'left',
                        'right'
                    ]
                });
            },
            onDrag ({ source: source, self: self }) {
                if (source.data.id !== id) setClosestEdge((0, $biEfA.extractClosestEdge)(self.data));
            },
            onDragLeave: ()=>{
                setClosestEdge(null);
            },
            onDrop: ()=>{
                setClosestEdge(null);
            }
        }));
    }, [
        isDragEnabled,
        isOverflowing,
        position,
        id,
        isSelected,
        elementRef,
        handleDrag,
        isMoreMenu,
        isDropEnabled
    ]);
    const isDragging = Boolean(dragState && dragState.type === 'dragging');
    return {
        closestEdge: closestEdge,
        isActiveDropZone: isActiveDropZone,
        dragState: dragState,
        isDragging: isDragging
    };
}

});
parcelRegister("biEfA", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $934cfe81468fb31a$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $934cfe81468fb31a$export$945a571f3b658bf);
const $934cfe81468fb31a$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $934cfe81468fb31a$var$uniqueKey = Symbol('closestEdge');
function $934cfe81468fb31a$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $934cfe81468fb31a$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$934cfe81468fb31a$var$uniqueKey]: addClosestEdge
    };
}
function $934cfe81468fb31a$export$945a571f3b658bf(userData) {
    return userData[$934cfe81468fb31a$var$uniqueKey] ?? null;
}

});

parcelRegister("4FF5h", function(module, exports) {

$parcel$export(module.exports, "preserveOffsetOnSource", () => (parcelRequire("hOQcA")).preserveOffsetOnSource);

var $hOQcA = parcelRequire("hOQcA");

});
parcelRegister("hOQcA", function(module, exports) {

$parcel$export(module.exports, "preserveOffsetOnSource", () => $204fc61c99793f66$export$8830e7ac6eee750e);
function $204fc61c99793f66$export$8830e7ac6eee750e({ element: element, input: input }) {
    return ({ container: container })=>{
        const sourceRect = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const offsetX = Math.min(// difference
        input.clientX - sourceRect.x, // don't let the difference be more than the width of the container,
        // otherwise the pointer will be off the preview
        containerRect.width);
        const offsetY = Math.min(// difference
        input.clientY - sourceRect.y, // don't let the difference be more than the height of the container,
        // otherwise the pointer will be off the preview
        containerRect.height);
        return {
            x: offsetX,
            y: offsetY
        };
    };
}

});


parcelRegister("erBEN", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("kpXwZ")).setCustomNativeDragPreview);

var $kpXwZ = parcelRequire("kpXwZ");

});
parcelRegister("kpXwZ", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $39163240d699f88a$export$52d889c66db0f96e);

var $40DDD = parcelRequire("40DDD");

var $6aABs = parcelRequire("6aABs");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $39163240d699f88a$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $39163240d699f88a$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $39163240d699f88a$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $ff68169bc3de57ec$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $6aABs.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $40DDD.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $ff68169bc3de57ec$export$7d0a15ee70427305 = 2147483647;





parcelRegister("cvb1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b21115c6ffe303ab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hjSul = parcelRequire("hjSul");

var $3Du7S = parcelRequire("3Du7S");

var $1aogK = parcelRequire("1aogK");
var $3Z96c = parcelRequire("3Z96c");

var $8uoun = parcelRequire("8uoun");

var $biyM9 = parcelRequire("biyM9");

var $88yhS = parcelRequire("88yhS");

var $68HIH = parcelRequire("68HIH");

var $fPjW7 = parcelRequire("fPjW7");

var $klBEJ = parcelRequire("klBEJ");

var $4qRir = parcelRequire("4qRir");

var $aiFA8 = parcelRequire("aiFA8");

var $1WfM5 = parcelRequire("1WfM5");

var $cJnqb = parcelRequire("cJnqb");
const $b21115c6ffe303ab$var$NonInteractiveTab = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component, children: children, isRenaming: isRenaming, isSelected: isSelected }, outerRef)=>/*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: isRenaming ? undefined : 0,
        ref: outerRef,
        "data-testid": "navigation-kit-ui-tab.ui.link-tab.non-interactive-tab",
        "aria-current": "page",
        "data-delegated-focus-ring": true,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _zulp1b66 _1e0c1txw _1q51pxbi _y4ti1b66 _85i5pxbi _bozgze3t _k48p1wq8 _1wybdlk8 _1dyz4jg8 _o5721q9c _4t3izwfg _vchhusvi _1ul91ris _syaz1ked _4cvr1h6o _nt751r31 _mizu1r31 _49pcglyw _ra3xglyw _1hvw1o36 _128m1o36 _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _9h8h1yx7 _f8pj1yx7 _v0vw1yx7 _30l31yx7 _9h8hhppw _gcm1hppw",
            isSelected && "_syaz1yx7"
        ]),
        children: children
    })));
const $b21115c6ffe303ab$export$6a360a5612cb30b8 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ className: className, elemAfter: elemAfter, elemBefore: elemBefore, handleDrag: handleDrag, href: href, isDraggable: isDraggable = false, isRenaming: isRenaming, name: name, onClick: onClick, onRenameCancel: onRenameCancel, onRenameComplete: onRenameComplete, position: position, renderMenu: renderMenu, testId: testId, type: type }, outerRef)=>{
    const { id: id, isSelected: isSelected, isOverflowing: isOverflowing } = (0, $1WfM5.useTabContext)();
    const elementRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $3Du7S.useMergeRefs)([
        outerRef,
        elementRef
    ]);
    const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(false);
    const { closestEdge: closestEdge, dragState: dragState, isDragging: isDragging } = (0, $cJnqb.useDraggableTabs)({
        isDragEnabled: isDraggable && !isRenaming,
        isDropEnabled: true,
        position: position,
        id: id,
        handleDrag: handleDrag,
        isSelected: isSelected,
        isOverflowing: isOverflowing,
        elementRef: elementRef
    });
    const hasMenu = renderMenu != null;
    if (isOverflowing) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $68HIH.default), {
            isOverflowing: true,
            isOpen: isMenuOpen,
            isSelected: isSelected,
            hasMenu: hasMenu,
            isRenaming: isRenaming,
            children: [
                isRenaming ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1aogK.default), {
                    component: (0, $klBEJ.RenameMenuItemComponent),
                    iconAfter: elemAfter,
                    iconBefore: elemBefore,
                    ref: mergedRefs,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            className: (0, $bwpsq.default)([
                                hasMenu && "_u5f3utpp _2hwx1ejb"
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4qRir.default), {
                                defaultValue: name,
                                onCancel: onRenameCancel,
                                onConfirm: onRenameComplete
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $biyM9.default), {
                            elemBefore: elemBefore,
                            elemAfter: elemAfter,
                            closestEdge: closestEdge,
                            dragState: dragState,
                            name: name
                        })
                    ]
                }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3Z96c.default), {
                    testId: "navigation-kit-ui-tab.ui.link-tab.link-item",
                    ref: mergedRefs,
                    href: href,
                    "aria-current": isSelected ? 'page' : undefined,
                    className: className,
                    onClick: onClick,
                    iconBefore: elemBefore,
                    iconAfter: elemAfter,
                    isSelected: isSelected,
                    UNSAFE_isDraggable: isDraggable,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            className: (0, $bwpsq.default)([
                                hasMenu && "_u5f3utpp _2hwx1ejb"
                            ]),
                            children: name
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $biyM9.default), {
                            elemBefore: elemBefore,
                            elemAfter: elemAfter,
                            closestEdge: closestEdge,
                            dragState: dragState,
                            name: name
                        })
                    ]
                }),
                hasMenu && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fPjW7.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_zulp1b66 _kqswstnw _1e0c1txw _4cvr1h6o _1xi2pxbi _154iu2gc"
                        ]),
                        children: renderMenu != null && renderMenu({
                            isOverflowing: isOverflowing,
                            isOpen: isMenuOpen,
                            setIsOpen: setIsMenuOpen
                        })
                    })
                })
            ]
        })
    });
    const renderTabContent = ()=>{
        const inside = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $88yhS.default), {
                    elementBefore: elemBefore
                }),
                isRenaming ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4qRir.default), {
                    defaultValue: name,
                    onCancel: onRenameCancel,
                    onConfirm: onRenameComplete
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    children: name
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8uoun.default), {
                    elemAfter: elemAfter,
                    closestEdge: closestEdge,
                    dragState: dragState,
                    name: name
                })
            ]
        });
        if (isSelected || isRenaming) return /*#__PURE__*/ (0, $2OMIu.jsx)($b21115c6ffe303ab$var$NonInteractiveTab, {
            as: isRenaming ? 'div' : 'h2',
            isRenaming: Boolean(isRenaming),
            isSelected: isSelected,
            children: inside
        });
        if (type === 'anchor') return /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
            href: href,
            className: (0, $bwpsq.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _zulp1b66 _1e0c1txw _1q51pxbi _y4ti1b66 _85i5pxbi _bozgze3t _k48p1wq8 _1wybdlk8 _1dyz4jg8 _o5721q9c _4t3izwfg _vchhusvi _1ul91ris _syaz1ked _4cvr1h6o _nt751r31 _mizu1r31 _49pcglyw _ra3xglyw _1hvw1o36 _128m1o36 _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _9h8h1yx7 _f8pj1yx7 _v0vw1yx7 _30l31yx7 _9h8hhppw _gcm1hppw",
                className
            ]),
            onClick: onClick,
            "data-testid": "navigation-kit-ui-tab.ui.link-tab.tab-anchor",
            draggable: "false",
            "data-delegated-focus-ring": true,
            children: inside
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hjSul.Link), {
            "data-delegated-focus-ring": true,
            "data-testid": "navigation-kit-ui-tab.ui.link-tab",
            to: href,
            prefetch: "hover",
            className: (0, $bwpsq.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4bfu18uv _1hmsglyw _ajmmnqa1 _zulp1b66 _1e0c1txw _1q51pxbi _y4ti1b66 _85i5pxbi _bozgze3t _k48p1wq8 _1wybdlk8 _1dyz4jg8 _o5721q9c _4t3izwfg _vchhusvi _1ul91ris _syaz1ked _4cvr1h6o _nt751r31 _mizu1r31 _49pcglyw _ra3xglyw _1hvw1o36 _128m1o36 _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _9h8h1yx7 _f8pj1yx7 _v0vw1yx7 _30l31yx7 _9h8hhppw _gcm1hppw",
                className
            ]),
            onClick: onClick,
            draggable: "false",
            children: inside
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: mergedRefs,
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $68HIH.default), {
            isSelected: isSelected,
            isOpen: isMenuOpen,
            hasMenu: hasMenu,
            isRenaming: isRenaming,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $aiFA8.default), {
                isSelected: isSelected,
                isDragging: isDragging,
                children: [
                    renderTabContent(),
                    hasMenu && renderMenu != null && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fPjW7.default), {
                        children: renderMenu({
                            isOverflowing: isOverflowing,
                            isOpen: isMenuOpen,
                            setIsOpen: setIsMenuOpen
                        })
                    }, "menu")
                ]
            })
        })
    });
}));
/* eslint-enable @atlaskit/design-system/no-unsafe-style-overrides */ /* eslint-enable @atlaskit/ui-styling-standard/no-classname-prop */ const $b21115c6ffe303ab$var$currentTabLabelStyles = null;
const $b21115c6ffe303ab$var$tabStyles = null;
const $b21115c6ffe303ab$var$overflowItemWrapperStyles = null;
const $b21115c6ffe303ab$var$overflowNameWrapperStyles = null;
const $b21115c6ffe303ab$var$actionItemsWrapperStyles = null;
var $b21115c6ffe303ab$export$2e2bcd8739ae039 = $b21115c6ffe303ab$export$6a360a5612cb30b8;

});



parcelRegister("g06jW", function(module, exports) {

$parcel$export(module.exports, "default", () => $502d3caa792f275d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $502d3caa792f275d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreTabWithBadge: {
        id: 'navigation-kit-ui-tab-list.more-trigger.more-tab-with-badge',
        defaultMessage: 'More',
        description: 'When the navigation links do not fit on the screen we show a "More [5]" tab which is a dropdown menu containing all the tabs that do not fit in the screen.'
    },
    moreTabsWithBadgeLabel: {
        id: 'navigation-kit-ui-tab-list.more-trigger.more-tabs-with-badge-label',
        defaultMessage: '{tabCount} more {tabCount, plural, one {tab} other {tabs}}',
        description: 'Accessible label for the More button that indicates it shows additional tabs that do not fit on the screen.'
    }
});

});



parcelRegister("6Lyip", function(module, exports) {

$parcel$export(module.exports, "OnboardingSpotlightMaybe", () => $ea144642b34a7c1d$export$77e61d078c8501ca);

var $5uXOq = parcelRequire("5uXOq");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $4R6GH = parcelRequire("4R6GH");
function $ea144642b34a7c1d$export$77e61d078c8501ca({ children: children, spotlight: spotlight }) {
    if (!(0, $4R6GH.fg)('blu-2735_nav4_onboarding')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return spotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: spotlight
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
}

});

parcelRegister("5NM6P", function(module, exports) {

$parcel$export(module.exports, "Nav4OnboardingComponentNames", () => $b94a87b237943b7f$export$f813aeb3fcf8b623);
$parcel$export(module.exports, "COMPONENT_TAP_TRAIT_MAP", () => $b94a87b237943b7f$export$c1a4e03cc30032f5);
const $b94a87b237943b7f$export$f813aeb3fcf8b623 = {
    GLOBAL_MODAL: 'nav4GlobalOnboardingModal',
    JIRA_SIDEBAR_TOGGLE_SPOTLIGHT: 'nav4SidebarToggleOnboardingSpotlight',
    // CONFLUENCE_SIDEBAR_TOGGLE_SPOTLIGHT: 'nav4ConfluenceSidebarToggleOnboardingSpotlight', // TODO: Spotlight has not been implemented in Confluence yet so this may change
    SIDEBAR_PROJECT_SPOTLIGHT: 'nav4SidebarProjectsOnboardingSpotlight',
    TAB_NAV_SPOTLIGHT: 'nav4TabNavigationOnboardingSpotlight',
    ATLAS_GLOBAL_MODAL: 'nav4AtlasGlobalOnboardingModal',
    ATLAS_GLOBAL_MODAL2: 'nav4AtlasGlobalOnboardingModal2'
};
const $b94a87b237943b7f$export$c1a4e03cc30032f5 = {
    nav4GlobalOnboardingModal: 'jira-platform_ui_nav4globalonboardingmodal_dismissed_jiraatlassianonboardingnav4_changed',
    nav4SidebarToggleOnboardingSpotlight: 'jira-platform_ui_nav4sidebartoggleonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    // nav4ConfluenceSidebarToggleOnboardingSpotlight: '', // TODO: Add when Confluence spotlight is implemented
    nav4SidebarProjectsOnboardingSpotlight: 'jira-platform_ui_nav4sidebarprojectsonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    nav4TabNavigationOnboardingSpotlight: 'jira-platform_ui_nav4tabnavigationonboardingspotlight_dismissed_jiraatlassianonboardingnav4_changed',
    nav4AtlasGlobalOnboardingModal: 'townsquare_ui_atlassianhomeonboardingnav4_dismissed_teamcentral_changed'
};

});


parcelRegister("7z86O", function(module, exports) {

$parcel$export(module.exports, "default", () => $340082cdbeafcda0$export$2e2bcd8739ae039);

var $jpNRc = parcelRequire("jpNRc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $BLPHT = parcelRequire("BLPHT");

var $4R6GH = parcelRequire("4R6GH");

var $7XluA = parcelRequire("7XluA");

var $47gW9 = parcelRequire("47gW9");

var $4mO32 = parcelRequire("4mO32");



var $41Jyf = parcelRequire("41Jyf");

var $4H0hX = parcelRequire("4H0hX");

var $6FtZ8 = parcelRequire("6FtZ8");
const $340082cdbeafcda0$var$AddTab = ({ containerFragment: containerFragment, tabsDescriptor: tabsDescriptor, onAddItem: onAddItem })=>{
    const containerData = (0, $8Uumt.useFragment)((0, $jpNRc.default), containerFragment);
    const scopeId = containerData.scopeId ?? '';
    const [isDropdownMenuOpen, setIsDropdownMenuOpen] = (0, $5uXOq.useState)(false);
    const onOpenChange = (0, $5uXOq.useCallback)(()=>{
        setIsDropdownMenuOpen((isDropdownMenuCurrent)=>!isDropdownMenuCurrent);
    }, []);
    const closeMenu = (0, $5uXOq.useCallback)(()=>{
        setIsDropdownMenuOpen(false);
    }, []);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $6FtZ8.addTabContentEntryPoint), (0, $5uXOq.useMemo)(()=>({
            scopeId: scopeId,
            first: (0, $f764d292f97c6de7$export$4653cda61a4943d6)
        }), [
        scopeId
    ]));
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isDropdownMenuOpen);
    const trigger = ({ isSelected: isMenuOpen, onClick: onClick, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41Jyf.default), {
            onClick: (event)=>{
                onClick && onClick(event);
            },
            isSelected: isDropdownMenuOpen,
            ...triggerProps,
            ref: (element)=>{
                triggerRef(element);
                typeof triggerProps.triggerRef === 'function' && triggerProps.triggerRef(element);
            },
            testId: "navigation-kit-add-tab.ui.trigger"
        });
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onAddItem: onAddItem,
            onClose: closeMenu,
            tabsDescriptor: tabsDescriptor
        }), [
        closeMenu,
        onAddItem,
        tabsDescriptor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: trigger,
        placement: "bottom-start",
        testId: "navigation-kit-add-tab.ui.dropdown-menu",
        isOpen: isDropdownMenuOpen,
        onOpenChange: onOpenChange,
        shouldRenderToParent: (0, $4R6GH.fg)('should-render-to-parent-should-be-true-navigation')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $340082cdbeafcda0$var$addTabContentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "navigation-kit-add-tab-content",
        packageName: "jiraNavigationKitAddTab",
        runtimeProps: runtimeProps,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4H0hX.LoadingSkeleton), null)
    })));
};
var $340082cdbeafcda0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($340082cdbeafcda0$var$AddTab);
const $340082cdbeafcda0$var$addTabContentWrapperStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    inlineSize: `${(0, $bd7d4a47a650a2da$export$5e641a5f03919b38)}px`
});

});
parcelRegister("jpNRc", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd4684027da85e3e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<44ed7ddeaad1fa52a71d05534d04501a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fd4684027da85e3e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AddTab_container",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "scopeId"
                    },
                    "action": "THROW",
                    "path": "scopeId"
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$fd4684027da85e3e$var$node.hash = "5c730fc8f652490d6ab22bf4e7225d95";
var $fd4684027da85e3e$export$2e2bcd8739ae039 = $fd4684027da85e3e$var$node;

});

const $bd7d4a47a650a2da$export$5e641a5f03919b38 = 600;
const $bd7d4a47a650a2da$export$7a5cc88a67fa13ae = 'APP';
const $bd7d4a47a650a2da$export$d57b6b390e78d90f = 'Navigation';

parcelRegister("41Jyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f889fc19c0e11e12$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $faod6 = parcelRequire("faod6");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $22OQR = parcelRequire("22OQR");

var $glIsx = parcelRequire("glIsx");
const $f889fc19c0e11e12$var$AddTabTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ presentational: presentational, noTooltip: noTooltip, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        spacing: "none",
        appearance: "subtle",
        role: presentational ? 'presentation' : undefined,
        name: formatMessage((0, $glIsx.default).addTabTriggerLabel),
        ref: ref,
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($faod6))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: formatMessage((0, $glIsx.default).addTabTriggerLabel)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $f889fc19c0e11e12$var$boxStyles
    }, noTooltip ? button : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $glIsx.default).addTabTriggerLabel),
        hideTooltipOnMouseDown: true
    }, button));
});
var $f889fc19c0e11e12$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($f889fc19c0e11e12$var$AddTabTrigger);
const $f889fc19c0e11e12$var$boxStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '0',
    position: 'relative',
    alignSelf: 'center'
});

});
parcelRegister("glIsx", function(module, exports) {

$parcel$export(module.exports, "default", () => $260f8a50e51dfd8d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $260f8a50e51dfd8d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addTabTriggerLabel: {
        "id": "navigation-kit-add-tab.add-tab-trigger.add-tab-trigger-label",
        "defaultMessage": "Add to navigation"
    }
});

});


parcelRegister("4H0hX", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $094e034c84929e6f$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZUJu = parcelRequire("eZUJu");
var $iwwXK = parcelRequire("iwwXK");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

const $094e034c84929e6f$export$44c18d210d5de37b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $094e034c84929e6f$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $094e034c84929e6f$var$skeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $094e034c84929e6f$var$listSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
        minWidth: 280
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $094e034c84929e6f$var$titleSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($094e034c84929e6f$var$Skeleton, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $094e034c84929e6f$var$titleSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($094e034c84929e6f$var$Skeleton, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        hasIcon: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $094e034c84929e6f$var$detailsSkeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($094e034c84929e6f$var$SkeletonPreview, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($094e034c84929e6f$var$Skeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($094e034c84929e6f$var$Skeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($094e034c84929e6f$var$SkeletonButton, null))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $094e034c84929e6f$var$Skeleton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1b66 _bfhkn82g _1bsbmgvx _4t3ipxbi",
            __cmplp.className
        ])
    });
});
const $094e034c84929e6f$var$SkeletonPreview = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $094e034c84929e6f$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbp3fh _4t3in0hr",
            __cmplp.className
        ])
    });
});
const $094e034c84929e6f$var$SkeletonButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $094e034c84929e6f$var$Skeleton, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbo7ol _4t3ixy5q",
            __cmplp.className
        ])
    });
});
const $094e034c84929e6f$var$skeletonWrapperStyles = (0, $8CUq3.xcss)({
    height: '100%',
    display: 'flex',
    flexDirection: 'row'
});
const $094e034c84929e6f$var$titleSkeletonWrapperStyles = (0, $8CUq3.xcss)({
    height: '42px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingInlineStart: 'space.250'
});
const $094e034c84929e6f$var$listSkeletonWrapperStyles = (0, $8CUq3.xcss)({
    paddingBlockStart: 'space.100',
    blockSize: '100%',
    inlineSize: '280px'
});
const $094e034c84929e6f$var$detailsSkeletonWrapperStyles = (0, $8CUq3.xcss)({
    alignItems: 'start',
    backgroundColor: 'elevation.surface.sunken',
    blockSize: '100%',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderWidth: 'border.width.0',
    borderInlineStartWidth: 'border.width',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.200',
    inlineSize: '320px',
    justifyContent: 'start',
    padding: 'space.500'
});
const $094e034c84929e6f$var$wrapperStyles = (0, $8CUq3.xcss)({
    boxSizing: 'border-box',
    color: 'color.text',
    blockSize: '385px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    inlineSize: `${(0, $bd7d4a47a650a2da$export$5e641a5f03919b38)}px`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

});

parcelRegister("6FtZ8", function(module, exports) {

$parcel$export(module.exports, "addTabContentEntryPoint", () => $a6d385136730113d$export$196d3b4618d24c77);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $jfvhV = parcelRequire("jfvhV");

const $a6d385136730113d$export$196d3b4618d24c77 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3ZJp4")), {
        moduleId: "6cee7023",
        moduleName: "AddTabContent",
        priority: "interaction"
    }),
    getPreloadProps: ({ scopeId: scopeId, first: first })=>({
            queries: {
                mainQuery: {
                    parameters: (0, $jfvhV.default),
                    variables: {
                        first: first,
                        containerNavigationInput: {
                            scopeId: scopeId
                        }
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        })
});

});
parcelRegister("jfvhV", function(module, exports) {

$parcel$export(module.exports, "default", () => $97918f10dad5c196$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8a0446fac6b067110cd459141e87422a>>
 * @relayHash f84ccf2ded04668e2e31e188f70e9484
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 507bbb3ea7ceceedb8ccfda00f5c3ffecb8c763884a6d06aca12a44641dadaef
const $97918f10dad5c196$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "containerNavigationInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "containerNavigationInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "scopeId"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v7 = {
        "kind": "ScalarField",
        "name": "appId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "message"
    }, v9 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v10 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v9 /*: any*/ 
        ]
    }, v11 = [
        v8 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v2 /*: any*/ ,
                v9 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AddTabContentQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.containerNavigation.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v4 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.containerNavigation.scopeId"
                                                },
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "concreteType": "JiraNavigationItemTypeConnection",
                                                    "kind": "LinkedField",
                                                    "name": "addableNavigationItemTypes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "JiraNavigationItemTypeEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v3 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.containerNavigation.addableNavigationItemTypes.edges.node.id"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v6 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "jira.containerNavigation.addableNavigationItemTypes.edges.node.typeKey"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v7 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraAppNavigationItemType"
                                                                                },
                                                                                {
                                                                                    "kind": "FragmentSpread",
                                                                                    "name": "ViewItem_item"
                                                                                },
                                                                                {
                                                                                    "kind": "FragmentSpread",
                                                                                    "name": "appItem_horizontalNavAddTab"
                                                                                },
                                                                                {
                                                                                    "kind": "FragmentSpread",
                                                                                    "name": "AddTabDetails_item"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "jira.containerNavigation.addableNavigationItemTypes.edges.node"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "jira.containerNavigation.addableNavigationItemTypes.edges"
                                                        },
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "errors",
                                                            "plural": true,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v10 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.containerNavigation"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AddTabContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "args": v5 /*: any*/ ,
                                            "concreteType": "JiraNavigationItemTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "addableNavigationItemTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemTypeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraNavigationItemType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "label"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        }
                                                                    ],
                                                                    "type": "JiraAppNavigationItemType"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v11 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v11 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "507bbb3ea7ceceedb8ccfda00f5c3ffecb8c763884a6d06aca12a44641dadaef",
            "metadata": {},
            "name": "AddTabContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$97918f10dad5c196$var$node.hash = "41079ddf0412e6da3b6d9525a2b7f747";
var $97918f10dad5c196$export$2e2bcd8739ae039 = $97918f10dad5c196$var$node;

});

parcelRegister("3ZJp4", function(module, exports) {

let $2e8a49be8462fe30$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2e8a49be8462fe30$var$load("kNFvF"),
    $2e8a49be8462fe30$var$load("hH6tl")
]).then(()=>parcelRequire('lpMzx'));

});



parcelRegister("bYbah", function(module, exports) {

$parcel$export(module.exports, "TabShortcutsContextProvider", () => $b6c13989dd8d2573$export$8b136156551d140a);
$parcel$export(module.exports, "useTabShortcuts", () => $b6c13989dd8d2573$export$4b7664145fd3fd6f);

var $5uXOq = parcelRequire("5uXOq");

var $7qDUb = parcelRequire("7qDUb");

var $eGdV2 = parcelRequire("eGdV2");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $5p1kJ = parcelRequire("5p1kJ");

var $879xD = parcelRequire("879xD");

var $5SjJK = parcelRequire("5SjJK");
const $b6c13989dd8d2573$export$eb842c33bb500fce = /*#__PURE__*/ (0, $5uXOq.createContext)({
    /**
   * Registers a tab with TabShortcutsContextProvider so it can be assigned a keyboard shortcut
   * returns a function to deregister.
   */ // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    registerTab: (_)=>()=>{}
});
const $b6c13989dd8d2573$export$8b136156551d140a = ({ navigationName: navigationName, children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [rawTabs, setRawTabs] = (0, $5uXOq.useState)([]);
    const registerTab = (0, $5uXOq.useCallback)((newTab)=>{
        setRawTabs((existingTabs)=>[
                ...existingTabs,
                newTab
            ]);
        return ()=>{
            setRawTabs((existingTabs)=>existingTabs.filter((tab)=>tab.index !== newTab.index));
        };
    }, [
        setRawTabs
    ]);
    /**
   * Generate a keyMap from the rawTabs. The tabs may be out of order, and there may be gaps in the index (some tabs will return null before they get to register)
   * so we sort first and use our own index for the trigger key.
   */ const generateKeyMap = ()=>{
        const keyMap = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($7qDUb)))(rawTabs, 'index').slice(0, 9).forEach((tab, index)=>{
            keyMap[String(index + 1)] = {
                callback: tab.callback,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                    ...(0, $5SjJK.messages).goTo,
                    values: {
                        label: tab.label
                    }
                }),
                registerInCommandPalette: {
                    id: `tab${index + 1}-${tab.label}`,
                    name: formatMessage((0, $5SjJK.messages).goTo, {
                        label: tab.label
                    }),
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
                                spacing: "spacious",
                                label: ""
                            })
                    },
                    section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).containerNavigation
                }
            };
        });
        return keyMap;
    };
    const valueMemo = (0, $5uXOq.useMemo)(()=>({
            registerTab: registerTab
        }), [
        registerTab
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b6c13989dd8d2573$export$eb842c33bb500fce.Provider, {
        value: valueMemo
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $879xD.CommandShortcuts), {
        keyMap: generateKeyMap(),
        label: navigationName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, navigationName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $5SjJK.messages).projectNavigation)
    }));
};
const $b6c13989dd8d2573$export$4b7664145fd3fd6f = ()=>{
    const context = (0, $5uXOq.useContext)($b6c13989dd8d2573$export$eb842c33bb500fce);
    if (!context) throw new Error('useTabShortcuts must be used within a TabShortcutsContextProvider');
    return context;
};

});
parcelRegister("7qDUb", function(module, exports) {

var $ekcP3 = parcelRequire("ekcP3");

var $kE90z = parcelRequire("kE90z");

var $g7i7g = parcelRequire("g7i7g");

var $4rDUz = parcelRequire("4rDUz");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $5689ea6dce44e1ca$var$sortBy = $g7i7g(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $4rDUz(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $4rDUz(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $kE90z(collection, $ekcP3(iteratees, 1), []);
});
module.exports = $5689ea6dce44e1ca$var$sortBy;

});
parcelRegister("kE90z", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $fTwLR = parcelRequire("fTwLR");

var $bxDef = parcelRequire("bxDef");

var $jXnVG = parcelRequire("jXnVG");

var $iWpGN = parcelRequire("iWpGN");

var $cW28x = parcelRequire("cW28x");

var $4pePQ = parcelRequire("4pePQ");

var $etyzk = parcelRequire("etyzk");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $f07e87ec0cad1451$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $1nIHN(iteratees, function(iteratee) {
        if ($8LQ84(iteratee)) return function(value) {
            return $fTwLR(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $etyzk
    ];
    var index = -1;
    iteratees = $1nIHN(iteratees, $cW28x($bxDef));
    var result = $jXnVG(collection, function(value, key, collection) {
        var criteria = $1nIHN(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $iWpGN(result, function(object, other) {
        return $4pePQ(object, other, orders);
    });
}
module.exports = $f07e87ec0cad1451$var$baseOrderBy;

});
parcelRegister("jXnVG", function(module, exports) {

var $e7pfQ = parcelRequire("e7pfQ");

var $hTJwX = parcelRequire("hTJwX");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e87616de80329acf$var$baseMap(collection, iteratee) {
    var index = -1, result = $hTJwX(collection) ? Array(collection.length) : [];
    $e7pfQ(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $e87616de80329acf$var$baseMap;

});

parcelRegister("iWpGN", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $dca1921d42c9de26$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $dca1921d42c9de26$var$baseSortBy;

});

parcelRegister("4pePQ", function(module, exports) {

var $7JssJ = parcelRequire("7JssJ");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $3355012d40661daa$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $7JssJ(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $3355012d40661daa$var$compareMultiple;

});
parcelRegister("7JssJ", function(module, exports) {

var $4faK3 = parcelRequire("4faK3");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $5a12d0703028d451$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $4faK3(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $4faK3(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $5a12d0703028d451$var$compareAscending;

});




parcelRegister("eGdV2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::101a51255f7076752a2af1f3fc652adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aaffc8f190d8dd35$var$_react = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aaffc8f190d8dd35$var$_arrowRight = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("h1TKi")));

var $aaffc8f190d8dd35$var$_arrowRight2 = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("8RBk4")));
function $aaffc8f190d8dd35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aaffc8f190d8dd35$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $aaffc8f190d8dd35$var$_react.default.createElement($aaffc8f190d8dd35$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $aaffc8f190d8dd35$var$_arrowRight2.default
    }, props));
$aaffc8f190d8dd35$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $aaffc8f190d8dd35$var$_default = module.exports.default = $aaffc8f190d8dd35$var$ArrowRightIcon;

});
parcelRegister("h1TKi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c65dc59efb96b35a$var$_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;

});

parcelRegister("8RBk4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
function $6740397d4ba98b13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $6740397d4ba98b13$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $6740397d4ba98b13$var$_arrowRight.default
    }));
$6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;

});


parcelRegister("5p1kJ", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $7691773a5eed3db6$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $7691773a5eed3db6$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $7691773a5eed3db6$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $7691773a5eed3db6$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $7691773a5eed3db6$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $7691773a5eed3db6$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $7691773a5eed3db6$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $7691773a5eed3db6$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $7691773a5eed3db6$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $7691773a5eed3db6$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $7691773a5eed3db6$export$16b06d29ef8f802b = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["containerNavigation"] = "container-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
    COMMAND_PALETTE_SECTIONS["forge"] = "forge";
    return COMMAND_PALETTE_SECTIONS;
}({});
const $7691773a5eed3db6$export$156ebd2354e25466 = 'issueActions';
const $7691773a5eed3db6$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $7691773a5eed3db6$export$9f646ab88e1d2b14 = 'commandPalette';
var $7691773a5eed3db6$export$abf26cc5daebd2c8 = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["containerNavigation"] = 2] = "containerNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["forge"] = 9] = "forge";
    return COMMAND_PALETTE_SECTIONS_PRIORITY;
}({});
var $7691773a5eed3db6$export$12514ca8899b0521 = /*#__PURE__*/ function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
    return COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY;
}({});
var $7691773a5eed3db6$export$5fa0bcf59f933c21 = /*#__PURE__*/ function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
    return COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY;
}({});
var $7691773a5eed3db6$export$7d9743be0b7d862f = /*#__PURE__*/ function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
    return COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY;
}({});
var $7691773a5eed3db6$export$b4e1633c86db2b70 = /*#__PURE__*/ function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
    return COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY;
}({});
var $7691773a5eed3db6$export$5e5a87aac5d9771f = /*#__PURE__*/ function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
    return COMMAND_PALETTE_HELP_PRIORITY;
}({});

});

parcelRegister("879xD", function(module, exports) {

$parcel$export(module.exports, "CommandShortcuts", () => $6700f9962d7215c2$export$7ff7e4fe85a5960a);

var $5uXOq = parcelRequire("5uXOq");

var $1Kt4o = parcelRequire("1Kt4o");

var $556k7 = parcelRequire("556k7");

var $jh7L9 = parcelRequire("jh7L9");

var $3Tty1 = parcelRequire("3Tty1");
const $6700f9962d7215c2$export$7ff7e4fe85a5960a = (props)=>{
    const { keyMap: keyMap } = props;
    const mappedCommands = (0, $5uXOq.useMemo)(()=>{
        const commands = [];
        Object.entries(keyMap).forEach(([key, mapItem])=>{
            if (!mapItem.registerInCommandPalette) return;
            const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
            let shortcutPrimaryAction;
            if (primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST || primaryAction?.type === (0, $jh7L9.CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
            else if (mapItem.callback) shortcutPrimaryAction = {
                type: (0, $jh7L9.CommandActionType).PERFORM,
                perform: ()=>mapItem.callback()
            };
            /**
			 * loadChildren function has the preference over the other actions
			 * followed by perform and then, if none set, the KeyMap callback
			 */ commands.push({
                id: `command-shortcut-${key}`,
                shortcut: key,
                ...command,
                primaryAction: shortcutPrimaryAction
            });
        });
        return commands;
    }, [
        keyMap
    ]);
    /**
	 * As mappedCommands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const shortcutIds = (0, $5uXOq.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
        mappedCommands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), props), !!mappedCommands.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $556k7.RegisterCommands), {
        registrationId: (0, $1Kt4o.COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
        commands: mappedCommands,
        deps: [
            shortcutIds
        ]
    }));
};

});
parcelRegister("1Kt4o", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $3add01bee0e3b846$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $3add01bee0e3b846$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $3add01bee0e3b846$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE',
    FORGE: 'FORGE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $3add01bee0e3b846$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $3add01bee0e3b846$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.COPY_URL,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.DESCRIPTION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.LOG_WORK,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.PARENT,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_ADD,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_SEARCH,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.SHORTCUTS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.STATUS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.STORY_POINTS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.THEME_MODE,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    }
};

});

parcelRegister("556k7", function(module, exports) {

$parcel$export(module.exports, "RegisterCommands", () => $ba0d6dd9c2ef02f6$export$cd555833c78729f1);

var $5uXOq = parcelRequire("5uXOq");

var $buHQa = parcelRequire("buHQa");
const $ba0d6dd9c2ef02f6$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buHQa.RegisterCommandsWithRegistry), props);

});
parcelRegister("buHQa", function(module, exports) {

$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $3f4c8625aa6e8942$export$b8955a01360d2876);

var $6QoIp = parcelRequire("6QoIp");
function $3f4c8625aa6e8942$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $6QoIp.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});
parcelRegister("6QoIp", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $9d04f6fb396fa7c9$export$8a824ae164ff968d);

var $5uXOq = parcelRequire("5uXOq");

var $fIZf0 = parcelRequire("fIZf0");
function $9d04f6fb396fa7c9$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $fIZf0.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $5uXOq.useRef)(commands);
    (0, $5uXOq.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("fIZf0", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $72118e9f2599bc72$export$880fc01e31710b27);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");
function $72118e9f2599bc72$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $d8lE2.useActionsCommandPalette)();
    const subscribe = (0, $5uXOq.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});
parcelRegister("d8lE2", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $f75514d959bfcca8$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $f75514d959bfcca8$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $f75514d959bfcca8$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $f75514d959bfcca8$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $f75514d959bfcca8$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $f75514d959bfcca8$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $f75514d959bfcca8$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $f75514d959bfcca8$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $f75514d959bfcca8$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $f75514d959bfcca8$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $f75514d959bfcca8$export$bbc05723eb144e03);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $gM5ou = parcelRequire("gM5ou");

var $2sRNe = parcelRequire("2sRNe");
const $f75514d959bfcca8$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $f75514d959bfcca8$var$store = (0, $iXqE5.createStore)({
    initialState: $f75514d959bfcca8$var$initialState,
    actions: $2sRNe.actions,
    name: 'commandPalette'
});
const $f75514d959bfcca8$export$6b58f9610017fbb7 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store);
const $f75514d959bfcca8$export$72aa7bc7c6a83c36 = (0, $3sQ5x.createActionsHook)($f75514d959bfcca8$var$store);
const $f75514d959bfcca8$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $f75514d959bfcca8$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $f75514d959bfcca8$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $gM5ou.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $gM5ou.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $gM5ou.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $f75514d959bfcca8$export$1f90c8f89f98110e = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: $f75514d959bfcca8$export$56f06313122d0aac
});
const $f75514d959bfcca8$export$cc979be9b69236df = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $f75514d959bfcca8$export$a18633b655403b12 = (0, $3sQ5x.createStateHook)($f75514d959bfcca8$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $f75514d959bfcca8$export$af8fd8cd4b048315 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $f75514d959bfcca8$export$4372697329bd9cbe = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $f75514d959bfcca8$export$7422170a403e909 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $f75514d959bfcca8$export$282aa48e4a3afada = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $f75514d959bfcca8$export$96819dfb22ad05d3 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $f75514d959bfcca8$export$a40e8ae3e53feab0 = (0, $6dDSs.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $gM5ou.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $f75514d959bfcca8$export$f893891deedab3c6 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: $f75514d959bfcca8$export$a40e8ae3e53feab0
});
const $f75514d959bfcca8$export$bbc05723eb144e03 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("gM5ou", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $cf289af0c139712c$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $cf289af0c139712c$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $cf289af0c139712c$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $cf289af0c139712c$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $cf289af0c139712c$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $cf289af0c139712c$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $cf289af0c139712c$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $cf289af0c139712c$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $cf289af0c139712c$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $cf289af0c139712c$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $cf289af0c139712c$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $cf289af0c139712c$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $cf289af0c139712c$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $cf289af0c139712c$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $cf289af0c139712c$export$c3d20e8c1e93a572);

var $5uXOq = parcelRequire("5uXOq");

var $bdDiz = parcelRequire("bdDiz");

var $2f2jJ = parcelRequire("2f2jJ");

var $bcTvL = parcelRequire("bcTvL");

var $jh7L9 = parcelRequire("jh7L9");
const $cf289af0c139712c$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $cf289af0c139712c$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $cf289af0c139712c$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $cf289af0c139712c$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $cf289af0c139712c$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $cf289af0c139712c$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $cf289af0c139712c$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $cf289af0c139712c$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $cf289af0c139712c$export$389b0273703d5c48(sections)
    };
};
const $cf289af0c139712c$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $cf289af0c139712c$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$cf289af0c139712c$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$cf289af0c139712c$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$cf289af0c139712c$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $cf289af0c139712c$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $cf289af0c139712c$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $cf289af0c139712c$export$daa5beabdf8d9fc3 = (event)=>(0, $2f2jJ.isMacOs)() ? event.metaKey : event.ctrlKey;
const $cf289af0c139712c$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $cf289af0c139712c$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $cf289af0c139712c$export$fa1c95a5ffa92036 = (str)=>(0, $bdDiz.createHash)().update(str).digest('hex');
const $cf289af0c139712c$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $cf289af0c139712c$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $cf289af0c139712c$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $cf289af0c139712c$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("2f2jJ", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $6846128323867ebd$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $6846128323867ebd$export$fe66dae91c68619b);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6846128323867ebd$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $6846128323867ebd$export$fe66dae91c68619b = ()=>$6846128323867ebd$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("bcTvL", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $3996a4302dca83b1$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $3996a4302dca83b1$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $3996a4302dca83b1$export$1ee9d153576afd13);
$parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", () => $3996a4302dca83b1$export$894e19fc96687503);
// EVENT TYPES
const $3996a4302dca83b1$export$a1562d08625f5d7e = 'UI';
const $3996a4302dca83b1$export$947dac6c72b26f81 = 'TRACK';
const $3996a4302dca83b1$export$f1d537d508d2945a = 'SCREEN';
const $3996a4302dca83b1$export$12346a674644c156 = 'OPERATIONAL';
var $3996a4302dca83b1$export$1ee9d153576afd13 = /*#__PURE__*/ function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
    return SHORTCUT_ELEMENT_TYPES;
}({});
const $3996a4302dca83b1$export$894e19fc96687503 = 250;

});

parcelRegister("jh7L9", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3);
var $b1e48ebd4c8d5e4e$export$f041b1b117ab382f = /*#__PURE__*/ function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
    return CommandActionType;
}({});
const $b1e48ebd4c8d5e4e$export$3e448fd53031e13c = Object.values($b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
const $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("2sRNe", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4f4c9e92d50d4f24$export$e324594224ef24da);

var $kGsr8 = parcelRequire("kGsr8");

var $7Jxgt = parcelRequire("7Jxgt");

var $e7WVN = parcelRequire("e7WVN");

var $eTXmK = parcelRequire("eTXmK");

var $2f2jJ = parcelRequire("2f2jJ");

var $jcw0u = parcelRequire("jcw0u");

var $bcTvL = parcelRequire("bcTvL");

var $jh7L9 = parcelRequire("jh7L9");

var $gM5ou = parcelRequire("gM5ou");

var $4DwnT = parcelRequire("4DwnT");

var $h3eZO = parcelRequire("h3eZO");

var $feUec = parcelRequire("feUec");
const $4f4c9e92d50d4f24$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $4f4c9e92d50d4f24$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        if (!getState().isOpen) (0, $eTXmK.default)('command-palette-opened');
        setState({
            commandPaletteSessionId: (0, $7Jxgt.v4)(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $4f4c9e92d50d4f24$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$4f4c9e92d50d4f24$var$rootCommands
        });
    };
const $4f4c9e92d50d4f24$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, $7Jxgt.v4)() : '',
            ...!isOpen ? $4f4c9e92d50d4f24$var$rootCommands : {}
        });
    };
const $4f4c9e92d50d4f24$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $4f4c9e92d50d4f24$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $4f4c9e92d50d4f24$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $4f4c9e92d50d4f24$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $4f4c9e92d50d4f24$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $4f4c9e92d50d4f24$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $4f4c9e92d50d4f24$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $bcTvL.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $4f4c9e92d50d4f24$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $4f4c9e92d50d4f24$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $4f4c9e92d50d4f24$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $gM5ou.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $4f4c9e92d50d4f24$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $eTXmK.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $jcw0u.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $e7WVN.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $4f4c9e92d50d4f24$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $4DwnT.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $gM5ou.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        (0, $feUec.setEventAttribute)(analyticsAttributes);
        const currentCommandAction = (0, $gM5ou.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $gM5ou.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $jh7L9.CommandActionType).PERFORM;
        if (command.mode) newState.shouldForceSearchValue = true;
        if (shouldLoadChildren) {
            (0, $eTXmK.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $h3eZO.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if (currentCommandAction.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $bcTvL.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $2f2jJ.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $eTXmK.default)('command-palette-executed');
                currentCommandAction.perform();
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $e7WVN.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent
                }
            });
        }
    };
const $4f4c9e92d50d4f24$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $4f4c9e92d50d4f24$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $4f4c9e92d50d4f24$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $4f4c9e92d50d4f24$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $4f4c9e92d50d4f24$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $4f4c9e92d50d4f24$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $4f4c9e92d50d4f24$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $4f4c9e92d50d4f24$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $4f4c9e92d50d4f24$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $4f4c9e92d50d4f24$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $4f4c9e92d50d4f24$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $4f4c9e92d50d4f24$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $4f4c9e92d50d4f24$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $4f4c9e92d50d4f24$export$e324594224ef24da = {
    open: $4f4c9e92d50d4f24$var$open,
    toggle: $4f4c9e92d50d4f24$var$toggle,
    close: $4f4c9e92d50d4f24$var$close,
    addCommands: $4f4c9e92d50d4f24$var$addCommands,
    removeCommands: $4f4c9e92d50d4f24$var$removeCommands,
    handleSearch: $4f4c9e92d50d4f24$var$handleSearch,
    forceFocusSearch: $4f4c9e92d50d4f24$var$forceFocusSearch,
    setActiveIndex: $4f4c9e92d50d4f24$var$setActiveIndex,
    executeCommand: $4f4c9e92d50d4f24$var$executeCommand,
    goBackLevel: $4f4c9e92d50d4f24$var$goBackLevel,
    setChildCommands: $4f4c9e92d50d4f24$var$setChildCommands,
    setLoadingList: $4f4c9e92d50d4f24$var$setLoadingList,
    setFocusInput: $4f4c9e92d50d4f24$var$setFocusInput,
    registerSections: $4f4c9e92d50d4f24$var$registerSections,
    unregisterSections: $4f4c9e92d50d4f24$var$unregisterSections,
    markAsLoaded: $4f4c9e92d50d4f24$var$markAsLoaded,
    getAnalyticsAttributes: $4f4c9e92d50d4f24$var$getAnalyticsAttributes,
    setIsDisabled: $4f4c9e92d50d4f24$var$setIsDisabled,
    setRegistry: $4f4c9e92d50d4f24$var$setRegistry,
    updateActiveRegistry: $4f4c9e92d50d4f24$var$updateActiveRegistry,
    removeCommandsById: $4f4c9e92d50d4f24$var$removeCommandsById,
    removeFromActiveRegistry: $4f4c9e92d50d4f24$var$removeFromActiveRegistry,
    performDialogCloseCommand: $4f4c9e92d50d4f24$var$performDialogCloseCommand,
    setAnalytics: $4f4c9e92d50d4f24$var$setAnalytics,
    setFallbackOverride: $4f4c9e92d50d4f24$var$setFallbackOverride,
    setHasPopupOverlay: $4f4c9e92d50d4f24$var$setHasPopupOverlay,
    forceSearchValue: $4f4c9e92d50d4f24$var$forceSearchValue,
    resetShouldForceSearchValue: $4f4c9e92d50d4f24$var$resetShouldForceSearchValue
};

});
parcelRegister("4DwnT", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b4088022dc3f5c54$export$639b7f41b0b47a01);

var $jh7L9 = parcelRequire("jh7L9");
const $b4088022dc3f5c54$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("h3eZO", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $dd5db8363c7eeda7$export$d75616d77443fe4e);

var $jh7L9 = parcelRequire("jh7L9");
const $dd5db8363c7eeda7$export$d75616d77443fe4e = (action)=>action?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});

parcelRegister("feUec", function(module, exports) {

$parcel$export(module.exports, "setEventAttribute", () => $dd73b01c41e7185b$export$7c0a9f4caaf7cfce);

var $5fc53 = parcelRequire("5fc53");

var $ctrpc = parcelRequire("ctrpc");
const $dd73b01c41e7185b$var$ACTIONS_TO_WATCH = [
    'unassign',
    'assignToMe'
];
const $dd73b01c41e7185b$export$7c0a9f4caaf7cfce = (attributes)=>{
    if (attributes.actionCategory === 'issueActions' && typeof attributes.action === 'string' && $dd73b01c41e7185b$var$ACTIONS_TO_WATCH.includes(attributes.action)) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().setAttributes((0, $5fc53.ASSIGNEE_TYPE), {
        isCommandPaletteEditing: true
    });
};

});
parcelRegister("5fc53", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $81f079589240b9b7$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $81f079589240b9b7$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $81f079589240b9b7$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $81f079589240b9b7$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $81f079589240b9b7$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $81f079589240b9b7$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $81f079589240b9b7$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $81f079589240b9b7$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $81f079589240b9b7$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $81f079589240b9b7$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $81f079589240b9b7$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $81f079589240b9b7$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $81f079589240b9b7$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $81f079589240b9b7$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $81f079589240b9b7$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $81f079589240b9b7$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $81f079589240b9b7$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $81f079589240b9b7$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $81f079589240b9b7$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $81f079589240b9b7$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $81f079589240b9b7$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $81f079589240b9b7$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $81f079589240b9b7$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $81f079589240b9b7$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $81f079589240b9b7$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $81f079589240b9b7$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $81f079589240b9b7$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $81f079589240b9b7$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $81f079589240b9b7$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $81f079589240b9b7$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $81f079589240b9b7$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $81f079589240b9b7$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $81f079589240b9b7$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $81f079589240b9b7$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $81f079589240b9b7$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $81f079589240b9b7$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $81f079589240b9b7$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $81f079589240b9b7$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $81f079589240b9b7$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $81f079589240b9b7$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $81f079589240b9b7$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $81f079589240b9b7$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $81f079589240b9b7$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $81f079589240b9b7$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $81f079589240b9b7$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $81f079589240b9b7$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $81f079589240b9b7$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $81f079589240b9b7$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $81f079589240b9b7$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $81f079589240b9b7$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $81f079589240b9b7$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $81f079589240b9b7$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $81f079589240b9b7$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $81f079589240b9b7$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $81f079589240b9b7$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $81f079589240b9b7$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $81f079589240b9b7$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $81f079589240b9b7$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $81f079589240b9b7$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $81f079589240b9b7$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $81f079589240b9b7$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $81f079589240b9b7$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $81f079589240b9b7$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $81f079589240b9b7$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $81f079589240b9b7$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $81f079589240b9b7$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $81f079589240b9b7$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $81f079589240b9b7$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "JCS_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$7fe9e7bac5a59952);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $81f079589240b9b7$export$798d2f5814884447);
$parcel$export(module.exports, "FORGE_STRING_TYPE", () => $81f079589240b9b7$export$1e188101081be3f8);
$parcel$export(module.exports, "FORGE_STRING_LIST_TYPE", () => $81f079589240b9b7$export$caf3b3f20c0589b9);
$parcel$export(module.exports, "FORGE_NUMBER_TYPE", () => $81f079589240b9b7$export$9bdf08a1276e866c);
$parcel$export(module.exports, "FORGE_DATE_TYPE", () => $81f079589240b9b7$export$996c3d3eb2880229);
$parcel$export(module.exports, "FORGE_DATETIME_TYPE", () => $81f079589240b9b7$export$578c5856bf684e2a);
$parcel$export(module.exports, "FORGE_USER_TYPE", () => $81f079589240b9b7$export$38791c0fdd0bcce);
$parcel$export(module.exports, "FORGE_USER_LIST_TYPE", () => $81f079589240b9b7$export$5c209e1debd6c274);
$parcel$export(module.exports, "FORGE_GROUP_TYPE", () => $81f079589240b9b7$export$8646fecba9a8be61);
$parcel$export(module.exports, "FORGE_GROUP_LIST_TYPE", () => $81f079589240b9b7$export$68b91cd2f2e6b810);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $81f079589240b9b7$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $81f079589240b9b7$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $81f079589240b9b7$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $81f079589240b9b7$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $81f079589240b9b7$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $81f079589240b9b7$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $81f079589240b9b7$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $81f079589240b9b7$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $81f079589240b9b7$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $81f079589240b9b7$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $81f079589240b9b7$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $81f079589240b9b7$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $81f079589240b9b7$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $81f079589240b9b7$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $81f079589240b9b7$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $81f079589240b9b7$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $81f079589240b9b7$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $81f079589240b9b7$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $81f079589240b9b7$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $81f079589240b9b7$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $81f079589240b9b7$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $81f079589240b9b7$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $81f079589240b9b7$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $81f079589240b9b7$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $81f079589240b9b7$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $81f079589240b9b7$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $81f079589240b9b7$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $81f079589240b9b7$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $81f079589240b9b7$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $81f079589240b9b7$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $81f079589240b9b7$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $81f079589240b9b7$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $81f079589240b9b7$export$34317c2d84a93553);
$parcel$export(module.exports, "ORGANIZATION_CF_TYPE", () => $81f079589240b9b7$export$c1e26582406f77ec);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $81f079589240b9b7$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $81f079589240b9b7$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $81f079589240b9b7$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $81f079589240b9b7$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $81f079589240b9b7$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $81f079589240b9b7$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $81f079589240b9b7$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $81f079589240b9b7$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $81f079589240b9b7$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $81f079589240b9b7$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $81f079589240b9b7$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $81f079589240b9b7$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $81f079589240b9b7$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $81f079589240b9b7$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $81f079589240b9b7$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $81f079589240b9b7$export$7b79405842547ccb);
$parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", () => $81f079589240b9b7$export$96201d0ae03ca323);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $81f079589240b9b7$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $81f079589240b9b7$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $81f079589240b9b7$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $81f079589240b9b7$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $81f079589240b9b7$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $81f079589240b9b7$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $81f079589240b9b7$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $81f079589240b9b7$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $81f079589240b9b7$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $81f079589240b9b7$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $81f079589240b9b7$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $81f079589240b9b7$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $81f079589240b9b7$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $81f079589240b9b7$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $81f079589240b9b7$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $81f079589240b9b7$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $81f079589240b9b7$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $81f079589240b9b7$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $81f079589240b9b7$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $81f079589240b9b7$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $81f079589240b9b7$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $81f079589240b9b7$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $81f079589240b9b7$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $81f079589240b9b7$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $81f079589240b9b7$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $81f079589240b9b7$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $81f079589240b9b7$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $81f079589240b9b7$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $81f079589240b9b7$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $81f079589240b9b7$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $81f079589240b9b7$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $81f079589240b9b7$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $81f079589240b9b7$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $81f079589240b9b7$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $81f079589240b9b7$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $81f079589240b9b7$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $81f079589240b9b7$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $81f079589240b9b7$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $81f079589240b9b7$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $81f079589240b9b7$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $81f079589240b9b7$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $81f079589240b9b7$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $81f079589240b9b7$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $81f079589240b9b7$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $81f079589240b9b7$export$b5358afda8ff335e);
$parcel$export(module.exports, "JOURNEY_PANEL_TYPE", () => $81f079589240b9b7$export$d2a475ff30e5bf97);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $81f079589240b9b7$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $81f079589240b9b7$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $81f079589240b9b7$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $81f079589240b9b7$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $81f079589240b9b7$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $81f079589240b9b7$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "WORKLOG", () => $81f079589240b9b7$export$df36fc05622c402);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $81f079589240b9b7$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $81f079589240b9b7$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $81f079589240b9b7$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "DETAILS_PANEL_IN_EDIT_MODE", () => $81f079589240b9b7$export$f4909db381566ce3);
$parcel$export(module.exports, "ARE_FIELDS_REORDERED", () => $81f079589240b9b7$export$6159d4eb69c78696);
$parcel$export(module.exports, "HIDE_EMPTY_FIELDS", () => $81f079589240b9b7$export$962c5b8782b7a233);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $81f079589240b9b7$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $81f079589240b9b7$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $81f079589240b9b7$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $81f079589240b9b7$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $81f079589240b9b7$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $81f079589240b9b7$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $81f079589240b9b7$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $81f079589240b9b7$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $81f079589240b9b7$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $81f079589240b9b7$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $81f079589240b9b7$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $81f079589240b9b7$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $81f079589240b9b7$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $81f079589240b9b7$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $81f079589240b9b7$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $81f079589240b9b7$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $81f079589240b9b7$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $81f079589240b9b7$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $81f079589240b9b7$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "AGGREGATE_TIME_ORIGINAL_ESTIMATE", () => $81f079589240b9b7$export$871661506c0a91ea);
$parcel$export(module.exports, "AGGREGATE_TIME_ESTIMATE", () => $81f079589240b9b7$export$4a7ecfe931ab6c07);
$parcel$export(module.exports, "PROGRESS", () => $81f079589240b9b7$export$fbc5ebe2e580bf8b);
$parcel$export(module.exports, "AGGREGATE_PROGRESS", () => $81f079589240b9b7$export$aa3b37e271efd578);
$parcel$export(module.exports, "WORKRATIO", () => $81f079589240b9b7$export$444bffe6526fb5f2);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $81f079589240b9b7$export$3c3e26aadbfa2c32);

var $8QpSo = parcelRequire("8QpSo");

var $4R6GH = parcelRequire("4R6GH");
const $81f079589240b9b7$export$b144116dae474c88 = 'issue-link-search';
const $81f079589240b9b7$export$bc917bc699b25f75 = 'number';
const $81f079589240b9b7$export$5f26ca419fdffbe7 = 'string';
const $81f079589240b9b7$export$ce9bfd823c7e1a6d = 'datetime';
const $81f079589240b9b7$export$346b72b1f7cd6d5a = 'date';
const $81f079589240b9b7$export$b20fbcacd7942c2a = 'option2';
const $81f079589240b9b7$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $81f079589240b9b7$export$a2e8554bffc61ece = 'any';
const $81f079589240b9b7$export$f25cd4907cbb25b9 = 'array';
const $81f079589240b9b7$export$5600354b43577e17 = 'user';
const $81f079589240b9b7$export$5dbc9917f72d0d2a = 'group';
const $81f079589240b9b7$export$253649f07fb55948 = 'object';
const $81f079589240b9b7$export$eb39592ba5247ee7 = 'group-list';
const $81f079589240b9b7$export$f48a9be226105736 = 'array-string';
const $81f079589240b9b7$export$42e2e93fc721df5d = 'version';
const $81f079589240b9b7$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$7773375e72c953ed = 'approval-panel';
const $81f079589240b9b7$export$80ad0037098f3919 = 'project';
const $81f079589240b9b7$export$82db8a26de491dd2 = 'array';
const $81f079589240b9b7$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $81f079589240b9b7$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $81f079589240b9b7$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $81f079589240b9b7$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $81f079589240b9b7$export$c979d9c548c05133 = 'JiraBooleanField';
const $81f079589240b9b7$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $81f079589240b9b7$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $81f079589240b9b7$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $81f079589240b9b7$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $81f079589240b9b7$export$b0deb225eed90fbd = 'JiraCMDBField';
const $81f079589240b9b7$export$add3775cfea8fde3 = 'JiraColorField';
const $81f079589240b9b7$export$9631d4098abab3eb = 'JiraComponentsField';
const $81f079589240b9b7$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $81f079589240b9b7$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $81f079589240b9b7$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $81f079589240b9b7$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $81f079589240b9b7$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $81f079589240b9b7$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $81f079589240b9b7$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $81f079589240b9b7$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $81f079589240b9b7$export$6d8da4497234455 = 'JiraEpicLinkField';
const $81f079589240b9b7$export$9bcfac568e4fa59c = 'JiraFlagField';
const $81f079589240b9b7$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $81f079589240b9b7$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $81f079589240b9b7$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $81f079589240b9b7$export$810709f0c5c2e9db = 'JiraLabelsField';
const $81f079589240b9b7$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $81f079589240b9b7$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $81f079589240b9b7$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $81f079589240b9b7$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $81f079589240b9b7$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $81f079589240b9b7$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $81f079589240b9b7$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $81f079589240b9b7$export$31aea7548807c6b5 = 'JiraPeopleField';
const $81f079589240b9b7$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $81f079589240b9b7$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $81f079589240b9b7$export$12f54499c6252188 = 'JiraProjectField';
const $81f079589240b9b7$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $81f079589240b9b7$export$c69486dd643dfb69 = 'JiraReporterField';
const $81f079589240b9b7$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $81f079589240b9b7$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $81f079589240b9b7$export$37f4daaa7b409554 = 'JiraRichTextField';
const $81f079589240b9b7$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $81f079589240b9b7$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $81f079589240b9b7$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $81f079589240b9b7$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $81f079589240b9b7$export$e40f819979b3881d = 'JiraStatusField';
const $81f079589240b9b7$export$6c243704a22baffe = 'JiraTeamField';
const $81f079589240b9b7$export$6c32429bac235203 = 'JiraTeamViewField';
const $81f079589240b9b7$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $81f079589240b9b7$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $81f079589240b9b7$export$37ccd11f08a93ccb = 'JiraUrlField';
const $81f079589240b9b7$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $81f079589240b9b7$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $81f079589240b9b7$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $81f079589240b9b7$export$aa815aaa741ae18 = 'JiraWatchesField';
const $81f079589240b9b7$export$e805f89b15d2abf4 = 'JiraAssetField';
const $81f079589240b9b7$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $81f079589240b9b7$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $81f079589240b9b7$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $81f079589240b9b7$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $81f079589240b9b7$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $81f079589240b9b7$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $81f079589240b9b7$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $81f079589240b9b7$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $81f079589240b9b7$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $81f079589240b9b7$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $81f079589240b9b7$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $81f079589240b9b7$export$c48132adab502d6b = 'JiraForgeUsersField';
const $81f079589240b9b7$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $81f079589240b9b7$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $81f079589240b9b7$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $81f079589240b9b7$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $81f079589240b9b7$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $81f079589240b9b7$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $81f079589240b9b7$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $81f079589240b9b7$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $81f079589240b9b7$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $81f079589240b9b7$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $81f079589240b9b7$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $81f079589240b9b7$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $81f079589240b9b7$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $81f079589240b9b7$export$bfcb1a91094f113a = 'JiraGoalsField';
const $81f079589240b9b7$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $81f079589240b9b7$export$7fe9e7bac5a59952 = 'JiraCustomerServiceOrganizationField';
const $81f079589240b9b7$export$798d2f5814884447 = 'forgeCustomField';
const $81f079589240b9b7$export$1e188101081be3f8 = 'forge/string';
const $81f079589240b9b7$export$caf3b3f20c0589b9 = 'forge/string-list';
const $81f079589240b9b7$export$9bdf08a1276e866c = 'forge/number';
const $81f079589240b9b7$export$996c3d3eb2880229 = 'forge/date';
const $81f079589240b9b7$export$578c5856bf684e2a = 'forge/datetime';
const $81f079589240b9b7$export$38791c0fdd0bcce = 'forge/user';
const $81f079589240b9b7$export$5c209e1debd6c274 = 'forge/user-list';
const $81f079589240b9b7$export$8646fecba9a8be61 = 'forge/group';
const $81f079589240b9b7$export$68b91cd2f2e6b810 = 'forge/group-list';
const $81f079589240b9b7$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $81f079589240b9b7$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $81f079589240b9b7$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $81f079589240b9b7$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $81f079589240b9b7$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $81f079589240b9b7$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $81f079589240b9b7$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $81f079589240b9b7$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $81f079589240b9b7$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $81f079589240b9b7$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $81f079589240b9b7$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $81f079589240b9b7$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $81f079589240b9b7$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $81f079589240b9b7$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $81f079589240b9b7$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $81f079589240b9b7$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $81f079589240b9b7$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $81f079589240b9b7$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $81f079589240b9b7$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $81f079589240b9b7$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $81f079589240b9b7$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $81f079589240b9b7$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $81f079589240b9b7$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $81f079589240b9b7$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $81f079589240b9b7$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $81f079589240b9b7$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $81f079589240b9b7$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $81f079589240b9b7$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $81f079589240b9b7$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $81f079589240b9b7$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $81f079589240b9b7$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $81f079589240b9b7$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $81f079589240b9b7$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $81f079589240b9b7$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $81f079589240b9b7$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $81f079589240b9b7$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $81f079589240b9b7$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
const $81f079589240b9b7$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $81f079589240b9b7$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $81f079589240b9b7$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $81f079589240b9b7$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $81f079589240b9b7$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $81f079589240b9b7$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $81f079589240b9b7$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $81f079589240b9b7$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $81f079589240b9b7$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $81f079589240b9b7$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $81f079589240b9b7$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $81f079589240b9b7$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $81f079589240b9b7$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $81f079589240b9b7$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $81f079589240b9b7$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $81f079589240b9b7$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $81f079589240b9b7$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $81f079589240b9b7$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $81f079589240b9b7$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $81f079589240b9b7$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $81f079589240b9b7$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $81f079589240b9b7$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $81f079589240b9b7$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $81f079589240b9b7$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $81f079589240b9b7$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $81f079589240b9b7$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $81f079589240b9b7$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $81f079589240b9b7$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $81f079589240b9b7$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $81f079589240b9b7$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $81f079589240b9b7$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $81f079589240b9b7$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $81f079589240b9b7$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $81f079589240b9b7$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $81f079589240b9b7$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $81f079589240b9b7$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $81f079589240b9b7$export$fba8634fd401ba8b = 'assignee';
const $81f079589240b9b7$export$a91aea2438afcce8 = 'reporter';
const $81f079589240b9b7$export$b159f8b8f27aae4c = 'duedate';
const $81f079589240b9b7$export$34740f8d07d23ac0 = 'priority';
const $81f079589240b9b7$export$43b6e33ec70f2272 = 'labels';
const $81f079589240b9b7$export$ff39ebd4bb12b718 = 'created';
const $81f079589240b9b7$export$cd8e68094cb5c3cb = 'updated';
const $81f079589240b9b7$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $81f079589240b9b7$export$37abf56f13f61ec5 = 'components';
const $81f079589240b9b7$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $81f079589240b9b7$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $81f079589240b9b7$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $81f079589240b9b7$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $81f079589240b9b7$export$791007408faf42f4 = 'servicedesk-incident-management';
const $81f079589240b9b7$export$827a1c600bac12a3 = 'devSummary';
const $81f079589240b9b7$export$e9ba671d077969f8 = 'releases';
const $81f079589240b9b7$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $81f079589240b9b7$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $81f079589240b9b7$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $81f079589240b9b7$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $81f079589240b9b7$export$a5c9f63aadcb220 = 'fixVersions';
const $81f079589240b9b7$export$94009605902e4fe5 = 'versions';
const $81f079589240b9b7$export$5e7324042f1d6b31 = 'description';
const $81f079589240b9b7$export$113281d03e6830ef = 'environment';
const $81f079589240b9b7$export$5ff798870a3dffbf = 'watches';
const $81f079589240b9b7$export$907219511d14ba3d = 'summary';
const $81f079589240b9b7$export$d09aa6a4f3538063 = 'proforma-forms';
const $81f079589240b9b7$export$3aca8c91b58a42e2 = 'resolution';
const $81f079589240b9b7$export$ccb5ffefbf8b987c = 'timetracking';
const $81f079589240b9b7$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $81f079589240b9b7$export$358267065be1e = 'status';
const $81f079589240b9b7$export$dcaa788c7ada56de = 'statusCategory';
const $81f079589240b9b7$export$ebb48b08205007c5 = 'issuetype';
const $81f079589240b9b7$export$5e91047fe9955d0e = 'issuekey';
const $81f079589240b9b7$export$3b3d0889022c85b3 = 'children-issues';
const $81f079589240b9b7$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $81f079589240b9b7$export$8fe3d5be8cb17459 = 'epic-issues';
const $81f079589240b9b7$export$335851d83a79891 = 'hierarchy-level-below';
const $81f079589240b9b7$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $81f079589240b9b7$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $81f079589240b9b7$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $81f079589240b9b7$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $81f079589240b9b7$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $81f079589240b9b7$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $81f079589240b9b7$export$7b3d247435a784fa = 'SLA_PANEL';
const $81f079589240b9b7$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $81f079589240b9b7$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $81f079589240b9b7$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $81f079589240b9b7$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $81f079589240b9b7$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $81f079589240b9b7$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $81f079589240b9b7$export$d2a475ff30e5bf97 = 'JOURNEY_PANEL';
const $81f079589240b9b7$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $81f079589240b9b7$export$22f61ccc2730431f = 'similar-issues';
const $81f079589240b9b7$export$8bbb446f57294715 = 'subtasks';
const $81f079589240b9b7$export$34fcd7cb291a1e4d = 'votes';
const $81f079589240b9b7$export$5e93f2a57cc4ca3a = 'parent';
const $81f079589240b9b7$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$91a9dba2d38d9a6f = 'project';
const $81f079589240b9b7$export$df36fc05622c402 = 'worklog';
const $81f079589240b9b7$export$ede0a4c20124ec85 = 'timespent';
const $81f079589240b9b7$export$3eeb79d48fb5f667 = 'dataclassification';
const $81f079589240b9b7$export$45e72c9a63ab61ab = 'SENTIMENT';
const $81f079589240b9b7$export$f4909db381566ce3 = 'DETAILS_PANEL_IN_EDIT_MODE';
const $81f079589240b9b7$export$6159d4eb69c78696 = 'ARE_FIELDS_REORDERED';
const $81f079589240b9b7$export$962c5b8782b7a233 = 'HIDE_EMPTY_FIELDS';
const $81f079589240b9b7$export$99ad62164189f781 = 'ecosystemGlance';
const $81f079589240b9b7$export$7719ef6e9283671 = 'forgeGlance';
const $81f079589240b9b7$export$bfebea5ce2e1887a = 'ecosystemContext';
const $81f079589240b9b7$export$be8e68fb1aed253e = 'forgeContext';
const $81f079589240b9b7$export$84e5674890d55030 = 'issuerestriction';
const $81f079589240b9b7$export$326a5522a485e43d = 'security';
const $81f079589240b9b7$export$c9f3f01e2c535302 = 'securitylevel';
const $81f079589240b9b7$export$35e5652f764785bd = 'creator';
const $81f079589240b9b7$export$66519f3bbff1796a = 'team';
const $81f079589240b9b7$export$a4ee0bca77cc8463 = 'estimate';
const $81f079589240b9b7$export$fed53408e89e0497 = 'dueDate';
const $81f079589240b9b7$export$d53c26f9ce31f56b = 'targetStart';
const $81f079589240b9b7$export$48f82d653f85e459 = 'targetEnd';
const $81f079589240b9b7$export$ea5a888f39f722c7 = 'startDate';
const $81f079589240b9b7$export$f245bbec12cc0e40 = 'color';
const $81f079589240b9b7$export$aed630b4b7114a59 = 'attachment';
const $81f079589240b9b7$export$b50c1a8fef07104 = 'issuelinks';
const $81f079589240b9b7$export$ea3d72f4bb7738ba = 'timeestimate';
const $81f079589240b9b7$export$a4cab0124760d860 = 'comment';
const $81f079589240b9b7$export$734929aef118d7e2 = 'worklog';
const $81f079589240b9b7$export$ffbacacb07c1d46d = 'parent';
const $81f079589240b9b7$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $81f079589240b9b7$export$278c072e2f9176ab = 'aggregatetimespent';
const $81f079589240b9b7$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $81f079589240b9b7$export$fbc5ebe2e580bf8b = 'progress';
const $81f079589240b9b7$export$aa3b37e271efd578 = 'aggregateprogress';
const $81f079589240b9b7$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $81f079589240b9b7$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $81f079589240b9b7$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $81f079589240b9b7$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $81f079589240b9b7$export$34740f8d07d23ac0,
        REPORTER_TYPE: $81f079589240b9b7$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $81f079589240b9b7$export$5e7324042f1d6b31,
        LABELS_TYPE: $81f079589240b9b7$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $81f079589240b9b7$export$37abf56f13f61ec5,
        SPRINT_TYPE: $81f079589240b9b7$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $81f079589240b9b7$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $81f079589240b9b7$export$269d70c1b1c9fb80,
        FIX_VERSIONS_TYPE: $81f079589240b9b7$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $81f079589240b9b7$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $81f079589240b9b7$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $81f079589240b9b7$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $81f079589240b9b7$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $81f079589240b9b7$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $81f079589240b9b7$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $81f079589240b9b7$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $81f079589240b9b7$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $81f079589240b9b7$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $81f079589240b9b7$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $81f079589240b9b7$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $81f079589240b9b7$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $81f079589240b9b7$export$c7ae0622b0bd5d56,
        ASSETS_CF_TYPE: $81f079589240b9b7$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $81f079589240b9b7$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $81f079589240b9b7$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $81f079589240b9b7$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $81f079589240b9b7$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $81f079589240b9b7$export$e9ba671d077969f8,
        BASELINE_START_CF_TYPE: $81f079589240b9b7$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $81f079589240b9b7$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $81f079589240b9b7$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $81f079589240b9b7$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $81f079589240b9b7$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $81f079589240b9b7$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $81f079589240b9b7$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $81f079589240b9b7$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $81f079589240b9b7$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $81f079589240b9b7$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $81f079589240b9b7$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $81f079589240b9b7$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $81f079589240b9b7$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $81f079589240b9b7$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $81f079589240b9b7$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $81f079589240b9b7$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $81f079589240b9b7$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $81f079589240b9b7$export$39866626496bbfc8,
        VERSION_CF_TYPE: $81f079589240b9b7$export$24382b4e8c58336b,
        DATE_CF_TYPE: $81f079589240b9b7$export$ff745f432984005d,
        GROUP_CF_TYPE: $81f079589240b9b7$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $81f079589240b9b7$export$b600addfa3355c57,
        USER_CF_TYPE: $81f079589240b9b7$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $81f079589240b9b7$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $81f079589240b9b7$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $81f079589240b9b7$export$65524be5675e57e6,
        TEAM_CF_TYPE: $81f079589240b9b7$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $81f079589240b9b7$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $81f079589240b9b7$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $81f079589240b9b7$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $81f079589240b9b7$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $81f079589240b9b7$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $81f079589240b9b7$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $81f079589240b9b7$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $81f079589240b9b7$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $81f079589240b9b7$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $81f079589240b9b7$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $81f079589240b9b7$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $81f079589240b9b7$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $81f079589240b9b7$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $81f079589240b9b7$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $81f079589240b9b7$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $81f079589240b9b7$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $81f079589240b9b7$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $81f079589240b9b7$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $81f079589240b9b7$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $81f079589240b9b7$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $81f079589240b9b7$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $81f079589240b9b7$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $81f079589240b9b7$export$2bbb7f69c97ea279,
        PARENT_TYPE: $81f079589240b9b7$export$5e93f2a57cc4ca3a,
        FORGE_CONTEXT_TYPE: $81f079589240b9b7$export$be8e68fb1aed253e,
        SENTIMENT_CF_TYPE: $81f079589240b9b7$export$c23cfbdf83daa90d
    };
    Object.assign(types, {
        SENTIMENT_TYPE: $81f079589240b9b7$export$45e72c9a63ab61ab
    });
    if ((0, $4R6GH.fg)('jsm-journey-builder-in-issue-view')) Object.assign(types, {
        JOURNEY_PANEL_TYPE: $81f079589240b9b7$export$d2a475ff30e5bf97
    });
    return types;
};
const $81f079589240b9b7$export$3c3e26aadbfa2c32 = (0, $8QpSo.default)($81f079589240b9b7$var$getLayoutFieldTypesNonMemoized);

});

parcelRegister("ctrpc", function(module, exports) {

$parcel$export(module.exports, "eventFlowManager", () => $a32e213c0a4381f7$export$87846400a9b428fc);
$parcel$export(module.exports, "getUpdateAnalyticsFlowHelper", () => $a32e213c0a4381f7$export$f3b2b77402b2631f);

var $7Jxgt = parcelRequire("7Jxgt");

var $2YZCu = parcelRequire("2YZCu");

var $8zOmE = parcelRequire("8zOmE");

var $8ikZj = parcelRequire("8ikZj");

var $bximr = parcelRequire("bximr");
/**
 * A singleton class to provide a sessionId to track update of fields
 */ class $a32e213c0a4381f7$var$EventFlowManager {
    reset() {
        this.ids.clear();
        this.extraAttributes.clear();
    }
    push(key) {
        const id = (0, $7Jxgt.v4)();
        this.ids.set(key, id);
        return id;
    }
    pull(key, shouldDelete = true) {
        const value = this.ids.get(key);
        if (shouldDelete) this.ids.delete(key);
        return value;
    }
    constructor(){
        this.ids = new Map();
        this.extraAttributes = new Map();
    }
}
const $a32e213c0a4381f7$export$87846400a9b428fc = new $a32e213c0a4381f7$var$EventFlowManager();
/**
 * Concatenates updateSessionId, default attributes and the attributes sent through
 *  the event and/or setAttributes
 */ const $a32e213c0a4381f7$var$concatAttributes = (fieldKey, updateSessionId, attributes)=>{
    let fieldTypeValue = attributes.fieldType;
    const extraAttributes = $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.get(fieldKey);
    fieldTypeValue = extraAttributes?.fieldType ?? fieldTypeValue;
    const fieldType = fieldTypeValue && (0, $8ikZj.FIELD_TYPE_MAP)[fieldTypeValue] ? (0, $8ikZj.FIELD_TYPE_MAP)[fieldTypeValue] : fieldTypeValue;
    return {
        updateSessionId: updateSessionId,
        ...(0, $8ikZj.DEFAULT_ATTRIBUTES),
        ...attributes,
        ...extraAttributes,
        fieldKey: fieldKey,
        fieldType: fieldType
    };
};
const $a32e213c0a4381f7$var$hasError = (e)=>e instanceof Error;
/**
 * Provides three events START {@link fireAnalyticsStart},
 * END {@link fireAnalyticsEnd} to track the user flow when updating
 * a field and setAttributes{@link setAttributes} to set specific
 * fields attributes
 */ const $a32e213c0a4381f7$var$updateAnalyticsFlowHelper = {
    fireAnalyticsStart (fieldKey, params) {
        try {
            const { assigneeId: assigneeId, product: product } = (0, $bximr.getContextAssigneeIdAndProduct)(params.analytics.context);
            if (product === 'serviceDesk') return;
            $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                ...params.attributes,
                assigneeId: assigneeId
            });
            const sessionid = $a32e213c0a4381f7$export$87846400a9b428fc.push(fieldKey);
            const attributes = $a32e213c0a4381f7$var$concatAttributes(fieldKey, sessionid, params.attributes);
            attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $8zOmE.fireUIAnalytics)(params.analytics, `${(0, $8ikZj.START_ACTION_SUBJECT)} ${(0, $8ikZj.START_ACTION)}`, (0, $8ikZj.START_ACTION_SUBJECT_ID), attributes);
        } catch (e) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsStart', $a32e213c0a4381f7$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    fireAnalyticsEnd (fieldKey, params, isEndOfSession = true) {
        try {
            if ((0, $bximr.getContextProduct)(params.analytics.context) === 'serviceDesk') return;
            const sessionid = $a32e213c0a4381f7$export$87846400a9b428fc.pull(fieldKey, isEndOfSession);
            const isFieldKeyUnknown = (0, $8ikZj.UNKNOWN_FIELD_IDS).includes(fieldKey);
            const actualFieldKey = isFieldKeyUnknown && params.attributes.fieldKey && typeof params.attributes.fieldKey === 'string' ? params.attributes.fieldKey : fieldKey;
            const attributes = $a32e213c0a4381f7$var$concatAttributes(actualFieldKey, sessionid, params.attributes);
            if (isEndOfSession) {
                if (isFieldKeyUnknown) $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
                $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(actualFieldKey);
            }
            attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $8zOmE.fireTrackAnalytics)(params.analytics, `${(0, $8ikZj.END_ACTION_SUBJECT)} ${(0, $8ikZj.END_ACTION)}`, (0, $8ikZj.END_ACTION_SUBJECT_ID), {
                ...attributes,
                is_new_1event: true
            });
        } catch (e) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsEnd', $a32e213c0a4381f7$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    setAttributes (fieldKey, attributes) {
        const currentAttributes = $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.get(fieldKey);
        $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
            ...currentAttributes,
            ...attributes
        });
    },
    setActionTakenAttributes (fieldKey, oldValId, newValId) {
        if (oldValId !== newValId) this.setAttributes(fieldKey, {
            oldValId: oldValId,
            newValId: newValId,
            actionTaken: (0, $bximr.getActionTaken)(oldValId, newValId)
        });
    },
    // Use this to clean up session without firing analytics event. This happens for entity fields when
    // multiple end events can be fired after a start event
    endSession (fieldKey) {
        $a32e213c0a4381f7$export$87846400a9b428fc.pull(fieldKey);
        $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
    },
    reset () {
        $a32e213c0a4381f7$export$87846400a9b428fc.reset();
    }
};
const $a32e213c0a4381f7$export$f3b2b77402b2631f = ()=>$a32e213c0a4381f7$var$updateAnalyticsFlowHelper;

});
parcelRegister("8ikZj", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ATTRIBUTES", () => $ba1d12fd09beb370$export$69665899d8392309);
$parcel$export(module.exports, "START_ACTION", () => $ba1d12fd09beb370$export$c0a4673e0c78e972);
$parcel$export(module.exports, "START_ACTION_SUBJECT", () => $ba1d12fd09beb370$export$34a5ae354a38cc7e);
$parcel$export(module.exports, "START_ACTION_SUBJECT_ID", () => $ba1d12fd09beb370$export$bc373f59492dc6e2);
$parcel$export(module.exports, "END_ACTION", () => $ba1d12fd09beb370$export$b19686c1fe99f85a);
$parcel$export(module.exports, "END_ACTION_SUBJECT", () => $ba1d12fd09beb370$export$4ce67e80878d47ed);
$parcel$export(module.exports, "END_ACTION_SUBJECT_ID", () => $ba1d12fd09beb370$export$e3d957ccc2d46469);
$parcel$export(module.exports, "ACTION_TAKEN_ADD", () => $ba1d12fd09beb370$export$3b3e3ac6d7f6e219);
$parcel$export(module.exports, "ACTION_TAKEN_REMOVE", () => $ba1d12fd09beb370$export$6137e1b2fcde2333);
$parcel$export(module.exports, "DRAG_DROP_UNKNOWN_FIELD_ID", () => $ba1d12fd09beb370$export$6d8c364f9d389764);
$parcel$export(module.exports, "UNKNOWN_FIELD_IDS", () => $ba1d12fd09beb370$export$7d1d20ff891eeb26);
$parcel$export(module.exports, "FIELD_TYPE_MAP", () => $ba1d12fd09beb370$export$d8ccf495ccc97a69);
$parcel$export(module.exports, "ENTITY_FIELD_KEYS", () => $ba1d12fd09beb370$export$7d9dd31e187cb2db);

var $5fc53 = parcelRequire("5fc53");
const $ba1d12fd09beb370$export$69665899d8392309 = {
    isInlineEditing: false,
    isCommandPaletteEditing: false,
    isDragEditing: false,
    isContextMenuEditing: false,
    isIssueViewEditing: false
};
const $ba1d12fd09beb370$export$c0a4673e0c78e972 = 'clicked';
const $ba1d12fd09beb370$export$34a5ae354a38cc7e = 'item';
const $ba1d12fd09beb370$export$bc373f59492dc6e2 = 'issue';
const $ba1d12fd09beb370$export$b19686c1fe99f85a = 'updated';
const $ba1d12fd09beb370$export$4ce67e80878d47ed = 'issue';
const $ba1d12fd09beb370$export$e3d957ccc2d46469 = 'ended';
const $ba1d12fd09beb370$export$3b3e3ac6d7f6e219 = 'add';
const $ba1d12fd09beb370$export$6137e1b2fcde2333 = 'remove';
const $ba1d12fd09beb370$export$6d8c364f9d389764 = 'unknown';
const $ba1d12fd09beb370$export$7d1d20ff891eeb26 = [
    $ba1d12fd09beb370$export$6d8c364f9d389764
];
const $ba1d12fd09beb370$export$403ea87111529de = {
    [(0, $5fc53.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: 'versions',
    [(0, $5fc53.VERSION_CF_TYPE)]: 'versions',
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $5fc53.SPRINT_TYPE)]: 'link',
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $5fc53.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $5fc53.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $5fc53.USER_CF_TYPE)]: 'singleUser',
    [(0, $5fc53.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $5fc53.URL_CF_TYPE)]: 'url',
    [(0, $5fc53.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: 'multiGroup'
};
const $ba1d12fd09beb370$export$d8ccf495ccc97a69 = {
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: 'affectsVersions',
    [(0, $5fc53.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $5fc53.ATTACHMENT_TYPE)]: 'attachment',
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: 'cascadingSelect',
    [(0, $5fc53.COMPONENTS_TYPE)]: 'components',
    [(0, $5fc53.DATE_CF_TYPE)]: 'date',
    [(0, $5fc53.DATETIME_CF_TYPE)]: 'dateTime',
    [(0, $5fc53.DESCRIPTION_TYPE)]: 'richText',
    [(0, $5fc53.DUE_DATE_TYPE)]: 'date',
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: 'fixVersions',
    [(0, $5fc53.FLAGGED_CF_TYPE)]: 'flag',
    [(0, $5fc53.GOALS_CF_TYPE)]: 'goals',
    [(0, $5fc53.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $5fc53.ISSUE_TYPE)]: 'issuetype',
    [(0, $5fc53.LABELS_CF_TYPE)]: 'labels',
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: 'multiGroup',
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $5fc53.NUMBER_CF_TYPE)]: 'float',
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $5fc53.PARENT_TYPE)]: 'parent',
    [(0, $5fc53.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.PRIORITY_TYPE)]: 'priority',
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: 'project',
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $5fc53.RANK_CF_TYPE)]: 'rank',
    [(0, $5fc53.START_DATE_TYPE)]: 'date',
    [(0, $5fc53.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $5fc53.SPRINT_TYPE)]: 'sprint',
    [(0, $5fc53.STATUS_TYPE)]: 'status',
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: 'storyPointEstimate',
    [(0, $5fc53.STORY_POINTS_TYPE)]: 'storyPointEstimate',
    [(0, $5fc53.SUMMARY_TYPE)]: 'singleLineText',
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: 'team',
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $5fc53.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $5fc53.TIME_ESTIMATE_TYPE)]: 'originalTimeEstimate',
    [(0, $5fc53.TIME_TRACKING_TYPE)]: 'timeTracking',
    [(0, $5fc53.URL_CF_TYPE)]: 'url',
    [(0, $5fc53.USER_CF_TYPE)]: 'singleUser',
    [(0, $5fc53.VERSION_CF_TYPE)]: 'version',
    [(0, $5fc53.VOTES_TYPE)]: 'votes',
    [(0, $5fc53.WATCHES_TYPE)]: 'watchers'
};
const $ba1d12fd09beb370$export$7d9dd31e187cb2db = {
    WEB_LINK: 'weblink',
    ATTACHMENT: 'attachment',
    ISSUE_LINKS: 'linkIssue',
    PARENT: 'parent'
};

});

parcelRegister("bximr", function(module, exports) {

$parcel$export(module.exports, "getActionTaken", () => $440267fcdb63291a$export$9d814e3464362b48);
$parcel$export(module.exports, "getContextAssigneeIdAndProduct", () => $440267fcdb63291a$export$e6dd41ec8f1794f6);
$parcel$export(module.exports, "getContextProduct", () => $440267fcdb63291a$export$4cb0aa9574634a48);

var $8ikZj = parcelRequire("8ikZj");
const $440267fcdb63291a$export$9d814e3464362b48 = (oldValId, newValId)=>{
    if (oldValId !== newValId) {
        if (newValId === null) return 0, $8ikZj.ACTION_TAKEN_REMOVE;
        if (oldValId === null || oldValId === undefined) return 0, $8ikZj.ACTION_TAKEN_ADD;
    }
    return undefined;
};
const $440267fcdb63291a$export$e6dd41ec8f1794f6 = (context)=>{
    let assigneeId;
    let product;
    for (const item of context){
        if (item?.attributes?.assigneeId) assigneeId = item.attributes.assigneeId;
        if (item?.attributes?.previousSubProduct) product = item.attributes.previousSubProduct;
        if (assigneeId && product) break;
    }
    return {
        assigneeId: assigneeId,
        product: product
    };
};
const $440267fcdb63291a$export$4cb0aa9574634a48 = (context)=>{
    for (const item of context){
        if (item?.attributes?.previousSubProduct) return item.attributes.previousSubProduct;
    }
};

});










parcelRegister("5SjJK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $95c4262fb06a7b0d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $95c4262fb06a7b0d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    projectNavigation: {
        "id": "horizontal-nav-common.common.tab-shortcut-context.project-navigation",
        "defaultMessage": "Project navigation"
    },
    goTo: {
        "id": "horizontal-nav-common.common.tab-shortcut-context.go-to",
        "defaultMessage": "Go to {label}"
    }
});

});


parcelRegister("cUcEa", function(module, exports) {

$parcel$export(module.exports, "RENAME_ONBOARDING", () => $dcaed4e80c6c1d23$export$8b943171fca14870);
$parcel$export(module.exports, "SAVE_VIEW_ONBOARDING", () => $dcaed4e80c6c1d23$export$a5717569cf53d503);
$parcel$export(module.exports, "SavedViewsOnboardingInitializer", () => $dcaed4e80c6c1d23$export$816ee139d9a87d77);
$parcel$export(module.exports, "useOnboarding", () => $dcaed4e80c6c1d23$export$5520b3b17c256ea3);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $i205g = parcelRequire("i205g");

var $6s1PB = parcelRequire("6s1PB");
const $dcaed4e80c6c1d23$var$TTL_SEEN = 31536000000; // ~ 365 days
const $dcaed4e80c6c1d23$export$8b943171fca14870 = 'board-saved-views-rename';
const $dcaed4e80c6c1d23$export$a5717569cf53d503 = 'board-saved-views-save-view';
const $dcaed4e80c6c1d23$var$actions = {
    initialize: (seenItResponse)=>({ setState: setState })=>{
            setState({
                [$dcaed4e80c6c1d23$export$8b943171fca14870]: seenItResponse[$dcaed4e80c6c1d23$export$8b943171fca14870]?.status !== true,
                [$dcaed4e80c6c1d23$export$a5717569cf53d503]: seenItResponse[$dcaed4e80c6c1d23$export$a5717569cf53d503]?.status !== true
            });
        },
    markAsSeen: (key)=>({ setState: setState, getState: getState })=>setState({
                ...getState(),
                [key]: false
            })
};
const $dcaed4e80c6c1d23$var$store = (0, $iXqE5.createStore)({
    name: 'SavedViewsOnboardingStore',
    initialState: {
        [$dcaed4e80c6c1d23$export$8b943171fca14870]: false,
        [$dcaed4e80c6c1d23$export$a5717569cf53d503]: false
    },
    actions: $dcaed4e80c6c1d23$var$actions
});
const $dcaed4e80c6c1d23$var$useActions = (0, $3sQ5x.createActionsHook)($dcaed4e80c6c1d23$var$store);
const $dcaed4e80c6c1d23$var$getOnboardingByKey = (state, args)=>state[args[0]];
const $dcaed4e80c6c1d23$var$useOnboardingState = (0, $3sQ5x.createStateHook)($dcaed4e80c6c1d23$var$store, {
    selector: $dcaed4e80c6c1d23$var$getOnboardingByKey
});
const $dcaed4e80c6c1d23$export$816ee139d9a87d77 = ()=>{
    const { initialize: initialize } = $dcaed4e80c6c1d23$var$useActions();
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $6s1PB.expVal)('saved_views', 'enabled', false)) return;
        if (false) return;
        (0, $i205g.getFlags)({
            [$dcaed4e80c6c1d23$export$8b943171fca14870]: {},
            [$dcaed4e80c6c1d23$export$a5717569cf53d503]: {}
        }).then(initialize).catch(()=>{
        // Ignore errors
        });
    }, [
        initialize
    ]);
    return null;
};
const $dcaed4e80c6c1d23$export$5520b3b17c256ea3 = (key)=>{
    const { markAsSeen: markAsSeen } = $dcaed4e80c6c1d23$var$useActions();
    const isOnboardingVisible = $dcaed4e80c6c1d23$var$useOnboardingState([
        key
    ]);
    const markOnboardingAsSeen = (0, $5uXOq.useCallback)(()=>{
        markAsSeen(key);
        (0, $i205g.setFlag)(key, $dcaed4e80c6c1d23$var$TTL_SEEN);
    }, [
        key,
        markAsSeen
    ]);
    return [
        isOnboardingVisible,
        markOnboardingAsSeen
    ];
};

});
parcelRegister("i205g", function(module, exports) {

$parcel$export(module.exports, "getFlags", () => $2e5c55e74efea073$export$d5815430bcc75df0);
$parcel$export(module.exports, "setFlag", () => $2e5c55e74efea073$export$5e165df1e30a1331);

var $dPSWJ = parcelRequire("dPSWJ");

var $sLb2Q = parcelRequire("sLb2Q");

var $4Pf62 = parcelRequire("4Pf62");

var $1nokx = parcelRequire("1nokx");

var $7UyIQ = parcelRequire("7UyIQ");
const $2e5c55e74efea073$export$442e3330dfabd1f5 = 3600000; // 1 hour
const $2e5c55e74efea073$export$4d45fa66d41a8ca9 = 2592000000; // ~1 month
const $2e5c55e74efea073$export$d5815430bcc75df0 = async (request)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const flagKeys = Object.keys(request);
    const retrieveFlagKeysLookup = (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(flagKeys);
    if (!atlassianAccountId || isAnonymous) return (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(retrieveFlagKeysLookup, ()=>({
            status: true,
            lastSeenDate: null
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flags = {};
    if (0, $7UyIQ.default) flagKeys.forEach((flagKey)=>{
        // @ts-expect-error - Object is possibly 'null'.
        const value = (0, $7UyIQ.default).get(flagKey);
        if (value) {
            delete retrieveFlagKeysLookup[flagKey];
            flags[flagKey] = value;
        }
    });
    const retrieveFlagKeys = Object.keys(retrieveFlagKeysLookup);
    if (retrieveFlagKeys.length > 0) Object.assign(flags, await (0, $1nokx.getFlags)(atlassianAccountId, retrieveFlagKeys));
    if (0, $7UyIQ.default) {
        const now = Date.now();
        retrieveFlagKeys.forEach((flagKey)=>{
            // Not sure whats going wrong here - but i assume `apiGetFlags` may not always return all `retrieveFalgKeys`
            // and so `flags[flagKey]` can be undefined - so we have to guard against it
            if (!flags[flagKey]) return;
            const { status: status } = flags[flagKey];
            const ttlNotSeen = request[flagKey].ttlNotSeen || $2e5c55e74efea073$export$442e3330dfabd1f5;
            const ttlSeen = request[flagKey].ttlSeen || $2e5c55e74efea073$export$4d45fa66d41a8ca9;
            // @ts-expect-error - TS2531: Object is possibly 'null'.
            (0, $7UyIQ.default).set(flagKey, flags[flagKey], now + (status ? ttlSeen : ttlNotSeen));
        });
    }
    return flags;
};
const $2e5c55e74efea073$export$5e165df1e30a1331 = async (flagKey, ttl = $2e5c55e74efea073$export$4d45fa66d41a8ca9)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (!atlassianAccountId || isAnonymous) return;
    if (0, $7UyIQ.default) {
        const value = (0, $7UyIQ.default).get(flagKey);
        if (value && value.status) return;
        const now = new Date();
        (0, $7UyIQ.default).set(flagKey, {
            status: true,
            lastSeenDate: now.toISOString()
        }, now.getTime() + ttl);
    }
    await (0, $1nokx.setFlag)(atlassianAccountId, flagKey);
};

});
parcelRegister("dPSWJ", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $a12aa8fd8ab9a7da$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $bxDef(iteratee, 3);
    $hDnyx(object, function(value, key, object) {
        $1m3dq(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $a12aa8fd8ab9a7da$var$mapValues;

});

parcelRegister("sLb2Q", function(module, exports) {

var $hsOo6 = parcelRequire("hsOo6");

var $dVL8S = parcelRequire("dVL8S");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $056736098c9e0b45$var$zipObject(props, values) {
    return $dVL8S(props || [], values || [], $hsOo6);
}
module.exports = $056736098c9e0b45$var$zipObject;

});
parcelRegister("dVL8S", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $a2452aab1e6d9d16$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $a2452aab1e6d9d16$var$baseZipObject;

});


parcelRegister("1nokx", function(module, exports) {

$parcel$export(module.exports, "setFlag", () => $4c27c5726c27889e$export$5e165df1e30a1331);
$parcel$export(module.exports, "getFlags", () => $4c27c5726c27889e$export$d5815430bcc75df0);

var $dPSWJ = parcelRequire("dPSWJ");

var $jJZqs = parcelRequire("jJZqs");
const $4c27c5726c27889e$export$c1f083639d344e75 = 'https://have-i-seen-it.us-east-1.prod.public.atl-paas.net';
const $4c27c5726c27889e$export$5e165df1e30a1331 = (userKey, flagKey)=>{
    const data = {
        userKey: userKey,
        flagKey: flagKey
    };
    return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flag`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
        return undefined;
    });
};
const $4c27c5726c27889e$var$convertToDates = (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(response, ({ status: status, lastSeenDate: lastSeenDate })=>({
            status: status,
            lastSeenDate: lastSeenDate ? new Date(lastSeenDate) : null
        }));
const $4c27c5726c27889e$export$d5815430bcc75df0 = (userKey, flagKeys)=>{
    const params = new URLSearchParams();
    flagKeys.forEach((flagKey)=>params.append('flagKey', flagKey));
    params.append('userKey', userKey);
    return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flags?${params.toString()}`).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
        return response.json();
    }).then((response)=>$4c27c5726c27889e$var$convertToDates(response));
};

});

parcelRegister("7UyIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $158da724691281b4$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

var $4Pf62 = parcelRequire("4Pf62");

var $2YZCu = parcelRequire("2YZCu");
/**
 * Return an ExpirableStorage to be used with the "have i seen it" service.
 *
 * If the user is anonymous, return null.
 */ const $158da724691281b4$var$createStorage = ()=>{
    let storage = null;
    try {
        let context;
        try {
            context = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            return storage;
        }
        const { atlassianAccountId: atlassianAccountId } = context;
        if (atlassianAccountId) storage = (0, $eNf8a.createSessionExpirableStorageProvider)(`have-i-seen-it-${atlassianAccountId.replace(/:/g, '_')}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('have-i-seen-it.storage', 'Failed to initialize storage.');
    }
    return storage;
};
var $158da724691281b4$export$2e2bcd8739ae039 = $158da724691281b4$var$createStorage();

});



parcelRegister("fFClA", function(module, exports) {

$parcel$export(module.exports, "useDroppableTabList", () => $ca201e8f80d95342$export$ecea8c8c33275ef5);

var $5uXOq = parcelRequire("5uXOq");

var $biEfA = parcelRequire("biEfA");

var $3m5yC = parcelRequire("3m5yC");

var $7gWdR = parcelRequire("7gWdR");

var $8dXDG = parcelRequire("8dXDG");

var $kaHBi = parcelRequire("kaHBi");

var $feuVB = parcelRequire("feuVB");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $ca201e8f80d95342$export$b8b9d90f9e5bd72b = 'jiraNavigationKitRankItem';
const $ca201e8f80d95342$export$f1e608dba99fa330 = {
    experience: 'reorderView'
};
const $ca201e8f80d95342$var$BEFORE = 'before';
const $ca201e8f80d95342$var$AFTER = 'after';
const $ca201e8f80d95342$export$ecea8c8c33275ef5 = (tabs, containerNavigationId, scopeId)=>{
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        ...$ca201e8f80d95342$export$f1e608dba99fa330,
        analyticsSource: $ca201e8f80d95342$export$b8b9d90f9e5bd72b
    });
    const onExperienceAbort = (0, $8dXDG.useExperienceAbort)($ca201e8f80d95342$export$f1e608dba99fa330);
    const [rankNavigationItem] = (0, $feuVB.useRankNavigationItem)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>(0, $7gWdR.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.type === 'tab';
            },
            onDrop ({ source: source, location: location }) {
                onStartExperience();
                const destination = location.current.dropTargets[0];
                if (!destination) {
                    onExperienceAbort('Dropped outside of drop targets');
                    return;
                }
                if (source.data.type === 'tab' && source.data.id !== destination.data.id) {
                    const sourceTabIndex = tabs.findIndex((tab)=>tab.id === source.data.id);
                    let targetTabIndex;
                    let closestEdgeOfTarget;
                    if (destination.data.isMoreMenu) {
                        // assume no pagination and move it to the bottom of the list
                        targetTabIndex = tabs.length - 1;
                        closestEdgeOfTarget = 'bottom';
                    } else {
                        targetTabIndex = tabs.findIndex((tab)=>tab.id === destination.data.id);
                        closestEdgeOfTarget = (0, $biEfA.extractClosestEdge)(destination.data);
                    }
                    const reorderedTabs = (0, $3m5yC.reorderWithEdge)({
                        list: tabs,
                        startIndex: sourceTabIndex,
                        indexOfTarget: targetTabIndex,
                        closestEdgeOfTarget: closestEdgeOfTarget,
                        axis: destination.data.isOverflowing ? 'vertical' : 'horizontal'
                    });
                    if (reorderedTabs && tabs.every((value, index)=>value === reorderedTabs[index])) return;
                    const placement = closestEdgeOfTarget === 'left' || closestEdgeOfTarget === 'top' ? $ca201e8f80d95342$var$BEFORE : $ca201e8f80d95342$var$AFTER;
                    const { id: id, typeKey: typeKey, appId: appId, dataId: dataId } = tabs[sourceTabIndex];
                    const beforeItemId = placement === $ca201e8f80d95342$var$BEFORE ? tabs[targetTabIndex].id : null;
                    const afterItemId = placement === $ca201e8f80d95342$var$AFTER ? tabs[targetTabIndex].id : null;
                    if (id.includes('optimisticId') || beforeItemId && beforeItemId.includes('optimisticId') || afterItemId && afterItemId.includes('optimisticId')) return;
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'navigationItem dragged', 'projectNavigationTab', {
                        itemType: typeKey && typeKey.toLowerCase(),
                        itemId: appId,
                        draggedFromMore: Boolean(source.data.isOverflowing),
                        draggedToMore: Boolean(destination.data.isOverflowing || destination.data.isMoreMenu)
                    });
                    rankNavigationItem({
                        placement: placement,
                        sourceTabIndex: sourceTabIndex,
                        targetTabIndex: targetTabIndex,
                        id: id,
                        beforeItemId: beforeItemId,
                        afterItemId: afterItemId,
                        dataId: dataId,
                        actionType: 'dragged',
                        containerNavigationId: containerNavigationId,
                        scopeId: scopeId
                    });
                }
            }
        }), [
        tabs,
        rankNavigationItem,
        onStartExperience,
        onExperienceAbort,
        containerNavigationId,
        scopeId,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("3m5yC", function(module, exports) {

$parcel$export(module.exports, "reorderWithEdge", () => $503dd84564f0390c$export$d0bc664d2812b3ba);
parcelRequire("ii3zs");
var $a44uV = parcelRequire("a44uV");

var $9EGGH = parcelRequire("9EGGH");
function $503dd84564f0390c$export$d0bc664d2812b3ba({ list: list, startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    return (0, $a44uV.reorder)({
        list: list,
        startIndex: startIndex,
        finishIndex: (0, $9EGGH.getReorderDestinationIndex)({
            closestEdgeOfTarget: closestEdgeOfTarget,
            startIndex: startIndex,
            indexOfTarget: indexOfTarget,
            axis: axis
        })
    });
}

});
parcelRegister("ii3zs", function(module, exports) {

$parcel$export(module.exports, "reorder", () => (parcelRequire("a44uV")).reorder);

var $a44uV = parcelRequire("a44uV");

});
parcelRegister("a44uV", function(module, exports) {

$parcel$export(module.exports, "reorder", () => $921c81942b5fc66a$export$fc77a6137e3f91c);
/**
 * A function that will reorder an array (`list`).
 * `reorder` returns a new array with reordered items and does not
 *  modify the original array. The items in the array are also not modified.
 */ function $921c81942b5fc66a$export$fc77a6137e3f91c({ list: list, startIndex: startIndex, finishIndex: finishIndex }) {
    if (startIndex === -1 || finishIndex === -1) // Making this function consistently return a new array reference.
    // This is consistent with .toSorted() which always returns a new array
    // even when it does not do anything
    return Array.from(list);
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(finishIndex, 0, removed);
    return result;
}

});


parcelRegister("9EGGH", function(module, exports) {

$parcel$export(module.exports, "getReorderDestinationIndex", () => $178b6900979d74e0$export$846f792f51b92b6e);
function $178b6900979d74e0$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}

});


parcelRegister("8dXDG", function(module, exports) {

$parcel$export(module.exports, "useExperienceAbort", () => $2df1decadd95b490$export$cc92b7ce453f4403);

var $5uXOq = parcelRequire("5uXOq");

var $l9g16 = parcelRequire("l9g16");
const $2df1decadd95b490$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $l9g16.useExperienceContext)();
    const self = (0, $5uXOq.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $5uXOq.useCallback)((reason, extraAttributes = {})=>{
        const { current: current } = self;
        current.experienceTracker.abort({
            name: current.name,
            reason: reason,
            attributes: {
                ...current.attributes,
                ...extraAttributes
            }
        });
    }, [
        self
    ]);
};

});

parcelRegister("feuVB", function(module, exports) {

$parcel$export(module.exports, "useRankNavigationItem", () => $205726356a7c0e8e$export$d474c994a9313e38);

var $bVfi8 = parcelRequire("bVfi8");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3m5yC = parcelRequire("3m5yC");

var $c9Ur7 = parcelRequire("c9Ur7");

var $jcw0u = parcelRequire("jcw0u");

var $93jKl = parcelRequire("93jKl");

var $3bQtK = parcelRequire("3bQtK");

var $pa9q9 = parcelRequire("pa9q9");

var $eCBf9 = parcelRequire("eCBf9");


var $j4hty = parcelRequire("j4hty");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $iJZ8l = parcelRequire("iJZ8l");

var $fhJ4C = parcelRequire("fhJ4C");
const $205726356a7c0e8e$var$BEFORE = 'before';
const $205726356a7c0e8e$var$AFTER = 'after';
const $205726356a7c0e8e$var$HANDLED_STATUS_CODES = [
    401,
    403,
    404
];
const $205726356a7c0e8e$var$ERROR_TYPE = 'error';
const $205726356a7c0e8e$var$RANK_NAVIGATION_ERROR_FLAG = {
    type: $205726356a7c0e8e$var$ERROR_TYPE,
    title: (0, $fhJ4C.default).errorTitle,
    description: (0, $fhJ4C.default).errorMessage,
    messageId: 'horizontal-nav-rank-item-service.services.rank-navigation-error-flag.flag.error',
    messageType: 'transactional'
};
const $205726356a7c0e8e$export$b8b9d90f9e5bd72b = 'jiraNavigationKitRankItem';
const $205726356a7c0e8e$export$111d365fc37d2de3 = 'reorderView';
const $205726356a7c0e8e$export$d57b6b390e78d90f = 'Navigation';
const $205726356a7c0e8e$export$f1e608dba99fa330 = {
    experience: $205726356a7c0e8e$export$111d365fc37d2de3
};
const $205726356a7c0e8e$var$getFlagDetails = (error)=>{
    const statusCode = error instanceof (0, $eCBf9.MutationError) ? error.extensions?.statusCode ?? null : error.extensions?.[0]?.statusCode ?? null;
    switch(statusCode){
        case 401:
            return {
                type: $205726356a7c0e8e$var$ERROR_TYPE,
                title: (0, $fhJ4C.default).unauthenticatedUserErrorTitle,
                description: (0, $fhJ4C.default).unauthenticatedUserErrorMessage,
                messageId: 'horizontal-nav-rank-item-service.services.flag.unauthenticated-user-error',
                messageType: 'transactional'
            };
        case 403:
            return {
                type: $205726356a7c0e8e$var$ERROR_TYPE,
                title: (0, $fhJ4C.default).authorisationErrorTitle,
                description: (0, $fhJ4C.default).authorisationErrorMessage,
                messageId: 'horizontal-nav-rank-item-service.services.flag.authorisation-error',
                messageType: 'transactional'
            };
        case 404:
            return {
                type: $205726356a7c0e8e$var$ERROR_TYPE,
                title: (0, $fhJ4C.default).viewNotFoundErrorTitle,
                description: (0, $fhJ4C.default).viewNotFoundErrorMessage,
                messageId: 'horizontal-nav-rank-item-service.services.flag.view-not-found-error',
                messageType: 'transactional'
            };
        default:
            return null;
    }
};
const $205726356a7c0e8e$export$d474c994a9313e38 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [commitMutation, isLoading] = (0, $8Uumt.useMutation)((0, $bVfi8.default));
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)($205726356a7c0e8e$export$f1e608dba99fa330);
    const onExperienceFail = (0, $93jKl.useExperienceFail)($205726356a7c0e8e$export$f1e608dba99fa330);
    const sendErrorAnalytics = (0, $5uXOq.useCallback)((error)=>{
        onExperienceFail($205726356a7c0e8e$export$b8b9d90f9e5bd72b, error);
        (0, $jcw0u.default)({
            meta: {
                id: $205726356a7c0e8e$export$111d365fc37d2de3,
                packageName: $205726356a7c0e8e$export$b8b9d90f9e5bd72b,
                teamName: $205726356a7c0e8e$export$d57b6b390e78d90f
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onExperienceFail
    ]);
    const rankNavigationItem = (0, $5uXOq.useCallback)(({ placement: placement, sourceTabIndex: sourceTabIndex, targetTabIndex: targetTabIndex, id: id, beforeItemId: beforeItemId, afterItemId: afterItemId, dataId: dataId, actionType: actionType, containerNavigationId: containerNavigationId, scopeId: scopeId })=>{
        let initialTabOrder = [];
        commitMutation({
            variables: {
                input: {
                    id: id,
                    beforeItemId: beforeItemId,
                    afterItemId: afterItemId,
                    scopeId: scopeId
                },
                first: (0, $f764d292f97c6de7$export$4653cda61a4943d6)
            },
            optimisticUpdater: (store)=>{
                const relayId = (0, $iJZ8l.default)({
                    id: containerNavigationId
                }, 'JiraContainerNavigation');
                const connection = relayId && store.get(relayId)?.getLinkedRecord('navigationItems', {
                    first: (0, $f764d292f97c6de7$export$4653cda61a4943d6)
                });
                if (!connection) return;
                const existingEdges = connection?.getLinkedRecords('edges') || [];
                initialTabOrder = (0, $j4hty.getAnalyticsTabOrder)(store, containerNavigationId);
                const tabs = Array.from(existingEdges || []);
                const reorderedTabs = (0, $3m5yC.reorderWithEdge)({
                    list: tabs,
                    startIndex: sourceTabIndex,
                    indexOfTarget: targetTabIndex,
                    closestEdgeOfTarget: placement === $205726356a7c0e8e$var$BEFORE ? 'left' : 'right',
                    axis: 'horizontal'
                });
                const edges = reorderedTabs.map((tab)=>existingEdges.find((edge)=>tab?.getLinkedRecord('node')?.getDataID() === edge.getLinkedRecord('node')?.getDataID())).filter(Boolean);
                connection?.setLinkedRecords(edges, 'edges');
            },
            updater: (store, response)=>{
                if (!response?.jira?.rankNavigationItem?.success) return;
                const finalTabOrder = (0, $j4hty.getAnalyticsTabOrder)(store, containerNavigationId);
                const itemType = dataId && store.get(dataId)?.getValue('typeKey');
                const itemId = dataId && store.get(dataId)?.getValue('appId');
                let finalTabIndex = targetTabIndex;
                if (placement === $205726356a7c0e8e$var$AFTER && sourceTabIndex > targetTabIndex) // placing it after the tab which will keep the same index, hence the destination is the target + 1
                finalTabIndex += 1;
                else if (placement === $205726356a7c0e8e$var$BEFORE && sourceTabIndex < targetTabIndex) // dropping it before the tab which will keep the same index, hence the destination is the target - 1
                finalTabIndex -= 1;
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectNavigationTabItem updated', {
                    originalItems: initialTabOrder,
                    updatedItems: finalTabOrder,
                    itemType: String(itemType).toLowerCase(),
                    itemId: itemId && String(itemId),
                    action: 'reordered',
                    method: actionType,
                    initialTabIndex: sourceTabIndex,
                    finalTabIndex: finalTabIndex
                });
            },
            onCompleted: (data)=>{
                const { errors: errors, success: success, containerNavigation: containerNavigation } = data?.jira?.rankNavigationItem ?? {};
                if (success && !errors) {
                    onExperienceSuccess();
                    return;
                }
                if (success && !errors) {
                    onExperienceSuccess();
                    return;
                }
                if (errors && errors?.length > 0 || containerNavigation?.__typename && containerNavigation.__typename === 'QueryError') {
                    const { ...queryError } = containerNavigation ?? {};
                    const error = errors ? new (0, $eCBf9.MutationError)(errors[0]) : new (0, $c9Ur7.QueryError)(queryError);
                    const flagDetails = $205726356a7c0e8e$var$getFlagDetails(error) ?? $205726356a7c0e8e$var$RANK_NAVIGATION_ERROR_FLAG;
                    showFlag(flagDetails);
                    if ($205726356a7c0e8e$var$HANDLED_STATUS_CODES.includes(error.statusCode ?? -1)) {
                        onExperienceSuccess();
                        return;
                    }
                    sendErrorAnalytics(error);
                    return;
                }
                showFlag($205726356a7c0e8e$var$RANK_NAVIGATION_ERROR_FLAG);
            },
            onError: (error)=>{
                const err = new (0, $eCBf9.MutationError)(error);
                showFlag($205726356a7c0e8e$var$RANK_NAVIGATION_ERROR_FLAG);
                sendErrorAnalytics(err);
            }
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        showFlag,
        onExperienceSuccess,
        sendErrorAnalytics
    ]);
    return [
        rankNavigationItem,
        isLoading
    ];
};

});
parcelRegister("bVfi8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b5867d4c1044857$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a94134f02495ac20f6a39bed337f7c2c>>
 * @relayHash 7dca2046022ad34e2d2a772b39ff5c6c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1565cb414d793dcea0c21b69eedabc92a4338f5a58284dd1c96386a0257aad86
const $2b5867d4c1044857$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = [
        v7 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "servicesRankNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraRankNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "rankNavigationItem",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ContainerNavigationTabs_container"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v8 /*: any*/ ,
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "servicesRankNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraRankNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "rankNavigationItem",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v8 /*: any*/ ,
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "containerNavigation",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraContainerNavigationResult"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "scopeId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "first",
                                                            "variableName": "first"
                                                        }
                                                    ],
                                                    "concreteType": "JiraNavigationItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "navigationItems",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraNavigationItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isDefault"
                                                                        },
                                                                        v10 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "typeKey"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isJiraNavigationItem"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canRename"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canRemove"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canSetAsDefault"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "appId"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraAppSection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "sections",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "links",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v10 /*: any*/ ,
                                                                                                v11 /*: any*/ ,
                                                                                                v12 /*: any*/ ,
                                                                                                v13 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v11 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v12 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "envLabel"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v14 /*: any*/ 
                                                                                    ],
                                                                                    "type": "JiraNavigationItem",
                                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                                }
                                                                            ],
                                                                            "type": "JiraAppNavigationItem"
                                                                        },
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canEdit"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "scopeUrl"
                                                }
                                            ],
                                            "type": "JiraContainerNavigation"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "QueryError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v8 /*: any*/ ,
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1565cb414d793dcea0c21b69eedabc92a4338f5a58284dd1c96386a0257aad86",
            "metadata": {},
            "name": "servicesRankNavigationItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$2b5867d4c1044857$var$node.hash = "34762fae8622a1c18cbdffa633de3226";
var $2b5867d4c1044857$export$2e2bcd8739ae039 = $2b5867d4c1044857$var$node;

});

parcelRegister("fhJ4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $8df0cabf7f3c712e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8df0cabf7f3c712e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "navigation-kit-rank-item-service.services.error-message",
        "defaultMessage": "Refresh the page and try again."
    },
    errorTitle: {
        "id": "navigation-kit-rank-item-service.services.error-title",
        "defaultMessage": "Something's gone wrong"
    },
    unauthenticatedUserErrorTitle: {
        "id": "navigation-kit-rank-item-service.services.unauthenticated-user-error-title",
        "defaultMessage": "You'll need to log in"
    },
    unauthenticatedUserErrorMessage: {
        "id": "navigation-kit-rank-item-service.services.unauthenticated-user-error-message",
        "defaultMessage": "You need to be logged in to manage the navigation. Please log in and try again."
    },
    authorisationErrorTitle: {
        "id": "navigation-kit-rank-item-service.services.authorisation-error-title",
        "defaultMessage": "You don't have permission"
    },
    authorisationErrorMessage: {
        "id": "navigation-kit-rank-item-service.services.authorisation-error-message",
        "defaultMessage": "You are not allowed to manage the navigation."
    },
    viewNotFoundErrorTitle: {
        "id": "navigation-kit-rank-item-service.services.view-not-found-error-title",
        "defaultMessage": "This tab has been removed"
    },
    viewNotFoundErrorMessage: {
        "id": "navigation-kit-rank-item-service.services.view-not-found-error-message",
        "defaultMessage": "The tab you're trying to move can't be found"
    }
});

});



parcelRegister("5QXyw", function(module, exports) {

$parcel$export(module.exports, "NavigationItemTab", () => $c86636f03fa9de2d$export$8123409ae5ebd68);

var $jOFFy = parcelRequire("jOFFy");

var $lKRoQ = parcelRequire("lKRoQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dE5tT = parcelRequire("dE5tT");

var $8hXfI = parcelRequire("8hXfI");

var $bHBFf = parcelRequire("bHBFf");
const $c86636f03fa9de2d$export$8123409ae5ebd68 = ({ tabFragment: tabFragment, containerFragment: containerFragment, position: position, beforeItemId: beforeItemId, afterItemId: afterItemId, tabsDescriptor: tabsDescriptor, isRenaming: isRenaming, onRenamingChange: onRenamingChange })=>{
    const tabData = (0, $8Uumt.useFragment)((0, $lKRoQ.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $jOFFy.default), containerFragment);
    if (tabData.__typename === 'JiraAppNavigationItem') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8hXfI.AppTab), {
        tabFragment: tabData,
        containerFragment: containerData,
        position: position,
        beforeItemId: beforeItemId,
        afterItemId: afterItemId
    });
    if (tabData.typeKey === 'SHORTCUTS') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bHBFf.ShortcutsTab), {
        tabFragment: tabData,
        containerFragment: containerData,
        position: position,
        beforeItemId: beforeItemId,
        afterItemId: afterItemId,
        isRenaming: isRenaming,
        onRenamingChange: onRenamingChange
    });
    if (tabData.url == null) return null;
    const Icon = tabsDescriptor[tabData.typeKey]?.Icon ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dE5tT.DefaultTab), {
        tabFragment: tabData,
        containerFragment: containerData,
        position: position,
        icon: Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
            label: ""
        }),
        beforeItemId: beforeItemId,
        afterItemId: afterItemId,
        isRenaming: isRenaming,
        onRenamingChange: onRenamingChange
    });
};

});
parcelRegister("jOFFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c285de238cd83205$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6618727869e83c51134b946cb67b705d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c285de238cd83205$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NavigationItemTab_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "DefaultTab_container"
        },
        {
            "kind": "FragmentSpread",
            "name": "ShortcutsTab_container"
        },
        {
            "kind": "FragmentSpread",
            "name": "AppTab_container"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$c285de238cd83205$var$node.hash = "9e2c189c40e4bc3dcbb1cf10c08a8bf2";
var $c285de238cd83205$export$2e2bcd8739ae039 = $c285de238cd83205$var$node;

});

parcelRegister("lKRoQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f555ed0481afc184$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6ec91a07017fe901c44dfc3df36f84e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f555ed0481afc184$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NavigationItemTab_tab",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            "action": "THROW",
            "path": "typeKey"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "FragmentSpread",
            "name": "DefaultTab_tab"
        },
        {
            "kind": "FragmentSpread",
            "name": "ShortcutsTab_tab"
        },
        {
            "kind": "FragmentSpread",
            "name": "AppTab_tab"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$f555ed0481afc184$var$node.hash = "751fa7ab98212b17632e93d1c53dfc75";
var $f555ed0481afc184$export$2e2bcd8739ae039 = $f555ed0481afc184$var$node;

});

parcelRegister("dE5tT", function(module, exports) {

$parcel$export(module.exports, "DefaultTab", () => $e838ae8b80cf7320$export$15a1012301673c71);

var $9Tk15 = parcelRequire("9Tk15");

var $42ZFa = parcelRequire("42ZFa");

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $8Uumt = parcelRequire("8Uumt");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $4R6GH = parcelRequire("4R6GH");

var $lVJAU = parcelRequire("lVJAU");

var $bYbah = parcelRequire("bYbah");

var $3F9p6 = parcelRequire("3F9p6");




var $byTKd = parcelRequire("byTKd");

var $1WfM5 = parcelRequire("1WfM5");

var $haoad = parcelRequire("haoad");
const $e838ae8b80cf7320$export$15a1012301673c71 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ tabFragment: tabFragment, containerFragment: containerFragment, position: position, icon: icon, isRenaming: isRenaming, onRenamingChange: onRenamingChange, testId: testId, elemAfter: elemAfter, beforeItemId: beforeItemId, afterItemId: afterItemId }, ref)=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { isSelected: isSelected, hasOverflowed: hasOverflowed } = (0, $1WfM5.useTabContext)();
    const tabData = (0, $8Uumt.useFragment)((0, $42ZFa.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $9Tk15.default), containerFragment);
    const triggerAnalytics = (0, $byTKd.useNavigationItemAnalytics)((0, $5uXOq.useMemo)(()=>({
            itemId: 'undefined',
            itemType: (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(tabData.typeKey),
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            stage: (0, $3F9p6.getNav4Rollout)().stage,
            navigationLayer: (0, $ce9c0831aed9ffb3$export$33d8c916a600c5e9),
            navigationContainer: (0, $68cb678dc917978e$export$f1c9dd0f5207dd5e),
            isInMore: false
        }), [
        tabData.typeKey
    ]));
    const { registerTab: registerTab } = (0, $bYbah.useTabShortcuts)();
    (0, $5uXOq.useEffect)(()=>registerTab({
            index: position,
            callback: ()=>{
                if (!isSelected) push(tabData.url);
            },
            label: tabData.label
        }), [
        registerTab,
        tabData,
        position,
        push,
        isSelected
    ]);
    const tabWithMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $haoad.TabWithMenu), {
        elemBefore: icon,
        elemAfter: elemAfter,
        href: tabData.url,
        tabFragment: tabData,
        containerFragment: containerData,
        onClick: triggerAnalytics,
        isRenaming: isRenaming,
        onRenamingChange: onRenamingChange,
        testId: testId,
        beforeItemId: beforeItemId,
        afterItemId: afterItemId,
        position: position,
        type: "router-link",
        ref: ref
    });
    return !hasOverflowed && (0, $4R6GH.fg)('jira_horizontal_nav4_tab_spotlight') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: `horizontal-nav-tabs.${tabData.typeKey}`
    }, tabWithMenu) : tabWithMenu;
});

});
parcelRegister("9Tk15", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f802d8a3d3c2129$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<435ec6e3648eea9642eecd6b274b907f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9f802d8a3d3c2129$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "DefaultTab_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_container"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$9f802d8a3d3c2129$var$node.hash = "f01c95b8f6d1cd80c4ac15d2546c116d";
var $9f802d8a3d3c2129$export$2e2bcd8739ae039 = $9f802d8a3d3c2129$var$node;

});

parcelRegister("42ZFa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c1f93cf43b28872$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6762e3865e5c3a56f13719a55b9547c5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3c1f93cf43b28872$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "DefaultTab_tab",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "label"
            },
            "action": "THROW",
            "path": "label"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "url"
            },
            "action": "THROW",
            "path": "url"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            "action": "THROW",
            "path": "typeKey"
        },
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_tab"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$3c1f93cf43b28872$var$node.hash = "9da2b497cf3cffcac56da38a0c7d758a";
var $3c1f93cf43b28872$export$2e2bcd8739ae039 = $3c1f93cf43b28872$var$node;

});

parcelRegister("haoad", function(module, exports) {

$parcel$export(module.exports, "TabWithMenu", () => $01e294c795eeb8f9$export$be4d5a66758483a8);

var $jcsb1 = parcelRequire("jcsb1");

var $kovwN = parcelRequire("kovwN");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $d0cdX = parcelRequire("d0cdX");

var $1vy6C = parcelRequire("1vy6C");

var $dcuaN = parcelRequire("dcuaN");

var $4R6GH = parcelRequire("4R6GH");
const $01e294c795eeb8f9$export$be4d5a66758483a8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ tabFragment: tabFragment, containerFragment: containerFragment, beforeItemId: beforeItemId, afterItemId: afterItemId, isRenaming: isRenaming, onRenamingChange: onRenamingChange, ...tabProps }, ref)=>{
    const renameNavigationItem = (0, $1vy6C.useRenameNavigationItem)();
    const tabData = (0, $8Uumt.useFragment)((0, $kovwN.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $jcsb1.default), containerFragment);
    const canEdit = Boolean(containerData?.canEdit);
    const handleRenameComplete = (0, $5uXOq.useCallback)((newName)=>{
        renameNavigationItem?.({
            id: tabData.id,
            label: newName,
            scopeId: containerData.scopeId,
            typeKey: tabData.typeKey,
            __typename: tabData.__typename
        });
        onRenamingChange?.(false);
    }, [
        renameNavigationItem,
        tabData.id,
        tabData.typeKey,
        tabData.__typename,
        containerData.scopeId,
        onRenamingChange
    ]);
    const handleRenameClick = (0, $5uXOq.useCallback)(()=>{
        onRenamingChange?.(true);
    }, [
        onRenamingChange
    ]);
    const handleRenameCancel = (0, $5uXOq.useCallback)(()=>{
        onRenamingChange?.(false);
    }, [
        onRenamingChange
    ]);
    const renderMenu = (0, $5uXOq.useCallback)(({ isOverflowing: isOverflowing, isOpen: isMenuOpen, setIsOpen: setIsMenuOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d0cdX.TabMenu), {
            tabFragment: tabData,
            containerFragment: containerData,
            beforeItemId: beforeItemId,
            afterItemId: afterItemId,
            position: tabProps.position,
            isOverflowing: isOverflowing,
            isOpen: isMenuOpen,
            setIsOpen: setIsMenuOpen,
            onRenameClick: handleRenameClick
        }), [
        tabData,
        containerData,
        beforeItemId,
        afterItemId,
        tabProps.position,
        handleRenameClick
    ]);
    if ((0, $4R6GH.fg)('jfp_a11y_team_board_missing_unordered_list_mark-up')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        className: (0, $bwpsq.default)([
            $01e294c795eeb8f9$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcuaN.default), {
        name: tabData.label,
        isDraggable: canEdit,
        renderMenu: canEdit ? renderMenu : undefined,
        onRenameComplete: handleRenameComplete,
        onRenameCancel: handleRenameCancel,
        isRenaming: isRenaming,
        ...tabProps,
        ref: ref
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcuaN.default), {
        name: tabData.label,
        isDraggable: canEdit,
        renderMenu: canEdit ? renderMenu : undefined,
        onRenameComplete: handleRenameComplete,
        onRenameCancel: handleRenameCancel,
        isRenaming: isRenaming,
        ...tabProps,
        ref: ref
    });
});
const $01e294c795eeb8f9$var$styles = {
    root: "_qtt8glyw _19pkidpf"
};

});
parcelRegister("jcsb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $486706af25a2f26a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bb585c529bab9cef4749ed2a03ab95a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $486706af25a2f26a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TabWithMenu_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabMenu_container"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canEdit"
                },
                {
                    "kind": "ScalarField",
                    "name": "scopeId"
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$486706af25a2f26a$var$node.hash = "6224b42f30483a79a7b9e5f35d80a3f9";
var $486706af25a2f26a$export$2e2bcd8739ae039 = $486706af25a2f26a$var$node;

});

parcelRegister("kovwN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0db0a428cde57540$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e15ac5f88b72d8037f90a2c27f9b342e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0db0a428cde57540$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TabWithMenu_tab",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "label"
            },
            "action": "THROW",
            "path": "label"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            "action": "THROW",
            "path": "typeKey"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "FragmentSpread",
            "name": "TabMenu_tab"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$0db0a428cde57540$var$node.hash = "c2661c839237a566a5adce01990a7427";
var $0db0a428cde57540$export$2e2bcd8739ae039 = $0db0a428cde57540$var$node;

});

parcelRegister("d0cdX", function(module, exports) {

$parcel$export(module.exports, "TabMenu", () => $958d18a4f28c163e$export$60204bfd6efac94c);

var $aFatU = parcelRequire("aFatU");

var $d3b44 = parcelRequire("d3b44");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $42CjB = parcelRequire("42CjB");

var $aRoVz = parcelRequire("aRoVz");

var $bJeNF = parcelRequire("bJeNF");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $6cG4N = parcelRequire("6cG4N");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $22OQR = parcelRequire("22OQR");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $hCCtP = parcelRequire("hCCtP");

var $e9UUa = parcelRequire("e9UUa");

var $1xdDa = parcelRequire("1xdDa");

var $8q6eC = parcelRequire("8q6eC");

var $7LJ25 = parcelRequire("7LJ25");

var $6Y96S = parcelRequire("6Y96S");
const $958d18a4f28c163e$export$60204bfd6efac94c = /*#__PURE__*/ (0, $5uXOq.memo)(({ tabFragment: tabFragment, containerFragment: containerFragment, beforeItemId: beforeItemId, afterItemId: afterItemId, position: position, isOverflowing: isOverflowing, isOpen: isOpen, setIsOpen: setIsOpen, onRenameClick: onRenameClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const tabData = (0, $8Uumt.useFragment)((0, $d3b44.default), tabFragment);
    const canRename = Boolean(tabData?.canRename) && (0, $6s1PB.expVal)('saved_views', 'enabled', false);
    const canRemove = Boolean(tabData?.canRemove);
    const canSetAsDefault = Boolean(tabData?.canSetAsDefault);
    const containerData = (0, $8Uumt.useFragment)((0, $aFatU.default), containerFragment);
    const toggleMenuOpen = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((isMenuOpen)=>!isMenuOpen);
    }, [
        setIsOpen
    ]);
    const closeMenu = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const handleHideClick = (0, $5uXOq.useCallback)(()=>{
        closeMenu();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'projectNavigationTab', {
            action: 'remove',
            itemType: tabData.typeKey.toLowerCase(),
            itemId: tabData.appId ?? undefined,
            isInMore: Boolean(isOverflowing)
        });
    }, [
        closeMenu,
        createAnalyticsEvent,
        tabData.typeKey,
        tabData.appId,
        isOverflowing
    ]);
    const handleSetAsDefault = (0, $5uXOq.useCallback)(()=>{
        closeMenu();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'projectNavigationTab', {
            action: 'setAsDefault',
            itemType: tabData.typeKey.toLowerCase(),
            itemId: tabData.appId ?? undefined,
            isInMore: Boolean(isOverflowing)
        });
    }, [
        closeMenu,
        createAnalyticsEvent,
        isOverflowing,
        tabData.appId,
        tabData.typeKey
    ]);
    const handleRenameNavigationItem = (0, $5uXOq.useCallback)(()=>{
        closeMenu();
        onRenameClick?.();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'projectNavigationTab', {
            action: 'rename',
            itemType: tabData.typeKey.toLowerCase(),
            isInMore: Boolean(isOverflowing)
        });
    }, [
        closeMenu,
        createAnalyticsEvent,
        isOverflowing,
        onRenameClick,
        tabData.typeKey
    ]);
    const trigger = (triggerProps)=>{
        if (isOverflowing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ...triggerProps,
            label: formatMessage((0, $1xdDa.default).viewOptions),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))),
            isTooltipDisabled: false,
            tooltip: {
                hideTooltipOnClick: true,
                ...(0, $dCm1o.isVisualRefreshEnabled)() && {
                    content: formatMessage((0, $1xdDa.default).moreActionsTooltip)
                }
            },
            onClick: toggleMenuOpen,
            appearance: "subtle",
            spacing: "compact",
            isSelected: isOpen
        });
        return (0, $4R6GH.fg)('fix_navigation_three_dots_icon_color') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedIconButton), {
            ...triggerProps,
            label: formatMessage((0, $1xdDa.default).viewOptions),
            icon: (iconProps)=>// @ts-expect-error - TS2322
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                    ...iconProps,
                    color: !isOpen ? (0, $6cG4N.Tokens).COLOR_LINK : undefined
                }),
            isTooltipDisabled: false,
            tooltip: {
                hideTooltipOnClick: true,
                ...(0, $dCm1o.isVisualRefreshEnabled)() && {
                    content: formatMessage((0, $1xdDa.default).moreActionsTooltip)
                }
            },
            onClick: toggleMenuOpen,
            appearance: "subtle",
            spacing: "compact",
            isSelected: isOpen
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($958d18a4f28c163e$var$NavigationThemedButton, {
            ...triggerProps,
            isSelected: isOpen,
            onClick: toggleMenuOpen,
            appearance: "subtle",
            spacing: "compact",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: (0, $dCm1o.isVisualRefreshEnabled)() ? formatMessage((0, $1xdDa.default).moreActionsTooltip) : formatMessage((0, $1xdDa.default).viewOptions),
                hideTooltipOnClick: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                label: formatMessage((0, $1xdDa.default).viewOptions),
                LEGACY_size: "small"
            }))
        });
    };
    const hasTopGroup = canSetAsDefault || canRename;
    const hasMiddleGroup = position !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        trigger: trigger,
        isOpen: isOpen,
        onClose: closeMenu,
        placement: isOverflowing ? 'right-start' : 'bottom-start',
        shouldUseCaptureOnOutsideClick: true,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                sourceType: (0, $4d5e0871c06cee03$export$d1123261ca8831d2),
                sourceName: "navigationKitTabMenu"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $958d18a4f28c163e$var$containerStyles,
                testId: "navigation-kit-tab-menu.ui.tab-menu-options",
                role: "menu"
            }, hasTopGroup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, canSetAsDefault && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Y96S.SetAsDefaultItem), {
                onClick: handleSetAsDefault,
                tabFragment: tabData,
                containerFragment: containerData
            }), canRename && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LJ25.RenameItem), {
                onClick: handleRenameNavigationItem
            })), hasMiddleGroup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8q6eC.MoveItem), {
                hasSeparator: hasTopGroup,
                id: tabData?.id,
                dataId: tabData?.__id,
                beforeItemId: beforeItemId,
                afterItemId: afterItemId,
                position: position,
                onClick: closeMenu,
                tabFragment: tabData,
                containerFragment: containerData,
                isOverflowing: isOverflowing
            }), canRemove && !tabData.isDefault && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
                hasSeparator: hasTopGroup || hasMiddleGroup
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e9UUa.HideItem), {
                onClick: handleHideClick,
                tabFragment: tabData,
                containerFragment: containerData
            }))))
    });
});
// remove - on clean up fix_navigation_three_dots_icon_color
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $958d18a4f28c163e$var$NavigationThemedButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $22OQR.ThemedButton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_15ah14e8 _1nzwvy9e",
            __cmplp.className
        ])
    });
});
const $958d18a4f28c163e$var$containerStyles = (0, $8CUq3.xcss)({
    minWidth: '124px'
});

});
parcelRegister("aFatU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ccf5dd5d1dd66a8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0029a71db40a948fb3ab74f841092485>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4ccf5dd5d1dd66a8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TabMenu_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SetAsDefaultItem_container"
        },
        {
            "kind": "FragmentSpread",
            "name": "MoveItem_container"
        },
        {
            "kind": "FragmentSpread",
            "name": "HideItem_container"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$4ccf5dd5d1dd66a8$var$node.hash = "625543c1eef703b320bff9684648acce";
var $4ccf5dd5d1dd66a8$export$2e2bcd8739ae039 = $4ccf5dd5d1dd66a8$var$node;

});

parcelRegister("d3b44", function(module, exports) {

$parcel$export(module.exports, "default", () => $f44a3b6bf8a6450a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9fe02adf4dfe0d10d1dc49670185f93>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f44a3b6bf8a6450a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "TabMenu_tab",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SetAsDefaultItem_tab"
        },
        {
            "kind": "FragmentSpread",
            "name": "MoveItem_tab"
        },
        {
            "kind": "FragmentSpread",
            "name": "HideItem_tab"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            "action": "THROW",
            "path": "typeKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isDefault"
            },
            "action": "THROW",
            "path": "isDefault"
        },
        {
            "kind": "ScalarField",
            "name": "canRename"
        },
        {
            "kind": "ScalarField",
            "name": "canRemove"
        },
        {
            "kind": "ScalarField",
            "name": "canSetAsDefault"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "appId"
                }
            ],
            "type": "JiraAppNavigationItem"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$f44a3b6bf8a6450a$var$node.hash = "c39dc9c76de61cd2fa1248c73d2f808d";
var $f44a3b6bf8a6450a$export$2e2bcd8739ae039 = $f44a3b6bf8a6450a$var$node;

});

parcelRegister("e9UUa", function(module, exports) {

$parcel$export(module.exports, "HideItem", () => $ce674b382b8b60ff$export$688a1e0eb1cb83e7);

var $dhU6F = parcelRequire("dhU6F");

var $1CLLN = parcelRequire("1CLLN");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6B7KL = parcelRequire("6B7KL");

var $koVbs = parcelRequire("koVbs");

var $j2Q2d = parcelRequire("j2Q2d");

var $lVJAU = parcelRequire("lVJAU");

var $1WfM5 = parcelRequire("1WfM5");

var $1xdDa = parcelRequire("1xdDa");
const $ce674b382b8b60ff$export$688a1e0eb1cb83e7 = /*#__PURE__*/ (0, $5uXOq.memo)(({ tabFragment: tabFragment, containerFragment: containerFragment, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const hideNavigationItem = (0, $j2Q2d.useHideNavigationItem)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { isSelected: isSelected } = (0, $1WfM5.useTabContext)();
    const tabData = (0, $8Uumt.useFragment)((0, $1CLLN.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $dhU6F.default), containerFragment);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        onClick();
        if (!containerData.id) return;
        const defaultTabUrl = containerData.navigationItems?.edges?.find((edge)=>edge?.node.isDefault)?.node.url;
        hideNavigationItem({
            id: tabData.id,
            relayId: tabData.__id,
            containerNavigationId: containerData.id,
            onCompleted: ()=>{
                if (defaultTabUrl && isSelected) push(defaultTabUrl);
            }
        });
    }, [
        containerData,
        hideNavigationItem,
        isSelected,
        onClick,
        push,
        tabData.__id,
        tabData.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: handleClick
    }, formatMessage((0, $1xdDa.default).hideItem));
});

});
parcelRegister("dhU6F", function(module, exports) {

$parcel$export(module.exports, "default", () => $c26cf43974ce78bb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f2af84d5adc0f9b927b2d6b399dc9e58>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c26cf43974ce78bb$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "first"
        }
    ],
    "kind": "Fragment",
    "name": "HideItem_container",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "id"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                        }
                    ],
                    "concreteType": "JiraNavigationItemConnection",
                    "kind": "LinkedField",
                    "name": "navigationItems",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraNavigationItemEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "isDefault"
                                                },
                                                "action": "THROW",
                                                "path": "navigationItems.edges.node.isDefault"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "navigationItems.edges.node"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$c26cf43974ce78bb$var$node.hash = "74369dee0c0b32c1011fec3260d7a339";
var $c26cf43974ce78bb$export$2e2bcd8739ae039 = $c26cf43974ce78bb$var$node;

});

parcelRegister("1CLLN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5305e5fff6e7d86b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<62dbb3ecb0a3c1d9aab1d0ea97ab3827>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5305e5fff6e7d86b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "HideItem_tab",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "__id"
                    },
                    "action": "THROW",
                    "path": "__id"
                }
            ]
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$5305e5fff6e7d86b$var$node.hash = "2e58297399f7217bc7b0f7b7efcfd8cc";
var $5305e5fff6e7d86b$export$2e2bcd8739ae039 = $5305e5fff6e7d86b$var$node;

});

parcelRegister("j2Q2d", function(module, exports) {

$parcel$export(module.exports, "useHideNavigationItem", () => $60348a214ba87fe7$export$f81bcd521f99d535);

var $ZUIsc = parcelRequire("ZUIsc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $eCBf9 = parcelRequire("eCBf9");

var $j4hty = parcelRequire("j4hty");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dGeoc = parcelRequire("dGeoc");
const $60348a214ba87fe7$export$b8b9d90f9e5bd72b = 'jiraNavigationKitHideItemService';
const $60348a214ba87fe7$export$6d6eb6668e23e980 = 'hideView';
const $60348a214ba87fe7$export$d57b6b390e78d90f = 'Navigation';
const $60348a214ba87fe7$export$ab511d8a11c8295c = {
    experience: $60348a214ba87fe7$export$6d6eb6668e23e980
};
const $60348a214ba87fe7$var$NON_ADMIN_ERROR = 'User is not an admin';
const $60348a214ba87fe7$var$getFlagDetails = (error)=>{
    const { message: message } = error;
    const { statusCode: statusCode } = error.extensions || {};
    switch(statusCode){
        case 401:
            return {
                type: 'error',
                title: (0, $dGeoc.default).userNotLoggedInErrorFlagTitle,
                description: (0, $dGeoc.default).userNotLoggedInErrorFlagDescription,
                messageId: 'horizontal-nav-hide-item-service.services.flag.error.user-not-logged-in-error',
                messageType: 'transactional'
            };
        case 403:
            if (message === $60348a214ba87fe7$var$NON_ADMIN_ERROR) return {
                type: 'error',
                title: (0, $dGeoc.default).userNotAdminErrorFlagTitle,
                description: (0, $dGeoc.default).userNotAdminErrorFlagDescription,
                messageId: 'horizontal-nav-hide-item-service.services.flag.error.user-not-admin-error',
                messageType: 'transactional'
            };
            return null;
        case 404:
            return {
                type: 'error',
                title: (0, $dGeoc.default).viewNotFoundErrorFlagTitle,
                description: (0, $dGeoc.default).viewNotFoundErrorFlagDescription,
                messageId: 'horizontal-nav-hide-item-service.services.flag.error.view-not-found-error',
                messageType: 'transactional'
            };
        default:
            return null;
    }
};
const $60348a214ba87fe7$export$f81bcd521f99d535 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        ...$60348a214ba87fe7$export$ab511d8a11c8295c,
        analyticsSource: $60348a214ba87fe7$export$b8b9d90f9e5bd72b
    });
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)($60348a214ba87fe7$export$ab511d8a11c8295c);
    const onExperienceFail = (0, $93jKl.useExperienceFail)($60348a214ba87fe7$export$ab511d8a11c8295c);
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $ZUIsc.default));
    const getAnalyticsTabPosition = (0, $5uXOq.useCallback)((store, response, containerNavigationId)=>{
        if (response?.jira?.deleteNavigationItem == null) return;
        const { success: success, navigationItem: navigationItem } = response.jira.deleteNavigationItem;
        if (!success || navigationItem == null) return;
        const edges = (0, $j4hty.getStoreEdges)(store, containerNavigationId);
        if (!edges) return undefined;
        const index = edges.findIndex((edge)=>{
            const node = edge?.getLinkedRecord('node');
            return node?.getValue('id') === navigationItem;
        });
        return index === -1 ? undefined : index;
    }, []);
    const updater = (0, $5uXOq.useCallback)((store, response, navigationItemRelayId, containerNavigationId)=>{
        if (response?.jira?.deleteNavigationItem == null) return;
        const { success: success, navigationItem: navigationItem } = response.jira.deleteNavigationItem;
        if (!success || navigationItem == null) return;
        const connectionRecord = (0, $j4hty.getConnection)(store, containerNavigationId);
        if (!connectionRecord || navigationItemRelayId == null) return;
        (0, $8Uumt.ConnectionHandler).deleteNode(connectionRecord, navigationItemRelayId);
    }, []);
    const onError = (0, $5uXOq.useCallback)((error)=>{
        showFlag({
            messageId: 'horizontal-nav-hide-item-service.services.show-flag.error.hide-navigation-item-default-error',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $dGeoc.default).hideNavigationItemDefaultErrorFlagTitle),
            description: formatMessage((0, $dGeoc.default).hideNavigationItemDefaultErrorFlagDescription)
        });
        (0, $jcw0u.default)({
            meta: {
                id: $60348a214ba87fe7$export$6d6eb6668e23e980,
                packageName: $60348a214ba87fe7$export$b8b9d90f9e5bd72b,
                teamName: $60348a214ba87fe7$export$d57b6b390e78d90f
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail($60348a214ba87fe7$export$b8b9d90f9e5bd72b, error);
    }, [
        formatMessage,
        onExperienceFail,
        showFlag
    ]);
    return (0, $5uXOq.useCallback)(({ id: id, relayId: relayId, onCompleted: onCompleted, containerNavigationId: containerNavigationId })=>{
        if (id == null) return;
        onStartExperience();
        commitMutation({
            variables: {
                input: {
                    id: id
                }
            },
            optimisticResponse: {
                jira: {
                    deleteNavigationItem: {
                        success: true,
                        navigationItem: id,
                        errors: null
                    }
                }
            },
            optimisticUpdater: (store, response)=>{
                updater(store, response, relayId, containerNavigationId);
            },
            updater: (store, response)=>{
                const initialTabOrder = (0, $j4hty.getAnalyticsTabOrder)(store, containerNavigationId);
                const initialTabPosition = getAnalyticsTabPosition(store, response, containerNavigationId);
                updater(store, response, relayId, containerNavigationId);
                if (response?.jira?.deleteNavigationItem?.success) {
                    const finalTabOrder = (0, $j4hty.getAnalyticsTabOrder)(store, containerNavigationId);
                    const item = store.get(String(relayId));
                    const itemId = item?.getValue('appId');
                    const itemType = String(item?.getValue('typeKey'));
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectNavigationTabItem updated', {
                        originalItems: initialTabOrder,
                        updatedItems: finalTabOrder,
                        itemType: itemType.toLowerCase(),
                        itemId: itemId && String(itemId),
                        initialTabIndex: initialTabPosition,
                        action: 'removed'
                    });
                }
            },
            onError: onError,
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira?.deleteNavigationItem ?? {};
                if (errors) {
                    const error = new (0, $eCBf9.MutationError)(errors[0]);
                    const statusCode = error.statusCode;
                    if (statusCode != null) {
                        const flagDetails = $60348a214ba87fe7$var$getFlagDetails(error);
                        if (flagDetails) {
                            showFlag(flagDetails);
                            onExperienceSuccess();
                            return;
                        }
                    }
                    onError(error);
                    return;
                }
                onExperienceSuccess();
                onCompleted();
            }
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        getAnalyticsTabPosition,
        onError,
        onExperienceSuccess,
        onStartExperience,
        showFlag,
        updater
    ]);
};

});
parcelRegister("ZUIsc", function(module, exports) {

$parcel$export(module.exports, "default", () => $72bdceab737ea3a6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ca421b53344a880082a01ef55ae3298d>>
 * @relayHash 5e42aa4760fa1cda0f65d32ab2e48395
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 414b6dd12c5dd4719aa01c278cbc93efd3c83934596c33f80b7ffc0a13230fdf
const $72bdceab737ea3a6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "navigationItem"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "servicesHideNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDeleteNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "deleteNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "servicesHideNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDeleteNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "deleteNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "414b6dd12c5dd4719aa01c278cbc93efd3c83934596c33f80b7ffc0a13230fdf",
            "metadata": {},
            "name": "servicesHideNavigationItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$72bdceab737ea3a6$var$node.hash = "4640fb5e180d56505dbc99767c68be10";
var $72bdceab737ea3a6$export$2e2bcd8739ae039 = $72bdceab737ea3a6$var$node;

});

parcelRegister("dGeoc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b007ad09be8c132$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0b007ad09be8c132$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    hideNavigationItemDefaultErrorFlagTitle: {
        "id": "navigation-kit-hide-item-service.services.hide-navigation-item-default-error-flag-title",
        "defaultMessage": "Something's gone wrong"
    },
    hideNavigationItemDefaultErrorFlagDescription: {
        "id": "navigation-kit-hide-item-service.services.hide-navigation-item-default-error-flag-description",
        "defaultMessage": "Refresh the page and try again."
    },
    userNotLoggedInErrorFlagTitle: {
        "id": "navigation-kit-hide-item-service.services.user-not-logged-in-error-flag-title",
        "defaultMessage": "You'll need to log in"
    },
    userNotLoggedInErrorFlagDescription: {
        "id": "navigation-kit-hide-item-service.services.user-not-logged-in-error-flag-description",
        "defaultMessage": "You need to be logged in to manage the navigation. Please log in and try again."
    },
    userNotAdminErrorFlagTitle: {
        "id": "navigation-kit-hide-item-service.services.user-not-admin-error-flag-title",
        "defaultMessage": "You don't have permission"
    },
    userNotAdminErrorFlagDescription: {
        "id": "navigation-kit-hide-item-service.services.user-not-admin-error-flag-description",
        "defaultMessage": "You are not allowed to manage the navigation."
    },
    viewNotFoundErrorFlagTitle: {
        "id": "navigation-kit-hide-item-service.services.view-not-found-error-flag-title",
        "defaultMessage": "This tab has been removed"
    },
    viewNotFoundErrorFlagDescription: {
        "id": "navigation-kit-hide-item-service.services.view-not-found-error-flag-description",
        "defaultMessage": "The tab you're trying to remove can't be found."
    }
});

});


parcelRegister("1xdDa", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff2f640b9b445879$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ff2f640b9b445879$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewOptions: {
        "id": "navigation-kit-tab-menu.view-options",
        "defaultMessage": "Tab options"
    },
    setAsDefaultView: {
        "id": "navigation-kit-tab-menu.set-as-default-item.set-as-default-view",
        "defaultMessage": "Set as default"
    },
    selected: {
        "id": "navigation-kit-tab-menu.set-as-default-item.selected",
        "defaultMessage": "Selected"
    },
    renameItem: {
        "id": "navigation-kit-tab-menu.rename-item.rename-item",
        "defaultMessage": "Rename"
    },
    moveItemRight: {
        "id": "navigation-kit-tab-menu.move-item.move-item-right",
        "defaultMessage": "Move tab right"
    },
    moveItemDown: {
        "id": "navigation-kit-tab-menu.move-item.move-item-down",
        "defaultMessage": "Move tab down"
    },
    moveItemLeft: {
        "id": "navigation-kit-tab-menu.move-item.move-item-left",
        "defaultMessage": "Move tab left"
    },
    moveItemUp: {
        "id": "navigation-kit-tab-menu.move-item.move-item-up",
        "defaultMessage": "Move tab up"
    },
    hideItem: {
        "id": "navigation-kit-tab-menu.hide-item.hide-item",
        "defaultMessage": "Remove"
    },
    moreActionsTooltip: {
        "id": "navigation-kit-tab-menu.more-actions-tooltip",
        "defaultMessage": "More actions"
    }
});

});


parcelRegister("8q6eC", function(module, exports) {

$parcel$export(module.exports, "MoveItem", () => $9d6543e20eb10c28$export$c684f623a254a5c0);

var $4VWIn = parcelRequire("4VWIn");

var $6zBps = parcelRequire("6zBps");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $kaHBi = parcelRequire("kaHBi");

var $koVbs = parcelRequire("koVbs");

var $feuVB = parcelRequire("feuVB");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1xdDa = parcelRequire("1xdDa");
const $9d6543e20eb10c28$export$b8b9d90f9e5bd72b = 'jiraNavigationKitRankItem';
const $9d6543e20eb10c28$export$f1e608dba99fa330 = {
    experience: 'reorderView'
};
const $9d6543e20eb10c28$export$c684f623a254a5c0 = /*#__PURE__*/ (0, $5uXOq.memo)(({ id: id, dataId: dataId, beforeItemId: beforeItemId, afterItemId: afterItemId, position: position, hasSeparator: hasSeparator, onClick: onClick, isOverflowing: isOverflowing, tabFragment: tabFragment, containerFragment: containerFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [rankNavigationItem] = (0, $feuVB.useRankNavigationItem)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        ...$9d6543e20eb10c28$export$f1e608dba99fa330,
        analyticsSource: $9d6543e20eb10c28$export$b8b9d90f9e5bd72b
    });
    const tabData = (0, $8Uumt.useFragment)((0, $6zBps.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $4VWIn.default), containerFragment);
    const handleMoveAfter = (0, $5uXOq.useCallback)(()=>{
        if (!containerData.id || !containerData.scopeId || id.includes('optimisticId') || afterItemId && afterItemId.includes('optimisticId')) return;
        onClick();
        onStartExperience();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'projectNavigationTab', {
            action: 'moveTabAfter',
            itemType: tabData.typeKey.toLowerCase(),
            itemId: tabData.appId ?? undefined,
            isInMore: Boolean(isOverflowing)
        });
        rankNavigationItem({
            placement: 'after',
            sourceTabIndex: position,
            targetTabIndex: position + 1,
            id: id,
            afterItemId: afterItemId,
            dataId: dataId,
            actionType: 'clicked',
            containerNavigationId: containerData.id,
            scopeId: containerData.scopeId
        });
    }, [
        containerData.id,
        containerData.scopeId,
        id,
        afterItemId,
        onClick,
        onStartExperience,
        createAnalyticsEvent,
        tabData.typeKey,
        tabData.appId,
        isOverflowing,
        rankNavigationItem,
        position,
        dataId
    ]);
    const handleMoveBefore = (0, $5uXOq.useCallback)(()=>{
        if (!containerData.id || !containerData.scopeId || id.includes('optimisticId') || beforeItemId && beforeItemId.includes('optimisticId')) return;
        onClick();
        onStartExperience();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdownItem clicked', 'projectNavigationTab', {
            action: 'moveTabBefore',
            itemType: tabData.typeKey.toLowerCase(),
            itemId: tabData.appId ?? undefined,
            isInMore: Boolean(isOverflowing)
        });
        rankNavigationItem({
            placement: 'before',
            sourceTabIndex: position,
            targetTabIndex: position - 1,
            id: id,
            beforeItemId: beforeItemId,
            dataId: dataId,
            actionType: 'clicked',
            containerNavigationId: containerData.id,
            scopeId: containerData.scopeId
        });
    }, [
        containerData.id,
        containerData.scopeId,
        id,
        beforeItemId,
        onClick,
        onStartExperience,
        createAnalyticsEvent,
        tabData.typeKey,
        tabData.appId,
        isOverflowing,
        rankNavigationItem,
        position,
        dataId
    ]);
    if (!beforeItemId && !afterItemId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: hasSeparator
    }, beforeItemId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: handleMoveBefore
    }, formatMessage(isOverflowing ? (0, $1xdDa.default).moveItemUp : (0, $1xdDa.default).moveItemLeft)), afterItemId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: handleMoveAfter
    }, formatMessage(isOverflowing ? (0, $1xdDa.default).moveItemDown : (0, $1xdDa.default).moveItemRight)));
});

});
parcelRegister("4VWIn", function(module, exports) {

$parcel$export(module.exports, "default", () => $66291d49f3f4b3f6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<796de95e3150e72ab27c741f11b1c768>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $66291d49f3f4b3f6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "MoveItem_container",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "scopeId"
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$66291d49f3f4b3f6$var$node.hash = "f9f8b1902c6acb52496479dc02bba4da";
var $66291d49f3f4b3f6$export$2e2bcd8739ae039 = $66291d49f3f4b3f6$var$node;

});

parcelRegister("6zBps", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2310e37c8ecc6d5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<89b87352bf0c83a85e2ac9a5d9efd446>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c2310e37c8ecc6d5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "MoveItem_tab",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "typeKey"
            },
            "action": "THROW",
            "path": "typeKey"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "appId"
                }
            ],
            "type": "JiraAppNavigationItem"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$c2310e37c8ecc6d5$var$node.hash = "d80f30b8a83df095fbc3f7cdf31473c5";
var $c2310e37c8ecc6d5$export$2e2bcd8739ae039 = $c2310e37c8ecc6d5$var$node;

});


parcelRegister("7LJ25", function(module, exports) {

$parcel$export(module.exports, "RenameItem", () => $b61c9e5b9472a046$export$ee728c052485c654);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $koVbs = parcelRequire("koVbs");

var $cUcEa = parcelRequire("cUcEa");

var $k8shd = parcelRequire("k8shd");

var $1xdDa = parcelRequire("1xdDa");
const $b61c9e5b9472a046$export$ee728c052485c654 = /*#__PURE__*/ (0, $5uXOq.memo)(({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isRenameLozengeVisible, markRenameAsSeen] = (0, $cUcEa.useOnboarding)((0, $cUcEa.RENAME_ONBOARDING));
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        markRenameAsSeen();
        onClick();
    }, [
        markRenameAsSeen,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: handleClick
    }, formatMessage((0, $1xdDa.default).renameItem), isRenameLozengeVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k8shd.NewLozenge), null));
});

});
parcelRegister("k8shd", function(module, exports) {

$parcel$export(module.exports, "NewLozenge", () => $844e714be5fe758d$export$aaf471b17355e1c6);
/* NewLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $aYAc3 = parcelRequire("aYAc3");

var $koVbs = parcelRequire("koVbs");

var $aA0vY = parcelRequire("aA0vY");
const $844e714be5fe758d$export$aaf471b17355e1c6 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        as: "span",
        paddingInlineStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, formatMessage((0, $aA0vY.messages).new)));
};

});
parcelRegister("aA0vY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b9a26d7f080fcb05$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b9a26d7f080fcb05$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    new: {
        "id": "business-onboarding-board-saved-views.new",
        "defaultMessage": "New"
    }
});

});



parcelRegister("6Y96S", function(module, exports) {

$parcel$export(module.exports, "SetAsDefaultItem", () => $62ebac591fc0f78b$export$93c39ca6fde4b432);

var $7c8T3 = parcelRequire("7c8T3");

var $1LCEa = parcelRequire("1LCEa");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6B7KL = parcelRequire("6B7KL");

var $ky7e4 = parcelRequire("ky7e4");

var $koVbs = parcelRequire("koVbs");

var $bjeNT = parcelRequire("bjeNT");

var $1xdDa = parcelRequire("1xdDa");
const $62ebac591fc0f78b$export$93c39ca6fde4b432 = /*#__PURE__*/ (0, $5uXOq.memo)(({ tabFragment: tabFragment, containerFragment: containerFragment, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { setAsDefault: setAsDefault } = (0, $bjeNT.useSetAsDefault)();
    const { id: id, __id: __id, isDefault: isDefault } = (0, $8Uumt.useFragment)((0, $1LCEa.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $7c8T3.default), containerFragment);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        if (containerData.id && !isDefault) {
            setAsDefault({
                id: id,
                __id: __id,
                containerNavigationId: containerData.id,
                scopeId: containerData?.scopeId
            });
            onClick?.();
        }
    }, [
        isDefault,
        setAsDefault,
        id,
        __id,
        containerData?.id,
        containerData?.scopeId,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: handleClick,
        elemAfter: isDefault && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ky7e4))), {
            spacing: "spacious",
            label: formatMessage((0, $1xdDa.default).selected),
            color: "var(--ds-icon-selected, #0C66E4)"
        })
    }, formatMessage((0, $1xdDa.default).setAsDefaultView));
});

});
parcelRegister("7c8T3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f4639714c7d6074$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<47d7fcf1f10547547ad3a73ed397c318>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5f4639714c7d6074$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SetAsDefaultItem_container",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "scopeId"
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$5f4639714c7d6074$var$node.hash = "656aa8c184c3ae35259916ec5158b9d3";
var $5f4639714c7d6074$export$2e2bcd8739ae039 = $5f4639714c7d6074$var$node;

});

parcelRegister("1LCEa", function(module, exports) {

$parcel$export(module.exports, "default", () => $a47f5fde4ac41b1a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f725fd96c7a7e106c21843ce289a0e68>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a47f5fde4ac41b1a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SetAsDefaultItem_tab",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isDefault"
            },
            "action": "THROW",
            "path": "isDefault"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "__id"
                    },
                    "action": "THROW",
                    "path": "__id"
                }
            ]
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$a47f5fde4ac41b1a$var$node.hash = "88982584cb03f7a8362df915df0c2838";
var $a47f5fde4ac41b1a$export$2e2bcd8739ae039 = $a47f5fde4ac41b1a$var$node;

});

parcelRegister("bjeNT", function(module, exports) {

$parcel$export(module.exports, "useSetAsDefault", () => $dd83abf0517c5abf$export$5b2c06a7e56f39a8);

var $9r9JV = parcelRequire("9r9JV");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $iJZ8l = parcelRequire("iJZ8l");

var $dXq4S = parcelRequire("dXq4S");

var $j4hty = parcelRequire("j4hty");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $eCBf9 = parcelRequire("eCBf9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $9r2Nc = parcelRequire("9r2Nc");
const $dd83abf0517c5abf$var$VIEW_NOT_DEFAULTABLE_ERROR = 'View type is not defaultable';
const $dd83abf0517c5abf$var$DEFAULT_ERROR_FLAG = {
    type: 'error',
    title: (0, $9r2Nc.default).setAsDefaultErrorFlagTitle,
    description: (0, $9r2Nc.default).setAsDefaultErrorFlagDescription,
    messageId: 'horizontal-nav-tab-menu.services.set-as-default.default-error-flag.error.flag.default-error',
    messageType: 'transactional'
};
const $dd83abf0517c5abf$var$getFlagDetails = (error)=>{
    const { message: message } = error;
    const { statusCode: statusCode } = error.extensions || {};
    switch(statusCode){
        case 400:
            if (message === $dd83abf0517c5abf$var$VIEW_NOT_DEFAULTABLE_ERROR) return {
                type: 'error',
                title: (0, $9r2Nc.default).viewNotDefaultableErrorFlagTitle,
                description: (0, $9r2Nc.default).viewNotDefaultableErrorFlagDescription,
                messageId: 'horizontal-nav-tab-menu.services.set-as-default.flag.error.view-not-defaultable-error',
                messageType: 'transactional'
            };
            return null;
        case 401:
            return {
                type: 'error',
                title: (0, $9r2Nc.default).userNotLoggedInErrorFlagTitle,
                description: (0, $9r2Nc.default).userNotLoggedInErrorFlagDescription,
                messageId: 'horizontal-nav-tab-menu.services.set-as-default.flag.error.user-not-logged-in-error',
                messageType: 'transactional'
            };
        case 403:
            return {
                type: 'error',
                title: (0, $9r2Nc.default).userNotAdminErrorFlagTitle,
                description: (0, $9r2Nc.default).userNotAdminErrorFlagDescription,
                messageId: 'horizontal-nav-tab-menu.services.set-as-default.flag.error.user-not-admin-error',
                messageType: 'transactional'
            };
        case 404:
            return {
                type: 'error',
                title: (0, $9r2Nc.default).viewNotFoundErrorFlagTitle,
                description: (0, $9r2Nc.default).viewNotFoundErrorFlagDescription,
                messageId: 'horizontal-nav-tab-menu.services.set-as-default.flag.error.view-not-found-error',
                messageType: 'transactional'
            };
        default:
            return null;
    }
};
const $dd83abf0517c5abf$export$b8b9d90f9e5bd72b = 'jiraNavigationKitTabMenu';
const $dd83abf0517c5abf$export$c028e73dc12a34c5 = 'setAsDefaultView';
const $dd83abf0517c5abf$export$f444706ea2b317f8 = {
    experience: $dd83abf0517c5abf$export$c028e73dc12a34c5
};
const $dd83abf0517c5abf$export$5b2c06a7e56f39a8 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onStartExperience = (0, $kaHBi.useExperienceStart)({
        ...$dd83abf0517c5abf$export$f444706ea2b317f8,
        analyticsSource: $dd83abf0517c5abf$export$b8b9d90f9e5bd72b
    });
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)($dd83abf0517c5abf$export$f444706ea2b317f8);
    const onExperienceFail = (0, $93jKl.useExperienceFail)($dd83abf0517c5abf$export$f444706ea2b317f8);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $9r9JV.default));
    const handleError = (0, $5uXOq.useCallback)((error)=>{
        showFlag($dd83abf0517c5abf$var$DEFAULT_ERROR_FLAG);
        (0, $jcw0u.default)({
            meta: {
                id: $dd83abf0517c5abf$export$c028e73dc12a34c5,
                packageName: $dd83abf0517c5abf$export$b8b9d90f9e5bd72b,
                teamName: (0, $04a58e169bed821f$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail($dd83abf0517c5abf$export$b8b9d90f9e5bd72b, error);
    }, [
        onExperienceFail,
        showFlag
    ]);
    const setAsDefault = (0, $5uXOq.useCallback)(({ id: id, __id: __id, containerNavigationId: containerNavigationId, scopeId: scopeId })=>{
        let initialTabOrder = [];
        onStartExperience();
        commitMutation({
            variables: {
                input: {
                    id: id,
                    scopeId: scopeId
                }
            },
            optimisticUpdater: (store)=>{
                initialTabOrder = (0, $j4hty.getAnalyticsTabOrder)(store, containerNavigationId);
                const edges = (0, $j4hty.getStoreEdges)(store, containerNavigationId);
                if (!edges) return;
                edges.forEach((edge)=>{
                    const node = edge?.getLinkedRecord('node');
                    if (node?.getValue('isDefault') === true && node?.getValue('id') !== id) node.setValue(false, 'isDefault');
                    if (node?.getValue('id') === id) node?.setValue(true, 'isDefault');
                });
            },
            updater: (store, response)=>{
                const newDefaultRecord = store.get(__id);
                if (response?.jira?.setDefaultNavigationItem?.success) {
                    if (scopeId) {
                        const ariConfig = (0, $dXq4S.getAriConfig)(scopeId);
                        const scopeType = ariConfig.resourceType === 'board' ? 'JiraBoard' : 'JiraProject';
                        const scopeRelayId = (0, $iJZ8l.default)({
                            id: scopeId
                        }, scopeType);
                        if (scopeRelayId && newDefaultRecord) {
                            const scopeRecord = store.get(scopeRelayId);
                            scopeRecord?.setLinkedRecord(newDefaultRecord, 'defaultNavigationItem');
                        }
                    }
                    const finalTabOrder = (0, $j4hty.getAnalyticsTabOrder)(store, containerNavigationId);
                    const itemId = newDefaultRecord?.getValue('appId');
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectNavigationTabItem updated', {
                        originalItems: initialTabOrder,
                        updatedItems: finalTabOrder,
                        itemType: String(newDefaultRecord?.getValue('typeKey')).toLowerCase(),
                        itemId: itemId && String(itemId).toLowerCase(),
                        action: 'setAsDefault'
                    });
                }
            },
            onCompleted: (result)=>{
                const { success: success, newDefault: newDefault, errors: errors } = result?.jira?.setDefaultNavigationItem ?? {};
                if (success && newDefault && !errors) {
                    showFlag({
                        messageId: 'horizontal-nav-tab-menu.services.set-as-default.show-flag.success.flag.success',
                        messageType: 'transactional',
                        type: 'success',
                        title: formatMessage((0, $9r2Nc.default).setAsDefaultSuccessFlagTitle, {
                            viewName: newDefault.label
                        }),
                        description: formatMessage((0, $9r2Nc.default).setAsDefaultSuccessFlagDescription, {
                            viewName: newDefault.label
                        })
                    });
                    onExperienceSuccess();
                    return;
                }
                if (errors) {
                    const error = new (0, $eCBf9.MutationError)(errors[0]);
                    const statusCode = error.statusCode;
                    if (statusCode != null) {
                        const flagDetails = $dd83abf0517c5abf$var$getFlagDetails(error);
                        if (flagDetails) {
                            showFlag(flagDetails);
                            onExperienceSuccess();
                            return;
                        }
                    }
                    handleError(error);
                }
            },
            onError: (error)=>handleError(error)
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        formatMessage,
        handleError,
        onExperienceSuccess,
        onStartExperience,
        showFlag
    ]);
    return {
        setAsDefault: setAsDefault
    };
};

});
parcelRegister("9r9JV", function(module, exports) {

$parcel$export(module.exports, "default", () => $77ce27a3e25782bf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1d61d252896575ea2884d483ecd96119>>
 * @relayHash 1cdf55f994a6939963be94479cc21daf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 872712d044652e051fd8469f058c446a98f4a24a673c90d4f0a276d049ce2128
const $77ce27a3e25782bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "label"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isDefault"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "setAsDefaultItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSetDefaultNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "setDefaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "newDefault",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "previousDefault",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "setAsDefaultItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSetDefaultNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "setDefaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "newDefault",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "previousDefault",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "872712d044652e051fd8469f058c446a98f4a24a673c90d4f0a276d049ce2128",
            "metadata": {},
            "name": "setAsDefaultItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$77ce27a3e25782bf$var$node.hash = "bcaaa14d2f29d8020f8238f6031efdc3";
var $77ce27a3e25782bf$export$2e2bcd8739ae039 = $77ce27a3e25782bf$var$node;

});

const $04a58e169bed821f$export$d57b6b390e78d90f = 'Navigation';

parcelRegister("9r2Nc", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf6ca7d9747b0867$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cf6ca7d9747b0867$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    setAsDefaultSuccessFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.set-as-default-success-flag-title",
        "defaultMessage": "{viewName} set as default view"
    },
    setAsDefaultSuccessFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.set-as-default-success-flag-description",
        "defaultMessage": "{viewName} will be the default view for everyone."
    },
    setAsDefaultErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.set-as-default-error-flag-title",
        "defaultMessage": "Something's gone wrong"
    },
    setAsDefaultErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.set-as-default-error-flag-description",
        "defaultMessage": "Refresh the page and try again."
    },
    userNotLoggedInErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.user-not-logged-in-error-flag-title",
        "defaultMessage": "You'll need to log in"
    },
    userNotLoggedInErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.user-not-logged-in-error-flag-description",
        "defaultMessage": "You need to be logged in to set this view as default. Please log in and try again."
    },
    userNotAdminErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.user-not-admin-error-flag-title",
        "defaultMessage": "You don't have permission"
    },
    userNotAdminErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.user-not-admin-error-flag-description",
        "defaultMessage": "You are not allowed to manage the navigation."
    },
    viewNotDefaultableErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.view-not-defaultable-error-flag-title",
        "defaultMessage": "Choose a different default view"
    },
    viewNotDefaultableErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.view-not-defaultable-error-flag-description",
        "defaultMessage": "You can only set the summary, board, list, calendar, or timeline as the default view."
    },
    viewNotFoundErrorFlagTitle: {
        "id": "navigation-kit-tab-menu.services.set-as-default.view-not-found-error-flag-title",
        "defaultMessage": "This view tab been removed"
    },
    viewNotFoundErrorFlagDescription: {
        "id": "navigation-kit-tab-menu.services.set-as-default.view-not-found-error-flag-description",
        "defaultMessage": "The tab you're trying to set as default can't be found."
    }
});

});




parcelRegister("1vy6C", function(module, exports) {

$parcel$export(module.exports, "useRenameNavigationItem", () => $93fe6a770d7bd80f$export$881d234560f027b5);

var $jl13J = parcelRequire("jl13J");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $eCBf9 = parcelRequire("eCBf9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $HZElK = parcelRequire("HZElK");
const $93fe6a770d7bd80f$var$DEFAULT_ERROR_FLAG = {
    type: 'error',
    title: (0, $HZElK.default).defaultErrorFlagTitle,
    description: (0, $HZElK.default).defaultErrorFlagDescription,
    messageType: 'transactional',
    messageId: 'horizontal-nav-tab-menu.services.rename-navigation-item.default-error-flag.error.horizontal-nav-tab-menu-rename-navigation-item-default-error'
};
const $93fe6a770d7bd80f$var$getFlagDetails = (error)=>{
    const { message: message } = error;
    const { statusCode: statusCode } = error.extensions || {};
    switch(statusCode){
        case 400:
        case 404:
            return {
                type: 'error',
                title: (0, $HZElK.default).defaultErrorFlagTitle,
                description: message,
                messageType: 'transactional',
                messageId: 'horizontal-nav-tab-menu.services.rename-navigation-item.flag.error.horizontal-nav-tab-menu-rename-navigation-item-request-error'
            };
        case 401:
            return {
                type: 'error',
                title: (0, $HZElK.default).userNotLoggedInErrorFlagTitle,
                description: (0, $HZElK.default).userNotLoggedInErrorFlagDescription,
                messageType: 'transactional',
                messageId: 'horizontal-nav-tab-menu.services.rename-navigation-item.flag.error.horizontal-nav-tab-menu-rename-navigation-item-not-logged-in-error'
            };
        case 403:
            return {
                type: 'error',
                title: (0, $HZElK.default).userNotAdminErrorFlagTitle,
                description: (0, $HZElK.default).userNotAdminErrorFlagDescription,
                messageType: 'transactional',
                messageId: 'horizontal-nav-tab-menu.services.rename-navigation-item.flag.error.horizontal-nav-tab-menu-rename-navigation-item-not-admin-error'
            };
        default:
            return null;
    }
};
const $93fe6a770d7bd80f$export$881d234560f027b5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $jl13J.default));
    const onError = (0, $5uXOq.useCallback)((error)=>{
        showFlag($93fe6a770d7bd80f$var$DEFAULT_ERROR_FLAG);
        (0, $jcw0u.default)({
            meta: {
                id: 'renameNavigationItem',
                packageName: 'jiraHorizontalNavTabMenu',
                teamName: (0, $04a58e169bed821f$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        showFlag
    ]);
    return (0, $5uXOq.useCallback)(({ id: id, label: label, scopeId: scopeId, typeKey: typeKey, __typename: __typename })=>{
        commitMutation({
            variables: {
                input: {
                    id: id,
                    label: label,
                    scopeId: scopeId
                }
            },
            optimisticResponse: {
                jira: {
                    renameNavigationItem: {
                        success: true,
                        errors: null,
                        navigationItem: {
                            __typename: __typename,
                            label: label,
                            id: id
                        }
                    }
                }
            },
            onError: onError,
            onCompleted: (response)=>{
                if (response?.jira?.renameNavigationItem?.success === true) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'navigationItem renamed', {
                    typeKey: typeKey
                });
                else {
                    const firstError = response?.jira?.renameNavigationItem?.errors?.[0] ?? new Error('Unknown error');
                    const error = new (0, $eCBf9.MutationError)(firstError);
                    const flagDetails = $93fe6a770d7bd80f$var$getFlagDetails(error);
                    if (flagDetails) {
                        showFlag(flagDetails);
                        return;
                    }
                    onError(error);
                }
            }
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        onError,
        showFlag
    ]);
};

});
parcelRegister("jl13J", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fb29934efb3f8c8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fac2ccbfb6948585efd00ec262359df8>>
 * @relayHash 08ee531ee69dd70fba8cb7fc363431a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 271fc93bc9fd489bc0676a5a66d01039bb9f930387ee55b1ad3f33ebcee271eb
const $3fb29934efb3f8c8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "label"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "renameNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRenameNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "renameNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "navigationItem",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "renameNavigationItemMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraRenameNavigationItemPayload",
                            "kind": "LinkedField",
                            "name": "renameNavigationItem",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "navigationItem",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "271fc93bc9fd489bc0676a5a66d01039bb9f930387ee55b1ad3f33ebcee271eb",
            "metadata": {},
            "name": "renameNavigationItemMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$3fb29934efb3f8c8$var$node.hash = "89c71efe0597e03c9897cee5d89d8941";
var $3fb29934efb3f8c8$export$2e2bcd8739ae039 = $3fb29934efb3f8c8$var$node;

});

parcelRegister("HZElK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ce26e2314f52d94$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0ce26e2314f52d94$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultErrorFlagTitle: {
        "id": "jira-horizontal-nav-tab-menu.services.rename-navigation-item.default-error-flag-title",
        "defaultMessage": "We couldn't update the view name"
    },
    defaultErrorFlagDescription: {
        "id": "jira-horizontal-nav-tab-menu.services.rename-navigation-item.default-error-flag-description",
        "defaultMessage": "Refresh the page and try again."
    },
    userNotLoggedInErrorFlagTitle: {
        "id": "jira-horizontal-nav-tab-menu.rename-navigation-item.user-not-logged-in-error-flag-title",
        "defaultMessage": "You'll need to log in"
    },
    userNotLoggedInErrorFlagDescription: {
        "id": "jira-horizontal-nav-tab-menu.rename-navigation-item.user-not-logged-in-error-flag-description",
        "defaultMessage": "You need to be logged in to rename this view. Please log in and try again."
    },
    userNotAdminErrorFlagTitle: {
        "id": "jira-horizontal-nav-tab-menu.rename-navigation-item.user-not-admin-error-flag-title",
        "defaultMessage": "You don't have permission"
    },
    userNotAdminErrorFlagDescription: {
        "id": "jira-horizontal-nav-tab-menu.rename-navigation-item.user-not-admin-error-flag-description",
        "defaultMessage": "You are not allowed to rename views."
    }
});

});




parcelRegister("8hXfI", function(module, exports) {

$parcel$export(module.exports, "AppTab", () => $1797734e5bab4540$export$fca347df63cfad2c);

var $7K2QI = parcelRequire("7K2QI");

var $empIN = parcelRequire("empIN");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $hrlU6 = parcelRequire("hrlU6");

var $byTKd = parcelRequire("byTKd");




var $3F9p6 = parcelRequire("3F9p6");

var $aUk4j = parcelRequire("aUk4j");

var $7uRML = parcelRequire("7uRML");

var $hukKC = parcelRequire("hukKC");

var $haoad = parcelRequire("haoad");
const $1797734e5bab4540$export$fca347df63cfad2c = ({ tabFragment: tabFragment, containerFragment: containerFragment, position: position, beforeItemId: beforeItemId, afterItemId: afterItemId })=>{
    const webItemRef = (0, $5uXOq.useRef)(null);
    const tabData = (0, $8Uumt.useFragment)((0, $empIN.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $7K2QI.default), containerFragment);
    const triggerAnalytics = (0, $byTKd.useNavigationItemAnalytics)((0, $5uXOq.useMemo)(()=>({
            itemType: 'app',
            itemId: tabData.appId ?? '',
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            stage: (0, $3F9p6.getNav4Rollout)().stage,
            navigationLayer: (0, $ce9c0831aed9ffb3$export$33d8c916a600c5e9),
            navigationContainer: (0, $68cb678dc917978e$export$f1c9dd0f5207dd5e),
            isInMore: false
        }), [
        tabData.appId
    ]));
    const onClick = (0, $5uXOq.useCallback)((e)=>{
        if (tabData.styleClass) {
            (0, $hrlU6.withConnectHost)((connectHost)=>{
                if (webItemRef.current && tabData.url) connectHost.triggerWebItem(webItemRef.current, tabData.styleClass ?? '', tabData.url);
            });
            if ((0, $hrlU6.isConnectDialogWebItem)(tabData.styleClass)) {
                e.preventDefault();
                e.stopPropagation();
            }
        }
        triggerAnalytics();
    }, [
        tabData.styleClass,
        tabData.url,
        triggerAnalytics
    ]);
    if (tabData.sections && tabData.sections.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7uRML.AppTabMenu), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aUk4j.default), {
            url: tabData.iconUrl || '',
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hukKC.AppEnvLozenge), {
            label: tabData.envLabel || ''
        }),
        tabFragment: tabData,
        containerFragment: containerData,
        testId: `horizontal-nav.app-tab.${tabData.label}`,
        position: position,
        onClick: triggerAnalytics,
        beforeItemId: beforeItemId,
        afterItemId: afterItemId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $haoad.TabWithMenu), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aUk4j.default), {
            url: tabData.iconUrl || '',
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hukKC.AppEnvLozenge), {
            label: tabData.envLabel || ''
        }),
        href: tabData.url,
        tabFragment: tabData,
        containerFragment: containerData,
        onClick: onClick,
        testId: `horizontal-nav.app-tab.${tabData.label}`,
        beforeItemId: beforeItemId,
        afterItemId: afterItemId,
        position: position,
        type: "router-link",
        ref: webItemRef
    });
};
var $1797734e5bab4540$export$2e2bcd8739ae039 = $1797734e5bab4540$export$fca347df63cfad2c;

});
parcelRegister("7K2QI", function(module, exports) {

$parcel$export(module.exports, "default", () => $96239980f0bcc191$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7f951b0c8c256682bae1d46d09e2cf2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $96239980f0bcc191$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AppTab_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_container"
        },
        {
            "kind": "FragmentSpread",
            "name": "AppTabMenu_container"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$96239980f0bcc191$var$node.hash = "8257e51a0537d2533d3cb266fbb85918";
var $96239980f0bcc191$export$2e2bcd8739ae039 = $96239980f0bcc191$var$node;

});

parcelRegister("empIN", function(module, exports) {

$parcel$export(module.exports, "default", () => $94af1d49e6ad4653$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<28152e0fd82463bb04d925e467b2c53c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $94af1d49e6ad4653$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "label"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "AppTab_tab",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "TabWithMenu_tab"
            },
            {
                "kind": "FragmentSpread",
                "name": "AppTabMenu_tab"
            },
            {
                "kind": "RequiredField",
                "field": v0 /*: any*/ ,
                "action": "THROW",
                "path": "label"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "url"
                },
                "action": "THROW",
                "path": "url"
            },
            {
                "kind": "ScalarField",
                "name": "appId"
            },
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            {
                "kind": "ScalarField",
                "name": "styleClass"
            },
            {
                "kind": "ScalarField",
                "name": "envLabel"
            },
            {
                "concreteType": "JiraAppSection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                    v0 /*: any*/ 
                ]
            }
        ],
        "type": "JiraAppNavigationItem"
    };
}();
$94af1d49e6ad4653$var$node.hash = "93b2820577820b8e46d082f49f2dc9ff";
var $94af1d49e6ad4653$export$2e2bcd8739ae039 = $94af1d49e6ad4653$var$node;

});

parcelRegister("hrlU6", function(module, exports) {

$parcel$export(module.exports, "withConnectHost", () => $9316db67541b8a94$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $9316db67541b8a94$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $9316db67541b8a94$export$920fb4b46d4f2eec);

var $dJZWD = parcelRequire("dJZWD");
const $9316db67541b8a94$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $dJZWD.setupConnectJs)();
    action(connectHost);
};
const $9316db67541b8a94$export$186d423c00af146c = ()=>window.connectHost;
const $9316db67541b8a94$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("dJZWD", function(module, exports) {

$parcel$export(module.exports, "setupConnectJs", () => $762ba9fa524ea8e6$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
var $cQZXC = parcelRequire("cQZXC");

var $dH9DT = parcelRequire("dH9DT");

const $762ba9fa524ea8e6$var$installConnectJs = async ()=>{
    // we need the heritage to load in order for WRM core and jQuery to exist.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $cQZXC.waitForHeritage)();
    await (0, $dH9DT.waitForJQuery)();
    const loader = await (parcelRequire("fsoZQ"));
    await loader.performSideEffects();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};
let $762ba9fa524ea8e6$var$installConnectJsPromise = null;
const $762ba9fa524ea8e6$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__SPA__) {
        if ($762ba9fa524ea8e6$var$installConnectJsPromise === null) $762ba9fa524ea8e6$var$installConnectJsPromise = $762ba9fa524ea8e6$var$installConnectJs();
        return $762ba9fa524ea8e6$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $6BZYo.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};

});
parcelRegister("6BZYo", function(module, exports) {

$parcel$export(module.exports, "loadBridge", () => $ce95ee3fd66207c7$export$df8409da353bde5a);

var $fqWWz = parcelRequire("fqWWz");
var $3GASE = parcelRequire("3GASE");
var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");

var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");
var $8JNtu = parcelRequire("8JNtu");
var $5Ik5Y = parcelRequire("5Ik5Y");
const $ce95ee3fd66207c7$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $fqWWz.MAX_RETRIES), timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $7T84i.loadBridgeStrict)({
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $3GASE.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $ig88W.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("fqWWz", function(module, exports) {

$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $71bf66166926d1dc$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $71bf66166926d1dc$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $71bf66166926d1dc$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $71bf66166926d1dc$export$37f20f0ff732fcd7);

var $2YZCu = parcelRequire("2YZCu");
const { safeErrorWithoutCustomerData: $71bf66166926d1dc$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $71bf66166926d1dc$export$ea810ce67e3c8eac } = (0, $2YZCu.default);
const $71bf66166926d1dc$export$1f86472c1374185a = 40;
const $71bf66166926d1dc$export$7bd623b29ec8e1eb = 500;
const $71bf66166926d1dc$export$37f20f0ff732fcd7 = true;

});

parcelRegister("3GASE", function(module, exports) {

$parcel$export(module.exports, "loadBridgeBail", () => $e512b6cc4a8702e5$export$a036f92c2465504e);

var $wRU6t = parcelRequire("wRU6t");

var $fqWWz = parcelRequire("fqWWz");
const $e512b6cc4a8702e5$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $wRU6t.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("wRU6t", function(module, exports) {

$parcel$export(module.exports, "safeStringify", () => $7e2bd894031d4476$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7e2bd894031d4476$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});


parcelRegister("ig88W", function(module, exports) {

$parcel$export(module.exports, "loadBridgeRace", () => $64f1dbae1ea314ee$export$20c32b4579d78b92);

var $3GASE = parcelRequire("3GASE");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $64f1dbae1ea314ee$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $9B86Q.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $3GASE.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("9B86Q", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $61b2a5aa3a2a1160$export$3cefda82396756a1);

var $ifVVd = parcelRequire("ifVVd");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $61b2a5aa3a2a1160$var$pollingSingleton = null;
const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, $ifVVd.createPollingCollection)((v)=>window.require(v), 100);
    $61b2a5aa3a2a1160$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("ifVVd", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $60e6b0d4bc46beac$export$f163446a982a8077);

var $gKZoD = parcelRequire("gKZoD");

var $aePFs = parcelRequire("aePFs");
const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gKZoD.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $aePFs.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $aePFs.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("aePFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f3c6551bf5b1ff$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




parcelRegister("7T84i", function(module, exports) {

$parcel$export(module.exports, "loadBridgeStrict", () => $89a95eb8b151782d$export$eba600d28decc4ac);

var $c56lL = parcelRequire("c56lL");

var $ig88W = parcelRequire("ig88W");

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $89a95eb8b151782d$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    (0, $c56lL.saveStats)(name, wrmKeys);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $fVOHM.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $ig88W.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("c56lL", function(module, exports) {

$parcel$export(module.exports, "saveStats", () => $6c875a5034ae8433$export$9ea3ff7978093559);
const $6c875a5034ae8433$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $6c875a5034ae8433$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $6c875a5034ae8433$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $6c875a5034ae8433$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $6c875a5034ae8433$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6c875a5034ae8433$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $6c875a5034ae8433$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $6c875a5034ae8433$var$initStats();
        // stop accumulating stats at TTI mark
        if ($6c875a5034ae8433$var$isPageInteractive()) return;
        stats.requests += 1;
        $6c875a5034ae8433$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$6c875a5034ae8433$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $6c875a5034ae8433$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("fVOHM", function(module, exports) {

$parcel$export(module.exports, "loadWrmResources", () => $0c0552c7bb135144$export$6cda16b6eff75f59);

var $wRU6t = parcelRequire("wRU6t");

var $294PS = parcelRequire("294PS");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $0c0552c7bb135144$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $9B86Q.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $294PS.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("294PS", function(module, exports) {

$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $a437264dd6b89021$export$93d9db5fbabad1b0);

var $1r4rO = parcelRequire("1r4rO");
let $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = false;
const $a437264dd6b89021$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $a437264dd6b89021$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($a437264dd6b89021$var$isSuperBatchDependenciesLoaded || $a437264dd6b89021$var$isOnRapidBoardsPage()) return wrmKeys;
    $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = true;
    return (0, $1r4rO.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("1r4rO", function(module, exports) {

$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $e87d6a02e2466ae8$export$f14a6b583ce9e077);
const $e87d6a02e2466ae8$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});




parcelRegister("cQZXC", function(module, exports) {

$parcel$export(module.exports, "waitForHeritage", () => $90def0f7a7aa11d6$export$c61060338d026f78);

var $7aBP4 = parcelRequire("7aBP4");

var $aePFs = parcelRequire("aePFs");
const $90def0f7a7aa11d6$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WAIT_FOR_HERITAGE__ = new (0, $aePFs.default)();
        (0, $7aBP4.bootstrapWrmClient)().then(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__WAIT_FOR_HERITAGE__.resolve();
        });
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});
parcelRegister("7aBP4", function(module, exports) {

$parcel$export(module.exports, "bootstrapWrmClient", () => $f93199c7ae9c59d8$export$d001f71dd306cb0c);

var $7f4tk = parcelRequire("7f4tk");

var $wRU6t = parcelRequire("wRU6t");

var $jcw0u = parcelRequire("jcw0u");
const $f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
const $f93199c7ae9c59d8$var$fetchSpaWrmContext = async ()=>{
    return (0, $7f4tk.default)($f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT);
};
const $f93199c7ae9c59d8$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
    let element;
    if (resourceType === 'JAVASCRIPT') {
        element = globalThis.document?.createElement('script');
        element.setAttribute('crossorigin', '');
        element.setAttribute('src', url);
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    } else {
        element = globalThis.document?.createElement('link');
        element.setAttribute('crossorigin', '');
        element.setAttribute('href', url);
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('media', 'all');
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    }
    return element;
};
let $f93199c7ae9c59d8$var$hasWrmInitialised;
const $f93199c7ae9c59d8$var$runBootstrap = ()=>{
    const spaWrmContext = $f93199c7ae9c59d8$var$fetchSpaWrmContext();
    return new Promise((resolve, reject)=>{
        spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
            // eslint-disable-next-line no-multi-assign
            const WRM = globalThis.WRM = globalThis.WRM || {};
            WRM._unparsedData = data;
            WRM._unparsedErrors = errors;
            if (WRM._dataArrived) WRM._dataArrived();
            resources.map($f93199c7ae9c59d8$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
            resolve();
        }).catch((error)=>{
            (0, $jcw0u.default)({
                error: new Error((0, $wRU6t.safeStringify)(error)),
                meta: {
                    id: 'bootstrap-wrm-client',
                    packageName: 'common-bridge',
                    teamName: 'jfp-magma'
                }
            });
            reject(new Error('Failed to fetch the spa wrm context'));
        });
    });
};
const $f93199c7ae9c59d8$export$d001f71dd306cb0c = ()=>{
    if (false) return Promise.resolve();
    if ($f93199c7ae9c59d8$var$hasWrmInitialised) return $f93199c7ae9c59d8$var$hasWrmInitialised;
    // todo maybe a more robust check to validate whether WRM initialisation already underway?
    if (typeof globalThis.WRM !== 'undefined') $f93199c7ae9c59d8$var$hasWrmInitialised = Promise.resolve();
    else $f93199c7ae9c59d8$var$hasWrmInitialised = $f93199c7ae9c59d8$var$runBootstrap();
    return $f93199c7ae9c59d8$var$hasWrmInitialised;
};

});


parcelRegister("8JNtu", function(module, exports) {

$parcel$export(module.exports, "wrmRequire", () => $17e2d7d864398bad$export$cc9d8f51375ef66a);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $17e2d7d864398bad$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("5Ik5Y", function(module, exports) {

$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $a1df1daee76d40f7$export$e53a5db19a39ed2f);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $a1df1daee76d40f7$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});


parcelRegister("dH9DT", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $a78c52ec7ed5d025$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $a78c52ec7ed5d025$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $a78c52ec7ed5d025$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $a78c52ec7ed5d025$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $a78c52ec7ed5d025$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $a78c52ec7ed5d025$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $a78c52ec7ed5d025$export$d690da9bc8146677);

var $jcw0u = parcelRequire("jcw0u");

const $a78c52ec7ed5d025$export$c47913ca32a5c6f7 = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $a78c52ec7ed5d025$export$7232a6dc780f9887 = ()=>AJS.$;
const $a78c52ec7ed5d025$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public @atlassian/atlassian-connect-js library.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window._AP;
const $a78c52ec7ed5d025$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $a78c52ec7ed5d025$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $a78c52ec7ed5d025$var$FIVE_MINUTES = 300000;
const $a78c52ec7ed5d025$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $jcw0u.default)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $a78c52ec7ed5d025$var$FIVE_MINUTES);
    });
const $a78c52ec7ed5d025$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $a78c52ec7ed5d025$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $a78c52ec7ed5d025$export$d690da9bc8146677 = [
    $a78c52ec7ed5d025$export$cb954c21735b28e4,
    $a78c52ec7ed5d025$export$7315c38dc71bd41f
];

});

parcelRegister("fsoZQ", function(module, exports) {

let $b40cdc4ebdd385ab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b40cdc4ebdd385ab$var$load("gZGeX").then(()=>parcelRequire('8vJyT'));

});



parcelRegister("aUk4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $edf3f4c4729be8b6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8vDvO = parcelRequire("8vDvO");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $edf3f4c4729be8b6$var$AppIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.size === 'small' ? "_1bsbpxbi" : "_1bsbv47k",
            __cmplp.size === 'small' ? "_4t3ipxbi" : "_4t3iv47k",
            __cmplp.className
        ])
    });
});
const $edf3f4c4729be8b6$var$AppItemIcon = ({ url: url, size: size })=>url != null && String(url).trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($edf3f4c4729be8b6$var$AppIcon, {
        src: url,
        alt: "",
        size: size
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8vDvO))), {
        label: "",
        spacing: size === 'small' ? 'none' : 'spacious',
        color: "currentColor",
        LEGACY_size: size
    });
var $edf3f4c4729be8b6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($edf3f4c4729be8b6$var$AppItemIcon);

});

parcelRegister("7uRML", function(module, exports) {

$parcel$export(module.exports, "AppTabMenu", () => $ec5f406842763762$export$ab6e213c275a503b);

var $44zJ1 = parcelRequire("44zJ1");

var $fJZmM = parcelRequire("fJZmM");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $ujWmd = parcelRequire("ujWmd");

var $3Z96c = parcelRequire("3Z96c");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $hrlU6 = parcelRequire("hrlU6");

var $byTKd = parcelRequire("byTKd");

var $bYbah = parcelRequire("bYbah");




var $3F9p6 = parcelRequire("3F9p6");

var $1WfM5 = parcelRequire("1WfM5");

var $jgJNO = parcelRequire("jgJNO");

var $haoad = parcelRequire("haoad");
const $ec5f406842763762$export$ab6e213c275a503b = ({ tabFragment: tabFragment, containerFragment: containerFragment, position: position, icon: icon, testId: testId, elemAfter: elemAfter, beforeItemId: beforeItemId, afterItemId: afterItemId, onClick: onClick })=>{
    const [isDropdownMenuOpen, setIsDropdownMenuOpen] = (0, $5uXOq.useState)(false);
    const { isOverflowing: isOverflowing } = (0, $1WfM5.useTabContext)();
    const { registerTab: registerTab } = (0, $bYbah.useTabShortcuts)();
    const webItemRefs = (0, $5uXOq.useRef)([]);
    const tabData = (0, $8Uumt.useFragment)((0, $fJZmM.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $44zJ1.default), containerFragment);
    (0, $5uXOq.useEffect)(()=>{
        if (tabData.label) {
            const deregisterTab = registerTab({
                index: position,
                callback: ()=>{
                    setIsDropdownMenuOpen((isDropdownMenuCurrent)=>!isDropdownMenuCurrent);
                },
                label: tabData.label
            });
            return deregisterTab;
        }
        return 0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz));
    }, [
        registerTab,
        tabData.label,
        position
    ]);
    const triggerAnalytics = (0, $byTKd.useNavigationItemAnalytics)((0, $5uXOq.useMemo)(()=>({
            itemType: 'appSubpage',
            itemId: tabData.appId ?? '',
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            stage: (0, $3F9p6.getNav4Rollout)().stage,
            navigationLayer: (0, $ce9c0831aed9ffb3$export$33d8c916a600c5e9),
            navigationContainer: (0, $68cb678dc917978e$export$f1c9dd0f5207dd5e),
            isInMore: false
        }), [
        tabData.appId
    ]));
    if (!tabData.label) return null;
    const handleClick = ()=>{
        setIsDropdownMenuOpen((isDropdownMenuCurrent)=>!isDropdownMenuCurrent);
        onClick?.();
    };
    const handleConnectItemClick = (className, href, sectionIndex, index)=>(e)=>{
            if (className && href) {
                (0, $hrlU6.withConnectHost)((connectHost)=>{
                    connectHost.triggerWebItem(webItemRefs.current[sectionIndex][index], className, href);
                });
                if ((0, $hrlU6.isConnectDialogWebItem)(className)) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
            triggerAnalytics();
        };
    const trigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $haoad.TabWithMenu), {
            ...triggerProps,
            type: "dropdown-trigger",
            isOpen: isDropdownMenuOpen,
            onClick: handleClick,
            elemBefore: icon,
            position: position,
            tabFragment: tabData,
            containerFragment: containerData,
            elemAfter: elemAfter,
            testId: testId,
            beforeItemId: beforeItemId,
            afterItemId: afterItemId
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        trigger: trigger,
        placement: isOverflowing ? 'left' : 'bottom-end',
        messageId: "horizontal-nav-tabs.ui.popup",
        messageType: "transactional",
        shouldFlip: false,
        isOpen: isDropdownMenuOpen,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "horizontal-nav-app-tab.ui.app-menu.dropdown-menu",
        onClose: ()=>setIsDropdownMenuOpen((isDropdownMenuCurrent)=>!isDropdownMenuCurrent),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), null, tabData?.sections && tabData?.sections.map((section, i)=>{
                if (!webItemRefs.current[i]) webItemRefs.current[i] = new Array(section?.links?.length ?? 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
                    key: section?.label ?? `section-${i}`,
                    title: section?.label ?? undefined,
                    hasSeparator: i !== 0
                }, (section?.links ?? []).filter((link)=>link && link.label).map((link, j)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
                        key: link?.label ?? `link-${j}`,
                        href: link?.url ?? '',
                        isDisabled: !link?.url,
                        iconBefore: link?.iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
                            src: link.iconUrl,
                            size: "small"
                        }) : undefined,
                        onClick: handleConnectItemClick(link?.styleClass, link?.url, i, j),
                        ref: (ref)=>{
                            if (ref !== null) webItemRefs.current[i][j] = ref;
                        }
                    }, link?.label)));
            }))
    });
};

});
parcelRegister("44zJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $58aa5b805460479e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2792c6bb12caa73c8e12008719c7617a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $58aa5b805460479e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "AppTabMenu_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_container"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$58aa5b805460479e$var$node.hash = "687af9e59bccecfe4646886b7021170f";
var $58aa5b805460479e$export$2e2bcd8739ae039 = $58aa5b805460479e$var$node;

});

parcelRegister("fJZmM", function(module, exports) {

$parcel$export(module.exports, "default", () => $649ddca6218e3657$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5347f212c1326652ffb0a0988293a41e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $649ddca6218e3657$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "label"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "AppTabMenu_tab",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "TabWithMenu_tab"
            },
            {
                "kind": "ScalarField",
                "name": "appId"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "concreteType": "JiraAppSection",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "concreteType": "JiraAppNavigationItemNestedLink",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "iconUrl"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "url"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "styleClass"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAppNavigationItem"
    };
}();
$649ddca6218e3657$var$node.hash = "0b52617895e2febba892c1e3d0914263";
var $649ddca6218e3657$export$2e2bcd8739ae039 = $649ddca6218e3657$var$node;

});


parcelRegister("hukKC", function(module, exports) {

$parcel$export(module.exports, "AppEnvLozenge", () => $473d92cf52b729c9$export$63905d23c4aa4c89);

var $5uXOq = parcelRequire("5uXOq");

var $aYAc3 = parcelRequire("aYAc3");
const $473d92cf52b729c9$export$63905d23c4aa4c89 = ({ label: label })=>label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: label === 'Dev' ? 'default' : 'moved'
    }, label) : null;

});


parcelRegister("bHBFf", function(module, exports) {

$parcel$export(module.exports, "ShortcutsTab", () => $c4013aa14ae2a321$export$9bfb5d07e0d9a9ad);

var $glvW5 = parcelRequire("glvW5");

var $6Bdkk = parcelRequire("6Bdkk");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1I7E8 = parcelRequire("1I7E8");

var $fcZox = parcelRequire("fcZox");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $haoad = parcelRequire("haoad");




var $3F9p6 = parcelRequire("3F9p6");

var $k1ALc = parcelRequire("k1ALc");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koeKL = parcelRequire("koeKL");

var $47gW9 = parcelRequire("47gW9");

var $byTKd = parcelRequire("byTKd");

var $1WfM5 = parcelRequire("1WfM5");

var $7UhxN = parcelRequire("7UhxN");

var $j4hty = parcelRequire("j4hty");

var $hScKx = parcelRequire("hScKx");
const $c4013aa14ae2a321$export$9bfb5d07e0d9a9ad = ({ tabFragment: tabFragment, containerFragment: containerFragment, beforeItemId: beforeItemId, afterItemId: afterItemId, position: position, isRenaming: isRenaming, onRenamingChange: onRenamingChange })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const projectIdOrKey = (0, $j4hty.useProjectIdOrKey)() ?? '';
    const [isDropdownMenuOpen, setIsDropdownMenuOpen] = (0, $5uXOq.useState)(false);
    const closePopup = (0, $5uXOq.useCallback)(()=>setIsDropdownMenuOpen(false), []);
    const itemRef = (0, $5uXOq.useRef)(null);
    const { data: shortcutsData, loading: loading } = (0, $7UhxN.useShortcutsData)();
    const { isOverflowing: isOverflowing } = (0, $1WfM5.useTabContext)();
    const tabData = (0, $8Uumt.useFragment)((0, $6Bdkk.default), tabFragment);
    const containerData = (0, $8Uumt.useFragment)((0, $glvW5.default), containerFragment);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $hScKx.shortcutMenuContentEntryPoint), (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey
        }), [
        cloudId,
        projectIdOrKey
    ]));
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isDropdownMenuOpen);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            canEdit: containerData.canEdit ?? false,
            onClosePopup: closePopup,
            itemRef: itemRef
        }), [
        containerData.canEdit,
        closePopup
    ]);
    const triggerAnalytics = (0, $byTKd.useNavigationItemAnalytics)((0, $5uXOq.useMemo)(()=>({
            itemId: undefined,
            itemType: 'shortcuts',
            navState: (0, $1520d876660a71bd$export$2bd315ece9f68967),
            stage: (0, $3F9p6.getNav4Rollout)().stage,
            navigationLayer: (0, $ce9c0831aed9ffb3$export$33d8c916a600c5e9),
            navigationContainer: (0, $68cb678dc917978e$export$f1c9dd0f5207dd5e),
            isInMore: false
        }), []));
    const trigger = ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $haoad.TabWithMenu), {
            tabFragment: tabData,
            containerFragment: containerData,
            type: "dropdown-trigger",
            isOpen: isDropdownMenuOpen,
            isRenaming: isRenaming,
            onRenamingChange: onRenamingChange,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fcZox))), {
                label: "",
                LEGACY_size: "small"
            }),
            onClick: ()=>{
                setIsDropdownMenuOpen((isOpen)=>!isOpen);
                triggerAnalytics();
            },
            position: position,
            ref: (element)=>{
                itemRef.current = element;
                triggerRef(element);
                typeof ref === 'function' && ref(element);
            },
            beforeItemId: beforeItemId,
            afterItemId: afterItemId,
            testId: "horizontal-nav-shortcuts-tab.dropdown-menu-trigger",
            ...triggerProps
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        trigger: trigger,
        placement: isOverflowing ? 'left' : 'bottom-end',
        shouldFlip: false,
        isOpen: isDropdownMenuOpen,
        onClose: closePopup,
        testId: "horizontal-nav-shortcuts-tab.dropdown-menu",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1ALc.ShortcutsContainer), {
                data: shortcutsData,
                loading: loading,
                isGlobal: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "shortcut.shortcuts-menu-content",
                packageName: "jiraHorizontalNavShortcutsTab",
                runtimeProps: runtimeProps,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $c4013aa14ae2a321$var$fallbackStyles
                })
            })),
        shouldRenderToParent: (0, $4R6GH.fg)('should-render-to-parent-should-be-true-navigation')
    });
};
const $c4013aa14ae2a321$var$fallbackStyles = (0, $8CUq3.xcss)({
    width: '360px',
    height: '200px'
});

});
parcelRegister("glvW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4be77ece9c127918$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7604ac780c8d96764d7838fc785b06aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4be77ece9c127918$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ShortcutsTab_container",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_container"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "canEdit"
                    },
                    "action": "THROW",
                    "path": "canEdit"
                }
            ],
            "type": "JiraContainerNavigation"
        }
    ],
    "type": "JiraContainerNavigationResult",
    "abstractKey": "__isJiraContainerNavigationResult"
};
$4be77ece9c127918$var$node.hash = "68870b0a4c832d2519c1a0a32742229a";
var $4be77ece9c127918$export$2e2bcd8739ae039 = $4be77ece9c127918$var$node;

});

parcelRegister("6Bdkk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b7944c4825be786$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7d1cf693bab9584542567abe8891c3e0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1b7944c4825be786$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ShortcutsTab_tab",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "TabWithMenu_tab"
        }
    ],
    "type": "JiraNavigationItem",
    "abstractKey": "__isJiraNavigationItem"
};
$1b7944c4825be786$var$node.hash = "44ec907f13fc9eea05e67f5b8c1abeae";
var $1b7944c4825be786$export$2e2bcd8739ae039 = $1b7944c4825be786$var$node;

});

parcelRegister("fcZox", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bb119a22bda01c1dc796d8c652f466ee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b12799b511c38ec3$var$_react = $b12799b511c38ec3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b12799b511c38ec3$var$_link = $b12799b511c38ec3$var$_interopRequireDefault((parcelRequire("1f9bV")));

var $b12799b511c38ec3$var$_link2 = $b12799b511c38ec3$var$_interopRequireDefault((parcelRequire("7WxSP")));
function $b12799b511c38ec3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "EditorLinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b12799b511c38ec3$var$LinkIcon = (props)=>/*#__PURE__*/ $b12799b511c38ec3$var$_react.default.createElement($b12799b511c38ec3$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $b12799b511c38ec3$var$_link2.default
    }, props));
$b12799b511c38ec3$var$LinkIcon.Name = 'LinkIconMigration';
var $b12799b511c38ec3$var$_default = module.exports.default = $b12799b511c38ec3$var$LinkIcon;

});
parcelRegister("1f9bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e7e525cdad15340$var$_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0e7e525cdad15340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7e525cdad15340$var$LinkIcon = (props)=>/*#__PURE__*/ $0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;

});

parcelRegister("7WxSP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c883bb6fff27f31$var$_react = $5c883bb6fff27f31$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $5c883bb6fff27f31$var$_link = $5c883bb6fff27f31$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $5c883bb6fff27f31$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5c883bb6fff27f31$var$EditorLinkIcon = (props)=>/*#__PURE__*/ $5c883bb6fff27f31$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
    }, props, {
        newIcon: $5c883bb6fff27f31$var$_link.default
    }));
$5c883bb6fff27f31$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
var $5c883bb6fff27f31$var$_default = module.exports.default = $5c883bb6fff27f31$var$EditorLinkIcon;

});


parcelRegister("hScKx", function(module, exports) {

$parcel$export(module.exports, "shortcutMenuContentEntryPoint", () => $9f89d7a7810d5cd9$export$3b6d8ed8ad10a2e0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $hB38K = parcelRequire("hB38K");

const $9f89d7a7810d5cd9$export$3b6d8ed8ad10a2e0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("aMAQN")), {
        moduleId: "cf565f5d",
        moduleName: "ShortcutsPopupContent",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectIdOrKey: projectIdOrKey })=>({
            queries: {
                mainQuery: {
                    parameters: (0, $hB38K.default),
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("hB38K", function(module, exports) {

$parcel$export(module.exports, "default", () => $2adf569e9edb344c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c0a91e745996f53732022a7307f6d7d>>
 * @relayHash a6218fab775f20b2d64f2488618a1ee0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bbd38f006fb6a30be026af75e9185b1301cc9753e91e5f4bd37871d8143f0bc6
const $2adf569e9edb344c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v4 = {
        "kind": "ScalarField",
        "name": "projectId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ShortcutsPopupContentQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "jira_projectByIdOrKey",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v2 /*: any*/ ,
                                "action": "THROW",
                                "path": "jira_projectByIdOrKey.key"
                            },
                            {
                                "kind": "RequiredField",
                                "field": v3 /*: any*/ ,
                                "action": "THROW",
                                "path": "jira_projectByIdOrKey.projectType"
                            },
                            {
                                "kind": "RequiredField",
                                "field": v4 /*: any*/ ,
                                "action": "THROW",
                                "path": "jira_projectByIdOrKey.projectId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira_projectByIdOrKey"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ShortcutsPopupContentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bbd38f006fb6a30be026af75e9185b1301cc9753e91e5f4bd37871d8143f0bc6",
            "metadata": {},
            "name": "ShortcutsPopupContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2adf569e9edb344c$var$node.hash = "6fa8881cba653e7f2ddc0665b57f7b00";
var $2adf569e9edb344c$export$2e2bcd8739ae039 = $2adf569e9edb344c$var$node;

});

parcelRegister("aMAQN", function(module, exports) {

let $7d9af8d2150e36da$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7d9af8d2150e36da$var$load("ffQaD"),
    $7d9af8d2150e36da$var$load("kvRbA"),
    $7d9af8d2150e36da$var$load("7mIf9"),
    $7d9af8d2150e36da$var$load("jXweD"),
    $7d9af8d2150e36da$var$load("jT4iz")
]).then(()=>parcelRequire('bA4B1'));

});





parcelRegister("2DNQF", function(module, exports) {

$parcel$export(module.exports, "getFlagDetails", () => $5738a7896cb026e3$export$e0141c03826f0c2c);

var $8piKN = parcelRequire("8piKN");
const $5738a7896cb026e3$var$DEFAULT_ERROR_FLAG = {
    type: 'error',
    title: (0, $8piKN.default).defaultErrorTitle,
    description: (0, $8piKN.default).defaultErrorMessage,
    messageId: 'horizontal-nav-common.common.get-flag-details.default-error-flag.error.error.default-error-flag',
    messageType: 'transactional'
};
const $5738a7896cb026e3$export$e0141c03826f0c2c = (statusCode)=>{
    switch(statusCode){
        case 401:
            return {
                type: 'error',
                title: (0, $8piKN.default).unauthenticatedUserErrorTitle,
                description: (0, $8piKN.default).unauthenticatedUserErrorMessage,
                messageId: 'horizontal-nav-common.common.get-flag-details.flag.error.error.401',
                messageType: 'transactional'
            };
        case 403:
            return {
                type: 'error',
                title: (0, $8piKN.default).unauthorizedUserErrorTitle,
                description: (0, $8piKN.default).unauthorizedUserErrorMessage,
                messageId: 'horizontal-nav-common.common.get-flag-details.flag.error.error.403',
                messageType: 'transactional'
            };
        case 404:
            return {
                type: 'error',
                title: (0, $8piKN.default).projectNotFoundErrorTitle,
                description: (0, $8piKN.default).projectNotFoundErrorMessage,
                messageId: 'horizontal-nav-common.common.get-flag-details.flag.error.error.404',
                messageType: 'transactional'
            };
        default:
            return $5738a7896cb026e3$var$DEFAULT_ERROR_FLAG;
    }
};

});
parcelRegister("8piKN", function(module, exports) {

$parcel$export(module.exports, "default", () => $61798863c2faac20$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $61798863c2faac20$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultViewRedirectFlagTitle: {
        "id": "business-horizontal-nav.project-navigation.default-view-redirect-flag-title",
        "defaultMessage": "We've taken you to the default view"
    },
    defaultViewRedirectFlagDescription: {
        "id": "business-horizontal-nav.project-navigation.default-view-redirect-flag-description",
        "defaultMessage": "The view you're trying to access has been removed."
    },
    defaultErrorMessage: {
        "id": "business-horizontal-nav.project-navigation.default-error-message",
        "defaultMessage": "Try refreshing or navigating to another page."
    },
    defaultErrorTitle: {
        "id": "business-horizontal-nav.project-navigation.default-error-title",
        "defaultMessage": "Something's gone wrong"
    },
    unauthenticatedUserErrorTitle: {
        "id": "business-horizontal-nav.project-navigation.unauthenticated-user-error-title",
        "defaultMessage": "You'll need to log in"
    },
    unauthenticatedUserErrorMessage: {
        "id": "business-horizontal-nav.project-navigation.unauthenticated-user-error-message",
        "defaultMessage": "You need to be logged in to manage the navigation. Please log in and try again."
    },
    unauthorizedUserErrorTitle: {
        "id": "business-horizontal-nav.project-navigation.unauthorized-user-error-title",
        "defaultMessage": "You don't have permission"
    },
    unauthorizedUserErrorMessage: {
        "id": "business-horizontal-nav.project-navigation.unauthorized-user-error-message",
        "defaultMessage": "You don't have permission to view this project."
    },
    projectNotFoundErrorTitle: {
        "id": "business-horizontal-nav.project-navigation.project-not-found-error-title",
        "defaultMessage": "Project not found"
    },
    projectNotFoundErrorMessage: {
        "id": "business-horizontal-nav.project-navigation.project-not-found-error-message",
        "defaultMessage": "The project might have been deleted or you don't have permission."
    }
});

});


parcelRegister("5Ha3o", function(module, exports) {

$parcel$export(module.exports, "PagesSpotlightEntrypointContainer", () => $312d90eeadb7f388$export$44a256458bf80a84);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");

var $7XluA = parcelRequire("7XluA");

var $4hhNo = parcelRequire("4hhNo");

var $aAt8M = parcelRequire("aAt8M");

var $kRVji = parcelRequire("kRVji");

const $312d90eeadb7f388$var$entryPointParams = {};
const $312d90eeadb7f388$export$44a256458bf80a84 = (props)=>{
    const isQuickstartDismissed = (0, $kRVji.useIsQuickstartDismissed)();
    const [property] = (0, $4hhNo.useUserProperty)((0, $0f958c4b320efe3b$export$fc1565c98db060f9));
    const { isEligible: isEligible } = (0, $kRVji.useIsPagesSpotlightNav4Eligible)();
    const loadEntryPoint = (0, $5uXOq.useMemo)(()=>{
        return isQuickstartDismissed && property !== 'true' && isEligible && (0, $4R6GH.fg)('grw-1860_pages_horizontal_nav4_spotlight');
    }, [
        isQuickstartDismissed,
        property,
        isEligible
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $aAt8M.default), $312d90eeadb7f388$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (loadEntryPoint) entryPointActions.load();
        return ()=>{
            if (loadEntryPoint) entryPointActions.unload();
        };
    }, [
        loadEntryPoint,
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira-pages-spotlight-nav4",
        packageName: "@atlassian/jira-pages-spotlight-nav4",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("4hhNo", function(module, exports) {

$parcel$export(module.exports, "useUserProperty", () => $c992c6109f1d5118$export$fbe59e5a949d942d);

var $5uXOq = parcelRequire("5uXOq");

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");

var $gPVzL = parcelRequire("gPVzL");

var $cYlk7 = parcelRequire("cYlk7");
const $c992c6109f1d5118$export$fbe59e5a949d942d = (property, userId)=>{
    const { data: currentUser } = (0, $cYlk7.useCurrentUser)();
    const user = userId || currentUser.user.accountId;
    const storageKey = `user-property-${user}-${property}`;
    const [value, setValue] = (0, $gPVzL.usePersistentlyCachedRequest)(storageKey, undefined, (0, $5uXOq.useCallback)(()=>user ? (0, $89SaW.getUserProperty)(user, property).catch((error)=>{
            // user property is not found
            if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return undefined;
            throw error;
        }) : undefined, [
        user,
        property
    ]));
    const setProperty = (0, $5uXOq.useCallback)((newValue)=>{
        if (!user) return Promise.reject(new Error('user is unknown'));
        setValue(newValue);
        const operation = (0, $89SaW.setUserProperties)(user, property, newValue);
        operation.catch(()=>{
            // do not report error, that's consumer's responsibility
            // restore old value
            setValue(value);
        });
        return operation;
    }, [
        setValue,
        user,
        property,
        value
    ]);
    return (0, $5uXOq.useMemo)(()=>[
            value,
            setProperty
        ], [
        value,
        setProperty
    ]);
};

});
parcelRegister("gPVzL", function(module, exports) {

$parcel$export(module.exports, "usePersistentlyCachedRequest", () => $b08da57c65f63cec$export$984344f48cd049a);

var $5uXOq = parcelRequire("5uXOq");

var $2bus2 = parcelRequire("2bus2");
const $b08da57c65f63cec$export$984344f48cd049a = (storageKey, defaultValue, reader)=>{
    const cachedValue = (0, $5uXOq.useMemo)(()=>(0, $2bus2.getSessionStorageData)(storageKey), [
        storageKey
    ]);
    const [{ value: value, storageKey: storedKey }, setStoredValue] = (0, $5uXOq.useState)(()=>({
            storageKey: storageKey,
            value: cachedValue
        }));
    if (storedKey !== storageKey) // yes, you can do it
    setStoredValue({
        storageKey: storageKey,
        value: cachedValue
    });
    const setNewValue = (0, $5uXOq.useCallback)((newValue)=>{
        (0, $2bus2.setSessionStorageData)(storageKey, newValue);
        (0, $2bus2.updateBus).emit(storageKey, newValue);
    }, [
        storageKey
    ]);
    // note - updating value is done via effect and affects all consumers
    (0, $5uXOq.useEffect)(()=>(0, $2bus2.updateBus).subscribe(storageKey, (newValue)=>setStoredValue({
                storageKey: storageKey,
                value: newValue
            })), [
        storageKey
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!reader) return;
        if (cachedValue === undefined) (0, $2bus2.handleDataRequest)(storageKey, reader);
    }, [
        reader,
        storageKey,
        cachedValue
    ]);
    return (0, $5uXOq.useMemo)(()=>[
            value ?? defaultValue,
            setNewValue
        ], [
        value,
        defaultValue,
        setNewValue
    ]);
};

});
parcelRegister("2bus2", function(module, exports) {

$parcel$export(module.exports, "getSessionStorageData", () => $df6031856a4556b5$export$af84d82ff1eea56d);
$parcel$export(module.exports, "setSessionStorageData", () => $df6031856a4556b5$export$be8cb7c8f1a1db6b);
$parcel$export(module.exports, "updateBus", () => $df6031856a4556b5$export$6da4b0a5188cf0d7);
$parcel$export(module.exports, "handleDataRequest", () => $df6031856a4556b5$export$d09b7eeb5e60cdd9);

var $eNf8a = parcelRequire("eNf8a");

var $jcw0u = parcelRequire("jcw0u");

var $fFtW2 = parcelRequire("fFtW2");
const $df6031856a4556b5$var$ONE_DAY = 86400000; // 1 day
const $df6031856a4556b5$var$storage = (0, $eNf8a.createSessionExpirableStorageProvider)('jira-platform-persistent-cache');
const $df6031856a4556b5$export$af84d82ff1eea56d = (key)=>{
    const data = $df6031856a4556b5$var$storage.get(key);
    if (data) try {
        return JSON.parse(data);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getSessionStorageData', e);
        return undefined;
    }
    return undefined;
};
const $df6031856a4556b5$export$be8cb7c8f1a1db6b = (key, value)=>{
    try {
        $df6031856a4556b5$var$storage.set(key, JSON.stringify(value), Date.now() + $df6031856a4556b5$var$ONE_DAY);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('setSessionStorageData', e);
    }
};
const $df6031856a4556b5$export$6da4b0a5188cf0d7 = (0, $fFtW2.createEventBus)();
const $df6031856a4556b5$export$9a4e04a3b0938221 = {};
const $df6031856a4556b5$export$d09b7eeb5e60cdd9 = async (storageKey, // eslint-disable-next-line @typescript-eslint/no-explicit-any
request)=>{
    // If there's already a pending request for this storageKey, ignore this one
    if ($df6031856a4556b5$export$9a4e04a3b0938221[storageKey]) return $df6031856a4556b5$export$9a4e04a3b0938221[storageKey];
    // Otherwise, add this request to the list of pending requests
    try {
        const pending = request();
        $df6031856a4556b5$export$9a4e04a3b0938221[storageKey] = pending;
        // Wait for the request to complete
        const newValue = await pending;
        // update store and inform consumers
        $df6031856a4556b5$export$be8cb7c8f1a1db6b(storageKey, newValue);
        $df6031856a4556b5$export$6da4b0a5188cf0d7.emit(storageKey, newValue);
    } catch (error) {
        if (error instanceof Error) (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'handleDataRequest',
                packageName: 'jiraPlatformPersistentCache',
                teamName: 'crocs'
            }
        });
        else throw error;
    } finally{
        // Remove this request from the list of pending requests
        delete $df6031856a4556b5$export$9a4e04a3b0938221[storageKey];
    }
};

});
parcelRegister("fFtW2", function(module, exports) {

$parcel$export(module.exports, "createEventBus", () => $343015ef9de26d8a$export$f492882bd33cbb73);
const $343015ef9de26d8a$export$f492882bd33cbb73 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const listeners = new Map();
    const subscribe = (event, listener)=>{
        listeners.set(listener, event);
        return ()=>{
            listeners.delete(listener);
        };
    };
    const emit = (event, payload)=>{
        listeners.forEach((eventFilter, listener)=>{
            if (eventFilter === event) listener(payload);
        });
    };
    return {
        subscribe: subscribe,
        emit: emit,
        get length () {
            return listeners.size;
        }
    };
};

});



parcelRegister("cYlk7", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $cdd4ab536fcf9459$export$3901076af3749fa9);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");

var $leRCk = parcelRequire("leRCk");
const $cdd4ab536fcf9459$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $lzeFL.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $cdd4ab536fcf9459$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $cdd4ab536fcf9459$var$useCurrentUserBasic();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $leRCk.useUserSubscriber)();
    (0, $5uXOq.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $cdd4ab536fcf9459$export$3901076af3749fa9 = ()=>(0, $9OXo1.useTenantContext)().isAnonymous ? $cdd4ab536fcf9459$var$useCurrentUserBasic() : $cdd4ab536fcf9459$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $cdd4ab536fcf9459$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $cdd4ab536fcf9459$export$3901076af3749fa9();
    return children(result);
};

});
parcelRegister("leRCk", function(module, exports) {

$parcel$export(module.exports, "UserContainer", () => $46a581f1f6efe569$export$7ff085589970ee0a);
$parcel$export(module.exports, "useUserSubscriber", () => $46a581f1f6efe569$export$4e61bbf568682a96);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $314C6 = parcelRequire("314C6");
const $46a581f1f6efe569$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $46a581f1f6efe569$var$Store = (0, $iXqE5.createStore)({
    name: 'user',
    initialState: $46a581f1f6efe569$var$initialState,
    actions: $314C6
});
const $46a581f1f6efe569$export$7ff085589970ee0a = (0, $gg7kZ.createContainer)($46a581f1f6efe569$var$Store);
const $46a581f1f6efe569$export$4e61bbf568682a96 = (0, $3sQ5x.createHook)($46a581f1f6efe569$var$Store);

});
parcelRegister("314C6", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $acdfee9161693eca$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iF3m5 = parcelRequire("iF3m5");
const $acdfee9161693eca$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!params || currentState.loading || currentState.data && !forceRefetch) return;
        setState({
            loading: true
        });
        try {
            const data = await (0, $iF3m5.fetchData)({
                params: params,
                header: header
            });
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err,
                loading: false
            });
        }
    };

});
parcelRegister("iF3m5", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $d22d4c6d892f61f1$export$8134c072fddab6a5);

var $ebyGx = parcelRequire("ebyGx");

var $8QpSo = parcelRequire("8QpSo");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $e5wyW = parcelRequire("e5wyW");

var $6Z846 = parcelRequire("6Z846");
const $d22d4c6d892f61f1$export$5e5a6664039ed1cc = ({ params: params, header: header })=>{
    const queryParams = {
        ...params,
        expand: Object.keys(params.expand || {}).filter((key)=>params.expand && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            params.expand[key])
    };
    const query = (0, $ebyGx.stringify)(queryParams, {
        arrayFormat: 'none'
    });
    const queryString = query ? `?${query}` : '';
    const requestUrl = `/rest/api/2/user${queryString}`;
    // @ts-expect-error - TS2345 - Argument of type '{ headers: HeaderParamForceAccountId; } | {}' is not assignable to parameter of type 'RequestInit | undefined'.
    return (0, $eusud.performGetRequest)(requestUrl, header ? {
        headers: header
    } : {});
};
const $d22d4c6d892f61f1$var$fetchDataNew = (0, $8QpSo.default)($d22d4c6d892f61f1$export$5e5a6664039ed1cc, (newArgs, lastArgs)=>// compare params and headers to see if it should be memoised.
    (0, $6Z846.isShallowEqual)(newArgs[0].params, lastArgs[0].params) && (0, $6Z846.isShallowEqual)(newArgs[0].header, lastArgs[0].header));
const $d22d4c6d892f61f1$export$8134c072fddab6a5 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('user-iv-llc-unnecessary-api'), $d22d4c6d892f61f1$var$fetchDataNew, $d22d4c6d892f61f1$export$5e5a6664039ed1cc);

});





parcelRegister("aAt8M", function(module, exports) {

$parcel$export(module.exports, "default", () => $bab084ecca2ec721$export$2e2bcd8739ae039);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $bab084ecca2ec721$export$2e2bcd8739ae039 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("3LaQr")), {
        moduleId: "a8a2566c",
        moduleName: "PagesSpotlightMaybe",
        priority: "interaction"
    }),
    getPreloadProps () {
        return {};
    }
});

});
parcelRegister("3LaQr", function(module, exports) {

let $2bce2c76c8b44481$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2bce2c76c8b44481$var$load("fOkwb").then(()=>parcelRequire('8liue'));

});


parcelRegister("kRVji", function(module, exports) {

$parcel$export(module.exports, "useIsPagesSpotlightNav4Eligible", () => $65b9b7ac65c1e5b2$export$ad6ee0f6723dfc62);
$parcel$export(module.exports, "useIsQuickstartDismissed", () => $65b9b7ac65c1e5b2$export$b6803998caa91570);

var $5uXOq = parcelRequire("5uXOq");

var $5GDqD = parcelRequire("5GDqD");

var $cE2Qr = parcelRequire("cE2Qr");

var $8Bc5A = parcelRequire("8Bc5A");
const $65b9b7ac65c1e5b2$export$bc400196bb982723 = (0, $5GDqD.createTraitsSelector)('SITE_USER', ({ hasTrait: hasTrait })=>{
    return hasTrait('segment_day0_auto-provisioned_confluence_not_active_siteuser');
});
const $65b9b7ac65c1e5b2$export$271dc25f1c17f051 = (0, $5GDqD.createTraitsSelector)('SITE_USER', ({ hasTrait: hasTrait })=>{
    return hasTrait('segment_4c7a215c-2ec8-441a-b7c1-441e78eaaa72');
});
const $65b9b7ac65c1e5b2$export$7b76ceefe21f02d = (0, $5GDqD.createTraitsSelector)('SITE_USER', ({ hasTrait: hasTrait })=>{
    return hasTrait('exposed_INAPP-1399') || hasTrait('exposed_INAPP-2270');
});
function $65b9b7ac65c1e5b2$export$ad6ee0f6723dfc62() {
    const [isD0AP] = $65b9b7ac65c1e5b2$export$bc400196bb982723();
    const [isMLAP] = $65b9b7ac65c1e5b2$export$271dc25f1c17f051();
    const [hasSeenNav3] = $65b9b7ac65c1e5b2$export$7b76ceefe21f02d();
    let audience = null;
    if (isD0AP) audience = 'D0';
    else if (isMLAP) audience = 'ML';
    return (isD0AP || isMLAP) && !hasSeenNav3 ? {
        isEligible: true,
        audience: audience
    } : {
        isEligible: false,
        audience: audience
    };
}
const $65b9b7ac65c1e5b2$var$statusDismissedSet = new Set([
    (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED,
    (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED
]);
function $65b9b7ac65c1e5b2$export$b6803998caa91570() {
    const [quickstartStatus] = (0, $cE2Qr.useQuickstartUiStatus)();
    const [hasQuickstartBeenOpened, setHasQuickstartBeenOpened] = (0, $5uXOq.useState)(false);
    const isOpen = quickstartStatus === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
    if (!hasQuickstartBeenOpened && isOpen) setHasQuickstartBeenOpened(true);
    return !hasQuickstartBeenOpened && $65b9b7ac65c1e5b2$var$statusDismissedSet.has(quickstartStatus);
}

});
parcelRegister("5GDqD", function(module, exports) {

$parcel$export(module.exports, "useTraits", () => $5e4cf08f88a8a143$export$243330301a7ccf01);
$parcel$export(module.exports, "useTraitsActions", () => $5e4cf08f88a8a143$export$87f1d888def9d5a0);
$parcel$export(module.exports, "createTraitsSelector", () => $5e4cf08f88a8a143$export$fb8309e220d0dd3b);
$parcel$export(module.exports, "composeTraitsSelectors", () => $5e4cf08f88a8a143$export$e653f602b87eec56);

var $eusud = parcelRequire("eusud");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");

var $jX0pr = parcelRequire("jX0pr");

var $8ilPk = parcelRequire("8ilPk");

var $13UaH = parcelRequire("13UaH");

var $2LwjF = parcelRequire("2LwjF");
const $5e4cf08f88a8a143$var$addTrait = (traitType, trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        const state = currentUserTraits[traitType];
        if (!state.attributes) {
            setState({
                ...currentUserTraits,
                [traitType]: {
                    attributes: [
                        trait
                    ]
                }
            });
            return;
        }
        if (state.attributes.some((existingTrait)=>existingTrait.name === trait.name)) setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: state.attributes.map((existingTrait)=>existingTrait.name === trait.name ? trait : existingTrait)
            }
        });
        else setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: [
                    ...state.attributes,
                    trait
                ]
            }
        });
    };
const $5e4cf08f88a8a143$var$fetchTraitsOld = (traitTypes, { cloudId: cloudId, accountId: accountId, orgId: orgId })=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await Promise.all(traitTypes.map(async (traitType)=>{
            if (state[traitType].loaded || state[traitType].loading) return;
            setState({
                ...state,
                [traitType]: {
                    ...state[traitType],
                    loading: true
                }
            });
            const traitEndpointEndingFragment = (0, $2LwjF.buildTraitEndpointEndingFragment)({
                traitType: traitType,
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId
            });
            if (!traitEndpointEndingFragment) return;
            const url = (0, $13UaH.TRAIT_ENDPOINT_STARTING_FRAGMENT) + traitEndpointEndingFragment;
            try {
                const fetchedTraits = await (0, $eusud.performGetRequest)(url);
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: fetchedTraits?.attributes?.length ? fetchedTraits.attributes : null,
                        loading: false,
                        loaded: true
                    }
                });
            } catch  {
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: null,
                        loading: false,
                        loaded: true
                    }
                });
            }
        }));
    };
const $5e4cf08f88a8a143$var$fetchTraitsNew = (traitTypes, { cloudId: cloudId, accountId: accountId, orgId: orgId })=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await Promise.all(traitTypes.map(async (traitType)=>{
            if (state[traitType].loaded || state[traitType].loading) return;
            setState({
                ...state,
                [traitType]: {
                    ...state[traitType],
                    loading: true
                }
            });
            const traitEndpointEndingFragment = (0, $2LwjF.buildTraitEndpointEndingFragment)({
                traitType: traitType,
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId
            });
            if (!traitEndpointEndingFragment) return;
            const url = (0, $13UaH.TRAIT_ENDPOINT_STARTING_FRAGMENT) + traitEndpointEndingFragment;
            try {
                let fetchedTraits = null;
                // TODO: in the future, we will need to also memoise site user trait and user trait here
                // Thus, we need to add FG at each conditions to fetch if we should use the memoised fetcher
                if (traitType === (0, $13UaH.SITE) && cloudId && (0, $4R6GH.fg)('site-trait-iv-llc-unnecessary-api')) fetchedTraits = {
                    attributes: await (0, $jX0pr.memoizedFetchSitePersonalization)({
                        cloudId: cloudId
                    })
                };
                else if (traitType === (0, $13UaH.SITE_USER) && cloudId && accountId && (0, $4R6GH.fg)('site-user-trait-iv-llc-unnecessary-api')) fetchedTraits = {
                    attributes: await (0, $8ilPk.memoizedFetchSiteUserPersonalization)({
                        cloudId: cloudId,
                        userId: accountId
                    })
                };
                else fetchedTraits = await (0, $eusud.performGetRequest)(url);
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: fetchedTraits?.attributes?.length ? fetchedTraits.attributes : null,
                        loading: false,
                        loaded: true
                    }
                });
            } catch  {
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: null,
                        loading: false,
                        loaded: true
                    }
                });
            }
        }));
    };
const $5e4cf08f88a8a143$var$fetchTraits = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('site-trait-iv-llc-unnecessary-api') || (0, $4R6GH.fg)('site-user-trait-iv-llc-unnecessary-api'), $5e4cf08f88a8a143$var$fetchTraitsNew, $5e4cf08f88a8a143$var$fetchTraitsOld);
const $5e4cf08f88a8a143$var$actions = {
    fetchTraits: $5e4cf08f88a8a143$var$fetchTraits,
    addTrait: $5e4cf08f88a8a143$var$addTrait
};
const $5e4cf08f88a8a143$var$initialState = {
    ATLASSIAN_ACCOUNT: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE_USER: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG_USER: {
        attributes: null,
        loading: false,
        loaded: false
    }
};
const $5e4cf08f88a8a143$export$5b11e13f463f4eb = (0, $iXqE5.createStore)({
    initialState: $5e4cf08f88a8a143$var$initialState,
    actions: $5e4cf08f88a8a143$var$actions,
    name: 'TraitsStore'
});
const $5e4cf08f88a8a143$export$243330301a7ccf01 = (0, $3sQ5x.createHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb);
const $5e4cf08f88a8a143$export$87f1d888def9d5a0 = (0, $3sQ5x.createActionsHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb);
const $5e4cf08f88a8a143$var$defaultSelector = (traitsType, selector)=>(0, $6dDSs.createSelector)((state)=>({
            loading: !!state[traitsType]?.loading,
            loaded: state[traitsType]?.loaded || false,
            attributes: state[traitsType]?.attributes,
            userCreatedAfter: (date)=>state[traitsType].loaded ? (0, $2LwjF.userCreatedAfter)(state, date) : false,
            userCreatedBefore: (date)=>state[traitsType].loaded ? (0, $2LwjF.userCreatedBefore)(state, date) : false,
            getTraitByName: (name)=>state[traitsType].loaded ? (0, $2LwjF.getTraitByName)(state, name) : null,
            hasTrait: (name)=>state[traitsType].loaded ? (0, $2LwjF.hasTrait)(state, name) : false,
            getTraitValue: (name)=>state[traitsType].loaded ? (0, $2LwjF.getTraitValue)(state, name) : null
        }), selector);
const $5e4cf08f88a8a143$export$fb8309e220d0dd3b = (traitsType, selector)=>(0, $3sQ5x.createHook)($5e4cf08f88a8a143$export$5b11e13f463f4eb, {
        selector: $5e4cf08f88a8a143$var$defaultSelector(traitsType, selector)
    });
const $5e4cf08f88a8a143$export$e653f602b87eec56 = (traitTypes, hooks)=>({
        traitTypes: traitTypes,
        hooks: hooks
    });

});
parcelRegister("13UaH", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_ACCOUNT", () => $c8223610b88d815b$export$eac8289d83d13c9e);
$parcel$export(module.exports, "SITE", () => $c8223610b88d815b$export$1f4740cb59ea887e);
$parcel$export(module.exports, "SITE_USER", () => $c8223610b88d815b$export$2b629adc0b711448);
$parcel$export(module.exports, "ORG", () => $c8223610b88d815b$export$c7bc89c720838974);
$parcel$export(module.exports, "ORG_USER", () => $c8223610b88d815b$export$872e93425a929c06);
$parcel$export(module.exports, "TRAIT_ENDPOINT_STARTING_FRAGMENT", () => $c8223610b88d815b$export$ff5c5bd50c21e9a4);
const $c8223610b88d815b$export$eac8289d83d13c9e = 'ATLASSIAN_ACCOUNT';
const $c8223610b88d815b$export$1f4740cb59ea887e = 'SITE';
const $c8223610b88d815b$export$2b629adc0b711448 = 'SITE_USER';
const $c8223610b88d815b$export$c7bc89c720838974 = 'ORG';
const $c8223610b88d815b$export$872e93425a929c06 = 'ORG_USER';
const $c8223610b88d815b$export$ff5c5bd50c21e9a4 = '/gateway/api/tap-delivery/api/v3/personalization/';
const $c8223610b88d815b$export$ab3e7784d2a104d4 = [
    $c8223610b88d815b$export$eac8289d83d13c9e,
    $c8223610b88d815b$export$1f4740cb59ea887e,
    $c8223610b88d815b$export$2b629adc0b711448,
    $c8223610b88d815b$export$c7bc89c720838974,
    $c8223610b88d815b$export$872e93425a929c06
];

});

parcelRegister("2LwjF", function(module, exports) {

$parcel$export(module.exports, "buildTraitEndpointEndingFragment", () => $a4882989c0079311$export$118c30eb4b4c51e8);
$parcel$export(module.exports, "getTraitByName", () => $a4882989c0079311$export$e5b0d140cf11f46a);
$parcel$export(module.exports, "hasTrait", () => $a4882989c0079311$export$252a469687875173);
$parcel$export(module.exports, "getTraitValue", () => $a4882989c0079311$export$43a43c2e6ec7b13);
$parcel$export(module.exports, "userCreatedAfter", () => $a4882989c0079311$export$8388eb33623a9cff);
$parcel$export(module.exports, "userCreatedBefore", () => $a4882989c0079311$export$da1e8ce191f01409);

var $13UaH = parcelRequire("13UaH");
const $a4882989c0079311$export$e320a062b20fddc3 = (traitsData)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(traitsData).reduce((acc, [, val])=>{
        if (val?.attributes) acc.push(...val.attributes.map((singleTrait)=>singleTrait));
        return acc;
    }, []);
const $a4882989c0079311$export$118c30eb4b4c51e8 = ({ traitType: traitType, accountId: accountId, cloudId: cloudId, orgId: orgId })=>{
    switch(traitType){
        case 0, $13UaH.ATLASSIAN_ACCOUNT:
            return `user/${accountId}`;
        case 0, $13UaH.SITE:
            return `site/${cloudId}`;
        case 0, $13UaH.SITE_USER:
            return `site/${cloudId}/user/${accountId}`;
        case 0, $13UaH.ORG:
            return `org/${orgId}`;
        case 0, $13UaH.ORG_USER:
            return `org/${orgId}/user/${accountId}`;
        default:
            return null;
    }
};
function $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName);
}
function $a4882989c0079311$export$252a469687875173(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName) !== undefined;
}
function $a4882989c0079311$export$43a43c2e6ec7b13(traitsData, traitName) {
    return $a4882989c0079311$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName)?.value ?? null;
}
const $a4882989c0079311$export$d2a3b2f9735b6874 = (traitsData, traitNames)=>$a4882989c0079311$export$e320a062b20fddc3(traitsData)?.filter((trait)=>traitNames.includes(trait.name));
const $a4882989c0079311$export$8388eb33623a9cff = (traitsData, date)=>{
    const accountCreationDate = $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) > date;
};
const $a4882989c0079311$export$da1e8ce191f01409 = (traitsData, date)=>{
    const accountCreationDate = $a4882989c0079311$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) < date;
};

});


parcelRegister("cE2Qr", function(module, exports) {

$parcel$export(module.exports, "useJswOnboarding", () => $796be817ff5bbbfa$export$7d91c0af4772787a);
$parcel$export(module.exports, "useOpenTask", () => $796be817ff5bbbfa$export$594f006fa6a1b2e5);
$parcel$export(module.exports, "useNudgeStep", () => $796be817ff5bbbfa$export$c5e63e44ad178ae8);
$parcel$export(module.exports, "useQuickstartActions", () => $796be817ff5bbbfa$export$2c3cd14fff9d6e43);
$parcel$export(module.exports, "useShouldShowNudge", () => $796be817ff5bbbfa$export$b0db7e46e369e1d9);
$parcel$export(module.exports, "useInviteToProject", () => $796be817ff5bbbfa$export$71de79653346a1ea);
$parcel$export(module.exports, "useShowVideoCards", () => $796be817ff5bbbfa$export$61185a9266f1f57a);
$parcel$export(module.exports, "useProjectState", () => $796be817ff5bbbfa$export$ef4747ba36826d6a);
$parcel$export(module.exports, "useQuickstartUiStatus", () => $796be817ff5bbbfa$export$522993b46d9f8266);
$parcel$export(module.exports, "useIsLoaded", () => $796be817ff5bbbfa$export$aa4ba29241532382);
$parcel$export(module.exports, "useIsFocusedOn", () => $796be817ff5bbbfa$export$ed5c755b733bf2b1);
$parcel$export(module.exports, "useIsDismissed", () => $796be817ff5bbbfa$export$35fe0366802512dd);
$parcel$export(module.exports, "useCompletedTaskList", () => $796be817ff5bbbfa$export$a41ee0d3b6938099);
$parcel$export(module.exports, "useAllTasksCompleted", () => $796be817ff5bbbfa$export$4ae7b465b076be9);
$parcel$export(module.exports, "useMountedNudges", () => $796be817ff5bbbfa$export$bf6e646c0476acad);
$parcel$export(module.exports, "useHasEverSeen", () => $796be817ff5bbbfa$export$6b706bff94798d11);
$parcel$export(module.exports, "useRoadmapState", () => $796be817ff5bbbfa$export$c98db656edc5b3e1);
$parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", () => $796be817ff5bbbfa$export$a823278ac9d1112b);
$parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", () => $796be817ff5bbbfa$export$cb9e0e8fe4df8490);
$parcel$export(module.exports, "useHasNudgeActive", () => $796be817ff5bbbfa$export$521909e3dc7ab811);
$parcel$export(module.exports, "useSelectedProjectTemplateKeyFromOnboarding", () => $796be817ff5bbbfa$export$f4a2be940259bf95);
$parcel$export(module.exports, "QUICKSTART_UI_STATUS", () => (parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS);

var $58GFP = parcelRequire("58GFP");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");

var $8Bc5A = parcelRequire("8Bc5A");

var $6RAg1 = parcelRequire("6RAg1");

var $ieqoN = parcelRequire("ieqoN");

var $cGE52 = parcelRequire("cGE52");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");

const $796be817ff5bbbfa$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'jsw-onboarding-quickstart',
    initialState: $cGE52.initialState,
    actions: $6RAg1.actions
});
const $796be817ff5bbbfa$export$1cbc60d8dd921852 = (0, $51nlc.createSubscriber)($796be817ff5bbbfa$export$390f32400eaf98c9);
const $796be817ff5bbbfa$export$7d91c0af4772787a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9);
const $796be817ff5bbbfa$export$638bfcfce1254bb8 = (0, $gg7kZ.createContainer)($796be817ff5bbbfa$export$390f32400eaf98c9, {});
const $796be817ff5bbbfa$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
    const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, $3B5jO.getQuickstartTypeSelector)(state)] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
    itemNames.includes(state.openTask);
    return commonConditionsToShowNudge && state.hasNudgeActive;
};
const $796be817ff5bbbfa$export$ea14030920a5d8e6 = (state)=>state.openTask;
const $796be817ff5bbbfa$export$594f006fa6a1b2e5 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$ea14030920a5d8e6
});
const $796be817ff5bbbfa$export$a943afa434e9487a = (state)=>state.nudgeStep;
const $796be817ff5bbbfa$export$c5e63e44ad178ae8 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$a943afa434e9487a
});
const $796be817ff5bbbfa$export$2c3cd14fff9d6e43 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: null
});
const $796be817ff5bbbfa$export$b0db7e46e369e1d9 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: $796be817ff5bbbfa$export$9d731f44f82af09f
});
const $796be817ff5bbbfa$export$71de79653346a1ea = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
});
const $796be817ff5bbbfa$export$61185a9266f1f57a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.projectState) return false;
        const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
        return Boolean(isNextGen && (userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN || userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN || isProjectAdmin));
    }
});
const $796be817ff5bbbfa$export$ef4747ba36826d6a = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.projectState
});
const $796be817ff5bbbfa$export$522993b46d9f8266 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        if (state.shouldRenderComponent === false) return (0, $4ji4w.getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED;
        return state.visibility[quickstartType];
    }
});
const $796be817ff5bbbfa$export$aa4ba29241532382 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.isQuickstartLoaded
});
const $796be817ff5bbbfa$export$ed5c755b733bf2b1 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.isFocusedOn
});
const $796be817ff5bbbfa$export$35fe0366802512dd = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        const visibility = state.visibility[(0, $3B5jO.getQuickstartTypeSelector)(state)];
        return visibility === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED;
    }
});
const $796be817ff5bbbfa$export$a41ee0d3b6938099 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.completedTaskList
});
const $796be817ff5bbbfa$export$4ae7b465b076be9 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>{
        if (!state.tasks) return null;
        return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
    }
});
const $796be817ff5bbbfa$export$bf6e646c0476acad = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.mountedNudges
});
const $796be817ff5bbbfa$export$6b706bff94798d11 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.hasEverSeenRoute
});
const $796be817ff5bbbfa$export$c98db656edc5b3e1 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>({
            roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
            roadmapIsListEmpty: state.roadmapIsListEmpty
        })
});
const $796be817ff5bbbfa$export$a823278ac9d1112b = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && state.selectedProjectTemplateKeyFromOnboarding === (0, $58GFP.SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN)
});
const $796be817ff5bbbfa$export$cb9e0e8fe4df8490 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>Boolean(state.isQuickstartLoaded && state.selectedProjectTemplateKeyFromOnboarding === (0, $58GFP.KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN && // edge case - if e.g. welcome modal failed to load, and user completed task by themself, then the welcome modal should be skipped on subsequent page loads.
        !state.completedTaskList.includes((0, $8Bc5A.KANBAN_ONBOARDING_TASK)))
});
const $796be817ff5bbbfa$export$521909e3dc7ab811 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.hasNudgeActive
});
const $796be817ff5bbbfa$export$f4a2be940259bf95 = (0, $3sQ5x.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
    selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
});

});
parcelRegister("58GFP", function(module, exports) {

$parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$f40a08fc76eb112d);
$parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$e3844688f2693533);
$parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$e3cec071fcb2fbd3);
$parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$21783d461e3ef6d);
$parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$6cd1c1b2ba0f6e2d);
$parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$57d877f2e01e0029);
$parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$6f4213a3addc3fdb);
$parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", () => $c364c398187f9175$export$7492b6cc3ef89883);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7d9a4e0ef5194fe1);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$477ca3550da12e43);
$parcel$export(module.exports, "BLANK_TEMPLATE_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7c0307155b744916);
$parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$b5ab111fb8825075);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$14139f0ec41d437e);
$parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$ebf7af45376deb8b);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$7b6945581ccdab4a);
$parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$310a9ac5c28d65f6);
$parcel$export(module.exports, "TASK_TRACKING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$136d17feb2f4285d);
$parcel$export(module.exports, "DOCUMENT_APPROVAL_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$e288f4758e94a8cc);
$parcel$export(module.exports, "PROCESS_CONTROL_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$4e9ac1417ba54bba);
$parcel$export(module.exports, "POLICY_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$560c9f6765bf9af4);
$parcel$export(module.exports, "SALES_PIPELINE_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$14d4c6dbbb62a127);
$parcel$export(module.exports, "PROCUREMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$1367ee12532c525f);
$parcel$export(module.exports, "WEB_DESIGN_PROCESS_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$278632cc7ed9a312);
$parcel$export(module.exports, "BUDGET_CREATION_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$594d0d4f5ecbf4c7);
$parcel$export(module.exports, "EMPLOYEE_ONBOARDING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$dda85c7a8278e495);
$parcel$export(module.exports, "RECRUITMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$b92c431651f9ee91);
$parcel$export(module.exports, "LEAD_TRACKING_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$d72d75d9d0e071fc);
$parcel$export(module.exports, "IP_INFRINGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$753322ed1c32ff89);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$4d29ee0c00eb5df4);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$6278b41164dbde6c);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$17a2f771efabf02f);
$parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_OPERATIONS_TEMPLATE_KEY", () => $c364c398187f9175$export$df7d1440e0a80c03);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$bd14946bcde77195);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", () => $c364c398187f9175$export$e8df553a3f519284);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", () => $c364c398187f9175$export$97fc32bd703bb4d1);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", () => $c364c398187f9175$export$8eecdf6acea9494);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", () => $c364c398187f9175$export$ff16be7794ed4222);
$parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$9917830b560a2f4);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$b0928b02ffab3875);
$parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", () => $c364c398187f9175$export$fd75f6abc7861439);
$parcel$export(module.exports, "HR_SERVICE_PROJECT_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$2bc7db2da3df8313);
$parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", () => $c364c398187f9175$export$87a8fff98b5bc81);
$parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", () => $c364c398187f9175$export$7c567eb725bd36f);
$parcel$export(module.exports, "getIsJsmBlankProjectTemplate", () => $c364c398187f9175$export$73fd025e86012868);
$parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", () => $c364c398187f9175$export$a062badd78c9993);
// Project template type keys are used to create projects.
// TODO: KURO-1818 consolidate keys from `project-template-keys` in this file.
// Software template keys
const $c364c398187f9175$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
const $c364c398187f9175$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
const $c364c398187f9175$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
const $c364c398187f9175$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
const $c364c398187f9175$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
const $c364c398187f9175$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
const $c364c398187f9175$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
const $c364c398187f9175$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
const $c364c398187f9175$export$7d9a4e0ef5194fe1 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
const $c364c398187f9175$export$477ca3550da12e43 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
const $c364c398187f9175$export$7c0307155b744916 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
const $c364c398187f9175$export$b5ab111fb8825075 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
const $c364c398187f9175$export$14139f0ec41d437e = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
const $c364c398187f9175$export$ebf7af45376deb8b = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
const $c364c398187f9175$export$7b6945581ccdab4a = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
const $c364c398187f9175$export$310a9ac5c28d65f6 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
const $c364c398187f9175$export$136d17feb2f4285d = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
const $c364c398187f9175$export$e288f4758e94a8cc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
const $c364c398187f9175$export$4e9ac1417ba54bba = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
const $c364c398187f9175$export$560c9f6765bf9af4 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
const $c364c398187f9175$export$14d4c6dbbb62a127 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
const $c364c398187f9175$export$1367ee12532c525f = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
const $c364c398187f9175$export$278632cc7ed9a312 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-web-design-process-team-managed`;
const $c364c398187f9175$export$594d0d4f5ecbf4c7 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-budget-creation-team-managed`;
const $c364c398187f9175$export$dda85c7a8278e495 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-employee-onboarding-team-managed`;
const $c364c398187f9175$export$b92c431651f9ee91 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-recruitment-team-managed`;
const $c364c398187f9175$export$d72d75d9d0e071fc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-lead-tracking-team-managed`;
const $c364c398187f9175$export$753322ed1c32ff89 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-ip-infringement-team-managed`;
const $c364c398187f9175$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
const $c364c398187f9175$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
const $c364c398187f9175$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
const $c364c398187f9175$export$df7d1440e0a80c03 = 'com.atlassian.servicedesk:simplified-it-service-management-operations';
const $c364c398187f9175$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
const $c364c398187f9175$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
const $c364c398187f9175$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
const $c364c398187f9175$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
const $c364c398187f9175$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
const $c364c398187f9175$export$9e38ad41d19608ee = 'jsm.blank-service-management';
const $c364c398187f9175$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
const $c364c398187f9175$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
const $c364c398187f9175$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
const $c364c398187f9175$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
const $c364c398187f9175$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
const $c364c398187f9175$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
const $c364c398187f9175$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $c364c398187f9175$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
const $c364c398187f9175$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
const $c364c398187f9175$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
const $c364c398187f9175$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
const $c364c398187f9175$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
const $c364c398187f9175$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
const $c364c398187f9175$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
const $c364c398187f9175$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
const $c364c398187f9175$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
const $c364c398187f9175$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
const $c364c398187f9175$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
const $c364c398187f9175$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
const $c364c398187f9175$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
const $c364c398187f9175$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
const $c364c398187f9175$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
const $c364c398187f9175$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
const $c364c398187f9175$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
const $c364c398187f9175$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
const $c364c398187f9175$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
const $c364c398187f9175$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
const $c364c398187f9175$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
const $c364c398187f9175$export$87a8fff98b5bc81 = 'initial.project.template.name';
const $c364c398187f9175$export$7c567eb725bd36f = 'jira.polaris:discovery';
const $c364c398187f9175$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
const $c364c398187f9175$export$f9776303073903dd = 'jira.polaris:roadmap';
const $c364c398187f9175$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
const $c364c398187f9175$export$789332a2d3504754 = 'jira.polaris:portfolio';
const $c364c398187f9175$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $c364c398187f9175$export$e8df553a3f519284 || T4JTemplateKey === $c364c398187f9175$export$8eecdf6acea9494 || T4JTemplateKey === $c364c398187f9175$export$9e38ad41d19608ee;
const $c364c398187f9175$export$a062badd78c9993 = {
    [$c364c398187f9175$export$e82092c4fb277f9b]: $c364c398187f9175$export$b0928b02ffab3875,
    [$c364c398187f9175$export$fd75f6abc7861439]: $c364c398187f9175$export$b0928b02ffab3875,
    [$c364c398187f9175$export$5eddf3b31dd1858f]: $c364c398187f9175$export$50478ee5ecbf7a4d,
    [$c364c398187f9175$export$fb658bddae7f81bb]: $c364c398187f9175$export$50478ee5ecbf7a4d
};

});

parcelRegister("6RAg1", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4752306278e43a2d$export$e324594224ef24da);

var $6fSBR = parcelRequire("6fSBR");

var $j6wxT = parcelRequire("j6wxT");

var $7mZ3t = parcelRequire("7mZ3t");

var $8UXiA = parcelRequire("8UXiA");

var $3iEb4 = parcelRequire("3iEb4");

var $7yDu9 = parcelRequire("7yDu9");

var $5UBG2 = parcelRequire("5UBG2");

var $lHcRB = parcelRequire("lHcRB");

var $eiyXc = parcelRequire("eiyXc");

var $jZvbN = parcelRequire("jZvbN");

var $azcAL = parcelRequire("azcAL");

var $gbXQ5 = parcelRequire("gbXQ5");

var $iZuFy = parcelRequire("iZuFy");

var $70Fss = parcelRequire("70Fss");

var $erLQY = parcelRequire("erLQY");

var $dQPsy = parcelRequire("dQPsy");

var $abQXL = parcelRequire("abQXL");

var $4VXxO = parcelRequire("4VXxO");

var $cUGWT = parcelRequire("cUGWT");

var $boV1S = parcelRequire("boV1S");

var $4Viq4 = parcelRequire("4Viq4");

var $jIoq4 = parcelRequire("jIoq4");

var $75A1x = parcelRequire("75A1x");

var $1Xkin = parcelRequire("1Xkin");
const $4752306278e43a2d$export$e324594224ef24da = {
    changeTaskGroupParent: $6fSBR.nextChangeTaskGroupParent,
    goBackToPreviousTaskGroup: $6fSBR.nextGoBackToPreviousTaskGroup,
    setIsOpen: $j6wxT.setIsOpen,
    refreshAppState: $7mZ3t.refreshAppState,
    setNudgeStep: $8UXiA.setNudgeStep,
    addMountedNudge: $3iEb4.addMountedNudge,
    removeMountedNudge: $3iEb4.removeMountedNudge,
    setShouldRenderComponent: $7yDu9.setShouldRenderComponent,
    setProjectState: $5UBG2.setProjectState,
    setHasNudgeActive: $lHcRB.setHasNudgeActive,
    forceHideNudge: $eiyXc.forceHideNudge,
    setHasEverSeenRoute: $jZvbN.setHasEverSeenRoute,
    setRoadmapIsCreateEnabled: $azcAL.setRoadmapIsCreateEnabled,
    setRoadmapIsListEmpty: $azcAL.setRoadmapIsListEmpty,
    openNextTask: $gbXQ5.openNextTask,
    resetIsQuickstartLoaded: $iZuFy.resetIsQuickstartLoaded,
    refreshAppStateUiStatusOnly: $70Fss.refreshAppStateUiStatusOnly,
    nextMarkAsCompletedTask: $erLQY.nextMarkAsCompletedTask,
    nextSetChecklistItemSeen: $dQPsy.nextSetChecklistItemSeen,
    nextSetChecklistIsDismissed: $abQXL.nextSetChecklistIsDismissed,
    nextSetChecklistIsOpen: $4VXxO.nextSetChecklistIsOpen,
    nextOpenTask: $cUGWT.nextOpenTask,
    nextAutoExpand: $boV1S.nextAutoExpand,
    nextShouldShowNudgeAfterNavigation: $4Viq4.nextShouldShowNudgeAfterNavigation,
    nextGetTasks: $jIoq4.nextGetTasks,
    syncVisibilityWithLocal: $75A1x.syncVisibilityWithLocal,
    universalDispatch: $1Xkin.universalDispatch
};

});
parcelRegister("6fSBR", function(module, exports) {

$parcel$export(module.exports, "nextChangeTaskGroupParent", () => $0f1566e1d3fc2987$export$76708cce5888039a);
$parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", () => $0f1566e1d3fc2987$export$57534cbc400a434c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $0f1566e1d3fc2987$var$setTaskGroup = (taskGroup, openTask)=>({ setState: setState })=>{
        setState({
            ...taskGroup,
            openTask: openTask || ''
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_TASK_GROUP),
            value: {
                taskGroup: taskGroup
            }
        });
    };
const $0f1566e1d3fc2987$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
        const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
        if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) // prevent infinite loop nesting
        return;
        previousTaskGroupParents.push(currentTaskGroupParent);
        const taskGroup = {
            previousTaskGroupParents: previousTaskGroupParents,
            currentTaskGroupParent: newCurrentTaskGroupParent
        };
        dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
    };
const $0f1566e1d3fc2987$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
        if ((0, $4R6GH.fg)('jira_a11y_fix_returning_focus')) {
            const { previousTaskGroupParents: previousTaskGroupParents, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
            const lastIndexOfPreviousTaskGroupParents = previousTaskGroupParents.length - 1;
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $8Bc5A.ROOT_TASK) : previousTaskGroupParents[lastIndexOfPreviousTaskGroupParents];
            const newPreviousTaskGroupParents = previousTaskGroupParents.slice(0, lastIndexOfPreviousTaskGroupParents);
            const taskGroup = {
                previousTaskGroupParents: newPreviousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup, currentTriggerForTaskGroupParent));
        } else {
            const { previousTaskGroupParents: previousTaskGroupParents } = getState();
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, $8Bc5A.ROOT_TASK) : previousTaskGroupParents.pop();
            const taskGroup = {
                previousTaskGroupParents: previousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            // @ts-expect-error - TS2345 - Argument of type '{ previousTaskGroupParents: string[]; currentTaskGroupParent: string | undefined; }' is not assignable to parameter of type 'TaskGroup'.
            dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
        }
    };

});
parcelRegister("1ftPQ", function(module, exports) {

$parcel$export(module.exports, "pushToBackend", () => $d3dd40bf54ad27bf$export$583b2d2422a6757f);

var $89SaW = parcelRequire("89SaW");

var $4Pf62 = parcelRequire("4Pf62");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");
const $d3dd40bf54ad27bf$var$getAccountId = ()=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
    return atlassianAccountId;
};
const $d3dd40bf54ad27bf$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, $89SaW.setUserProperties)($d3dd40bf54ad27bf$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
    });
const $d3dd40bf54ad27bf$var$trySetUserProperties = async (props, attemptCount)=>{
    try {
        await $d3dd40bf54ad27bf$var$setRemoteUserProperties(props);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'pushToBackend',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                action: 'pushToBackend',
                actionSubject: 'jiraOnboardingChecklistCore',
                attemptCount: attemptCount,
                key: props.key,
                reason: error && error.message
            },
            error: error
        });
        return false;
    }
    return true;
};
const $d3dd40bf54ad27bf$export$583b2d2422a6757f = async (props)=>{
    const success = await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 1);
    if (!success) // On failure retry - if retry fails data is lost.
    await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 2);
};

});


parcelRegister("j6wxT", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $eefde484654068e9$export$dcf23146e0a40195);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");
const $eefde484654068e9$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        if (isOpen === currentIsOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            }
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        // Delete code below when cleaning up isOpen in state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: isOpen
        });
    };
var $eefde484654068e9$export$2e2bcd8739ae039 = $eefde484654068e9$export$dcf23146e0a40195;

});
parcelRegister("3B5jO", function(module, exports) {

$parcel$export(module.exports, "getQuickstartTypeSelector", () => $47424244d57f6abc$export$eae834ce0286017a);

var $2vSU6 = parcelRequire("2vSU6");

var $8Bc5A = parcelRequire("8Bc5A");
const $47424244d57f6abc$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
const $47424244d57f6abc$export$eae834ce0286017a = (state)=>{
    if ($47424244d57f6abc$export$6f17f2cb816105eb(state)) return (0, $8Bc5A.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
    return (0, $8Bc5A.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
};

});


parcelRegister("7mZ3t", function(module, exports) {

$parcel$export(module.exports, "refreshAppState", () => $ecf6e94ad9c4f8d6$export$797c35e2e1d0d014);


var $8fqy8 = parcelRequire("8fqy8");

var $8zOmE = parcelRequire("8zOmE");

var $bfWlw = parcelRequire("bfWlw");

var $ldyPw = parcelRequire("ldyPw");

var $8Bc5A = parcelRequire("8Bc5A");

var $6yhDy = parcelRequire("6yhDy");

var $1ftPQ = parcelRequire("1ftPQ");

var $52Vcw = parcelRequire("52Vcw");

var $ljzlb = parcelRequire("ljzlb");

var $6ypzr = parcelRequire("6ypzr");

var $4ji4w = parcelRequire("4ji4w");

var $abQXL = parcelRequire("abQXL");

var $4VXxO = parcelRequire("4VXxO");

var $erLQY = parcelRequire("erLQY");

var $6fSBR = parcelRequire("6fSBR");
const $ecf6e94ad9c4f8d6$var$allTasks = [
    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
    ...(0, $8Bc5A.JSM_BUSINESS_TASKS)
];
const $ecf6e94ad9c4f8d6$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const hasSeenTasks = [
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)),
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)),
            (0, $8Bc5A.convertToHaveSeenItTask)((0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK))
        ];
        const { projectState: projectState = null } = getState();
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectType;
        let backendVisibilityKeys = [];
        let jsmTaskProjectKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).map((type)=>(0, $8Bc5A.getBackendVisibilityKey)(type));
        if (projectState?.projectId) jsmTaskProjectKeys = (0, $8Bc5A.JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
        const backendState = await (0, $6yhDy.pollBackend)({
            keys: [
                (0, $8Bc5A.KEY_OPEN),
                (0, $8Bc5A.KEY_DISMISSED),
                (0, $8Bc5A.KEY_OPEN_TASK),
                (0, $8Bc5A.KEY_TASK_GROUP),
                (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $8Bc5A.KEY_JSW_ONBOARDING),
                (0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED),
                ...$ecf6e94ad9c4f8d6$var$allTasks,
                ...hasSeenTasks,
                ...backendVisibilityKeys,
                ...jsmTaskProjectKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
                    ...jsmTaskProjectKeys
                ].includes(key) && backendState[key] === true);
            updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
            Object.values((0, $8Bc5A.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $8Bc5A.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $8Bc5A.getBackendVisibilityKey)(type)];
                else if ((0, $8Bc5A.KEY_DISMISSED) in backendState && backendState[0, $8Bc5A.KEY_DISMISSED]) updatedState.visibility[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $8Bc5A.KEY_OPEN] ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
                (0, $4ji4w.setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
            });
            // Delete when cleaning up isDismissed in state
            if ((0, $8Bc5A.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $8Bc5A.KEY_DISMISSED];
            // Delete when cleaning up isOpen in state
            if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $8Bc5A.KEY_OPEN];
            if ((0, $8Bc5A.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $8Bc5A.KEY_OPEN_TASK];
            if ((0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $8Bc5A.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $8Bc5A.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, $8Bc5A.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $8Bc5A.KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
            }
        }
        // Important that this call is before the dismiss migration logic and the premium card permission migration, otherwise it would
        // override the dismiss and currentTaskGroupParent
        setState(updatedState);
        // Bit of a migration
        // Handles case where non-admin premium users have a premium card child open which they can no longer access as we added more permission checks
        // Or, if a user was on a premium trial and saw premium content but is now free,
        // We take them to the root instead
        if ((updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, $ldyPw.PREMIUM_EDITION)) {
            dispatch((0, $6fSBR.nextGoBackToPreviousTaskGroup)());
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
        }
        if (!(backendStateExists && (0, $8Bc5A.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $6ypzr.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $abQXL.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $52Vcw.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        const jswTrackDeferSitenameSiteTrait = await (0, $8fqy8.getJswTrackDeferSitenameSiteTrait)(cloudId, {
            packageName: (0, $8Bc5A.PACKAGE_NAME),
            teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
        });
        setState({
            isEligibleToUpdateSitename: jswTrackDeferSitenameSiteTrait?.value === 'experiment-generated-site-name'
        });
        const setPremiumCardAudienceTrait = async (accountId)=>{
            if (accountId === null) return;
            const trait = await (0, $ljzlb.getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
            setState({
                isCrossProjectBoardToPlanUpsell: trait?.value === true || false
            });
        };
        // We only want to check if a non-admin user has the CPB trait if they are in a
        // premium evaluation of jira software (i.e. they have access to Advanced Roadmaps)
        if (appEditions.software === (0, $ldyPw.PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
        const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
        // If the user is on a JSW Premium instance, perform a fetch to check that they signed up with a Premium Reverse Trial.
        let isReverseTrialForJSW;
        if (isTargetedForReverseTrials) {
            const isOnboardingPremiumTrial = await (0, $bfWlw.getOnboardingPremiumTrial)();
            isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
        }
        /**
		 * Re-open QS for:
		 *  - admins on an AdvancedRoadmaps trial who haven't had it re-opened for them yet
		 *  - non-admins on an AdvancedRoadmaps trial with isCrossProjectBoardToPlanUpsell trait
		 */ if (!isReverseTrialForJSW && appEditions.software === (0, $ldyPw.PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED]) {
            // Re-open QS if not already opened
            dispatch((0, $4VXxO.nextSetChecklistIsOpen)(true));
            dispatch((0, $abQXL.nextSetChecklistIsDismissed)(false));
            const taskToDispatch = isAdmin ? (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK) : (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN);
            // Go to advanced roadmaps task
            dispatch((0, $erLQY.nextMarkAsCompletedTask)(taskToDispatch));
            dispatch((0, $6fSBR.nextChangeTaskGroupParent)(taskToDispatch));
            await (0, $1ftPQ.pushToBackend)({
                key: (0, $8Bc5A.KEY_PREMIUM_TRIAL_REOPENED),
                value: true
            });
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                isAdmin: isAdmin
            });
        }
        setState({
            canEditPlans: canEditPlans
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $6784cbc7d62e5d7c$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$6e69f8dc03075ef8 = 'team-type';
const $6784cbc7d62e5d7c$export$c06666264cd35603 = 'team-type-shorthand';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $6784cbc7d62e5d7c$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $6784cbc7d62e5d7c$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $6784cbc7d62e5d7c$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $6784cbc7d62e5d7c$export$699265ec8ad9a740 = 'Software Development';
const $6784cbc7d62e5d7c$export$e07d1fa2da8ed874 = 'Customer Service';
const $6784cbc7d62e5d7c$export$76dcec3f438d9e56 = 'IT Support';
const $6784cbc7d62e5d7c$export$9a574c301f67ba30 = 'Human Resources';
const $6784cbc7d62e5d7c$export$363ec144a94029c8 = 'Finance';
const $6784cbc7d62e5d7c$export$df0fb32d68ae1e78 = 'Legal';
const $6784cbc7d62e5d7c$export$d9c0e3e59442fb4 = 'Marketing';
const $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3 = 'Operations';
const $6784cbc7d62e5d7c$export$a5dce388adf922bd = 'Sales';
const $6784cbc7d62e5d7c$export$e1473b31a257caff = 'Data Science';
const $6784cbc7d62e5d7c$export$85657457db93c2c2 = 'Product Management';
const $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd = 'Project Management';
const $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3 = 'Design';
const $6784cbc7d62e5d7c$export$7b60378c3b4372e9 = 'Other or Personal';
const $6784cbc7d62e5d7c$export$572242e58bd07594 = 'CS';
const $6784cbc7d62e5d7c$export$d7de553940261eba = 'ITS';
const $6784cbc7d62e5d7c$export$4c29d0d04c15e55d = 'HR';
const $6784cbc7d62e5d7c$export$3950f7f841bf94b6 = 'FNC';
const $6784cbc7d62e5d7c$export$881249b988b6030f = 'LGL';
const $6784cbc7d62e5d7c$export$e4824f74b9879164 = 'MKT';
const $6784cbc7d62e5d7c$export$4f3cb0844009af52 = 'OPS';
const $6784cbc7d62e5d7c$export$1a65d50c4a641bb4 = 'SAL';
const $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2 = 'DS';
const $6784cbc7d62e5d7c$export$b8b1ac856ba1434b = 'DEV';
const $6784cbc7d62e5d7c$export$4f54a09a24fd1d74 = 'PDM';
const $6784cbc7d62e5d7c$export$79685802e8ff1098 = 'PJM';
const $6784cbc7d62e5d7c$export$e5c438b7501b5a24 = 'DES';
const $6784cbc7d62e5d7c$export$cbc0e551d91a692d = 'OTR';

parcelRegister("8fqy8", function(module, exports) {

$parcel$export(module.exports, "getSignupTrackDeferSitenameUserTrait", () => $77364531dfabe700$export$686752df505238be);
$parcel$export(module.exports, "getJswTrackDeferSitenameSiteTrait", () => $77364531dfabe700$export$6da79f996c267010);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $77364531dfabe700$var$PERSONALIZATION_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/site/`;
const $77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/user/`;
const $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT = 'marketing-signup_track_deferred-sitename_signup_server_enrollment';
const $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT = 'jira_track_instance_created_server_defer_site_rename_cohort';
const $77364531dfabe700$var$fetchPersonalization = (endpoint, subject)=>async (id, meta)=>{
        try {
            const url = endpoint + id;
            return await (0, $eusud.performGetRequest)(url);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'onboarding',
                    teamName: 'jlove-makkuro',
                    ...meta
                },
                attributes: {
                    subject: subject
                },
                error: error
            });
            return undefined;
        }
    };
const $77364531dfabe700$var$getTraits = (fetch, traitName)=>async (id, meta)=>{
        const personalization = await fetch(id, meta);
        return personalization?.attributes?.find((att)=>att.name === traitName);
    };
const $77364531dfabe700$export$686752df505238be = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT, 'fetchUserPersonalization'), $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT);
const $77364531dfabe700$export$6da79f996c267010 = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT, 'fetchSitePersonalization'), $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT);

});

parcelRegister("bfWlw", function(module, exports) {

$parcel$export(module.exports, "getOnboardingPremiumTrialWithRethrow", () => $a55f3307b43c0521$export$d9a9dd6206da5bef);
$parcel$export(module.exports, "getOnboardingPremiumTrial", () => $a55f3307b43c0521$export$ef676f7f369f74fe);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $6c7t9 = parcelRequire("6c7t9");
const $a55f3307b43c0521$var$endpoint = '/rest/onboarding/1.0/premium-trial';
const $a55f3307b43c0521$export$d9a9dd6206da5bef = async ()=>{
    try {
        // Attempt to get from localStorage
        const localStorageOnboardingPremiumTrial = (0, $6c7t9.localStorageGetOnboardingPremiumTrial)();
        const localStorageOnboardingPremiumTrialCohort = (0, $6c7t9.localStorageGetOnboardingPremiumTrialCohort)();
        if (typeof localStorageOnboardingPremiumTrial === 'boolean' && typeof localStorageOnboardingPremiumTrialCohort === 'string') return {
            premiumTrialOnSignup: localStorageOnboardingPremiumTrial,
            reverseTrialCohort: localStorageOnboardingPremiumTrialCohort
        };
        const response = await (0, $eusud.performGetRequestWithRetry)($a55f3307b43c0521$var$endpoint);
        const premiumTrialOnSignup = response?.premiumTrialOnSignup;
        const reverseTrialCohort = response?.reverseTrialCohort;
        if (typeof premiumTrialOnSignup === 'boolean' && typeof reverseTrialCohort === 'string') {
            // Set into localStorage
            (0, $6c7t9.localStorageSetOnboardingPremiumTrial)(premiumTrialOnSignup);
            (0, $6c7t9.localStorageSetOnboardingPremiumTrialCohort)(reverseTrialCohort);
            return {
                premiumTrialOnSignup: premiumTrialOnSignup,
                reverseTrialCohort: reverseTrialCohort
            };
        }
        throw new Error('response?.premiumTrialOnSignup or response?.reverseTrialCohort is undefined');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getOnboardingPremiumTrialWithRethrow',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $a55f3307b43c0521$export$ef676f7f369f74fe = async ()=>{
    try {
        return await $a55f3307b43c0521$export$d9a9dd6206da5bef();
    } catch (e) {
    // ignored
    }
};

});
parcelRegister("6c7t9", function(module, exports) {

$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrial", () => $fab9df2877e9db77$export$782df5489e5cfd1e);
$parcel$export(module.exports, "localStorageGetOnboardingPremiumTrialCohort", () => $fab9df2877e9db77$export$c3378895d06b5528);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrial", () => $fab9df2877e9db77$export$f83a7a49524e74ad);
$parcel$export(module.exports, "localStorageSetOnboardingPremiumTrialCohort", () => $fab9df2877e9db77$export$f389f8ca168b4a3a);

var $bSSG7 = parcelRequire("bSSG7");

var $jcw0u = parcelRequire("jcw0u");
const $fab9df2877e9db77$export$3538ee3f5c6c8b5c = 'premiumTrialOnSignup';
const $fab9df2877e9db77$export$2f93fdc3330233dc = 'reverseTrialCohort';
const $fab9df2877e9db77$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('jsw-onboarding-premium-reverse-trial');
const $fab9df2877e9db77$export$782df5489e5cfd1e = ()=>{
    try {
        const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$3538ee3f5c6c8b5c);
        // localStorage.get is able to return proper booleans and not stringified booleans like "true"/"false"
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $fab9df2877e9db77$export$c3378895d06b5528 = ()=>{
    try {
        const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$2f93fdc3330233dc);
        return value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageGetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        // note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
        return undefined;
    }
};
const $fab9df2877e9db77$export$f83a7a49524e74ad = (premiumTrialOnSignup)=>{
    try {
        $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$3538ee3f5c6c8b5c, premiumTrialOnSignup);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $fab9df2877e9db77$export$f389f8ca168b4a3a = (reverseTrialCohort)=>{
    try {
        $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$2f93fdc3330233dc, reverseTrialCohort);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'localStorageSetOnboardingPremiumTrial',
                packageName: 'jiraReverseTrialUtils'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});


parcelRegister("6yhDy", function(module, exports) {

$parcel$export(module.exports, "pollBackend", () => $760653e5a4f27459$export$8420ef0cee98de);

var $1sYcL = parcelRequire("1sYcL");

var $g5X3G = parcelRequire("g5X3G");

var $8Bc5A = parcelRequire("8Bc5A");
const $760653e5a4f27459$export$8420ef0cee98de = async ({ keys: keys })=>{
    const { user: user } = await (0, $1sYcL.get)((0, $g5X3G.toBaseUrl)(''), {
        userProperties: keys,
        consumerMeta: {
            id: 'fetchUserProperties',
            packageName: (0, $8Bc5A.PACKAGE_NAME),
            teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
        }
    });
    return user;
};

});
parcelRegister("1sYcL", function(module, exports) {

$parcel$export(module.exports, "get", () => $7fc92c544211ac93$export$3988ae62b71be9a3);

var $lbWm4 = parcelRequire("lbWm4");

var $3T6Xo = parcelRequire("3T6Xo");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $fjcgS = parcelRequire("fjcgS");

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
let $7fc92c544211ac93$var$ufoExperiencesMap = {};
const $7fc92c544211ac93$var$getUfoExperience = (key)=>{
    if (!$7fc92c544211ac93$var$ufoExperiencesMap[key]) $7fc92c544211ac93$var$ufoExperiencesMap[key] = new (0, $duUGa.UFOExperience)(key, {
        type: (0, $atdLB.ExperienceTypes).Operation,
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
    });
    return $7fc92c544211ac93$var$ufoExperiencesMap[key];
};
const $7fc92c544211ac93$export$c907f169d33b2e25 = ()=>{
    $7fc92c544211ac93$var$ufoExperiencesMap = {};
};
const $7fc92c544211ac93$export$a5b7a8c3b1c6e775 = (baseUrl, { userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
    const params = new URLSearchParams();
    userProperties && params.append('user', userProperties.join(','));
    projectId !== undefined && params.append('projectId', projectId);
    projectProperties && params.append('project', projectProperties.join(','));
    instanceProperties && params.append('instance', instanceProperties.join(','));
    return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7fc92c544211ac93$var$patchProperties = (response, propertiesPath)=>((0, $4R6GH.fg)('handle_null_response_for_fe_config_properties_call') ? response : true) && (0, (/*@__PURE__*/$parcel$interopDefault($lbWm4)))(response[propertiesPath], (value, prop)=>{
        try {
            response[propertiesPath][prop] = JSON.parse(value);
        } catch (error) {
            // TODO: Endpoint should ideally only return stringified values
            if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
            else throw error;
        }
    });
const $7fc92c544211ac93$export$3988ae62b71be9a3 = async (baseUrl, options)=>{
    const ufoExperience = $7fc92c544211ac93$var$getUfoExperience(`${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(options.consumerMeta.packageName)}.${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(options.consumerMeta.id)}`);
    try {
        ufoExperience?.start();
        const url = $7fc92c544211ac93$export$a5b7a8c3b1c6e775(baseUrl, options);
        const response = await (0, $eusud.performGetRequest)(url);
        if (response === null) (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'succeeded',
                actionSubject: 'jiraCommonRestInternalLatest.getConfigProperties',
                source: 'frontendConfigProperties',
                attributes: {
                    package: consumerMeta.packageName,
                    id: consumerMeta.id,
                    isNullResponse: true
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        $7fc92c544211ac93$var$patchProperties(response, 'user');
        $7fc92c544211ac93$var$patchProperties(response, 'instance');
        $7fc92c544211ac93$var$patchProperties(response, 'project');
        const { consumerMeta: consumerMeta } = options;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'frontendConfigProperties',
                action: 'success',
                actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        ufoExperience?.success();
        return (0, $4R6GH.fg)('handle_null_response_for_fe_config_properties_call') ? response || {
            user: {},
            instance: {},
            project: {}
        } : response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { consumerMeta: consumerMeta } = options;
        !(0, $fZneA.isClientFetchError)(error) && (0, $jcw0u.default)({
            error: error,
            meta: {
                id: consumerMeta.id,
                packageName: consumerMeta.packageName,
                teamName: consumerMeta.teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
        ufoExperience?.failure();
        throw error;
    }
};

});


parcelRegister("52Vcw", function(module, exports) {

$parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", () => $5dab66e6da9554ae$export$c98a6ee6aadb8055);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", () => $5dab66e6da9554ae$export$45d8c76e0490b3ec);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", () => $5dab66e6da9554ae$export$b1be4ae35a43115d);
$parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", () => $5dab66e6da9554ae$export$fa4f266bd2444d14);
$parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", () => $5dab66e6da9554ae$export$a68a2e5a69c8cd74);
$parcel$export(module.exports, "fireAPIErrorAnalytics", () => $5dab66e6da9554ae$export$a4d7f1a52677d339);
$parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", () => $5dab66e6da9554ae$export$160bb78a3b11a5a9);
$parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", () => $5dab66e6da9554ae$export$6ccbe54cd3a5a12);
$parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", () => $5dab66e6da9554ae$export$6c39ca65ca354e59);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $8Bc5A = parcelRequire("8Bc5A");

var $izv86 = parcelRequire("izv86");
const $5dab66e6da9554ae$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
    analyticsEvent.update({
        action: 'closed',
        actionSubject: 'button'
    });
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button closed', (0, $8Bc5A.ACTION_SUBJECT_ID), attributes);
};
const $5dab66e6da9554ae$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
    if (source === 'button') (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
    else if (source === 'checklist') (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
};
const $5dab66e6da9554ae$export$b1be4ae35a43115d = (analyticsEvent)=>{
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
};
const $5dab66e6da9554ae$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, $izv86.convertTaskIdToActionSubjectId)(completedTaskId), {
        taskId: completedTaskId
    });
};
const $5dab66e6da9554ae$export$a4d7f1a52677d339 = (error, endpointSource)=>{
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: 'quickstartApiError',
            packageName: 'jiraOnboardingQuickstartCore',
            teamName: 'jlove-makkuro'
        },
        attributes: {
            error: error.message,
            endpointSource: endpointSource
        }
    });
};
const $5dab66e6da9554ae$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};
const $5dab66e6da9554ae$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
    const analyticsEvent = createAnalyticsEvent({});
    (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, $8Bc5A.ACTION_SUBJECT_ID), {
        ...attributes
    });
};

});
parcelRegister("izv86", function(module, exports) {

$parcel$export(module.exports, "getProductType", () => $4725f5ccfabd2231$export$27e53caf66bae1d);
$parcel$export(module.exports, "convertTaskIdToActionSubjectId", () => $4725f5ccfabd2231$export$3b914201960fa7a6);

var $e4eHl = parcelRequire("e4eHl");

var $2vSU6 = parcelRequire("2vSU6");
const $4725f5ccfabd2231$export$d64a7dd8c7cd80e0 = {
    [(0, $2vSU6.CORE_PROJECT)]: 'workManagement',
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'serviceManagement'
};
const $4725f5ccfabd2231$export$27e53caf66bae1d = (projectType)=>{
    if (projectType) return $4725f5ccfabd2231$export$d64a7dd8c7cd80e0[projectType] || (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(projectType);
    return null;
};
const $4725f5ccfabd2231$export$3b914201960fa7a6 = (taskId)=>{
    if (!taskId) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(taskId.split('.').pop());
};

});


parcelRegister("ljzlb", function(module, exports) {

$parcel$export(module.exports, "getCrossProjectBoardTrait", () => $9217b5bb53dd29c2$export$7f2186c37a3d095d);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");

var $8Bc5A = parcelRequire("8Bc5A");

var $k9OK8 = parcelRequire("k9OK8");
const $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
const $9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
const $9217b5bb53dd29c2$var$ONE_DAY = 86400000;
const $9217b5bb53dd29c2$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
    try {
        const url = `${$9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
        const result = await (0, $eusud.performGetRequest)(url);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
            synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
        });
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: (0, $8Bc5A.PACKAGE_NAME),
                teamName: (0, $8Bc5A.PACKAGE_TEAM_NAME)
            },
            attributes: {
                error: error.message,
                endpointSource: 'getJSWCrossProjectBoardTrait',
                synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            attributes: []
        };
    }
};
const $9217b5bb53dd29c2$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
    const { get: get, persist: persist } = (0, $k9OK8.crossProjectBoardTraitSessionStorageProvider)();
    // Check session storage
    const sessionStorage = get();
    if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $9217b5bb53dd29c2$var$ONE_DAY) {
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
            synthetic: (0, $4R6GH.fg)('is_synthetic_tenant')
        });
        return sessionStorage.attribute;
    }
    // Fetch from personalization
    const personalization = await $9217b5bb53dd29c2$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
    const attribute = personalization.attributes.find((att)=>att.name === $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
    if (attribute !== undefined) persist({
        attribute: attribute,
        date: Date.now(),
        userId: userId,
        siteId: siteId
    });
    return attribute;
};

});
parcelRegister("k9OK8", function(module, exports) {

$parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", () => $ee27e8acf854e0ab$export$99f3e48748c2a8c3);

var $eNf8a = parcelRequire("eNf8a");

const $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider = (0, $eNf8a.createSessionExpirableStorageProvider)((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
const $ee27e8acf854e0ab$export$99f3e48748c2a8c3 = ()=>{
    const persist = (toPersist)=>{
        $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.set((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a), toPersist);
    };
    const get = ()=>$ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.get((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
    return {
        get: get,
        persist: persist
    };
};

});
const $111ca51573c84ae8$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';



parcelRegister("6ypzr", function(module, exports) {

$parcel$export(module.exports, "getOnboardingSkipApplicationProperty", () => $98fe78eb4dc2e758$export$980c26b6f100081d);

var $eusud = parcelRequire("eusud");
const $98fe78eb4dc2e758$export$980c26b6f100081d = ()=>(0, $eusud.performGetRequest)('/rest/onboarding/1.0/skip');

});

parcelRegister("4ji4w", function(module, exports) {

$parcel$export(module.exports, "getNextNonCompleteTask", () => $af696889329ec63a$export$b61dc70e2ed3fae3);
$parcel$export(module.exports, "getNextTask", () => $af696889329ec63a$export$404421ce8f3cbf9a);
$parcel$export(module.exports, "setLocalStorageItem", () => $af696889329ec63a$export$5aa524d86254b4f);
$parcel$export(module.exports, "getLocalStorageItem", () => $af696889329ec63a$export$93d719890ad66653);

var $bSSG7 = parcelRequire("bSSG7");

var $aFsRe = parcelRequire("aFsRe");
const $af696889329ec63a$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
    const taskPosition = (0, $aFsRe.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const start = taskPosition === -1 ? 0 : taskPosition;
    const len = tasks.length;
    // This loop:
    // 1) searches for non completed items from the start index to last index of the array
    // 2) searches from 0 until start if nothing was found during 1)
    for(let i = start; i < start + len; i += 1){
        const ind = i % len;
        if (!completed.includes(tasks[ind])) return tasks[ind];
    }
    // nothing was found there is no task to open
    return null;
};
const $af696889329ec63a$export$404421ce8f3cbf9a = (tasks, openTask)=>{
    const taskPosition = (0, $aFsRe.getTaskIndex)(tasks, openTask);
    // if the task does not exist(-1), we want to start at 0
    // if it exists we want to start at array index + 1 (taskPosition is already index+1)
    const ind = taskPosition === -1 ? 0 : taskPosition;
    return tasks[ind] ? tasks[ind] : null;
};
const $af696889329ec63a$var$store = (0, $bSSG7.createLocalStorageProvider)('quickstart');
const $af696889329ec63a$export$5aa524d86254b4f = (key, value)=>{
    $af696889329ec63a$var$store.set(key, value);
};
const $af696889329ec63a$export$93d719890ad66653 = (key)=>$af696889329ec63a$var$store.get(key);

});
parcelRegister("aFsRe", function(module, exports) {

$parcel$export(module.exports, "getTaskIndex", () => $856e0575daef172f$export$9ba3adcb1954c00);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", () => $856e0575daef172f$export$9711f11998d5795c);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", () => $856e0575daef172f$export$995248f3b43d8505);
$parcel$export(module.exports, "convertTaskIdToActionSubjectIdForCta", () => $856e0575daef172f$export$293f6b2affa6ea5a);

var $izv86 = parcelRequire("izv86");







const $856e0575daef172f$export$9ba3adcb1954c00 = (taskList, taskId)=>{
    if (!taskList || taskId === null) return -1;
    return taskList.indexOf(taskId) + 1;
};
const $856e0575daef172f$export$9711f11998d5795c = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
const $856e0575daef172f$export$995248f3b43d8505 = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}Link`;
const $856e0575daef172f$export$293f6b2affa6ea5a = (taskId)=>`${(0, $izv86.convertTaskIdToActionSubjectId)(taskId)}Cta`;

});


parcelRegister("abQXL", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsDismissed", () => $dc09dffee9419aae$export$f24c05f83b880547);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $dc09dffee9419aae$export$f24c05f83b880547 = (isDismissed)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsDismissed = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
        if (isDismissed === currentIsDismissed) // if state has not been updated we just return
        return;
        const quickstartStatus = isDismissed ? (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED : (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            isFocusedOn: !isDismissed
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $4ji4w.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isDismissed in state
        if (isDismissed === false) // When setting IsDismissed to false, also setting QS status to OPEN so checklist appears in open state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: true
        });
        else // When setting IsDismissed, also toggle the open state of the checklist to match.
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: false
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_DISMISSED),
            value: isDismissed
        });
    };

});

parcelRegister("4VXxO", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistIsOpen", () => $7815e3bf96163d46$export$4249eabbb34e2e69);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $7815e3bf96163d46$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const currentIsOpen = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
        const currentIsMinimised = state.visibility[quickstartType] === (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) // if state has not been updated we just return
        return;
        const quickstartStatus = isOpen ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: quickstartStatus
            },
            hasNudgeActive: false,
            isFocusedOn: isOpen
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.getBackendVisibilityKey)(quickstartType),
            value: quickstartStatus
        });
        (0, $4ji4w.setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
        // Delete all code below when cleaning up isOpen in state
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN),
            value: isOpen
        });
    };

});

parcelRegister("erLQY", function(module, exports) {

$parcel$export(module.exports, "nextMarkAsCompletedTask", () => $f082da41253fd664$export$d6628d41a3bec42d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $1ftPQ = parcelRequire("1ftPQ");
const $f082da41253fd664$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
        // When a task is complete:
        // Check to see if the task is complete in the completedKeys already
        // update the checklist dict (maybe should be at a different point or use setState)
        const { completedTaskList: completedTaskList } = getState();
        if (completedTaskList.includes(taskId)) return;
        // update the backend with the KEY and true
        (0, $1ftPQ.pushToBackend)({
            key: taskId,
            value: true
        });
        // update itemsList to reflect checked status. clone -> update -> override
        setState({
            completedTaskList: [
                ...completedTaskList,
                taskId
            ]
        });
    };

});


parcelRegister("8UXiA", function(module, exports) {

$parcel$export(module.exports, "setNudgeStep", () => $2d15900fae273e3c$export$4debc323813b6997);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2d15900fae273e3c$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { nudgeStep: nudgeStep } = getState();
        if (nudge === nudgeStep) return;
        setState({
            nudgeStep: nudge
        });
    };
var $2d15900fae273e3c$export$2e2bcd8739ae039 = $2d15900fae273e3c$export$4debc323813b6997;

});

parcelRegister("3iEb4", function(module, exports) {

$parcel$export(module.exports, "addMountedNudge", () => $d23aba2b0749d2be$export$92a89c32d0ea3943);
$parcel$export(module.exports, "removeMountedNudge", () => $d23aba2b0749d2be$export$748f4cda8ab98c91);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d23aba2b0749d2be$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already added
        if (mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: [
                ...mountedNudges,
                nudge
            ]
        });
    };
const $d23aba2b0749d2be$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
        const { mountedNudges: mountedNudges } = getState();
        // skip store update if this nudge is already removed
        if (!mountedNudges.includes(nudge)) return;
        setState({
            mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
        });
    };

});

parcelRegister("7yDu9", function(module, exports) {

$parcel$export(module.exports, "setShouldRenderComponent", () => $e7988e1b8f7782bd$export$1f9c6770ed938b6e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e7988e1b8f7782bd$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is shouldRenderComponent */ const { shouldRenderComponent: currentShouldRenderComponent } = getState();
        if (shouldRenderComponent === currentShouldRenderComponent) // if state has not been updated we just return
        return;
        setState({
            shouldRenderComponent: shouldRenderComponent
        });
    };
var $e7988e1b8f7782bd$export$2e2bcd8739ae039 = $e7988e1b8f7782bd$export$1f9c6770ed938b6e;

});

parcelRegister("5UBG2", function(module, exports) {

$parcel$export(module.exports, "setProjectState", () => $72dc29ca0b198f0e$export$1ba498e440c0a1e4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $72dc29ca0b198f0e$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
        setState({
            projectState: projectState
        });
    };
var $72dc29ca0b198f0e$export$2e2bcd8739ae039 = $72dc29ca0b198f0e$export$1ba498e440c0a1e4;

});

parcelRegister("lHcRB", function(module, exports) {

$parcel$export(module.exports, "setHasNudgeActive", () => $4ecbca1b06d3bc5e$export$497c281e6eb0786e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $4ecbca1b06d3bc5e$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
        /* Grab current state of is currentHasNudgeActive */ const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
        if (hasNudgeActive === currentHasNudgeActive) // if state has not been updated we just return
        return;
        if (hasNudgeActive === false && itemName !== openTask) // do not update a nudge if the current open task is different than the one we called the function with
        return;
        setState({
            hasNudgeActive: hasNudgeActive
        });
    };
var $4ecbca1b06d3bc5e$export$2e2bcd8739ae039 = $4ecbca1b06d3bc5e$export$497c281e6eb0786e;

});

parcelRegister("eiyXc", function(module, exports) {

$parcel$export(module.exports, "forceHideNudge", () => $7ab5d12e3e83c16f$export$6d1ed97b83a62e8e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
// We use this action in cases where we want to hide the nudge no matter what.
const $7ab5d12e3e83c16f$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
        setState({
            hasNudgeActive: false
        });
    };

});

parcelRegister("jZvbN", function(module, exports) {

$parcel$export(module.exports, "setHasEverSeenRoute", () => $bde38543b00c29f3$export$28e0a4314a1ce52f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $bde38543b00c29f3$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
        const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
        const somethingHasBeenUpdated = Object.keys(update).some(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
        (key)=>update[key] !== currentHasEverSeenRoute[key]);
        if (!somethingHasBeenUpdated) return;
        const newHasEverSeenRoute = {
            ...currentHasEverSeenRoute,
            ...update
        };
        setState({
            hasEverSeenRoute: newHasEverSeenRoute
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
            value: newHasEverSeenRoute
        });
    };
var $bde38543b00c29f3$export$2e2bcd8739ae039 = $bde38543b00c29f3$export$28e0a4314a1ce52f;

});

parcelRegister("azcAL", function(module, exports) {

$parcel$export(module.exports, "setRoadmapIsCreateEnabled", () => $f19987e3027503ab$export$35ea35d1a8e07307);
$parcel$export(module.exports, "setRoadmapIsListEmpty", () => $f19987e3027503ab$export$932967764e7a0b31);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $f19987e3027503ab$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
        // skip store update if no state change
        if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
        setState({
            roadmapIsCreateEnabled: roadmapIsCreateEnabled
        });
    };
const $f19987e3027503ab$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
        const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
        // skip store update if no state change
        if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
        setState({
            roadmapIsListEmpty: roadmapIsListEmpty
        });
    };

});

parcelRegister("gbXQ5", function(module, exports) {

$parcel$export(module.exports, "openNextTask", () => $460159056a360dfc$export$867dbb6d61569ae9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4ji4w = parcelRequire("4ji4w");

var $cUGWT = parcelRequire("cUGWT");
const $460159056a360dfc$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
        const { openTask: openTask, tasks: tasks } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        const taskIdToExpand = (0, $4ji4w.getNextTask)(items, openTask);
        if (taskIdToExpand === null) return;
        dispatch((0, $cUGWT.nextOpenTask)(taskIdToExpand));
    };

});
parcelRegister("cUGWT", function(module, exports) {

$parcel$export(module.exports, "nextOpenTask", () => $f8b3135a172025f8$export$5deb889489d2f989);
$parcel$export(module.exports, "nextAutoOpenTask", () => $f8b3135a172025f8$export$cc5f3544a6cb2922);


var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");

var $8UXiA = parcelRequire("8UXiA");

var $lHcRB = parcelRequire("lHcRB");
const $f8b3135a172025f8$var$openTask = (taskId)=>({ setState: setState })=>{
        setState({
            openTask: taskId
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.KEY_OPEN_TASK),
            value: taskId
        });
    };
const $f8b3135a172025f8$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
        dispatch($f8b3135a172025f8$var$openTask(taskId));
        const { completedTaskList: completedTaskList } = getState();
        const taskIsCompleted = completedTaskList.includes(taskId);
        const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
        if (closeNudge) dispatch((0, $lHcRB.setHasNudgeActive)(false, taskId));
        else dispatch((0, $lHcRB.setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
        // This is a temporary solution for Scrum Onboarding.
        // See https://hello.atlassian.net/wiki/spaces/agile/pages/1321008806/Draft+Quickstart+Nudge+Interaction for details
        if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.SCRUM_ONBOARDING_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$b1a6ab17737f33e)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.KANBAN_ONBOARDING_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
        else if (taskIdExistsAndIsNotCompleted && taskId === (0, $8Bc5A.ADD_COLUMNS_TASK)) dispatch((0, $8UXiA.setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
        else dispatch((0, $8UXiA.setNudgeStep)(''));
    };
const $f8b3135a172025f8$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
        dispatch($f8b3135a172025f8$var$openTask(taskId));
        dispatch((0, $lHcRB.setHasNudgeActive)(false, taskId));
        dispatch((0, $8UXiA.setNudgeStep)(''));
    };

});


parcelRegister("iZuFy", function(module, exports) {

$parcel$export(module.exports, "resetIsQuickstartLoaded", () => $b50ce46f86d3e3d7$export$bda085a823763e5a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $3B5jO = parcelRequire("3B5jO");
const $b50ce46f86d3e3d7$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED
            },
            hasNudgeActive: false,
            isQuickstartLoaded: false
        });
    };

});

parcelRegister("70Fss", function(module, exports) {

$parcel$export(module.exports, "refreshAppStateUiStatusOnly", () => $f0fdda8951af3bde$export$87fe8079a4ed9766);


var $8Bc5A = parcelRequire("8Bc5A");

var $6yhDy = parcelRequire("6yhDy");

var $52Vcw = parcelRequire("52Vcw");

var $6ypzr = parcelRequire("6ypzr");

var $abQXL = parcelRequire("abQXL");
const $f0fdda8951af3bde$export$87fe8079a4ed9766 = ({ taskList: taskList })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        // Need to check to see if there is anything in the backend to take that as source of truth
        // If there is nothing then use defaults
        // Check backend for flags that are marked as completed (true)
        // Carry over state from previous actions
        // Create Completed Actions
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedState = {};
        const { projectState: projectState } = getState();
        if (!projectState) return;
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.isOpen = true;
        updatedState.isDismissed = false;
        updatedState.quickstartStateProjectType = projectState.projectType;
        let backendVisibilityKeys = [];
        // Open QS Checklist as default state if state cannot be determined from the backend
        updatedState.visibility = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).reduce((acc, type)=>{
            acc[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        backendVisibilityKeys = Object.values((0, $8Bc5A.QUICKSTART_TYPE)).map((type)=>(0, $8Bc5A.getBackendVisibilityKey)(type));
        const backendState = await (0, $6yhDy.pollBackend)({
            keys: [
                (0, $8Bc5A.KEY_OPEN),
                (0, $8Bc5A.KEY_DISMISSED),
                (0, $8Bc5A.KEY_OPEN_TASK),
                (0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE),
                (0, $8Bc5A.KEY_JSW_ONBOARDING),
                ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks),
                ...backendVisibilityKeys
            ]
        });
        const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
        if (backendStateExists) {
            updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                    ...(0, $8Bc5A.allTasksExcludingJSMBusinessTasks)
                ].includes(key) && backendState[key] === true);
            Object.values((0, $8Bc5A.QUICKSTART_TYPE)).forEach((type)=>{
                // use new state if possible
                if ((0, $8Bc5A.getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, $8Bc5A.getBackendVisibilityKey)(type)];
                else if ((0, $8Bc5A.KEY_DISMISSED) in backendState && backendState[0, $8Bc5A.KEY_DISMISSED]) updatedState.visibility[type] = (0, $8Bc5A.QUICKSTART_UI_STATUS).DISMISSED;
                else if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, $8Bc5A.KEY_OPEN] ? (0, $8Bc5A.QUICKSTART_UI_STATUS).OPEN : (0, $8Bc5A.QUICKSTART_UI_STATUS).MINIMIZED;
            });
            if ((0, $8Bc5A.KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, $8Bc5A.KEY_DISMISSED];
            if ((0, $8Bc5A.KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, $8Bc5A.KEY_OPEN];
            if ((0, $8Bc5A.KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, $8Bc5A.KEY_OPEN_TASK];
            if ((0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, $8Bc5A.KEY_HAS_EVER_SEEN_ROUTE];
            if ((0, $8Bc5A.KEY_TASK_GROUP) in backendState) {
                updatedState.currentTaskGroupParent = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                updatedState.previousTaskGroupParents = // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                backendState[0, $8Bc5A.KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
            }
            if ((0, $8Bc5A.KEY_JSW_ONBOARDING) in backendState) {
                if (typeof backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] === 'object' && backendState[0, $8Bc5A.KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, $8Bc5A.KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, $8Bc5A.KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
            }
        }
        setState(updatedState);
        if (!(backendStateExists && (0, $8Bc5A.KEY_OPEN) in backendState)) try {
            const skipApplicationProperty = await (0, $6ypzr.getOnboardingSkipApplicationProperty)();
            if (skipApplicationProperty.quickstart) dispatch((0, $abQXL.nextSetChecklistIsDismissed)(true));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $52Vcw.fireAPIErrorAnalytics)(error, 'skipOnboarding');
        }
        setState({
            taskList: taskList
        });
        setState({
            isQuickstartLoaded: true
        });
    };

});

parcelRegister("dQPsy", function(module, exports) {

$parcel$export(module.exports, "nextSetChecklistItemSeen", () => $82a74350685dcd25$export$4eac017dcde0be8f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $1ftPQ = parcelRequire("1ftPQ");
const $82a74350685dcd25$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
        const hasSeenTaskId = (0, $8Bc5A.convertToHaveSeenItTask)(taskId);
        const { hasSeenTasks: hasSeenTasks } = getState();
        if (hasSeenTasks.includes(hasSeenTaskId)) return;
        setState({
            hasSeenTasks: [
                ...hasSeenTasks,
                hasSeenTaskId
            ]
        });
        (0, $1ftPQ.pushToBackend)({
            key: (0, $8Bc5A.convertToHaveSeenItTask)(taskId),
            value: true
        });
    };

});

parcelRegister("boV1S", function(module, exports) {

$parcel$export(module.exports, "nextAutoExpand", () => $35a410a5fb89f79b$export$3d24e97d30cfd09e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $8Bc5A = parcelRequire("8Bc5A");

var $984bX = parcelRequire("984bX");

var $4ji4w = parcelRequire("4ji4w");

var $cUGWT = parcelRequire("cUGWT");
const $35a410a5fb89f79b$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
        const hasNudgeToShowAfterNavigation = (0, $984bX.localStorageProvider)().get({
            accountId: (0, $8Bc5A.ACCOUNT_ID),
            key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK)
        });
        if (hasNudgeToShowAfterNavigation) return;
        const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks, currentTriggerForTaskGroupParent: currentTriggerForTaskGroupParent } = getState();
        if (!tasks) return;
        const { items: items } = tasks;
        if (// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        items.includes(openTask) && // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        !completedTaskList.includes(openTask)) return;
        const taskIdToExpand = (0, $4ji4w.getNextNonCompleteTask)(items, completedTaskList, openTask);
        if (taskIdToExpand === null) return;
        // If the openTask is the same as the currentTriggerForTaskGroupParent, we just returned back from a sub menu and don't need to auto open the next task
        if ((0, $4R6GH.fg)('jira_a11y_fix_returning_focus')) {
            if (openTask === currentTriggerForTaskGroupParent) return;
        }
        dispatch((0, $cUGWT.nextAutoOpenTask)(taskIdToExpand));
    };

});
parcelRegister("984bX", function(module, exports) {

$parcel$export(module.exports, "localStorageProvider", () => $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5);
$parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", () => $a6d0a6873aa6f7aa$export$f2666fae743fa5f);

var $eNf8a = parcelRequire("eNf8a");

var $jcw0u = parcelRequire("jcw0u");

var $8Bc5A = parcelRequire("8Bc5A");
const $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY = 1;
const $a6d0a6873aa6f7aa$var$DAY = 86400000;
const $a6d0a6873aa6f7aa$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
const $a6d0a6873aa6f7aa$var$getExpiryTime = ()=>{
    const now = Date.now();
    return now + $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY * $a6d0a6873aa6f7aa$var$DAY;
};
let $a6d0a6873aa6f7aa$var$localStorage;
const $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5 = ()=>{
    if ($a6d0a6873aa6f7aa$var$localStorage) return $a6d0a6873aa6f7aa$var$localStorage;
    const provider = (0, $eNf8a.createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
    try {
        provider.removeExpiredKeys();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $jcw0u.default)({
            meta: {
                id: 'localStorageProviderKeyRemoval',
                packageName: 'jiraOnboardingQuickstartCore'
            },
            error: e
        });
    }
    const get = ({ accountId: accountId, key: key })=>provider.get($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }));
    const set = ({ accountId: accountId, key: key, value: value })=>provider.set($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }), value, $a6d0a6873aa6f7aa$var$getExpiryTime());
    const remove = ({ accountId: accountId, key: key })=>provider.remove($a6d0a6873aa6f7aa$var$getKey({
            accountId: accountId,
            key: key
        }));
    $a6d0a6873aa6f7aa$var$localStorage = {
        provider: provider,
        remove: remove,
        get: get,
        set: set
    };
    return $a6d0a6873aa6f7aa$var$localStorage;
};
const $a6d0a6873aa6f7aa$export$f2666fae743fa5f = (value)=>{
    $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5().set({
        accountId: (0, $8Bc5A.ACCOUNT_ID),
        key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK),
        value: value
    });
};

});


parcelRegister("4Viq4", function(module, exports) {

$parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", () => $0d74d0b8a43d2c5f$export$6f336ccb6432fcd0);
// Special case for nudges that need to show after a navigation.
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8Bc5A = parcelRequire("8Bc5A");

var $984bX = parcelRequire("984bX");

var $lHcRB = parcelRequire("lHcRB");
const $0d74d0b8a43d2c5f$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
        const nudgeToShowAfterNavigationKeyPair = {
            accountId: (0, $8Bc5A.ACCOUNT_ID),
            key: (0, $8Bc5A.KEY_HAS_NAVIGATED_FROM_LINK)
        };
        const shouldShowNudge = (0, $984bX.localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
        if (shouldShowNudge) {
            dispatch((0, $lHcRB.setHasNudgeActive)(true));
            (0, $984bX.localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
        }
    };

});

parcelRegister("jIoq4", function(module, exports) {

$parcel$export(module.exports, "nextGetTasks", () => $034f263b888956c9$export$15d877e1f3abf489);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $ikZFc = parcelRequire("ikZFc");
const $034f263b888956c9$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState })=>{
        const { taskList: taskList } = getState();
        const tasks = (0, $ikZFc.getAllTasks)({
            ...props,
            taskList: taskList
        });
        setState({
            tasks: tasks
        });
    };

});
parcelRegister("ikZFc", function(module, exports) {

$parcel$export(module.exports, "getAllTasks", () => $cb6c1b1dc7b1b225$export$d1f442602a91e7cc);

var $6s1PB = parcelRequire("6s1PB");

var $c04PQ = parcelRequire("c04PQ");

var $4R6GH = parcelRequire("4R6GH");


var $ldyPw = parcelRequire("ldyPw");

var $jtI3q = parcelRequire("jtI3q");

var $8Bc5A = parcelRequire("8Bc5A");

var $1ffS1 = parcelRequire("1ffS1");

var $ieqoN = parcelRequire("ieqoN");

var $3Iaiu = parcelRequire("3Iaiu");

var $aHo1U = parcelRequire("aHo1U");

var $5yUqp = parcelRequire("5yUqp");

var $5zzQl = parcelRequire("5zzQl");

var $jJca1 = parcelRequire("jJca1");

var $d7Knl = parcelRequire("d7Knl");

var $8VfDj = parcelRequire("8VfDj");

var $pDX5d = parcelRequire("pDX5d");
const $cb6c1b1dc7b1b225$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_rt_quickstart_m1');
    if (variants.includes((0, $aHo1U.JSW).experiment.jswReverseTrial) && !expConfig.get('isEnabled', false)) {
        const { title: title, items: items } = taskList[taskGroupParent === (0, $8Bc5A.ROOT_TASK) ? (0, $8Bc5A.REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, $8Bc5A.REVERSE_TRIAL_ROOT_TASK];
        return {
            title: title,
            items: (0, $5zzQl.getTasks)(variants, taskVariants, items)
        };
    }
    const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, $8Bc5A.ROOT_TASK];
    return {
        title: title,
        items: (0, $5zzQl.getTasks)(variants, taskVariants, items)
    };
};
const $cb6c1b1dc7b1b225$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS, canEditPlans, premiumTrialOnSignup)=>{
    const variants = new Set();
    const isTmpScrumWithSprintPermission = mountedNudges.includes((0, $8Bc5A.BACKLOG_CREATE_SPRINT_NUDGE_ID));
    const isEligibleForKanbanTour = mountedNudges.includes((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112));
    if ((0, $c04PQ.isFedRamp)()) variants.add((0, $aHo1U.JSW).experience.fedRamp);
    if (premiumTrialOnSignup) {
        variants.add((0, $aHo1U.JSW).experiment.jswReverseTrial);
        (0, $6s1PB.expValEquals)('jira_rt_quickstart_m1', 'isEnabled', true) && variants.add((0, $aHo1U.JSW).experiment.rtQuickstartM1);
    }
    if (isCustomerTemplateProject) variants.add((0, $aHo1U.JSW).projectProperties.isCreatedFromCustomerTemplate);
    if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, $aHo1U.JSW).experiment.scrumOnboarding);
    if (isCrossProjectBoardToPlanUpsell) variants.add((0, $aHo1U.JSW).trait.crossProjectBoardToPlanUpsell);
    if (canEditPlans) variants.add((0, $aHo1U.JSW).permissions.hasPlanEditPermissions);
    if (isEligibleForKanbanTour || routeName !== 'software-boards') variants.add((0, $aHo1U.JSW).experience.kanbanOnboarding);
    if (isWizardSimplifyQS) variants.add((0, $aHo1U.JSW).experiment.wizard);
    if (canCreateProject === false) variants.add((0, $aHo1U.JSW).permissions.notCanCreateProject);
    if (projectState?.isNextGen) variants.add((0, $aHo1U.JSW).projectStyle.teamManaged);
    else variants.add((0, $aHo1U.JSW).projectStyle.companyManaged);
    if (projectState?.isProjectAdmin) variants.add((0, $aHo1U.JSW).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) {
        variants.add((0, $aHo1U.JSW).userRole.jiraAdmin);
        variants.add((0, $aHo1U.JSW).userRole.admin);
    }
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) {
        variants.add((0, $aHo1U.JSW).userRole.siteAdmin);
        variants.add((0, $aHo1U.JSW).userRole.admin);
    }
    if (projectState?.edition === (0, $ldyPw.FREE_EDITION)) variants.add((0, $aHo1U.JSW).edition.free);
    else if (projectState?.edition === (0, $ldyPw.STANDARD_EDITION)) variants.add((0, $aHo1U.JSW).edition.standard);
    else if (projectState?.edition === (0, $ldyPw.PREMIUM_EDITION)) variants.add((0, $aHo1U.JSW).edition.premium);
    if ((0, $1ffS1.isRoadmapRoute)(routeName)) variants.add((0, $aHo1U.JSW).route.softwareRoadmap);
    else if (routeName === 'software-backlog') variants.add((0, $aHo1U.JSW).route.softwareBacklog);
    else if (routeName === 'software-boards') variants.add((0, $aHo1U.JSW).route.softwareBoard);
    else if (routeName === 'software-list' || routeName === 'software-list-classic') variants.add((0, $aHo1U.JSW).route.softwareList);
    else if (routeName === 'project-settings-software-access') variants.add((0, $aHo1U.JSW).route.projectSettingsSoftwareAccess);
    else if (routeName === 'issue') variants.add((0, $aHo1U.JSW).route.issue);
    else if ((routeName === 'software-calendar' || routeName === 'software-calendar-classic') && (0, $4R6GH.fg)('software_calendar_quickstart_onboarding')) variants.add((0, $aHo1U.JSW).route.softwareCalendar);
    if (isEligibleToUpdateSitename) variants.add((0, $aHo1U.JSW).experiment.customizeSiteName);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: Array.from(variants.values()),
        taskVariants: (0, $aHo1U.JSW).taskVariants,
        taskList: (0, $aHo1U.JSW).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createJwmTasks = ({ projectState: projectState, taskGroupParent: taskGroupParent, taskList: taskList = (0, $5yUqp.JWM).taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5 })=>{
    const variants = [];
    variants.push((0, $5yUqp.JWM).experiments.projectTheming);
    if (isEligibleForTailoredOnboardingM2P5) return $cb6c1b1dc7b1b225$var$createTailoredOnboardingTasksM2P5({
        taskGroupParent: taskGroupParent,
        teamType: teamType
    });
    if (projectState?.isProjectAdmin) variants.push((0, $5yUqp.JWM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) variants.push((0, $5yUqp.JWM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) variants.push((0, $5yUqp.JWM).userRole.siteAdmin);
    if (projectState?.isSampleProject) variants.push((0, $5yUqp.JWM).experiments.isSampleProject);
    else variants.push((0, $5yUqp.JWM).experiments.isNotSampleProject);
    if (projectState?.isTrelloCrossflow) variants.push((0, $5yUqp.JWM).experiments.trelloCrossflow);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $5yUqp.JWM).taskVariants,
        taskList: taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createJsmTasks = (projectState, taskGroupParent)=>{
    const variants = [];
    variants.push((0, $3Iaiu.JSM).experiments.projectTheming);
    if (projectState?.isProjectAdmin) variants.push((0, $3Iaiu.JSM).userRole.projectAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).JIRA_ADMIN) variants.push((0, $3Iaiu.JSM).userRole.jiraAdmin);
    if (projectState?.userRole === (0, $ieqoN.USER_ROLE).SITE_ADMIN) variants.push((0, $3Iaiu.JSM).userRole.siteAdmin);
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $3Iaiu.JSM).taskVariants,
        taskList: (0, $3Iaiu.JSM).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$export$d9d83c8e96505820 = (taskGroupParent, teamType, features, isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban)=>{
    if ((0, $4R6GH.fg)('jira_tailored_onboarding_single_config')) {
        const variants = [];
        if (features?.hasBacklog) variants.push((0, $pDX5d.Feature).hasBacklog);
        if (features?.hasSprint) variants.push((0, $pDX5d.Feature).hasSprint);
        if (isEligibleForTailoredOnboardingM3) variants.push((0, $8VfDj.Experiment).tailoredOnboardingM3Eligible);
        if (isEligibleForTailoredOnboardingScrumAndSoftwareKanban) variants.push((0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible);
        if (teamType && (0, $jtI3q.isTailoredOnboardingWithScrumAndSoftwareKanbanTeamType)(teamType)) variants.push(`teamType.${teamType}`);
        else variants.push('teamType.everythingElse');
        return $cb6c1b1dc7b1b225$var$getTaskListItem({
            variants: variants,
            taskVariants: (0, $d7Knl.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskVariants,
            taskList: (0, $d7Knl.TAILORED_ONBOARDING_WITH_SINGLE_CONFIG).taskList,
            taskGroupParent: taskGroupParent
        });
    }
    // Following the same pattern as other configs and using an array here
    // but right now only one value(team type) will ever be in this array
    const variants = [];
    if (teamType && (0, $jtI3q.isTailoredOnboardingTailoredTeamType)(teamType)) variants.push(teamType);
    else variants.push('everythingElse');
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $d7Knl.TAILORED_ONBOARDING).getTaskVariants(teamType ?? 'everythingElse'),
        taskList: (0, $d7Knl.TAILORED_ONBOARDING).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$var$createTailoredOnboardingTasksM2P5 = ({ taskGroupParent: taskGroupParent, teamType: teamType })=>{
    const variants = [];
    if (teamType && (0, $jtI3q.isTailoredOnboardingM2P5TailoredTeamType)(teamType)) variants.push(teamType);
    else variants.push('everythingElse');
    return $cb6c1b1dc7b1b225$var$getTaskListItem({
        variants: variants,
        taskVariants: (0, $d7Knl.TAILORED_ONBOARDING_M2P5).getM2P5TaskVariants(teamType ?? 'everythingElse'),
        taskList: (0, $d7Knl.TAILORED_ONBOARDING_M2P5).taskList,
        taskGroupParent: taskGroupParent
    });
};
const $cb6c1b1dc7b1b225$export$d1f442602a91e7cc = ({ projectState: projectState, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isEligibleToUpdateSitename: isEligibleToUpdateSitename, isCustomerTemplateProject: isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS: isWizardSimplifyQS = false, canEditPlans: canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, taskList: taskList, teamType: teamType, isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5, isEligibleForTailoredOnboardingM3: isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban: isEligibleForTailoredOnboardingScrumAndSoftwareKanban, features: features })=>{
    if ((0, $jJca1.isJwmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJwmTasks({
        projectState: projectState,
        taskGroupParent: taskGroupParent,
        taskList: taskList,
        teamType: teamType,
        isEligibleForTailoredOnboardingM2P5: isEligibleForTailoredOnboardingM2P5
    });
    if ((0, $jJca1.isJsmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJsmTasks(projectState, taskGroupParent);
    // We cannot do these in the config itself as we need to fallback to createJswTasks for other users
    // And unlike previous QS experiments, we want to change the entire QS for these users so a new config makes sense over variants to the existing JSW one
    if (isEligibleForTailoredOnboardingM3 || isEligibleForTailoredOnboardingScrumAndSoftwareKanban) return $cb6c1b1dc7b1b225$export$d9d83c8e96505820(taskGroupParent, teamType, features, isEligibleForTailoredOnboardingM3, isEligibleForTailoredOnboardingScrumAndSoftwareKanban);
    return $cb6c1b1dc7b1b225$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, isWizardSimplifyQS, canEditPlans, premiumTrialOnSignup);
};

});
parcelRegister("jtI3q", function(module, exports) {

$parcel$export(module.exports, "isTailoredOnboardingTailoredTeamType", () => $606262a699c9299e$export$8ea98ac9729b7e09);
$parcel$export(module.exports, "isTailoredOnboardingWithScrumAndSoftwareKanbanTeamType", () => $606262a699c9299e$export$a40edd97e5cbfaa9);
$parcel$export(module.exports, "isTailoredOnboardingM2P5TailoredTeamType", () => $606262a699c9299e$export$26c385918d734203);

var $370Ye = parcelRequire("370Ye");
const $606262a699c9299e$export$8ea98ac9729b7e09 = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $370Ye.tailoredTeamTypes).includes(teamType);
};
const $606262a699c9299e$export$a40edd97e5cbfaa9 = (teamType)=>{
    return (0, $370Ye.tailoredTeamTypesWithSoftware).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    teamType);
};
const $606262a699c9299e$export$26c385918d734203 = (teamType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $370Ye.tailoredM2P5TeamTypes).includes(teamType);
};

});
parcelRegister("370Ye", function(module, exports) {

$parcel$export(module.exports, "tailoredTeamTypes", () => $06c84b7af2a23aee$export$a1fbb7d965e15a39);
$parcel$export(module.exports, "tailoredTeamTypesWithSoftware", () => $06c84b7af2a23aee$export$7e2d6cf3886ecaf7);
$parcel$export(module.exports, "tailoredM2P5TeamTypes", () => $06c84b7af2a23aee$export$52c5394d6e6cfcf3);

const $06c84b7af2a23aee$export$a1fbb7d965e15a39 = [
    (0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24),
    (0, $6784cbc7d62e5d7c$export$d7de553940261eba),
    (0, $6784cbc7d62e5d7c$export$e4824f74b9879164),
    (0, $6784cbc7d62e5d7c$export$4f3cb0844009af52),
    (0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d),
    (0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74),
    (0, $6784cbc7d62e5d7c$export$79685802e8ff1098)
];
const $06c84b7af2a23aee$export$7e2d6cf3886ecaf7 = [
    ...$06c84b7af2a23aee$export$a1fbb7d965e15a39,
    (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)
];
const $06c84b7af2a23aee$export$52c5394d6e6cfcf3 = [
    (0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24),
    (0, $6784cbc7d62e5d7c$export$d7de553940261eba),
    (0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d),
    (0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74),
    (0, $6784cbc7d62e5d7c$export$79685802e8ff1098),
    (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)
];

});


parcelRegister("1ffS1", function(module, exports) {

$parcel$export(module.exports, "isRoadmapRoute", () => $ee93e5dd18635f6d$export$d1fa67c1ffb68871);
const $ee93e5dd18635f6d$export$d1fa67c1ffb68871 = (routeName)=>{
    if (routeName === undefined) return false;
    return routeName === 'software-timeline' || routeName === 'software-timeline-classic';
};

});

parcelRegister("ieqoN", function(module, exports) {

$parcel$export(module.exports, "USER_ROLE", () => $353950c3dd35bbc6$export$8eeb199b23203523);
const $353950c3dd35bbc6$export$8eeb199b23203523 = {
    END_USER: 'end-user',
    SITE_ADMIN: 'site-admin',
    JIRA_ADMIN: 'jira-admin'
};

});

parcelRegister("3Iaiu", function(module, exports) {

$parcel$export(module.exports, "JSM", () => $56a077523ddf70fb$export$63f289f2da861d35);

var $58IQc = parcelRequire("58IQc");
const $56a077523ddf70fb$export$63f289f2da861d35 = {
    taskList: (0, $58IQc.JSM_TASK_LIST),
    taskVariants: (0, $58IQc.JSM_TASK_VARIANTS),
    userRole: (0, $58IQc.UserRole),
    experiments: (0, $58IQc.Experiments)
};

});
parcelRegister("58IQc", function(module, exports) {

$parcel$export(module.exports, "JSM_TASK_LIST", () => $3c13225c81ad4b5c$export$6c6c561944d49bcb);
$parcel$export(module.exports, "Experiments", () => $3c13225c81ad4b5c$export$c8d6ffd15214553a);
$parcel$export(module.exports, "UserRole", () => $3c13225c81ad4b5c$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "JSM_TASK_VARIANTS", () => $3c13225c81ad4b5c$export$5b68aef408c932d9);

var $8Bc5A = parcelRequire("8Bc5A");

var $kTSRm = parcelRequire("kTSRm");
const $3c13225c81ad4b5c$export$6c6c561944d49bcb = Object.freeze({
    root: {
        title: (0, $kTSRm.messages).rootTitle,
        items: [
            (0, $8Bc5A.JSM_REVIEW_YOUR_CHANNELS_TASK),
            (0, $8Bc5A.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
            (0, $8Bc5A.JSM_INVITE_YOUR_TEAM_TASK)
        ]
    }
});
const $3c13225c81ad4b5c$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming'
};
const $3c13225c81ad4b5c$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};
const $3c13225c81ad4b5c$export$5b68aef408c932d9 = {
    [(0, $8Bc5A.JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
        position: {
            default: 1
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JSM_INVITE_YOUR_TEAM_TASK)]: {
        position: {
            default: 2
        },
        visibility: {
            default: true
        }
    }
};

});
parcelRegister("kTSRm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f1f6142c4170f38e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f1f6142c4170f38e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});



parcelRegister("aHo1U", function(module, exports) {

$parcel$export(module.exports, "JSW", () => $563027753d017a60$export$4cfe6e52f2e72a54);

var $8VfDj = parcelRequire("8VfDj");
const $563027753d017a60$export$4cfe6e52f2e72a54 = {
    taskList: (0, $8VfDj.TASK_LIST),
    taskVariants: (0, $8VfDj.TASK_VARIANTS),
    experiment: (0, $8VfDj.Experiment),
    experience: (0, $8VfDj.Experience),
    projectStyle: (0, $8VfDj.ProjectStyle),
    projectProperties: (0, $8VfDj.ProjectProperties),
    userRole: (0, $8VfDj.UserRole),
    edition: (0, $8VfDj.Edition),
    route: (0, $8VfDj.Route),
    permissions: (0, $8VfDj.Permissions),
    trait: (0, $8VfDj.Trait)
};

});
parcelRegister("8VfDj", function(module, exports) {

$parcel$export(module.exports, "Experiment", () => $ea3903bb15047c3b$export$4e0ab25c8a7e4009);
$parcel$export(module.exports, "Experience", () => $ea3903bb15047c3b$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "ProjectStyle", () => $ea3903bb15047c3b$export$1f66f9f05afa05a8);
$parcel$export(module.exports, "ProjectProperties", () => $ea3903bb15047c3b$export$543c19ee8dba9252);
$parcel$export(module.exports, "UserRole", () => $ea3903bb15047c3b$export$eb3485a690c2f0b8);
$parcel$export(module.exports, "Edition", () => $ea3903bb15047c3b$export$6f4a0f769e61929);
$parcel$export(module.exports, "Route", () => $ea3903bb15047c3b$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Permissions", () => $ea3903bb15047c3b$export$2d41982586bbb6be);
$parcel$export(module.exports, "Trait", () => $ea3903bb15047c3b$export$2d08cfa40d69142e);
$parcel$export(module.exports, "TASK_LIST", () => $ea3903bb15047c3b$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $ea3903bb15047c3b$export$36f4d47dfe11b613);

var $8Bc5A = parcelRequire("8Bc5A");

var $ciLFO = parcelRequire("ciLFO");
const $ea3903bb15047c3b$export$4e0ab25c8a7e4009 = {
    scrumOnboarding: 'experiment.scrumOnboarding',
    customizeSiteName: 'experiment.customizeSiteName',
    jswReverseTrial: 'experiment.jswReverseTrial',
    rtQuickstartM1: 'experiment.rtQuickstartM1',
    wizard: 'experiment.wizard',
    tailoredOnboardingM3Eligible: 'experiment.tailoredOnboardingM3Eligible',
    tailoredOnboardingScrumAndSoftwareKanbanEligible: 'experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible'
};
const $ea3903bb15047c3b$export$c90b54e658fc4d7c = {
    kanbanOnboarding: 'experience.kanbanOnboarding',
    fedRamp: 'experience.fedRamp'
};
const $ea3903bb15047c3b$export$1f66f9f05afa05a8 = {
    teamManaged: 'projectStyle.teamManaged',
    companyManaged: 'projectStyle.companyManaged'
};
const $ea3903bb15047c3b$export$543c19ee8dba9252 = {
    isCreatedFromCustomerTemplate: 'projectProperties.isCreatedFromCustomerTemplate'
};
const $ea3903bb15047c3b$export$eb3485a690c2f0b8 = {
    siteAdmin: 'userRole.siteAdmin',
    jiraAdmin: 'userRole.jiraAdmin',
    admin: 'userRole.admin',
    projectAdmin: 'userRole.projectAdmin'
};
const $ea3903bb15047c3b$export$6f4a0f769e61929 = {
    free: 'productEdition.free',
    standard: 'productEdition.standard',
    premium: 'productEdition.premium'
};
const $ea3903bb15047c3b$export$e7b0ac011bb776c6 = {
    softwareRoadmap: 'route.softwareRoadmap',
    softwareBacklog: 'route.softwareBacklog',
    softwareBoard: 'route.softwareBoard',
    softwareList: 'route.softwareList',
    projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
    issue: 'route.issue',
    softwareCalendar: 'route.softwareCalendar'
};
const $ea3903bb15047c3b$export$2d41982586bbb6be = {
    notCanCreateProject: 'permissions.notCanCreateProject',
    hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
};
const $ea3903bb15047c3b$export$2d08cfa40d69142e = {
    crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
};
const $ea3903bb15047c3b$var$DEFAULT_TASK_LIST = [
    (0, $8Bc5A.ADD_COLUMNS_TASK),
    (0, $8Bc5A.CREATE_PROJECT_TASK),
    (0, $8Bc5A.CREATE_ISSUE_TASK),
    (0, $8Bc5A.CREATE_ISSUE_TASK_SIMPLIFIED),
    (0, $8Bc5A.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
    (0, $8Bc5A.INVITE_TEAMMATES_TASK),
    (0, $8Bc5A.INVITE_TEAMMATES_VIDEO_TASK),
    (0, $8Bc5A.CAPTURE_INTEGRATIONS_TASK),
    (0, $8Bc5A.FIND_HELP_TASK),
    (0, $8Bc5A.SET_UP_BOARD_TASK),
    (0, $8Bc5A.GET_MOBILE_APP_TASK),
    (0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK),
    (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK),
    (0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
    (0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK),
    (0, $8Bc5A.MAP_OUT_YOUR_PROJECT_GOALS_TASK),
    (0, $8Bc5A.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
    (0, $8Bc5A.MONITOR_MANAGE_RISK_TASK),
    (0, $8Bc5A.SCRUM_ONBOARDING_TASK),
    (0, $8Bc5A.CUSTOMIZE_SITE_NAME_TASK),
    (0, $8Bc5A.GET_TO_KNOW_YOUR_TEMPLATE_TASK),
    (0, $8Bc5A.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
    (0, $8Bc5A.GET_STARTED_LIST_TASK),
    (0, $8Bc5A.CALENDAR_VIEW_TASK)
];
const $ea3903bb15047c3b$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $ciLFO.messages).rootTitle,
        items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
    },
    reverseTrialRoot: {
        title: (0, $ciLFO.messages).reverseTrialRootTitle,
        items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
    },
    [(0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)]: {
        title: (0, $ciLFO.messages).reverseTrialCardTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.CHANGE_CONTROL_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        title: (0, $ciLFO.messages).premiumPlanTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.CHANGE_CONTROL_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK)
        ]
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        title: (0, $ciLFO.messages).premiumPlanTitle,
        items: [
            (0, $8Bc5A.ADVANCED_ROADMAPS_TASK),
            (0, $8Bc5A.AUTOMATIONS_TASK)
        ]
    },
    [(0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK)]: {
        title: (0, $ciLFO.messages).standardPlanTitle,
        items: [
            (0, $8Bc5A.AUTOMATIONS_TASK),
            (0, $8Bc5A.USER_MANAGEMENT_TASK),
            (0, $8Bc5A.SITE_ADMINISTRATIONS_TASK)
        ]
    }
});
const $ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS = {
    [(0, $8Bc5A.PREMIUM_REVERSE_TRIAL_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.rtQuickstartM1,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    // This condition needs to be the opposite condition to PREMIUM_EDITION_OVERVIEW_TASK
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.STANDARD_EDITION_OVERVIEW_TASK)]: {
        position: {
            default: 900
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.ADVANCED_ROADMAPS_TASK)]: {
        position: {
            default: 105
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.AUTOMATIONS_TASK)]: {
        position: {
            default: 110
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                        $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.USER_MANAGEMENT_TASK)]: {
        position: {
            default: 115
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CHANGE_CONTROL_TASK)]: {
        position: {
            default: 120
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.SITE_ADMINISTRATIONS_TASK)]: {
        position: {
            default: 125
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $ea3903bb15047c3b$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS = {
    [(0, $8Bc5A.GET_TO_KNOW_YOUR_TEMPLATE_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$543c19ee8dba9252.isCreatedFromCustomerTemplate,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};
const $ea3903bb15047c3b$export$36f4d47dfe11b613 = {
    ...$ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS,
    ...$ea3903bb15047c3b$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS,
    [(0, $8Bc5A.CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$543c19ee8dba9252.isCreatedFromCustomerTemplate
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CUSTOMIZE_SITE_NAME_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.customizeSiteName
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CALENDAR_VIEW_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    value: true,
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareCalendar
                    ]
                }
            ]
        }
    },
    [(0, $8Bc5A.SCRUM_ONBOARDING_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.scrumOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBacklog
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.MAP_OUT_YOUR_PROJECT_GOALS_TASK)]: {
        position: {
            default: 150
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)]: {
        position: {
            default: 151
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.MONITOR_MANAGE_RISK_TASK)]: {
        position: {
            default: 152
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.SET_UP_BOARD_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_ISSUE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_ISSUE_TASK_SIMPLIFIED)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.ADD_COLUMNS_TASK)]: {
        position: {
            default: 310
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 320
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK)]: {
        position: {
            default: 350
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.INVITE_TEAMMATES_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.INVITE_TEAMMATES_VIDEO_TASK)]: {
        position: {
            default: 400,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: 600
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.CAPTURE_INTEGRATIONS_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_MOBILE_APP_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.FIND_HELP_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                    ],
                    value: false
                },
                {
                    condition: [
                        $ea3903bb15047c3b$export$4e0ab25c8a7e4009.wizard,
                        $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                        $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                    ],
                    value: false
                }
            ]
        }
    }
};

});
parcelRegister("ciLFO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $609e253829546460$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $609e253829546460$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
        "defaultMessage": "Quickstart"
    },
    premiumPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
        "defaultMessage": "Included in your Premium plan"
    },
    standardPlanTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
        "defaultMessage": "Your Standard plan"
    },
    reverseTrialRootTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
        "defaultMessage": "Your 30-day Premium trial"
    },
    reverseTrialCardTitle: {
        "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
        "defaultMessage": "Included in your Premium trial"
    }
});

});



parcelRegister("5yUqp", function(module, exports) {

$parcel$export(module.exports, "JWM", () => $80382801c7786de6$export$3ff26c80cb588e12);

var $82B5j = parcelRequire("82B5j");

var $8jC8d = parcelRequire("8jC8d");

var $5PFhq = parcelRequire("5PFhq");
const $80382801c7786de6$export$3ff26c80cb588e12 = {
    taskList: (0, $82B5j.TASK_LIST),
    taskVariants: (0, $82B5j.TASK_VARIANTS),
    userRole: (0, $5PFhq.UserRole),
    experiments: (0, $8jC8d.Experiments)
};

});
parcelRegister("82B5j", function(module, exports) {

$parcel$export(module.exports, "TASK_LIST", () => $3b1179694682c8c8$export$601c8c0f45aeb0a0);
$parcel$export(module.exports, "TASK_VARIANTS", () => $3b1179694682c8c8$export$36f4d47dfe11b613);

var $8Bc5A = parcelRequire("8Bc5A");

var $8jC8d = parcelRequire("8jC8d");

var $aQMWP = parcelRequire("aQMWP");

var $5PFhq = parcelRequire("5PFhq");
const $3b1179694682c8c8$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $aQMWP.messages).rootTitle,
        items: [
            (0, $8Bc5A.JWM_CREATE_PROJECT_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
            (0, $8Bc5A.JWM_SUMMARY_AND_REPORTS_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
            (0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
            (0, $8Bc5A.JWM_CREATE_SAMPLE_PROJECT_TASK),
            (0, $8Bc5A.JWM_PROJECT_SUMMARY_TASK),
            (0, $8Bc5A.GET_STARTED_LIST_TASK),
            (0, $8Bc5A.JWM_CALENDAR_TASK),
            (0, $8Bc5A.JWM_TIMELINE_TASK),
            (0, $8Bc5A.JWM_BUILD_FORM_TASK),
            (0, $8Bc5A.JWM_BACKGROUND_COLOR_TASK),
            (0, $8Bc5A.JWM_FEEDBACK_TASK),
            (0, $8Bc5A.JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
            (0, $8Bc5A.JWM_SHARE_PROJECT_TASK),
            (0, $8Bc5A.JWM_CREATE_YOUR_OWN_PROJECT_TASK)
        ]
    }
});
const $3b1179694682c8c8$var$OPS_TAILORED_ONBOARDING_TASK_VARIANTS = {
    [(0, $8Bc5A.OPS_JTBD_3_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_3_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_3_PAGES)]: {
        position: {
            default: 300
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_LIST)]: {
        position: {
            default: 400
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_CALENDAR)]: {
        position: {
            default: 500
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_TIMELINE)]: {
        position: {
            default: 600
        }
    },
    [(0, $8Bc5A.OPS_JTBD_4_SUMMARY)]: {
        position: {
            default: 700
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_TIMELINE)]: {
        position: {
            default: 900
        }
    },
    [(0, $8Bc5A.OPS_JTBD_5_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $8Bc5A.OPS_JTBD_7_LIST)]: {
        position: {
            default: 1100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_7_CALENDAR)]: {
        position: {
            default: 1200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_BOARD)]: {
        position: {
            default: 1300
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_FORMS)]: {
        position: {
            default: 1400
        }
    },
    [(0, $8Bc5A.OPS_JTBD_2_SUMMARY)]: {
        position: {
            default: 1500
        }
    },
    [(0, $8Bc5A.OPS_JTBD_1_LIST)]: {
        position: {
            default: 1600
        }
    },
    [(0, $8Bc5A.OPS_JTBD_6_PAGES)]: {
        position: {
            default: 1700
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_TIMELINE)]: {
        position: {
            default: 1900
        }
    },
    [(0, $8Bc5A.OPS_JTBD_0_PAGES)]: {
        position: {
            default: 2000
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 2100
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 2200
        }
    },
    [(0, $8Bc5A.OPS_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2300
        }
    }
};
const $3b1179694682c8c8$var$MKT_TAILORED_ONBOARDING_TASK_VARIANTS = {
    [(0, $8Bc5A.MKT_JTBD_1_LIST)]: {
        position: {
            default: 100
        }
    },
    [(0, $8Bc5A.MKT_JTBD_1_CALENDAR)]: {
        position: {
            default: 200
        }
    },
    [(0, $8Bc5A.MKT_JTBD_1_TIMELINE)]: {
        position: {
            default: 300
        }
    },
    [(0, $8Bc5A.MKT_JTBD_2_CALENDAR)]: {
        position: {
            default: 400
        }
    },
    [(0, $8Bc5A.MKT_JTBD_2_PAGES)]: {
        position: {
            default: 500
        }
    },
    [(0, $8Bc5A.MKT_JTBD_3_PAGES)]: {
        position: {
            default: 600
        }
    },
    [(0, $8Bc5A.MKT_JTBD_3_TIMELINE)]: {
        position: {
            default: 700
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_LIST)]: {
        position: {
            default: 800
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_SUMMARY)]: {
        position: {
            default: 900
        }
    },
    [(0, $8Bc5A.MKT_JTBD_4_PAGES)]: {
        position: {
            default: 1000
        }
    },
    [(0, $8Bc5A.MKT_JTBD_5_TIMELINE)]: {
        position: {
            default: 1100
        }
    },
    [(0, $8Bc5A.MKT_JTBD_5_SUMMARY)]: {
        position: {
            default: 1200
        }
    },
    [(0, $8Bc5A.MKT_JTBD_6_FORMS)]: {
        position: {
            default: 1300
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_LIST)]: {
        position: {
            default: 1400
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_CALENDAR)]: {
        position: {
            default: 1500
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_TIMELINE)]: {
        position: {
            default: 1600
        }
    },
    [(0, $8Bc5A.MKT_JTBD_0_SUMMARY)]: {
        position: {
            default: 1700
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_LIST)]: {
        position: {
            default: 1800
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_BOARD)]: {
        position: {
            default: 1900
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_PROJECT)]: {
        position: {
            default: 2000
        }
    },
    [(0, $8Bc5A.MKT_JTBD_DEFAULT_INVITES)]: {
        position: {
            default: 2100
        }
    }
};
const $3b1179694682c8c8$export$36f4d47dfe11b613 = {
    ...$3b1179694682c8c8$var$OPS_TAILORED_ONBOARDING_TASK_VARIANTS,
    ...$3b1179694682c8c8$var$MKT_TAILORED_ONBOARDING_TASK_VARIANTS,
    [(0, $8Bc5A.JWM_CREATE_PROJECT_TASK)]: {
        position: {
            default: 0
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
        position: {
            default: 15
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 40
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_PROJECT_SUMMARY_TASK)]: {
        position: {
            default: 50
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.GET_STARTED_LIST_TASK)]: {
        position: {
            default: 100
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CALENDAR_TASK)]: {
        position: {
            default: 200
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TIMELINE_TASK)]: {
        position: {
            default: 300
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_BUILD_FORM_TASK)]: {
        position: {
            default: 400
        },
        visibility: {
            default: true
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
        position: {
            default: 425
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_SUMMARY_AND_REPORTS_TASK)]: {
        position: {
            default: 450
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_BACKGROUND_COLOR_TASK)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).projectTheming,
                        (0, $5PFhq.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_SHARE_PROJECT_TASK)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
        position: {
            default: 650
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isNotSampleProject,
                        (0, $8jC8d.Experiments).trelloCrossflow,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_FEEDBACK_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: true,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).trelloCrossflow
                    ],
                    value: false
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
        position: {
            default: 700
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
        position: {
            default: 800
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).jiraAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).siteAdmin
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8jC8d.Experiments).isSampleProject,
                        (0, $5PFhq.UserRole).projectAdmin
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("8jC8d", function(module, exports) {

$parcel$export(module.exports, "Experiments", () => $6cd173da51fb2ca8$export$c8d6ffd15214553a);
const $6cd173da51fb2ca8$export$c8d6ffd15214553a = {
    projectTheming: 'projectTheming',
    isSampleProject: 'isSampleProject',
    isNotSampleProject: 'isNotSampleProject',
    trelloCrossflow: 'trelloCrossflow'
};

});

parcelRegister("aQMWP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $40755a70921f89dd$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $40755a70921f89dd$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("5PFhq", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $637dacd99a3a1727$export$eb3485a690c2f0b8);
const $637dacd99a3a1727$export$eb3485a690c2f0b8 = {
    projectAdmin: 'projectAdmin',
    jiraAdmin: 'jiraAdmin',
    siteAdmin: 'siteAdmin'
};

});



parcelRegister("5zzQl", function(module, exports) {

$parcel$export(module.exports, "getTasks", () => $f17c108f7b3045ad$export$20b82b4a32771893);

var $fNtu3 = parcelRequire("fNtu3");
const $f17c108f7b3045ad$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, $fNtu3.getConditional)(visibility, variants) : true;
const $f17c108f7b3045ad$var$getTaskPosition = (variants, position)=>(0, $fNtu3.getConditional)(position, variants);
const $f17c108f7b3045ad$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$f17c108f7b3045ad$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskA].position) - $f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskB].position));

});
parcelRegister("fNtu3", function(module, exports) {

$parcel$export(module.exports, "getConditional", () => $8978a3b25f57d9ac$export$fe3161cde0106bba);
const $8978a3b25f57d9ac$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
    if (conditions === undefined) return defaultValue;
    const variantsIncludesCondition = (c)=>variants.includes(c);
    const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
    return conditionObj ? conditionObj.value : defaultValue;
};

});


parcelRegister("jJca1", function(module, exports) {

$parcel$export(module.exports, "isJwmProject", () => $6249819f9bc2846f$export$ea2e5a5c1a1a6748);
$parcel$export(module.exports, "isJsmProject", () => $6249819f9bc2846f$export$a972ed853ed1d469);

var $2vSU6 = parcelRequire("2vSU6");
const $6249819f9bc2846f$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, $2vSU6.CORE_PROJECT);
const $6249819f9bc2846f$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);

});

parcelRegister("d7Knl", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING", () => $98ba598c6688dfac$export$861e712b5b639c2a);
$parcel$export(module.exports, "TAILORED_ONBOARDING_WITH_SINGLE_CONFIG", () => $98ba598c6688dfac$export$83849aa73c0a20db);
$parcel$export(module.exports, "TAILORED_ONBOARDING_M2P5", () => $98ba598c6688dfac$export$eb17ad7838835d2a);


var $8Bc5A = parcelRequire("8Bc5A");

var $57ZKw = parcelRequire("57ZKw");

var $i2O9c = parcelRequire("i2O9c");

var $643hq = parcelRequire("643hq");

var $2Ld7w = parcelRequire("2Ld7w");

var $1bW8Q = parcelRequire("1bW8Q");

var $9mlnS = parcelRequire("9mlnS");

var $aRLWM = parcelRequire("aRLWM");

var $8oUbS = parcelRequire("8oUbS");

var $f4rKN = parcelRequire("f4rKN");

var $3YqPl = parcelRequire("3YqPl");

var $xk58e = parcelRequire("xk58e");
const $98ba598c6688dfac$export$601c8c0f45aeb0a0 = Object.freeze({
    root: {
        title: (0, $57ZKw.messages).rootTitle,
        items: [
            (0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY),
            (0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR),
            (0, $8Bc5A.TAILORED_ONBOARDING_LIST),
            (0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE),
            (0, $8Bc5A.TAILORED_ONBOARDING_PAGES),
            (0, $8Bc5A.TAILORED_ONBOARDING_FORM),
            (0, $8Bc5A.TAILORED_ONBOARDING_INVITE),
            (0, $8Bc5A.TAILORED_ONBOARDING_BOARD)
        ]
    }
});
const $98ba598c6688dfac$export$36f4d47dfe11b613 = {
    ...(0, $643hq.PRODUCT_MANAGEMENT_VARIANTS),
    ...(0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS),
    ...(0, $2Ld7w.DESIGN_VARIANTS),
    ...(0, $1bW8Q.IT_SUPPORT_VARIANTS),
    ...(0, $9mlnS.OTHER_PERSONAL_VARIANTS),
    ...(0, $aRLWM.MARKETING_VARIANTS),
    ...(0, $8oUbS.OPERATIONS_VARIANTS),
    ...(0, $f4rKN.EVERYTHING_ELSE_VARIANTS)
};
const $98ba598c6688dfac$var$getTaskVariants = (teamType)=>{
    switch(teamType){
        case 0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74:
            return 0, $643hq.PRODUCT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$79685802e8ff1098:
            return 0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24:
            return 0, $2Ld7w.DESIGN_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$d7de553940261eba:
            return 0, $1bW8Q.IT_SUPPORT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d:
            return 0, $9mlnS.OTHER_PERSONAL_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$e4824f74b9879164:
            return 0, $aRLWM.MARKETING_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$4f3cb0844009af52:
            return 0, $8oUbS.OPERATIONS_VARIANTS;
        default:
            return 0, $f4rKN.EVERYTHING_ELSE_VARIANTS;
    }
};
const $98ba598c6688dfac$export$861e712b5b639c2a = {
    taskList: $98ba598c6688dfac$export$601c8c0f45aeb0a0,
    getTaskVariants: $98ba598c6688dfac$var$getTaskVariants
};
const $98ba598c6688dfac$export$2757f7b23d120b9b = Object.freeze({
    root: {
        title: (0, $57ZKw.messages).rootTitle,
        items: [
            (0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY),
            (0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR),
            (0, $8Bc5A.TAILORED_ONBOARDING_LIST),
            (0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE),
            (0, $8Bc5A.TAILORED_ONBOARDING_PAGES),
            (0, $8Bc5A.TAILORED_ONBOARDING_FORM),
            (0, $8Bc5A.TAILORED_ONBOARDING_INVITE),
            (0, $8Bc5A.TAILORED_ONBOARDING_BOARD),
            (0, $8Bc5A.TAILORED_ONBOARDING_BACKLOG),
            (0, $8Bc5A.TAILORED_ONBOARDING_CODE)
        ]
    }
});
const $98ba598c6688dfac$export$83849aa73c0a20db = {
    taskList: $98ba598c6688dfac$export$2757f7b23d120b9b,
    taskVariants: (0, $xk58e.TAILORED_ONBOARDING_SINGLE_CONFIG)
};
const $98ba598c6688dfac$export$fd94bb9b6d992528 = Object.freeze({
    root: {
        title: (0, $57ZKw.messages).rootTitle,
        items: [
            (0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY),
            (0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR),
            (0, $8Bc5A.TAILORED_ONBOARDING_LIST),
            (0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE),
            (0, $8Bc5A.TAILORED_ONBOARDING_PAGES),
            (0, $8Bc5A.TAILORED_ONBOARDING_FORM),
            (0, $8Bc5A.TAILORED_ONBOARDING_INVITE),
            (0, $8Bc5A.TAILORED_ONBOARDING_BOARD)
        ]
    }
});
const $98ba598c6688dfac$export$be9c097e18825d4c = {
    ...(0, $643hq.PRODUCT_MANAGEMENT_VARIANTS),
    ...(0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS),
    ...(0, $2Ld7w.DESIGN_VARIANTS),
    ...(0, $1bW8Q.IT_SUPPORT_VARIANTS),
    ...(0, $3YqPl.SOFTWARE_VARIANTS),
    ...(0, $9mlnS.OTHER_PERSONAL_VARIANTS),
    ...(0, $f4rKN.EVERYTHING_ELSE_VARIANTS)
};
const $98ba598c6688dfac$export$3c409334669aec75 = (teamType)=>{
    switch(teamType){
        case 0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74:
            return 0, $643hq.PRODUCT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$79685802e8ff1098:
            return 0, $i2O9c.PROJECT_MANAGEMENT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24:
            return 0, $2Ld7w.DESIGN_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$d7de553940261eba:
            return 0, $1bW8Q.IT_SUPPORT_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d:
            return 0, $9mlnS.OTHER_PERSONAL_VARIANTS;
        case 0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b:
            return 0, $3YqPl.SOFTWARE_VARIANTS;
        default:
            return 0, $f4rKN.EVERYTHING_ELSE_VARIANTS;
    }
};
const $98ba598c6688dfac$export$eb17ad7838835d2a = {
    taskList: $98ba598c6688dfac$export$fd94bb9b6d992528,
    getM2P5TaskVariants: $98ba598c6688dfac$export$3c409334669aec75
};

});
parcelRegister("57ZKw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b241f4df6ba82218$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b241f4df6ba82218$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rootTitle: {
        "id": "software-onboarding-quickstart.services.tasks.config.tailored-onboarding.root-title.no-translate",
        "defaultMessage": "Quickstart"
    }
});

});

parcelRegister("i2O9c", function(module, exports) {

$parcel$export(module.exports, "PROJECT_MANAGEMENT_VARIANTS", () => $c81c85368d94bebb$export$bdd338c80f8962df);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $c81c85368d94bebb$export$bdd338c80f8962df = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).projectManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});
parcelRegister("pDX5d", function(module, exports) {

$parcel$export(module.exports, "TeamType", () => $c47e1ea5de95ecc4$export$26bc40b960693765);
$parcel$export(module.exports, "TeamTypeWithPrefix", () => $c47e1ea5de95ecc4$export$668a7c1cbabc62a);
$parcel$export(module.exports, "Feature", () => $c47e1ea5de95ecc4$export$6e91cf7616333d5);

const $c47e1ea5de95ecc4$export$26bc40b960693765 = {
    productManagement: (0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74),
    projectManagement: (0, $6784cbc7d62e5d7c$export$79685802e8ff1098),
    design: (0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24),
    itSupport: (0, $6784cbc7d62e5d7c$export$d7de553940261eba),
    otherPersonal: (0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d),
    marketing: (0, $6784cbc7d62e5d7c$export$e4824f74b9879164),
    operations: (0, $6784cbc7d62e5d7c$export$4f3cb0844009af52),
    software: (0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b),
    // Fallback team type config used for team types we aren't catering for e.g. Data science
    // and also used if the team type is unexpected/unknown
    everythingElse: 'everythingElse'
};
const $c47e1ea5de95ecc4$export$668a7c1cbabc62a = {
    productManagement: `teamType.${(0, $6784cbc7d62e5d7c$export$4f54a09a24fd1d74)}`,
    projectManagement: `teamType.${(0, $6784cbc7d62e5d7c$export$79685802e8ff1098)}`,
    design: `teamType.${(0, $6784cbc7d62e5d7c$export$e5c438b7501b5a24)}`,
    itSupport: `teamType.${(0, $6784cbc7d62e5d7c$export$d7de553940261eba)}`,
    otherPersonal: `teamType.${(0, $6784cbc7d62e5d7c$export$cbc0e551d91a692d)}`,
    marketing: `teamType.${(0, $6784cbc7d62e5d7c$export$e4824f74b9879164)}`,
    operations: `teamType.${(0, $6784cbc7d62e5d7c$export$4f3cb0844009af52)}`,
    software: `teamType.${(0, $6784cbc7d62e5d7c$export$b8b1ac856ba1434b)}`,
    // Fallback team type config used for team types we aren't catering for e.g. Data science
    // and also used if the team type is unexpected/unknown
    everythingElse: 'teamType.everythingElse'
};
const $c47e1ea5de95ecc4$export$6e91cf7616333d5 = {
    hasBacklog: 'feature.hasBacklog',
    hasSprint: 'feature.hasSprint'
};

});


parcelRegister("643hq", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_MANAGEMENT_VARIANTS", () => $fed1dddbfb0b30cf$export$b07ea6a2d29f9c08);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $fed1dddbfb0b30cf$export$b07ea6a2d29f9c08 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).productManagement
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("2Ld7w", function(module, exports) {

$parcel$export(module.exports, "DESIGN_VARIANTS", () => $d62d711ad5ddd92f$export$a3c4cd8e420f13a);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $d62d711ad5ddd92f$export$a3c4cd8e420f13a = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).design
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("1bW8Q", function(module, exports) {

$parcel$export(module.exports, "IT_SUPPORT_VARIANTS", () => $09c03dfb484f3e93$export$a25e809b52945082);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $09c03dfb484f3e93$export$a25e809b52945082 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).itSupport
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("9mlnS", function(module, exports) {

$parcel$export(module.exports, "OTHER_PERSONAL_VARIANTS", () => $6398fc5437bfee58$export$916be3c140ae8c0);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $6398fc5437bfee58$export$916be3c140ae8c0 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).otherPersonal
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("aRLWM", function(module, exports) {

$parcel$export(module.exports, "MARKETING_VARIANTS", () => $ca6dac271f81ec57$export$5580e2b7ba40f572);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $ca6dac271f81ec57$export$5580e2b7ba40f572 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).marketing
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("8oUbS", function(module, exports) {

$parcel$export(module.exports, "OPERATIONS_VARIANTS", () => $7ebba77bc28e7956$export$cd166ee66dc078f4);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $7ebba77bc28e7956$export$cd166ee66dc078f4 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 600
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).operations
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("f4rKN", function(module, exports) {

$parcel$export(module.exports, "EVERYTHING_ELSE_VARIANTS", () => $dc653043c34d0d58$export$7a0daeb069f34de3);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $dc653043c34d0d58$export$7a0daeb069f34de3 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("3YqPl", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_VARIANTS", () => $136badd6870fea88$export$76a143792cc73994);

var $8Bc5A = parcelRequire("8Bc5A");

var $pDX5d = parcelRequire("pDX5d");
const $136badd6870fea88$export$76a143792cc73994 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: -1
        },
        visibility: {
            default: false
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 200
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 400
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamType).software
                    ],
                    value: true
                }
            ]
        }
    }
};

});

parcelRegister("xk58e", function(module, exports) {

$parcel$export(module.exports, "TAILORED_ONBOARDING_SINGLE_CONFIG", () => $70190108b7b6e00a$export$64855550cee11b78);

var $8Bc5A = parcelRequire("8Bc5A");

var $8VfDj = parcelRequire("8VfDj");

var $pDX5d = parcelRequire("pDX5d");
const $70190108b7b6e00a$export$64855550cee11b78 = {
    [(0, $8Bc5A.TAILORED_ONBOARDING_SUMMARY)]: {
        position: {
            default: 200,
            conditional: [
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_TIMELINE)]: {
        position: {
            default: 0,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: 600
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_LIST)]: {
        position: {
            default: 0,
            conditional: []
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BACKLOG)]: {
        position: {
            default: 0
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_BOARD)]: {
        position: {
            default: 100,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: 100
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CALENDAR)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: 100
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: 200
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: 200
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_CODE)]: {
        position: {
            default: 300
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_PAGES)]: {
        position: {
            default: 300,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: 500
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: false
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_FORM)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 500
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: 400
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: 300
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: 400
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    },
    [(0, $8Bc5A.TAILORED_ONBOARDING_INVITE)]: {
        position: {
            default: 500,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: 700
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software,
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible
                    ],
                    value: 700
                }
            ]
        },
        visibility: {
            default: false,
            conditional: [
                {
                    condition: [
                        (0, $8VfDj.Experiment).tailoredOnboardingScrumAndSoftwareKanbanEligible,
                        (0, $pDX5d.Feature).hasBacklog,
                        (0, $pDX5d.Feature).hasSprint
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).marketing
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).design
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).productManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).projectManagement
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).software
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).otherPersonal
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).itSupport
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).operations
                    ],
                    value: true
                },
                {
                    condition: [
                        (0, $pDX5d.TeamTypeWithPrefix).everythingElse
                    ],
                    value: true
                }
            ]
        }
    }
};

});




parcelRegister("75A1x", function(module, exports) {

$parcel$export(module.exports, "syncVisibilityWithLocal", () => $f9427b1514e1931c$export$4aab9a98fc53b894);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3B5jO = parcelRequire("3B5jO");

var $4ji4w = parcelRequire("4ji4w");
const $f9427b1514e1931c$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        const quickstartType = (0, $3B5jO.getQuickstartTypeSelector)(state);
        const visibilityLocal = (0, $4ji4w.getLocalStorageItem)(`${quickstartType}.visibility`);
        if (visibilityLocal === state.visibility[quickstartType]) return;
        setState({
            visibility: {
                ...state.visibility,
                [quickstartType]: visibilityLocal
            }
        });
    };

});

parcelRegister("1Xkin", function(module, exports) {

$parcel$export(module.exports, "universalDispatch", () => $e706482dec5e8abf$export$efe980271ca9cc08);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e706482dec5e8abf$export$efe980271ca9cc08 = ({ fn: fn })=>({ dispatch: dispatch })=>{
        dispatch(fn());
    };

});


parcelRegister("cGE52", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $d175a7a443e10f6d$export$d4c72bab9d6cc13a);

var $8Bc5A = parcelRequire("8Bc5A");
const $d175a7a443e10f6d$export$d4c72bab9d6cc13a = {
    shouldRenderComponent: false,
    completedTaskList: [],
    hasSeenTasks: [],
    isDismissed: true,
    isOpen: false,
    isFocusedOn: false,
    openTask: '',
    projectState: null,
    hasNudgeActive: false,
    isQuickstartLoaded: false,
    nudgeStep: '',
    mountedNudges: [],
    hasEverSeenRoute: {
        'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
    },
    roadmapIsCreateEnabled: false,
    roadmapIsListEmpty: true,
    previousTaskGroupParents: [],
    currentTaskGroupParent: (0, $8Bc5A.ROOT_TASK),
    currentTriggerForTaskGroupParent: '',
    selectedProjectTemplateKeyFromOnboarding: undefined,
    isEligibleToUpdateSitename: false,
    isCrossProjectBoardToPlanUpsell: false,
    canEditPlans: false,
    visibility: {
        [(0, $8Bc5A.QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED,
        [(0, $8Bc5A.QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, $8Bc5A.QUICKSTART_UI_STATUS).NOT_LOADED
    }
};

});



const $0f958c4b320efe3b$export$fc1565c98db060f9 = 'horizontal-nav-tabs-pages-spotlight-seen';


parcelRegister("3hiNj", function(module, exports) {

$parcel$export(module.exports, "JIRA_TABS", () => $5f48941933227bf2$export$3345ebb003d7978a);

var $5uXOq = parcelRequire("5uXOq");

var $41CZr = parcelRequire("41CZr");

var $ehis8 = parcelRequire("ehis8");

var $korlx = parcelRequire("korlx");

var $e4B5S = parcelRequire("e4B5S");

var $9x5pH = parcelRequire("9x5pH");

var $4iV1e = parcelRequire("4iV1e");

var $fNZB4 = parcelRequire("fNZB4");

var $e78BF = parcelRequire("e78BF");

var $1f9bV = parcelRequire("1f9bV");

var $2ciBJ = parcelRequire("2ciBJ");

var $eZ9Cp = parcelRequire("eZ9Cp");

var $QasRB = parcelRequire("QasRB");

var $dME4E = parcelRequire("dME4E");

var $acknU = parcelRequire("acknU");

var $bZNwM = parcelRequire("bZNwM");

var $hPcwl = parcelRequire("hPcwl");

var $8ndMa = parcelRequire("8ndMa");

var $lfDf7 = parcelRequire("lfDf7");

var $eQfWH = parcelRequire("eQfWH");

var $esjuM = parcelRequire("esjuM");

var $k2Gga = parcelRequire("k2Gga");

var $hOz5f = parcelRequire("hOz5f");

var $llvRa = parcelRequire("llvRa");

var $7Uevx = parcelRequire("7Uevx");

var $90gd1 = parcelRequire("90gd1");

var $7WxSP = parcelRequire("7WxSP");

var $7nnPp = parcelRequire("7nnPp");

var $lFcKf = parcelRequire("lFcKf");

var $4R6GH = parcelRequire("4R6GH");

var $aZEzT = parcelRequire("aZEzT");

var $bU94A = parcelRequire("bU94A");

var $9a8PH = parcelRequire("9a8PH");

var $4GBow = parcelRequire("4GBow");

var $fGlXq = parcelRequire("fGlXq");

var $ivrMo = parcelRequire("ivrMo");

var $fz9oE = parcelRequire("fz9oE");

var $3pzqk = parcelRequire("3pzqk");

var $AL4UQ = parcelRequire("AL4UQ");

var $dJlky = parcelRequire("dJlky");

var $gafcx = parcelRequire("gafcx");

var $5aUMY = parcelRequire("5aUMY");

var $gzEPo = parcelRequire("gzEPo");

var $ad6tu = parcelRequire("ad6tu");

var $1X4ga = parcelRequire("1X4ga");

var $85Sm6 = parcelRequire("85Sm6");

var $sQUnj = parcelRequire("sQUnj");

var $7Zltj = parcelRequire("7Zltj");

var $5EY5v = parcelRequire("5EY5v");

var $g8Wnk = parcelRequire("g8Wnk");

var $gS64m = parcelRequire("gS64m");

var $hR0XV = parcelRequire("hR0XV");

var $833ck = parcelRequire("833ck");

var $1GbRa = parcelRequire("1GbRa");

var $52BHa = parcelRequire("52BHa");
const $5f48941933227bf2$export$3345ebb003d7978a = {
    APP: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ndMa))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $aZEzT.default),
        description: ()=>(0, $52BHa.default).appDescription
    },
    APPROVALS: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eZ9Cp))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $bU94A.default),
        description: ()=>(0, $52BHa.default).approvalsDescription
    },
    ARCHIVED_ISSUES: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($41CZr))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size
            }),
        Illustration: (0, $ad6tu.default),
        description: ()=>(0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $52BHa.default).archivedIssuesDescriptionIssueTermRefresh : (0, $52BHa.default).archivedIssuesDescription
    },
    ATTACHMENTS: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($QasRB))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $9a8PH.default),
        description: ()=>(0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $52BHa.default).attachmentsDescriptionIssueTermRefresh : (0, $52BHa.default).attachmentsDescription
    },
    BACKLOG: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($QasRB))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $4GBow.default),
        description: ()=>(0, $52BHa.default).backlogDescription
    },
    BOARD: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dME4E))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $fGlXq.default),
        description: ()=>(0, $52BHa.default).boardDescription
    },
    CALENDAR: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $ivrMo.default),
        description: ()=>(0, $52BHa.default).calendarDescription
    },
    CODE: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2ciBJ))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $fz9oE.default),
        description: ()=>(0, $52BHa.default).codeDescription
    },
    COMPONENTS: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ehis8))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size
            }),
        Illustration: (0, $3pzqk.default),
        description: ()=>(0, $52BHa.default).componentsDescription
    },
    DEPLOYMENTS: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hPcwl))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $AL4UQ.default),
        description: ()=>(0, $52BHa.default).deploymentsDescription
    },
    DEVELOPMENT: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e78BF))), {
                label: "",
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $dJlky.default),
        description: ()=>(0, $52BHa.default).developmentDescription
    },
    FORMS: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e4B5S))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size
            }),
        Illustration: (0, $gafcx.default),
        description: ()=>(0, $52BHa.default).formsDescription
    },
    GOALS: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4iV1e))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size,
                LEGACY_fallbackIcon: (0, $1GbRa.GoalIcon)
            }),
        Illustration: (0, $5aUMY.default),
        description: ()=>(0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $52BHa.default).goalsDescriptionIssueTermRefresh : (0, $52BHa.default).goalsDescription
    },
    INCIDENTS: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fNZB4))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size,
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7nnPp)))
            }),
        Illustration: (0, $gzEPo.default),
        description: ()=>(0, $52BHa.default).incidentsDescription
    },
    ISSUES: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lfDf7))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $ad6tu.default),
        description: ()=>(0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $52BHa.default).issuesDescriptionIssueTermRefresh : (0, $52BHa.default).issuesDescription
    },
    LIST: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Uevx))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size,
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($90gd1)))
            }),
        Illustration: (0, $1X4ga.default),
        description: ()=>(0, $52BHa.default).listDescription
    },
    ON_CALL: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hOz5f))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size,
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lFcKf)))
            }),
        Illustration: (0, $85Sm6.default),
        description: ()=>(0, $52BHa.default).onCallDescription
    },
    PAGES: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $sQUnj.default),
        description: ()=>(0, $52BHa.default).pagesDescription
    },
    RELEASES: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($esjuM))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $7Zltj.default),
        description: ()=>(0, $52BHa.default).releasesDescription
    },
    REPORTS: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $5EY5v.default),
        description: ()=>(0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $52BHa.default).reportsDescriptionIssueTermRefresh : (0, $52BHa.default).reportsDescription
    },
    SECURITY: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($llvRa))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size
            }),
        Illustration: (0, $g8Wnk.default),
        description: ()=>(0, $52BHa.default).securityDescription
    },
    SHORTCUTS: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1f9bV))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size,
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7WxSP)))
            }),
        Illustration: (0, $gS64m.default),
        description: ()=>(0, $52BHa.default).shortcutsDescription
    },
    SUMMARY: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9x5pH))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size
            }),
        Illustration: (0, $hR0XV.default),
        description: ()=>(0, $52BHa.default).summaryDescriptionNonFinal
    },
    TIMELINE: {
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k2Gga))), {
                ...props,
                color: "currentColor",
                spacing: props.size === 'small' ? 'none' : 'spacious',
                LEGACY_size: props.size
            }),
        Illustration: (0, $833ck.default),
        description: ()=>(0, $52BHa.default).timelineDescription
    },
    INBOX: {
        Icon: ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($korlx))), {
                ...props,
                color: "currentColor",
                spacing: size === 'small' ? 'none' : 'spacious',
                LEGACY_size: size
            }),
        Illustration: (0, $ad6tu.default),
        description: ()=>(0, $52BHa.default).inboxDescription
    }
};

});
parcelRegister("41CZr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53af402aec64299fbaefa11fd3d04c88>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ee5800a86362bd2$var$_react = $2ee5800a86362bd2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2ee5800a86362bd2$var$_baseNew = $2ee5800a86362bd2$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2ee5800a86362bd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArchiveBox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ee5800a86362bd2$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $2ee5800a86362bd2$var$_react.default.createElement($2ee5800a86362bd2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v5h-1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1zm2.5 5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6zm10-1.5h-11v-2h11zm-3 4.5h-5V7.5h5z" clip-rule="evenodd"/>`
    }, props));
$2ee5800a86362bd2$var$ArchiveBoxIcon.displayName = 'ArchiveBoxIcon';
var $2ee5800a86362bd2$var$_default = module.exports.default = $2ee5800a86362bd2$var$ArchiveBoxIcon;

});

parcelRegister("ehis8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b85e957a451f01111d5005fe7bfa754b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a650f78d49c8cbb1$var$_react = $a650f78d49c8cbb1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a650f78d49c8cbb1$var$_baseNew = $a650f78d49c8cbb1$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a650f78d49c8cbb1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Component".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for components in Jira and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a650f78d49c8cbb1$var$ComponentIcon = (props)=>/*#__PURE__*/ $a650f78d49c8cbb1$var$_react.default.createElement($a650f78d49c8cbb1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.75A.75.75 0 0 1 2.75 2h3.5a.75.75 0 0 1 .75.75V4.5h2V2.75A.75.75 0 0 1 9.75 2h3.5a.75.75 0 0 1 .75.75V4.5a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6.5a2 2 0 0 1 2-2zM3.5 4.5h2v-1h-2zm9 0v-1h-2v1zM2 6a.5.5 0 0 0-.5.5V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6.5A.5.5 0 0 0 14 6z" clip-rule="evenodd"/>`
    }, props));
$a650f78d49c8cbb1$var$ComponentIcon.displayName = 'ComponentIcon';
var $a650f78d49c8cbb1$var$_default = module.exports.default = $a650f78d49c8cbb1$var$ComponentIcon;

});

parcelRegister("korlx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::81177d596079c24ecbc8bf8bc933664f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed8b42fa0c7772ef$var$_react = $ed8b42fa0c7772ef$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ed8b42fa0c7772ef$var$_baseNew = $ed8b42fa0c7772ef$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ed8b42fa0c7772ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Inbox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: 'Your work' in Confluence, inbox, mail.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed8b42fa0c7772ef$var$InboxIcon = (props)=>/*#__PURE__*/ $ed8b42fa0c7772ef$var$_react.default.createElement($ed8b42fa0c7772ef$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v5h3a.75.75 0 0 1 .75.75 1.75 1.75 0 1 0 3.5 0A.75.75 0 0 1 10.5 8h3V3a.5.5 0 0 0-.5-.5zm10.5 7h-2.337a3.251 3.251 0 0 1-6.326 0H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM12 6H4V4.5h8z" clip-rule="evenodd"/>`
    }, props));
$ed8b42fa0c7772ef$var$InboxIcon.displayName = 'InboxIcon';
var $ed8b42fa0c7772ef$var$_default = module.exports.default = $ed8b42fa0c7772ef$var$InboxIcon;

});

parcelRegister("e4B5S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6cd595d4ec67af9dd83acc02e35c9f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3ee36718444182a$var$_react = $a3ee36718444182a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a3ee36718444182a$var$_baseNew = $a3ee36718444182a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a3ee36718444182a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Form".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Represents forms across Atlassian products, including Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a3ee36718444182a$var$FormIcon = (props)=>/*#__PURE__*/ $a3ee36718444182a$var$_react.default.createElement($a3ee36718444182a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 1.5H1V0h6zM1 3.875c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75C15 6.385 14.384 7 13.625 7H2.375C1.615 7 1 6.384 1 5.625zM2.5 4v1.5h11V4zM7 10.5H1V9h6zm-6 2.375c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75c0 .76-.616 1.375-1.375 1.375H2.375C1.615 16 1 15.384 1 14.625zM2.5 13v1.5h11V13z" clip-rule="evenodd"/>`
    }, props));
$a3ee36718444182a$var$FormIcon.displayName = 'FormIcon';
var $a3ee36718444182a$var$_default = module.exports.default = $a3ee36718444182a$var$FormIcon;

});

parcelRegister("fNZB4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cca747bf584e772ee6e9df3631122996>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b81b36817ee75239$var$_react = $b81b36817ee75239$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b81b36817ee75239$var$_baseNew = $b81b36817ee75239$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b81b36817ee75239$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b81b36817ee75239$var$IncidentIcon = (props)=>/*#__PURE__*/ $b81b36817ee75239$var$_react.default.createElement($b81b36817ee75239$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$b81b36817ee75239$var$IncidentIcon.displayName = 'IncidentIcon';
var $b81b36817ee75239$var$_default = module.exports.default = $b81b36817ee75239$var$IncidentIcon;

});

parcelRegister("2ciBJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::892203c72b828429279b82b0b7182ba7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $199b22d6246a3269$var$_react = $199b22d6246a3269$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $199b22d6246a3269$var$_angleBrackets = $199b22d6246a3269$var$_interopRequireDefault((parcelRequire("jSlaY")));

var $199b22d6246a3269$var$_code = $199b22d6246a3269$var$_interopRequireDefault((parcelRequire("c2JK5")));
function $199b22d6246a3269$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AngleBracketsIcon.
 * This component is AngleBracketsIcon, with `UNSAFE_fallbackIcon` set to "CodeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $199b22d6246a3269$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $199b22d6246a3269$var$_react.default.createElement($199b22d6246a3269$var$_angleBrackets.default, Object.assign({
        LEGACY_fallbackIcon: $199b22d6246a3269$var$_code.default
    }, props));
$199b22d6246a3269$var$AngleBracketsIcon.Name = 'AngleBracketsIconMigration';
var $199b22d6246a3269$var$_default = module.exports.default = $199b22d6246a3269$var$AngleBracketsIcon;

});
parcelRegister("c2JK5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c49276b1d591265$var$_react = $8c49276b1d591265$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $8c49276b1d591265$var$_angleBrackets = $8c49276b1d591265$var$_interopRequireDefault((parcelRequire("jSlaY")));
function $8c49276b1d591265$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8c49276b1d591265$var$CodeIcon = (props)=>/*#__PURE__*/ $8c49276b1d591265$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.16 4.06a1 1 0 0 0-1.27.62L8.06 18.73a1 1 0 0 0 1.89.65l4.83-14.04a1 1 0 0 0-.62-1.27m-6.14 8.2-2.58-2.5 2.8-2.72a1 1 0 1 0-1.39-1.44L3.31 9.04a1 1 0 0 0 0 1.44l3.32 3.22a1 1 0 1 0 1.39-1.44m12.22 1.57-3.32-3.22a1 1 0 1 0-1.39 1.44l2.58 2.5-2.8 2.72a1 1 0 1 0 1.39 1.44l3.54-3.43a1 1 0 0 0 0-1.44"/></svg>`
    }, props, {
        newIcon: $8c49276b1d591265$var$_angleBrackets.default
    }));
$8c49276b1d591265$var$CodeIcon.displayName = 'CodeIcon';
var $8c49276b1d591265$var$_default = module.exports.default = $8c49276b1d591265$var$CodeIcon;

});


parcelRegister("eZ9Cp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0ced1d960d5ffcbbe0ac5a90af7d239>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae8e393f8b71055f$var$_react = $ae8e393f8b71055f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ae8e393f8b71055f$var$_attachment = $ae8e393f8b71055f$var$_interopRequireDefault((parcelRequire("dP8up")));

var $ae8e393f8b71055f$var$_attachment2 = $ae8e393f8b71055f$var$_interopRequireDefault((parcelRequire("j3Vfq")));
function $ae8e393f8b71055f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AttachmentIcon.
 * This component is AttachmentIcon, with `UNSAFE_fallbackIcon` set to "AttachmentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for attaching files to work types or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ae8e393f8b71055f$var$AttachmentIcon = (props)=>/*#__PURE__*/ $ae8e393f8b71055f$var$_react.default.createElement($ae8e393f8b71055f$var$_attachment.default, Object.assign({
        LEGACY_fallbackIcon: $ae8e393f8b71055f$var$_attachment2.default
    }, props));
$ae8e393f8b71055f$var$AttachmentIcon.Name = 'AttachmentIconMigration';
var $ae8e393f8b71055f$var$_default = module.exports.default = $ae8e393f8b71055f$var$AttachmentIcon;

});
parcelRegister("dP8up", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174ee51c60633f76b0dbf1c968e4afc5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1069f9774dbd57c$var$_react = $a1069f9774dbd57c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a1069f9774dbd57c$var$_baseNew = $a1069f9774dbd57c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a1069f9774dbd57c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Attachment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for attaching files to work types or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1069f9774dbd57c$var$AttachmentIcon = (props)=>/*#__PURE__*/ $a1069f9774dbd57c$var$_react.default.createElement($a1069f9774dbd57c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.22 8.47 4.5-4.5 1.06 1.06-4.5 4.5a.664.664 0 0 0 .94.94l4.5-4.5a2.079 2.079 0 0 0-2.94-2.94l-4.5 4.5a3.492 3.492 0 0 0 4.94 4.94l2.5-2.5 1.06 1.06-2.5 2.5a4.993 4.993 0 0 1-7.06-7.06l4.5-4.5a3.578 3.578 0 0 1 5.06 5.06l-4.5 4.5a2.165 2.165 0 0 1-3.06-3.06"/>`
    }, props));
$a1069f9774dbd57c$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $a1069f9774dbd57c$var$_default = module.exports.default = $a1069f9774dbd57c$var$AttachmentIcon;

});

parcelRegister("j3Vfq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de0ab45660c611f8$var$_react = $de0ab45660c611f8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $de0ab45660c611f8$var$_attachment = $de0ab45660c611f8$var$_interopRequireDefault((parcelRequire("dP8up")));
function $de0ab45660c611f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $de0ab45660c611f8$var$AttachmentIcon = (props)=>/*#__PURE__*/ $de0ab45660c611f8$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.643 17.965c-1.53 1.495-4.016 1.496-5.542.004a3.773 3.773 0 0 1 .002-5.412l7.147-6.985a2.316 2.316 0 0 1 3.233-.003c.893.873.895 2.282.004 3.153l-6.703 6.55a.653.653 0 0 1-.914-.008.62.62 0 0 1 0-.902l6.229-6.087a.94.94 0 0 0 0-1.353.995.995 0 0 0-1.384 0l-6.23 6.087a2.5 2.5 0 0 0 0 3.607 2.643 2.643 0 0 0 3.683.009l6.703-6.55a4.074 4.074 0 0 0-.003-5.859 4.306 4.306 0 0 0-6.002.003l-7.148 6.985a5.655 5.655 0 0 0-.001 8.118c2.29 2.239 6.015 2.238 8.31-.005l6.686-6.533a.94.94 0 0 0 0-1.353.995.995 0 0 0-1.384 0z"/></svg>`
    }, props, {
        newIcon: $de0ab45660c611f8$var$_attachment.default
    }));
$de0ab45660c611f8$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $de0ab45660c611f8$var$_default = module.exports.default = $de0ab45660c611f8$var$AttachmentIcon;

});


parcelRegister("acknU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));

var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
function $76cad653a4883392$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76cad653a4883392$var$CalendarIcon = (props)=>/*#__PURE__*/ $76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
    }, props));
$76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;

});
parcelRegister("3fesp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25cdfcb8bb836404$var$_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25cdfcb8bb836404$var$CalendarIcon = (props)=>/*#__PURE__*/ $25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;

});

parcelRegister("cTemL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9625c3edd02eaf26$var$CalendarIcon = (props)=>/*#__PURE__*/ $9625c3edd02eaf26$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $9625c3edd02eaf26$var$_calendar.default
    }));
$9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;

});


parcelRegister("bZNwM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::82e1d157ecf30f62ef37497818841c29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bbbcf5ce8764439$var$_react = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8bbbcf5ce8764439$var$_chartTrend = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("7EZ5v")));

var $8bbbcf5ce8764439$var$_graphLine = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("gSPJV")));
function $8bbbcf5ce8764439$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChartTrendIcon.
 * This component is ChartTrendIcon, with `UNSAFE_fallbackIcon` set to "GraphLineIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8bbbcf5ce8764439$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $8bbbcf5ce8764439$var$_react.default.createElement($8bbbcf5ce8764439$var$_chartTrend.default, Object.assign({
        LEGACY_fallbackIcon: $8bbbcf5ce8764439$var$_graphLine.default
    }, props));
$8bbbcf5ce8764439$var$ChartTrendIcon.Name = 'ChartTrendIconMigration';
var $8bbbcf5ce8764439$var$_default = module.exports.default = $8bbbcf5ce8764439$var$ChartTrendIcon;

});
parcelRegister("gSPJV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4a9d2eb82ff139c$var$_react = $c4a9d2eb82ff139c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c4a9d2eb82ff139c$var$_chartTrend = $c4a9d2eb82ff139c$var$_interopRequireDefault((parcelRequire("7EZ5v")));
function $c4a9d2eb82ff139c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c4a9d2eb82ff139c$var$GraphLineIcon = (props)=>/*#__PURE__*/ $c4a9d2eb82ff139c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M21 17H5c-.55 0-1-.45-1-1.01V6a1 1 0 1 0-2 0v9.99A3 3 0 0 0 5 19h16a1 1 0 0 0 0-2m-3-8v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="M13.293 13.707a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L14 11.586l-2.293-2.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 11.414z"/></g></svg>`
    }, props, {
        newIcon: $c4a9d2eb82ff139c$var$_chartTrend.default
    }));
$c4a9d2eb82ff139c$var$GraphLineIcon.displayName = 'GraphLineIcon';
var $c4a9d2eb82ff139c$var$_default = module.exports.default = $c4a9d2eb82ff139c$var$GraphLineIcon;

});


parcelRegister("hPcwl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da6815f1e303f26a4e473874c26eef5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfa0e970215956ee$var$_react = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cfa0e970215956ee$var$_cloudArrowUp = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("ePJ5X")));

var $cfa0e970215956ee$var$_upload = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("aPRJS")));
function $cfa0e970215956ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloudArrowUpIcon.
 * This component is CloudArrowUpIcon, with `UNSAFE_fallbackIcon` set to "UploadIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cfa0e970215956ee$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $cfa0e970215956ee$var$_react.default.createElement($cfa0e970215956ee$var$_cloudArrowUp.default, Object.assign({
        LEGACY_fallbackIcon: $cfa0e970215956ee$var$_upload.default
    }, props));
$cfa0e970215956ee$var$CloudArrowUpIcon.Name = 'CloudArrowUpIconMigration';
var $cfa0e970215956ee$var$_default = module.exports.default = $cfa0e970215956ee$var$CloudArrowUpIcon;

});
parcelRegister("ePJ5X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e83f76db2e7ada7e0358014b5e026a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc8cf07db1d2dba$var$_react = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $acc8cf07db1d2dba$var$_baseNew = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $acc8cf07db1d2dba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc8cf07db1d2dba$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $acc8cf07db1d2dba$var$_react.default.createElement($acc8cf07db1d2dba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$acc8cf07db1d2dba$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $acc8cf07db1d2dba$var$_default = module.exports.default = $acc8cf07db1d2dba$var$CloudArrowUpIcon;

});

parcelRegister("aPRJS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e385a40dadea6dc$var$_react = $7e385a40dadea6dc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7e385a40dadea6dc$var$_cloudArrowUp = $7e385a40dadea6dc$var$_interopRequireDefault((parcelRequire("ePJ5X")));
function $7e385a40dadea6dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7e385a40dadea6dc$var$UploadIcon = (props)=>/*#__PURE__*/ $7e385a40dadea6dc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props, {
        newIcon: $7e385a40dadea6dc$var$_cloudArrowUp.default
    }));
$7e385a40dadea6dc$var$UploadIcon.displayName = 'UploadIcon';
var $7e385a40dadea6dc$var$_default = module.exports.default = $7e385a40dadea6dc$var$UploadIcon;

});


parcelRegister("8ndMa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d9c2fe4153711de61c73f11b1bae070a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $618b284e40a0b360$var$_react = $618b284e40a0b360$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $618b284e40a0b360$var$_decision = $618b284e40a0b360$var$_interopRequireDefault((parcelRequire("8HSNL")));

var $618b284e40a0b360$var$_decision2 = $618b284e40a0b360$var$_interopRequireDefault((parcelRequire("fkXRs")));
function $618b284e40a0b360$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DecisionIcon.
 * This component is DecisionIcon, with `UNSAFE_fallbackIcon` set to "EditorDecisionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $618b284e40a0b360$var$DecisionIcon = (props)=>/*#__PURE__*/ $618b284e40a0b360$var$_react.default.createElement($618b284e40a0b360$var$_decision.default, Object.assign({
        LEGACY_fallbackIcon: $618b284e40a0b360$var$_decision2.default
    }, props));
$618b284e40a0b360$var$DecisionIcon.Name = 'DecisionIconMigration';
var $618b284e40a0b360$var$_default = module.exports.default = $618b284e40a0b360$var$DecisionIcon;

});
parcelRegister("8HSNL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0b9c9537e0b69b1d3c8d2587861fe5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $656cd9546d343d79$var$_react = $656cd9546d343d79$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $656cd9546d343d79$var$_baseNew = $656cd9546d343d79$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $656cd9546d343d79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $656cd9546d343d79$var$DecisionIcon = (props)=>/*#__PURE__*/ $656cd9546d343d79$var$_react.default.createElement($656cd9546d343d79$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$656cd9546d343d79$var$DecisionIcon.displayName = 'DecisionIcon';
var $656cd9546d343d79$var$_default = module.exports.default = $656cd9546d343d79$var$DecisionIcon;

});

parcelRegister("fkXRs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2a7287aaf779f72$var$_react = $b2a7287aaf779f72$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $b2a7287aaf779f72$var$_decision = $b2a7287aaf779f72$var$_interopRequireDefault((parcelRequire("8HSNL")));
function $b2a7287aaf779f72$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b2a7287aaf779f72$var$EditorDecisionIcon = (props)=>/*#__PURE__*/ $b2a7287aaf779f72$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0"/></svg>`
    }, props, {
        newIcon: $b2a7287aaf779f72$var$_decision.default
    }));
$b2a7287aaf779f72$var$EditorDecisionIcon.displayName = 'EditorDecisionIcon';
var $b2a7287aaf779f72$var$_default = module.exports.default = $b2a7287aaf779f72$var$EditorDecisionIcon;

});


parcelRegister("hOz5f", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54d86c00219aaf0598bf3eec65b605b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf825211d8a9eeef$var$_react = $cf825211d8a9eeef$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cf825211d8a9eeef$var$_baseNew = $cf825211d8a9eeef$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $cf825211d8a9eeef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OnCall".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing on-call across Atlassian products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf825211d8a9eeef$var$OnCallIcon = (props)=>/*#__PURE__*/ $cf825211d8a9eeef$var$_react.default.createElement($cf825211d8a9eeef$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.75A.75.75 0 0 1 .75 2h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L3.29 8.86a12.3 12.3 0 0 0 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 0 2.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM2.56 7.516 4.27 6.09a.25.25 0 0 0 .08-.261L3.684 3.5H1.525A11.4 11.4 0 0 0 2.56 7.516" clip-rule="evenodd"/><path fill="currentcolor" d="M16 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-2.5 2.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M11 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$cf825211d8a9eeef$var$OnCallIcon.displayName = 'OnCallIcon';
var $cf825211d8a9eeef$var$_default = module.exports.default = $cf825211d8a9eeef$var$OnCallIcon;

});

parcelRegister("7Uevx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1fd96c5b3b13ee02dc5743b09d638d98>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c1904502a6c690c$var$_react = $5c1904502a6c690c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5c1904502a6c690c$var$_baseNew = $5c1904502a6c690c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5c1904502a6c690c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spreadsheet".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for spreadsheets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c1904502a6c690c$var$SpreadsheetIcon = (props)=>/*#__PURE__*/ $5c1904502a6c690c$var$_react.default.createElement($5c1904502a6c690c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v3.25H5V3.5zm4.5 0v3.75h8V4a.5.5 0 0 0-.5-.5zm8 5.25h-8v3.75H14a.5.5 0 0 0 .5-.5zM5 12.5V8.75H1.5V12a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$5c1904502a6c690c$var$SpreadsheetIcon.displayName = 'SpreadsheetIcon';
var $5c1904502a6c690c$var$_default = module.exports.default = $5c1904502a6c690c$var$SpreadsheetIcon;

});

parcelRegister("lFcKf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc57502d94449bcf$var$_react = $fc57502d94449bcf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $fc57502d94449bcf$var$_onCall = $fc57502d94449bcf$var$_interopRequireDefault((parcelRequire("hOz5f")));
function $fc57502d94449bcf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fc57502d94449bcf$var$HipchatDialOutIcon = (props)=>/*#__PURE__*/ $fc57502d94449bcf$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7.794 5.364c-1.726 2.133-.611 4.957.266 7.089.416 1.012 1.073 2.025 1.629 2.84.973 1.424 3.189 4.13 5.901 3.722 1.168-.176 2.527-1.555 1.597-2.436l-1.869-1.94s-.523-.436-1.171-.08l-1.048.613s-.428.202-.799-.275c-1.163-1.371-1.995-2.797-2.578-4.496-.227-.663.168-.828.168-.828l.767-.45c.637-.378.524-1.051.524-1.051l-.438-2.738c-.132-.568-.601-.803-1.145-.803-.648 0-1.4.334-1.804.833"/></svg>`
    }, props, {
        newIcon: $fc57502d94449bcf$var$_onCall.default
    }));
$fc57502d94449bcf$var$HipchatDialOutIcon.displayName = 'HipchatDialOutIcon';
var $fc57502d94449bcf$var$_default = module.exports.default = $fc57502d94449bcf$var$HipchatDialOutIcon;

});

parcelRegister("aZEzT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8e9302a8b16bd67$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $aBIhW = parcelRequire("aBIhW");

var $hWYmk = parcelRequire("hWYmk");
const $f8e9302a8b16bd67$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hWYmk)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($aBIhW))
});
var $f8e9302a8b16bd67$export$2e2bcd8739ae039 = $f8e9302a8b16bd67$var$Illustration;
// for advanced use only
const $f8e9302a8b16bd67$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("dCLgq", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $191b30bb5e9fa934$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $191b30bb5e9fa934$export$4d00e7be716a0093);

var $5uXOq = parcelRequire("5uXOq");

var $10ozQ = parcelRequire("10ozQ");
function $191b30bb5e9fa934$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $10ozQ.AsImg), props);
}
function $191b30bb5e9fa934$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($191b30bb5e9fa934$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("10ozQ", function(module, exports) {

$parcel$export(module.exports, "AsImg", () => $b5af8835f639f069$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");
// suggested defaults, the consumer is free to override
const $b5af8835f639f069$var$defaultStyles = null;
const $b5af8835f639f069$var$fillStyles = null;
const $b5af8835f639f069$var$autoDarkModeStyles = null;
function $b5af8835f639f069$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_1r04idpf _kqswstnw _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}

});


parcelRegister("aBIhW", function(module, exports) {
module.exports = new URL("app-preview-dark.692f3794.svg", import.meta.url).toString();

});

parcelRegister("hWYmk", function(module, exports) {
module.exports = new URL("app-preview.701bd916.svg", import.meta.url).toString();

});


parcelRegister("bU94A", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ab5734c5483a312$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $kKssv = parcelRequire("kKssv");

var $ijDaZ = parcelRequire("ijDaZ");
const $2ab5734c5483a312$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($ijDaZ)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($kKssv))
});
var $2ab5734c5483a312$export$2e2bcd8739ae039 = $2ab5734c5483a312$var$Illustration;
// for advanced use only
const $2ab5734c5483a312$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("kKssv", function(module, exports) {
module.exports = new URL("approvals-preview-dark.6d3cc8df.svg", import.meta.url).toString();

});

parcelRegister("ijDaZ", function(module, exports) {
module.exports = new URL("approvals-preview.ce5f015e.svg", import.meta.url).toString();

});


parcelRegister("9a8PH", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d6f697cd504e99$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $e9Wj1 = parcelRequire("e9Wj1");

var $736jZ = parcelRequire("736jZ");
const $45d6f697cd504e99$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($736jZ)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($e9Wj1))
});
var $45d6f697cd504e99$export$2e2bcd8739ae039 = $45d6f697cd504e99$var$Illustration;
// for advanced use only
const $45d6f697cd504e99$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("e9Wj1", function(module, exports) {
module.exports = new URL("attachments-preview-dark.33a03e0d.svg", import.meta.url).toString();

});

parcelRegister("736jZ", function(module, exports) {
module.exports = new URL("attachments-preview.7bdfffc6.svg", import.meta.url).toString();

});


parcelRegister("4GBow", function(module, exports) {

$parcel$export(module.exports, "default", () => $e68ffabe5e49917a$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $961Wr = parcelRequire("961Wr");

var $ea8PL = parcelRequire("ea8PL");
const $e68ffabe5e49917a$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($ea8PL)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($961Wr))
});
var $e68ffabe5e49917a$export$2e2bcd8739ae039 = $e68ffabe5e49917a$var$Illustration;
// for advanced use only
const $e68ffabe5e49917a$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("961Wr", function(module, exports) {
module.exports = new URL("backlog-preview-dark.d971d34f.svg", import.meta.url).toString();

});

parcelRegister("ea8PL", function(module, exports) {
module.exports = new URL("backlog-preview.286ce430.svg", import.meta.url).toString();

});


parcelRegister("fGlXq", function(module, exports) {

$parcel$export(module.exports, "default", () => $56958bdcbb5fed5b$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $7PiAM = parcelRequire("7PiAM");

var $lUqf8 = parcelRequire("lUqf8");
const $56958bdcbb5fed5b$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($lUqf8)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($7PiAM))
});
var $56958bdcbb5fed5b$export$2e2bcd8739ae039 = $56958bdcbb5fed5b$var$Illustration;
// for advanced use only
const $56958bdcbb5fed5b$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("7PiAM", function(module, exports) {
module.exports = new URL("board-preview-dark.ba6ae5d7.svg", import.meta.url).toString();

});

parcelRegister("lUqf8", function(module, exports) {
module.exports = new URL("board-preview.caf8f30f.svg", import.meta.url).toString();

});


parcelRegister("ivrMo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e950b3b295ffcd66$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $fMjVT = parcelRequire("fMjVT");

var $8sGff = parcelRequire("8sGff");
const $e950b3b295ffcd66$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8sGff)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fMjVT))
});
var $e950b3b295ffcd66$export$2e2bcd8739ae039 = $e950b3b295ffcd66$var$Illustration;
// for advanced use only
const $e950b3b295ffcd66$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("fMjVT", function(module, exports) {
module.exports = new URL("calendar-preview-dark.1428b9c3.svg", import.meta.url).toString();

});

parcelRegister("8sGff", function(module, exports) {
module.exports = new URL("calendar-preview.cff0b145.svg", import.meta.url).toString();

});


parcelRegister("fz9oE", function(module, exports) {

$parcel$export(module.exports, "default", () => $edee4da055e0570e$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $Hcwkx = parcelRequire("Hcwkx");

var $7SZxR = parcelRequire("7SZxR");
const $edee4da055e0570e$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($7SZxR)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($Hcwkx))
});
var $edee4da055e0570e$export$2e2bcd8739ae039 = $edee4da055e0570e$var$Illustration;
// for advanced use only
const $edee4da055e0570e$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("Hcwkx", function(module, exports) {
module.exports = new URL("code-preview-dark.6f4d4989.svg", import.meta.url).toString();

});

parcelRegister("7SZxR", function(module, exports) {
module.exports = new URL("code-preview.15cf9a6e.svg", import.meta.url).toString();

});


parcelRegister("3pzqk", function(module, exports) {

$parcel$export(module.exports, "default", () => $936ff2bab8c98662$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $lSepf = parcelRequire("lSepf");

var $gu2fr = parcelRequire("gu2fr");
const $936ff2bab8c98662$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($gu2fr)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($lSepf))
});
var $936ff2bab8c98662$export$2e2bcd8739ae039 = $936ff2bab8c98662$var$Illustration;
// for advanced use only
const $936ff2bab8c98662$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("lSepf", function(module, exports) {
module.exports = new URL("component-preview-dark.ac5aacd0.svg", import.meta.url).toString();

});

parcelRegister("gu2fr", function(module, exports) {
module.exports = new URL("component-preview.e6bd185f.svg", import.meta.url).toString();

});


parcelRegister("AL4UQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2dcc9d70948736f$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $eVhuj = parcelRequire("eVhuj");

var $bOrrK = parcelRequire("bOrrK");
const $c2dcc9d70948736f$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($bOrrK)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($eVhuj))
});
var $c2dcc9d70948736f$export$2e2bcd8739ae039 = $c2dcc9d70948736f$var$Illustration;
// for advanced use only
const $c2dcc9d70948736f$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("eVhuj", function(module, exports) {
module.exports = new URL("deployments-preview-dark.0cf1d99c.svg", import.meta.url).toString();

});

parcelRegister("bOrrK", function(module, exports) {
module.exports = new URL("deployments-preview.78ac1bac.svg", import.meta.url).toString();

});


parcelRegister("dJlky", function(module, exports) {

$parcel$export(module.exports, "default", () => $64c1e2819400ba27$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $fNqqO = parcelRequire("fNqqO");

var $eBkD1 = parcelRequire("eBkD1");
const $64c1e2819400ba27$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($eBkD1)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fNqqO))
});
var $64c1e2819400ba27$export$2e2bcd8739ae039 = $64c1e2819400ba27$var$Illustration;
// for advanced use only
const $64c1e2819400ba27$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("fNqqO", function(module, exports) {
module.exports = new URL("development-preview-dark.d26e9f57.svg", import.meta.url).toString();

});

parcelRegister("eBkD1", function(module, exports) {
module.exports = new URL("development-preview.bf178645.svg", import.meta.url).toString();

});


parcelRegister("gafcx", function(module, exports) {

$parcel$export(module.exports, "default", () => $84cfa41e2e38c966$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $aAjZp = parcelRequire("aAjZp");

var $bVZ6x = parcelRequire("bVZ6x");
const $84cfa41e2e38c966$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($bVZ6x)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($aAjZp))
});
var $84cfa41e2e38c966$export$2e2bcd8739ae039 = $84cfa41e2e38c966$var$Illustration;
// for advanced use only
const $84cfa41e2e38c966$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("aAjZp", function(module, exports) {
module.exports = new URL("forms-preview-dark.430156b1.svg", import.meta.url).toString();

});

parcelRegister("bVZ6x", function(module, exports) {
module.exports = new URL("forms-preview.5e482c7a.svg", import.meta.url).toString();

});


parcelRegister("5aUMY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9def757a09f39c8$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $1g8P4 = parcelRequire("1g8P4");

var $i5Tiv = parcelRequire("i5Tiv");
const $a9def757a09f39c8$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($i5Tiv)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($1g8P4))
});
var $a9def757a09f39c8$export$2e2bcd8739ae039 = $a9def757a09f39c8$var$Illustration;
// for advanced use only
const $a9def757a09f39c8$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("1g8P4", function(module, exports) {
module.exports = new URL("goals-preview-dark.0421fbf5.svg", import.meta.url).toString();

});

parcelRegister("i5Tiv", function(module, exports) {
module.exports = new URL("goals-preview.8d233f18.svg", import.meta.url).toString();

});


parcelRegister("gzEPo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9be86b79c8ab00b9$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $d02PD = parcelRequire("d02PD");

var $eaDfM = parcelRequire("eaDfM");
const $9be86b79c8ab00b9$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($eaDfM)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($d02PD))
});
var $9be86b79c8ab00b9$export$2e2bcd8739ae039 = $9be86b79c8ab00b9$var$Illustration;
// for advanced use only
const $9be86b79c8ab00b9$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("d02PD", function(module, exports) {
module.exports = new URL("incidents-preview-dark.30e9470b.svg", import.meta.url).toString();

});

parcelRegister("eaDfM", function(module, exports) {
module.exports = new URL("incidents-preview.e6af1843.svg", import.meta.url).toString();

});


parcelRegister("ad6tu", function(module, exports) {

$parcel$export(module.exports, "default", () => $686a30c829043502$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $958WM = parcelRequire("958WM");

var $4Ayb6 = parcelRequire("4Ayb6");
const $686a30c829043502$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4Ayb6)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($958WM))
});
var $686a30c829043502$export$2e2bcd8739ae039 = $686a30c829043502$var$Illustration;
// for advanced use only
const $686a30c829043502$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("958WM", function(module, exports) {
module.exports = new URL("issues-preview-dark.5cdc89fc.svg", import.meta.url).toString();

});

parcelRegister("4Ayb6", function(module, exports) {
module.exports = new URL("issues-preview.c08edc67.svg", import.meta.url).toString();

});


parcelRegister("1X4ga", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b7a866c21212700$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $bNjwd = parcelRequire("bNjwd");

var $g78AY = parcelRequire("g78AY");
const $3b7a866c21212700$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($g78AY)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($bNjwd))
});
var $3b7a866c21212700$export$2e2bcd8739ae039 = $3b7a866c21212700$var$Illustration;
// for advanced use only
const $3b7a866c21212700$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("bNjwd", function(module, exports) {
module.exports = new URL("list-preview-dark.e53f1bb5.svg", import.meta.url).toString();

});

parcelRegister("g78AY", function(module, exports) {
module.exports = new URL("list-preview.9c8441b2.svg", import.meta.url).toString();

});


parcelRegister("85Sm6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fef2577684df85ff$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $9k6rI = parcelRequire("9k6rI");

var $leQd8 = parcelRequire("leQd8");
const $fef2577684df85ff$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($leQd8)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($9k6rI))
});
var $fef2577684df85ff$export$2e2bcd8739ae039 = $fef2577684df85ff$var$Illustration;
// for advanced use only
const $fef2577684df85ff$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("9k6rI", function(module, exports) {
module.exports = new URL("oncall-preview-dark.44c69321.svg", import.meta.url).toString();

});

parcelRegister("leQd8", function(module, exports) {
module.exports = new URL("oncall-preview.83fb7508.svg", import.meta.url).toString();

});


parcelRegister("sQUnj", function(module, exports) {

$parcel$export(module.exports, "default", () => $128e5932ddfe0686$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $ftxeI = parcelRequire("ftxeI");

var $hJ2bL = parcelRequire("hJ2bL");
const $128e5932ddfe0686$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hJ2bL)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($ftxeI))
});
var $128e5932ddfe0686$export$2e2bcd8739ae039 = $128e5932ddfe0686$var$Illustration;
// for advanced use only
const $128e5932ddfe0686$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("ftxeI", function(module, exports) {
module.exports = new URL("pages-preview-dark.db4817b0.svg", import.meta.url).toString();

});

parcelRegister("hJ2bL", function(module, exports) {
module.exports = new URL("pages-preview.fb1778e6.svg", import.meta.url).toString();

});


parcelRegister("7Zltj", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a7f4a374446cdd2$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $j81Gl = parcelRequire("j81Gl");

var $lbnSg = parcelRequire("lbnSg");
const $4a7f4a374446cdd2$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($lbnSg)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($j81Gl))
});
var $4a7f4a374446cdd2$export$2e2bcd8739ae039 = $4a7f4a374446cdd2$var$Illustration;
// for advanced use only
const $4a7f4a374446cdd2$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("j81Gl", function(module, exports) {
module.exports = new URL("releases-preview-dark.7aa6179c.svg", import.meta.url).toString();

});

parcelRegister("lbnSg", function(module, exports) {
module.exports = new URL("releases-preview.d6e2b061.svg", import.meta.url).toString();

});


parcelRegister("5EY5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $05de15dfc4738b45$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $exHOt = parcelRequire("exHOt");

var $ezBXt = parcelRequire("ezBXt");
const $05de15dfc4738b45$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($ezBXt)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($exHOt))
});
var $05de15dfc4738b45$export$2e2bcd8739ae039 = $05de15dfc4738b45$var$Illustration;
// for advanced use only
const $05de15dfc4738b45$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("exHOt", function(module, exports) {
module.exports = new URL("reports-preview-dark.c0a44511.svg", import.meta.url).toString();

});

parcelRegister("ezBXt", function(module, exports) {
module.exports = new URL("reports-preview.8bb5ca71.svg", import.meta.url).toString();

});


parcelRegister("g8Wnk", function(module, exports) {

$parcel$export(module.exports, "default", () => $32e877357083e802$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $kIYOj = parcelRequire("kIYOj");

var $kZfAm = parcelRequire("kZfAm");
const $32e877357083e802$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($kZfAm)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($kIYOj))
});
var $32e877357083e802$export$2e2bcd8739ae039 = $32e877357083e802$var$Illustration;
// for advanced use only
const $32e877357083e802$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("kIYOj", function(module, exports) {
module.exports = new URL("security-preview-dark.fe257a0b.svg", import.meta.url).toString();

});

parcelRegister("kZfAm", function(module, exports) {
module.exports = new URL("security-preview.5dc5fb3a.svg", import.meta.url).toString();

});


parcelRegister("gS64m", function(module, exports) {

$parcel$export(module.exports, "default", () => $098262013fc43113$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $bMYvy = parcelRequire("bMYvy");

var $jj4QA = parcelRequire("jj4QA");
const $098262013fc43113$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($jj4QA)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($bMYvy))
});
var $098262013fc43113$export$2e2bcd8739ae039 = $098262013fc43113$var$Illustration;
// for advanced use only
const $098262013fc43113$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("bMYvy", function(module, exports) {
module.exports = new URL("shortcuts-preview-dark.ee547f9e.svg", import.meta.url).toString();

});

parcelRegister("jj4QA", function(module, exports) {
module.exports = new URL("shortcuts-preview.8780e9d0.svg", import.meta.url).toString();

});


parcelRegister("hR0XV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0734d37e50948b26$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $8niMh = parcelRequire("8niMh");

var $6k23z = parcelRequire("6k23z");
const $0734d37e50948b26$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6k23z)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8niMh))
});
var $0734d37e50948b26$export$2e2bcd8739ae039 = $0734d37e50948b26$var$Illustration;
// for advanced use only
const $0734d37e50948b26$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("8niMh", function(module, exports) {
module.exports = new URL("summary-preview-dark.32dd4d90.svg", import.meta.url).toString();

});

parcelRegister("6k23z", function(module, exports) {
module.exports = new URL("summary-preview.10045d4f.svg", import.meta.url).toString();

});


parcelRegister("833ck", function(module, exports) {

$parcel$export(module.exports, "default", () => $7790084e44c29578$export$2e2bcd8739ae039);

var $dCLgq = parcelRequire("dCLgq");

var $aIn5A = parcelRequire("aIn5A");

var $t7nyY = parcelRequire("t7nyY");
const $7790084e44c29578$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($t7nyY)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($aIn5A))
});
var $7790084e44c29578$export$2e2bcd8739ae039 = $7790084e44c29578$var$Illustration;
// for advanced use only
const $7790084e44c29578$export$a179c88182cb9d56 = [
    0,
    0,
    216,
    120
];

});
parcelRegister("aIn5A", function(module, exports) {
module.exports = new URL("timeline-preview-dark.a8fbe72d.svg", import.meta.url).toString();

});

parcelRegister("t7nyY", function(module, exports) {
module.exports = new URL("timeline-preview.cf56bfbb.svg", import.meta.url).toString();

});


parcelRegister("1GbRa", function(module, exports) {

$parcel$export(module.exports, "GoalIcon", () => $12f8ec0674b81469$export$134cbcd70c6693b8);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $koVbs = parcelRequire("koVbs");

var $bG0w3 = parcelRequire("bG0w3");
const $12f8ec0674b81469$var$getGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9ZM13 9C13 11.2091 11.2091 13 9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9Z",
        fillRule: "evenodd"
    })));
const $12f8ec0674b81469$export$134cbcd70c6693b8 = ({ size: size, primaryColor: primaryColor })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $12f8ec0674b81469$var$getGlyph,
        size: size,
        label: formatMessage((0, $bG0w3.default).goalIconLabel),
        primaryColor: primaryColor
    });
};

});
parcelRegister("bG0w3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9702f2f1c783da1a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9702f2f1c783da1a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    goalIconLabel: {
        "id": "spa-apps-sidebar-common.goal-icon.goal-icon-label",
        "defaultMessage": "Goal"
    }
});

});


parcelRegister("52BHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $e950f63c8f63875d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e950f63c8f63875d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    approvalsDescription: {
        "id": "horizontal-nav-add-tab-details.approvals-description",
        "defaultMessage": "Add approvals into your workflow to save you time following up."
    },
    attachmentsDescription: {
        "id": "horizontal-nav-add-tab-details.attachments-description",
        "defaultMessage": "View attachments that have been added to issues within your project."
    },
    archivedIssuesDescription: {
        "id": "horizontal-nav-add-tab-details.archived-issues-description",
        "defaultMessage": "View all the issues archived in your project here."
    },
    attachmentsDescriptionIssueTermRefresh: {
        "id": "horizontal-nav-add-tab-details.attachments-description-issue-term-refresh",
        "defaultMessage": "View attachments that have been added to work items within your project."
    },
    archivedIssuesDescriptionIssueTermRefresh: {
        "id": "horizontal-nav-add-tab-details.archived-issues-description-issue-term-refresh",
        "defaultMessage": "View all the work items archived in your project here."
    },
    issuesDescription: {
        "id": "horizontal-nav-add-tab-details.issues-description",
        "defaultMessage": "View all the issues in your project. Use built-in filters and text search to find issues."
    },
    backlogDescription: {
        "id": "horizontal-nav-add-tab-details.backlog-description",
        "defaultMessage": "Plan and prioritize your team's work in a dedicated space."
    },
    reportsDescription: {
        "id": "horizontal-nav-add-tab-details.reports-description",
        "defaultMessage": "View statistics for people, projects, versions, or information about issues."
    },
    securityDescription: {
        "id": "horizontal-nav-add-tab-details.security-description",
        "defaultMessage": "Connect security tools to triage and track vulnerabilities in Jira."
    },
    boardDescription: {
        "id": "horizontal-nav-add-tab-details.board-description",
        "defaultMessage": "Get a snapshot of the status of your team's work and easily drag your cards through a workflow."
    },
    codeDescription: {
        "id": "horizontal-nav-add-tab-details.code-description",
        "defaultMessage": "Connect Bitbucket, GitHub and other development tools to link your team's repositories to Jira."
    },
    componentsDescription: {
        "id": "horizontal-nav-add-tab-details.components-description",
        "defaultMessage": "Use components to create subsections of a project."
    },
    deploymentsDescription: {
        "id": "horizontal-nav-add-tab-details.deployments-description",
        "defaultMessage": "Easily manage and track deployments for a seamless software delivery experience."
    },
    developmentDescription: {
        "id": "horizontal-nav-add-tab-details.development-description",
        "defaultMessage": "Discover key technical insights and work suggestions for your software development journey in one place."
    },
    goalsDescription: {
        "id": "horizontal-nav-add-tab-details.goals-description",
        "defaultMessage": "View issues that are linked to goals in this project."
    },
    incidentsDescription: {
        "id": "horizontal-nav-add-tab-details.incidents-description",
        "defaultMessage": "Triage incidents and track PIR actions in your project by connecting incident management tools."
    },
    releasesDescription: {
        "id": "horizontal-nav-add-tab-details.releases-description",
        "defaultMessage": "Versions help you package and schedule project deliveries."
    },
    requestsDescription: {
        "id": "horizontal-nav-add-tab-details.requests-description",
        "defaultMessage": "Manage, prioritize, and track requests, and connect them to this project."
    },
    timelineDescription: {
        "id": "horizontal-nav-add-tab-details.timeline-description",
        "defaultMessage": "Plan and manage your project dependencies on a timeline and see when things are landing."
    },
    onCallDescription: {
        "id": "horizontal-nav-add-tab-details.on-call-description",
        "defaultMessage": "View on-call schedules in your project. Requires Opsgenie by Atlassian."
    },
    calendarDescription: {
        "id": "horizontal-nav-add-tab-details.calendar-description",
        "defaultMessage": "See when work is due and get a quick glance at what the next month looks like."
    },
    shortcutsDescription: {
        "id": "horizontal-nav-add-tab-details.shortcuts-description",
        "defaultMessage": "Add easily accessible links for your team to access from your project."
    },
    pagesDescription: {
        "id": "horizontal-nav-add-tab-details.pages-description",
        "defaultMessage": "Create and manage Confluence pages in your project."
    },
    listDescription: {
        "id": "horizontal-nav-add-tab-details.list-description",
        "defaultMessage": "Get a list of your project's work in spreadsheet-like table."
    },
    appDescription: {
        "id": "horizontal-nav-add-tab-details.app-description",
        "defaultMessage": "Supercharge your project by integrating third-party apps."
    },
    formsDescription: {
        "id": "horizontal-nav-add-tab-details.forms-description",
        "defaultMessage": "Collect information for your team with forms."
    },
    summaryDescriptionNonFinal: {
        "id": "horizontal-nav-add-tab-details.summary-description-non-final",
        "defaultMessage": "Get an overview of work progress, priorities, workload distribution, and other projects."
    },
    issuesDescriptionIssueTermRefresh: {
        "id": "horizontal-nav-add-tab-details.issues-description-issue-term-refresh",
        "defaultMessage": "View all the work items in your project. Use built-in filters and text search to find work items."
    },
    reportsDescriptionIssueTermRefresh: {
        "id": "horizontal-nav-add-tab-details.reports-description-issue-term-refresh",
        "defaultMessage": "View statistics for people, projects, versions, or information about work items."
    },
    goalsDescriptionIssueTermRefresh: {
        "id": "horizontal-nav-add-tab-details.goals-description-issue-term-refresh",
        "defaultMessage": "View work items that are linked to goals in this project."
    },
    inboxDescription: {
        "id": "horizontal-nav.inbox-description",
        "defaultMessage": "Enable customer service teams to forward work items to this project. Teams will see this project in their forwarding options and can forward work directly to your inbox."
    }
});

});






//# sourceMappingURL=async-jira-horizontal-nav-entrypoint.4a94a369.js.map
